/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/m/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 267);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(270);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(326)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(329);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GET_CMSAPI_INDEXDATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GET_CMSAPI_TAGARTICLEDATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_CMSAPI_GETARTICLEDATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GET_CMSAPI_ZAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return GET_CMSAPI_PUBLISH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return GET_CMSAPI_SEARCHARTICLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GET_CMSAPI_GETHOMEPAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return GET_USER_LOGINSTATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_ARTICLE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return GET_NAVIGATION_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return GET_PAGES_DATABYID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return GET_SERVICE_INTRODUCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return POST_PRODUCT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return GET_USER_APPLY_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GET_CMSAPI_USERAPPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GET_HELPAPI_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GET_HELPAPI_GETTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return GET_NAVLIST_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GET_CMSAPI_PRODUCT_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GET_CMSAPI_PRODUCT_DETAIL_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return GET_CMSAPI_PRODUCT_DETAIL_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return GET_CMSAPI_PRODUCT_MORE_DETAIL_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return GET_NUMBER_COMMON_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return GET_NUMBER_COMMON_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return GET_NUMBER_SEARCH_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return POST_NUMBER_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_ALREADY_PHONE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return GET_INSTANCE_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_ACTIVITY_GET_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return GET_INSTANCE_GETINSTANCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GET_APIMEAL_PAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return GET_VDC_REPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return GET_URL_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GET_GET_NEW_SERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GET_SCAN_SERVERVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_PRIVACY_COMPANY_V2; });
/* unused harmony export GET_REPORT_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_CHACK_AI_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_CHACK_AI_INSDUSTRY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return GET_VUL_HOMEPAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return GET_VUL_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return GET_VUL_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return GET_LEADER_BOARD; });
/**
 * @file 请求标识
 * @author wangzhuang
 */ // 安全社区首页
var GET_CMSAPI_INDEXDATA = 'GET_CMSAPI_INDEXDATA'; // 标签页面
var GET_CMSAPI_TAGARTICLEDATA = 'GET_CMSAPI_TAGARTICLEDATA'; // 单篇文章数据
var GET_CMSAPI_GETARTICLEDATA = 'GET_CMSAPI_GETARTICLEDATA'; // 文章点赞
var GET_CMSAPI_ZAN = 'GET_CMSAPI_ZAN';var GET_CMSAPI_PUBLISH = 'GET_CMSAPI_PUBLISH'; // 文章搜索
var GET_CMSAPI_SEARCHARTICLE = 'GET_CMSAPI_SEARCHARTICLE'; // 官网首页
var GET_CMSAPI_GETHOMEPAGE = 'GET_CMSAPI_GETHOMEPAGE'; // 判断是否登录
var GET_USER_LOGINSTATE = 'GET_USER_LOGINSTATE'; // 安全社区文章列表
var GET_ARTICLE_LIST = 'GET_ARTICLE_LIST'; // 导航列表
var GET_NAVIGATION_LIST = 'GET_NAVIGATION_LIST'; // 产品详情
var GET_PAGES_DATABYID = 'GET_PAGES_DATABYID'; // 产品价格
var GET_SERVICE_INTRODUCE = 'GET_SERVICE_INTRODUCE'; // 更新产品页面的id
var POST_PRODUCT_ID = 'POST_PRODUCT_ID'; // 申请试用获取业务、时间列表
var GET_USER_APPLY_DATA = 'GET_USER_APPLY_DATA'; // 申请试用页面提交
var GET_CMSAPI_USERAPPLY = 'GET_CMSAPI_USERAPPLY'; // 帮助支持导航列表
var GET_HELPAPI_INDEX = 'GET_HELPAPI_INDEX'; // 帮助指南文章页
var GET_HELPAPI_GETTEXT = 'GET_HELPAPI_GETTEXT'; // 获取落地页当前的id父级导航索引
var GET_NAVLIST_INDEX = 'GET_NAVLIST_INDEX'; // 获取产品列表
var GET_CMSAPI_PRODUCT_LIST = 'GET_CMSAPI_PRODUCT_LIST'; // 产品详情首页
var GET_CMSAPI_PRODUCT_DETAIL_INDEX = 'GET_CMSAPI_PRODUCT_DETAIL_INDEX'; // 产品详情列表第一页
var GET_CMSAPI_PRODUCT_DETAIL_LIST = 'GET_CMSAPI_PRODUCT_DETAIL_LIST'; // 产品详情列表分页
var GET_CMSAPI_PRODUCT_MORE_DETAIL_LIST = 'GET_CMSAPI_PRODUCT_MORE_DETAIL_LIST'; // 获取黄页数据列表接口
var GET_NUMBER_COMMON_LIST = 'GET_NUMBER_COMMON_LIST'; // 获取黄页数据详情接口
var GET_NUMBER_COMMON_INFO = 'GET_NUMBER_COMMON_INFO'; // 号码模糊查询接口
var GET_NUMBER_SEARCH_RESULT = 'GET_NUMBER_SEARCH_RESULT'; // 号码举报接口
var POST_NUMBER_REPORT = 'POST_NUMBER_REPORT'; // 获取号码举报审核列表
var GET_ALREADY_PHONE_LIST = 'GET_ALREADY_PHONE_LIST'; // 获取组织信息
var GET_INSTANCE_INFO = 'GET_INSTANCE_INFO'; // 聚合页-获取产品列表
var GET_ACTIVITY_GET_SERVICE = 'GET_ACTIVITY_GET_SERVICE'; // 聚合页-获取组织ID
var GET_INSTANCE_GETINSTANCE = 'GET_INSTANCE_GETINSTANCE'; // 聚合页-购买服务
var GET_APIMEAL_PAY = 'GET_APIMEAL_PAY'; // VDC 文件查询
var GET_VDC_REPORT = 'GET_VDC_REPORT'; // VDC 文件查询
var GET_URL_UPLOAD = 'GET_URL_UPLOAD'; // 抽奖活动服务列表
var GET_GET_NEW_SERVICE = 'GET_GET_NEW_SERVICE'; // 漏洞扫描套餐活动列表
var GET_SCAN_SERVERVICE = 'GET_SCAN_SERVERVICE'; // 史宾格申请表单
var AUTH_PRIVACY_COMPANY_V2 = 'AUTH_PRIVACY_COMPANY_V2'; // 史宾格申请表单
var GET_REPORT_DATA = 'GET_REPORT_DATA'; // 深度检测查询
var FETCH_CHACK_AI_IMAGE = 'FETCH_CHACK_AI_IMAGE'; // ai安防
var FETCH_CHACK_AI_INSDUSTRY = 'FETCH_CHACK_AI_INSDUSTRY'; // 漏洞查询
var GET_VUL_HOMEPAGE = 'GET_VUL_HOMEPAGE'; // 漏洞搜索
var GET_VUL_SEARCH = 'GET_VUL_SEARCH'; // 漏洞详情
var GET_VUL_DETAIL = 'GET_VUL_DETAIL'; // 鲁棒性排行榜
var GET_LEADER_BOARD = 'GET_LEADER_BOARD';

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = rcAjax;
/* harmony export (immutable) */ __webpack_exports__["a"] = bAntiBotSend;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return thunkMiddleware; });
/* harmony export (immutable) */ __webpack_exports__["b"] = extendComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/**
 * @file 扩展插件
 * @author WangZhuang
 */ /* globals shareConfig */function rcAjax(type, url, param, data, callback) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default()({ method: type, url: url, params: param, data: data }).then(function (response) {
    callback(response);return response;
  }).catch(function (error) {
    callback(error.response);
  });
}function bAntiBotSend() {
  if (window.BCat_2024 && window.BCat_2024.miao) {
    window.BCat_2024.miao();
  } else if (window.BAntiBot && window.BAntiBot.send) {
    window.BAntiBot.send();
  }
}var thunkMiddleware = function thunkMiddleware(_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;return function (next) {
    return function (action) {
      if (Object.prototype.toString.call(action) === '[object Function]') {
        return action(dispatch, getState);
      }return next(action);
    };
  };
};(function (designWidth, maxWidth) {
  // 淘宝移动端的rem计算方式
  var doc = document;var win = window;var docEl = doc.documentElement;var metaEl = void 0;var metaElCon = void 0;var remStyle = document.createElement('style');var tid = void 0;function refreshRem() {
    // var width = parseInt(window.screen.width)
    var width = docEl.getBoundingClientRect().width;if (!maxWidth) {
      maxWidth = 540;
    }if (width > maxWidth) {
      // 限制在540的屏幕下，这样100%就跟10rem不一样了
      width = maxWidth;
    }var rem = width * 100 / designWidth; // var rem = width / 10; // 如果要兼容vw的话分成10份
    // docEl.style.fontSize = rem + "px";
    // 旧的做法，在uc浏览器下面会有切换横竖屏时定义了font-size的标签不起作用的bug
    remStyle.innerHTML = 'html{font-size:' + rem + 'px;}';
  } // 设置 viewport ，有的话修改 没有的话设置
  metaEl = doc.querySelector('meta[name="viewport"]'); // 20171219修改：增加 viewport-fit=cover ，用于适配iphoneX
  metaElCon = 'width=device-width,initial-scale=1,maximum-scale=1.0,user-scalable=no,viewport-fit=cover';if (metaEl) {
    metaEl.setAttribute('content', metaElCon);
  } else {
    metaEl = doc.createElement('meta');metaEl.setAttribute('name', 'viewport');metaEl.setAttribute('content', metaElCon);if (docEl.firstElementChild) {
      docEl.firstElementChild.appendChild(metaEl);
    } else {
      var wraps = doc.createElement('div');wraps.appendChild(metaEl);doc.write(wraps.innerHTML);wraps = null;
    }
  } // 要等 wiewport 设置好后才能执行 refreshRem，不然 refreshRem 会执行2次；
  refreshRem();if (docEl.firstElementChild) {
    docEl.firstElementChild.appendChild(remStyle);
  } else {
    var wrap = doc.createElement('div');wrap.appendChild(remStyle);doc.write(wrap.innerHTML);wrap = null;
  }win.addEventListener('resize', function () {
    clearTimeout(tid); // 防止执行两次
    tid = setTimeout(refreshRem, 300);
  }, false);win.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      // 浏览器后退的时候重新计算
      clearTimeout(tid);tid = setTimeout(refreshRem, 300);
    }
  }, false);
})(1080, 1080);function extendComponent() {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.isEmptyobj = function (obj) {
      // 判断是否为空对象
      for (var key in obj) {
        return false;
      }return true;
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.isTest = function () {
      // 判断是否为测试线
      var reg = new RegExp('(localhost|127.0.0.1|test.anquan.baidu.com|cq02-security-dev01.cq02.baidu.com)');var res = reg.test(location.host);return res;
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.isPC = function () {
      // 判断是否为PC端
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        return false;
      } else {
        return true;
      }
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.isPhone = function (val) {
      // 判断是否为手机号
      var reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;var value = val.replace(/\s/g, '');return reg.test(value);
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.isIos = function () {
      // 判断是否为ios端
      return navigator.userAgent.match(/(iPhone|iPod|ios)/i);
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.isAndroid = function () {
      // 判断是否为Android端
      return navigator.userAgent.match(/(Android)/i);
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.isSafari = function () {
      // 判断是否为Safari
      var ua = navigator.userAgent; // IOS系统
      if (/ OS \d/.test(ua)) {
        // 不是Chrome
        if (!~ua.indexOf('CriOS')) {
          // 开头必须为Mozilla
          if (!ua.indexOf('Mozilla')) {
            // 结尾需为：Safari/xxx.xx
            if (/Safari\/[\d\\.]+$/.test(ua)) {
              return true;
            }
          }
        }
      }return false;
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.getRequest = function () {
      var url = location.search; // 获取url中"?"符后的字串
      var theRequest = {};if (url.indexOf('?') !== -1) {
        var str = url.substr(1);var strs = str.split('&');for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
        }
      }return theRequest;
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.shareWX = function (obj) {
      var json = { debug: location.href.indexOf('share_debug=1') > 0, title: '百度安全社区-有AI更安全', contentDefault: '百度安全', linkUrl: 'https://anquan.baidu.com' + location.pathname, iconUrl: 'https://anquan.baidu.com/bdaq.jpg', iconUrlDefault: 'https://anquan.baidu.com/bdaq.jpg', bdbox: { source: 'feednews' }, wx: { appId: 'wxadc1a0c6b9096e89', jsApiList: [] } };for (var attr in obj) {
        json[attr] = obj[attr];
      }shareConfig.init(json);
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.formatTime = function (time) {
      var d = time / 60 / 60 / 24 / 1000;if (d === 365) {
        return '1年';
      } else if (d === 30) {
        return '1月';
      } else {
        return d + '天';
      }
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.isDev = function () {
      var reg = new RegExp('(localhost|localtest.baidu.com|127.0.0.1' + '|test.anquan.baidu.com|yq01-security)');return reg.test(location.host); // 判断是否为测试线
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.loginUrl = function (url) {
      var curUrl = encodeURIComponent(url ? location.origin + url : location.href); // return this.isDev()
      //     ? `//wappass.qatest.baidu.com?tpl=spu&subpro=spuuser&u=${curUrl}`
      //     : `//wappass.baidu.com?tpl=spu&subpro=spuuser&u=${curUrl}`;
      return '/m/login?urlto=' + encodeURIComponent(curUrl);
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.userCenterUrl = function (url) {
      var curUrl = encodeURIComponent(url ? location.origin + url : location.href);return this.isDev() ? '//wappass.qatest.baidu.com/wp/v3/ucenter/realnameverify?tpl=spu&adapter=&client=&okU=' + curUrl : '//wappass.baidu.com/wp/v3/ucenter/realnameverify?tpl=spu&adapter=&client=&okU=' + curUrl;
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.getParams = function () {
      var search = (window.location.search || '').split('?')[1];return __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(search);
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.isPageTitle = function isPageTitle(string, text) {
      return (text || '').toLowerCase().indexOf(string) > -1;
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.reportAjax = function reportData(channel, responseData) {
      if (!responseData) {
        return;
      }try {
        var companyJson = { channel: channel, event: 'click' };var localData = JSON.parse(responseData);if (localData && localData.data) {
          companyJson.data = localData.data;
        }if (localData && localData.key_id) {
          companyJson['key_id'] = localData['key_id'];
        }if (localData && localData.sign) {
          companyJson.sign = localData.sign;
        }__WEBPACK_IMPORTED_MODULE_0_axios___default()({ url: '/xiapi/api/v1/activity/reportData', method: 'POST', data: companyJson });
      } catch (e) {
        return;
      }
    };__WEBPACK_IMPORTED_MODULE_1_react__["Component"].prototype.reportData = function reportData(channel, disabledSendMessage) {
      try {
        if (!disabledSendMessage) {
          bAntiBotSend();
        }var that = this;window['__abbaidu_2024_cb'] = function (responseData) {
          that.reportAjax(channel, responseData);
        };
      } catch (e) {
        return;
      }
    };
  };
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(201);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(107);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(407);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(411);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(107);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Productitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 产品标题
  * @author wangzhuang
  */var Productitle = (_temp = _class = function (_Component) {
  _inherits(Productitle, _Component);function Productitle() {
    _classCallCheck(this, Productitle);return _possibleConstructorReturn(this, (Productitle.__proto__ || Object.getPrototypeOf(Productitle)).apply(this, arguments));
  }_createClass(Productitle, [{ key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('product-title mui-flex align-center', this.props.className) }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, this.props.title));
    } }]);return Productitle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string }, _temp);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(415);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProBanner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: wangzhuang@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2023-08-22 23:52:17
  * @FilePath: /m-anquan-baidu-com/src/components/ProBanner/index.js
  * @Description: 通用产品页 banner
  */var ProBanner = (_temp = _class = function (_Component) {
  _inherits(ProBanner, _Component);function ProBanner() {
    _classCallCheck(this, ProBanner);return _possibleConstructorReturn(this, (ProBanner.__proto__ || Object.getPrototypeOf(ProBanner)).apply(this, arguments));
  }_createClass(ProBanner, [{ key: 'render', value: function render() {
      var _this2 = this;var _props = this.props,
          title = _props.title,
          urlText = _props.urlText,
          url = _props.url,
          bgImg = _props.bgImg,
          nextUrl = _props.nextUrl,
          nextText = _props.nextText;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proBanner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'banner-con pr', style: { backgroundImage: 'url(' + bgImg + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: url, onClick: function onClick(e) {
          if (_this2.isPageTitle('mesatee', title)) {
            _this2.reportData('mesatee_banner');
          }
        }, className: 'link', target: '_blank' }, urlText), nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: nextUrl, target: '_blank', className: 'compliance-btn' }, nextText) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'phone' }, '\u6216\u81F4\u7535\uFF1A010-58003138')));
    } }]);return ProBanner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, bgImg: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, urlText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, url: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, nextUrl: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, nextText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string }, _temp);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(538);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports = typeof window == 'object' && window && window.Math == Math ? window
  : typeof self == 'object' && self && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(201);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(214);
var isBuffer = __webpack_require__(425);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(64)('wks');
var uid = __webpack_require__(90);
var Symbol = __webpack_require__(15).Symbol;
var NATIVE_SYMBOL = __webpack_require__(290);

module.exports = function (name) {
  return store[name] || (store[name] = NATIVE_SYMBOL && Symbol[name]
    || (NATIVE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(376);

__webpack_require__(377);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(315);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* unused harmony export compose */
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_symbol_observable__ = __webpack_require__(322);


/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT' + Math.random().toString(36).substring(7).split('').join('.'),
  REPLACE: '@@redux/REPLACE' + Math.random().toString(36).substring(7).split('').join('.')
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) return false;

  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribe(listener) for more details.');
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.REPLACE });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if ((typeof observer === 'undefined' ? 'undefined' : _typeof(observer)) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_0_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty
}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionDescription = actionType && 'action "' + String(actionType) + '"' || 'an action';

  return 'Given ' + actionDescription + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if ((typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators === 'undefined' ? 'undefined' : _typeof(actionCreators)) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var store = createStore.apply(undefined, args);
      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(undefined, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */
function isCrushed() {}

if (false) {
  warning("You are currently using minified code outside of NODE_ENV === 'production'. " + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 23 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var definePropertyModule = __webpack_require__(32);
var createPropertyDescriptor = __webpack_require__(85);

module.exports = __webpack_require__(31) ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(349)();
}


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchPagesDataById;
/* harmony export (immutable) */ __webpack_exports__["h"] = fetchServiceIntroduce;
/* harmony export (immutable) */ __webpack_exports__["g"] = fetchProductId;
/* unused harmony export fetchScanService */
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchChackAiImage;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchChackAiIndustry;
/* harmony export (immutable) */ __webpack_exports__["j"] = getInstanceId;
/* harmony export (immutable) */ __webpack_exports__["a"] = applyInspectionForm;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchGetServices;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchBsbCheck;
/* harmony export (immutable) */ __webpack_exports__["i"] = fetchVariantCheck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file 产品详情
 * @author wangzhuang
 */function fetchPagesDataById(dispatch, id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/getPagesDataById', { id: id }, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["E" /* GET_PAGES_DATABYID */], data: data.data });
  });
}function fetchServiceIntroduce(dispatch, id) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/getServiceIntroduceByItemid', { itemid: id }, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["G" /* GET_SERVICE_INTRODUCE */], data: data.data });
  });
}function fetchProductId(dispatch, id) {
  dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["P" /* POST_PRODUCT_ID */], data: { id: id } });
}function fetchScanService(params) {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/xiapi/api/v1/activity/getServicesV2', params, {}, function (data) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["F" /* GET_SCAN_SERVERVICE */], data: data.data });
    });
  };
} // 深度检测
function fetchChackAiImage(obj) {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/deepface/deepfakes', {}, obj, function (data) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["b" /* FETCH_CHACK_AI_IMAGE */], data: data.data });
    });
  };
} // ai 安防
function fetchChackAiIndustry(obj) {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/industry/detect', {}, obj, function (data) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["c" /* FETCH_CHACK_AI_INSDUSTRY */], data: data.data });
    });
  };
} // 获取组织id
function getInstanceId(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/instance/getInstance', {}, obj, function () {
    return null;
  }).then(function (data) {
    return data.data;
  });
} // 创建免费poc
function applyInspectionForm(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/industry/authCompany', {}, obj, function () {
    return null;
  }).then(function (data) {
    return data.data;
  });
} // 网址安全检测获取套餐
function fetchGetServices(json) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/xiapi/api/v1/bsb/get_open_services', json, {}, function () {
    return null;
  }).then(function (data) {
    return data.data;
  });
} // 网址安全检查询
function fetchBsbCheck(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/bsb/check', {}, obj, function () {
    return null;
  }).then(function (data) {
    return data.data;
  });
} // 文本变体检测
function fetchVariantCheck(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/variant/check', null, obj, function () {
    return null;
  }).then(function (data) {
    return data.data;
  });
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchActivityGetService;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchInstanceGetInstance;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchApimealPay;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchGetNewService;
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchRealName;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchPayInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file 聚合页
 * @author wangzhuang
 */function fetchActivityGetService(dispatch, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/xiapi/api/v1/activity/getService', obj, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["d" /* GET_ACTIVITY_GET_SERVICE */], data: data.data });
  });
}function fetchInstanceGetInstance(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/xiapi/api/v1/instance/getInstance', {}, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["w" /* GET_INSTANCE_GETINSTANCE */], data: data.data });
  });
}function fetchApimealPay(dispatch, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/gateway/apimeal/pay', {}, obj, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["f" /* GET_APIMEAL_PAY */], data: data.data });
  });
}function fetchGetNewService(dispatch, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/xiapi/api/v1/activity/getNewService', obj, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["t" /* GET_GET_NEW_SERVICE */], data: data.data });
  });
}function fetchRealName(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/gateway/apimeal/real_name', {}, obj, function () {
    return null;
  }).then(function (data) {
    return data.data;
  });
}function fetchPayInfo(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/xiapi/api/v1/gateway/apimeal/getActivityService', obj, {}, function () {
    return null;
  }).then(function (data) {
    return data.data;
  });
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(24)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(31);
var IE8_DOM_DEFINE = __webpack_require__(169);
var anObject = __webpack_require__(33);
var toPrimitive = __webpack_require__(168);
var nativeDefineProperty = Object.defineProperty;

exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(25);

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(52);
var IE8_DOM_DEFINE = __webpack_require__(203);
var toPrimitive = __webpack_require__(106);
var dP = Object.defineProperty;

exports.f = __webpack_require__(36) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(53)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 37 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TouchFeedback__ = __webpack_require__(470);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__TouchFeedback__["a"]; });


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(345);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(351);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(197);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(353);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(356);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(359);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(361);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(100);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(367);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(371);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(28);
var core = __webpack_require__(34);
var ctx = __webpack_require__(202);
var hide = __webpack_require__(41);
var has = __webpack_require__(37);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(35);
var createDesc = __webpack_require__(69);
module.exports = __webpack_require__(36) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(208);
var defined = __webpack_require__(109);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(114)('wks');
var uid = __webpack_require__(71);
var Symbol = __webpack_require__(28).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TopBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp2;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file topbar
  * @author wangzhuang
  */var TopBar = (_temp2 = _class = function (_Component) {
  _inherits(TopBar, _Component);function TopBar() {
    var _ref;var _temp, _this, _ret;_classCallCheck(this, TopBar);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TopBar.__proto__ || Object.getPrototypeOf(TopBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isMenuShow: false }, _temp), _possibleConstructorReturn(_this, _ret);
  }_createClass(TopBar, [{ key: 'changeMenuStatus', value: function changeMenuStatus(isShow) {
      this.setState({ isMenuShow: isShow });
    } }, { key: 'renderMenu', value: function renderMenu() {
      return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { key: 'menu', className: 'menu' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/forum' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'menu-icon forum' }), '\u5B89\u5168\u793E\u533A\u9996\u9875')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/productCenter' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'menu-icon product-center-icon' }), '\u4EA7\u54C1\u677F\u5757')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/submission' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'menu-icon submission' }), '\u6295\u7A3F')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'menu-icon home' }), '\u8FD4\u56DE\u767E\u5EA6\u5B89\u5168\u5B98\u7F51'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: this.changeMenuStatus.bind(this, false), key: 'mask', className: 'mask' })];
    } }, { key: 'render', value: function render() {
      var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('top-bar pr', { active: this.state.isMenuShow });return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: className }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'top-bar-left' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/forum', className: 'spu-logo' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(452), alt: 'spu-logo' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'top-bar-right' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/forum/search', className: 'search-link' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'menu-btn' }, this.state.isMenuShow ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.changeMenuStatus.bind(this, false), src: __webpack_require__(453), alt: 'forum-menu' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: this.changeMenuStatus.bind(this, true), src: __webpack_require__(454), alt: 'forum-menu' }))), this.state.isMenuShow && this.renderMenu());
    } }]);return TopBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { typeLeft: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool }, _temp2);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var hide = __webpack_require__(26);
var has = __webpack_require__(23);
var setGlobal = __webpack_require__(87);
var nativeFunctionToString = __webpack_require__(171);
var InternalStateModule = __webpack_require__(65);
var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(nativeFunctionToString).split('toString');

__webpack_require__(64)('inspectSource', function (it) {
  return nativeFunctionToString.call(it);
});

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) hide(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else hide(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || nativeFunctionToString.call(this);
});


/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(42);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListPro; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 文章列表（有图片）
  * @author wangzhuang
  */var ListPro = (_temp = _class = function (_Component) {
  _inherits(ListPro, _Component);function ListPro() {
    _classCallCheck(this, ListPro);return _possibleConstructorReturn(this, (ListPro.__proto__ || Object.getPrototypeOf(ListPro)).apply(this, arguments));
  }_createClass(ListPro, [{ key: 'render', value: function render() {
      var _props = this.props,
          title = _props.title,
          brief = _props.brief,
          imgSrc = _props.imgSrc,
          time = _props.time,
          tagList = _props.tagList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-pro mui-flex pr' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-multiple' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-content' }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-brief' }, time ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'list-time' }, time) : '', brief)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-thumb cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-thumb-shadow' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imgSrc, alt: title, width: '100%' })), tagList ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tag-mod' }, tagList.map(function (item, index) {
        if (index < 2) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index }, item.tagname);
        }return '';
      })) : null);
    } }]);return ListPro;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, brief: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, imgSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, time: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, tagList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array }, _temp);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(660);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Upload */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Select; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CodePic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FormItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_textarea_item_style_css__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_textarea_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_textarea_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_textarea_item__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_textarea_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_textarea_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_input_item_style_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_input_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_input_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_input_item__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_input_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_input_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_exif_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_exif_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_exif_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_less__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(57);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp, _class2, _temp3, _class3, _temp5, _class4, _temp6;function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: number report
  * @author: wence
  */ /* istanbul ignore file */var Upload = (_temp = _class = function (_PureComponent) {
  _inherits(Upload, _PureComponent);function Upload(props) {
    _classCallCheck(this, Upload);var _this = _possibleConstructorReturn(this, (Upload.__proto__ || Object.getPrototypeOf(Upload)).call(this, props));_this.onChange = _this.onChange.bind(_this);return _this;
  }_createClass(Upload, [{ key: 'readFile', value: function readFile(file) {
      return new Promise(function (resolve, reject) {
        var fileReader = new FileReader();fileReader.addEventListener('load', resolve);fileReader.addEventListener('error', reject);fileReader.readAsDataURL(file);
      });
    } }, { key: 'compressImage', value: function compressImage(base64Data, orientation, quality) {
      var scale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;return new Promise(function (resolve, reject) {
        var image = new Image();image.addEventListener('load', function () {
          var width = image.width * scale;var height = image.height * scale;var cvs = document.createElement('canvas');var context = cvs.getContext('2d');cvs.height = height;cvs.width = width;if (orientation && orientation !== 1) {
            switch (orientation) {case 6:
                // 旋转90度
                cvs.height = width;cvs.width = height;context.rotate(Math.PI / 2);context.drawImage(image, 0, -height, width, height);break;case 3:
                // 旋转180度
                context.rotate(Math.PI);context.drawImage(image, -width, -height, width, height);break;case 8:
                // 旋转-90度
                cvs.height = width;cvs.width = height;context.rotate(3 * Math.PI / 2);context.drawImage(image, -width, 0, width, height);break;}
          } else {
            context.drawImage(image, 0, 0, width, height);
          }var dataURL = cvs.toDataURL('image/jpeg', quality);resolve(dataURL);
        });image.addEventListener('error', reject);image.src = base64Data;
      });
    } }, { key: 'dataURLtoFile', value: function dataURLtoFile(base64Data, filename) {
      var arr = base64Data.split(','); // const mime = arr[0].match(/:(.*?);/)[1];
      var bstr = window.atob(arr[1]);var len = bstr.length;var u8arr = new window.Uint8Array(len);while (len--) {
        u8arr[len] = bstr.charCodeAt(len);
      }return new File([u8arr], filename, { type: 'image/jpg' });
    } }, { key: 'getOriention', value: function getOriention(file) {
      return new Promise(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_8_exif_js___default.a.getData(file, function () {
          resolve(__WEBPACK_IMPORTED_MODULE_8_exif_js___default.a.getTag(this, 'Orientation'));
        });
      });
    } }, { key: 'onChange', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(e) {
        var _props, fileSize, fileType, validate, onChange, file, reg, scale, orientation, _data, fdate, compressFile, data;return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                _props = this.props, fileSize = _props.fileSize, fileType = _props.fileType, validate = _props.validate, onChange = _props.onChange;file = e.target.files[0];reg = /\.(jpg|png|jpeg)$/; // 优先判断是不是jpg|png|jpeg其中一种如果是则判断大小是否超过1m如果超过则压缩转换
                // 如果小于1m判断是否是jpg|png
                if (reg.test(file.name)) {
                  _context.next = 5;break;
                }return _context.abrupt('return', validate({ validate: true, message: '图片格式不正确' }));case 5:
                if (!(fileType && (fileType + ';image/jpeg').indexOf(file.type) < 0)) {
                  _context.next = 7;break;
                }return _context.abrupt('return', validate({ validate: true, message: '图片格式不正确' }));case 7:
                if (!(fileSize && file.size > fileSize)) {
                  _context.next = 25;break;
                }scale = 1024 * 1024 / file.size;_context.next = 11;return this.getOriention(file);case 11:
                orientation = _context.sent;_context.next = 14;return this.readFile(file);case 14:
                _data = _context.sent;_context.next = 17;return this.compressImage(_data.target.result, orientation, scale, scale);case 17:
                fdate = _context.sent;compressFile = this.dataURLtoFile(fdate, file.name);if (!(fileSize && compressFile.size > fileSize)) {
                  _context.next = 21;break;
                }return _context.abrupt('return', validate({ validate: true, message: '图片大小不符合要求' }));case 21:
                if (!(fileType && fileType.indexOf(compressFile.type) < 0)) {
                  _context.next = 23;break;
                }return _context.abrupt('return', validate({ validate: true, message: '图片格式不正确' }));case 23:
                onChange && onChange(fdate, compressFile);return _context.abrupt('return');case 25:
                if (!(fileType && fileType.indexOf(file.type) < 0 && !/\.(jpg|png)$/.test(file.name))) {
                  _context.next = 27;break;
                }return _context.abrupt('return', validate({ validate: true, message: '图片格式不正确' }));case 27:
                validate({ validate: false, message: '' });_context.next = 30;return this.readFile(file);case 30:
                data = _context.sent;onChange && onChange(data.target.result, file);case 32:case 'end':
                return _context.stop();}
          }
        }, _callee, this);
      }));function onChange(_x2) {
        return _ref.apply(this, arguments);
      }return onChange;
    }() }, { key: 'render', value: function render() {
      var _props2 = this.props,
          value = _props2.value,
          onChange = _props2.onChange,
          isRequire = _props2.isRequire,
          validate = _props2.validate,
          labelName = _props2.labelName,
          name = _props2.name,
          className = _props2.className;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', null, value ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'upload-image' }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', { src: value, alt: '' }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'upload-image-mask' }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', { onClick: function onClick() {
          if (isRequire) {
            validate({ validate: true, message: labelName + '\u4E0D\u80FD\u4E3A\u7A7A!' });
          }onChange && onChange('', null);
        }, src: __webpack_require__(673), alt: '' }))) : __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('label', { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('upload', className) }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', { src: __webpack_require__(674), alt: '' }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', null, '\u4E0A\u4F20\u56FE\u7247'), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('input', { style: { display: 'none' }, type: 'file', name: name || labelName, accept: 'image/*', multiple: false, onChange: this.onChange })));
    } }]);return Upload;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]), _class.propTypes = { onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, validate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, fileSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, fileType: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, isRequire: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, labelName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, name: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string }, _temp);var Select = (_temp3 = _class2 = function (_PureComponent2) {
  _inherits(Select, _PureComponent2);function Select() {
    var _ref2;var _temp2, _this2, _ret;_classCallCheck(this, Select);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }return _ret = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = { value: undefined }, _temp2), _possibleConstructorReturn(_this2, _ret);
  }_createClass(Select, [{ key: 'render', value: function render() {
      var _props3 = this.props,
          data = _props3.data,
          _onChange = _props3.onChange,
          props = _objectWithoutProperties(_props3, ['data', 'onChange']);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'form-select' }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('select', Object.assign({}, props, { onChange: function onChange(e) {
          return _onChange && _onChange(e.target.value);
        } }), data && data.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('option', { key: item.value, value: item.value }, item.label);
      })), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'arrow' }));
    } }]);return Select;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]), _class2.propTypes = { data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array, onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func }, _temp3);var CodePic = (_temp5 = _class3 = function (_PureComponent3) {
  _inherits(CodePic, _PureComponent3);function CodePic() {
    var _ref3;var _temp4, _this3, _ret2;_classCallCheck(this, CodePic);for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }return _ret2 = (_temp4 = (_this3 = _possibleConstructorReturn(this, (_ref3 = CodePic.__proto__ || Object.getPrototypeOf(CodePic)).call.apply(_ref3, [this].concat(args))), _this3), _this3.state = { tmp: Date.now() }, _this3.resetCode = function () {
      _this3.setState({ tmp: Date.now() });_this3.props.resetCaptcha && _this3.props.resetCaptcha();
    }, _temp4), _possibleConstructorReturn(_this3, _ret2);
  }_createClass(CodePic, [{ key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'component-code', onClick: this.resetCode }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('img', { src: '/xiapi/api/v1/phone/captcha?t=' + this.state.tmp, alt: '' }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: '' }, '\u5237\u65B0\u9A8C\u8BC1\u7801'));
    } }]);return CodePic;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]), _class3.propTypes = { resetCaptcha: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func }, _temp5);var FormItem = (_temp6 = _class4 = function (_PureComponent4) {
  _inherits(FormItem, _PureComponent4);function FormItem(props) {
    _classCallCheck(this, FormItem);var _this4 = _possibleConstructorReturn(this, (FormItem.__proto__ || Object.getPrototypeOf(FormItem)).call(this, props));_this4.validate = function (cusValidate) {
      if (cusValidate) {
        _this4.setState({ validate: cusValidate.validate, message: cusValidate.message });return;
      }var _getValidate = Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* getValidate */])(_this4.props.rules, _this4.props.value || ''),
          validate = _getValidate.validate,
          message = _getValidate.message;_this4.setState({ validate: validate, message: message });return { validate: validate, message: message };
    };_this4.Item = { input: __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_input_item___default.a, textarea: __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_textarea_item___default.a, select: Select, upload: Upload };_this4.state = { validate: '', message: '' };return _this4;
  }_createClass(FormItem, [{ key: 'componentDidUpdate', value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value && this.state.validate) {
        var validate = Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* getValidate */])(this.props.rules, this.props.value || '').message;if (!validate) {
          this.setState({ validate: false, message: '' });
        }
      }
    } }, { key: 'render', value: function render() {
      var _props4 = this.props,
          isRequire = _props4.isRequire,
          label = _props4.label,
          des = _props4.des,
          placeholder = _props4.placeholder,
          type = _props4.type,
          className = _props4.className,
          comClassName = _props4.comClassName,
          noLabel = _props4.noLabel,
          renderRight = _props4.renderRight,
          props = _objectWithoutProperties(_props4, ['isRequire', 'label', 'des', 'placeholder', 'type', 'className', 'comClassName', 'noLabel', 'renderRight']);var Com = this.Item[type];var extraProps = type === 'upload' ? { validate: this.validate, isRequire: isRequire } : {};return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('form-item', className) }, !noLabel && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'form-label' }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('label', null, isRequire && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: 'hint-star' }, '*'), label), des && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'des' }, des)), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()({ horizontal: !!renderRight }) }, Com && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Com, Object.assign({ placeholder: placeholder }, props, { rules: undefined }, extraProps, { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(comClassName, { error: this.state.validate }) })), renderRight && renderRight()), this.state.validate && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'error-message' }, this.state.message));
    } }]);return FormItem;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]), _class4.propTypes = { isRequire: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, label: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string || __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, des: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string || __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, placeholder: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, comClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, rules: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array, value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any, renderRight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, noLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool }, _temp6);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return validateRequire; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return validateMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return validateMin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return validateEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return validatePhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getValidate; });
/**
 * @file: form 表单验证
 * @author: wence
 */var validateRequire = function validateRequire(name) {
  return { validate: function validate(value) {
      var val = (value || '').trim();return val.length === 0;
    }, message: name + '\u4E0D\u80FD\u4E3A\u7A7A!' };
};var validateMax = function validateMax(name, max, message) {
  return { validate: function validate(value) {
      var val = (value || '').trim();return val.length > max;
    }, message: message || name + '\u4E0D\u80FD\u8D85\u8FC7' + max + '\u5B57!' };
};var validateMin = function validateMin(name, min, message) {
  return { validate: function validate(value) {
      var val = (value || '').trim();return val.length < min;
    }, message: message || name + '\u957F\u5EA6\u4E0D\u80FD\u5C0F\u4E8E' + min };
};var validateEmail = function validateEmail() {
  return [{ validate: function validate(value) {
      var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;return value.length !== 0 && !reg.test(value);
    }, message: '邮箱格式不正确！' }, { validate: function validate(value) {
      return value.length > 320;
    }, message: '邮箱长度不能超过320位！' }];
};var validatePhone = function validatePhone(name, isTel, phoneList) {
  var rule = [{ validate: function validate(value) {
      var val = (value || '').trim();return val.length === 0;
    }, message: name + '\u4E0D\u80FD\u4E3A\u7A7A!' }, { validate: function validate(value) {
      var re = /^\d{5,10}$/;var re9 = /^9\d{3,11}$/;var rePhone = /^1[3456789]\d{9}$/;var reTel = /^0\d{2,3}-\d{7,8}$/;if (!isTel) {
        return !rePhone.test(value);
      }return !re.test(value) && !re9.test(value) && !reTel.test(value) && !rePhone.test(value);
    }, message: '号码格式不正确！' }];if (isTel) {
    rule.push({ validate: function validate(value) {
        return phoneList && phoneList.some(function (item) {
          return item === value;
        });
      }, message: '号码已在审核中！' });
  }return rule;
};var getValidate = function getValidate(rules, value) {
  var validate = false;var message = '';if (rules && rules.length > 0) {
    rules.forEach(function (rule) {
      if (validate) {
        return;
      }if (rule && rule.validate && rule.validate(value)) {
        validate = true;message = rule.message;
      }
    });
  }return { validate: validate, message: message };
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(753);

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alert = __webpack_require__(754);

var _alert2 = _interopRequireDefault(_alert);

var _Modal = __webpack_require__(82);

var _Modal2 = _interopRequireDefault(_Modal);

var _operation = __webpack_require__(758);

var _operation2 = _interopRequireDefault(_operation);

var _prompt = __webpack_require__(759);

var _prompt2 = _interopRequireDefault(_prompt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Modal2['default'].alert = _alert2['default'];
_Modal2['default'].prompt = _prompt2['default'];
_Modal2['default'].operation = _operation2['default'];
exports['default'] = _Modal2['default'];
module.exports = exports['default'];

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return flag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return confirm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_buyAction__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Confirmation__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_activityAction__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_activitySuAction__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modal__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util__ = __webpack_require__(5);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 运营活动页面
  * @author: wence
  */var flag = 'saasact4';var _renderBody = function _renderBody(content, title, disabledHtml) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-prize-body' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'title' }, title), disabledHtml ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'content' }, content) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'content', dangerouslySetInnerHTML: { __html: content } }));
};var _renderFooter = function _renderFooter(_ref) {
  var okText = _ref.okText,
      okClick = _ref.okClick,
      cancelText = _ref.cancelText,
      cancelClick = _ref.cancelClick;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'x-footer' }, cancelText && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { onClick: cancelClick, className: 'x-btn x-footer-cancel' }, cancelText), okText && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { onClick: okClick, className: 'x-btn x-footer-confirm' }, okText));
};_renderFooter.propTypes = { okText: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, okClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, cancelText: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, cancelClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func };var confirm = function confirm(_ref2) {
  var title = _ref2.title,
      type = _ref2.type,
      content = _ref2.content,
      okText = _ref2.okText,
      okClick = _ref2.okClick,
      cancelText = _ref2.cancelText,
      cancelClick = _ref2.cancelClick,
      disabledHtml = _ref2.disabledHtml,
      isAnimation = _ref2.isAnimation,
      disableCloseByMask = _ref2.disableCloseByMask;return Object(__WEBPACK_IMPORTED_MODULE_7__components_Confirmation__["a" /* default */])({ title: title, isAnimation: isAnimation, disableCloseByMask: disableCloseByMask, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('w-confirm-modal', type), renderBody: function renderBody() {
      return _renderBody(content, title, disabledHtml);
    }, renderFooter: function renderFooter() {
      return _renderFooter({ okText: okText, okClick: okClick, cancelText: cancelText, cancelClick: cancelClick });
    } });
};var Activity = (_temp = _class = function (_PureComponent) {
  _inherits(Activity, _PureComponent);function Activity(props) {
    var _this2 = this;_classCallCheck(this, Activity);var _this = _possibleConstructorReturn(this, (Activity.__proto__ || Object.getPrototypeOf(Activity)).call(this, props));_this.fetchActivityInfo = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res, prize;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _context.next = 2;return Object(__WEBPACK_IMPORTED_MODULE_8__actions_activityAction__["a" /* fetchActivityInfo */])({ flag: flag, 'is_wap': 1 });case 2:
              res = _context.sent;if (res.status === 0) {
                _this.setState({ activityInfo: res.data });prize = (res.data && res.data.prize || []).length;_this.prizeCount = prize;_this.setState({ isStart: res.data.start });
              } else {
                _this.setState({ activityInfo: {} });
              }case 4:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2);
    }));_this.fetchGetNewService = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var fetchGetNewService, newService;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              fetchGetNewService = _this.props.fetchGetNewService;_context2.next = 3;return fetchGetNewService(_this.instanceId ? { 'instance_id': _this.instanceId } : undefined);case 3:
              newService = _context2.sent;if (newService.data && newService.data.status === 0) {
                _this.setState({ serviceList: newService.data.data.free_list, orderList: newService.data.data.order_list });
              }case 5:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2);
    }));_this.payVoucher = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var params, localKey, dataStr, data, res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {case 0:
              params = { 'instance_id': _this.instanceId, 'channel': '1' };try {
                localKey = '__abbaidu_20181211_cb';dataStr = localStorage.getItem(localKey);data = JSON.parse(dataStr);params.data = data.data;params['key_id'] = data.key_id;params.sign = data.sign;
              } catch (e) {
                params.data = '';params['key_id'] = '';params.sign = '';
              }_context3.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_9__actions_activitySuAction__["b" /* payVoucher */])(params);case 4:
              res = _context3.sent;if (res.status === 0) {
                _this.confirm = confirm({ title: '领取成功！', content: '<div class="lq-success">\n                <div class="lq-item"><span>100</span><span>\u5143</span><span>\u6F0F\u6D1E\u626B\u63CF-\u4E13\u4E1A\u7248 \u6708\u5957\u9910\u4E13\u7528</span></div>\n                <div class="lq-item"><span>300</span><span>\u5143</span><span>\u6F0F\u6D1E\u626B\u63CF-\u4E13\u4E1A\u7248 \u5E74\u5957\u9910\u4E13\u7528</span></div>\n                <div class="lq-item"><span>4000</span><span>\u5143</span><span>\u7F51\u5740\u5B89\u5168\u68C0\u6D4B A\u5957\u9910\u4E13\u7528</span></div>\n                <div class="lq-item"><span>5400</span><span>\u5143</span><span>\u7F51\u5740\u5B89\u5168\u68C0\u6D4B B\u5957\u9910\u4E13\u7528</span></div>\n            </div>\n            <div class="lq-hint">\n            \u53D1\u653E\u81F3\u8D26\u6237\uFF0C\u53EF\u5728<a target="_blank" href="/console/#/orderView">\u4E2A\u4EBA\u4E2D\u5FC3</a>\u67E5\u770B\n            </div>', okText: '去购买', okClick: function okClick() {
                    window.location.href = '/console/#/urlsec/buy';
                  } });
              } else if (res.status === 401) {
                window.location.href = _this.loginUrl();
              } else if (res.description) {
                _this.confirm = confirm({ title: '', content: res.description, okText: '关闭', isAnimation: false, okClick: function okClick() {
                    return _this.confirm && _this.confirm();
                  } });
              }case 6:case 'end':
              return _context3.stop();}
        }
      }, _callee3, _this2);
    }));_this.payProduct = function (item) {
      if (item.is_buy) {
        return false;
      }var _this$state = _this.state,
          instanceRes = _this$state.instanceRes,
          serviceList = _this$state.serviceList;if (serviceList.length && instanceRes.status === 0) {
        var json = { 'instance_id': _this.instanceId, 'service_id': item.service_id, 'meal_id': item.meal_id };_this.props.fetchApimealPay(json).then(function (data) {
          if (data.data.status === 0) {
            // 购买成功
            _this.fetchGetNewService();_this.fetchRemainInfo();_this.confirm = confirm({ title: '', type: 'small', content: '购买成功，可前往控制台查看使用说明', okText: '继续购买', okClick: function okClick() {
                _this.confirm && _this.confirm();
              }, cancelText: '去控制台', cancelClick: function cancelClick() {
                window.location.href = item.url;
              } });
          } else if (data.data.status === 404008) {
            // 未实名
            Object(__WEBPACK_IMPORTED_MODULE_6__actions_buyAction__["f" /* fetchRealName */])({ 'instance_id': _this.instanceId }).then(function (res) {
              _this.confirm = confirm({ title: '', type: 'small', content: '您的账号还没有认证，认证后才能购买哦！', okText: '去认证', okClick: function okClick() {
                  window.location.href = res && res.data && res.data['auth_type'] === 1 ? '/console/#/attestation' : _this.userCenterUrl();
                } });
            });
          } else if (data.data.status === 404008) {
            // 未登录
            location.href = _this.loginUrl();
          } else {
            _this.confirm = confirm({ title: '', content: data.data.description, okText: '确认', okClick: function okClick() {
                _this.confirm && _this.confirm();
              } });
          }
        });
      } else {
        location.href = _this.loginUrl();
      }
    };_this.getActivityId = function () {
      return ((_this.state.activityInfo || {}).activity || {}).activity_id;
    };_this.fetchRemainInfo = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {case 0:
              _context4.next = 2;return Object(__WEBPACK_IMPORTED_MODULE_8__actions_activityAction__["d" /* fetchRemain */])({ aid: _this.getActivityId(), flag: flag, 'instance_id': _this.instanceId });case 2:
              res = _context4.sent;if (res.status === 0) {
                _this.setState({ remain: res.data.remain, remainMsg: '' });
              } else {
                _this.setState({ remainMsg: res.description });
              }case 4:case 'end':
              return _context4.stop();}
        }
      }, _callee4, _this2);
    }));_this.getPrize = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var params;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {case 0:
              if (_this.state.isStart) {
                _context6.next = 3;break;
              }_this.confirm = confirm({ title: '', content: '您好，不在活动时间范围内哦', okText: '确认', okClick: function okClick() {
                  _this.confirm && _this.confirm();
                } });return _context6.abrupt('return');case 3:
              if (!_this.start) {
                _context6.next = 5;break;
              }return _context6.abrupt('return');case 5:
              _this.start = true;params = { aid: _this.getActivityId(), flag: flag, 'instance_id': _this.instanceId };Object(__WEBPACK_IMPORTED_MODULE_11__util__["a" /* bAntiBotSend */])();window['__abbaidu_2024_cb'] = function () {
                var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(responseData) {
                  var localData, res, prizeList, index;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {case 0:
                          localData = JSON.parse(responseData);if (localData && localData.data) {
                            params.data = localData.data;
                          }if (localData && localData.key_id) {
                            params['key_id'] = localData['key_id'];
                          }if (localData && localData.sign) {
                            params.sign = localData.sign;
                          }_context5.next = 6;return Object(__WEBPACK_IMPORTED_MODULE_8__actions_activityAction__["b" /* fetchPrize */])(params);case 6:
                          res = _context5.sent;if (!(res.status === 0)) {
                            _context5.next = 27;break;
                          }if (res.data.status) {
                            _context5.next = 21;break;
                          }_this.start = false;if (!(res.data.code === 10003)) {
                            _context5.next = 13;break;
                          }_this.makeTask(res.data.message);return _context5.abrupt('return');case 13:
                          if (!(res.data.code === 10004)) {
                            _context5.next = 19;break;
                          }_this.setState({ remain: res.data.remain || 0 });_this.startRoll();_this.interRoll(res.data);_this.stopRoll(-1);return _context5.abrupt('return');case 19:
                          _this.confirm = confirm({ title: '', content: res.data.message, okText: '确认', okClick: function okClick() {
                              _this.confirm && _this.confirm();
                            } });return _context5.abrupt('return');case 21:
                          _this.setState({ remain: res.data.remain || 0 });_this.startRoll();_this.interRoll(res.data);if (res.data.prize && res.data.prize.pid) {
                            prizeList = _this.state.activityInfo.prize || [];index = prizeList.findIndex(function (item) {
                              return item.pid === res.data.prize.pid;
                            });_this.stopRoll(index);
                          } else {
                            _this.stopRoll(-1);
                          }_context5.next = 28;break;case 27:
                          if (res.status === 401) {
                            _this.start = false;_this.confirm = confirm({ title: '', content: res.description, okText: '去登录', okClick: function okClick() {
                                _this.confirm && _this.confirm();window.location.href = _this.loginUrl();
                              } });
                          } else {
                            _this.start = false;_this.confirm = confirm({ title: '', content: res.description, okText: '确认', okClick: function okClick() {
                                _this.confirm && _this.confirm();
                              } });
                          }case 28:case 'end':
                          return _context5.stop();}
                    }
                  }, _callee5, _this2);
                }));return function (_x) {
                  return _ref8.apply(this, arguments);
                };
              }();case 9:case 'end':
              return _context6.stop();}
        }
      }, _callee6, _this2);
    }));_this.makeTask = function (text) {
      _this.confirm = confirm({ title: '', content: text, okText: '去参加', okClick: function okClick() {
          _this.confirm && _this.confirm();var offsetTop = _this.productNode.getBoundingClientRect().top;document.documentElement.scrollTop = document.body.scrollTop = offsetTop;
        } });
    };_this.successRoll = function () {
      _this.start = false;if (!_this.info) {
        return;
      }var info = _this.info;if (info.status && info.prize && info.prize.prize_type === 1) {
        _this.confirm = confirm({ title: '', content: '恭喜您获得' + info.prize.prize_name + '一个，请填写邮寄信息', okText: '填写信息', cancelText: '继续抽奖', okClick: function okClick() {
            _this.setState({ visible: true, parizeInfo: info }, function () {
              _this.confirm && _this.confirm();
            });
          }, cancelClick: function cancelClick() {
            _this.confirm && _this.confirm();
          } });
      } else if (info && info.prize && info.prize.prize_name) {
        _this.confirm = confirm({ title: '', content: info.message || '恭喜您中奖' + info.prize.prize_name + '，请前往<a ' + 'target="_blank"' + 'href="/console/#/orderView">控制台</a>查看使用', okText: _this.state.remain > 0 ? '继续抽奖' : '确认', okClick: function okClick() {
            _this.confirm && _this.confirm(); // if (this.state.remain === 0) {
            //     const offsetTop = this.productNode.offsetTop;
            //     document.documentElement.scrollTop = document.body.scrollTop = offsetTop;
            // }
          } });
      } else if (info && info.message) {
        _this.confirm = confirm({ title: '', content: info.message, okText: '确认', okClick: function okClick() {
            _this.confirm && _this.confirm();
          } });
      }_this.setState({ prizeIndex: -1 });
    };_this.startRoll = function () {
      _this.speed += 10;if (!_this.inter && _this.speed > 50) {
        _this.speed = 50;
      }if (_this.speed >= 100) {
        _this.speed = 100;
      }if (_this.circle <= 0 && _this.endIndex === _this.state.prizeIndex) {
        clearTimeout(_this.timer);_this.timer = null;_this.initalCountParams();_this.successRoll();return;
      }if (_this.circle <= 0 && _this.endIndex === -1) {
        clearTimeout(_this.timer);_this.timer = null;_this.initalCountParams();_this.successRoll();_this.setState({ prizeIndex: -1 });return;
      }_this.circle -= 1;if (!_this.inter && _this.circle <= 10) {
        _this.circle = 10;
      }_this.setState({ prizeIndex: _this.index }, function () {
        if (_this.index >= _this.prizeCount - 1) {
          _this.index = 0;
        } else {
          _this.index += 1;
        }setTimeout(_this.startRoll, _this.speed);
      });
    };_this.interRoll = function (info) {
      _this.inter = true;_this.info = info;
    };_this.stopRoll = function (index) {
      _this.endIndex = index || -1;
    };_this.setPrizeCount = function (count) {
      _this.prizeCount = count;
    };_this.initalCountParams = function () {
      _this.speed = 30;_this.inter = false;_this.timer = null;_this.index = -1;_this.endIndex = -1;_this.circle = 30;
    };_this.state = { instanceRes: {}, serviceList: [], orderList: [], activityInfo: {}, remain: 0, prizeIndex: -1, // 中奖位置
      visible: false, parizeInfo: null, isStart: false, remainMsg: '' };_this.instanceId = '';_this.speed = 30;_this.inter = false;_this.timer = null;_this.index = 0;_this.endIndex = -1;_this.circle = 30;_this.prizeCount = 0;_this.start = false;if (_this.isPC()) {
      location.href = '/activity/prize';
    }return _this;
  }_createClass(Activity, [{ key: 'componentDidMount', value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var fetchInstanceGetInstance, instanceRes;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {case 0:
                fetchInstanceGetInstance = this.props.fetchInstanceGetInstance;_context7.next = 3;return fetchInstanceGetInstance();case 3:
                instanceRes = _context7.sent;if (instanceRes.data && instanceRes.data.status === 0) {
                  this.instanceId = Object.keys(instanceRes.data.data)[0];
                }_context7.next = 7;return this.fetchActivityInfo();case 7:
                _context7.next = 9;return this.fetchRemainInfo();case 9:
                this.fetchGetNewService();this.setState({ instanceRes: instanceRes ? instanceRes.data : {} });case 11:case 'end':
                return _context7.stop();}
          }
        }, _callee7, this);
      }));function componentDidMount() {
        return _ref9.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _this3 = this;var prizeList = [0, 1, 2, 7, -1, 3, 6, 5, 4];var _state = this.state,
          serviceList = _state.serviceList,
          activityInfo = _state.activityInfo,
          visible = _state.visible,
          parizeInfo = _state.parizeInfo,
          orderList = _state.orderList;var activity = activityInfo && activityInfo.activity || {};var obj = { ent: '企业版', adv: '专业版', free: '免费版' };return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-activity' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pic1' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pic2' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pic3' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__modal__["a" /* default */], { aid: this.getActivityId(), resetData: function resetData() {
          return null;
        }, visible: visible, successMsg: '信息提交成功, 详细信息请到我的奖品中查看~', parizeInfo: parizeInfo && parizeInfo.prize, onCancel: function onCancel() {
          return _this3.setState({ visible: false, parizeInfo: null });
        } }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-activity-banner' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-section-title padding-top-100', style: { display: 'none' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3', { className: 'w-section-title-text' }, activity.activity_name)), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4', { className: 'w-section-sub-title' }, activity.activity_desc), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-prize-wrapper' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-prize' }, prizeList.map(function (index) {
        if (index === -1) {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, onClick: _this3.getPrize, className: 'w-prize-btn' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'prize' }, '\u7ACB\u5373\u62BD\u5956'), _this3.state.instanceRes.status === 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'count' }, '\u5269\u4F59' + _this3.state.remain + '\u6B21\u62BD\u5956\u673A\u4F1A'));
        }var info = (activityInfo.prize || [])[index] || {};var imgUrl = info.prize_img_url ? 'url(' + info.prize_img_url + ')' : '';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('w-prize-cell', { active: _this3.state.prizeIndex === index }) }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pic', style: { backgroundImage: imgUrl } }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'name' }, info.prize_name));
      }))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-rules' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'w-rules-content' }, '\u6D3B\u52A8\u65F6\u95F4\uFF1A2021\u5E746\u67089\u65E5 - 2021\u5E747\u67088\u65E5', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '\u53C2\u4E0E\u65B9\u5F0F', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '1\u3001\u30100\u5143\u62BD\u5927\u5956\u3011\u9996\u6B21\u9886\u53D6\u514D\u8D39\u8BD5\u7528\u6216\u8005\u8D2D\u4E70\u4EFB\u4E00\u4ED8\u8D39\u4EA7\u54C1\uFF08\u6F0F\u6D1E\u626B\u63CF\u4E13\u4E1A\u7248/\u4F01\u4E1A\u7248\u670D\u52A1\u3001\u7F51\u5740\u5B89\u5168\u68C0\u6D4B\u4EFB\u610F\u4ED8\u8D39\u5957\u9910\u670D\n                        \u52A1\uFF09\uFF0C\u5373\u53EF\u83B7\u5F97\u4E09\u6B21\u62BD\u5956\u673A\u4F1A\uFF0C\u6BCF\u4E2A\u8D26\u6237\u6700\u591A\u4E09\u6B21\u62BD\u5956\u673A\u4F1A\uFF1B', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '2.\u3010\u65B0\u8D2D\u6EE1\u989D\u9001\u3011\u6210\u529F\u8D2D\u4E70\u7F51\u5740\u5B89\u5168\u68C0\u6D4B\u670D\u52A1\u7684\u4ED8\u8D39\u5957\u9910\uFF0C\u5373\u8D60\u9001\u4EF7\u503C500\u5143\u7684\u4EAC\u4E1C\u793C\u54C1\u5361\u4E00\u5F20\uFF0C\u9650\u91CF\u62A2\u8D2D\uFF0C\u9001\u5B8C\u4E3A\u6B62\u3002\u4E0B\u5355\u6210\u529F\u540E\uFF0C\u8BF7\u5728', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { target: '_blank', className: 'w-linkClassP', href: '/activity/address' }, '\u6211\u7684\u5956\u54C1'), '\u586B\u5199\u90AE\u5BC4\u4FE1\u606F\u3002', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '3\u3001\u3010\u4E07\u5143\u5927\u793C\u5305\u3011\u6240\u6709\u5E73\u53F0\u65B0\u8001\u7528\u6237\u5747\u53EF\u9886\u53D6\u4E07\u5143\u4F18\u60E0\u5238\u5927\u793C\u5305\u3002\u4EE3\u91D1\u5238\u6709\u6548\u671F\uFF1A2021\u5E746\u67089\u65E5 - 2021\u5E747\u67088\u65E5\uFF1B', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '\u7528\u6237\u62BD\u4E2D\u5B9E\u7269\u5956\u54C1\u540E\uFF0C\u5DE5\u4F5C\u4EBA\u5458\u5C06\u4F1A\u5728\u6D3B\u52A8\u7ED3\u675F\u540E15\u4E2A\u5DE5\u4F5C\u65E5\u5185\u5BC4\u9001\uFF0C\u5956\u54C1\u8BF7\u5728\u6D3B\u52A8\u671F\u5185\u5B8C\u6210\u90AE\u5BC4\u4FE1\u606F\u7684\u586B\u5199\uFF0C \u5426\u5219\u89C6\u4E3A\u81EA\u52A8\u653E\u5F03\uFF1B\u7528\u6237\u62BD\u4E2D\u4EE3\u91D1\u5238\u5956\u54C1\u540E\uFF0C\u5C06\u7531\u7CFB\u7EDF\u81EA\u52A8\u53D1\u653E\u81F3\u8D26\u6237\uFF0C\u53EF\u5728', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { target: '_blank', className: 'w-linkClassP', href: '/console/#/orderView' }, '\u4E2A\u4EBA\u4E2D\u5FC3'), '\u67E5\u770B\u3002 \u4EE3\u91D1\u5238\u6709\u6548\u671F\uFF1A2021\u5E746\u67089\u65E5 - 2021\u5E747\u67088\u65E5\uFF1B'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'w-rules-options' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { onClick: function onClick() {
          _this3.confirm = confirm({ title: '活动规则', type: 'large', content: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'details-wrapper' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'details' }, '1.\u6D3B\u52A8\u65F6\u95F4', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '2021\u5E746\u67089\u65E5 - 2021\u5E747\u67088\u65E5', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '2.\u53C2\u4E0E\u6761\u4EF6', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '1)\u30100\u5143\u62BD\u5927\u5956\u3011\u9996\u6B21\u9886\u53D6\u514D\u8D39\u8BD5\u7528\u6216\u8005\u8D2D\u4E70\u4EFB\u4E00\u4ED8\u8D39\u4EA7\u54C1\uFF08\u6F0F\u6D1E\u626B\u63CF\u4E13\u4E1A\u7248/\u4F01\u4E1A\u7248\u670D\u52A1\n                                                \u3001\u7F51\u5740\u5B89\u5168\u68C0\u6D4B\u4EFB\u610F\u4ED8\u8D39\u5957\u9910\u670D\u52A1\uFF09\uFF0C\u5373\u53EF\u83B7\u5F97\u4E09\u6B21\u62BD\u5956\u673A\u4F1A\uFF0C\u6BCF\u4E2A\u8D26\u6237\u6700\u591A\u4E09\u6B21\u62BD\u5956\u673A\u4F1A', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '2)\u3010\u65B0\u8D2D\u6EE1\u989D\u9001\u3011\u6210\u529F\u8D2D\u4E70\u7F51\u5740\u5B89\u5168\u68C0\u6D4B\u670D\u52A1\u7684\u4ED8\u8D39\u5957\u9910\uFF0C\u5373\u8D60\u9001\u4EF7\u503C500\u5143\u7684\u4EAC\u4E1C\u793C\u54C1\u5361\u4E00\u5F20\uFF0C \u9650\u91CF\u62A2\u8D2D\uFF0C\u9001\u5B8C\u4E3A\u6B62\u3002\u4E0B\u5355\u6210\u529F\u540E\uFF0C\u8BF7\u5728', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { target: '_blank', className: 'w-linkClassP', href: '/m/activity/address' }, '\u6211\u7684\u5956\u54C1'), '\u586B\u5199\u90AE\u5BC4\u4FE1\u606F\u3002', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '3)\u3010\u4E07\u5143\u5927\u793C\u5305\u3011\u6240\u6709\u5E73\u53F0\u65B0\u8001\u7528\u6237\u5747\u53EF\u9886\u53D6\u4E07\u5143\u4F18\u60E0\u5238\u5927\u793C\u5305\u3002\u7CFB\u7EDF\u5C06\u81EA\u52A8\u53D1\u653E\u81F3\u8D26\u6237\uFF0C \u53EF\u5728', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { target: '_blank', className: 'w-linkClassP', href: '/console/#/orderView' }, '\u4E2A\u4EBA\u4E2D\u5FC3'), '\u67E5\u770B\uFF1B\u4EE3\u91D1\u5238\u6709\u6548\u671F\uFF1A2021\u5E746\u67089\u65E5 - 2021\u5E747\u67088\u65E5\uFF1B', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '3. \u53C2\u4E0E\u5BF9\u8C61', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '\u672C\u6B21\u6D3B\u52A8\u4EC5\u9488\u5BF9\u672A\u5728\u672C\u5E73\u53F0\u9886\u53D6\u8FC7\u514D\u8D39\u8BD5\u7528\u4EA7\u54C1\u7684\u7528\u6237\uFF0C\u53CA\u6D3B\u52A8\u671F\u95F4\u6210\u529F\u8D2D\u4E70\u4ED8\u8D39\u7248\u6F0F\u6D1E\u626B\u63CF\u6216\u7F51\u5740\u5B89\u5168\u68C0\u6D4B\u670D\u52A1\u7684\u7528\u6237\u3002', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '4.\u5956\u54C1\u4FE1\u606F', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '1)\u672C\u6B21\u62BD\u5956\u6D3B\u52A8\u7684\u5B9E\u7269\u5956\u54C1\u6709\u5C0F\u5EA6\u667A\u80FD\u97F3\u7BB1Pro\u3001\u5EA6\u718A\u684C\u9762\u52A0\u6E7F\u5668\u3001\u4EAC\u4E1C\u793C\u54C1\u536150\u5143\u3001\u4EAC\u4E1C\u793C \u54C1\u5361100\u5143\u3001\u7231\u5947\u827AVIP\u9EC4\u91D1\u4F1A\u5458\u6708\u5361\u3001\u767E\u5EA6\u6F0F\u6D1E\u626B\u63CF\u4F01\u4E1A\u7248\u6708\u5957\u9910\u4F18\u60E0\u52381000\u5143\uFF0C\u767E\u5EA6\u6F0F\u6D1E\u626B\u63CF \u4F01\u4E1A\u7248\u5E74\u5957\u9910\u4F18\u60E0\u52385000\u5143\u3001\u5C0F\u6728\u5C4B\u56FE\u4E66\xB7\u81F3\u5C0A\u5148\u4EAB\u6708\u5361\uFF0C\u6D3B\u52A8\u603B\u4F53\u4E2D\u5956\u6982\u738799%\u3002', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '2)\u7528\u6237\u62BD\u4E2D\u5B9E\u7269\u5956\u54C1\u540E\uFF0C\u8BF7\u5728\u6D3B\u52A8\u671F\u5185\uFF0C\u53732021\u5E746\u67089\u65E5\u81F32021\u5E747\u67088\u65E5\u671F\u95F4\u5728', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { target: '_blank', className: 'w-linkClassP', href: '/m/activity/address' }, '\u6211\u7684\u5956\u54C1'), '\u5B8C\u6210\u90AE\u5BC4\u4FE1\u606F\u7684\u586B\u5199\uFF0C\u5426\u5219\u89C6\u4E3A\u81EA\u52A8\u653E\u5F03\u3002\u5DE5\u4F5C\u4EBA\u5458\u5C06\u4F1A\u5728\u6D3B\u52A8\u7ED3\u675F\u540E 15\u4E2A\u5DE5\u4F5C\u65E5\u5185\u5BC4\u9001\u5956\u54C1\u3002\u903E\u671F\u672A\u5B8C\u6210\u90AE\u5BC4\u4FE1\u606F\u586B\u5199\u6216\u56E0\u6240\u63D0\u4F9B\u4FE1\u606F\u95EE\u9898\u5BFC\u81F4\u7684\u9519\u53D1\u3001 \u5956\u54C1\u4E22\u5931\u6216\u672A\u6536\u5230\u5956\u54C1\u7684\uFF0C\u5C06\u7531\u7528\u6237\u627F\u62C5\u4E0D\u5229\u540E\u679C\u3002', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '3)\u5B9E\u7269\u5956\u54C1\u56FE\u7247\u4EC5\u4F9B\u53C2\u8003\uFF0C\u8BF7\u4EE5\u5177\u4F53\u5B9E\u7269\u4E3A\u51C6\uFF0C\u5177\u4F53\u5956\u54C1\u914D\u5957\u53CA\u552E\u540E\u670D\u52A1\u7B49\uFF0C\u7531\u76F8\u5E94\u5B9E\u7269 \u751F\u4EA7\u548C\u9500\u552E\u5546\u5BB6\u8D1F\u8D23\u63D0\u4F9B\uFF0C\u5177\u4F53\u89C1\u5B9E\u7269\u5956\u54C1\u914D\u5957\u4F7F\u7528\u8BF4\u660E\u4E66\u7B49\u3002\u7528\u6237\u5728\u6536\u5230\u5B9E\u7269\u5956\u54C1\u540E\uFF0C \u52A1\u5FC5\u7B2C\u4E00\u65F6\u95F4\u9A8C\u8D27\u3002\u82E5\u53D1\u73B0\u8FD0\u8F93\u9014\u4E2D\u9020\u6210\u5546\u54C1\u635F\u574F\uFF0C\u8BF7\u62D2\u7B7E\u9000\u56DE\uFF0C\u5982\u786E\u8BA4\u65E0\u8BEF\u65B9\u53EF\u7B7E\u6536\u3002 \u4E00\u7ECF\u7B7E\u6536\uFF0C\u5956\u54C1\u6BC1\u635F\u706D\u5931\u767E\u5EA6\u6982\u4E0D\u8D1F\u8D23\u3002\u5B9E\u7269\u5956\u54C1\u65E0\u8D28\u91CF\u95EE\u9898\u5747\u4E0D\u652F\u6301\u9000\u6362\uFF0C\u5956\u54C1\u5747\u4E0D\u63D0 \u4F9B\u53D1\u7968\u548C\u6536\u636E\u7B49\u51ED\u8BC1\u3002', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '4)\u7528\u6237\u62BD\u4E2D\u4EE3\u91D1\u5238\u7B49\u975E\u5B9E\u7269\u5956\u54C1\u540E\uFF0C\u5C06\u7531\u7CFB\u7EDF\u81EA\u52A8\u53D1\u653E\u81F3\u7528\u6237\u8D26\u6237\uFF0C\u8BF7\u901A\u8FC7', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { target: '_blank', className: 'w-linkClassP', href: '/console/#/orderView' }, '\u4E2A\u4EBA\u4E2D\u5FC3'), '\u67E5\u770B\u3002 \u4EE3\u91D1\u5238\u6709\u6548\u671F\u4E3A2021\u5E746\u67089\u65E5 - 2021\u5E747\u67088\u65E5\u3002', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '5.\u7279\u522B\u8BF4\u660E', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '1)\u53C2\u4E0E\u6D3B\u52A8\u7684\u7528\u6237\u5E94\u540C\u65F6\u9075\u5B88\u767E\u5EA6\u5B89\u5168\u5B98\u7F51\u6240\u793A\u7684\u300A\u7528\u6237\u670D\u52A1\u534F\u8BAE\u300B\u3001 \u4EA7\u54C1\u76F8\u5173\u7684\u534F\u8BAE\u53CA\u9875\u9762 \u4F7F\u7528\u89C4\u5219\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4EA7\u54C1\u670D\u52A1\u7B49\u7EA7\u534F\u8BAE\uFF0C\u4F7F\u7528\u89C4\u8303\uFF0C\u4EA7\u54C1\u670D\u52A1\u6761\u6B3E\u7B49\uFF09\u3002', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '2)\u540C\u4E00\u8BBE\u5907\u4EC5\u53EF\u767B\u5F55\u4E00\u4E2A\u5E10\u53F7\u53C2\u4E0E\u6D3B\u52A8\u3002\u6D3B\u52A8\u671F\u95F4\uFF0C\u4E00\u7ECF\u53D1\u73B0\u901A\u8FC7\u6076\u610F\u6CE8\u518C\u6216\u5176\u4ED6\u4E0D\u6B63\u5F53\u624B \u6BB5\u5728\u672C\u6B21\u6D3B\u52A8\u4E2D\u8FDB\u884C\u975E\u6CD5\u725F\u5229\u3001\u7092\u4F5C\u3001\u8F6C\u552E\u3001\u83B7\u5956\u3001\u865A\u5047\u4EA4\u6613\u7684\uFF0C\u767E\u5EA6\u6709\u6743\u53D6\u6D88\u5176\u83B7\u5956\u8D44\u683C \u6216\u5176\u56E0\u53C2\u52A0\u6D3B\u52A8\u6240\u83B7\u6743\u76CA\uFF0C\u6709\u6743\u91C7\u53D6\u5305\u62EC\u4E0D\u9650\u4E8E\u505C\u6B62\u670D\u52A1\u3001\u5C01\u505C\u5E10\u53F7\u3001\u51BB\u7ED3\u4EE3\u91D1\u5238\u7B49\u6B62\u635F\u548C\u4FDD \u62A4\u63AA\u65BD\uFF1B\u5982\u8BE5\u8FDD\u89C4\u884C\u4E3A\u7ED9\u767E\u5EA6\u9020\u6210\u635F\u5931\u7684\uFF0C\u767E\u5EA6\u4FDD\u7559\u8FFD\u7A76\u5176\u6C11\u4E8B\u8D23\u4EFB\u548C\u5211\u4E8B\u8D23\u4EFB\u7684\u6743\u5229\u3002', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '3)\u6D3B\u52A8\u671F\u95F4\uFF0C\u56E0\u7528\u6237\u64CD\u4F5C\u4E0D\u5F53\u6216\u7528\u6237\u6240\u5728\u5730\u533A\u7F51\u7EDC\u6545\u969C\u3001\u7535\u4FE1\u8FD0\u8425\u5546\u6545\u969C\u7B49\u975E\u767E\u5EA6\u6240\u80FD\u63A7\u5236\u7684 \u539F\u56E0\u5BFC\u81F4\u7528\u6237\u65E0\u6CD5\u53C2\u4E0E\u6D3B\u52A8\u6216\u53C2\u4E0E\u5931\u8D25\uFF0C\u8BF7\u60A8\u8054\u7CFB\u5F53\u5730\u7535\u4FE1\u8FD0\u8425\u5546\u89E3\u51B3\u3002', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '4)\u53C2\u4E0E\u672C\u6D3B\u52A8\u7528\u6237\uFF0C\u9700\u4FDD\u8BC1\u8EAB\u4EFD\u771F\u5B9E\u6709\u6548\uFF0C\u4E14\u4E2D\u5956\u7528\u6237\u9700\u4E0E\u6D3B\u52A8\u53C2\u4E0E\u4EBA\u4FDD\u6301\u4E00\u81F4\uFF0C\u5982\u7528\u6237\u4FE1 \u606F\u4E0D\u4E00\u81F4\u6240\u5BFC\u81F4\u7684\u635F\u5931\u7531\u7528\u6237\u81EA\u884C\u627F\u62C5\u3002', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '5)\u5982\u51FA\u73B0\u4E0D\u53EF\u6297\u529B\u6216\u60C5\u52BF\u53D8\u66F4\u7684\u60C5\u51B5(\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u91CD\u5927\u707E\u5BB3\u4E8B\u4EF6\u3001\u6D3B\u52A8\u53D7\u653F\u5E9C\u673A\u5173\u6307\u4EE4\u9700 \u8981\u505C\u6B62\u4E3E\u529E\u6216\u8C03\u6574\u7684\u3001\u6D3B\u52A8\u906D\u53D7\u4E25\u91CD\u7F51\u7EDC\u653B\u51FB\u6216\u56E0\u7CFB\u7EDF\u6545\u969C\u9700\u8981\u6682\u505C\u4E3E\u529E\u7684),\u5219\u767E\u5EA6\u53EF\u4F9D\u76F8 \u5173\u6CD5\u5F8B\u6CD5\u89C4\u7684\u89C4\u5B9A\u4E3B\u5F20\u514D\u8D23\u3002', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '6)\u767E\u5EA6\u53EF\u6839\u636E\u6D3B\u52A8\u7684\u5B9E\u9645\u60C5\u51B5\uFF0C\u5728\u6CD5\u5F8B\u5141\u8BB8\u7684\u8303\u56F4\u5185\uFF0C\u5BF9\u672C\u6D3B\u52A8\u89C4\u5219\u8FDB\u884C\u53D8\u52A8\u6216\u8C03\u6574\uFF0C\u76F8\u5173 \u53D8\u52A8\u6216\u8C03\u6574\u5C06\u516C\u5E03\u5728\u6D3B\u52A8\u89C4\u5219\u9875\u9762\u4E0A\uFF0C \u5E76\u4E8E\u516C\u5E03\u65F6\u5373\u65F6\u751F\u6548\u3002', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null))), disabledHtml: true, okText: '确认', okClick: function okClick() {
              _this3.confirm && _this3.confirm();
            } });
        }, className: 'w-rules-options-details', ref: function ref(product) {
          return _this3.productNode = product;
        } }, '\u89C4\u5219\u8BE6\u60C5', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'w-icon-arrow w-icon-arrow-s' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: '/m/activity/address', className: 'w-rules-options-prize' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', null), '\u6211\u7684\u5956\u54C1'))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-section-title' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3', { className: 'w-section-title-text' }, '\u7279\u60E0\u4E13\u533A')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'srd-mod-lq' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(761), alt: '', onClick: function onClick() {
          _this3.payVoucher();
        } })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'news-srd-mod' }, orderList.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'srd-item-mod', key: index }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'srd-item-mod-top' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'srd-item-name' }, item.service_name), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'srd-item-type' }, obj[item.version] + ' ' + item.t_m, ' ')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: '/m/product/5', target: '_blank', className: 'srd-item-mod-a' }, '\u4EA7\u54C1\u8BE6\u60C5')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'srd-item-mod-m' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, item.detail.domain), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'srd-item-span' }, '\u57DF\u540D')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, item.detail.url), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'srd-item-span' }, 'URL')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, item.detail.scan), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'srd-item-span' }, '\u626B\u63CF\u6B21\u6570'))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'srd-item-tetx' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'srd-item-u' }, '\uFFE5'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'srd-item-price' }, item.price), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(149), alt: '' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'srd-item-delay' }, '\u539F\u4EF7\uFF1A', item.origin_price)), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { className: 'srd-item-mod-bot', href: '/console/#/scan/buy/all/' + item.meal_id, target: '_blank' }, '\u7ACB\u5373\u8D2D\u4E70'));
      })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'srd-list-box' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'srd-list-item' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'title' }, '\u7F51\u5740\u5B89\u5168\u68C0\u6D4B'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'des' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u67E5\u8BE2\u6B21\u6570'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '50\u4E07\u6B21')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'text' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\uFFE5'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '26000'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(149), alt: '' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'text2' }, '\u539F\u4EF7\uFF1A30000\u5143/\u5E74'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: '/m/product/urlsec', target: '_blank', className: 'srd-item-mod-a' }, '\u4EA7\u54C1\u8BE6\u60C5'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { className: 'srd-item-mod-bot', href: '/console/#/urlsec/buy', target: '_blank' }, '\u7ACB\u5373\u8D2D\u4E70')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'srd-list-item' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'title' }, '\u7F51\u5740\u5B89\u5168\u68C0\u6D4B'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'des' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u67E5\u8BE2\u6B21\u6570'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '100\u4E07\u6B21')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'text' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\uFFE5'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '44600'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(149), alt: '' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'text2' }, '\u539F\u4EF7\uFF1A50000\u5143/\u5E74'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: '/m/product/urlsec', target: '_blank', className: 'srd-item-mod-a' }, '\u4EA7\u54C1\u8BE6\u60C5'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { className: 'srd-item-mod-bot', href: '/console/#/urlsec/buy', target: '_blank' }, '\u7ACB\u5373\u8D2D\u4E70'))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-section-title' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3', { className: 'w-section-title-text' }, '\u514D\u8D39\u4E13\u533A')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-section-product padding-top-100' }, serviceList && serviceList.length > 0 && serviceList.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: item.service_id || index, className: 'w-section-product-item-wrapper' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'item-title' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('name', { hot: item.is_hot }) }, item.service_name), !!item.is_hot && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'hot-icon' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'item-body' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-des' }, item.service_desc), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'overHidden' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { className: 'product-details', href: item.url, target: '_blank' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u4EA7\u54C1\u8BE6\u60C5'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { className: 'w-icon-arrow' }))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-time' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'label' }, '\u514D\u8D39\u4F53\u9A8C\u65F6\u957F\uFF1A'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'value' }, item.capacity)), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { onClick: _this3.payProduct.bind(_this3, item), className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('product-btn', { disabled: item.is_buy }) }, item.is_buy ? '已领取' : '免费领取')));
      })));
    } }]);return Activity;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]), _class.propTypes = { fetchGetNewService: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, fetchInstanceGetInstance: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, fetchApimealPay: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, instanceGetinstance: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, activityGetService: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object }, _temp);/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function (state) {
  return { activityGetService: state.activityGetService, instanceGetinstance: state.instanceGetinstance };
}, function (dispatch) {
  return { fetchInstanceGetInstance: function fetchInstanceGetInstance() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }return __WEBPACK_IMPORTED_MODULE_6__actions_buyAction__["d" /* fetchInstanceGetInstance */].apply(undefined, [dispatch].concat(args));
    }, fetchGetNewService: function fetchGetNewService() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }return __WEBPACK_IMPORTED_MODULE_6__actions_buyAction__["c" /* fetchGetNewService */].apply(undefined, [dispatch].concat(args));
    }, fetchApimealPay: function fetchApimealPay() {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }return __WEBPACK_IMPORTED_MODULE_6__actions_buyAction__["b" /* fetchApimealPay */].apply(undefined, [dispatch].concat(args));
    } };
})(Activity));

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(280);
var requireObjectCoercible = __webpack_require__(86);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var setGlobal = __webpack_require__(87);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.0.0',
  mode: __webpack_require__(88) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(281);
var isObject = __webpack_require__(25);
var hide = __webpack_require__(26);
var objectHas = __webpack_require__(23);
var sharedKey = __webpack_require__(89);
var hiddenKeys = __webpack_require__(66);
var WeakMap = __webpack_require__(15).WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    hide(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(346)();
}


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(51);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(207);
var enumBugKeys = __webpack_require__(115);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(442);
var objectAssign = __webpack_require__(61);
var decodeComponent = __webpack_require__(443);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loding; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 加载中状态
  * @author wangzhuang
  */var Loding = (_temp = _class = function (_Component) {
  _inherits(Loding, _Component);function Loding() {
    _classCallCheck(this, Loding);return _possibleConstructorReturn(this, (Loding.__proto__ || Object.getPrototypeOf(Loding)).apply(this, arguments));
  }_createClass(Loding, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;window.addEventListener('scroll', function () {
        return _this2.loadingMore();
      });
    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
      var _this3 = this;window.removeEventListener('scroll', function () {
        return _this3.loadingMore();
      });
    } }, { key: 'loadingMore', value: function loadingMore() {
      var lodingBox = this.lodingBox;var _props = this.props,
          callbackFn = _props.callbackFn,
          isLoad = _props.isLoad;var docScrollTop = document.documentElement.scrollTop || document.body.scrollTop;var clientHeight = document.documentElement.clientHeight;if (lodingBox) {
        if (docScrollTop + clientHeight > lodingBox.offsetTop && isLoad) {
          callbackFn && callbackFn();
        }
      }
    } }, { key: 'render', value: function render() {
      var _this4 = this;var _props2 = this.props,
          type = _props2.type,
          style = _props2.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'loading-box', style: style, ref: function ref(el) {
          return _this4.lodingBox = el;
        } }, type ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'loding-btn' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'loading pr' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'conter' }, '\u6CA1\u6709\u66F4\u591A\u6587\u7AE0')));
    } }]);return Loding;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // 透传样式
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // 判断加载中or没有更多
  isLoad: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, // 是否继续回调
  callbackFn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func // 滚动条到指定位置的回调
}, _temp);

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_arrow_wap.19637bc2.svg";

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchVdcReport;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchUrlUpload;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file vdc检查结果
 * @author wangzhuang
 */function fetchVdcReport(dispatch, obj, type) {
  if (type === 'report') {
    Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bAntiBotSend */])();return new Promise(function (resolve) {
      window['__abbaidu_2024_cb'] = function (responseData) {
        var localData = JSON.parse(responseData); // task report
        if (localData.data) {
          obj.data = localData.data;
        }if (localData.key_id) {
          obj['key_id'] = localData.key_id;
        }if (localData.sign) {
          obj.sign = localData.sign;
        }return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/vdc/' + type, {}, obj, function (data) {
          var curData = data.data && data.data.data || {};if (curData.is_auth === 'login') {
            window.location.href = '/m/login/' + location.href;return;
          }dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["K" /* GET_VDC_REPORT */], data: data.data });resolve(data);
        });
      };
    });
  } else {
    var localKey = '__abbaidu_20181211_cb';var localData = {};try {
      if (window.localStorage) {
        localData = JSON.parse(window.localStorage.getItem(localKey)) || {};
      }
    } catch (e) {
      localData = {};
    }if (localData.data) {
      obj.data = localData.data;
    }if (localData.key_id) {
      obj['key_id'] = localData.key_id;
    }if (localData.sign) {
      obj.sign = localData.sign;
    }return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/vdc/' + type, {}, obj, function (data) {
      var curData = data.data && data.data.data || {};if (curData.is_auth === 'login') {
        window.location.href = '/m/login/' + location.href;return;
      }dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["K" /* GET_VDC_REPORT */], data: data.data });
    });
  }
}function fetchUrlUpload(dispatch, obj, type) {
  Object(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* bAntiBotSend */])();return new Promise(function (resolve) {
    window['__abbaidu_2024_cb'] = function (responseData) {
      var localData = JSON.parse(responseData); // urlUpload  fileUpload
      if (localData.data) {
        obj.data = localData.data;
      }if (localData.key_id) {
        obj['key_id'] = localData.key_id;
      }if (localData.sign) {
        obj.sign = localData.sign;
      }var formData = new FormData();for (var attr in obj) {
        formData.append(attr, obj[attr]);
      }return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/vdc/' + type, {}, type === 'fileUpload' ? formData : obj, function (data) {
        var curData = data.data && data.data.data || {};if (curData.is_auth === 'login') {
          window.location.href = '/m/login/' + location.href;return;
        }dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["H" /* GET_URL_UPLOAD */], data: data.data });resolve(data);
      });
    };
  });
}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_jishuzhicheng.4f3a99c8.svg";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(55);

__webpack_require__(662);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(17);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames3 = __webpack_require__(3);

var _classnames4 = _interopRequireDefault(_classnames3);

var _propTypes = __webpack_require__(1);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rmcFeedback = __webpack_require__(38);

var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);

var _getLocale = __webpack_require__(221);

var _CustomInput = __webpack_require__(663);

var _CustomInput2 = _interopRequireDefault(_CustomInput);

var _Input = __webpack_require__(667);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

function noop() {}
function normalizeValue(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value + '';
}

var InputItem = function (_React$Component) {
    (0, _inherits3['default'])(InputItem, _React$Component);

    function InputItem(props) {
        (0, _classCallCheck3['default'])(this, InputItem);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (InputItem.__proto__ || Object.getPrototypeOf(InputItem)).call(this, props));

        _this.onInputChange = function (e) {
            var el = e.target;
            var rawVal = el.value;

            var prePos = 0;
            try {
                // some input type do not support selection, see https://html.spec.whatwg.org/multipage/input.html#do-not-apply
                prePos = el.selectionEnd || 0;
            } catch (error) {
                console.warn('Get selection error:', error);
            }
            var _this$state$value = _this.state.value,
                preCtrlVal = _this$state$value === undefined ? '' : _this$state$value;
            var type = _this.props.type;

            var ctrlValue = rawVal;
            switch (type) {
                case 'bankCard':
                    ctrlValue = rawVal.replace(/\D/g, '').replace(/(....)(?=.)/g, '$1 ');
                    break;
                case 'phone':
                    ctrlValue = rawVal.replace(/\D/g, '').substring(0, 11);
                    var valueLen = ctrlValue.length;
                    if (valueLen > 3 && valueLen < 8) {
                        ctrlValue = ctrlValue.substr(0, 3) + ' ' + ctrlValue.substr(3);
                    } else if (valueLen >= 8) {
                        ctrlValue = ctrlValue.substr(0, 3) + ' ' + ctrlValue.substr(3, 4) + ' ' + ctrlValue.substr(7);
                    }
                    break;
                case 'number':
                    ctrlValue = rawVal.replace(/\D/g, '');
                    break;
                case 'text':
                case 'password':
                default:
                    break;
            }
            _this.handleOnChange(ctrlValue, ctrlValue !== rawVal, function () {
                switch (type) {
                    case 'bankCard':
                    case 'phone':
                    case 'number':
                        // controlled input type needs to adjust the position of the caret
                        try {
                            // some input type do not support selection, see https://html.spec.whatwg.org/multipage/input.html#do-not-apply
                            var pos = _this.calcPos(prePos, preCtrlVal, rawVal, ctrlValue, [' '], /\D/g);
                            if (type === 'phone' && (pos === 4 || pos === 9) || type === 'bankCard' && pos > 0 && pos % 5 === 0) {
                                pos -= 1;
                            }
                            el.selectionStart = el.selectionEnd = pos;
                        } catch (error) {
                            console.warn('Set selection error:', error);
                        }
                        break;
                    default:
                        break;
                }
            });
        };
        _this.handleOnChange = function (value) {
            var isMutated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var adjustPos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;
            var onChange = _this.props.onChange;

            if (!('value' in _this.props)) {
                _this.setState({ value: value });
            } else {
                _this.setState({ value: _this.props.value });
            }
            if (onChange) {
                if (isMutated) {
                    setTimeout(function () {
                        onChange(value);
                        adjustPos();
                    });
                } else {
                    onChange(value);
                    adjustPos();
                }
            } else {
                adjustPos();
            }
        };
        _this.onInputFocus = function (value) {
            if (_this.debounceTimeout) {
                clearTimeout(_this.debounceTimeout);
                _this.debounceTimeout = null;
            }
            _this.setState({
                focus: true
            });
            if (_this.props.onFocus) {
                _this.props.onFocus(value);
            }
        };
        _this.onInputBlur = function (value) {
            if (_this.inputRef) {
                // this.inputRef may be null if customKeyboard unmount
                _this.debounceTimeout = window.setTimeout(function () {
                    if (document.activeElement !== (_this.inputRef && _this.inputRef.inputRef)) {
                        _this.setState({
                            focus: false
                        });
                    }
                }, 200);
            }
            if (_this.props.onBlur) {
                // fix autoFocus item blur with flash
                setTimeout(function () {
                    // fix ios12 wechat browser click failure after input
                    if (document.body) {
                        document.body.scrollTop = document.body.scrollTop;
                    }
                }, 100);
                _this.props.onBlur(value);
            }
        };
        _this.clearInput = function () {
            if (_this.props.type !== 'password' && _this.props.updatePlaceholder) {
                _this.setState({
                    placeholder: _this.props.value
                });
            }
            _this.setState({
                value: ''
            });
            if (_this.props.onChange) {
                _this.props.onChange('');
            }
            _this.focus();
        };
        // this is instance method for user to use
        _this.focus = function () {
            if (_this.inputRef) {
                _this.inputRef.focus();
            }
        };
        // calculate the position of the caret
        _this.calcPos = function (prePos, preCtrlVal, rawVal, ctrlVal, placeholderChars, maskReg) {
            var editLength = rawVal.length - preCtrlVal.length;
            var isAddition = editLength > 0;
            var pos = prePos;
            if (isAddition) {
                var additionStr = rawVal.substr(pos - editLength, editLength);
                var ctrlCharCount = additionStr.replace(maskReg, '').length;
                pos -= editLength - ctrlCharCount;
                var placeholderCharCount = 0;
                while (ctrlCharCount > 0) {
                    if (placeholderChars.indexOf(ctrlVal.charAt(pos - ctrlCharCount + placeholderCharCount)) === -1) {
                        ctrlCharCount--;
                    } else {
                        placeholderCharCount++;
                    }
                }
                pos += placeholderCharCount;
            }
            return pos;
        };
        _this.state = {
            placeholder: props.placeholder,
            value: normalizeValue(props.value || props.defaultValue)
        };
        return _this;
    }

    (0, _createClass3['default'])(InputItem, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('placeholder' in nextProps && !nextProps.updatePlaceholder) {
                this.setState({
                    placeholder: nextProps.placeholder
                });
            }
            if ('value' in nextProps) {
                this.setState({
                    value: nextProps.value
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.debounceTimeout) {
                window.clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _classnames2,
                _this2 = this;

            var props = (0, _extends3['default'])({}, this.props);
            delete props.updatePlaceholder;

            var prefixCls = props.prefixCls,
                prefixListCls = props.prefixListCls,
                editable = props.editable,
                style = props.style,
                clear = props.clear,
                children = props.children,
                error = props.error,
                className = props.className,
                extra = props.extra,
                labelNumber = props.labelNumber,
                type = props.type,
                onExtraClick = props.onExtraClick,
                onErrorClick = props.onErrorClick,
                moneyKeyboardAlign = props.moneyKeyboardAlign,
                moneyKeyboardWrapProps = props.moneyKeyboardWrapProps,
                moneyKeyboardHeader = props.moneyKeyboardHeader,
                onVirtualKeyboardConfirm = props.onVirtualKeyboardConfirm,
                autoAdjustHeight = props.autoAdjustHeight,
                disabledKeys = props.disabledKeys,
                restProps = __rest(props, ["prefixCls", "prefixListCls", "editable", "style", "clear", "children", "error", "className", "extra", "labelNumber", "type", "onExtraClick", "onErrorClick", "moneyKeyboardAlign", "moneyKeyboardWrapProps", "moneyKeyboardHeader", "onVirtualKeyboardConfirm", "autoAdjustHeight", "disabledKeys"]);

            var name = restProps.name,
                disabled = restProps.disabled,
                maxLength = restProps.maxLength;
            var value = this.state.value;
            // tslint:disable-next-line:variable-name

            var _locale = (0, _getLocale.getComponentLocale)(this.props, this.context, 'InputItem', function () {
                return __webpack_require__(668);
            });
            var confirmLabel = _locale.confirmLabel,
                backspaceLabel = _locale.backspaceLabel,
                cancelKeyboardLabel = _locale.cancelKeyboardLabel;
            var _state = this.state,
                focus = _state.focus,
                placeholder = _state.placeholder;

            var wrapCls = (0, _classnames4['default'])(prefixListCls + '-item', prefixCls + '-item', prefixListCls + '-item-middle', className, (_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classnames, prefixCls + '-error', error), (0, _defineProperty3['default'])(_classnames, prefixCls + '-focus', focus), (0, _defineProperty3['default'])(_classnames, prefixCls + '-android', focus), _classnames));
            var labelCls = (0, _classnames4['default'])(prefixCls + '-label', (_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-2', labelNumber === 2), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-3', labelNumber === 3), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-4', labelNumber === 4), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-5', labelNumber === 5), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-6', labelNumber === 6), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-7', labelNumber === 7), _classnames2));
            var controlCls = prefixCls + '-control';
            var inputType = 'text';
            if (type === 'bankCard' || type === 'phone') {
                inputType = 'tel';
            } else if (type === 'password') {
                inputType = 'password';
            } else if (type === 'digit') {
                inputType = 'number';
            } else if (type !== 'text' && type !== 'number') {
                inputType = type;
            }
            var patternProps = void 0;
            if (type === 'number') {
                patternProps = {
                    pattern: '[0-9]*'
                };
            }
            var classNameProps = void 0;
            if (type === 'digit') {
                classNameProps = {
                    className: 'h5numInput'
                };
            }
            return React.createElement(
                'div',
                { className: wrapCls },
                React.createElement(
                    'div',
                    { className: prefixListCls + '-line' },
                    children ? React.createElement(
                        'div',
                        { className: labelCls },
                        children
                    ) : null,
                    React.createElement(
                        'div',
                        { className: controlCls },
                        type === 'money' ? React.createElement(_CustomInput2['default'], { value: normalizeValue(value), type: type, ref: function ref(el) {
                                return _this2.inputRef = el;
                            }, maxLength: maxLength, placeholder: placeholder, onChange: this.onInputChange, onFocus: this.onInputFocus, onBlur: this.onInputBlur, onVirtualKeyboardConfirm: onVirtualKeyboardConfirm, disabled: disabled, editable: editable, prefixCls: prefixCls, style: style, confirmLabel: confirmLabel, backspaceLabel: backspaceLabel, cancelKeyboardLabel: cancelKeyboardLabel, moneyKeyboardAlign: moneyKeyboardAlign, moneyKeyboardWrapProps: moneyKeyboardWrapProps, moneyKeyboardHeader: moneyKeyboardHeader, autoAdjustHeight: autoAdjustHeight, disabledKeys: disabledKeys }) : React.createElement(_Input2['default'], (0, _extends3['default'])({}, patternProps, restProps, classNameProps, { value: normalizeValue(value), defaultValue: undefined, ref: function ref(el) {
                                return _this2.inputRef = el;
                            }, style: style, type: inputType, maxLength: maxLength, name: name, placeholder: placeholder, onChange: this.onInputChange, onFocus: this.onInputFocus, onBlur: this.onInputBlur, readOnly: !editable, disabled: disabled }))
                    ),
                    clear && editable && !disabled && value && ('' + value).length > 0 ? React.createElement(
                        _rmcFeedback2['default'],
                        { activeClassName: prefixCls + '-clear-active' },
                        React.createElement('div', { className: prefixCls + '-clear', onClick: this.clearInput })
                    ) : null,
                    error ? React.createElement('div', { className: prefixCls + '-error-extra', onClick: onErrorClick }) : null,
                    extra !== '' ? React.createElement(
                        'div',
                        { className: prefixCls + '-extra', onClick: onExtraClick },
                        extra
                    ) : null
                )
            );
        }
    }]);
    return InputItem;
}(React.Component);

InputItem.defaultProps = {
    prefixCls: 'am-input',
    prefixListCls: 'am-list',
    type: 'text',
    editable: true,
    disabled: false,
    placeholder: '',
    clear: false,
    onChange: noop,
    onBlur: noop,
    onFocus: noop,
    extra: '',
    onExtraClick: noop,
    error: false,
    onErrorClick: noop,
    onVirtualKeyboardConfirm: noop,
    labelNumber: 5,
    updatePlaceholder: false,
    moneyKeyboardAlign: 'right',
    moneyKeyboardWrapProps: {},
    moneyKeyboardHeader: null,
    disabledKeys: null
};
InputItem.contextTypes = {
    antLocale: PropTypes.object
};
exports['default'] = InputItem;
module.exports = exports['default'];

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(728);

__webpack_require__(730);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(17);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rmcNotification = __webpack_require__(731);

var _rmcNotification2 = _interopRequireDefault(_rmcNotification);

var _icon = __webpack_require__(742);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SHORT = 3;
var _config = {
    duration: SHORT,
    mask: true
};
var messageInstance = void 0;
var prefixCls = 'am-toast';
function getMessageInstance(mask, callback) {
    var _classnames;

    if (messageInstance) {
        messageInstance.destroy();
        messageInstance = null;
    }
    _rmcNotification2['default'].newInstance({
        prefixCls: prefixCls,
        style: {},
        transitionName: 'am-fade',
        className: (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-mask', mask), (0, _defineProperty3['default'])(_classnames, prefixCls + '-nomask', !mask), _classnames))
    }, function (notification) {
        return callback && callback(notification);
    });
}
function notice(content, type) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config.duration;
    var _onClose = arguments[3];
    var mask = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _config.mask;

    var iconTypes = {
        info: '',
        success: 'success',
        fail: 'fail',
        offline: 'dislike',
        loading: 'loading'
    };
    var iconType = iconTypes[type];
    getMessageInstance(mask, function (notification) {
        messageInstance = notification;
        notification.notice({
            duration: duration,
            style: {},
            content: !!iconType ? React.createElement(
                'div',
                { className: prefixCls + '-text ' + prefixCls + '-text-icon', role: 'alert', 'aria-live': 'assertive' },
                React.createElement(_icon2['default'], { type: iconType, size: 'lg' }),
                React.createElement(
                    'div',
                    { className: prefixCls + '-text-info' },
                    content
                )
            ) : React.createElement(
                'div',
                { className: prefixCls + '-text', role: 'alert', 'aria-live': 'assertive' },
                React.createElement(
                    'div',
                    null,
                    content
                )
            ),
            closable: true,
            onClose: function onClose() {
                if (_onClose) {
                    _onClose();
                }
                notification.destroy();
                notification = null;
                messageInstance = null;
            }
        });
    });
}
exports['default'] = {
    SHORT: SHORT,
    LONG: 8,
    show: function show(content, duration, mask) {
        return notice(content, 'info', duration, function () {}, mask);
    },
    info: function info(content, duration, onClose, mask) {
        return notice(content, 'info', duration, onClose, mask);
    },
    success: function success(content, duration, onClose, mask) {
        return notice(content, 'success', duration, onClose, mask);
    },
    fail: function fail(content, duration, onClose, mask) {
        return notice(content, 'fail', duration, onClose, mask);
    },
    offline: function offline(content, duration, onClose, mask) {
        return notice(content, 'offline', duration, onClose, mask);
    },
    loading: function loading(content, duration, onClose, mask) {
        return notice(content, 'loading', duration, onClose, mask);
    },
    hide: function hide() {
        if (messageInstance) {
            messageInstance.destroy();
            messageInstance = null;
        }
    },
    config: function config() {
        var conf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _conf$duration = conf.duration,
            duration = _conf$duration === undefined ? SHORT : _conf$duration,
            mask = conf.mask;

        _config.duration = duration;
        if (mask === false) {
            _config.mask = false;
        }
    }
};
module.exports = exports['default'];

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModalComponent = undefined;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(17);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames3 = __webpack_require__(3);

var _classnames4 = _interopRequireDefault(_classnames3);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rmcDialog = __webpack_require__(755);

var _rmcDialog2 = _interopRequireDefault(_rmcDialog);

var _rmcFeedback = __webpack_require__(38);

var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var ModalComponent = exports.ModalComponent = function (_React$Component) {
    (0, _inherits3['default'])(ModalComponent, _React$Component);

    function ModalComponent() {
        (0, _classCallCheck3['default'])(this, ModalComponent);
        return (0, _possibleConstructorReturn3['default'])(this, (ModalComponent.__proto__ || Object.getPrototypeOf(ModalComponent)).apply(this, arguments));
    }

    return ModalComponent;
}(React.Component);

var Modal = function (_ModalComponent) {
    (0, _inherits3['default'])(Modal, _ModalComponent);

    function Modal() {
        (0, _classCallCheck3['default'])(this, Modal);
        return (0, _possibleConstructorReturn3['default'])(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Modal, [{
        key: 'renderFooterButton',
        value: function renderFooterButton(button, prefixCls, i) {
            var buttonStyle = {};
            if (button.style) {
                buttonStyle = button.style;
                if (typeof buttonStyle === 'string') {
                    var styleMap = {
                        cancel: {},
                        'default': {},
                        destructive: { color: 'red' }
                    };
                    buttonStyle = styleMap[buttonStyle] || {};
                }
            }
            var onClickFn = function onClickFn(e) {
                e.preventDefault();
                if (button.onPress) {
                    button.onPress();
                }
            };
            return React.createElement(
                _rmcFeedback2['default'],
                { activeClassName: prefixCls + '-button-active', key: i },
                React.createElement(
                    'a',
                    { className: prefixCls + '-button', role: 'button', style: buttonStyle, onClick: onClickFn },
                    button.text || 'Button'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this,
                _classnames2;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                wrapClassName = _a.wrapClassName,
                transitionName = _a.transitionName,
                maskTransitionName = _a.maskTransitionName,
                style = _a.style,
                platform = _a.platform,
                _a$footer = _a.footer,
                footer = _a$footer === undefined ? [] : _a$footer,
                operation = _a.operation,
                animated = _a.animated,
                transparent = _a.transparent,
                popup = _a.popup,
                animationType = _a.animationType,
                restProps = __rest(_a, ["prefixCls", "className", "wrapClassName", "transitionName", "maskTransitionName", "style", "platform", "footer", "operation", "animated", "transparent", "popup", "animationType"]);
            var btnGroupClass = (0, _classnames4['default'])(prefixCls + '-button-group-' + (footer.length === 2 && !operation ? 'h' : 'v'), prefixCls + '-button-group-' + (operation ? 'operation' : 'normal'));
            var footerDom = footer.length ? React.createElement(
                'div',
                { className: btnGroupClass, role: 'group' },
                footer.map(function (button, i) {
                    return (
                        // tslint:disable-next-line:jsx-no-multiline-js
                        _this3.renderFooterButton(button, prefixCls, i)
                    );
                })
            ) : null;
            var transName = void 0;
            var maskTransName = void 0;
            if (animated) {
                // tslint:disable-next-line:prefer-conditional-expression
                if (transparent) {
                    transName = maskTransName = 'am-fade';
                } else {
                    transName = maskTransName = 'am-slide-up';
                }
                if (popup) {
                    transName = animationType === 'slide-up' ? 'am-slide-up' : 'am-slide-down';
                    maskTransName = 'am-fade';
                }
            }
            var wrapCls = (0, _classnames4['default'])(wrapClassName, (0, _defineProperty3['default'])({}, prefixCls + '-wrap-popup', popup));
            var cls = (0, _classnames4['default'])(className, (_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-transparent', transparent), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-popup', popup), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-popup-' + animationType, popup && animationType), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-android', platform === 'android'), _classnames2));
            return React.createElement(_rmcDialog2['default'], (0, _extends3['default'])({}, restProps, { prefixCls: prefixCls, className: cls, wrapClassName: wrapCls, transitionName: transitionName || transName, maskTransitionName: maskTransitionName || maskTransName, style: style, footer: footerDom }));
        }
    }]);
    return Modal;
}(ModalComponent);

exports['default'] = Modal;

Modal.defaultProps = {
    prefixCls: 'am-modal',
    transparent: false,
    popup: false,
    animationType: 'slide-down',
    animated: true,
    style: {},
    onShow: function onShow() {},

    footer: [],
    closable: false,
    operation: false,
    platform: 'ios'
};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file_loading.e6aabcf1.svg";

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_spinner_large.bdc71ac1.svg";

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var hide = __webpack_require__(26);

module.exports = function (key, value) {
  try {
    hide(global, key, value);
  } catch (e) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(64)('keys');
var uid = __webpack_require__(90);

module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + postfix).toString(36));
};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),
/* 92 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(32).f;
var has = __webpack_require__(23);
var TO_STRING_TAG = __webpack_require__(19)('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(33);
var defineProperties = __webpack_require__(297);
var enumBugKeys = __webpack_require__(92);
var html = __webpack_require__(299);
var documentCreateElement = __webpack_require__(170);
var IE_PROTO = __webpack_require__(89)('IE_PROTO');
var PROTOTYPE = 'prototype';
var Empty = function () { /* empty */ };

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var length = enumBugKeys.length;
  var lt = '<';
  var script = 'script';
  var gt = '>';
  var js = 'java' + script + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  iframe.src = String(js);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : defineProperties(result, Properties);
};

__webpack_require__(66)[IE_PROTO] = true;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(165);
var createIteratorConstructor = __webpack_require__(301);
var getPrototypeOf = __webpack_require__(182);
var setPrototypeOf = __webpack_require__(179);
var setToStringTag = __webpack_require__(93);
var hide = __webpack_require__(26);
var redefine = __webpack_require__(48);
var IS_PURE = __webpack_require__(88);
var ITERATOR = __webpack_require__(19)('iterator');
var Iterators = __webpack_require__(49);
var IteratorsCore = __webpack_require__(181);
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          hide(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    hide(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(15);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(194);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(195);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(101);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(378);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var WingBlank = function (_React$Component) {
    (0, _inherits3['default'])(WingBlank, _React$Component);

    function WingBlank() {
        (0, _classCallCheck3['default'])(this, WingBlank);
        return (0, _possibleConstructorReturn3['default'])(this, (WingBlank.__proto__ || Object.getPrototypeOf(WingBlank)).apply(this, arguments));
    }

    (0, _createClass3['default'])(WingBlank, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                size = _props.size,
                className = _props.className,
                children = _props.children,
                style = _props.style;

            var wrapCls = (0, _classnames2['default'])(prefixCls, prefixCls + '-' + size, className);
            return React.createElement(
                'div',
                { className: wrapCls, style: style },
                children
            );
        }
    }]);
    return WingBlank;
}(React.Component);

exports['default'] = WingBlank;

WingBlank.defaultProps = {
    prefixCls: 'am-wingblank',
    size: 'lg'
};
module.exports = exports['default'];

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(42);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(382);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(397);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(52);
var dPs = __webpack_require__(387);
var enumBugKeys = __webpack_require__(115);
var IE_PROTO = __webpack_require__(113)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(204)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(391).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(114)('keys');
var uid = __webpack_require__(71);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(28);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(35).f;
var has = __webpack_require__(37);
var TAG = __webpack_require__(44)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(44);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(28);
var core = __webpack_require__(34);
var LIBRARY = __webpack_require__(110);
var wksExt = __webpack_require__(117);
var defineProperty = __webpack_require__(35).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 119 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(414);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(17);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames3 = __webpack_require__(3);

var _classnames4 = _interopRequireDefault(_classnames3);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rmcNukaCarousel = __webpack_require__(419);

var _rmcNukaCarousel2 = _interopRequireDefault(_rmcNukaCarousel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Carousel = function (_React$Component) {
    (0, _inherits3['default'])(Carousel, _React$Component);

    function Carousel(props) {
        (0, _classCallCheck3['default'])(this, Carousel);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

        _this.onChange = function (index) {
            _this.setState({
                selectedIndex: index
            }, function () {
                if (_this.props.afterChange) {
                    _this.props.afterChange(index);
                }
            });
        };
        _this.state = {
            selectedIndex: _this.props.selectedIndex
        };
        return _this;
    }

    (0, _createClass3['default'])(Carousel, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                infinite = _a.infinite,
                selectedIndex = _a.selectedIndex,
                beforeChange = _a.beforeChange,
                afterChange = _a.afterChange,
                dots = _a.dots,
                restProps = __rest(_a, ["infinite", "selectedIndex", "beforeChange", "afterChange", "dots"]);var prefixCls = restProps.prefixCls,
                dotActiveStyle = restProps.dotActiveStyle,
                dotStyle = restProps.dotStyle,
                className = restProps.className,
                vertical = restProps.vertical;

            var newProps = (0, _extends3['default'])({}, restProps, { wrapAround: infinite, slideIndex: selectedIndex, beforeSlide: beforeChange });
            var Decorators = [];
            if (dots) {
                Decorators = [{
                    component: function component(_ref) {
                        var slideCount = _ref.slideCount,
                            slidesToScroll = _ref.slidesToScroll,
                            currentSlide = _ref.currentSlide;

                        var arr = [];
                        for (var i = 0; i < slideCount; i += slidesToScroll) {
                            arr.push(i);
                        }
                        var dotDom = arr.map(function (index) {
                            var dotCls = (0, _classnames4['default'])(prefixCls + '-wrap-dot', (0, _defineProperty3['default'])({}, prefixCls + '-wrap-dot-active', index === currentSlide));
                            var currentDotStyle = index === currentSlide ? dotActiveStyle : dotStyle;
                            return React.createElement(
                                'div',
                                { className: dotCls, key: index },
                                React.createElement('span', { style: currentDotStyle })
                            );
                        });
                        return React.createElement(
                            'div',
                            { className: prefixCls + '-wrap' },
                            dotDom
                        );
                    },
                    position: 'BottomCenter'
                }];
            }
            var wrapCls = (0, _classnames4['default'])(prefixCls, className, (0, _defineProperty3['default'])({}, prefixCls + '-vertical', vertical));
            return React.createElement(_rmcNukaCarousel2['default'], (0, _extends3['default'])({}, newProps, { className: wrapCls, decorators: Decorators, afterSlide: this.onChange }));
        }
    }]);
    return Carousel;
}(React.Component);

exports['default'] = Carousel;

Carousel.defaultProps = {
    prefixCls: 'am-carousel',
    dots: true,
    arrows: false,
    autoplay: false,
    infinite: false,
    cellAlign: 'center',
    selectedIndex: 0,
    dotStyle: {},
    dotActiveStyle: {}
};
module.exports = exports['default'];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(18);
var normalizeHeaderName = __webpack_require__(427);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(215);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(215);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 搜索框
  * @author: wence
  */var SearchBar = (_temp = _class = function (_PureComponent) {
  _inherits(SearchBar, _PureComponent);_createClass(SearchBar, null, [{ key: 'getDerivedStateFromProps', value: function getDerivedStateFromProps(props, state) {
      if ('value' in props && props.value !== state.value) {
        return { value: props.value };
      }return null;
    } }]);function SearchBar(props) {
    _classCallCheck(this, SearchBar);var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));_this.onChange = function (e) {
      var value = e.target.value;var onChange = _this.props.onChange;if (!('value' in _this.props)) {
        _this.setState({ value: value });
      }onChange && onChange(value);
    };_this.onSubmit = function (e) {
      e.preventDefault();var onSubmit = _this.props.onSubmit;onSubmit && onSubmit(_this.state.value);_this.input && _this.input.blur();
    };_this.state = { value: '' };return _this;
  }_createClass(SearchBar, [{ key: 'render', value: function render() {
      var _this2 = this;var _props = this.props,
          placeholder = _props.placeholder,
          isShowCancel = _props.isShowCancel,
          isShowClear = _props.isShowClear,
          restProps = _objectWithoutProperties(_props, ['placeholder', 'isShowCancel', 'isShowClear']);var value = this.state.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', { onSubmit: this.onSubmit, className: 'cus-search-wrapper' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cus-search' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cus-search-btn' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: 'icon', src: __webpack_require__(495) })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', Object.assign({ ref: function ref(input) {
          return _this2.input = input;
        }, className: 'cus-search-input' }, restProps, { placeholder: placeholder, type: 'search', onChange: this.onChange, value: value })), isShowClear && value !== '' && value !== undefined && value !== null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cus-search-clear' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: 'icon', onClick: this.onChange.bind(this, { target: { value: '' } }), src: __webpack_require__(496) }))), isShowCancel && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: this.props.onCancel, className: 'cus-search-cancel' }, '\u53D6\u6D88'));
    } }]);return SearchBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, isShowCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, isShowClear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool }, _class.defaultProps = { isShowClear: true }, _temp);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getNumberCommonList;
/* harmony export (immutable) */ __webpack_exports__["a"] = getNumberCommonInfo;
/* harmony export (immutable) */ __webpack_exports__["c"] = getNumberSearchResult;
/* unused harmony export fetchPhoneQuery */
/* unused harmony export getGeoloaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
} /**
  * @file 号码认证
  * @author wence
  */var isGetProsition = false;function getNumberCommonList() {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/xiapi/api/v1/phone/phoneList', {}, {}, function (data) {
      return dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["C" /* GET_NUMBER_COMMON_LIST */], data: data.data && data.data.data || [] });
    });
  };
}function getNumberCommonInfo(id) {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/xiapi/api/v1/phone/phoneDetail', { id: id }, {}, function (data) {
      return dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["B" /* GET_NUMBER_COMMON_INFO */], data: data.data && data.data.data || [] });
    });
  };
}function getNumberSearchResult(_ref) {
  var isMore = _ref.isMore,
      params = _objectWithoutProperties(_ref, ['isMore']);return function (dispatch, getState) {
    if (!isGetProsition && !params.position) {
      return getGeoloaction().then(function (position) {
        isGetProsition = true;return fetchPhoneQuery(Object.assign({}, params, { position: position }), dispatch, getState, isMore);
      });
    }return fetchPhoneQuery(params, dispatch, getState, isMore);
  };
}function fetchPhoneQuery(params, dispatch, getState, isMore) {
  var localKey = '__abbaidu_20181211_cb';var localData = {};try {
    if (window.localStorage) {
      localData = JSON.parse(window.localStorage.getItem(localKey)) || {};
    }
  } catch (e) {
    localData = {};
  }if (localData.data) {
    params.data = localData.data;
  }if (localData.key_id) {
    params.key_id = localData.key_id;
  }if (localData.sign) {
    params.sign = localData.sign;
  }return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/phone/query', {}, __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(params), function (data) {
    var numberSearchResult = getState().numberSearchResult;var curData = data.data && data.data.data || {};var isAuthKey = 'is_auth';if (curData.is_auth === 'login') {
      window.location.href = '/m/login/' + location.href;return;
    }if (curData.is_auth === 'bot') {
      return dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["D" /* GET_NUMBER_SEARCH_RESULT */], data: _defineProperty({ list: [] }, isAuthKey, 'bot'), status: data.data.status, params: params });
    }if (curData.list && isMore) {
      curData.list = [].concat(_toConsumableArray(numberSearchResult.list), _toConsumableArray(curData.list));
    }return dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["D" /* GET_NUMBER_SEARCH_RESULT */], data: curData, status: data.data.status, params: params });
  });
}function getGeoloaction() {
  return new Promise(function (resolve) {
    if (window.BMap) {
      setTimeout(function () {
        var position = ''; // if (window.localStorage) {
        //     try {
        //         position = window.localStorage.getItem('position') || '';
        //     }
        //     catch (e) {
        //         position = '';
        //     }
        // }
        resolve(position);
      }, 5000);var geolocation = new window.BMap.Geolocation();geolocation.getCurrentPosition(function (res) {
        if (this.getStatus() === 0) {
          var position = res.point.lat + '|' + res.point.lng;if (window.localStorage) {
            window.localStorage.setItem('position', position);
          }resolve(position);
        } else {
          resolve('');
        }
      }, { enableHighAccuracy: true });
    } else {
      resolve('');
    }
  });
}

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_jingzhunjiance.37bea8ed.svg";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_gaotuntu.3c290068.svg";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_kuaisujieru.8400a659.svg";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_yinsibaohu.c58eaff6.svg";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {

    var debug = false;

    var root = this;

    var EXIF = function(obj) {
        if (obj instanceof EXIF) return obj;
        if (!(this instanceof EXIF)) return new EXIF(obj);
        this.EXIFwrapped = obj;
    };

    if (true) {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = EXIF;
        }
        exports.EXIF = EXIF;
    } else {
        root.EXIF = EXIF;
    }

    var ExifTags = EXIF.Tags = {

        // version tags
        0x9000 : "ExifVersion",             // EXIF version
        0xA000 : "FlashpixVersion",         // Flashpix format version

        // colorspace tags
        0xA001 : "ColorSpace",              // Color space information tag

        // image configuration
        0xA002 : "PixelXDimension",         // Valid width of meaningful image
        0xA003 : "PixelYDimension",         // Valid height of meaningful image
        0x9101 : "ComponentsConfiguration", // Information about channels
        0x9102 : "CompressedBitsPerPixel",  // Compressed bits per pixel

        // user information
        0x927C : "MakerNote",               // Any desired information written by the manufacturer
        0x9286 : "UserComment",             // Comments by user

        // related file
        0xA004 : "RelatedSoundFile",        // Name of related sound file

        // date and time
        0x9003 : "DateTimeOriginal",        // Date and time when the original image was generated
        0x9004 : "DateTimeDigitized",       // Date and time when the image was stored digitally
        0x9290 : "SubsecTime",              // Fractions of seconds for DateTime
        0x9291 : "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
        0x9292 : "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized

        // picture-taking conditions
        0x829A : "ExposureTime",            // Exposure time (in seconds)
        0x829D : "FNumber",                 // F number
        0x8822 : "ExposureProgram",         // Exposure program
        0x8824 : "SpectralSensitivity",     // Spectral sensitivity
        0x8827 : "ISOSpeedRatings",         // ISO speed rating
        0x8828 : "OECF",                    // Optoelectric conversion factor
        0x9201 : "ShutterSpeedValue",       // Shutter speed
        0x9202 : "ApertureValue",           // Lens aperture
        0x9203 : "BrightnessValue",         // Value of brightness
        0x9204 : "ExposureBias",            // Exposure bias
        0x9205 : "MaxApertureValue",        // Smallest F number of lens
        0x9206 : "SubjectDistance",         // Distance to subject in meters
        0x9207 : "MeteringMode",            // Metering mode
        0x9208 : "LightSource",             // Kind of light source
        0x9209 : "Flash",                   // Flash status
        0x9214 : "SubjectArea",             // Location and area of main subject
        0x920A : "FocalLength",             // Focal length of the lens in mm
        0xA20B : "FlashEnergy",             // Strobe energy in BCPS
        0xA20C : "SpatialFrequencyResponse",    //
        0xA20E : "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
        0xA20F : "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
        0xA210 : "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
        0xA214 : "SubjectLocation",         // Location of subject in image
        0xA215 : "ExposureIndex",           // Exposure index selected on camera
        0xA217 : "SensingMethod",           // Image sensor type
        0xA300 : "FileSource",              // Image source (3 == DSC)
        0xA301 : "SceneType",               // Scene type (1 == directly photographed)
        0xA302 : "CFAPattern",              // Color filter array geometric pattern
        0xA401 : "CustomRendered",          // Special processing
        0xA402 : "ExposureMode",            // Exposure mode
        0xA403 : "WhiteBalance",            // 1 = auto white balance, 2 = manual
        0xA404 : "DigitalZoomRation",       // Digital zoom ratio
        0xA405 : "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
        0xA406 : "SceneCaptureType",        // Type of scene
        0xA407 : "GainControl",             // Degree of overall image gain adjustment
        0xA408 : "Contrast",                // Direction of contrast processing applied by camera
        0xA409 : "Saturation",              // Direction of saturation processing applied by camera
        0xA40A : "Sharpness",               // Direction of sharpness processing applied by camera
        0xA40B : "DeviceSettingDescription",    //
        0xA40C : "SubjectDistanceRange",    // Distance to subject

        // other tags
        0xA005 : "InteroperabilityIFDPointer",
        0xA420 : "ImageUniqueID"            // Identifier assigned uniquely to each image
    };

    var TiffTags = EXIF.TiffTags = {
        0x0100 : "ImageWidth",
        0x0101 : "ImageHeight",
        0x8769 : "ExifIFDPointer",
        0x8825 : "GPSInfoIFDPointer",
        0xA005 : "InteroperabilityIFDPointer",
        0x0102 : "BitsPerSample",
        0x0103 : "Compression",
        0x0106 : "PhotometricInterpretation",
        0x0112 : "Orientation",
        0x0115 : "SamplesPerPixel",
        0x011C : "PlanarConfiguration",
        0x0212 : "YCbCrSubSampling",
        0x0213 : "YCbCrPositioning",
        0x011A : "XResolution",
        0x011B : "YResolution",
        0x0128 : "ResolutionUnit",
        0x0111 : "StripOffsets",
        0x0116 : "RowsPerStrip",
        0x0117 : "StripByteCounts",
        0x0201 : "JPEGInterchangeFormat",
        0x0202 : "JPEGInterchangeFormatLength",
        0x012D : "TransferFunction",
        0x013E : "WhitePoint",
        0x013F : "PrimaryChromaticities",
        0x0211 : "YCbCrCoefficients",
        0x0214 : "ReferenceBlackWhite",
        0x0132 : "DateTime",
        0x010E : "ImageDescription",
        0x010F : "Make",
        0x0110 : "Model",
        0x0131 : "Software",
        0x013B : "Artist",
        0x8298 : "Copyright"
    };

    var GPSTags = EXIF.GPSTags = {
        0x0000 : "GPSVersionID",
        0x0001 : "GPSLatitudeRef",
        0x0002 : "GPSLatitude",
        0x0003 : "GPSLongitudeRef",
        0x0004 : "GPSLongitude",
        0x0005 : "GPSAltitudeRef",
        0x0006 : "GPSAltitude",
        0x0007 : "GPSTimeStamp",
        0x0008 : "GPSSatellites",
        0x0009 : "GPSStatus",
        0x000A : "GPSMeasureMode",
        0x000B : "GPSDOP",
        0x000C : "GPSSpeedRef",
        0x000D : "GPSSpeed",
        0x000E : "GPSTrackRef",
        0x000F : "GPSTrack",
        0x0010 : "GPSImgDirectionRef",
        0x0011 : "GPSImgDirection",
        0x0012 : "GPSMapDatum",
        0x0013 : "GPSDestLatitudeRef",
        0x0014 : "GPSDestLatitude",
        0x0015 : "GPSDestLongitudeRef",
        0x0016 : "GPSDestLongitude",
        0x0017 : "GPSDestBearingRef",
        0x0018 : "GPSDestBearing",
        0x0019 : "GPSDestDistanceRef",
        0x001A : "GPSDestDistance",
        0x001B : "GPSProcessingMethod",
        0x001C : "GPSAreaInformation",
        0x001D : "GPSDateStamp",
        0x001E : "GPSDifferential"
    };

     // EXIF 2.3 Spec
    var IFD1Tags = EXIF.IFD1Tags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0111: "StripOffsets",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x011C: "PlanarConfiguration",
        0x0128: "ResolutionUnit",
        0x0201: "JpegIFOffset",    // When image format is JPEG, this value show offset to JPEG data stored.(aka "ThumbnailOffset" or "JPEGInterchangeFormat")
        0x0202: "JpegIFByteCount", // When image format is JPEG, this value shows data size of JPEG image (aka "ThumbnailLength" or "JPEGInterchangeFormatLength")
        0x0211: "YCbCrCoefficients",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x0214: "ReferenceBlackWhite"
    };

    var StringValues = EXIF.StringValues = {
        ExposureProgram : {
            0 : "Not defined",
            1 : "Manual",
            2 : "Normal program",
            3 : "Aperture priority",
            4 : "Shutter priority",
            5 : "Creative program",
            6 : "Action program",
            7 : "Portrait mode",
            8 : "Landscape mode"
        },
        MeteringMode : {
            0 : "Unknown",
            1 : "Average",
            2 : "CenterWeightedAverage",
            3 : "Spot",
            4 : "MultiSpot",
            5 : "Pattern",
            6 : "Partial",
            255 : "Other"
        },
        LightSource : {
            0 : "Unknown",
            1 : "Daylight",
            2 : "Fluorescent",
            3 : "Tungsten (incandescent light)",
            4 : "Flash",
            9 : "Fine weather",
            10 : "Cloudy weather",
            11 : "Shade",
            12 : "Daylight fluorescent (D 5700 - 7100K)",
            13 : "Day white fluorescent (N 4600 - 5400K)",
            14 : "Cool white fluorescent (W 3900 - 4500K)",
            15 : "White fluorescent (WW 3200 - 3700K)",
            17 : "Standard light A",
            18 : "Standard light B",
            19 : "Standard light C",
            20 : "D55",
            21 : "D65",
            22 : "D75",
            23 : "D50",
            24 : "ISO studio tungsten",
            255 : "Other"
        },
        Flash : {
            0x0000 : "Flash did not fire",
            0x0001 : "Flash fired",
            0x0005 : "Strobe return light not detected",
            0x0007 : "Strobe return light detected",
            0x0009 : "Flash fired, compulsory flash mode",
            0x000D : "Flash fired, compulsory flash mode, return light not detected",
            0x000F : "Flash fired, compulsory flash mode, return light detected",
            0x0010 : "Flash did not fire, compulsory flash mode",
            0x0018 : "Flash did not fire, auto mode",
            0x0019 : "Flash fired, auto mode",
            0x001D : "Flash fired, auto mode, return light not detected",
            0x001F : "Flash fired, auto mode, return light detected",
            0x0020 : "No flash function",
            0x0041 : "Flash fired, red-eye reduction mode",
            0x0045 : "Flash fired, red-eye reduction mode, return light not detected",
            0x0047 : "Flash fired, red-eye reduction mode, return light detected",
            0x0049 : "Flash fired, compulsory flash mode, red-eye reduction mode",
            0x004D : "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
            0x004F : "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
            0x0059 : "Flash fired, auto mode, red-eye reduction mode",
            0x005D : "Flash fired, auto mode, return light not detected, red-eye reduction mode",
            0x005F : "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod : {
            1 : "Not defined",
            2 : "One-chip color area sensor",
            3 : "Two-chip color area sensor",
            4 : "Three-chip color area sensor",
            5 : "Color sequential area sensor",
            7 : "Trilinear sensor",
            8 : "Color sequential linear sensor"
        },
        SceneCaptureType : {
            0 : "Standard",
            1 : "Landscape",
            2 : "Portrait",
            3 : "Night scene"
        },
        SceneType : {
            1 : "Directly photographed"
        },
        CustomRendered : {
            0 : "Normal process",
            1 : "Custom process"
        },
        WhiteBalance : {
            0 : "Auto white balance",
            1 : "Manual white balance"
        },
        GainControl : {
            0 : "None",
            1 : "Low gain up",
            2 : "High gain up",
            3 : "Low gain down",
            4 : "High gain down"
        },
        Contrast : {
            0 : "Normal",
            1 : "Soft",
            2 : "Hard"
        },
        Saturation : {
            0 : "Normal",
            1 : "Low saturation",
            2 : "High saturation"
        },
        Sharpness : {
            0 : "Normal",
            1 : "Soft",
            2 : "Hard"
        },
        SubjectDistanceRange : {
            0 : "Unknown",
            1 : "Macro",
            2 : "Close view",
            3 : "Distant view"
        },
        FileSource : {
            3 : "DSC"
        },

        Components : {
            0 : "",
            1 : "Y",
            2 : "Cb",
            3 : "Cr",
            4 : "R",
            5 : "G",
            6 : "B"
        }
    };

    function addEvent(element, event, handler) {
        if (element.addEventListener) {
            element.addEventListener(event, handler, false);
        } else if (element.attachEvent) {
            element.attachEvent("on" + event, handler);
        }
    }

    function imageHasData(img) {
        return !!(img.exifdata);
    }


    function base64ToArrayBuffer(base64, contentType) {
        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return buffer;
    }

    function objectURLToBlob(url, callback) {
        var http = new XMLHttpRequest();
        http.open("GET", url, true);
        http.responseType = "blob";
        http.onload = function(e) {
            if (this.status == 200 || this.status === 0) {
                callback(this.response);
            }
        };
        http.send();
    }

    function getImageData(img, callback) {
        function handleBinaryFile(binFile) {
            var data = findEXIFinJPEG(binFile);
            img.exifdata = data || {};
            var iptcdata = findIPTCinJPEG(binFile);
            img.iptcdata = iptcdata || {};
            if (EXIF.isXmpEnabled) {
               var xmpdata= findXMPinJPEG(binFile);
               img.xmpdata = xmpdata || {};               
            }
            if (callback) {
                callback.call(img);
            }
        }

        if (img.src) {
            if (/^data\:/i.test(img.src)) { // Data URI
                var arrayBuffer = base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);

            } else if (/^blob\:/i.test(img.src)) { // Object URL
                var fileReader = new FileReader();
                fileReader.onload = function(e) {
                    handleBinaryFile(e.target.result);
                };
                objectURLToBlob(img.src, function (blob) {
                    fileReader.readAsArrayBuffer(blob);
                });
            } else {
                var http = new XMLHttpRequest();
                http.onload = function() {
                    if (this.status == 200 || this.status === 0) {
                        handleBinaryFile(http.response);
                    } else {
                        throw "Could not load image";
                    }
                    http = null;
                };
                http.open("GET", img.src, true);
                http.responseType = "arraybuffer";
                http.send(null);
            }
        } else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
            var fileReader = new FileReader();
            fileReader.onload = function(e) {
                if (debug) console.log("Got file of length " + e.target.result.byteLength);
                handleBinaryFile(e.target.result);
            };

            fileReader.readAsArrayBuffer(img);
        }
    }

    function findEXIFinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            marker;

        while (offset < length) {
            if (dataView.getUint8(offset) != 0xFF) {
                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }

            marker = dataView.getUint8(offset + 1);
            if (debug) console.log(marker);

            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data

            if (marker == 225) {
                if (debug) console.log("Found 0xFFE1 marker");

                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);

                // offset += 2 + file.getShortAt(offset+2, true);

            } else {
                offset += 2 + dataView.getUint16(offset+2);
            }

        }

    }

    function findIPTCinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength;


        var isFieldSegmentStart = function(dataView, offset){
            return (
                dataView.getUint8(offset) === 0x38 &&
                dataView.getUint8(offset+1) === 0x42 &&
                dataView.getUint8(offset+2) === 0x49 &&
                dataView.getUint8(offset+3) === 0x4D &&
                dataView.getUint8(offset+4) === 0x04 &&
                dataView.getUint8(offset+5) === 0x04
            );
        };

        while (offset < length) {

            if ( isFieldSegmentStart(dataView, offset )){

                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset+7);
                if(nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
                // Check for pre photoshop 6 format
                if(nameHeaderLength === 0) {
                    // Always 4
                    nameHeaderLength = 4;
                }

                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);

                return readIPTCData(file, startOffset, sectionLength);

                break;

            }


            // Not the marker, continue searching
            offset++;

        }

    }
    var IptcFieldMap = {
        0x78 : 'caption',
        0x6E : 'credit',
        0x19 : 'keywords',
        0x37 : 'dateCreated',
        0x50 : 'byline',
        0x55 : 'bylineTitle',
        0x7A : 'captionWriter',
        0x69 : 'headline',
        0x74 : 'copyright',
        0x0F : 'category'
    };
    function readIPTCData(file, startOffset, sectionLength){
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while(segmentStartPos < startOffset+sectionLength) {
            if(dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos+1) === 0x02){
                segmentType = dataView.getUint8(segmentStartPos+2);
                if(segmentType in IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos+3);
                    segmentSize = dataSize + 5;
                    fieldName = IptcFieldMap[segmentType];
                    fieldValue = getStringFromDB(dataView, segmentStartPos+5, dataSize);
                    // Check if we already stored a value with this name
                    if(data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if(data[fieldName] instanceof Array) {
                            data[fieldName].push(fieldValue);
                        }
                        else {
                            data[fieldName] = [data[fieldName], fieldValue];
                        }
                    }
                    else {
                        data[fieldName] = fieldValue;
                    }
                }

            }
            segmentStartPos++;
        }
        return data;
    }



    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd),
            tags = {},
            entryOffset, tag,
            i;

        for (i=0;i<entries;i++) {
            entryOffset = dirStart + i*12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    }


    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset+2, !bigEnd),
            numValues = file.getUint32(entryOffset+4, !bigEnd),
            valueOffset = file.getUint32(entryOffset+8, !bigEnd) + tiffStart,
            offset,
            vals, val, n,
            numerator, denominator;

        switch (type) {
            case 1: // byte, 8-bit unsigned int
            case 7: // undefined, 8-bit byte, value depending on field
                if (numValues == 1) {
                    return file.getUint8(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint8(offset + n);
                    }
                    return vals;
                }

            case 2: // ascii, 8-bit byte
                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                return getStringFromDB(file, offset, numValues-1);

            case 3: // short, 16 bit int
                if (numValues == 1) {
                    return file.getUint16(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint16(offset + 2*n, !bigEnd);
                    }
                    return vals;
                }

            case 4: // long, 32 bit int
                if (numValues == 1) {
                    return file.getUint32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint32(valueOffset + 4*n, !bigEnd);
                    }
                    return vals;
                }

            case 5:    // rational = two long values, first is numerator, second is denominator
                if (numValues == 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset+4, !bigEnd);
                    val = new Number(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        numerator = file.getUint32(valueOffset + 8*n, !bigEnd);
                        denominator = file.getUint32(valueOffset+4 + 8*n, !bigEnd);
                        vals[n] = new Number(numerator / denominator);
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;
                }

            case 9: // slong, 32 bit signed int
                if (numValues == 1) {
                    return file.getInt32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getInt32(valueOffset + 4*n, !bigEnd);
                    }
                    return vals;
                }

            case 10: // signed rational, two slongs, first is numerator, second is denominator
                if (numValues == 1) {
                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset+4, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getInt32(valueOffset + 8*n, !bigEnd) / file.getInt32(valueOffset+4 + 8*n, !bigEnd);
                    }
                    return vals;
                }
        }
    }

    /**
    * Given an IFD (Image File Directory) start offset
    * returns an offset to next IFD or 0 if it's the last IFD.
    */
    function getNextIFDOffset(dataView, dirStart, bigEnd){
        //the first 2bytes means the number of directory entries contains in this IFD
        var entries = dataView.getUint16(dirStart, !bigEnd);

        // After last directory entry, there is a 4bytes of data,
        // it means an offset to next IFD.
        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.

        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
    }

    function readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd){
        // get the IFD1 offset
        var IFD1OffsetPointer = getNextIFDOffset(dataView, tiffStart+firstIFDOffset, bigEnd);

        if (!IFD1OffsetPointer) {
            // console.log('******** IFD1Offset is empty, image thumb not found ********');
            return {};
        }
        else if (IFD1OffsetPointer > dataView.byteLength) { // this should not happen
            // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
            return {};
        }
        // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);

        var thumbTags = readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, IFD1Tags, bigEnd)

        // EXIF 2.3 specification for JPEG format thumbnail

        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.

        if (thumbTags['Compression']) {
            // console.log('Thumbnail image found!');

            switch (thumbTags['Compression']) {
                case 6:
                    // console.log('Thumbnail image format is JPEG');
                    if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
                    // extract the thumbnail
                        var tOffset = tiffStart + thumbTags.JpegIFOffset;
                        var tLength = thumbTags.JpegIFByteCount;
                        thumbTags['blob'] = new Blob([new Uint8Array(dataView.buffer, tOffset, tLength)], {
                            type: 'image/jpeg'
                        });
                    }
                break;

            case 1:
                console.log("Thumbnail image format is TIFF, which is not implemented.");
                break;
            default:
                console.log("Unknown thumbnail image format '%s'", thumbTags['Compression']);
            }
        }
        else if (thumbTags['PhotometricInterpretation'] == 2) {
            console.log("Thumbnail image format is RGB, which is not implemented.");
        }
        return thumbTags;
    }

    function getStringFromDB(buffer, start, length) {
        var outstr = "";
        for (n = start; n < start+length; n++) {
            outstr += String.fromCharCode(buffer.getUint8(n));
        }
        return outstr;
    }

    function readEXIFData(file, start) {
        if (getStringFromDB(file, start, 4) != "Exif") {
            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
            return false;
        }

        var bigEnd,
            tags, tag,
            exifData, gpsData,
            tiffOffset = start + 6;

        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) == 0x4949) {
            bigEnd = false;
        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
            bigEnd = true;
        } else {
            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
            return false;
        }

        if (file.getUint16(tiffOffset+2, !bigEnd) != 0x002A) {
            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
            return false;
        }

        var firstIFDOffset = file.getUint32(tiffOffset+4, !bigEnd);

        if (firstIFDOffset < 0x00000008) {
            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset+4, !bigEnd));
            return false;
        }

        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

        if (tags.ExifIFDPointer) {
            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
            for (tag in exifData) {
                switch (tag) {
                    case "LightSource" :
                    case "Flash" :
                    case "MeteringMode" :
                    case "ExposureProgram" :
                    case "SensingMethod" :
                    case "SceneCaptureType" :
                    case "SceneType" :
                    case "CustomRendered" :
                    case "WhiteBalance" :
                    case "GainControl" :
                    case "Contrast" :
                    case "Saturation" :
                    case "Sharpness" :
                    case "SubjectDistanceRange" :
                    case "FileSource" :
                        exifData[tag] = StringValues[tag][exifData[tag]];
                        break;

                    case "ExifVersion" :
                    case "FlashpixVersion" :
                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                        break;

                    case "ComponentsConfiguration" :
                        exifData[tag] =
                            StringValues.Components[exifData[tag][0]] +
                            StringValues.Components[exifData[tag][1]] +
                            StringValues.Components[exifData[tag][2]] +
                            StringValues.Components[exifData[tag][3]];
                        break;
                }
                tags[tag] = exifData[tag];
            }
        }

        if (tags.GPSInfoIFDPointer) {
            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
            for (tag in gpsData) {
                switch (tag) {
                    case "GPSVersionID" :
                        gpsData[tag] = gpsData[tag][0] +
                            "." + gpsData[tag][1] +
                            "." + gpsData[tag][2] +
                            "." + gpsData[tag][3];
                        break;
                }
                tags[tag] = gpsData[tag];
            }
        }

        // extract thumbnail
        tags['thumbnail'] = readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);

        return tags;
    }

   function findXMPinJPEG(file) {

        if (!('DOMParser' in self)) {
            // console.warn('XML parsing not supported without DOMParser');
            return;
        }
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
           if (debug) console.log("Not a valid JPEG");
           return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            dom = new DOMParser();

        while (offset < (length-4)) {
            if (getStringFromDB(dataView, offset, 4) == "http") {
                var startOffset = offset - 1;
                var sectionLength = dataView.getUint16(offset - 2) - 1;
                var xmpString = getStringFromDB(dataView, startOffset, sectionLength)
                var xmpEndIndex = xmpString.indexOf('xmpmeta>') + 8;
                xmpString = xmpString.substring( xmpString.indexOf( '<x:xmpmeta' ), xmpEndIndex );

                var indexOfXmp = xmpString.indexOf('x:xmpmeta') + 10
                //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
                //Without these namespaces, XML is thought to be invalid by parsers
                xmpString = xmpString.slice(0, indexOfXmp)
                            + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" '
                            + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" '
                            + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" '
                            + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" '
                            + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" '
                            + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" '
                            + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" '
                            + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" '
                            + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" '
                            + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" '
                            + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" '
                            + xmpString.slice(indexOfXmp)

                var domDocument = dom.parseFromString( xmpString, 'text/xml' );
                return xml2Object(domDocument);
            } else{
             offset++;
            }
        }
    }

    function xml2json(xml) {
        var json = {};
      
        if (xml.nodeType == 1) { // element node
          if (xml.attributes.length > 0) {
            json['@attributes'] = {};
            for (var j = 0; j < xml.attributes.length; j++) {
              var attribute = xml.attributes.item(j);
              json['@attributes'][attribute.nodeName] = attribute.nodeValue;
            }
          }
        } else if (xml.nodeType == 3) { // text node
          return xml.nodeValue;
        }
      
        // deal with children
        if (xml.hasChildNodes()) {
          for(var i = 0; i < xml.childNodes.length; i++) {
            var child = xml.childNodes.item(i);
            var nodeName = child.nodeName;
            if (json[nodeName] == null) {
              json[nodeName] = xml2json(child);
            } else {
              if (json[nodeName].push == null) {
                var old = json[nodeName];
                json[nodeName] = [];
                json[nodeName].push(old);
              }
              json[nodeName].push(xml2json(child));
            }
          }
        }
        
        return json;
    }

    function xml2Object(xml) {
        try {
            var obj = {};
            if (xml.children.length > 0) {
              for (var i = 0; i < xml.children.length; i++) {
                var item = xml.children.item(i);
                var attributes = item.attributes;
                for(var idx in attributes) {
                    var itemAtt = attributes[idx];
                    var dataKey = itemAtt.nodeName;
                    var dataValue = itemAtt.nodeValue;

                    if(dataKey !== undefined) {
                        obj[dataKey] = dataValue;
                    }
                }
                var nodeName = item.nodeName;

                if (typeof (obj[nodeName]) == "undefined") {
                  obj[nodeName] = xml2json(item);
                } else {
                  if (typeof (obj[nodeName].push) == "undefined") {
                    var old = obj[nodeName];

                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                  }
                  obj[nodeName].push(xml2json(item));
                }
              }
            } else {
              obj = xml.textContent;
            }
            return obj;
          } catch (e) {
              console.log(e.message);
          }
    }

    EXIF.enableXmp = function() {
        EXIF.isXmpEnabled = true;
    }

    EXIF.disableXmp = function() {
        EXIF.isXmpEnabled = false;
    }

    EXIF.getData = function(img, callback) {
        if (((self.Image && img instanceof self.Image)
            || (self.HTMLImageElement && img instanceof self.HTMLImageElement))
            && !img.complete)
            return false;

        if (!imageHasData(img)) {
            getImageData(img, callback);
        } else {
            if (callback) {
                callback.call(img);
            }
        }
        return true;
    }

    EXIF.getTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.exifdata[tag];
    }
    
    EXIF.getIptcTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.iptcdata[tag];
    }

    EXIF.getAllTags = function(img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.exifdata,
            tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    }
    
    EXIF.getAllIptcTags = function(img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.iptcdata,
            tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    }

    EXIF.pretty = function(img) {
        if (!imageHasData(img)) return "";
        var a,
            data = img.exifdata,
            strPretty = "";
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                if (typeof data[a] == "object") {
                    if (data[a] instanceof Number) {
                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                    } else {
                        strPretty += a + " : [" + data[a].length + " values]\r\n";
                    }
                } else {
                    strPretty += a + " : " + data[a] + "\r\n";
                }
            }
        }
        return strPretty;
    }

    EXIF.readFromBinaryFile = function(file) {
        return findEXIFinJPEG(file);
    }

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
            return EXIF;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}.call(this));



/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Body */
/* harmony export (immutable) */ __webpack_exports__["a"] = confirmation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file Confirmation
  * @author Wence
  */var Body = (_temp = _class = function (_PureComponent) {
  _inherits(Body, _PureComponent);function Body(props) {
    _classCallCheck(this, Body);var _this = _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).call(this, props));_this.state = { isAnimation: false };_this.clearTimer = _this.clearTimer.bind(_this);_this.onClose = _this.onClose.bind(_this);_this.onCancel = _this.onCancel.bind(_this);return _this;
  }_createClass(Body, [{ key: 'clearTimer', value: function clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);this.timer = null;
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;this.clearTimer();if (this.props.isAnimation) {
        this.timer = setTimeout(function () {
          _this2.setState({ isAnimation: true });
        }, 50);
      } else {
        this.setState({ isAnimation: true });
      }
    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
      this.clearTimer();
    } }, { key: 'onClose', value: function onClose() {
      var onClose = this.props.onClose;this.setState({ isAnimation: false });if (this.props.isAnimation) {
        setTimeout(function () {
          onClose && onClose();
        }, 50);
      } else {
        onClose && onClose();
      }
    } }, { key: 'onCancel', value: function onCancel() {
      var onCancel = this.props.onCancel;onCancel && onCancel();this.onClose();
    } }, { key: 'render', value: function render() {
      var _props = this.props,
          content = _props.content,
          okText = _props.okText,
          concelText = _props.concelText,
          onOk = _props.onOk,
          renderFooter = _props.renderFooter,
          className = _props.className,
          renderBody = _props.renderBody,
          disableCloseByMask = _props.disableCloseByMask;var isAnimation = this.state.isAnimation;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('xb-comfirm', className) }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('xb-comfirm-mask', { active: isAnimation }) }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'xb-comfirm-wrap' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: disableCloseByMask ? function () {
          return null;
        } : this.onClose, className: 'xb-comfirm-blank' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('xb-comfirm-content', { active: isAnimation }) }, typeof renderBody === 'function' ? renderBody() : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'xb-comfirm-body' }, content), typeof renderFooter === 'function' ? renderFooter() : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'xb-comfirm-footer' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: this.onCancel, className: 'xb-comfirm-btn xb-comfirm-cancel' }, concelText || '取消'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: onOk, className: 'xb-comfirm-btn xb-comfirm-ok' }, okText || '联系')))));
    } }]);return Body;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, disableCloseByMask: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, content: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]), okText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, concelText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, onCancel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, onOk: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, renderFooter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, renderBody: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, isAnimation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool }, _class.defaultProps = { isAnimation: true }, _temp);function confirmation() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var container = document.createElement('div');var body = document.body || document.documentElement.body;var _close = function close() {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(container);if (container && container.parentNode) {
      container.parentNode.removeChild(container);
    }if (_close) {
      _close = null;
    }
  };body.appendChild(container);__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Body, Object.assign({ onClose: _close }, props)), container);return _close;
}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_duopingtai.eb0b7998.svg";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_duorenwu.0351f626.svg";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_yunduanheihe.b7d8250d.svg";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_biaozhunhua.628e1fb0.svg";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_keyanzheng.a857fec0.svg";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_yewuzhuanjia.5a4aa6c4.svg";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_fengfu.33a4e0a1.svg";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg_card_1_wap.7fa204e0.png";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg_card_2_wap.5c3e3c98.png";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg_card_3_wap.55304344.png";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file_click.cbb8e2d5.svg";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var IS_IOS = exports.IS_IOS = canUseDOM && /iphone|ipad|ipod/i.test(window.navigator.userAgent);

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _ListItem = __webpack_require__(669);

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

var List = function (_React$Component) {
    (0, _inherits3['default'])(List, _React$Component);

    function List() {
        (0, _classCallCheck3['default'])(this, List);
        return (0, _possibleConstructorReturn3['default'])(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
    }

    (0, _createClass3['default'])(List, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                children = _a.children,
                className = _a.className,
                style = _a.style,
                renderHeader = _a.renderHeader,
                renderFooter = _a.renderFooter,
                restProps = __rest(_a, ["prefixCls", "children", "className", "style", "renderHeader", "renderFooter"]);
            var wrapCls = (0, _classnames2['default'])(prefixCls, className);
            return React.createElement(
                'div',
                (0, _extends3['default'])({ className: wrapCls, style: style }, restProps),
                renderHeader ? React.createElement(
                    'div',
                    { className: prefixCls + '-header' },
                    typeof renderHeader === 'function' ? renderHeader() : renderHeader
                ) : null,
                children ? React.createElement(
                    'div',
                    { className: prefixCls + '-body' },
                    children
                ) : null,
                renderFooter ? React.createElement(
                    'div',
                    { className: prefixCls + '-footer' },
                    typeof renderFooter === 'function' ? renderFooter() : renderFooter
                ) : null
            );
        }
    }]);
    return List;
}(React.Component);

exports['default'] = List;

List.Item = _ListItem2['default'];
List.defaultProps = {
    prefixCls: 'am-list'
};
module.exports = exports['default'];

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCmsapiIndexData;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchUserApply;
/* unused harmony export fetchCompanyV2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file 申请试用页面
 * @author wangzhuang
 */function fetchCmsapiIndexData(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/mobileUserApplyData', {}, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["I" /* GET_USER_APPLY_DATA */], data: data.data });
  });
}function fetchUserApply(dispatch, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/cmsapi/userApply', obj, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["r" /* GET_CMSAPI_USERAPPLY */], data: data.data });
  });
}function fetchCompanyV2(dispatch, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/privacy/authPrivacyCompanyV2', {}, obj, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["a" /* AUTH_PRIVACY_COMPANY_V2 */], data: data.data });
  });
}

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return postNumberReport; });
/* unused harmony export getInstanceInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAlreadyPhoneList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return validateNumberOwner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchPersonComplaint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCompanyComplaint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/**
 * @file 号码认证 - 申诉举报
 * @author wence
 */var postNumberReport = function postNumberReport(params) {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/phone/report', {}, JSON.stringify({ phone: params.phone, type: params.type, reason: params.reason, email: params.email, captcha: params.captcha }), function (data) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["O" /* POST_NUMBER_REPORT */], data: data.data });
    });
  };
};var getInstanceInfo = function getInstanceInfo() {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/instance/getInstance', {}, {}, function (data) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["x" /* GET_INSTANCE_INFO */], data: data.data });
    }).then(function (data) {
      return data.data;
    });
  };
};var getAlreadyPhoneList = function getAlreadyPhoneList(params) {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/phone/getAppealPhoneList', {}, __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(params), function (data) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["e" /* GET_ALREADY_PHONE_LIST */], data: data.data });
    }).then(function (data) {
      return data.data;
    });
  };
};var validateNumberOwner = function validateNumberOwner(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/account/doAuth', {}, __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(params), function (data) {
    return data.data;
  }).then(function (data) {
    return data.data;
  });
};var fetchPersonComplaint = function fetchPersonComplaint(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/phone/personComplaint', {}, params, function (data) {
    return data.data;
  }).then(function (data) {
    return data.data;
  });
};var fetchCompanyComplaint = function fetchCompanyComplaint(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/phone/companyComplaint', {}, params, function (data) {
    return data.data;
  }).then(function (data) {
    return data.data;
  });
};

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = closest;
function closest(el, selector) {
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    var p = el;
    while (p) {
        if (matchesSelector.call(p, selector)) {
            return p;
        }
        p = p.parentElement;
    }
    return null;
}
module.exports = exports["default"];

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchActivityInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchRemain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchPrize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchPrizeInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateContact; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_query_string__);
/**
 * @file: 活动页面的action
 * @author: wence
 */ // 获取活动奖品信息
var fetchActivityInfo = function fetchActivityInfo(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/activity/getActivity', {}, params, function () {
    return null;
  }).then(function (data) {
    return data && data.data || {};
  });
}; // 获取剩余中奖次数
var fetchRemain = function fetchRemain(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/activity/remain', {}, params, function () {
    return null;
  }).then(function (data) {
    return data && data.data || {};
  });
};var fetchPrize = function fetchPrize(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/activity/prize', {}, __WEBPACK_IMPORTED_MODULE_1_query_string___default.a.stringify(params), function () {
    return null;
  }).then(function (data) {
    return data && data.data || {};
  });
}; // 获取中奖信息
var fetchPrizeInfo = function fetchPrizeInfo(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/activity/getPrizeInfo', {}, params, function () {
    return null;
  }).then(function (data) {
    return data && data.data || {};
  });
}; // 添加实物地址
var updateContact = function updateContact(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/activity/contact', {}, params, function () {
    return null;
  }).then(function (data) {
    return data && data.data || {};
  });
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_quanhou.a433e823.svg";

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file_apk.6b7ae68a.svg";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file_dex.0911e73d.svg";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file_dll.2095d148.svg";

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file_dmg.84cb649b.svg";

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file_doc.868f0877.svg";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file_elf.bb59d036.svg";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file_exe.1a9befb7.svg";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file_pdf.e41688df.svg";

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file_qita.d54ae16b.svg";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file_so.7decfb1c.svg";

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file_sys.3763ef19.svg";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(273);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(15);
var isForced = __webpack_require__(164);
var $export = __webpack_require__(165);
var redefine = __webpack_require__(48);
var InternalMetadataModule = __webpack_require__(174);
var iterate = __webpack_require__(175);
var anInstance = __webpack_require__(178);
var isObject = __webpack_require__(25);
var fails = __webpack_require__(24);
var checkCorrectnessOfIteration = __webpack_require__(294);
var setToStringTag = __webpack_require__(93);
var inheritIfRequired = __webpack_require__(295);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common, IS_MAP, IS_WEAK) {
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var ADDER = IS_MAP ? 'set' : 'add';
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(a) {
        nativeMethod.call(this, a === 0 ? 0 : a);
        return this;
      } : KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : nativeMethod.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : nativeMethod.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : nativeMethod.call(this, a === 0 ? 0 : a);
      } : function set(a, b) {
        nativeMethod.call(this, a === 0 ? 0 : a, b);
        return this;
      }
    );
  };

  // eslint-disable-next-line max-len
  if (isForced(CONSTRUCTOR_NAME, typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
    new NativeConstructor().entries().next();
  })))) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (target, iterable) {
        anInstance(target, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), target, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $export({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(24);
var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(15);
var getOwnPropertyDescriptor = __webpack_require__(166).f;
var hide = __webpack_require__(26);
var redefine = __webpack_require__(48);
var setGlobal = __webpack_require__(87);
var copyConstructorProperties = __webpack_require__(282);
var isForced = __webpack_require__(164);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      hide(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(31);
var propertyIsEnumerableModule = __webpack_require__(279);
var createPropertyDescriptor = __webpack_require__(85);
var toIndexedObject = __webpack_require__(63);
var toPrimitive = __webpack_require__(168);
var has = __webpack_require__(23);
var IE8_DOM_DEFINE = __webpack_require__(169);
var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),
/* 167 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(25);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(31) && !__webpack_require__(24)(function () {
  return Object.defineProperty(__webpack_require__(170)('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(25);
var document = __webpack_require__(15).document;
// typeof document.createElement is 'object' in old IE
var exist = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return exist ? document.createElement(it) : {};
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(64)('native-function-to-string', Function.toString);


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(23);
var toIndexedObject = __webpack_require__(63);
var arrayIndexOf = __webpack_require__(285)(false);
var hiddenKeys = __webpack_require__(66);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(91);
var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var METADATA = __webpack_require__(90)('meta');
var FREEZING = __webpack_require__(288);
var isObject = __webpack_require__(25);
var has = __webpack_require__(23);
var defineProperty = __webpack_require__(32).f;
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

__webpack_require__(66)[METADATA] = true;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(33);
var isArrayIteratorMethod = __webpack_require__(289);
var toLength = __webpack_require__(173);
var bind = __webpack_require__(176);
var getIteratorMethod = __webpack_require__(292);
var callWithSafeIterationClosing = __webpack_require__(293);
var BREAK = {};

var exports = module.exports = function (iterable, fn, that, ENTRIES, ITERATOR) {
  var boundFunction = bind(fn, that, ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, step;

  if (ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = ENTRIES ? boundFunction(anObject(step = iterable[index])[0], step[1]) : boundFunction(iterable[index]);
        if (result === BREAK) return BREAK;
      } return;
    }
    iterator = iterFn.call(iterable);
  }

  while (!(step = iterator.next()).done) {
    if (callWithSafeIterationClosing(iterator, boundFunction, step.value, ENTRIES) === BREAK) return BREAK;
  }
};

exports.BREAK = BREAK;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(291);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var classofRaw = __webpack_require__(167);
var TO_STRING_TAG = __webpack_require__(19)('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var validateSetPrototypeOfArguments = __webpack_require__(296);

module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () { // eslint-disable-line
  var correctSetter = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    correctSetter = test instanceof Array;
  } catch (e) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    validateSetPrototypeOfArguments(O, proto);
    if (correctSetter) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__(32).f;
var create = __webpack_require__(94);
var redefineAll = __webpack_require__(300);
var bind = __webpack_require__(176);
var anInstance = __webpack_require__(178);
var iterate = __webpack_require__(175);
var defineIterator = __webpack_require__(95);
var setSpecies = __webpack_require__(304);
var DESCRIPTORS = __webpack_require__(31);
var fastKey = __webpack_require__(174).fastKey;
var InternalStateModule = __webpack_require__(65);
var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__(182);
var hide = __webpack_require__(26);
var has = __webpack_require__(23);
var IS_PURE = __webpack_require__(88);
var ITERATOR = __webpack_require__(19)('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(23);
var toObject = __webpack_require__(302);
var IE_PROTO = __webpack_require__(89)('IE_PROTO');
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(303);
var ObjectPrototype = Object.prototype;

module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(306);
var ObjectPrototype = Object.prototype;

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (toString !== ObjectPrototype.toString) {
  __webpack_require__(48)(ObjectPrototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var codePointAt = __webpack_require__(307);
var InternalStateModule = __webpack_require__(65);
var defineIterator = __webpack_require__(95);
var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = codePointAt(string, index, true);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var DOMIterables = __webpack_require__(308);
var ArrayIteratorMethods = __webpack_require__(309);
var global = __webpack_require__(15);
var hide = __webpack_require__(26);
var wellKnownSymbol = __webpack_require__(19);
var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      hide(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (e) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) hide(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        hide(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (e) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(314)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(188);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(192);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(97);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(334);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(199);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(102);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(379), __esModule: true };

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(381);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(36) && !__webpack_require__(53)(function () {
  return Object.defineProperty(__webpack_require__(204)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(42);
var document = __webpack_require__(28).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(110);
var $export = __webpack_require__(40);
var redefine = __webpack_require__(206);
var hide = __webpack_require__(41);
var Iterators = __webpack_require__(111);
var $iterCreate = __webpack_require__(386);
var setToStringTag = __webpack_require__(116);
var getPrototypeOf = __webpack_require__(392);
var ITERATOR = __webpack_require__(44)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(41);


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(37);
var toIObject = __webpack_require__(43);
var arrayIndexOf = __webpack_require__(388)(false);
var IE_PROTO = __webpack_require__(113)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(209);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 209 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(109);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(207);
var hiddenKeys = __webpack_require__(115).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(72);
var createDesc = __webpack_require__(69);
var toIObject = __webpack_require__(43);
var toPrimitive = __webpack_require__(106);
var has = __webpack_require__(37);
var IE8_DOM_DEFINE = __webpack_require__(203);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(36) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchCmsapiHomepage;
/* harmony export (immutable) */ __webpack_exports__["e"] = fetchUserLogin;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchArticleList;
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchNavigationList;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchNavListIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file 官网首页
 * @author wangzhuang
 */function fetchCmsapiHomepage(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/getHomepage', {}, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["i" /* GET_CMSAPI_GETHOMEPAGE */], data: data.data });
  });
}function fetchUserLogin(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/user/loginState?rd=' + Math.random(), {}, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["J" /* GET_USER_LOGINSTATE */], data: data.data });
  });
}function fetchArticleList(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/publishArticleList', { catid: 0 }, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["g" /* GET_ARTICLE_LIST */], data: data.data });
  });
}function fetchNavigationList(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/getNavigationList?need_pages=1', {}, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["z" /* GET_NAVIGATION_LIST */], data: data.data });
  });
}function fetchNavListIndex(dispatch, index) {
  dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["A" /* GET_NAVLIST_INDEX */], data: { index: index } });
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);
var settle = __webpack_require__(428);
var buildURL = __webpack_require__(430);
var parseHeaders = __webpack_require__(431);
var isURLSameOrigin = __webpack_require__(432);
var createError = __webpack_require__(216);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(433);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(434);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(429);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(469);

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(17);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames4 = __webpack_require__(3);

var _classnames5 = _interopRequireDefault(_classnames4);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _propTypes = __webpack_require__(1);

var PropTypes = _interopRequireWildcard(_propTypes);

var _rmcFeedback = __webpack_require__(38);

var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);

var _getDataAttr = __webpack_require__(471);

var _getDataAttr2 = _interopRequireDefault(_getDataAttr);

var _getLocale = __webpack_require__(221);

var _PropsType = __webpack_require__(472);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function onNextFrame(cb) {
    if (window.requestAnimationFrame) {
        return window.requestAnimationFrame(cb);
    }
    return window.setTimeout(cb, 1);
}
function clearNextFrameAction(nextFrameId) {
    if (window.cancelAnimationFrame) {
        window.cancelAnimationFrame(nextFrameId);
    } else {
        window.clearTimeout(nextFrameId);
    }
}

var SearchBar = function (_React$Component) {
    (0, _inherits3['default'])(SearchBar, _React$Component);

    function SearchBar(props) {
        (0, _classCallCheck3['default'])(this, SearchBar);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));

        _this.onSubmit = function (e) {
            e.preventDefault();
            if (_this.props.onSubmit) {
                _this.props.onSubmit(_this.state.value || '');
            }
            if (_this.inputRef) {
                _this.inputRef.blur();
            }
        };
        _this.onChange = function (e) {
            if (!_this.state.focus) {
                _this.setState({
                    focus: true
                });
            }
            var value = e.target.value;
            if (!('value' in _this.props)) {
                _this.setState({ value: value });
            }
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };
        _this.onFocus = function () {
            _this.setState({
                focus: true
            });
            _this.firstFocus = true;
            if (_this.props.onFocus) {
                _this.props.onFocus();
            }
        };
        _this.onBlur = function () {
            _this.onBlurTimeout = onNextFrame(function () {
                if (!_this.blurFromOnClear) {
                    if (document.activeElement !== _this.inputRef) {
                        _this.setState({
                            focus: false
                        });
                    }
                }
                _this.blurFromOnClear = false;
            });
            if (_this.props.onBlur) {
                // fix autoFocus item blur with flash
                setTimeout(function () {
                    // fix ios12 wechat browser click failure after input
                    if (document.body) {
                        document.body.scrollTop = document.body.scrollTop;
                    }
                }, 100);
                _this.props.onBlur();
            }
        };
        _this.onClear = function () {
            _this.doClear();
        };
        _this.doClear = function () {
            var blurFromOnClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            _this.blurFromOnClear = blurFromOnClear;
            if (!('value' in _this.props)) {
                _this.setState({ value: '' });
            }
            if (_this.props.onClear) {
                _this.props.onClear('');
            }
            if (_this.props.onChange) {
                _this.props.onChange('');
            }
            if (blurFromOnClear) {
                _this.focus();
            }
        };
        _this.onCancel = function () {
            if (_this.props.onCancel) {
                _this.props.onCancel(_this.state.value || '');
            } else {
                _this.doClear(false);
            }
        };
        _this.focus = function () {
            if (_this.inputRef) {
                _this.inputRef.focus();
            }
        };
        var value = void 0;
        if ('value' in props) {
            value = props.value || '';
        } else if ('defaultValue' in props) {
            value = props.defaultValue;
        } else {
            value = '';
        }
        _this.state = {
            value: value,
            focus: false
        };
        return _this;
    }

    (0, _createClass3['default'])(SearchBar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.rightBtnRef) {
                var initBtn = window.getComputedStyle(this.rightBtnRef);
                this.rightBtnInitMarginleft = initBtn.marginLeft;
            }
            this.componentDidUpdate();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.syntheticPhRef) {
                if (this.inputContainerRef && this.inputContainerRef.className.indexOf(this.props.prefixCls + '-start') > -1) {
                    // 检测是否包含名为 ${this.props.prefixCls}-start 样式，生成动画
                    // offsetWidth 某些时候是向上取整，某些时候是向下取整，不能用
                    if (this.syntheticPhContainerRef) {
                        var realWidth = this.syntheticPhContainerRef.getBoundingClientRect().width; // 包含小数
                        this.syntheticPhRef.style.width = Math.ceil(realWidth) + 'px';
                    }
                    if (!this.props.showCancelButton && this.rightBtnRef) {
                        this.rightBtnRef.style.marginRight = '0';
                    }
                } else {
                    this.syntheticPhRef.style.width = '100%';
                    if (!this.props.showCancelButton && this.rightBtnRef) {
                        this.rightBtnRef.style.marginRight = '-' + (this.rightBtnRef.offsetWidth + (this.rightBtnInitMarginleft != null ? parseInt(this.rightBtnInitMarginleft, 10) : 0)) + 'px';
                    }
                }
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps && nextProps.value !== this.state.value) {
                this.setState({
                    value: nextProps.value
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.onBlurTimeout) {
                clearNextFrameAction(this.onBlurTimeout);
                this.onBlurTimeout = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames3,
                _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                showCancelButton = _props.showCancelButton,
                disabled = _props.disabled,
                placeholder = _props.placeholder,
                className = _props.className,
                style = _props.style,
                maxLength = _props.maxLength;
            // tslint:disable-next-line:variable-name

            var _locale = (0, _getLocale.getComponentLocale)(this.props, this.context, 'SearchBar', function () {
                return __webpack_require__(473);
            });
            var cancelText = _locale.cancelText;
            var _state = this.state,
                value = _state.value,
                focus = _state.focus;

            var wrapCls = (0, _classnames5['default'])(prefixCls, className, (0, _defineProperty3['default'])({}, prefixCls + '-start', !!(focus || value && value.length > 0)));
            var clearCls = (0, _classnames5['default'])(prefixCls + '-clear', (0, _defineProperty3['default'])({}, prefixCls + '-clear-show', !!(focus && value && value.length > 0)));
            var cancelCls = (0, _classnames5['default'])(prefixCls + '-cancel', (_classnames3 = {}, (0, _defineProperty3['default'])(_classnames3, prefixCls + '-cancel-show', !!(showCancelButton || focus || value && value.length > 0)), (0, _defineProperty3['default'])(_classnames3, prefixCls + '-cancel-anim', this.firstFocus), _classnames3));
            return React.createElement(
                'form',
                { onSubmit: this.onSubmit, className: wrapCls, style: style, ref: function ref(el) {
                        return _this2.inputContainerRef = el;
                    }, action: '#' },
                React.createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    React.createElement(
                        'div',
                        { className: prefixCls + '-synthetic-ph', ref: function ref(el) {
                                return _this2.syntheticPhRef = el;
                            } },
                        React.createElement(
                            'span',
                            { className: prefixCls + '-synthetic-ph-container', ref: function ref(el) {
                                    return _this2.syntheticPhContainerRef = el;
                                } },
                            React.createElement('i', { className: prefixCls + '-synthetic-ph-icon' }),
                            React.createElement(
                                'span',
                                { className: prefixCls + '-synthetic-ph-placeholder'
                                    // tslint:disable-next-line:jsx-no-multiline-js
                                    , style: {
                                        visibility: placeholder && !value ? 'visible' : 'hidden'
                                    } },
                                placeholder
                            )
                        )
                    ),
                    React.createElement('input', (0, _extends3['default'])({ type: 'search', className: prefixCls + '-value', value: value, disabled: disabled, placeholder: placeholder, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, ref: function ref(el) {
                            return _this2.inputRef = el;
                        }, maxLength: maxLength }, (0, _getDataAttr2['default'])(this.props))),
                    React.createElement(
                        _rmcFeedback2['default'],
                        { activeClassName: prefixCls + '-clear-active' },
                        React.createElement('a', { onClick: this.onClear, className: clearCls })
                    )
                ),
                React.createElement(
                    'div',
                    { className: cancelCls, onClick: this.onCancel, ref: function ref(el) {
                            return _this2.rightBtnRef = el;
                        } },
                    this.props.cancelText || cancelText
                )
            );
        }
    }]);
    return SearchBar;
}(React.Component);

exports['default'] = SearchBar;

SearchBar.defaultProps = _PropsType.defaultProps;
SearchBar.contextTypes = {
    antLocale: PropTypes.object
};
module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

exports.getComponentLocale = getComponentLocale;
exports.getLocaleCode = getLocaleCode;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getComponentLocale(props, context, componentName, getDefaultLocale) {
    var locale = {};
    if (context && context.antLocale && context.antLocale[componentName]) {
        locale = context.antLocale[componentName];
    } else {
        var defaultLocale = getDefaultLocale();
        // TODO: make default lang of antd be English
        // https://github.com/ant-design/ant-design/issues/6334
        locale = defaultLocale['default'] || defaultLocale;
    }
    var result = (0, _extends3['default'])({}, locale);
    if (props.locale) {
        result = (0, _extends3['default'])({}, result, props.locale);
        if (props.locale.lang) {
            result.lang = (0, _extends3['default'])({}, locale.lang, props.locale.lang);
        }
    }
    return result;
}
function getLocaleCode(context) {
    var localeCode = context.antLocale && context.antLocale.locale;
    // Had use LocaleProvide but didn't set locale
    if (context.antLocale && context.antLocale.exist && !localeCode) {
        return 'zh-cn';
    }
    return localeCode;
}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/spu_menu_account.eb075c71.svg";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_qiyehaomashensu.3b68df20.svg";

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_gerenhaomashensu.b0a659e7.svg";

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_saoraodianhuajubao.f11f7fe7.svg";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_quanmianfanghu.4c5752be.svg";

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DrawRegion; });
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
} /**
  * @file: DrawRegion
  * @author: wence
  */var DrawRegion = function () {
  function DrawRegion(config) {
    _classCallCheck(this, DrawRegion);this.config = config || {};this.canvas = document.getElementById(this.config.id);this.locationScale = 1;this.ctx = this.canvas.getContext('2d');this.ratio = this.getPixelRatio();this.canvas.style = 'transform: scale(' + 1 / this.ratio + ')';
  }_createClass(DrawRegion, [{ key: 'drawImage', value: function drawImage(config, callback, errorCallback) {
      var curConfig = config || {};var url = curConfig.url;var img = document.createElement('img');img.src = url;var self = this;this.locationScale = 1;img.onload = function () {
        // 超过宽高的
        if (img.height > self.config.height || img.width > self.config.width) {
          var locationScaleH = self.config.height / this.height;var locationScaleW = self.config.width / this.width;if (locationScaleH > locationScaleW) {
            this.width = self.config.width;self.locationScale = locationScaleW;
          } else if (locationScaleH < locationScaleW) {
            this.height = self.config.height;self.locationScale = locationScaleH;
          } else {
            this.width = self.config.width;self.locationScale = locationScaleW;
          }
        }var imageHeight = this.height;var imageWidth = this.width;var realWidth = self.getRealSize(imageWidth);var realHeight = self.getRealSize(imageHeight);self.canvas.height = realHeight;self.canvas.width = realWidth;self.ctx.drawImage(this, 0, 0, self.canvas.width, self.canvas.height);if (callback) {
          callback();
        }self.ctx.restore();document.body.removeChild(img);
      };img.onerror = function () {
        if (errorCallback) {
          errorCallback();
        }
      };document.body.appendChild(img);
    } }, { key: 'drawStrokeInImage', value: function drawStrokeInImage(config) {
      var curConfig = config || {};var list = curConfig.list || [];for (var i = 0; i < list.length; i++) {
        this.drowStrokeWithText(list[i]);
      }
    } }, { key: 'getRealSize', value: function getRealSize(size) {
      return size * this.ratio;
    } }, { key: 'clearDraw', value: function clearDraw() {
      this.canvas.height = this.canvas.height;
    } }, { key: 'getPixelRatio', value: function getPixelRatio() {
      var backingStore = this.ctx.backingStorePixelRatio || this.ctx.webkitBackingStorePixelRatio || this.ctx.mozBackingStorePixelRatio || this.ctx.msBackingStorePixelRatio || this.ctx.oBackingStorePixelRatio || this.ctx.backingStorePixelRatio || 1;return (window.devicePixelRatio || 1) / backingStore;
    } }, { key: 'drowStrokeWithText', value: function drowStrokeWithText(config) {
      var curConfig = config || {};var x = this.getRealSize((curConfig.location.left || 0) * this.locationScale);var y = this.getRealSize((curConfig.location.top || 0) * this.locationScale);var width = this.getRealSize((curConfig.location.width || 0) * this.locationScale);var height = this.getRealSize((curConfig.location.height || 0) * this.locationScale);var fontSize = this.getRealSize(12);var textCenterPiontX = Math.round(x + width / 2);var textCenterPiontY = y < 25 ? height + y + 25 : y - 10;var text = curConfig.text || '';var textColor = curConfig.textColor || '';this.ctx.strokeStyle = curConfig.strokeStyle || 'red';this.ctx.textAlign = 'center';this.ctx.fillStyle = textColor;this.ctx.font = fontSize + 'px PingFangSC-Regular, "PingFang SC", "Helvetica Neue", Helvetica,' + '"Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif';this.ctx.lineWidth = curConfig.lineWidth || this.getRealSize(1);this.ctx.strokeRect(x, y, width, height);this.ctx.stroke();this.ctx.fillText(text, textCenterPiontX, textCenterPiontY);this.ctx.restore();
    } }]);return DrawRegion;
}();

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sp_lingxian.d8214e5a.svg";

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sp_wending.6678d8d4.svg";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sp_duli.dbfd71e0.svg";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_zhuanye.a54bb5bd.svg";

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_zhuanye.cbbfbb59.svg";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_wanzheng.443bd806.svg";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_duoyang.9654d371.svg";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_chuangxin.7b1c0b8f.svg";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yewu-cj1.1f56c27a.png";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yewu-cj4.829c1750.png";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_search.75d7c1c2.svg";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_search_click.e7b83ae7.svg";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_url.64d592ae.svg";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_url_click.995c1268.svg";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_file.3c2e47cb.svg";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner-wap.35c38996.png";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(55);

__webpack_require__(661);

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(17);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames3 = __webpack_require__(3);

var _classnames4 = _interopRequireDefault(_classnames3);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rmcFeedback = __webpack_require__(38);

var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);

var _exenv = __webpack_require__(142);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

function noop() {}
function fixControlledValue(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value;
}
var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]|\n/g;
function countSymbols() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return text.replace(regexAstralSymbols, '_').length;
}

var TextareaItem = function (_React$Component) {
    (0, _inherits3['default'])(TextareaItem, _React$Component);

    function TextareaItem(props) {
        (0, _classCallCheck3['default'])(this, TextareaItem);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (TextareaItem.__proto__ || Object.getPrototypeOf(TextareaItem)).call(this, props));

        _this.focus = function () {
            _this.textareaRef.focus();
        };
        _this.reAlignHeight = function () {
            var textareaDom = _this.textareaRef;
            textareaDom.style.height = ''; // 字数减少时能自动减小高度
            textareaDom.style.height = textareaDom.scrollHeight + 'px';
        };
        _this.onChange = function (e) {
            var value = e.target.value;
            if ('value' in _this.props) {
                _this.setState({ value: _this.props.value });
            } else {
                _this.setState({ value: value });
            }
            var onChange = _this.props.onChange;

            if (onChange) {
                onChange(value);
            }
            // 设置 defaultValue 时，用户输入不会触发 componentDidUpdate ，此处手工调用
            _this.componentDidUpdate();
        };
        _this.onBlur = function (e) {
            _this.debounceTimeout = setTimeout(function () {
                if (document.activeElement !== _this.textareaRef) {
                    _this.setState({
                        focus: false
                    });
                }
            }, 100);
            var value = e.currentTarget.value;
            if (_this.props.onBlur) {
                // fix autoFocus item blur with flash
                setTimeout(function () {
                    // fix ios12 wechat browser click failure after input
                    if (document.body) {
                        document.body.scrollTop = document.body.scrollTop;
                    }
                }, 100);
                _this.props.onBlur(value);
            }
        };
        _this.onFocus = function (e) {
            if (_this.debounceTimeout) {
                clearTimeout(_this.debounceTimeout);
                _this.debounceTimeout = null;
            }
            _this.setState({
                focus: true
            });
            var value = e.currentTarget.value;
            if (_this.props.onFocus) {
                _this.props.onFocus(value);
            }
        };
        _this.onErrorClick = function () {
            if (_this.props.onErrorClick) {
                _this.props.onErrorClick();
            }
        };
        _this.clearInput = function () {
            _this.setState({
                value: ''
            });
            if (_this.props.onChange) {
                _this.props.onChange('');
            }
        };
        _this.state = {
            focus: false,
            value: props.value || props.defaultValue || ''
        };
        return _this;
    }

    (0, _createClass3['default'])(TextareaItem, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
                this.setState({
                    value: fixControlledValue(nextProps.value)
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.autoHeight) {
                this.reAlignHeight();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.autoHeight && this.state.focus) {
                this.reAlignHeight();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _classnames2,
                _this2 = this;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                prefixListCls = _a.prefixListCls,
                editable = _a.editable,
                style = _a.style,
                clear = _a.clear,
                children = _a.children,
                error = _a.error,
                className = _a.className,
                count = _a.count,
                labelNumber = _a.labelNumber,
                title = _a.title,
                onErrorClick = _a.onErrorClick,
                autoHeight = _a.autoHeight,
                defaultValue = _a.defaultValue,
                otherProps = __rest(_a, ["prefixCls", "prefixListCls", "editable", "style", "clear", "children", "error", "className", "count", "labelNumber", "title", "onErrorClick", "autoHeight", "defaultValue"]);var disabled = otherProps.disabled;
            var _state = this.state,
                value = _state.value,
                focus = _state.focus;

            var hasCount = count > 0 && this.props.rows > 1;
            var wrapCls = (0, _classnames4['default'])(className, prefixListCls + '-item', prefixCls + '-item', (_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classnames, prefixCls + '-item-single-line', this.props.rows === 1 && !autoHeight), (0, _defineProperty3['default'])(_classnames, prefixCls + '-error', error), (0, _defineProperty3['default'])(_classnames, prefixCls + '-focus', focus), (0, _defineProperty3['default'])(_classnames, prefixCls + '-has-count', hasCount), _classnames));
            var labelCls = (0, _classnames4['default'])(prefixCls + '-label', (_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-2', labelNumber === 2), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-3', labelNumber === 3), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-4', labelNumber === 4), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-5', labelNumber === 5), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-6', labelNumber === 6), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-7', labelNumber === 7), _classnames2));
            var characterLength = countSymbols(value);
            var lengthCtrlProps = {};
            if (count > 0) {
                // Note: If in the iOS environment of dev-tools, It will fail.
                if (_exenv.IS_IOS) {
                    var entValue = value ? value.replace(regexAstralSymbols, '_') : '';
                    var entLen = entValue ? entValue.split('_').length - 1 : 0;
                    lengthCtrlProps.maxLength = count + entLen - characterLength + (value ? value.length : 0);
                } else {
                    lengthCtrlProps.maxLength = count - characterLength + (value ? value.length : 0);
                }
            }
            return React.createElement(
                'div',
                { className: wrapCls },
                title && React.createElement(
                    'div',
                    { className: labelCls },
                    title
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-control' },
                    React.createElement('textarea', (0, _extends3['default'])({ ref: function ref(el) {
                            return _this2.textareaRef = el;
                        } }, lengthCtrlProps, otherProps, { value: value, onChange: this.onChange, onBlur: this.onBlur, onFocus: this.onFocus, readOnly: !editable, style: style }))
                ),
                clear && editable && value && characterLength > 0 && React.createElement(
                    _rmcFeedback2['default'],
                    { activeClassName: prefixCls + '-clear-active' },
                    React.createElement('div', { className: prefixCls + '-clear', onClick: this.clearInput })
                ),
                error && React.createElement('div', { className: prefixCls + '-error-extra', onClick: this.onErrorClick }),
                hasCount && React.createElement(
                    'span',
                    { className: prefixCls + '-count' },
                    React.createElement(
                        'span',
                        null,
                        value ? characterLength : 0
                    ),
                    '/',
                    count
                )
            );
        }
    }]);
    return TextareaItem;
}(React.Component);

exports['default'] = TextareaItem;

TextareaItem.defaultProps = {
    prefixCls: 'am-textarea',
    prefixListCls: 'am-list',
    autoHeight: false,
    editable: true,
    disabled: false,
    placeholder: '',
    clear: false,
    rows: 1,
    onChange: noop,
    onBlur: noop,
    onFocus: noop,
    onErrorClick: noop,
    error: false,
    labelNumber: 5
};
module.exports = exports['default'];

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/apply-succ.b90c2eba.svg";

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Spin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file Spin
  * @author WenCe
  */var Spin = (_temp = _class = function (_PureComponent) {
  _inherits(Spin, _PureComponent);function Spin() {
    _classCallCheck(this, Spin);return _possibleConstructorReturn(this, (Spin.__proto__ || Object.getPrototypeOf(Spin)).apply(this, arguments));
  }_createClass(Spin, [{ key: 'render', value: function render() {
      var size = this.props.size;var rem = size + 'rem';var style = { width: rem, height: rem };return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spin-wrapper' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spin', style: style }));
    } }]);return Spin;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }, _class.defaultProps = { size: 0.8 }, _temp);

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_yanzheng.5b062002.svg";

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(254);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getVoucher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return payVoucher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/**
 * @file: 云扫描活动
 * @author: wence
 */var getVoucher = function getVoucher(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/pay/getOneClickVoucher', {}, params, function () {
    return null;
  }).then(function (data) {
    return data && data.data || {};
  });
};var payVoucher = function payVoucher(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/pay/oneClickVoucher', {}, params, function () {
    return null;
  }).then(function (data) {
    return data && data.data || {};
  });
};

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__numberOptions_formCom__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__numberOptions_utils__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_activityAction__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_less__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 地址填写
  * @author: wence
  */var FormModal = (_temp = _class = function (_PureComponent) {
  _inherits(FormModal, _PureComponent);function FormModal(props) {
    var _this2 = this;_classCallCheck(this, FormModal);var _this = _possibleConstructorReturn(this, (FormModal.__proto__ || Object.getPrototypeOf(FormModal)).call(this, props));_this.onSubmit = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var parizeInfo, aid, params, res;return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              parizeInfo = _this.props.parizeInfo;aid = _this.props.aid;params = { aid: aid, flag: __WEBPACK_IMPORTED_MODULE_7__index__["c" /* flag */], wid: parizeInfo && parizeInfo.wid, address: _this.state.address.trim(), mobile: _this.state.mobile.trim(), 'user_name': _this.state.name.trim() };_context.next = 5;return Object(__WEBPACK_IMPORTED_MODULE_8__actions_activityAction__["e" /* updateContact */])(params);case 5:
              res = _context.sent;if (res.status === 0) {
                if (res.data.success) {
                  _this.confirm && _this.confirm();_this.confirm = Object(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* confirm */])({ title: '', content: _this.props.successMsg, okText: '确认', isAnimation: false, okClick: function okClick() {
                      return _this.confirm && _this.confirm();
                    } });_this.props.resetData();_this.setState({ address: '', name: '', mobile: '' });_this.props.onCancel();
                } else if (res.data && res.data.message) {
                  _this.confirm = Object(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* confirm */])({ title: '提示', isAnimation: false, content: res.data.message, okText: '确认', okClick: function okClick() {
                      return _this.confirm && _this.confirm();
                    } });
                }
              } else {
                _this.confirm && _this.confirm();_this.confirm = Object(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* confirm */])({ title: '提示', isAnimation: false, content: res && res.description, okText: '返回修改', okClick: function okClick() {
                    _this.confirm && _this.confirm();
                  } });
              }case 7:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2);
    }));_this.renderForm = function () {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'form' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__numberOptions_formCom__["b" /* FormItem */], { isRequire: true, ref: _this.pushValidate.bind(_this, 'name'), value: _this.state.name, onChange: function onChange(value) {
          return _this.setState({ name: value });
        }, label: '\u59D3\u540D:', rules: [Object(__WEBPACK_IMPORTED_MODULE_6__numberOptions_utils__["f" /* validateRequire */])('姓名')], placeholder: '\u8BF7\u8F93\u5165\u60A8\u7684\u59D3\u540D', type: 'input' }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__numberOptions_formCom__["b" /* FormItem */], { isRequire: true, label: '\u5730\u5740:', ref: _this.pushValidate.bind(_this, 'address'), rules: [Object(__WEBPACK_IMPORTED_MODULE_6__numberOptions_utils__["f" /* validateRequire */])('地址')], value: _this.state.address, onChange: function onChange(value) {
          return _this.setState({ address: value });
        }, placeholder: '\u8BF7\u8F93\u5165\u60A8\u7684\u5730\u5740', type: 'textarea' }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__numberOptions_formCom__["b" /* FormItem */], { isRequire: true, ref: _this.pushValidate.bind(_this, 'mobile'), rules: [Object(__WEBPACK_IMPORTED_MODULE_6__numberOptions_utils__["f" /* validateRequire */])('联系方式')], value: _this.state.mobile, onChange: function onChange(value) {
          return _this.setState({ mobile: value });
        }, label: '\u8054\u7CFB\u65B9\u5F0F:', placeholder: '\u8BF7\u8F93\u5165\u60A8\u7684\u8054\u7CFB\u65B9\u5F0F', type: 'input' }));
    };_this.state = { name: '', address: '', mobile: '' };_this.validate = {};return _this;
  }_createClass(FormModal, [{ key: 'pushValidate', value: function pushValidate(key, node) {
      if (node) {
        this.validate[key] = node.validate;
      }
    } }, { key: 'render', value: function render() {
      var _this3 = this;var _props = this.props,
          visible = _props.visible,
          onCancel = _props.onCancel;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default.a, { transparent: true, visible: visible, maskClosable: true, onClose: onCancel, className: 'activity-form w-confirm-modal' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { onTouchStart: function onTouchStart(e) {
          return e.stopPropagation();
        }, className: 'activity-form-container' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'modal-title' }, '\u90AE\u5BC4\u4FE1\u606F'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'scorll' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'scorll-inner' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('p', { className: 'tips' }, '1.\u6D3B\u52A8\u7ED3\u675F\u540E\uFF0C\u7EDF\u4E00\u5B89\u6392\u53D1\u653E\uFF0C\u4EE5\u5FEB\u9012\u65B9\u5F0F\u90AE\u5BC4\u81F3\u60A8\u586B\u5199\u7684\u5730\u5740\u3002'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('p', { className: 'tips' }, '2.\u90AE\u5BC4\u4FE1\u606F\u63D0\u4EA4\u540E\u4E0D\u80FD\u4FEE\u6539\uFF0C\u8BF7\u60A8\u786E\u8BA4\u540E\u63D0\u4EA4'), this.renderForm())), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'x-footer' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { onClick: onCancel, className: 'x-btn x-footer-cancel' }, '\u6682\u4E0D\u63D0\u4EA4'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { onClick: function onClick() {
          var canSubmit = true;Object.keys(_this3.validate).map(function (key) {
            var validate = _this3.validate[key] && _this3.validate[key]();if (validate.validate && canSubmit) {
              canSubmit = false;
            }
          });if (!canSubmit) {
            return;
          }_this3.confirm = Object(__WEBPACK_IMPORTED_MODULE_7__index__["a" /* confirm */])({ title: '信息确认', content: '邮寄信息提交后不能修改，请您确认后提交', okText: '确认提交', isAnimation: false, okClick: _this3.onSubmit, cancelText: '去修改', cancelClick: function cancelClick() {
              return _this3.confirm && _this3.confirm();
            } });
        }, className: 'x-btn x-footer-confirm' }, '\u786E\u8BA4\u63D0\u4EA4'))));
    } }]);return FormModal;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]), _class.propTypes = { parizeInfo: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, visible: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, onCancel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, resetData: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, successMsg: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, aid: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any }, _temp);

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic_wap_1.ed0db5d5.svg";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic_wap_2.8fa71e5a.svg";

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ic_wap_3.85691ee6.svg";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_anquan.2f93885d.svg";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_input_search.b56edaac.svg";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_spinner_small.927a5b0a.svg";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_weixian.02a01196.svg";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_wufajiance.e071d592.svg";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_normalerror.02c240a9.svg";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(268);
__webpack_require__(271);
module.exports = __webpack_require__(276);


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(269);
} else {
  module.exports = require('./dist/react-hot-loader.development.js');
}


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(0)),classCallCheck=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},inherits=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)},possibleConstructorReturn=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t},AppContainer=function(e){function t(){return classCallCheck(this,t),possibleConstructorReturn(this,e.apply(this,arguments))}return inherits(t,e),t.prototype.render=function(){return React.Children.only(this.props.children)},t}(React.Component),hot_prod=function(){return function(e){return e}},areComponentsEqual=function(e,t){return e===t},setConfig=function(){};exports.AppContainer=AppContainer,exports.hot=hot_prod,exports.areComponentsEqual=areComponentsEqual,exports.setConfig=setConfig;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(61),n=__webpack_require__(46),p=__webpack_require__(161),q=__webpack_require__(47),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(272).enable();
  window.Promise = __webpack_require__(274);
}

// fetch() polyfill for making API calls.
__webpack_require__(275);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(61);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(162);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(62)))

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(162);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 275 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es_map__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es_set__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_es_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_polyfill__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raf_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reducers__ = __webpack_require__(807);
/**
 * @file 入口文件
 * @author WangZhuang
 */var todoApp = Object(__WEBPACK_IMPORTED_MODULE_5_redux__["c" /* combineReducers */])(__WEBPACK_IMPORTED_MODULE_10__reducers__["a" /* default */]);var store = Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* createStore */])(todoApp, Object(__WEBPACK_IMPORTED_MODULE_5_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* thunkMiddleware */]));Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* extendComponent */])()();Object(__WEBPACK_IMPORTED_MODULE_4_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* Provider */], { store: store }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["a" /* BrowserRouter */], { basename: '/m' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__App__["a" /* default */], null))), document.getElementById('root'));

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(278);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(185);

module.exports = __webpack_require__(96).Map;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// `Map` constructor
// https://tc39.github.io/ecma262/#sec-map-objects
module.exports = __webpack_require__(163)('Map', function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, __webpack_require__(180), true);


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = nativeGetOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = nativeGetOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var fails = __webpack_require__(24);
var classof = __webpack_require__(167);
var split = ''.split;

module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var nativeFunctionToString = __webpack_require__(171);
var WeakMap = __webpack_require__(15).WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(nativeFunctionToString.call(WeakMap));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(23);
var ownKeys = __webpack_require__(283);
var getOwnPropertyDescriptorModule = __webpack_require__(166);
var definePropertyModule = __webpack_require__(32);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var getOwnPropertyNamesModule = __webpack_require__(284);
var getOwnPropertySymbolsModule = __webpack_require__(287);
var anObject = __webpack_require__(33);
var Reflect = __webpack_require__(15).Reflect;

// all object keys, includes non-enumerable and symbols
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var internalObjectKeys = __webpack_require__(172);
var hiddenKeys = __webpack_require__(92).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(63);
var toLength = __webpack_require__(173);
var toAbsoluteIndex = __webpack_require__(286);

// `Array.prototype.{ indexOf, includes }` methods implementation
// false -> Array#indexOf
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
// true  -> Array#includes
// https://tc39.github.io/ecma262/#sec-array.prototype.includes
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(91);
var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 287 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(24)(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(49);
var ITERATOR = __webpack_require__(19)('iterator');
var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// Chrome 38 Symbol has incorrect toString conversion
module.exports = !__webpack_require__(24)(function () {
  // eslint-disable-next-line no-undef
  String(Symbol());
});


/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(177);
var ITERATOR = __webpack_require__(19)('iterator');
var Iterators = __webpack_require__(49);

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(33);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw e;
  }
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(19)('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (e) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(25);
var setPrototypeOf = __webpack_require__(179);

module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(25);
var anObject = __webpack_require__(33);

module.exports = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) {
    throw TypeError("Can't set " + String(proto) + ' as a prototype');
  }
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(31);
var definePropertyModule = __webpack_require__(32);
var anObject = __webpack_require__(33);
var objectKeys = __webpack_require__(298);

module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var key;
  while (length > i) definePropertyModule.f(O, key = keys[i++], Properties[key]);
  return O;
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var internalObjectKeys = __webpack_require__(172);
var enumBugKeys = __webpack_require__(92);

module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(15).document;

module.exports = document && document.documentElement;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(48);

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(181).IteratorPrototype;
var create = __webpack_require__(94);
var createPropertyDescriptor = __webpack_require__(85);
var setToStringTag = __webpack_require__(93);
var Iterators = __webpack_require__(49);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(86);

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(24)(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(305);
var definePropertyModule = __webpack_require__(32);
var DESCRIPTORS = __webpack_require__(31);
var SPECIES = __webpack_require__(19)('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var C = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;
  if (DESCRIPTORS && C && !C[SPECIES]) defineProperty(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(96);
var global = __webpack_require__(15);

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(177);
var TO_STRING_TAG = __webpack_require__(19)('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = String(test) !== '[object z]' ? function toString() {
  return '[object ' + classof(this) + ']';
} : test.toString;


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(91);
var requireObjectCoercible = __webpack_require__(86);
// CONVERT_TO_STRING: true  -> String#at
// CONVERT_TO_STRING: false -> String#codePointAt
module.exports = function (that, pos, CONVERT_TO_STRING) {
  var S = String(requireObjectCoercible(that));
  var position = toInteger(pos);
  var size = S.length;
  var first, second;
  if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
  first = S.charCodeAt(position);
  return first < 0xd800 || first > 0xdbff || position + 1 === size
    || (second = S.charCodeAt(position + 1)) < 0xdc00 || second > 0xdfff
      ? CONVERT_TO_STRING ? S.charAt(position) : first
      : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};


/***/ }),
/* 308 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(63);
var addToUnscopables = __webpack_require__(310);
var Iterators = __webpack_require__(49);
var InternalStateModule = __webpack_require__(65);
var defineIterator = __webpack_require__(95);
var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var UNSCOPABLES = __webpack_require__(19)('unscopables');
var create = __webpack_require__(94);
var hide = __webpack_require__(26);
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  hide(ArrayPrototype, UNSCOPABLES, create(null));
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(312);
__webpack_require__(183);
__webpack_require__(184);
__webpack_require__(185);

module.exports = __webpack_require__(96).Set;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// `Set` constructor
// https://tc39.github.io/ecma262/#sec-set-objects
module.exports = __webpack_require__(163)('Set', function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, __webpack_require__(180));


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(186).polyfill()


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)))

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var ba=__webpack_require__(46),ea=__webpack_require__(0),m=__webpack_require__(316),A=__webpack_require__(61),C=__webpack_require__(47),fa=__webpack_require__(317),ha=__webpack_require__(318),ja=__webpack_require__(319),ka=__webpack_require__(161);
function D(a){for(var b=arguments.length-1,c="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ea?void 0:D("227");
function ma(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ma.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return na.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function na(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var oa=null,pa={};
function qa(){if(oa)for(var a in pa){var b=pa[a],c=oa.indexOf(a);-1<c?void 0:D("96",a);if(!ra[c]){b.extractEvents?void 0:D("97",a);ra[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;sa.hasOwnProperty(g)?D("99",g):void 0;sa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ta(k[e],h,g);e=!0}else f.registrationName?(ta(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
function ta(a,b,c){ua[a]?D("100",a):void 0;ua[a]=b;va[a]=b.eventTypes[c].dependencies}var ra=[],sa={},ua={},va={};function wa(a){oa?D("101"):void 0;oa=Array.prototype.slice.call(a);qa()}function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];pa.hasOwnProperty(c)&&pa[c]===d||(pa[c]?D("102",c):void 0,pa[c]=d,b=!0)}b&&qa()}
var Ca=Object.freeze({plugins:ra,eventNameDispatchConfigs:sa,registrationNameModules:ua,registrationNameDependencies:va,possibleRegistrationNames:null,injectEventPluginOrder:wa,injectEventPluginsByName:xa}),Da=null,Ea=null,Fa=null;function Ga(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Fa(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Ha(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ia(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ja=null;
function Ka(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Ga(a,b,c[e],d[e]);else c&&Ga(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function La(a){return Ka(a,!0)}function Ma(a){return Ka(a,!1)}var Na={injectEventPluginOrder:wa,injectEventPluginsByName:xa};
function Oa(a,b){var c=a.stateNode;if(!c)return null;var d=Da(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
return c}function Pa(a,b){null!==a&&(Ja=Ha(Ja,a));a=Ja;Ja=null;a&&(b?Ia(a,La):Ia(a,Ma),Ja?D("95"):void 0,E.rethrowCaughtError())}function Qa(a,b,c,d){for(var e=null,f=0;f<ra.length;f++){var h=ra[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ha(e,h))}Pa(e,!1)}var Ra=Object.freeze({injection:Na,getListener:Oa,runEventsInBatch:Pa,runExtractedEventsInBatch:Qa}),Sa=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Sa,Ta="__reactEventHandlers$"+Sa;
function Ua(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Va(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Xa(a){return a[Ta]||null}var bb=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ua,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Va,getFiberCurrentPropsFromNode:Xa,updateFiberProps:function(a,b){a[Ta]=b}});
function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function cb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function db(a,b,c){if(b=Oa(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a)}function eb(a){a&&a.dispatchConfig.phasedRegistrationNames&&cb(a._targetInst,db,a)}
function fb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;cb(b,db,a)}}function gb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Oa(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a))}function hb(a){a&&a.dispatchConfig.registrationName&&gb(a._targetInst,null,a)}function ib(a){Ia(a,eb)}
function jb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)gb(e[d],"bubbled",a);for(a=c.length;0<a--;)gb(c[a],"captured",b)}
var kb=Object.freeze({accumulateTwoPhaseDispatches:ib,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ia(a,fb)},accumulateEnterLeaveDispatches:jb,accumulateDirectDispatches:function(a){Ia(a,hb)}}),lb=null;function mb(){!lb&&m.canUseDOM&&(lb="textContent"in document.documentElement?"textContent":"innerText");return lb}var M={_root:null,_startText:null,_fallbackText:null};
function nb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=ob(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function ob(){return"value"in M._root?M._root.value:M._root[mb()]}
var pb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),qb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<pb.length;a++)this[pb[a]]=null}});N.Interface=qb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;rb(c);return c};rb(N);
function sb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function tb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function rb(a){a.eventPool=[];a.getPooled=sb;a.release=tb}var ub=N.extend({data:null}),vb=N.extend({data:null}),wb=[9,13,27,32],xb=m.canUseDOM&&"CompositionEvent"in window,yb=null;m.canUseDOM&&"documentMode"in document&&(yb=document.documentMode);
var zb=m.canUseDOM&&"TextEvent"in window&&!yb,Ab=m.canUseDOM&&(!xb||yb&&8<yb&&11>=yb),Bb=String.fromCharCode(32),Kb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Lb=!1;
function Mb(a,b){switch(a){case "topKeyUp":return-1!==wb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Nb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Ob=!1;function Pb(a,b){switch(a){case "topCompositionEnd":return Nb(b);case "topKeyPress":if(32!==b.which)return null;Lb=!0;return Bb;case "topTextInput":return a=b.data,a===Bb&&Lb?null:a;default:return null}}
function Qb(a,b){if(Ob)return"topCompositionEnd"===a||!xb&&Mb(a,b)?(a=nb(),M._root=null,M._startText=null,M._fallbackText=null,Ob=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return Ab?null:b.data;default:return null}}
var Rb={eventTypes:Kb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(xb)b:{switch(a){case "topCompositionStart":e=Kb.compositionStart;break b;case "topCompositionEnd":e=Kb.compositionEnd;break b;case "topCompositionUpdate":e=Kb.compositionUpdate;break b}e=void 0}else Ob?Mb(a,c)&&(e=Kb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Kb.compositionStart);e?(Ab&&(Ob||e!==Kb.compositionStart?e===Kb.compositionEnd&&Ob&&(f=nb()):(M._root=d,M._startText=ob(),Ob=!0)),e=ub.getPooled(e,
b,c,d),f?e.data=f:(f=Nb(c),null!==f&&(e.data=f)),ib(e),f=e):f=null;(a=zb?Pb(a,c):Qb(a,c))?(b=vb.getPooled(Kb.beforeInput,b,c,d),b.data=a,ib(b)):b=null;return null===f?b:null===b?f:[f,b]}},Sb=null,Tb={injectFiberControlledHostComponent:function(a){Sb=a}},Ub=null,Vb=null;function Wb(a){if(a=Ea(a)){Sb&&"function"===typeof Sb.restoreControlledState?void 0:D("194");var b=Da(a.stateNode);Sb.restoreControlledState(a.stateNode,a.type,b)}}function Xb(a){Ub?Vb?Vb.push(a):Vb=[a]:Ub=a}
function Yb(){return null!==Ub||null!==Vb}function Zb(){if(Ub){var a=Ub,b=Vb;Vb=Ub=null;Wb(a);if(b)for(a=0;a<b.length;a++)Wb(b[a])}}var $b=Object.freeze({injection:Tb,enqueueStateRestore:Xb,needsStateRestore:Yb,restoreStateIfNeeded:Zb});function ac(a,b){return a(b)}function bc(a,b,c){return a(b,c)}function cc(){}var dc=!1;function ec(a,b){if(dc)return a(b);dc=!0;try{return ac(a,b)}finally{dc=!1,Yb()&&(cc(),Zb())}}
var fc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function gc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!fc[a.type]:"textarea"===b?!0:!1}function hc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function ic(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function jc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function kc(a){var b=jc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function lc(a){a._valueTracker||(a._valueTracker=kc(a))}function mc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=jc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var nc=ea.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],oc=O?Symbol["for"]("react.element"):60103,pc=O?Symbol["for"]("react.call"):60104,qc=O?Symbol["for"]("react.return"):60105,rc=O?Symbol["for"]("react.portal"):60106,sc=O?Symbol["for"]("react.fragment"):60107,tc=O?Symbol["for"]("react.strict_mode"):60108,uc=O?Symbol["for"]("react.provider"):60109,vc=O?Symbol["for"]("react.context"):60110,wc=O?Symbol["for"]("react.async_mode"):60111,
xc=O?Symbol["for"]("react.forward_ref"):60112,yc="function"===typeof Symbol&&Symbol.iterator;function zc(a){if(null===a||"undefined"===typeof a)return null;a=yc&&a[yc]||a["@@iterator"];return"function"===typeof a?a:null}
function Ac(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case sc:return"ReactFragment";case rc:return"ReactPortal";case pc:return"ReactCall";case qc:return"ReactReturn"}if("object"===typeof a&&null!==a)switch(a.$$typeof){case xc:return a=a.render.displayName||a.render.name||"",""!==a?"ForwardRef("+a+")":"ForwardRef"}return null}
function Bc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=Ac(a);var f=null;c&&(f=Ac(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
var Cc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Dc={},Ec={};function Fc(a){if(Ec.hasOwnProperty(a))return!0;if(Dc.hasOwnProperty(a))return!1;if(Cc.test(a))return Ec[a]=!0;Dc[a]=!0;return!1}
function Gc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Hc(a,b,c,d){if(null===b||"undefined"===typeof b||Gc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Sc=/[\-:]([a-z])/g;function Tc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Sc,
Tc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
function Uc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Hc(b,c,e,d)&&(c=null),d||null===e?Fc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Vc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Xc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Yc(a,b){b=b.checked;null!=b&&Uc(a,"checked",b,!1)}
function Zc(a,b){Yc(a,b);var c=Xc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?$c(a,b.type,c):b.hasOwnProperty("defaultValue")&&$c(a,b.type,Xc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function ad(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function $c(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Xc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var bd={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function cd(a,b,c){a=N.getPooled(bd.change,a,b,c);a.type="change";Xb(c);ib(a);return a}var dd=null,ed=null;function fd(a){Pa(a,!1)}
function gd(a){var b=Va(a);if(mc(b))return a}function hd(a,b){if("topChange"===a)return b}var id=!1;m.canUseDOM&&(id=ic("input")&&(!document.documentMode||9<document.documentMode));function jd(){dd&&(dd.detachEvent("onpropertychange",kd),ed=dd=null)}function kd(a){"value"===a.propertyName&&gd(ed)&&(a=cd(ed,a,hc(a)),ec(fd,a))}function ld(a,b,c){"topFocus"===a?(jd(),dd=b,ed=c,dd.attachEvent("onpropertychange",kd)):"topBlur"===a&&jd()}
function md(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return gd(ed)}function nd(a,b){if("topClick"===a)return gd(b)}function od(a,b){if("topInput"===a||"topChange"===a)return gd(b)}
var pd={eventTypes:bd,_isInputEventSupported:id,extractEvents:function(a,b,c,d){var e=b?Va(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=hd:gc(e)?id?f=od:(f=md,h=ld):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=nd);if(f&&(f=f(a,b)))return cd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&$c(e,"number",e.value)}},qd=N.extend({view:null,
detail:null}),rd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function sd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=rd[a])?!!b[a]:!1}function td(){return sd}
var ud=qd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:td,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),vd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},wd={eventTypes:vd,extractEvents:function(a,
b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ua(b):null):a=null;if(a===b)return null;var f=null==a?e:Va(a);e=null==b?e:Va(b);var h=ud.getPooled(vd.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=ud.getPooled(vd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
f;jb(h,c,a,b);return[h,c]}};function xd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function yd(a){return(a=a._reactInternalFiber)?2===xd(a):!1}function zd(a){2!==xd(a)?D("188"):void 0}
function Ad(a){var b=a.alternate;if(!b)return b=xd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return zd(e),a;if(h===d)return zd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Bd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function Cd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Dd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Ed=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Fd=qd.extend({relatedTarget:null});
function Gd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Hd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Id={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Jd=qd.extend({key:function(a){if(a.key){var b=Hd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Gd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Id[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:td,charCode:function(a){return"keypress"===
a.type?Gd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Gd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Kd=ud.extend({dataTransfer:null}),Ld=qd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:td}),Md=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Nd=ud.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Od={},Pd={};function Qd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Od[a]=b;Pd[c]=b}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Qd(a,!0)});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Qd(a,!1)});
var Rd={eventTypes:Od,isInteractiveTopLevelEventType:function(a){a=Pd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Pd[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Gd(c))return null;case "topKeyDown":case "topKeyUp":a=Jd;break;case "topBlur":case "topFocus":a=Fd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
ud;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Kd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Ld;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Dd;break;case "topTransitionEnd":a=Md;break;case "topScroll":a=qd;break;case "topWheel":a=Nd;break;case "topCopy":case "topCut":case "topPaste":a=Ed;break;default:a=
N}b=a.getPooled(e,b,c,d);ib(b);return b}},Sd=Rd.isInteractiveTopLevelEventType,Td=[];function Ud(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ua(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Qa(a.topLevelType,b,a.nativeEvent,hc(a.nativeEvent))}var Vd=!0;function Wd(a){Vd=!!a}
function W(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!1)}function Zd(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!0)}function Xd(a,b){bc(Yd,a,b)}
function Yd(a,b){if(Vd){var c=hc(b);c=Ua(c);null!==c&&"number"===typeof c.tag&&2!==xd(c)&&(c=null);if(Td.length){var d=Td.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{ec(Ud,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Td.length&&Td.push(a)}}}
var $d=Object.freeze({get _enabled(){return Vd},setEnabled:Wd,isEnabled:function(){return Vd},trapBubbledEvent:W,trapCapturedEvent:Zd,dispatchEvent:Yd});function ae(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var be={animationend:ae("Animation","AnimationEnd"),animationiteration:ae("Animation","AnimationIteration"),animationstart:ae("Animation","AnimationStart"),transitionend:ae("Transition","TransitionEnd")},ce={},de={};m.canUseDOM&&(de=document.createElement("div").style,"AnimationEvent"in window||(delete be.animationend.animation,delete be.animationiteration.animation,delete be.animationstart.animation),"TransitionEvent"in window||delete be.transitionend.transition);
function ee(a){if(ce[a])return ce[a];if(!be[a])return a;var b=be[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in de)return ce[a]=b[c];return a}
var fe={topAnimationEnd:ee("animationend"),topAnimationIteration:ee("animationiteration"),topAnimationStart:ee("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:ee("transitionend"),topWheel:"wheel"},ge={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},he={},ie=0,je="_reactListenersID"+(""+Math.random()).slice(2);function ke(a){Object.prototype.hasOwnProperty.call(a,je)||(a[je]=ie++,he[a[je]]={});return he[a[je]]}function le(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function me(a,b){var c=le(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=le(c)}}function ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var oe=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,pe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},qe=null,re=null,se=null,te=!1;
function ue(a,b){if(te||null==qe||qe!==fa())return null;var c=qe;"selectionStart"in c&&ne(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return se&&ha(se,c)?null:(se=c,a=N.getPooled(pe.select,re,a,b),a.type="select",a.target=qe,ib(a),a)}
var ve={eventTypes:pe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=ke(e);f=va.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Va(b):window;switch(a){case "topFocus":if(gc(e)||"true"===e.contentEditable)qe=e,re=b,se=null;break;case "topBlur":se=re=qe=null;break;case "topMouseDown":te=!0;break;case "topContextMenu":case "topMouseUp":return te=!1,ue(c,d);case "topSelectionChange":if(oe)break;
case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Na.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Da=bb.getFiberCurrentPropsFromNode;Ea=bb.getInstanceFromNode;Fa=bb.getNodeFromInstance;Na.injectEventPluginsByName({SimpleEventPlugin:Rd,EnterLeaveEventPlugin:wd,ChangeEventPlugin:pd,SelectEventPlugin:ve,BeforeInputEventPlugin:Rb});
function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function ze(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Ae(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case sc:return Be(a.children,b,c,e);case wc:f=11;b|=3;break;case tc:f=11;b|=2;break;case pc:f=7;break;case qc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case uc:f=13;break;case vc:f=12;break;case xc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Be(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Ce(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function De(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var Ee=null,Fe=null;
function Ge(a){return function(b){try{return a(b)}catch(c){}}}function He(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ee=Ge(function(a){return b.onCommitFiberRoot(c,a)});Fe=Ge(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ie(a){"function"===typeof Ee&&Ee(a)}function Je(a){"function"===typeof Fe&&Fe(a)}new Set;
function Ke(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Le(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Me=void 0,Ne=void 0;
function Oe(a){Me=Ne=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Ke(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Ke(null))):a=null;Me=c;Ne=a!==c?a:null}function Pe(a,b){Oe(a);a=Me;var c=Ne;null===c?Le(a,b):null===a.last||null===c.last?(Le(a,b),Le(c,b)):(Le(a,b),c.last=b)}function Qe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Re(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Qe(g,d,a,e),h=!0;else if(v=Qe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
return a}function Se(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
function Te(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ha(b,c)||!ha(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,z=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:yd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Pe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
constructClassInstance:function(a,b){var c=a.type,d=p(a),e=z(a),f=e?l(a,d):ka;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ka;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Re(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,z=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||z!==q)&&g(a,n,r,q);z=a.memoizedState;b=null!==a.updateQueue?Re(null,a,a.updateQueue,n,r,b):z;var u=void 0;h!==r&&(u=k(a,n,r,b));if(null!==u&&void 0!==u){b=null===b||void 0===b?u:A({},b,u);var t=a.updateQueue;
null!==t&&(t.baseState=A({},t.baseState,u))}if(!(h!==r||z!==b||B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,z,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=
4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,u=p(b);u=l(b,u);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||
(h!==r||q!==u)&&g(b,x,r,u);q=b.memoizedState;c=null!==b.updateQueue?Re(a,b,b.updateQueue,x,r,c):q;var t=void 0;h!==r&&(t=k(b,x,r,c));if(null!==t&&void 0!==t){c=null===c||void 0===c?t:A({},c,t);var y=b.updateQueue;null!==y&&(y.baseState=A({},y.baseState,t))}if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=2048),!1;(t=f(b,h,r,q,c,u))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,u),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,u)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=u;return t}}}var Ue=Array.isArray;
function Ve(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ka?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
function We(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Xe(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ve(a,b,c),d["return"]=a,d;d=Ae(c,a.mode,d);d.ref=Ve(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
De(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Be(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ce(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case oc:return c=Ae(b,a.mode,c),c.ref=Ve(a,null,b),c["return"]=a,c;case rc:return b=De(b,a.mode,c),b["return"]=a,b}if(Ue(b)||zc(b))return b=Be(b,
a.mode,c,null),b["return"]=a,b;We(a,b)}return null}function z(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case oc:return c.key===e?c.type===sc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case rc:return c.key===e?v(a,b,c,d):null}if(Ue(c)||zc(c))return null!==e?null:l(a,b,c,d,null);We(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case oc:return a=a.get(null===d.key?c:d.key)||null,d.type===sc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case rc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Ue(d)||zc(d))return a=a.get(c)||null,l(b,a,d,e,null);We(b,d)}return null}function r(e,l,g,h){for(var r=null,k=null,q=l,u=l=0,t=null;null!==q&&u<g.length;u++){q.index>u?(t=q,q=null):t=q.sibling;var n=z(e,q,g[u],h);if(null===n){null===q&&(q=t);break}a&&q&&null===
n.alternate&&b(e,q);l=f(n,l,u);null===k?r=n:k.sibling=n;k=n;q=t}if(u===g.length)return c(e,q),r;if(null===q){for(;u<g.length;u++)if(q=p(e,g[u],h))l=f(q,l,u),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);u<g.length;u++)if(t=B(q,e,u,g[u],h)){if(a&&null!==t.alternate)q["delete"](null===t.key?u:t.key);l=f(t,l,u);null===k?r=t:k.sibling=t;k=t}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,l,g,h){var r=zc(g);"function"!==typeof r?D("150"):void 0;g=r.call(g);null==g?D("151"):void 0;for(var k=
r=null,q=l,u=l=0,t=null,n=g.next();null!==q&&!n.done;u++,n=g.next()){q.index>u?(t=q,q=null):t=q.sibling;var H=z(e,q,n.value,h);if(null===H){q||(q=t);break}a&&q&&null===H.alternate&&b(e,q);l=f(H,l,u);null===k?r=H:k.sibling=H;k=H;q=t}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;u++,n=g.next())n=p(e,n.value,h),null!==n&&(l=f(n,l,u),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;u++,n=g.next())if(n=B(q,e,u,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?u:n.key);
l=f(n,l,u);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,l){"object"===typeof f&&null!==f&&f.type===sc&&null===f.key&&(f=f.props.children);var g="object"===typeof f&&null!==f;if(g)switch(f.$$typeof){case oc:a:{var k=f.key;for(g=d;null!==g;){if(g.key===k)if(10===g.tag?f.type===sc:g.type===f.type){c(a,g.sibling);d=e(g,f.type===sc?f.props.children:f.props,l);d.ref=Ve(a,g,f);d["return"]=a;a=d;break a}else{c(a,g);break}else b(a,g);g=g.sibling}f.type===
sc?(d=Be(f.props.children,a.mode,l,f.key),d["return"]=a,a=d):(l=Ae(f,a.mode,l),l.ref=Ve(a,d,f),l["return"]=a,a=l)}return h(a);case rc:a:{for(g=f.key;null!==d;){if(d.key===g)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],l);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=De(f,a.mode,l);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
6===d.tag?(c(a,d.sibling),d=e(d,f,l),d["return"]=a,a=d):(c(a,d),d=Ce(f,a.mode,l),d["return"]=a,a=d),h(a);if(Ue(f))return r(a,d,f,l);if(zc(f))return Q(a,d,f,l);g&&We(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:l=a.type,D("152",l.displayName||l.name||"Component")}return c(a,d)}}var Ye=Xe(!0),Ze=Xe(!1);
function $e(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ze(b,null,c,d):Ye(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&y(b,!1),r(a,b);c=b.stateNode;nc.current=b;var l=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,l,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&y(b,!0);return b.child}function p(a){var b=a.stateNode;
b.pendingContext?t(a,b.pendingContext,b.pendingContext!==b.context):b.context&&t(a,b.context,!1);Y(a,b.containerInfo)}function z(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var l=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==l&&(0===l.expirationTime||l.expirationTime>d)&&(l.expirationTime=d);else if(null!==l&&(0===l.expirationTime||l.expirationTime>d))l.expirationTime=
d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
r(a,b);l=0}else{var h=f.value;if(h===l&&(0!==h||1/h===1/l)||h!==h&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else z(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ze(a,a.pendingProps,a.expirationTime);
b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ze(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,u=c.pushContextProvider,t=c.pushTopLevelContextObject,y=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Cb=e.tryToClaimNextHydratableInstance;
a=Te(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Db=a.mountClassInstance,Mc=a.resumeMountClassInstance,Eb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:u(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=u(b),Jc(b,d),Db(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=u(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Db(b,c),d=!0):d=Mc(b,c):d=Eb(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Re(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ze(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Cb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Cb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ze(b,b.stateNode,d,c):Ye(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Ye(b,null,e,c):g(a,b,e),b.memoizedProps=
e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:a:{d=b.type;f=b.pendingProps;h=b.memoizedProps;e=d._currentValue;var t=d._changedBits;if(q()||0!==t||h!==f){b.memoizedProps=
f;var k=f.unstable_observedBits;if(void 0===k||null===k)k=1073741823;b.stateNode=k;if(0!==(t&k))z(b,d,t,c);else if(h===f){a=r(a,b);break a}c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b)}return a;default:D("156")}}}}
function af(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,z=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,u=void 0,t=void 0;a.mutation?(q=function(){},u=function(a,b,c){(b.updateQueue=
c)&&f(b)},t=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=z();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,y=r();H=l(H,e,p,d,c,y);u(a,b,H,e,p,d,c,y);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(y=b.child;null!==y;){if(5===y.tag||6===y.tag)k(p,y.stateNode);else if(4!==y.tag&&null!==y.child){y.child["return"]=y;y=y.child;continue}if(y===b)break;
for(;null===y.sibling;){if(null===y["return"]||y["return"]===b)break a;y=y["return"]}y.sibling["return"]=y["return"];y=y.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)t(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=z();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Ye(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
function bf(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Bc(b)};do{switch(a.tag){case 3:Oe(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Oe(a);c=a.updateQueue;var d=c.capturedValues;null===d?
c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
function cf(a,b){var c=b.source;null===b.stack&&Bc(c);null!==c&&Ac(c);b=b.value;null!==a&&2===a.tag&&Ac(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
function df(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(t){b(a,t)}else c.current=null}function h(a){"function"===typeof Je&&Je(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(t){b(a,t)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var z=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Se(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Se(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
4&&z(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var l=d.value,g=d.stack;cf(a,d);b.componentDidCatch(l,{componentStack:null!==g?g:""})}break;
case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],cf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var ef={};
function ff(a,b){function c(a){a===ef?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(ef),k=a(ef),v=a(ef);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);f(k,a,a);f(g,ef,a);b=e(b);h(g,a);f(g,b,a)},pushHostContext:function(a){var b=
c(v.current),e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
function gf(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,z=null,B=!1;return{enterHydrationState:function(a){z=
k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){z=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=z;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,z)}p=a;z=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=z;c;)b(a,c),c=g(c);d(a);z=p?g(a.stateNode):null;return!0}}}
function hf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",Ac(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ka),k=e(!1),v=ka;return{getUnmaskedContext:function(a){return c(a)?
v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ka;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ka;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
xd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
function jf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type._context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type._context;a._currentValue=c;a._changedBits=b}}}
function kf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
function lf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Ya=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Cb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));nc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Ya||null===I)b(),Ya=a,Z=c,I=ze(Ya.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Bc(a)};Pe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Za?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Za?1:Z:a.mode&1?za?10*(((l()+15)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Za&&Ya===d||B(d,c);Fb>xg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ye=Ic()-Pc;return yg=(ye/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function z(a){if(0!==Gb){if(a>Gb)return;mg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():z(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){$a=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==$a&&(Gb=0,Qc=-1);0!==P&&z(P);$a=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(wg){Ba||(Ba=!0,Jb=wg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
0;return}a.finishedWork=null;Za=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();nc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Db(w.alternate,w),w=w.nextEffect}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==
w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Eb(w);w.effectTag&=-3;break;case 6:Eb(w);w.effectTag&=-3;we(w.alternate,w);break;case 4:we(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch(ab){p=!0,n=ab}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Za=!1;"function"===typeof Ie&&Ie(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===$a||$a.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var u=kf(),t=ff(a,u),y=hf(u);u=jf(u);var H=gf(a),
Wa=$e(a,t,y,u,H,v,k).beginWork,Cb=af(a,t,y,u,H).completeWork;t=bf(t,y,u,v,c);var Jc=t.throwException,Kc=t.unwindWork,Lc=t.unwindInterruptedWork;t=df(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Db=t.commitBeforeMutationLifeCycles,Mc=t.commitResetTextContent,Eb=t.commitPlacement,gg=t.commitDeletion,we=t.commitWork,hg=t.commitLifeCycles,ig=t.commitErrorLogging,jg=t.commitAttachRef,kg=t.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,mg=a.cancelDeferredCallback,zg=a.prepareForCommit,
Ag=a.resetAfterCommit,Pc=Ic(),yg=2,ye=Pc,Rc=0,ia=0,ca=!1,I=null,Ya=null,Z=0,w=null,Za=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,$a=null,J=!1,Hb=!1,za=!1,Aa=null,xg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:y}}
function mf(a){function b(a,b,c,d,e,h){d=b.current;if(c){c=c._reactInternalFiber;var l=g(c);c=k(c)?v(c,l):l}else c=ka;null===b.context?b.context=c:b.pendingContext=c;b=h;Pe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});f(d,e);return e}var c=a.getPublicInstance;a=lf(a);var d=a.recalculateCurrentTime,e=a.computeExpirationForFiber,f=a.scheduleWork,h=a.legacyContext,g=h.findCurrentUnmaskedContext,k=h.isContextProvider,v=
h.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,f,h){var g=c.current,k=d();g=e(g);return b(a,c,f,k,g,h)},updateContainerAtExpirationTime:function(a,c,e,f,g){var h=d();return b(a,c,e,h,f,g)},flushRoot:a.flushRoot,
requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},
findHostInstance:function(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?D("188"):D("268",Object.keys(a)));a=Bd(b);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=Cd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return He(A({},a,{findHostInstanceByFiber:function(a){a=Bd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}
var nf=Object.freeze({default:mf}),of=nf&&mf||nf,pf=of["default"]?of["default"]:of;function qf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:rc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var rf="object"===typeof performance&&"function"===typeof performance.now,sf=void 0;sf=rf?function(){return performance.now()}:function(){return Date.now()};var tf=void 0,uf=void 0;
if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var vf=null,wf=!1,xf=-1,yf=!1,zf=0,Af=33,Bf=33,Cf=void 0;Cf=rf?{didTimeout:!1,timeRemaining:function(){var a=zf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=zf-Date.now();return 0<a?a:0}};var Df="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Df){wf=!1;a=sf();if(0>=zf-a)if(-1!==
xf&&xf<=a)Cf.didTimeout=!0;else{yf||(yf=!0,requestAnimationFrame(Ef));return}else Cf.didTimeout=!1;xf=-1;a=vf;vf=null;null!==a&&a(Cf)}},!1);var Ef=function(a){yf=!1;var b=a-zf+Bf;b<Bf&&Af<Bf?(8>b&&(b=8),Bf=b<Af?Af:b):Af=b;zf=a+Bf;wf||(wf=!0,window.postMessage(Df,"*"))};tf=function(a,b){vf=a;null!=b&&"number"===typeof b.timeout&&(xf=sf()+b.timeout);yf||(yf=!0,requestAnimationFrame(Ef));return 0};uf=function(){vf=null;wf=!1;xf=-1}}else tf=window.requestIdleCallback,uf=window.cancelIdleCallback;else tf=
function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},uf=function(a){clearTimeout(a)};function Ff(a){var b="";ea.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Gf(a,b){a=A({children:void 0},b);if(b=Ff(b.children))a.children=b;return a}
function Hf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function If(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Jf(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Kf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Lf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Mf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Nf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Of(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Pf(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Of(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Qf=void 0,Rf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Nf.svg||"innerHTML"in a)a.innerHTML=b;else{Qf=Qf||document.createElement("div");Qf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Qf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Sf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Tf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Uf=["Webkit","ms","Moz","O"];Object.keys(Tf).forEach(function(a){Uf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Tf[b]=Tf[a]})});
function Vf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Tf.hasOwnProperty(e)&&Tf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Wf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Xf(a,b,c){b&&(Wf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
function Yf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Zf=C.thatReturns("");
function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=ke(a);b=va[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Zd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Zd("topFocus","focus",a),Zd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(ic("cancel",!0)&&Zd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(ic("close",!0)&&Zd("topClose","close",a),c.topClose=!0):fe.hasOwnProperty(e)&&W(e,fe[e],a),c[e]=!0)}}
function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Nf.html&&(d=Of(a));d===Nf.html?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function cg(a,b,c,d){var e=Yf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Wc(a,c);f=Vc(a,c);W("topInvalid",
"invalid",a);$f(d,"onChange");break;case "option":f=Gf(a,c);break;case "select":If(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Kf(a,c);f=Jf(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Xf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Vf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Rf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Sf(a,k):"number"===typeof k&&
Sf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ua.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Uc(a,g,k,e))}switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Hf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Hf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Vc(a,c);d=Vc(a,d);f=[];break;case "option":c=Gf(a,c);d=Gf(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=Jf(a,c);d=Jf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Xf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ua.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ua.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Yc(a,e);Yf(c,d);d=Yf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Vf(a,g,Zf):"dangerouslySetInnerHTML"===h?Rf(a,g):"children"===h?Sf(a,g):Uc(a,h,g,d)}switch(c){case "input":Zc(a,e);break;case "textarea":Lf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Hf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Hf(a,!!e.multiple,e.defaultValue,!0):Hf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Wc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":If(a,
c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Kf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Xf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ua.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function ng(a,b){return a.nodeValue!==b}
var og=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:ng,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Zc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Xa(d);e?void 0:D("90");mc(d);Zc(d,e)}}}break;case "textarea":Lf(a,c);break;case "select":b=c.value,null!=b&&Hf(a,!!c.multiple,b,!1)}}});Tb.injectFiberControlledHostComponent(og);var pg=null,qg=null;
function rg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}rg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new sg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
rg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
rg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};rg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function sg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}sg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
sg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function tg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}tg.prototype.render=function(a,b){var c=this._internalRoot,d=new sg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
tg.prototype.unmount=function(a){var b=this._internalRoot,c=new sg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};tg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new sg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
tg.prototype.createBatch=function(){var a=new rg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ug(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function vg(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
var X=pf({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Pf(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Pf(a,b)}return a},getChildHostContext:function(a,b){return Pf(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){pg=Vd;var a=fa();if(ne(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var z;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(z=l.firstChild))break;p=l;l=z}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(z=l.nextSibling))break;l=p;p=l.parentNode}l=z}b=-1===h||-1===g?null:
{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;qg={focusedElem:a,selectionRange:b};Wd(!1)},resetAfterCommit:function(){var a=qg,b=fa(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ja(document.documentElement,c)){if(ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[mb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=me(c,a);var f=me(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
a.element.scrollTop=a.top}qg=null;Wd(pg);pg=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Ta]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return vg(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:sf,mutation:{commitMount:function(a,b,c){vg(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Ta]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Sf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Ta]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return ng(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:tf,cancelDeferredCallback:uf}),Cg=X;ac=Cg.batchedUpdates;bc=Cg.interactiveUpdates;cc=Cg.flushInteractiveUpdates;
function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new tg(a,!1,b)}
function Eg(a,b,c,d,e){ug(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ug(b)?void 0:D("200");return qf(a,b,null,c)}
var Gg={createPortal:Fg,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:X.findHostInstance(a)},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){ug(a)?void 0:D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=
null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ra,EventPluginRegistry:Ca,EventPropagators:kb,ReactControlledComponent:$b,ReactDOMComponentTree:bb,ReactDOMEventListener:$d},unstable_createRoot:function(a,b){return new tg(a,!0,null!=b&&!0===b.hydrate)}};
X.injectIntoDevTools({findFiberByHostInstance:Ua,bundleType:0,version:"16.3.2",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(320);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(321);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(324);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(62), __webpack_require__(323)(module)))

/***/ }),
/* 323 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(97);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(47);
var invariant = __webpack_require__(46);
var ReactPropTypesSecret = __webpack_require__(327);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(343);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(191);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(340);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(337);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(335);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(62)))

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(193);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(339);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(191);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(192);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(344);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(97);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(100);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(47);
var invariant = __webpack_require__(46);
var ReactPropTypesSecret = __webpack_require__(347);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(98);

var _PathUtils = __webpack_require__(50);

var _createTransitionManager = __webpack_require__(99);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(47);
var invariant = __webpack_require__(46);
var ReactPropTypesSecret = __webpack_require__(350);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(100);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(16);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(98);

var _PathUtils = __webpack_require__(50);

var _createTransitionManager = __webpack_require__(99);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(354);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(101);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(14);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(50);

var _LocationUtils = __webpack_require__(98);

var _createTransitionManager = __webpack_require__(99);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(197);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(358)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 358 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(360);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(362);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(363);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(364);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(365);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(366);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(68);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(51);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(200);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(200);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(103);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(368);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(101);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(370);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(102);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(102);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(373);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(199);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_home__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_forum__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_mark__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_page__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_search__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_NavBar__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_FooterBar__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_product__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_apply__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_apply_plan__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_appliSucc__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_help__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__containers_community__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__containers_about__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__containers_redirect__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__containers_brand__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__containers_submission__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__containers_productCenter__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__containers_productDetails__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__containers_numberSearch__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__containers_numberSearch_searchResult__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__containers_numberCommon__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__containers_numberOptions_guidePage__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__containers_numberOptions_numberReport__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__containers_numberOptions_numberAppeal__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__containers_numberOptions_successPage__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__containers_buy__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__containers_buy_activity__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__containers_activity__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__containers_activity_activityAddress__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__containers_activitySu__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__containers_activityResume__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__containers_fileCheck__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__containers_securityPlan__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__containers_product_temperature__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__containers_apply_app__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__containers_login__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__containers_inspectionApply__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__containers_bugSearch__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__containers_product_page_website_sescurity__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__asset_less_base_less__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__asset_less_base_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__asset_less_base_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__actions_homeAction__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_conpin__ = __webpack_require__(804);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: WangZhuang@baidu.com
  * @Date: 2023-01-10 17:48:53
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2023-09-06 16:18:07
  * @FilePath: /m-anquan-baidu-com/src/App.js
  * @Description: App
  */ // import SpringerPlan from './containers/springerPlan';
// import SpringerPlanAgreement from './containers/springerPlan/agreement';
// import SpringerPlanApply from './containers/springerPlan/apply.js';
function isRouter(extraRouter) {
  var routers = ['forum', 'brand', 'submission', 'productCenter', 'productDetail', '/haoma/search'];if (extraRouter && extraRouter.length > 0) {
    routers = [].concat(routers, extraRouter);
  }var length = routers.length;for (var i = 0; i < length; i++) {
    if (location.pathname.indexOf(routers[i]) !== -1) {
      return true;
    }
  }return false;
}var App = (_temp = _class = function (_Component) {
  _inherits(App, _Component);function App(props, context) {
    _classCallCheck(this, App);var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props, context));_this.state = { conMinHeight: 0 };return _this;
  }_createClass(App, [{ key: 'componentDidMount', value: function componentDidMount() {
      this.props.fetchUserLogin();this.props.fetchNavigationList();this.setState({ conMinHeight: window.innerHeight - this.footer.offsetHeight });
    } }, { key: 'render', value: function render() {
      var _this2 = this;var _props = this.props,
          userLoginstate = _props.userLoginstate,
          navigationList = _props.navigationList,
          productId = _props.productId;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, !isRouter() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_NavBar__["a" /* default */], { userInfo: userLoginstate, navList: navigationList.itemlist, changeNavIndex: this.props.fetchNavListIndex, productId: productId }) : '', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { minHeight: this.state.conMinHeight + 'px' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Switch */], null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { exact: true, path: '/', component: __WEBPACK_IMPORTED_MODULE_4__containers_home__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/home', component: __WEBPACK_IMPORTED_MODULE_4__containers_home__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { exact: true, path: '/product/ai/temperature', component: __WEBPACK_IMPORTED_MODULE_38__containers_product_temperature__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/product/:id', component: __WEBPACK_IMPORTED_MODULE_11__containers_product__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/apply/:Iid?', component: __WEBPACK_IMPORTED_MODULE_12__containers_apply__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/apply-plan', component: __WEBPACK_IMPORTED_MODULE_13__containers_apply_plan__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/apply-succ', component: __WEBPACK_IMPORTED_MODULE_14__containers_appliSucc__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/help', component: __WEBPACK_IMPORTED_MODULE_15__containers_help__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/community/:urlId/:fileType?/:typeid?', component: __WEBPACK_IMPORTED_MODULE_16__containers_community__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { exact: true, path: '/forum', component: __WEBPACK_IMPORTED_MODULE_5__containers_forum__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/forum/mark/:tagId?', component: __WEBPACK_IMPORTED_MODULE_6__containers_mark__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/forum/page/:aId?', component: __WEBPACK_IMPORTED_MODULE_7__containers_page__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/forum/search/:keywords?', component: __WEBPACK_IMPORTED_MODULE_8__containers_search__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/about/:type?', component: __WEBPACK_IMPORTED_MODULE_17__containers_about__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/brand', component: __WEBPACK_IMPORTED_MODULE_19__containers_brand__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/submission', component: __WEBPACK_IMPORTED_MODULE_20__containers_submission__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/productCenter', component: __WEBPACK_IMPORTED_MODULE_21__containers_productCenter__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/productDetail/:id', component: __WEBPACK_IMPORTED_MODULE_22__containers_productDetails__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/haoma/search/', component: __WEBPACK_IMPORTED_MODULE_23__containers_numberSearch__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/haoma/result/:keywords', component: __WEBPACK_IMPORTED_MODULE_24__containers_numberSearch_searchResult__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/haoma/common/:id', component: __WEBPACK_IMPORTED_MODULE_25__containers_numberCommon__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/haoma/guide', component: __WEBPACK_IMPORTED_MODULE_26__containers_numberOptions_guidePage__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/haoma/report', component: __WEBPACK_IMPORTED_MODULE_27__containers_numberOptions_numberReport__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/haoma/appeal/:type', component: __WEBPACK_IMPORTED_MODULE_28__containers_numberOptions_numberAppeal__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/haoma/success/:path/:type?/:selectType?', component: __WEBPACK_IMPORTED_MODULE_29__containers_numberOptions_successPage__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/buy', exact: true, component: __WEBPACK_IMPORTED_MODULE_30__containers_buy__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/activity/buy', exact: true, component: __WEBPACK_IMPORTED_MODULE_31__containers_buy_activity__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/activity/address', exact: true, component: __WEBPACK_IMPORTED_MODULE_33__containers_activity_activityAddress__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/activity/prize', exact: true, component: __WEBPACK_IMPORTED_MODULE_32__containers_activity__["b" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/activity/su', exact: true, component: __WEBPACK_IMPORTED_MODULE_34__containers_activitySu__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/activity/resume', exact: true, component: __WEBPACK_IMPORTED_MODULE_35__containers_activityResume__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/fileCheck/:type/:key', component: __WEBPACK_IMPORTED_MODULE_36__containers_fileCheck__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/security/plan', component: __WEBPACK_IMPORTED_MODULE_37__containers_securityPlan__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/apply-app', component: __WEBPACK_IMPORTED_MODULE_39__containers_apply_app__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/apply-inspection', component: __WEBPACK_IMPORTED_MODULE_41__containers_inspectionApply__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/login', exact: true, component: __WEBPACK_IMPORTED_MODULE_40__containers_login__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/bug_search', exact: true, component: __WEBPACK_IMPORTED_MODULE_42__containers_bugSearch__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { path: '/newsite/websitesec', exact: true, component: __WEBPACK_IMPORTED_MODULE_43__containers_product_page_website_sescurity__["a" /* default */] }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Route */], { component: __WEBPACK_IMPORTED_MODULE_18__containers_redirect__["a" /* default */] }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { ref: function ref(el) {
          return _this2.footer = el;
        } }, !isRouter(['/haoma/common', '/haoma/result']) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_FooterBar__["a" /* default */], null) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__components_conpin__["a" /* default */], null));
    } }]);return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { fetchUserLogin: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, fetchNavigationList: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, fetchNavListIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, userLoginstate: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, navigationList: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, productId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return { userLoginstate: state.userLoginstate, navigationList: state.navigationList, productId: state.productId };
}function mapDispatchToProps(dispatch) {
  return { fetchUserLogin: function fetchUserLogin() {
      return Object(__WEBPACK_IMPORTED_MODULE_45__actions_homeAction__["e" /* fetchUserLogin */])(dispatch);
    }, fetchNavigationList: function fetchNavigationList() {
      return Object(__WEBPACK_IMPORTED_MODULE_45__actions_homeAction__["d" /* fetchNavigationList */])(dispatch);
    }, fetchNavListIndex: function fetchNavListIndex(index) {
      return Object(__WEBPACK_IMPORTED_MODULE_45__actions_homeAction__["c" /* fetchNavListIndex */])(dispatch, index);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(App));

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_wing_blank_style_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_wing_blank_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_wing_blank_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_wing_blank__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_wing_blank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_wing_blank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_carousel_style_css__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_carousel_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_carousel_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_carousel__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_homeAction__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ListPro__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_less__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file home
  * @author wangzhuang
  * */var Home = (_temp = _class = function (_Component) {
  _inherits(Home, _Component);function Home(props, context) {
    _classCallCheck(this, Home);var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props, context));_this.isWeiXin = function () {
      // 判断是否是微信浏览器的函数
      var ua = window.navigator.userAgent.toLowerCase();return ua.indexOf('micromessenger') !== -1;
    };_this.state = { spuSkill0: true, planOff: false };return _this;
  }_createClass(Home, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        var search = location.search || '';location.href = '/' + search;
      }
    } }, { key: 'preventDefault', value: function preventDefault(e) {
      e.preventDefault();
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      this.props.fetchCmsapiHomepage();this.props.fetchArticleList();if (this.isIos()) {
        this.banner.addEventListener('touchmove', this.preventDefault, false);
      }
    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
      if (this.isIos()) {
        this.banner.removeEventListener('touchmove', this.preventDefault, false);
      }
    } }, { key: 'getUrl', value: function getUrl(item) {
      if (item.banner_type === '2') {
        return item.next_url;
      }if (item.next_url === 'pages/brand.html') {
        return 'brand';
      }return '/m/product/' + item.next_url;
    } }, { key: 'render', value: function render() {
      var _this2 = this;var _props = this.props,
          cmsapiHomepagea = _props.cmsapiHomepagea,
          articleList = _props.articleList;var planOff = this.state.planOff;var banner = [];var planList = [];var navData = [];if (!this.isEmptyobj(cmsapiHomepagea)) {
        banner = cmsapiHomepagea.itemlist.banner;planList = cmsapiHomepagea.itemlist.recommend_solution;navData = cmsapiHomepagea.itemlist.recommend_product;
      }return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'home' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-banner', ref: function ref(banner) {
          return _this2.banner = banner;
        } }, banner.length ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_wing_blank___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_carousel___default.a, { autoplay: false, autoplayInterval: 4000, infinite: true }, banner.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { onClick: function onClick(e) {
            if (item.next_url && item.next_url.indexOf('.apk') !== -1 && _this2.isWeiXin() || !item.next_url || item.next_url === '0') {
              e.preventDefault();
            }
          }, key: index, href: _this2.getUrl(item), style: { minHeight: '6.3rem' }, className: item.banner_type === '1' ? '' : 'activity' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'banner-shade', style: { backgroundImage: 'url(' + item.mobile_background_pic + ')' } }, item.banner_type === '1' ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: item.mobile_icon, alt: item.title }) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'bn-img' }), item.banner_type !== '2' ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', null, item.note) : null));
      }))) : ''), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-trait mui-flex' }, !this.isEmptyobj(cmsapiHomepagea) ? cmsapiHomepagea.itemlist.brand_story.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: item.next_url, className: 'spu-trait-item', key: index }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-trait-mod' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-trait-title' }, item.title), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-trait-des' }, item.note)));
      }) : null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-skill' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-skill-title' }, '\u4E13\u4E1A\u5B89\u5168\u56E2\u961F\u4E3A\u60A8\u6253\u9020\u4E0B\u4E00\u4EE3\u667A\u80FD\u5B89\u5168\u4EA7\u54C1'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-skill-hint' }, '\u4ECE\u884C\u4E3A\u5230\u60C5\u62A5\uFF0C\u8BA9\u5A01\u80C1\u63D0\u524D\u611F\u77E5 \u4ECE\u5355\u70B9\u5230\u5168\u5C40\uFF0C\u8BA9\u9632\u5FA1\u6EF4\u6C34\u4E0D\u6F0F \u4ECE\u53D1\u73B0\u5230\u5B9A\u4F4D\uFF0C\u8BA9\u9ED1\u5BA2\u65E0\u5904\u9041\u5F62 \u4ECE\u88AB\u52A8\u5230\u4E3B\u52A8\uFF0C\u8BA9\u54CD\u5E94\u53CD\u5BA2\u4E3A\u4E3B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-skill-list' }, navData.length ? navData.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: _this2.state['spuSkill' + index] ? 'spu-skill-box on' : 'spu-skill-box', key: index }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3', { onClick: function onClick() {
            _this2.setState(_defineProperty({}, 'spuSkill' + index, !_this2.state['spuSkill' + index]));
          } }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'skill-box-icon', style: { backgroundImage: 'url(' + item.mobile_navigation_icon + ')' } }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'skill-box-name' }, item.navigation_name), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'skill-box-more' })), _this2.state['spuSkill' + index] ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'skill-box-link', style: { backgroundImage: 'url(' + item.m_nav_bg_pic + ')' } }, item.child.map(function (item2, index2) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: '/m/product/' + item2.alias, key: index2 }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'skill-link-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { style: { marginRight: '.24rem' } }, item2.navigation_name), item2.product_sort !== '0' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'hot icon' }), item2.is_sale === '1' && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'sale icon' })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'skill-link-text' }, item2.yijuhua));
        })) : null);
      }) : null)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-plan' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-plan-title' }, '\u4F01\u4E1A\u7EA7\u5927\u6570\u636E \u884C\u4E1A\u4E13\u4E1A\u89E3\u51B3\u65B9\u6848'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-plan-des' }, '\u6570\u5341\u8F7D\u5B89\u5168\u6570\u636E\u79EF\u7D2F + \u6570\u5341\u4E07\u4F01\u4E1A\u5B89\u5168\u5B9E\u8DF5', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br', null), '\u914D\u5408\u5168\u7F51\u5A01\u80C1\u60C5\u62A5\u534F\u540C\u8054\u52A8', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br', null), '\u94F8\u5C31\u66F4\u52A0\u667A\u80FD\u3001\u6210\u719F\u7684\u884C\u4E1A\u5B89\u5168\u89E3\u51B3\u65B9\u6848'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-plan-list' }, planList.length > 0 ? planList.map(function (item, index) {
        var homeRecommend = item.home_recommend;if (index > 4 && !planOff) {
          return null;
        }return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: '/m/product/' + item.alias, className: 'plan-list-cell pr', key: index }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: homeRecommend && homeRecommend.mobilePic, alt: item.navigation_name, width: '100%' }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'list-cell-share' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3', null, item.navigation_name), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: item.home_recommend.mobileIcon }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'plan-pro-text' }, item.yijuhua), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'plan-pro-more' }, '\u4E86\u89E3\u66F4\u591A')));
      }) : ''), planList.length > 0 ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'linkText ' + (planOff ? 'on' : ''), onClick: function onClick() {
          _this2.setState({ planOff: !planOff });
        } }, planOff ? '收起' : '查看', '\u5168\u90E8') : ''), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-work' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3', { className: 'spu-work-title' }, '\u56E0\u4E3A\u4E86\u89E3 \u6240\u4EE5\u4FE1\u8D56'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: __webpack_require__(447), alt: '', width: '100%' })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'feedback-mod' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'feedback-mod-text' }, '\u767E\u5EA6\u5B89\u5168\u4EE5\u6280\u672F\u5F00\u6E90\u3001\u4E13\u5229\u5171\u4EAB\u3001\u6807\u51C6\u9A71\u52A8\u4E3A\u7406\u5FF5\uFF0C\u8054\u5408\u4E92\u8054\u7F51\u516C\u53F8\u3001\u5B89\u5168\u5382\u5546\u3001\u7EC8\u7AEF\u5236\u9020\u5546\u3001 \u9AD8\u6821\u53CA\u79D1\u7814\u673A\u6784\uFF0C \u63A8\u52A8AI\u65F6\u4EE3\u7684\u5B89\u5168\u751F\u6001\u5EFA\u8BBE\uFF0C\u8BA9\u5168\u884C\u4E1A\u4EAB\u53D7\u66F4\u5B89\u5168\u7684AI\u6240\u5E26\u6765\u7684\u53D8\u9769\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: __webpack_require__(448), alt: '\u767E\u5EA6\u54C1\u724C', width: '100%', className: 'feedback-mod-img' }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: __webpack_require__(449), alt: '\u8D44\u8D28\u6587\u4EF6', width: '100%', className: 'feedback-mod-icon' }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'feedback-mod-char' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', null, 'CSA STAR \u56FD\u9645\u8BA4\u8BC1'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', null, '\u4FE1\u606F\u7CFB\u7EDF\u5B89\u5168\u7B49\u7EA7\u4FDD\u62A4\u7B2C\u2162\u7EA7'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', null, 'ISO27017 \u4E91\u5B89\u5168\u7BA1\u7406\u4F53\u7CFB\u8BA4\u8BC1'))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-news' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h3', null, '\u524D\u6CBF\u9886\u57DF\u7684\u65B0\u89C2\u5BDF'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'spu-forum-des' }, '\u884C\u4E1A\u8D44\u8BAF\u3001\u524D\u6CBF\u6280\u672F\u3001\u5F00\u6E90\u5B9E\u6218\uFF0C\u65B0\u9C9C\uFF0C', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br', null), '\u6709\u8DA3\uFF0C\u5B9E\u7528'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-forum-mod' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'page-box' }, !this.isEmptyobj(articleList) ? articleList.itemlist.article_list.datalist.map(function (item, index) {
        if (index < 4) {
          return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: '/m/forum/page/' + item.aid, className: 'section', key: index }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ListPro__["a" /* default */], { title: item.title, imgSrc: item.pic, tagList: item.tags_data }));
        }
      }) : ''))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'user-recall' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: '/m/apply' }, '\u7ACB\u5373\u54A8\u8BE2')));
    } }]);return Home;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class.propTypes = { fetchCmsapiHomepage: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, fetchArticleList: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, cmsapiHomepagea: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, articleList: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return { cmsapiHomepagea: state.cmsapiHomepagea, articleList: state.articleList };
}function mapDispatchToProps(dispatch) {
  return { fetchCmsapiHomepage: function fetchCmsapiHomepage() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__actions_homeAction__["b" /* fetchCmsapiHomepage */])(dispatch);
    }, fetchArticleList: function fetchArticleList() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__actions_homeAction__["a" /* fetchArticleList */])(dispatch);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Home));

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(380);
var $Object = __webpack_require__(34).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(40);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(36), 'Object', { defineProperty: __webpack_require__(35).f });


/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(383), __esModule: true };

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(384);
__webpack_require__(393);
module.exports = __webpack_require__(117).f('iterator');


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(385)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(205)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(108);
var defined = __webpack_require__(109);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(112);
var descriptor = __webpack_require__(69);
var setToStringTag = __webpack_require__(116);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(41)(IteratorPrototype, __webpack_require__(44)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(35);
var anObject = __webpack_require__(52);
var getKeys = __webpack_require__(70);

module.exports = __webpack_require__(36) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(43);
var toLength = __webpack_require__(389);
var toAbsoluteIndex = __webpack_require__(390);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(108);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(108);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(28).document;
module.exports = document && document.documentElement;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(37);
var toObject = __webpack_require__(210);
var IE_PROTO = __webpack_require__(113)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(394);
var global = __webpack_require__(28);
var hide = __webpack_require__(41);
var Iterators = __webpack_require__(111);
var TO_STRING_TAG = __webpack_require__(44)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(395);
var step = __webpack_require__(396);
var Iterators = __webpack_require__(111);
var toIObject = __webpack_require__(43);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(205)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(398), __esModule: true };

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(399);
__webpack_require__(404);
__webpack_require__(405);
__webpack_require__(406);
module.exports = __webpack_require__(34).Symbol;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(28);
var has = __webpack_require__(37);
var DESCRIPTORS = __webpack_require__(36);
var $export = __webpack_require__(40);
var redefine = __webpack_require__(206);
var META = __webpack_require__(400).KEY;
var $fails = __webpack_require__(53);
var shared = __webpack_require__(114);
var setToStringTag = __webpack_require__(116);
var uid = __webpack_require__(71);
var wks = __webpack_require__(44);
var wksExt = __webpack_require__(117);
var wksDefine = __webpack_require__(118);
var enumKeys = __webpack_require__(401);
var isArray = __webpack_require__(402);
var anObject = __webpack_require__(52);
var isObject = __webpack_require__(42);
var toIObject = __webpack_require__(43);
var toPrimitive = __webpack_require__(106);
var createDesc = __webpack_require__(69);
var _create = __webpack_require__(112);
var gOPNExt = __webpack_require__(403);
var $GOPD = __webpack_require__(212);
var $DP = __webpack_require__(35);
var $keys = __webpack_require__(70);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(211).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(72).f = $propertyIsEnumerable;
  __webpack_require__(119).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(110)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(41)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(71)('meta');
var isObject = __webpack_require__(42);
var has = __webpack_require__(37);
var setDesc = __webpack_require__(35).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(53)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(70);
var gOPS = __webpack_require__(119);
var pIE = __webpack_require__(72);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(209);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(43);
var gOPN = __webpack_require__(211).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 404 */
/***/ (function(module, exports) {



/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118)('asyncIterator');


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118)('observable');


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(408), __esModule: true };

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(409);
module.exports = __webpack_require__(34).Object.setPrototypeOf;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(40);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(410).set });


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(42);
var anObject = __webpack_require__(52);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(202)(Function.call, __webpack_require__(212).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(412), __esModule: true };

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(413);
var $Object = __webpack_require__(34).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(40);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(112) });


/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(416), __esModule: true };

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(417);
module.exports = __webpack_require__(34).Object.assign;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(40);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(418) });


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(70);
var gOPS = __webpack_require__(119);
var pIE = __webpack_require__(72);
var toObject = __webpack_require__(210);
var IObject = __webpack_require__(208);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(53)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__carousel__ = __webpack_require__(420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__carousel__["a"]; });


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__decorators__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_exenv__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raf__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_raf__);











// from https://github.com/chenglou/tween-functions
function easeOutCirc(t, b, _c, d) {
    var c = _c - b;
    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
}
function linear(t, b, _c, d) {
    var c = _c - b;
    return c * t / d + b;
}
var DEFAULT_STACK_BEHAVIOR = 'ADDITIVE';
var DEFAULT_DURATION = 300;
var DEFAULT_DELAY = 0;
var stackBehavior = {
    ADDITIVE: 'ADDITIVE',
    DESTRUCTIVE: 'DESTRUCTIVE'
};
var addEvent = function addEvent(elem, type, eventHandle) {
    if (elem === null || typeof elem === 'undefined') {
        return;
    }
    if (elem.addEventListener) {
        elem.addEventListener(type, eventHandle, false);
    } else if (elem.attachEvent) {
        elem.attachEvent('on' + type, eventHandle);
    } else {
        elem['on' + type] = eventHandle;
    }
};
var removeEvent = function removeEvent(elem, type, eventHandle) {
    if (elem === null || typeof elem === 'undefined') {
        return;
    }
    if (elem.removeEventListener) {
        elem.removeEventListener(type, eventHandle, false);
    } else if (elem.detachEvent) {
        elem.detachEvent('on' + type, eventHandle);
    } else {
        elem['on' + type] = null;
    }
};

var Carousel = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Carousel, _React$Component);

    function Carousel(props) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Carousel);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

        _this._rafCb = function () {
            var state = _this.state;
            if (state.tweenQueue.length === 0) {
                return;
            }
            var now = Date.now();
            var newTweenQueue = [];
            for (var i = 0; i < state.tweenQueue.length; i++) {
                var item = state.tweenQueue[i];
                var initTime = item.initTime,
                    config = item.config;

                if (now - initTime < config.duration) {
                    newTweenQueue.push(item);
                } else {
                    if (config.onEnd) {
                        config.onEnd();
                    }
                }
            }
            // onEnd might trigger a parent callback that removes this component
            // -1 means we've canceled it in componentWillUnmount
            if (_this._rafID === -1) {
                return;
            }
            _this.setState({
                tweenQueue: newTweenQueue
            });
            _this._rafID = __WEBPACK_IMPORTED_MODULE_8_raf___default()(_this._rafCb);
        };
        _this.handleClick = function (e) {
            if (_this.clickSafe === true) {
                e.preventDefault();
                e.stopPropagation();
                if (e.nativeEvent) {
                    e.nativeEvent.stopPropagation();
                }
            }
        };
        _this.autoplayIterator = function () {
            if (_this.props.wrapAround) {
                return _this.nextSlide();
            }
            if (_this.state.currentSlide !== _this.state.slideCount - _this.state.slidesToShow) {
                _this.nextSlide();
            } else {
                _this.stopAutoplay();
            }
        };
        // Action Methods
        _this.goToSlide = function (index) {
            var _this$props = _this.props,
                beforeSlide = _this$props.beforeSlide,
                afterSlide = _this$props.afterSlide;

            if (index >= __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(_this.props.children) || index < 0) {
                if (!_this.props.wrapAround) {
                    return;
                }
                ;
                if (index >= __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(_this.props.children)) {
                    beforeSlide(_this.state.currentSlide, 0);
                    return _this.setState({
                        currentSlide: 0
                    }, function () {
                        _this.animateSlide(null, null, _this.getTargetLeft(null, index), function () {
                            _this.animateSlide(null, 0.01);
                            afterSlide(0);
                            _this.resetAutoplay();
                            _this.setExternalData();
                        });
                    });
                } else {
                    var endSlide = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(_this.props.children) - _this.state.slidesToScroll;
                    beforeSlide(_this.state.currentSlide, endSlide);
                    return _this.setState({
                        currentSlide: endSlide
                    }, function () {
                        _this.animateSlide(null, null, _this.getTargetLeft(null, index), function () {
                            _this.animateSlide(null, 0.01);
                            afterSlide(endSlide);
                            _this.resetAutoplay();
                            _this.setExternalData();
                        });
                    });
                }
            }
            beforeSlide(_this.state.currentSlide, index);
            _this.setState({
                currentSlide: index
            }, function () {
                _this.animateSlide();
                _this.props.afterSlide(index);
                _this.resetAutoplay();
                _this.setExternalData();
            });
        };
        _this.nextSlide = function () {
            var childrenCount = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(_this.props.children);
            var slidesToShow = _this.props.slidesToShow;
            if (_this.props.slidesToScroll === 'auto') {
                slidesToShow = _this.state.slidesToScroll;
            }
            if (_this.state.currentSlide >= childrenCount - slidesToShow && !_this.props.wrapAround) {
                return;
            }
            if (_this.props.wrapAround) {
                _this.goToSlide(_this.state.currentSlide + _this.state.slidesToScroll);
            } else {
                if (_this.props.slideWidth !== 1) {
                    return _this.goToSlide(_this.state.currentSlide + _this.state.slidesToScroll);
                }
                _this.goToSlide(Math.min(_this.state.currentSlide + _this.state.slidesToScroll, childrenCount - slidesToShow));
            }
        };
        _this.previousSlide = function () {
            if (_this.state.currentSlide <= 0 && !_this.props.wrapAround) {
                return;
            }
            if (_this.props.wrapAround) {
                _this.goToSlide(_this.state.currentSlide - _this.state.slidesToScroll);
            } else {
                _this.goToSlide(Math.max(0, _this.state.currentSlide - _this.state.slidesToScroll));
            }
        };
        _this.onResize = function () {
            _this.setDimensions();
        };
        _this.onReadyStateChange = function () {
            _this.setDimensions();
        };
        _this.state = {
            currentSlide: _this.props.slideIndex,
            dragging: false,
            frameWidth: 0,
            left: 0,
            slideCount: 0,
            slidesToScroll: _this.props.slidesToScroll,
            slideWidth: 0,
            top: 0,
            tweenQueue: []
        };
        _this.touchObject = {};
        _this.clickSafe = true;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Carousel, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.setInitialDimensions();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDimensions();
            this.bindEvents();
            this.setExternalData();
            if (this.props.autoplay) {
                this.startAutoplay();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                slideCount: nextProps.children.length
            });
            this.setDimensions(nextProps);
            if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide) {
                this.goToSlide(nextProps.slideIndex);
            }
            if (this.props.autoplay !== nextProps.autoplay) {
                if (nextProps.autoplay) {
                    this.startAutoplay();
                } else {
                    this.stopAutoplay();
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.unbindEvents();
            this.stopAutoplay();
            __WEBPACK_IMPORTED_MODULE_8_raf___default.a.cancel(this._rafID);
            this._rafID = -1;
        }
        // react-tween-state

    }, {
        key: 'tweenState',
        value: function tweenState(path, _ref) {
            var _this2 = this;

            var easing = _ref.easing,
                duration = _ref.duration,
                delay = _ref.delay,
                beginValue = _ref.beginValue,
                endValue = _ref.endValue,
                onEnd = _ref.onEnd,
                configSB = _ref.stackBehavior;

            this.setState(function (state) {
                var cursor = state;
                var stateName = void 0;
                // see comment below on pash hash
                var pathHash = void 0;
                if (typeof path === 'string') {
                    stateName = path;
                    pathHash = path;
                } else {
                    for (var i = 0; i < path.length - 1; i++) {
                        cursor = cursor[path[i]];
                    }
                    stateName = path[path.length - 1];
                    pathHash = path.join('|');
                }
                // see the reasoning for these defaults at the top of file
                var newConfig = {
                    easing: easing,
                    duration: duration == null ? DEFAULT_DURATION : duration,
                    delay: delay == null ? DEFAULT_DELAY : delay,
                    beginValue: beginValue == null ? cursor[stateName] : beginValue,
                    endValue: endValue,
                    onEnd: onEnd,
                    stackBehavior: configSB || DEFAULT_STACK_BEHAVIOR
                };
                var newTweenQueue = state.tweenQueue;
                if (newConfig.stackBehavior === stackBehavior.DESTRUCTIVE) {
                    newTweenQueue = state.tweenQueue.filter(function (item) {
                        return item.pathHash !== pathHash;
                    });
                }
                // we store path hash, so that during value retrieval we can use hash
                // comparison to find the path. See the kind of shitty thing you have to
                // do when you don't have value comparison for collections?
                newTweenQueue.push({
                    pathHash: pathHash,
                    config: newConfig,
                    initTime: Date.now() + newConfig.delay
                });
                // sorry for mutating. For perf reasons we don't want to deep clone.
                // guys, can we please all start using persistent collections so that
                // we can stop worrying about nonesense like this
                cursor[stateName] = newConfig.endValue;
                if (newTweenQueue.length === 1) {
                    _this2._rafID = __WEBPACK_IMPORTED_MODULE_8_raf___default()(_this2._rafCb);
                }
                // this will also include the above mutated update
                return { tweenQueue: newTweenQueue };
            });
        }
    }, {
        key: 'getTweeningValue',
        value: function getTweeningValue(path) {
            var state = this.state;
            var tweeningValue = void 0;
            var pathHash = void 0;
            if (typeof path === 'string') {
                tweeningValue = state[path];
                pathHash = path;
            } else {
                tweeningValue = state;
                for (var i = 0; i < path.length; i++) {
                    tweeningValue = tweeningValue[path[i]];
                }
                pathHash = path.join('|');
            }
            var now = Date.now();
            for (var _i = 0; _i < state.tweenQueue.length; _i++) {
                var _state$tweenQueue$_i = state.tweenQueue[_i],
                    itemPathHash = _state$tweenQueue$_i.pathHash,
                    initTime = _state$tweenQueue$_i.initTime,
                    config = _state$tweenQueue$_i.config;

                if (itemPathHash !== pathHash) {
                    continue;
                }
                var progressTime = now - initTime > config.duration ? config.duration : Math.max(0, now - initTime);
                // `now - initTime` can be negative if initTime is scheduled in the
                // future by a delay. In this case we take 0
                // if duration is 0, consider that as jumping to endValue directly. This
                // is needed because the easing functino might have undefined behavior for
                // duration = 0
                var easeValue = config.duration === 0 ? config.endValue : config.easing(progressTime, config.beginValue, config.endValue, config.duration);
                var contrib = easeValue - config.endValue;
                tweeningValue += contrib;
            }
            return tweeningValue;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var children = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(this.props.children) > 1 ? this.formatChildren(this.props.children) : this.props.children;
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                'div',
                { className: ['slider', this.props.className || ''].join(' '), ref: 'slider', style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getSliderStyles(), this.props.style) },
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'div',
                    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: 'slider-frame', ref: 'frame', style: this.getFrameStyles() }, this.getTouchEvents(), this.getMouseEvents(), { onClick: this.handleClick }),
                    __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                        'ul',
                        { className: 'slider-list', ref: 'list', style: this.getListStyles() },
                        children
                    )
                ),
                this.props.decorators ? this.props.decorators.map(function (Decorator, index) {
                    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                        'div',
                        { style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this3.getDecoratorStyles(Decorator.position), Decorator.style || {}), className: 'slider-decorator-' + index, key: index },
                        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Decorator.component, { currentSlide: _this3.state.currentSlide, slideCount: _this3.state.slideCount, frameWidth: _this3.state.frameWidth, slideWidth: _this3.state.slideWidth, slidesToScroll: _this3.state.slidesToScroll, cellSpacing: _this3.props.cellSpacing, slidesToShow: _this3.props.slidesToShow, wrapAround: _this3.props.wrapAround, nextSlide: _this3.nextSlide, previousSlide: _this3.previousSlide, goToSlide: _this3.goToSlide })
                    );
                }) : null,
                __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('style', { type: 'text/css', dangerouslySetInnerHTML: { __html: this.getStyleTagStyles() } })
            );
        }
        // Touch Events

    }, {
        key: 'getTouchEvents',
        value: function getTouchEvents() {
            var self = this;
            if (this.props.swiping === false) {
                return null;
            }
            return {
                onTouchStart: function onTouchStart(e) {
                    self.touchObject = {
                        startX: e.touches[0].pageX,
                        startY: e.touches[0].pageY
                    };
                    self.handleMouseOver();
                },
                onTouchMove: function onTouchMove(e) {
                    var direction = self.swipeDirection(self.touchObject.startX, e.touches[0].pageX, self.touchObject.startY, e.touches[0].pageY);
                    if (direction !== 0) {
                        e.preventDefault();
                    }
                    var length = self.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - self.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - self.touchObject.startX, 2)));
                    self.touchObject = {
                        startX: self.touchObject.startX,
                        startY: self.touchObject.startY,
                        endX: e.touches[0].pageX,
                        endY: e.touches[0].pageY,
                        length: length,
                        direction: direction
                    };
                    self.setState({
                        left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
                        top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0
                    });
                },
                onTouchEnd: function onTouchEnd(e) {
                    self.handleSwipe(e);
                    self.handleMouseOut();
                },
                onTouchCancel: function onTouchCancel(e) {
                    self.handleSwipe(e);
                }
            };
        }
    }, {
        key: 'getMouseEvents',
        value: function getMouseEvents() {
            var self = this;
            if (this.props.dragging === false) {
                return null;
            }
            return {
                onMouseOver: function onMouseOver() {
                    self.handleMouseOver();
                },
                onMouseOut: function onMouseOut() {
                    self.handleMouseOut();
                },
                onMouseDown: function onMouseDown(e) {
                    self.touchObject = {
                        startX: e.clientX,
                        startY: e.clientY
                    };
                    self.setState({
                        dragging: true
                    });
                },
                onMouseMove: function onMouseMove(e) {
                    if (!self.state.dragging) {
                        return;
                    }
                    var direction = self.swipeDirection(self.touchObject.startX, e.clientX, self.touchObject.startY, e.clientY);
                    if (direction !== 0) {
                        e.preventDefault();
                    }
                    var length = self.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - self.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - self.touchObject.startX, 2)));
                    self.touchObject = {
                        startX: self.touchObject.startX,
                        startY: self.touchObject.startY,
                        endX: e.clientX,
                        endY: e.clientY,
                        length: length,
                        direction: direction
                    };
                    self.setState({
                        left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
                        top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0
                    });
                },
                onMouseUp: function onMouseUp(e) {
                    if (!self.state.dragging) {
                        return;
                    }
                    self.handleSwipe(e);
                },
                onMouseLeave: function onMouseLeave(e) {
                    if (!self.state.dragging) {
                        return;
                    }
                    self.handleSwipe(e);
                }
            };
        }
    }, {
        key: 'handleMouseOver',
        value: function handleMouseOver() {
            if (this.props.autoplay) {
                this.autoplayPaused = true;
                this.stopAutoplay();
            }
        }
    }, {
        key: 'handleMouseOut',
        value: function handleMouseOut() {
            if (this.props.autoplay && this.autoplayPaused) {
                this.startAutoplay();
                this.autoplayPaused = null;
            }
        }
    }, {
        key: 'handleSwipe',
        value: function handleSwipe(_) {
            if (typeof this.touchObject.length !== 'undefined' && this.touchObject.length > 44) {
                this.clickSafe = true;
            } else {
                this.clickSafe = false;
            }
            var _props = this.props,
                slidesToShow = _props.slidesToShow,
                slidesToScroll = _props.slidesToScroll,
                swipeSpeed = _props.swipeSpeed;
            // var slidesToShow = this.props.slidesToShow;

            if (slidesToScroll === 'auto') {
                slidesToShow = this.state.slidesToScroll;
            }
            if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(this.props.children) > 1 && this.touchObject.length > this.state.slideWidth / slidesToShow / swipeSpeed) {
                if (this.touchObject.direction === 1) {
                    if (this.state.currentSlide >= __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(this.props.children) - slidesToShow && !this.props.wrapAround) {
                        this.animateSlide(this.props.edgeEasing);
                    } else {
                        this.nextSlide();
                    }
                } else if (this.touchObject.direction === -1) {
                    if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
                        this.animateSlide(this.props.edgeEasing);
                    } else {
                        this.previousSlide();
                    }
                }
            } else {
                this.goToSlide(this.state.currentSlide);
            }
            this.touchObject = {};
            this.setState({
                dragging: false
            });
        }
    }, {
        key: 'swipeDirection',
        value: function swipeDirection(x1, x2, y1, y2) {
            var xDist = x1 - x2;
            var yDist = y1 - y2;
            var r = Math.atan2(yDist, xDist);
            var swipeAngle = Math.round(r * 180 / Math.PI);
            if (swipeAngle < 0) {
                swipeAngle = 360 - Math.abs(swipeAngle);
            }
            if (swipeAngle <= 45 && swipeAngle >= 0) {
                return 1;
            }
            if (swipeAngle <= 360 && swipeAngle >= 315) {
                return 1;
            }
            if (swipeAngle >= 135 && swipeAngle <= 225) {
                return -1;
            }
            if (this.props.vertical === true) {
                if (swipeAngle >= 35 && swipeAngle <= 135) {
                    return 1;
                } else {
                    return -1;
                }
            }
            return 0;
        }
    }, {
        key: 'startAutoplay',
        value: function startAutoplay() {
            if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(this.props.children) <= 1) {
                return;
            }
            this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
        }
    }, {
        key: 'resetAutoplay',
        value: function resetAutoplay() {
            if (this.props.resetAutoplay && this.props.autoplay && !this.autoplayPaused) {
                this.stopAutoplay();
                this.startAutoplay();
            }
        }
    }, {
        key: 'stopAutoplay',
        value: function stopAutoplay() {
            if (this.autoplayID) {
                clearInterval(this.autoplayID);
            }
        }
        // Animation

    }, {
        key: 'animateSlide',
        value: function animateSlide(easing, duration, endValue, callback) {
            this.tweenState(this.props.vertical ? 'top' : 'left', {
                easing: easing || this.props.easing,
                duration: duration || this.props.speed,
                endValue: endValue || this.getTargetLeft(),
                delay: null,
                beginValue: null,
                onEnd: callback || null,
                stackBehavior: stackBehavior
            });
        }
    }, {
        key: 'getTargetLeft',
        value: function getTargetLeft(touchOffset, slide) {
            var offset = void 0;
            var target = slide || this.state.currentSlide;
            var cellSpacing = this.props.cellSpacing;
            switch (this.props.cellAlign) {
                case 'left':
                    {
                        offset = 0;
                        offset -= cellSpacing * target;
                        break;
                    }
                case 'center':
                    {
                        offset = (this.state.frameWidth - this.state.slideWidth) / 2;
                        offset -= cellSpacing * target;
                        break;
                    }
                case 'right':
                    {
                        offset = this.state.frameWidth - this.state.slideWidth;
                        offset -= cellSpacing * target;
                        break;
                    }
                default:
                    break;
            }
            var left = this.state.slideWidth * target;
            var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;
            if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
                left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
                offset = 0;
                offset -= cellSpacing * (this.state.slideCount - 1);
            }
            offset -= touchOffset || 0;
            return (left - offset) * -1;
        }
        // Bootstrapping

    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            if (__WEBPACK_IMPORTED_MODULE_7_exenv___default.a.canUseDOM) {
                addEvent(window, 'resize', this.onResize);
                addEvent(document, 'readystatechange', this.onReadyStateChange);
            }
        }
    }, {
        key: 'unbindEvents',
        value: function unbindEvents() {
            if (__WEBPACK_IMPORTED_MODULE_7_exenv___default.a.canUseDOM) {
                removeEvent(window, 'resize', this.onResize);
                removeEvent(document, 'readystatechange', this.onReadyStateChange);
            }
        }
    }, {
        key: 'formatChildren',
        value: function formatChildren(children) {
            var _this4 = this;

            var positionValue = this.props.vertical ? this.getTweeningValue('top') : this.getTweeningValue('left');
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.map(children, function (child, index) {
                return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
                    'li',
                    { className: 'slider-slide', style: _this4.getSlideStyles(index, positionValue), key: index },
                    child
                );
            });
        }
    }, {
        key: 'setInitialDimensions',
        value: function setInitialDimensions() {
            var _this5 = this;

            var _props2 = this.props,
                vertical = _props2.vertical,
                initialSlideHeight = _props2.initialSlideHeight,
                initialSlideWidth = _props2.initialSlideWidth,
                slidesToShow = _props2.slidesToShow,
                cellSpacing = _props2.cellSpacing,
                children = _props2.children;

            var slideWidth = vertical ? initialSlideHeight || 0 : initialSlideWidth || 0;
            var slideHeight = initialSlideHeight ? initialSlideHeight * slidesToShow : 0;
            var frameHeight = slideHeight + cellSpacing * (slidesToShow - 1);
            this.setState({
                slideHeight: slideHeight,
                frameWidth: vertical ? frameHeight : '100%',
                slideCount: __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(children),
                slideWidth: slideWidth
            }, function () {
                _this5.setLeft();
                _this5.setExternalData();
            });
        }
    }, {
        key: 'setDimensions',
        value: function setDimensions(props) {
            var _this6 = this;

            props = props || this.props;
            var frameWidth = void 0;
            var frameHeight = void 0;
            var slideHeight = void 0;
            var slideWidth = void 0;
            var slidesToScroll = props.slidesToScroll;
            var frame = this.refs.frame;
            var firstSlide = frame.childNodes[0].childNodes[0];
            if (firstSlide) {
                firstSlide.style.height = 'auto';
                slideHeight = this.props.vertical ? firstSlide.offsetHeight * props.slidesToShow : firstSlide.offsetHeight;
            } else {
                slideHeight = 100;
            }
            if (typeof props.slideWidth !== 'number') {
                slideWidth = parseInt(props.slideWidth, 10);
            } else {
                if (props.vertical) {
                    slideWidth = slideHeight / props.slidesToShow * props.slideWidth;
                } else {
                    slideWidth = frame.offsetWidth / props.slidesToShow * props.slideWidth;
                }
            }
            if (!props.vertical) {
                slideWidth -= props.cellSpacing * ((100 - 100 / props.slidesToShow) / 100);
            }
            frameHeight = slideHeight + props.cellSpacing * (props.slidesToShow - 1);
            frameWidth = props.vertical ? frameHeight : frame.offsetWidth;
            if (props.slidesToScroll === 'auto') {
                slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
            }
            this.setState({
                slideHeight: slideHeight,
                frameWidth: frameWidth,
                slideWidth: slideWidth,
                slidesToScroll: slidesToScroll,
                left: props.vertical ? 0 : this.getTargetLeft(),
                top: props.vertical ? this.getTargetLeft() : 0
            }, function () {
                _this6.setLeft();
            });
        }
    }, {
        key: 'setLeft',
        value: function setLeft() {
            this.setState({
                left: this.props.vertical ? 0 : this.getTargetLeft(),
                top: this.props.vertical ? this.getTargetLeft() : 0
            });
        }
        // Data

    }, {
        key: 'setExternalData',
        value: function setExternalData() {
            if (this.props.data) {
                this.props.data();
            }
        }
        // Styles

    }, {
        key: 'getListStyles',
        value: function getListStyles() {
            var listWidth = this.state.slideWidth * __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(this.props.children);
            var cellSpacing = this.props.cellSpacing;
            var spacingOffset = cellSpacing * __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.count(this.props.children);
            var transform = 'translate3d(' + this.getTweeningValue('left') + 'px, ' + this.getTweeningValue('top') + 'px, 0)';
            return {
                transform: transform,
                WebkitTransform: transform,
                msTransform: 'translate(' + this.getTweeningValue('left') + 'px, ' + this.getTweeningValue('top') + 'px)',
                position: 'relative',
                display: 'block',
                margin: this.props.vertical ? cellSpacing / 2 * -1 + 'px 0px' : '0px ' + cellSpacing / 2 * -1 + 'px',
                padding: 0,
                height: this.props.vertical ? listWidth + spacingOffset : this.state.slideHeight,
                width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
                cursor: this.state.dragging === true ? 'pointer' : 'inherit',
                boxSizing: 'border-box',
                MozBoxSizing: 'border-box'
            };
        }
    }, {
        key: 'getFrameStyles',
        value: function getFrameStyles() {
            return {
                position: 'relative',
                display: 'block',
                overflow: this.props.frameOverflow,
                height: this.props.vertical ? this.state.frameWidth || 'initial' : 'auto',
                margin: this.props.framePadding,
                padding: 0,
                transform: 'translate3d(0, 0, 0)',
                WebkitTransform: 'translate3d(0, 0, 0)',
                msTransform: 'translate(0, 0)',
                boxSizing: 'border-box',
                MozBoxSizing: 'border-box'
            };
        }
    }, {
        key: 'getSlideStyles',
        value: function getSlideStyles(index, positionValue) {
            var targetPosition = this.getSlideTargetPosition(index, positionValue);
            var cellSpacing = this.props.cellSpacing;
            return {
                position: 'absolute',
                left: this.props.vertical ? 0 : targetPosition,
                top: this.props.vertical ? targetPosition : 0,
                display: this.props.vertical ? 'block' : 'inline-block',
                listStyleType: 'none',
                verticalAlign: 'top',
                width: this.props.vertical ? '100%' : this.state.slideWidth,
                height: 'auto',
                boxSizing: 'border-box',
                MozBoxSizing: 'border-box',
                marginLeft: this.props.vertical ? 'auto' : cellSpacing / 2,
                marginRight: this.props.vertical ? 'auto' : cellSpacing / 2,
                marginTop: this.props.vertical ? cellSpacing / 2 : 'auto',
                marginBottom: this.props.vertical ? cellSpacing / 2 : 'auto'
            };
        }
    }, {
        key: 'getSlideTargetPosition',
        value: function getSlideTargetPosition(index, positionValue) {
            var slidesToShow = this.state.frameWidth / this.state.slideWidth;
            var targetPosition = (this.state.slideWidth + this.props.cellSpacing) * index;
            var end = (this.state.slideWidth + this.props.cellSpacing) * slidesToShow * -1;
            if (this.props.wrapAround) {
                var slidesBefore = Math.ceil(positionValue / this.state.slideWidth);
                if (this.state.slideCount - slidesBefore <= index) {
                    return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount - index) * -1;
                }
                var slidesAfter = Math.ceil((Math.abs(positionValue) - Math.abs(end)) / this.state.slideWidth);
                if (this.state.slideWidth !== 1) {
                    slidesAfter = Math.ceil((Math.abs(positionValue) - this.state.slideWidth) / this.state.slideWidth);
                }
                if (index <= slidesAfter - 1) {
                    return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount + index);
                }
            }
            return targetPosition;
        }
    }, {
        key: 'getSliderStyles',
        value: function getSliderStyles() {
            return {
                position: 'relative',
                display: 'block',
                width: this.props.width,
                height: 'auto',
                boxSizing: 'border-box',
                MozBoxSizing: 'border-box',
                visibility: this.state.slideWidth ? 'visible' : 'hidden'
            };
        }
    }, {
        key: 'getStyleTagStyles',
        value: function getStyleTagStyles() {
            return '.slider-slide > img {width: 100%; display: block;}';
        }
    }, {
        key: 'getDecoratorStyles',
        value: function getDecoratorStyles(position) {
            switch (position) {
                case 'TopLeft':
                    {
                        return {
                            position: 'absolute',
                            top: 0,
                            left: 0
                        };
                    }
                case 'TopCenter':
                    {
                        return {
                            position: 'absolute',
                            top: 0,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            WebkitTransform: 'translateX(-50%)',
                            msTransform: 'translateX(-50%)'
                        };
                    }
                case 'TopRight':
                    {
                        return {
                            position: 'absolute',
                            top: 0,
                            right: 0
                        };
                    }
                case 'CenterLeft':
                    {
                        return {
                            position: 'absolute',
                            top: '50%',
                            left: 0,
                            transform: 'translateY(-50%)',
                            WebkitTransform: 'translateY(-50%)',
                            msTransform: 'translateY(-50%)'
                        };
                    }
                case 'CenterCenter':
                    {
                        return {
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%,-50%)',
                            WebkitTransform: 'translate(-50%, -50%)',
                            msTransform: 'translate(-50%, -50%)'
                        };
                    }
                case 'CenterRight':
                    {
                        return {
                            position: 'absolute',
                            top: '50%',
                            right: 0,
                            transform: 'translateY(-50%)',
                            WebkitTransform: 'translateY(-50%)',
                            msTransform: 'translateY(-50%)'
                        };
                    }
                case 'BottomLeft':
                    {
                        return {
                            position: 'absolute',
                            bottom: 0,
                            left: 0
                        };
                    }
                case 'BottomCenter':
                    {
                        return {
                            position: 'absolute',
                            bottom: 0,
                            width: '100%',
                            textAlign: 'center'
                        };
                    }
                case 'BottomRight':
                    {
                        return {
                            position: 'absolute',
                            bottom: 0,
                            right: 0
                        };
                    }
                default:
                    {
                        return {
                            position: 'absolute',
                            top: 0,
                            left: 0
                        };
                    }
            }
        }
    }]);

    return Carousel;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Carousel.defaultProps = {
    afterSlide: function afterSlide() {},
    autoplay: false,
    resetAutoplay: true,
    swipeSpeed: 12,
    autoplayInterval: 3000,
    beforeSlide: function beforeSlide() {},
    cellAlign: 'left',
    cellSpacing: 0,
    data: function data() {},
    decorators: __WEBPACK_IMPORTED_MODULE_6__decorators__["a" /* default */],
    dragging: true,
    easing: easeOutCirc,
    edgeEasing: linear,
    framePadding: '0px',
    frameOverflow: 'hidden',
    slideIndex: 0,
    slidesToScroll: 1,
    slidesToShow: 1,
    slideWidth: 1,
    speed: 500,
    swiping: true,
    vertical: false,
    width: '100%',
    wrapAround: false,
    style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Carousel);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);







var DefaultDecorators = [{
    component: function (_React$Component) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(component, _React$Component);

        function component() {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, component);

            var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (component.__proto__ || Object.getPrototypeOf(component)).apply(this, arguments));

            _this.handleClick = function (e) {
                e.preventDefault();
                _this.props.previousSlide();
            };
            return _this;
        }

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(component, [{
            key: 'render',
            value: function render() {
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'button',
                    { style: this.getButtonStyles(this.props.currentSlide === 0 && !this.props.wrapAround), onClick: this.handleClick },
                    'PREV'
                );
            }
        }, {
            key: 'getButtonStyles',
            value: function getButtonStyles(disabled) {
                return {
                    border: 0,
                    background: 'rgba(0,0,0,0.4)',
                    color: 'white',
                    padding: 10,
                    outline: 0,
                    opacity: disabled ? 0.3 : 1,
                    cursor: 'pointer'
                };
            }
        }]);

        return component;
    }(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component),
    position: 'CenterLeft'
}, {
    component: function (_React$Component2) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(component, _React$Component2);

        function component() {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, component);

            var _this2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (component.__proto__ || Object.getPrototypeOf(component)).apply(this, arguments));

            _this2.handleClick = function (e) {
                e.preventDefault();
                if (_this2.props.nextSlide) {
                    _this2.props.nextSlide();
                }
            };
            return _this2;
        }

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(component, [{
            key: 'render',
            value: function render() {
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'button',
                    { style: this.getButtonStyles(this.props.currentSlide + this.props.slidesToScroll >= this.props.slideCount && !this.props.wrapAround), onClick: this.handleClick },
                    'NEXT'
                );
            }
        }, {
            key: 'getButtonStyles',
            value: function getButtonStyles(disabled) {
                return {
                    border: 0,
                    background: 'rgba(0,0,0,0.4)',
                    color: 'white',
                    padding: 10,
                    outline: 0,
                    opacity: disabled ? 0.3 : 1,
                    cursor: 'pointer'
                };
            }
        }]);

        return component;
    }(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component),
    position: 'CenterRight'
}, {
    component: function (_React$Component3) {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(component, _React$Component3);

        function component() {
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, component);

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (component.__proto__ || Object.getPrototypeOf(component)).apply(this, arguments));
        }

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(component, [{
            key: 'render',
            value: function render() {
                var _this4 = this;

                var indexes = this.getIndexes(this.props.slideCount, this.props.slidesToScroll);
                return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                    'ul',
                    { style: this.getListStyles() },
                    indexes.map(function (index) {
                        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                            'li',
                            { style: _this4.getListItemStyles(), key: index },
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
                                'button',
                                { style: _this4.getButtonStyles(_this4.props.currentSlide === index), onClick: _this4.props.goToSlide && _this4.props.goToSlide.bind(null, index) },
                                '\u2022'
                            )
                        );
                    })
                );
            }
        }, {
            key: 'getIndexes',
            value: function getIndexes(count, inc) {
                var arr = [];
                for (var i = 0; i < count; i += inc) {
                    arr.push(i);
                }
                return arr;
            }
        }, {
            key: 'getListStyles',
            value: function getListStyles() {
                return {
                    position: 'relative',
                    margin: 0,
                    top: -10,
                    padding: 0
                };
            }
        }, {
            key: 'getListItemStyles',
            value: function getListItemStyles() {
                return {
                    listStyleType: 'none',
                    display: 'inline-block'
                };
            }
        }, {
            key: 'getButtonStyles',
            value: function getButtonStyles(active) {
                return {
                    border: 0,
                    background: 'transparent',
                    color: 'black',
                    cursor: 'pointer',
                    padding: 10,
                    outline: 0,
                    fontSize: 24,
                    opacity: active ? 1 : 0.5
                };
            }
        }]);

        return component;
    }(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component),
    position: 'BottomCenter'
}];
/* harmony default export */ __webpack_exports__["a"] = (DefaultDecorators);

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(424);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);
var bind = __webpack_require__(214);
var Axios = __webpack_require__(426);
var defaults = __webpack_require__(122);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(218);
axios.CancelToken = __webpack_require__(440);
axios.isCancel = __webpack_require__(217);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(441);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 425 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(122);
var utils = __webpack_require__(18);
var InterceptorManager = __webpack_require__(435);
var dispatchRequest = __webpack_require__(436);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(216);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);
var transformData = __webpack_require__(437);
var isCancel = __webpack_require__(217);
var defaults = __webpack_require__(122);
var isAbsoluteURL = __webpack_require__(438);
var combineURLs = __webpack_require__(439);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(18);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(218);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_unfold_wap.9ab0c5f2.svg";

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/huoban.678ce3ab.png";

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pinpai.053a5083.png";

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/image_zizhi-wap.d49604db.png";

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_wing_blank_style_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_wing_blank_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_wing_blank_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_wing_blank__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_wing_blank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_wing_blank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_carousel_style_css__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_carousel_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_carousel_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_carousel__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_TopBar__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ListPro__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Loading__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_forumAction__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_less__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 安全社区
  * @author wangzhuang
  * */var Forum = (_temp = _class = function (_Component) {
  _inherits(Forum, _Component);function Forum(props, context) {
    _classCallCheck(this, Forum);var _this = _possibleConstructorReturn(this, (Forum.__proto__ || Object.getPrototypeOf(Forum)).call(this, props, context));_this.state = { isLoading: true, loadingClass: false, overstep: false, loadingMore: true, slideLiIndex: parseInt(localStorage.slideLiIndex, 10), curPage: 1 };return _this;
  }_createClass(Forum, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        location.href = '/forum';
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;if (this.isEmptyobj(this.props.cmsapiIndexData)) {
        this.props.fetchCmsapiIndexData().then(function () {
          var cmsapiIndexData = _this2.props.cmsapiIndexData;_this2.setState({ catid: cmsapiIndexData.itemlist.article_list.catid, slideLiIndex: 0 });localStorage.setItem('slideLiIndex', 0);_this2.sildeTabTop();
        });
      }window.addEventListener('scroll', function () {
        return _this2.sildeTabTop();
      });
    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
      var _this3 = this;window.removeEventListener('scroll', function () {
        return _this3.sildeTabTop();
      });
    } }, { key: 'sildeTabTop', value: function sildeTabTop() {
      var sildeBox = this.sildeBox,
          topBar = this.topBar;var docScrollTop = document.documentElement.scrollTop || document.body.scrollTop;if (sildeBox) {
        if (docScrollTop >= sildeBox.offsetTop - topBar.offsetHeight && !this.state.overstep) {
          this.setState({ overstep: true });
        } else if (docScrollTop < sildeBox.offsetTop - topBar.offsetHeight && this.state.overstep) {
          this.setState({ overstep: false });
        }
      }
    } }, { key: 'slideTab', value: function slideTab(obj) {
      var _this4 = this;var sildeBox = this.sildeBox;this.setState({ slideLiIndex: obj.index, curPage: obj.page, catid: obj.catid, loadingMore: false });localStorage.setItem('slideLiIndex', obj.index);if (this.state.overstep) {
        document.documentElement.scrollTop = document.body.scrollTop = sildeBox.offsetTop - sildeBox.offsetHeight;
      }this.props.fetchCmsapiPublish(obj.catid, obj.page).then(function () {
        var cmsapiPublish = _this4.props.cmsapiPublish;_this4.setState({ loadingMore: cmsapiPublish.total_page > cmsapiPublish.cur_page });
      });
    } }, { key: 'fetchPublish', value: function fetchPublish() {
      var _this5 = this;var _state = this.state,
          catid = _state.catid,
          curPage = _state.curPage;this.setState({ loadingMore: false });this.props.fetchCmsapiPublish(catid, curPage + 1, true).then(function () {
        var cmsapiPublish = _this5.props.cmsapiPublish;_this5.setState({ curPage: cmsapiPublish.cur_page, loadingMore: cmsapiPublish.total_page > cmsapiPublish.cur_page });
      });
    } }, { key: 'render', value: function render() {
      var _this6 = this;this.shareWX({ title: '百度安全社区-有AI更安全', content: ' ' });var _props = this.props,
          cmsapiIndexData = _props.cmsapiIndexData,
          cmsapiPublish = _props.cmsapiPublish;var _state2 = this.state,
          loadingMore = _state2.loadingMore,
          slideLiIndex = _state2.slideLiIndex,
          overstep = _state2.overstep;var slideClass = __WEBPACK_IMPORTED_MODULE_7_classnames___default()({ 'section pr z-index-1': true, 'slide-fixed': overstep });var banner = [];var isMore = true;if (!this.isEmptyobj(cmsapiIndexData)) {
        var itemlist = cmsapiIndexData.itemlist;banner.push.apply(banner, _toConsumableArray(itemlist.big_banner.datalist).concat(_toConsumableArray(itemlist.small_banner.datalist)));
      }if (!this.isEmptyobj(cmsapiPublish)) {
        if (cmsapiPublish.total_page > cmsapiPublish.cur_page) {
          isMore = true;
        } else {
          isMore = false;
        }
      }return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'forum' }, !this.isPC() ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'top-bar-box', ref: function ref(el) {
          return _this6.topBar = el;
        } }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_TopBar__["a" /* default */], null)) : '', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'pt130' }, banner.length ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_wing_blank___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_carousel___default.a, { autoplay: true, autoplayInterval: 4000, infinite: true }, banner.map(function (val) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { key: val, href: val.aid ? '/m/forum/page/' + val.aid : val.address && '/m' + val.address || '', target: '_black' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: val.pic, alt: val.title, width: '100%' }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'banner-shade' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', null, val.title)));
      }))) : ''), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: { height: '1.3rem', overflow: 'hidden' }, ref: function ref(el) {
          return _this6.sildeBox = el;
        } }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: slideClass }, !this.isEmptyobj(cmsapiIndexData) && cmsapiIndexData.itemlist.category.length > 2 ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'shade-left' }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'shade-right' })) : null, !this.isEmptyobj(cmsapiIndexData) ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'slide' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li', { className: slideLiIndex === 0 ? 'on' : '', onClick: this.slideTab.bind(this, { index: 0, catid: 0, page: 1 }) }, '\u70ED\u95E8\u63A8\u8350'), cmsapiIndexData.itemlist.category.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('li', { className: slideLiIndex === index + 1 ? 'on' : '', key: index, onClick: _this6.slideTab.bind(_this6, { index: index + 1, catid: item.catid, page: 1 }) }, item.title);
      }))) : '')), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'page-box' }, !this.isEmptyobj(cmsapiPublish) ? cmsapiPublish.datalist.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { key: index, href: '/m/forum/page/' + item.aid, className: 'section', target: '_black' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_ListPro__["a" /* default */], { title: item.title, time: item.publish_time.slice(5, 10), brief: item.pv + '\u4EBA\u9605\u8BFB', imgSrc: item.pic }));
      }) : ''), !this.isEmptyobj(cmsapiPublish) ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Loading__["a" /* default */], { type: isMore, isLoad: loadingMore, callbackFn: this.fetchPublish.bind(this), style: { paddingTop: '0.6rem', paddingBottom: '0.8rem' }, ref: function ref(el) {
          return _this6.loading = el;
        } }) : '');
    } }]);return Forum;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class.propTypes = { fetchCmsapiIndexData: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, fetchCmsapiPublish: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, cmsapiIndexData: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, match: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, cmsapiPublish: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return { cmsapiIndexData: state.cmsapiIndexData, cmsapiPublish: state.cmsapiPublish };
}function mapDispatchToProps(dispatch) {
  return { fetchCmsapiIndexData: function fetchCmsapiIndexData() {
      return Object(__WEBPACK_IMPORTED_MODULE_11__actions_forumAction__["a" /* fetchCmsapiIndexData */])(dispatch);
    }, fetchCmsapiPublish: function fetchCmsapiPublish(catid, page, isMore) {
      return Object(__WEBPACK_IMPORTED_MODULE_11__actions_forumAction__["b" /* fetchCmsapiPublish */])(dispatch, catid, page, isMore);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Forum));

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/image_forum_home.40afc7d8.svg";

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_menu_close.a4bef685.svg";

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_menu.bf4d9e11.svg";

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCmsapiIndexData;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchCmsapiPublish;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file 安全社区首页
 * @author wangzhuang
 */function fetchCmsapiIndexData(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/indexData', {}, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["j" /* GET_CMSAPI_INDEXDATA */], data: data.data });
  });
}function fetchCmsapiPublish(dispatch, catid, page, isMore) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/publishArticleList', { catid: catid, page: page }, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["o" /* GET_CMSAPI_PUBLISH */], data: data.data, isMore: isMore });
  });
}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Mark */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ListPro__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Loading__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_TopBar__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_markAction__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_less__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file mark
  * @author wangzhuang
  * */var Mark = (_temp = _class = function (_Component) {
  _inherits(Mark, _Component);function Mark(props, context) {
    _classCallCheck(this, Mark);var _this = _possibleConstructorReturn(this, (Mark.__proto__ || Object.getPrototypeOf(Mark)).call(this, props, context));_this.state = { tagId: _this.props.match.params.tagId, loadingMore: false };return _this;
  }_createClass(Mark, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        var tagId = this.props.match.params.tagId;location.href = tagId ? '/tag/' + tagId : '/tag';
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;this.props.fetchCmsapiTagArticleData({ tagid: this.state.tagId }).then(function (data) {
        if (data.data.is_error !== 0) {
          _this2.props.history.push('/');
        } else {
          var articleList = _this2.props.cmsapiTagArticleData.itemlist.article_list;_this2.setState({ curPage: articleList.cur_page, loadingMore: true });
        }
      });
    } }, { key: 'fetchArticleData', value: function fetchArticleData() {
      var _this3 = this;var _state = this.state,
          tagId = _state.tagId,
          curPage = _state.curPage;this.setState({ loadingMore: false });this.props.fetchCmsapiTagArticleData({ tagid: tagId, page: curPage + 1 }, true).then(function () {
        var articleList = _this3.props.cmsapiTagArticleData.itemlist.article_list;_this3.setState({ curPage: articleList.cur_page, loadingMore: articleList.total_page > articleList.cur_page });
      });
    } }, { key: 'render', value: function render() {
      this.shareWX({ title: '标签-百度安全社区', content: ' ' });var cmsapiTagArticleData = this.props.cmsapiTagArticleData.itemlist;var loadingMore = this.state.loadingMore;var isMore = true;if (!this.isEmptyobj(cmsapiTagArticleData)) {
        var articleList = cmsapiTagArticleData.article_list;if (articleList.total_page > articleList.cur_page) {
          isMore = true;
        } else {
          isMore = false;
        }
      }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mark' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'top-bar-box' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_TopBar__["a" /* default */], null)), !this.isEmptyobj(cmsapiTagArticleData) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mark-title mui-flex section' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'big' }, '#', cmsapiTagArticleData.tagname[cmsapiTagArticleData.tagid], '#'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'small' }, cmsapiTagArticleData.article_list.total, '\u7BC7\u6587\u7AE0')) : '', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'page-box' }, !this.isEmptyobj(cmsapiTagArticleData) ? cmsapiTagArticleData.article_list.datalist.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/forum/page/' + item.aid, key: item.aid, className: 'section' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ListPro__["a" /* default */], { title: item.title, time: item.publish_time.slice(5, 10), brief: item.pv + '\u4EBA\u9605\u8BFB', imgSrc: item.pic, target: '_black' }));
      }) : ''), !this.isEmptyobj(cmsapiTagArticleData) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Loading__["a" /* default */], { type: isMore, isLoad: loadingMore, callbackFn: this.fetchArticleData.bind(this), style: { paddingTop: '0.6rem', paddingBottom: '0.8rem' } }) : '');
    } }]);return Mark;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { fetchCmsapiTagArticleData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, cmsapiTagArticleData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, match: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return { cmsapiTagArticleData: state.cmsapiTagArticleData };
}function mapDispatchToProps(dispatch) {
  return { fetchCmsapiTagArticleData: function fetchCmsapiTagArticleData(aidObj, isMore) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__actions_markAction__["a" /* fetchCmsapiTagArticleData */])(dispatch, aidObj, isMore);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Mark));

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCmsapiTagArticleData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file 标签页
 * @author wangzhuang
 */function fetchCmsapiTagArticleData(dispatch, tagIdObj, isMore) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/tagArticleData', tagIdObj, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["q" /* GET_CMSAPI_TAGARTICLEDATA */], data: data.data, isMore: isMore });
  });
}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Page */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LikeBtn__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ShadeImg__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ListPro__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TopBar__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_pageAction__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_less__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file page
  * @author wangzhuang
  * */var Page = (_temp = _class = function (_Component) {
  _inherits(Page, _Component);function Page(props, context) {
    _classCallCheck(this, Page);var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props, context));_this.state = { zan: 0, showOff: false, aId: _this.props.match.params.aId };_this.forumLikes = JSON.parse(localStorage.getItem('forumLikes')) || [];_this.LikeBtnClick = _this.LikeBtnClick.bind(_this);return _this;
  }_createClass(Page, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        var aId = this.props.match.params.aId;location.href = aId ? '/article/' + aId : '/article';
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;this.props.fetchCmsapiGetArticleData({ aid: this.state.aId }).then(function (data) {
        var resData = data.data;if (resData.is_error === 0) {
          _this2.setState({ zan: +resData.itemlist.article_detail.zan, showOff: true });_this2.shareWX({ title: resData.itemlist.article_detail.title, content: resData.itemlist.article_detail.subtitle });
        } else {
          _this2.props.history.push('/forum');
        }
      });
    } }, { key: 'LikeBtnClick', value: function LikeBtnClick() {
      var _this3 = this;var _state = this.state,
          aId = _state.aId,
          zan = _state.zan;this.props.fetchCmsapiZan({ aid: aId }).then(function (data) {
        if (data.data.is_error === 0) {
          _this3.forumLikes.push(aId);localStorage.setItem('forumLikes', JSON.stringify(_this3.forumLikes));_this3.setState({ zan: zan + 1 });
        }
      });
    } }, { key: 'render', value: function render() {
      var cmsapiGetArticleData = this.props.cmsapiGetArticleData.itemlist;var articleDetail = cmsapiGetArticleData ? cmsapiGetArticleData.article_detail : {};var mobileAdRecommend = cmsapiGetArticleData ? cmsapiGetArticleData.mobile_ad_recommend : false;var recommendRead = cmsapiGetArticleData ? cmsapiGetArticleData.recommend_read : [];var _state2 = this.state,
          aId = _state2.aId,
          showOff = _state2.showOff;if (!cmsapiGetArticleData) {
        return null;
      }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'top-bar-box' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_TopBar__["a" /* default */], null)), showOff ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'page pt130' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1', { className: 'section' }, articleDetail.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'section page-info' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'page-time' }, articleDetail.publish_time.slice(5, 10)), articleDetail.pv, '\u4EBA\u9605\u8BFB')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'page-conter section', dangerouslySetInnerHTML: { __html: articleDetail.content } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mark-tab mui-flex section detail-label' }, articleDetail.tags_data && articleDetail.tags_data.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/forum/mark/' + item.tagid, key: item.tagid, className: 'align-center insert-btn' }, item.tagname);
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'center', marginTop: '0.6rem', marginBottom: '0.8rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_LikeBtn__["a" /* default */], { num: this.state.zan, hasLike: this.forumLikes.indexOf(aId) > -1, handleClick: this.LikeBtnClick })), mobileAdRecommend && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'insert-box section' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ShadeImg__["a" /* default */], { title: mobileAdRecommend.title, text: mobileAdRecommend.subtitle, imgAlt: mobileAdRecommend.title, imgSrc: mobileAdRecommend.pic, href: mobileAdRecommend.url }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'insert-mod just-end' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: mobileAdRecommend.url, className: 'insert-btn align-center just-center' }, mobileAdRecommend.button_toast))), recommendRead && recommendRead.length !== 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { paddingBottom: '0.8rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'nominate-page section' }, '\u63A8\u8350\u9605\u8BFB'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'page-box' }, recommendRead.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/forum/page/' + item.aid, key: item.aid, className: 'section' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ListPro__["a" /* default */], { title: item.title, time: item.publish_time.slice(5, 10), brief: item.pv + '\u4EBA\u9605\u8BFB', imgSrc: item.pic }));
      })))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { minHeight: '100vh' } }));
    } }]);return Page;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { fetchCmsapiGetArticleData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, fetchCmsapiZan: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, cmsapiGetArticleData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, match: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return { cmsapiGetArticleData: state.cmsapiGetArticleData };
}function mapDispatchToProps(dispatch) {
  return { fetchCmsapiGetArticleData: function fetchCmsapiGetArticleData(aidObj) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__actions_pageAction__["a" /* fetchCmsapiGetArticleData */])(dispatch, aidObj);
    }, fetchCmsapiZan: function fetchCmsapiZan(aidObj) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__actions_pageAction__["b" /* fetchCmsapiZan */])(dispatch, aidObj);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Page));

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LikeBtn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 点赞按钮
  * @author wangzhuang
  */var LikeBtn = (_temp = _class = function (_Component) {
  _inherits(LikeBtn, _Component);function LikeBtn(props, context) {
    _classCallCheck(this, LikeBtn);var _this = _possibleConstructorReturn(this, (LikeBtn.__proto__ || Object.getPrototypeOf(LikeBtn)).call(this, props, context));_this.likeBtnClick = _this.likeBtnClick.bind(_this);return _this;
  }_createClass(LikeBtn, [{ key: 'likeBtnClick', value: function likeBtnClick() {
      var hasLike = this.props.hasLike;if (!hasLike) {
        this.props.handleClick();
      }
    } }, { key: 'render', value: function render() {
      var _props = this.props,
          hasLike = _props.hasLike,
          num = _props.num;var btnClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()({ 'like-btn': true, 'on': hasLike });return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: btnClass, onClick: this.likeBtnClick }, num);
    } }]);return LikeBtn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { hasLike: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, handleClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, num: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number }, _temp);

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShadeImg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 带遮罩大图
  * @author wangzhuang
  */var ShadeImg = (_temp = _class = function (_Component) {
  _inherits(ShadeImg, _Component);function ShadeImg() {
    _classCallCheck(this, ShadeImg);return _possibleConstructorReturn(this, (ShadeImg.__proto__ || Object.getPrototypeOf(ShadeImg)).apply(this, arguments));
  }_createClass(ShadeImg, [{ key: 'render', value: function render() {
      var _props = this.props,
          href = _props.href,
          imgSrc = _props.imgSrc,
          imgAlt = _props.imgAlt,
          title = _props.title,
          text = _props.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'shade-img' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: href, className: 'pr' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imgSrc, width: '100%', alt: imgAlt }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'shade-hint' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'shade-title' }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title-text' }, text))));
    } }]);return ShadeImg;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { href: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, imgSrc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, imgAlt: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string }, _temp);

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCmsapiGetArticleData;
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchCmsapiZan;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file 文章页
 * @author wangzhuang
 */function fetchCmsapiGetArticleData(dispatch, aidObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/getArticleData', aidObj, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["h" /* GET_CMSAPI_GETARTICLEDATA */], data: data.data });
  });
}function fetchCmsapiZan(dispatch, aidObj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/zan', aidObj, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["s" /* GET_CMSAPI_ZAN */], data: data.data });
  });
}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Search */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_search_bar_style_css__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_search_bar_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_search_bar_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_search_bar__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_search_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_search_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ListPage__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Loading__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_searchAction__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_less__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file seatch
  * @author wangzhuang
  * */var Search = (_temp = _class = function (_Component) {
  _inherits(Search, _Component);function Search(props, context) {
    _classCallCheck(this, Search);var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props, context));_this.onChange = function (value) {
      _this.setState({ value: value });
    };_this.clear = function () {
      _this.setState({ value: '' });_this.props.history.push('/search');
    };_this.handleClick = function () {
      _this.manualFocusInst.focus();
    };_this.onSubmit = function (value) {
      _this.saveHistory(value);_this.setState({ showHistory: false, notHavePage: false, searchHistory: JSON.parse(localStorage.getItem('searchHistory')) }, function () {
        _this.loadSearchData(value);_this.setState({ keywords: value });
      });_this.props.history.push('/forum/search/' + value);
    };_this.onCancel = function () {
      location.href = '/m/forum';
    };_this.searchHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];var keywords = _this.props.match.params.keywords;_this.state = { keywords: keywords, value: keywords, showHistory: !keywords, notHavePage: false, loadingMore: true, searchHistory: _this.searchHistory };_this.MAX_HISTORY = 10;return _this;
  }_createClass(Search, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        var keywords = this.props.match.params.keywords;location.href = keywords ? '/search?kwd=' + keywords : '/search';
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var value = this.state.value;value && this.loadSearchData(value);
    } }, { key: 'saveHistory', value: function saveHistory(value) {
      var searchHistory = this.state.searchHistory;var valueIndex = searchHistory.indexOf(value); // 空字符串不添加历史
      if (value === '') {
        return;
      } // 去除重复的历史
      if (valueIndex !== -1) {
        searchHistory.splice(valueIndex, 1);searchHistory.unshift(value);
      } else {
        searchHistory.unshift(value);
      } // 最多10条历史
      var len = searchHistory.length;if (len > this.MAX_HISTORY) {
        searchHistory.splice(0, len - this.MAX_HISTORY);
      }localStorage.setItem('searchHistory', JSON.stringify(searchHistory));
    } }, { key: 'loadSearchData', value: function loadSearchData(value) {
      var _this2 = this;this.props.fetchCmsapiSearchArticle({ kwd: value, catid: 0, page: 1 }).then(function () {
        var articleList = _this2.props.cmsapiSearchArticle.itemlist.article_list;if (articleList.datalist.length) {
          _this2.setState({ curPage: articleList.cur_page, notHavePage: false, loadingMore: articleList.total_page > articleList.cur_page });
        } else {
          _this2.setState({ notHavePage: true });
        }
      });
    } }, { key: 'fetchPublish', value: function fetchPublish() {
      var _this3 = this;this.setState({ loadingMore: false });var _state = this.state,
          keywords = _state.keywords,
          curPage = _state.curPage;if (keywords !== undefined) {
        this.props.fetchCmsapiSearchArticle({ kwd: keywords, catid: 0, page: curPage + 1 }, true).then(function () {
          var articleList = _this3.props.cmsapiSearchArticle.itemlist.article_list;_this3.setState({ curPage: articleList.cur_page, loadingMore: articleList.total_page > articleList.cur_page });
        });
      }
    } }, { key: 'render', value: function render() {
      var _this4 = this;this.shareWX({ title: '搜索-百度安全社区', content: ' ' });var _state2 = this.state,
          showHistory = _state2.showHistory,
          searchHistory = _state2.searchHistory,
          notHavePage = _state2.notHavePage,
          loadingMore = _state2.loadingMore,
          value = _state2.value;var cmsapiSearchArticle = this.props.cmsapiSearchArticle;var isMore = true;if (!this.isEmptyobj(cmsapiSearchArticle)) {
        var articleList = cmsapiSearchArticle.itemlist.article_list;isMore = articleList.total_page > articleList.cur_page;
      }return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'search' }, this.isPC() ? '' : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'section search-box' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_search_bar___default.a, { value: value ? value : '', placeholder: '想找什么呢？', onSubmit: this.onSubmit, onClear: this.clear, onFocus: function onFocus() {
          if (_this4.state.showHistory) {
            return;
          }_this4.setState({ showHistory: true });
        }, onCancel: this.onCancel, showCancelButton: true, onChange: this.onChange })), searchHistory.length !== 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'search-history-box section', style: { display: showHistory ? 'block' : 'none' } }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'search-title' }, '\u641C\u7D22\u5386\u53F2'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'search-history' }, searchHistory.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'just-bet', key: 'm' + index + item }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'search-key', onClick: function onClick() {
            _this4.setState({ value: item });_this4.onSubmit(item);
          } }, item), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'clear-note', onClick: function onClick() {
            var searchHistory = _this4.state.searchHistory;searchHistory.splice(index, 1);localStorage.setItem('searchHistory', JSON.stringify(searchHistory));_this4.setState({ searchHistory: JSON.parse(localStorage.getItem('searchHistory')) });
          } }));
      }))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'page-main' }, !showHistory && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'page-box', style: { marginTop: '0.6rem' } }, !this.isEmptyobj(cmsapiSearchArticle) ? cmsapiSearchArticle.itemlist.article_list.datalist.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: '/m/forum/page/' + item.aid, key: index, className: 'section', target: '_black' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ListPage__["a" /* default */], { title: item.title, text: item.subtitle }));
      }) : '', notHavePage ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'not-have-page pr' }, '\u627E\u4E0D\u5230\u4F60\u67E5\u8BE2\u7684\u5185\u5BB9\u5566~(>_<)~') : ''), !this.isEmptyobj(cmsapiSearchArticle) && !showHistory && cmsapiSearchArticle.itemlist.article_list.datalist.length && !notHavePage ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Loading__["a" /* default */], { type: isMore, isLoad: loadingMore, callbackFn: this.fetchPublish.bind(this), style: { paddingTop: '0.6rem', paddingBottom: '0.8rem' }, ref: function ref(el) {
          return _this4.loading = el;
        } }) : '')));
    } }]);return Search;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class.propTypes = { fetchCmsapiSearchArticle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, cmsapiSearchArticle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, match: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, history: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return { cmsapiSearchArticle: state.cmsapiSearchArticle };
}function mapDispatchToProps(dispatch) {
  return { fetchCmsapiSearchArticle: function fetchCmsapiSearchArticle(aidObj, isMore) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__actions_searchAction__["a" /* fetchCmsapiSearchArticle */])(dispatch, aidObj, isMore);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Search));

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);








var TouchFeedback = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TouchFeedback, _React$Component);

    function TouchFeedback() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TouchFeedback);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TouchFeedback.__proto__ || Object.getPrototypeOf(TouchFeedback)).apply(this, arguments));

        _this.state = {
            active: false
        };
        _this.onTouchStart = function (e) {
            _this.triggerEvent('TouchStart', true, e);
        };
        _this.onTouchMove = function (e) {
            _this.triggerEvent('TouchMove', false, e);
        };
        _this.onTouchEnd = function (e) {
            _this.triggerEvent('TouchEnd', false, e);
        };
        _this.onTouchCancel = function (e) {
            _this.triggerEvent('TouchCancel', false, e);
        };
        _this.onMouseDown = function (e) {
            // pc simulate mobile
            _this.triggerEvent('MouseDown', true, e);
        };
        _this.onMouseUp = function (e) {
            _this.triggerEvent('MouseUp', false, e);
        };
        _this.onMouseLeave = function (e) {
            _this.triggerEvent('MouseLeave', false, e);
        };
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TouchFeedback, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.disabled && this.state.active) {
                this.setState({
                    active: false
                });
            }
        }
    }, {
        key: 'triggerEvent',
        value: function triggerEvent(type, isActive, ev) {
            var eventType = 'on' + type;
            var children = this.props.children;

            if (children.props[eventType]) {
                children.props[eventType](ev);
            }
            if (isActive !== this.state.active) {
                this.setState({
                    active: isActive
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                disabled = _props.disabled,
                activeClassName = _props.activeClassName,
                activeStyle = _props.activeStyle;

            var events = disabled ? undefined : {
                onTouchStart: this.onTouchStart,
                onTouchMove: this.onTouchMove,
                onTouchEnd: this.onTouchEnd,
                onTouchCancel: this.onTouchCancel,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            var child = __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.only(children);
            if (!disabled && this.state.active) {
                var _child$props = child.props,
                    style = _child$props.style,
                    className = _child$props.className;

                if (activeStyle !== false) {
                    if (activeStyle) {
                        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, activeStyle);
                    }
                    className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, activeClassName);
                }
                return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: className,
                    style: style }, events));
            }
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(child, events);
        }
    }]);

    return TouchFeedback;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (TouchFeedback);

TouchFeedback.defaultProps = {
    disabled: false
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (props) {
    return Object.keys(props).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
            prev[key] = props[key];
        }
        return prev;
    }, {});
};

module.exports = exports['default'];

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
function noop() {}
var defaultProps = exports.defaultProps = {
    prefixCls: 'am-search',
    placeholder: '',
    onSubmit: noop,
    onChange: noop,
    onFocus: noop,
    onBlur: noop,
    onClear: noop,
    showCancelButton: false,
    disabled: false
};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    cancelText: '取消'
};
module.exports = exports['default'];

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 文章列表（无图片）
  * @author wangzhuang
  */var ListPage = (_temp = _class = function (_Component) {
  _inherits(ListPage, _Component);function ListPage() {
    _classCallCheck(this, ListPage);return _possibleConstructorReturn(this, (ListPage.__proto__ || Object.getPrototypeOf(ListPage)).apply(this, arguments));
  }_createClass(ListPage, [{ key: 'render', value: function render() {
      var _props = this.props,
          title = _props.title,
          text = _props.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-page' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-page-title', dangerouslySetInnerHTML: { __html: title } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-page-text', dangerouslySetInnerHTML: { __html: text } }));
    } }]);return ListPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, text: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string }, _temp);

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCmsapiSearchArticle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file 搜索页
 * @author wangzhuang
 */function fetchCmsapiSearchArticle(dispatch, aidObj, isMore) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/searchArticle', aidObj, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["p" /* GET_CMSAPI_SEARCHARTICLE */], data: data.data, isMore: isMore });
  });
}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_cancel.49749045.svg";

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_nav_bar_style_css__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_nav_bar_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_nav_bar_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_nav_bar__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_nav_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_nav_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file navbar
  * @author wangzhuang
  */var SAFE_ADVISORY = 'SAFE_ADVISORY';var TopBar = (_temp = _class = function (_Component) {
  _inherits(TopBar, _Component);function TopBar() {
    var _ref;_classCallCheck(this, TopBar);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }var _this = _possibleConstructorReturn(this, (_ref = TopBar.__proto__ || Object.getPrototypeOf(TopBar)).call.apply(_ref, [this].concat(args)));_this.onMaskClick = function () {
      _this.setState({ userShow: false, menuShow: false });
    };_this.changeLogin = function () {
      var _this$state = _this.state,
          isLogin = _this$state.isLogin,
          loginUrl = _this$state.loginUrl;var params = _this.getParams() || {};if (/\/haoma\/guide/.test(location.href) && params.url) {
        location.href = _this.loginUrl(params.url);return;
      }if (isLogin) {
        location.href = '/user/logout?redirect_url=' + encodeURIComponent(location.href);
      } else {
        location.href = loginUrl;
      }
    };var res = _this.isTest();_this.state = { userShow: false, menuShow: false, isLogin: false, navIndex: [], navIndex2: [], extraIndex: [], isTest: res, loginUrl: _this.loginUrl() };return _this;
  }_createClass(TopBar, [{ key: 'componentDidMount', value: function componentDidMount() {
      this.setState({ userShow: false });
    } }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;if (nextProps.history.location.pathname === '/' && this.props.history.location.pathname !== '/' && this.state.menuShow) {
        this.setState({ menuShow: false, navIndex: [], navIndex2: [] });
      }var userInfo = nextProps.userInfo,
          productId = nextProps.productId,
          navList = nextProps.navList,
          changeNavIndex = nextProps.changeNavIndex;var _state = this.state,
          navIndex = _state.navIndex,
          navIndex2 = _state.navIndex2;if (!this.isEmptyobj(userInfo)) {
        this.setState({ isLogin: userInfo.status === 0 });
      }if (!this.isEmptyobj(productId) && navList) {
        var id = productId.id;navList.forEach(function (item, index) {
          item.child.forEach(function (item2, index2) {
            if (item2.flag === 'page' && item2.alias === id) {
              changeNavIndex(index);navIndex[index] = true;_this2.setState({ navIndex: navIndex });
            } else if (item2.flag === 'navigation') {
              item2.child.forEach(function (item3) {
                if (item3.alias === id) {
                  changeNavIndex(index);navIndex[index] = true;navIndex2[index2] = true;_this2.setState({ navIndex: navIndex, navIndex2: navIndex2 });
                }
              });
            }
          });
        });
      }if (navList !== this.props.navList && location.href.match('bug_search')) {
        this.setState({ extraIndex: [SAFE_ADVISORY] });
      }
    } }, { key: 'render', value: function render() {
      var _this3 = this;var _state2 = this.state,
          userShow = _state2.userShow,
          menuShow = _state2.menuShow,
          isLogin = _state2.isLogin,
          navIndex = _state2.navIndex,
          navIndex2 = _state2.navIndex2,
          loginUrl = _state2.loginUrl,
          extraIndex = _state2.extraIndex;var _props = this.props,
          userInfo = _props.userInfo,
          navList = _props.navList,
          productId = _props.productId;var userEl = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'user-el' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'single-foo-menu' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: '/m/apply', target: '_blank' }, '\u4E1A\u52A1\u54A8\u8BE2'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: '/m/brand' }, '\u767E\u5EA6\u5B89\u5168\u54C1\u724C'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: isLogin ? '/console/' : loginUrl }, '\u63A7\u5236\u53F0')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'user-info' }, isLogin ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'user-name' }, userInfo.data.user_name) : '', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'login-btn', onClick: this.changeLogin }, isLogin ? '退出' : '登录')));var menuEl = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'menu-el-box' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul', { className: 'menu-el' }, navList ? navList.map(function (item, index) {
        if (parseInt(item.navigation_id, 10) === 6) {
          return;
        }return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li', { className: navIndex[index] ? 'on' : '', key: index }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'just-bet', style: { paddingLeft: '.4rem' }, onClick: function onClick() {
            navIndex[index] = !navIndex[index];_this3.setState({ navIndex: navIndex, navIndex2: navIndex[index] ? navIndex2 : [] });
          } }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', null, item.navigation_name), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'menu-el-icon' })), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul', null, item.child.length ? item.child.map(function (item2, index2) {
          return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li', { className: navIndex2[index2] ? 'on' : '', key: index2 }, item2.flag === 'page' ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: '/m/product/' + item2.alias, className: 'menu-el-page ' + (item2.alias === productId.id ? 'on' : ''), style: { paddingLeft: '.8rem' } }, item2.navigation_name) : '', item2.flag === 'navigation' ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'just-bet', style: { paddingLeft: '.8rem' }, onClick: function onClick() {
              navIndex2[index2] = !navIndex2[index2];_this3.setState({ navIndex2: navIndex2 });
            } }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', null, item2.navigation_name), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'menu-el-icon' })) : '', item2.flag === 'navigation' ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul', null, item2.child.map(function (item3, index3) {
            if (item3.navigation_name === '安全指数') {
              return null;
            }return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li', { key: index3 }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: '/m/product/' + item3.alias, style: { paddingLeft: '1.2rem' }, className: 'menu-el-page ' + (item3.alias === productId.id ? 'on' : '') }, item3.navigation_name));
          })) : '');
        }) : ''));
      }) : '', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li', { className: extraIndex.indexOf(SAFE_ADVISORY) > -1 ? 'on' : '' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'just-bet', onClick: function onClick() {
          var cur = extraIndex.slice(0);var index = extraIndex.indexOf(SAFE_ADVISORY);if (index > -1) {
            cur.splice(index, 1);
          } else {
            cur.push(SAFE_ADVISORY);
          }_this3.setState({ extraIndex: cur });
        }, style: { paddingLeft: '.4rem' } }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', null, '\u5B89\u5168\u8D44\u8BAF'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'menu-el-icon' })), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li', { className: 'extra-el' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: '/m/forum' }, '\u5B89\u5168\u793E\u533A')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li', { className: 'extra-el' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: '/m/bug_search', className: location.href.match('bug_search') ? 'on' : '' }, '\u6F0F\u6D1E\u5E93')))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('li', { className: 'extra-el' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: '/m/about', className: location.href.match('about') ? 'on' : '' }, '\u5173\u4E8E\u6211\u4EEC'))));return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'nav-bar' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: userShow ? 'single-menu-active' : '' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_nav_bar___default.a, { className: 'single-top-nav-bar', mode: 'light', icon: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { className: 'spu-logo', href: '/m/' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { src: __webpack_require__(484), alt: 'spu-logo' })), rightContent: userShow || menuShow ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { className: 'spu-nav-close', key: 2, src: __webpack_require__(485), alt: 'spu-menu', onClick: function onClick() {
            _this3.setState({ userShow: false, menuShow: false });
          } }) : [__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { className: 'spu-account', key: 0, src: __webpack_require__(222), alt: 'spu-account', onClick: function onClick() {
            _this3.setState({ userShow: !_this3.state.userShow });
          } }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img', { className: 'spu-menu', key: 1, src: __webpack_require__(486), alt: 'spu-menu', onClick: function onClick() {
            _this3.setState({ menuShow: !_this3.state.menuShow });
          } })] }), userShow ? userEl : null, menuShow ? menuEl : null, userShow || menuShow ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'menu-mask', onClick: this.onMaskClick }) : null));
    } }]);return TopBar;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class.propTypes = { changeNavIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, userInfo: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, productId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, navList: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array, history: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* withRouter */])(TopBar));

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(481);

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var NavBar = function (_React$Component) {
    (0, _inherits3['default'])(NavBar, _React$Component);

    function NavBar() {
        (0, _classCallCheck3['default'])(this, NavBar);
        return (0, _possibleConstructorReturn3['default'])(this, (NavBar.__proto__ || Object.getPrototypeOf(NavBar)).apply(this, arguments));
    }

    (0, _createClass3['default'])(NavBar, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                children = _a.children,
                mode = _a.mode,
                icon = _a.icon,
                onLeftClick = _a.onLeftClick,
                leftContent = _a.leftContent,
                rightContent = _a.rightContent,
                restProps = __rest(_a, ["prefixCls", "className", "children", "mode", "icon", "onLeftClick", "leftContent", "rightContent"]);
            return React.createElement(
                'div',
                (0, _extends3['default'])({}, restProps, { className: (0, _classnames2['default'])(className, prefixCls, prefixCls + '-' + mode) }),
                React.createElement(
                    'div',
                    { className: prefixCls + '-left', role: 'button', onClick: onLeftClick },
                    icon ?
                    // tslint:disable-next-line:jsx-no-multiline-js
                    React.createElement(
                        'span',
                        { className: prefixCls + '-left-icon', 'aria-hidden': 'true' },
                        icon
                    ) : null,
                    leftContent
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-title' },
                    children
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-right' },
                    rightContent
                )
            );
        }
    }]);
    return NavBar;
}(React.Component);

exports['default'] = NavBar;

NavBar.defaultProps = {
    prefixCls: 'am-navbar',
    mode: 'dark',
    onLeftClick: function onLeftClick() {}
};
module.exports = exports['default'];

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/spu_logo.2b13cc77.svg";

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/menu-close.6242fad4.svg";

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/spu_menu.da92107d.svg";

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp2;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file footerbar
  * @author wangzhuang
  */var TopBar = (_temp2 = _class = function (_Component) {
  _inherits(TopBar, _Component);function TopBar() {
    var _ref;var _temp, _this, _ret;_classCallCheck(this, TopBar);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TopBar.__proto__ || Object.getPrototypeOf(TopBar)).call.apply(_ref, [this].concat(args))), _this), _this.isHaomaPage = function () {
      var pagesDatabyid = _this.props.pagesDatabyid;var pageType = '';if (pagesDatabyid) {
        var pagesCommon = pagesDatabyid && pagesDatabyid.itemlist && pagesDatabyid.itemlist.pages_common;pageType = pagesCommon && pagesCommon.page_type;
      }var path = location.pathname || '';return pageType === '5001' || /\/haoma\//.test(path);
    }, _this.sendData = function () {
      var pagesDatabyid = _this.props.pagesDatabyid;var pagesCommon = pagesDatabyid && pagesDatabyid.itemlist && pagesDatabyid.itemlist.pages_common;var navName = pagesCommon && pagesCommon.navigation_name;if (_this.isPageTitle('mesatee', navName)) {
        _this.reportData('mesatee_banner');
      }var pageId = pagesCommon.id;window.open('/m/apply/' + pageId, '_blank');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }_createClass(TopBar, [{ key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'footer-bar' }, !this.isHaomaPage() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'footer-goodness align-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '7x24\u5C0F\u65F6'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u4E13\u4E1A\u5316\u56E2\u961F'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u4F01\u4E1A\u7EA7SRC')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'footer-itemize' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://anquan.baidu.com/?type=web' }, '\u5207\u6362\u81F3\u7535\u8111\u7248')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { // href=""
        onClick: this.sendData // target={'_banlk'}
      }, '\u7533\u8BF7\u8BD5\u7528')), !this.isHaomaPage() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, '\u5546\u52A1\u54A8\u8BE2 ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'tel://010-58003138', className: 'footer-phone' }, '010-58003138')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.sendData, className: 'footer-apply' // href="/m/apply"
        // target={'_banlk'}
      }, '\u7ACB\u5373\u54A8\u8BE2'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'footer-wechat' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u5173\u6CE8\u6211\u4EEC'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(489), alt: '\u5173\u6CE8\u6211\u4EEC' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'footer-tips' }, '\xA92020 Baidu ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://www.baidu.com/duty/' }, '\u4F7F\u7528\u767E\u5EA6\u524D\u5FC5\u8BFB'), ' \u4EACICP\u8BC1030173\u53F7'));
    } }]);return TopBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { pagesDatabyid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object }, _temp2);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
  return { pagesDatabyid: state.pagesDatabyid };
})(TopBar));

/***/ }),
/* 488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/weChat.cf4820e4.jpg";

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__numberAuth__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__page_temperature__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__compliance__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__vdc__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__page_app_solution__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__page_imagerecognition__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__page_inspection__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__securityPrivacy__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pageLuBang__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pageUrlSec__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pageTic__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pageTextCheck__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pageBrain__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pageCommercialPassword__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pageSecureSmartLock__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pageLargeModelSecurity__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pageSecAwarenrssSolution__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pageAiSoc__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pageIntelligentDataSecurityGateway__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__actions_productAction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__actions_fileCheckAction__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__index_less__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: wangzhuang@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2024-04-26 11:19:55
  * @FilePath: /m-anquan-baidu-com/src/containers/product/index.js
  * @Description: 产品二级页
  */ // 特殊的套餐模块 产品中的 pageType = 5006
// import PageScanBlock from './page_scan_block';
var nextMap = { '1': '使用服务', '2': '购买服务', '3': '试用服务', '4': '申请服务', '0': null };var skillImgData = [__webpack_require__(641), __webpack_require__(642), __webpack_require__(643), __webpack_require__(644)];var Product = (_temp = _class = function (_Component) {
  _inherits(Product, _Component);function Product(props, context) {
    _classCallCheck(this, Product);var _this = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this, props, context));_this.state = { isLoaded: false, vdcType: 'search', vdcValue: '', vdcPage: false, vdcText: '请输入待检测文件对应的md5', upIng: false };_this.renderScenes = _this.renderScenes.bind(_this);_this.renderContact = _this.renderContact.bind(_this);_this.onImageLoad = _this.onImageLoad.bind(_this);_this.renderTypicalCase = _this.renderTypicalCase.bind(_this);return _this;
  }_createClass(Product, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        var id = this.props.match.params.id;location.href = '/product/' + id;
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;var id = this.props.match.params.id;this.props.fetchPagesDataById(id).then(function (data) {
        if (data.data.is_error === 1) {
          location.href = '/m/';return;
        }var itemlist = data.data.itemlist;if (itemlist && itemlist.pages_common.page_type === '4000' && itemlist.pages_content.service) {
          _this2.props.fetchServiceIntroduce(itemlist.pages_content.service[0].title);
        }if (itemlist && itemlist.pages_common.navigation_name && _this2.isPageTitle('mesatee', itemlist.pages_common.navigation_name)) {
          setTimeout(function () {
            _this2.reportData('mesatee_details');
          }, 500);
        }
      });this.props.fetchProductId(id);
    } }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps(nextProps) {
      var id = nextProps.match.params.id;var pagesDatabyid = nextProps.pagesDatabyid;var pagesCommon = '';if (!this.isEmptyobj(pagesDatabyid)) {
        pagesCommon = pagesDatabyid.itemlist.pages_common;
      }if (!this.isEmptyobj(pagesCommon) && id !== pagesCommon.alias) {
        this.props.history.push('/product/' + pagesCommon.alias);
      }
    } }, { key: 'onImageLoad', value: function onImageLoad(status) {
      this.setState({ isLoaded: status });
    } }, { key: 'renderScenes', value: function renderScenes() {
      var _this3 = this;var pagesContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var pageType = arguments[1];var applyScene = pagesContent.apply_scene || []; // 产品模块支持价格套餐
      if (pageType !== '1000' && pageType !== '5006' || applyScene.length <= 0) {
        return null;
      }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-scenes-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '\u4F7F\u7528\u573A\u666F' })), applyScene && applyScene.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: item.id, className: 'product-scenes-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'scenes' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'img' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: item.mobile_scene_pic, alt: 'mobile_scene_pic' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, item.content), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'logo' }, !_this3.state.isLoaded && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(640), alt: 'product_sences_bg' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onLoad: _this3.onImageLoad.bind(_this3, true), onError: _this3.onImageLoad.bind(_this3, false), src: item.mobile_customer_logo_pic, alt: 'mobile_customer_logo_pic' }))));
      }));
    } }, { key: 'renderContact', value: function renderContact() {
      var pagesCommon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var bizConsult = pagesCommon.biz_consult;if (!bizConsult) {
        return null;
      }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'contact' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bg-image' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'contact-content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'img-wrapper' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'img' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'img-bg' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: bizConsult.mobile_pic, alt: 'mobile_pic' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, bizConsult.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, bizConsult.position))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'introduction' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, bizConsult.desp), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: function onClick() {
          return location.href = '/m/apply/' + pagesCommon.id;
        }, className: 'introduction-btn' }, '\u5546\u52A1\u54A8\u8BE2'))));
    } }, { key: 'renderTypicalCase', value: function renderTypicalCase(typicalCase) {
      return typicalCase.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '典型案例' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod example-box' }, typicalCase.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'mui-flex', href: '/m/community/' + item.id + '/1/3', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: '4rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: item.logo_pic, alt: item.title, width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'example-right' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, item.note), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u67E5\u770B\u8BE6\u60C5>>')));
      })));
    } }, { key: 'renderLearnMore', value: function renderLearnMore(learnMore, next_index) {
      if (learnMore.length === 1) {
        var item = learnMore[0] || {};if (next_index === '0') {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: item.content, target: '_blank', className: 'compliance-btn compliance-btn-border' }, item.title);
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: item.content, target: '_blank', className: 'compliance-btn compliance-btn-border', style: { left: '7rem' } }, item.title);
        }
      }return learnMore.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-tab' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-slide' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, learnMore.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: item.content, target: '_blank' }, item.title));
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tab-shadow' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tab-shadow' })) : null;
    } /**
      * @description 渲染产品页面
      * @param {Object} props - 组件属性对象，包含pagesDatabyid、serviceIntroduce等信息
      * @returns {JSX.Element} 返回JSX元素，展示产品页面的内容
      */ }, { key: 'render', value: function render() {
      var _this4 = this;var _props = this.props,
          pagesDatabyid = _props.pagesDatabyid,
          serviceIntroduce = _props.serviceIntroduce;var pagesCommon = '';var pagesContent = '';var pageType = ''; // 1000=安全产品 2000=安全服务 3000=解决方案 4000=开放服务
      var urlText = '';var proinfoBoxTitle = '';var proinfoBox = [];var profunBoxTitle = '';var profunBox = '';var techSupport = [];var serviceFlow = [];var typicalCase = [];var learnMore = [];var url = '';var nextText = '';var nextUrl = '';if (!this.isEmptyobj(pagesDatabyid)) {
        pagesCommon = pagesDatabyid.itemlist.pages_common;pagesContent = pagesDatabyid.itemlist.pages_content;typicalCase = pagesCommon.typical_case || [];pageType = pagesCommon.page_type;learnMore = pagesContent.learnMore || [];switch (pageType) {case '1000':case '5006':
            proinfoBoxTitle = '产品特色';profunBoxTitle = '产品功能';proinfoBox = pagesContent.prod_feature ? pagesContent.prod_feature : [];profunBox = pagesContent.prod_function ? pagesContent.prod_function : [];break;case '2000':
            proinfoBoxTitle = '服务优势';profunBoxTitle = '服务内容';proinfoBox = pagesContent.service_advantage ? pagesContent.service_advantage : [];profunBox = pagesContent.service_content ? pagesContent.service_content : [];serviceFlow = pagesContent.service_flow ? pagesContent.service_flow : [];break;case '3000':
            proinfoBoxTitle = '适用场景';profunBoxTitle = '方案特点';profunBox = pagesContent.program_features ? pagesContent.program_features : [];break;case '4000':
            proinfoBoxTitle = '应用场景';profunBoxTitle = '能力特点';profunBox = pagesContent.ability_features ? pagesContent.ability_features : [];techSupport = pagesContent.tech_support ? pagesContent.tech_support : [];break;}urlText = pagesCommon.alias === 'ddos' ? '产品咨询 限时试用' : '商务咨询';url = '/m/apply/' + pagesCommon.id;nextUrl = pagesCommon.next_url;nextText = nextMap[pagesCommon.next_index]; // if (pagesCommon.next_index === '2') {
        //     url = pagesCommon.next_url;
        // } else if (pagesCommon.next_index === '4') {
        //     url = '/m/apply-app';
        // } else {
        //     url = `/m/apply/${pagesCommon.id}`;
        // }
      }var serviceMeals = [];if (!this.isEmptyobj(serviceIntroduce)) {
        serviceMeals = serviceIntroduce.itemlist.service_info.service_meals;
      } // 号码认证
      if (pageType === '5001' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__numberAuth__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(645), bannerNote: '百度号码认证提供企业号码认证，企业号码申诉，个人号码申诉和常用号码查询服务', url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      } // 墨源文件威胁感知系统
      if (pageType === '5002' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__vdc__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(646), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5004' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__page_temperature__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(647), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5005' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__compliance__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(648), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5008' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__page_app_solution__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(649), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5007' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__page_imagerecognition__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(650), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5009' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__securityPrivacy__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(651), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5010' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__pageLuBang__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(652), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5011' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__page_inspection__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(653), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5012' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__pageUrlSec__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic, bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5013' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__pageTic__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic, bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5014' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__pageTextCheck__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(654), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5015' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__pageBrain__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(655), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5016' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__pageCommercialPassword__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(656), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5017' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__pageSecureSmartLock__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(657), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText } });
      }if (pageType === '5018' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__pageLargeModelSecurity__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic ? pagesCommon.mobile_banner_pic : __webpack_require__(658), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText, learnMore: learnMore, nextIndex: pagesCommon.next_index } });
      }if (pageType === '5019' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__pageIntelligentDataSecurityGateway__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: pagesCommon.mobile_banner_pic, bannerNote: pagesCommon.banner_note, proinfoBox: pagesContent.prod_feature ? pagesContent.prod_feature : [], profunBox: pagesContent.prod_function ? pagesContent.prod_function : [], url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText, learnMore: learnMore, nextIndex: pagesCommon.next_index } });
      }if (pageType === '5020' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__pageSecAwarenrssSolution__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: __webpack_require__(245), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText, learnMore: learnMore, nextIndex: pagesCommon.next_index } });
      }if (pageType === '5021' && !this.isEmptyobj(pagesDatabyid)) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__pageAiSoc__["a" /* default */], { bannerInfo: { title: pagesCommon.navigation_name, bgImg: __webpack_require__(245), bannerNote: pagesCommon.banner_note, url: url, urlText: urlText, nextUrl: nextUrl, nextText: nextText, learnMore: learnMore, nextIndex: pagesCommon.next_index } });
      }return !this.isEmptyobj(pagesDatabyid) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProBanner__["a" /* default */], { title: pagesCommon.navigation_name, urlText: urlText, bgImg: pagesCommon.mobile_banner_pic, url: url, nextUrl: nextUrl, nextText: nextText }), this.renderLearnMore(learnMore, pagesCommon.next_index)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, pagesCommon.banner_note), pageType === '1000' && pagesContent.prod_struct && pagesContent.prod_struct.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '\u4E1A\u52A1\u7ED3\u6784' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: pagesContent.prod_struct[0] && pagesContent.prod_struct[0].mobile_pic, style: { maxWidth: '10rem', margin: '0 auto 1rem' } })) : null, proinfoBox.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: proinfoBoxTitle })) : null, proinfoBox.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, proinfoBox.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: item.mobile_pic, width: '100%', alt: item.title })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, item.content)));
      })) : '', pagesCommon.alias === 'ddos' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '产品选型' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: pagesContent.lecto_type[0] && pagesContent.lecto_type[0].mobile_pic, style: { maxWidth: '10rem', margin: '0 auto 1rem' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, 'DDoS\u9632\u62A4\u670D\u52A1-\u9AD8\u9632IP'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u603B\u8BA1T\u7EA7\u7684DDoS\u9632\u62A4\u80FD\u529B\uFF0CBGP\u7EBF\u8DEF\uFF0C\u901F\u5EA6\u66F4\u5FEB\uFF0C\u5EF6\u8FDF\u66F4\u5C0F\uFF0C\u7EBF\u8DEF\u66F4\u7A33\u5B9A\uFF0C\u9ED8\u8BA41\u4E2A\u9AD8\u9632IP\u3002')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { style: { textAlign: 'center' }, className: 'service-meals', cellPadding: 0, cellSpacing: 0 }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { style: { width: '16%' } }, '\u4FDD\u5E95\u9632\u62A4\u5957\u9910'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { style: { width: '15%' } }, '\u7EBF\u8DEF'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { style: { width: '15%' } }, '\u7AEF\u53E3\u6570'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { style: { width: '18%' } }, '\u9632\u62A4\u57DF\u540D\u6570'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { style: { width: '16%' } }, '\u4E1A\u52A1\u5BBD\u5E26'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { style: { width: '20%' } }, '\u8D39\u7528'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '10Gb'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, 'BGP'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '50'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '50'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '100M'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { color: 'red' } }, '5800/\u6708')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '30Gb'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, 'BGP'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '50'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '50'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '100M'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { color: 'red' } }, '15800/\u6708')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '100Gb'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, 'BGP'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '50'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '50'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '100M'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { color: 'red' } }, '278000/\u5E74')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '300Gb'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, 'BGP'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '50'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '50'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, '100M'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { style: { color: 'red' } }, '448000/\u5E74')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { marginTop: '0.2rem', fontSize: '.36rem', lineHeight: '.5rem', color: '#999' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { display: 'flex' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u66F4\u591A\u5957\u9910\u8BF7'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { color: 'blue' }, onClick: function onClick() {
          return location.href = '/m/apply/' + pagesCommon.id;
        } }, '\u201C\u8054\u7CFB\u6211\u4EEC\u201D')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { marginTop: '10px' } }, '\u7559\u4E0B\u8054\u7CFB\u65B9\u5F0F\uFF0C\u5373\u53EF\u7ED9\u4E88800~10000\u4EE3\u91D1\u5238\u7528\u4EE5\u8D2D\u4E70\u767E\u5EA6\u4E91\u9AD8\u9632\u5957\u9910\u3002')))) : '', pageType === '4000' && pagesContent.application_scene ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '应用场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, pagesContent.application_scene.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-application', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'application-title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'application-content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: item.mobile_pic, alt: item.title })));
      }))) : '', pageType !== '1000' && pageType !== '5006' && pagesContent.applicable_scene ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '适用场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, pagesContent.applicable_scene.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable', key: index, style: { backgroundImage: 'url(' + item.mobile_pic + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, item.content));
      }))) : '', serviceFlow.length && serviceFlow[0].pic ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '服务流程' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, serviceFlow.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: item.mobile_pic, alt: '\u670D\u52A1\u6D41\u7A0B', width: '100%', key: index });
      }))) : '', profunBox ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: profunBoxTitle })) : '', profunBox.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, profunBox.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des', dangerouslySetInnerHTML: { __html: item.content } })));
      })) : '', (pageType === '1000' || pageType === '5006') && pagesContent.applicable_scene ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '适用场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, pagesContent.applicable_scene.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable', key: index, style: { backgroundImage: 'url(' + item.mobile_pic + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, item.content));
      }))) : '', this.renderScenes(pagesContent, pageType), serviceMeals.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '产品价格' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table', { className: 'service-meals', cellPadding: 0, cellSpacing: 0 }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', null, '\u5957\u9910\u540D\u79F0'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', null, '\u67E5\u8BE2\u6B21\u6570'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', null, '\u8C03\u7528\u9891\u7387'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', null, '\u6709\u6548\u65F6\u95F4'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', null, '\u4EF7\u683C')), serviceMeals.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr', { key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, item.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, item.capacity, '\u6B21'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, item.second, '\u6B21/\u79D2'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, _this4.formatTime(item.time)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null, item.price));
      })))) : '', techSupport.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '技术支持' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { textAlign: 'center' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod tech-support-box' }, techSupport.length ? techSupport.map(function (item, index) {
        if (item.content && item.content !== ',') {
          var pic = '';var bbscon = item.content.split(',');var content = '';switch (item.title) {case '技术咨询':
              pic = skillImgData[0];content = item.content;break;case '客服QQ':
              pic = skillImgData[1];content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'tencent://message/?uin=435826780&Site=\n                                                            ' + item.content + '&menu=yes', className: 'tech-support-title' }, item.content);break;case '社区论坛':
              pic = skillImgData[2];if (bbscon[0]) {
                content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { target: '_blank', href: 'http://' + bbscon[1] }, bbscon[0]);
              } else {
                content = 'forbid_show';
              }break;case '联系邮箱':
              pic = skillImgData[3];content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'mailto:' + item.content }, item.content);break;default:
              break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tech-support', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tech-support-pic' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: pic, alt: item.title })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tech-support-title' }, item.title, '\uFF1A', content));
        }
      }) : ''))), this.renderTypicalCase(typicalCase), pagesCommon.mobile_friend ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '合作伙伴' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: pagesCommon.mobile_friend, alt: '\u5408\u4F5C\u4F19\u4F34', style: { width: '100%' } }))) : '', pagesCommon && this.renderContact(pagesCommon)) : '';
    } }]);return Product;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { fetchUrlUpload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, fetchPagesDataById: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, fetchServiceIntroduce: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, fetchProductId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, match: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, serviceIntroduce: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, navigationList: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, pagesDatabyid: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, navListIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return { pagesDatabyid: state.pagesDatabyid, navListIndex: state.navListIndex, serviceIntroduce: state.serviceIntroduce };
}function mapDispatchToProps(dispatch) {
  return { fetchUrlUpload: function fetchUrlUpload(obj, type) {
      return Object(__WEBPACK_IMPORTED_MODULE_25__actions_fileCheckAction__["a" /* fetchUrlUpload */])(dispatch, obj, type);
    }, fetchPagesDataById: function fetchPagesDataById(id) {
      return Object(__WEBPACK_IMPORTED_MODULE_24__actions_productAction__["f" /* fetchPagesDataById */])(dispatch, id);
    }, fetchServiceIntroduce: function fetchServiceIntroduce(itemid) {
      return Object(__WEBPACK_IMPORTED_MODULE_24__actions_productAction__["h" /* fetchServiceIntroduce */])(dispatch, itemid);
    }, fetchProductId: function fetchProductId(id) {
      return Object(__WEBPACK_IMPORTED_MODULE_24__actions_productAction__["g" /* fetchProductId */])(dispatch, id);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Product));

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_searchBar__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_numberAuthAction__ = __webpack_require__(124);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 号码认证二级模块
  * @author: wence
  */var NumberAuth = (_temp = _class = function (_PureComponent) {
  _inherits(NumberAuth, _PureComponent);function NumberAuth() {
    _classCallCheck(this, NumberAuth);return _possibleConstructorReturn(this, (NumberAuth.__proto__ || Object.getPrototypeOf(NumberAuth)).apply(this, arguments));
  }_createClass(NumberAuth, [{ key: 'componentDidMount', value: function componentDidMount() {// this.props.getNumberCommonList();
    } }, { key: 'render', value: function render() {
      var numberCommonList = this.props.numberCommonList;var bannerInfo = this.props.bannerInfo || {};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proBanner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url })), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, bannerInfo.bannerNote, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u5173\u4E8E\u53F7\u7801\u6807\u8BB0\uFF0C\u7533\u8BC9\u53CA\u95EE\u9898\u89E3\u7B54\uFF0C\u60A8\u53EF\u6DFB\u52A0QQ\u7FA4 ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { style: { color: '#38F' } }, '119723959'), ' \u8054\u7CFB\u7FA4\u5185\u5DE5\u4F5C\u4EBA\u5458'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ProductTitle__["a" /* default */], { title: '\u4E1A\u52A1\u53D7\u7406' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://haoma.baidu.com/attest', className: 'number-auth-product-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'number-auth-product-item-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(497), alt: 'icon' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'number-auth-product-item-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u4F01\u4E1A\u53F7\u7801\u8BA4\u8BC1'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u901A\u8BDD\u65F6\u663E\u793A\u4F01\u4E1A\u4E13\u5C5E\u7535\u8BDD\u540D\u724C')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(75), alt: 'icon' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://haoma.baidu.com/appeal', className: 'number-auth-product-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'number-auth-product-item-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(223), alt: 'icon' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'number-auth-product-item-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u4F01\u4E1A\u53F7\u7801\u7533\u8BC9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u4F01\u4E1A\u53F7\u7801\u4FE1\u606F\u663E\u793A\u9519\u8BEF\u53EF\u7533\u8BC9\u4FEE\u6B63')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(75), alt: 'icon' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://haoma.baidu.com/appeal', className: 'number-auth-product-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'number-auth-product-item-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(224), alt: 'icon' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'number-auth-product-item-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u4E2A\u4EBA\u53F7\u7801\u7533\u8BC9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u4E2A\u4EBA\u53F7\u7801\u4FE1\u606F\u663E\u793A\u9519\u8BEF\u53EF\u7533\u8BC9\u4FEE\u6B63')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(75), alt: 'icon' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://haoma.baidu.com/mark', className: 'number-auth-product-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'number-auth-product-item-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(225), alt: 'icon' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'number-auth-product-item-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u9A9A\u6270\u7535\u8BDD\u4E3E\u62A5'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u9A9A\u6270\u7535\u8BDD\u4E0D\u80DC\u5176\u70E6\u53EF\u5FEB\u901F\u4E3E\u62A5')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(75), alt: 'icon' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { display: 'none' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ProductTitle__["a" /* default */], { title: '\u5E38\u7528\u53F7\u7801' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { display: 'none' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/haoma/search' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_searchBar__["a" /* default */], { disabled: true, placeholder: '\u8BF7\u8F93\u5165\u8981\u67E5\u8BE2\u7684\u7535\u8BDD\u53F7\u7801\u6216\u5173\u952E\u5B57' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'number-auth-hotline' }, !!numberCommonList && numberCommonList.length > 0 && numberCommonList.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/haoma/common/' + item.id, key: item.id, className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('number-auth-hotline-item', { no: (index + 1) % 4 === 0 && index !== 0 }) }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'img' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: item.iconurl, alt: item.name })), item.name);
      }))));
    } }]);return NumberAuth;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, numberCommonList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, getNumberCommonList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state) {
  return { numberCommonList: state.numberCommonList };
}, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({ getNumberCommonList: __WEBPACK_IMPORTED_MODULE_9__actions_numberAuthAction__["b" /* getNumberCommonList */] }, dispatch);
})(NumberAuth)));

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_search_btn.b1a03883.svg";

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_input clear.73be395c.svg";

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_qiyehaomarenzheng.43ad592d.svg";

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageTemperature; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_temperature_less__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_temperature_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__page_temperature_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: wence@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2023-06-09 15:28:30
  * @FilePath: /m-anquan-baidu-com/src/containers/product/page_temperature.js
  * @Description: ai体温检测解决方案
  */var PageTemperature = (_temp = _class = function (_PureComponent) {
  _inherits(PageTemperature, _PureComponent);function PageTemperature() {
    _classCallCheck(this, PageTemperature);return _possibleConstructorReturn(this, (PageTemperature.__proto__ || Object.getPrototypeOf(PageTemperature)).apply(this, arguments));
  }_createClass(PageTemperature, [{ key: 'render', value: function render() {
      var bannerInfo = this.props.bannerInfo || {};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, '\u57FA\u4E8E\u767E\u5EA6AI\u56FE\u50CF\u8BC6\u522B\u6280\u672F\u548C\u7EA2\u5916\u70ED\u6210\u50CF\u6280\u672F\u7684\u6574\u5408\uFF0C\u5F62\u6210\u5B8C\u5584\u7684\u591A\u4EBA\u4F53\u6E29\u5FEB\u901F\u68C0\u6D4B\u65B9\u6848\uFF0C\u53EF\u5BF9\u4EBA\u6D41\u4E2D\u591A\u4EBA\u989D\u5934\u6E29\u5EA6\u540C\u65F6\u8FDB\u884C\u5FEB\u901F\u7B5B\u9009\u53CA\u9884\u8B66\uFF0C\u65B9\u4FBF\u4EBA\u6D41\u805A\u96C6\u5904\u7684\u5FEB\u901F\u7B5B\u9009\u3002\u652F\u6301\u56FA\u5B9A\u68C0\u6D4B\u70B9\u548C\u4F7F\u7528\u79FB\u52A8\u8BBE\u5907\u8FDB\u884C\u5DE1\u68C0\u4E24\u79CD\u6A21\u5F0F\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u89E3\u51B3\u65B9\u6848\u7B80\u4ECB' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-des' }, '\u4F7F\u2F64\u4EBA\u8138\u68C0\u6D4B\u5173\u952E\u70B9\u5B9A\u4F4D\uFF08\u7CBE\u51C6\u5B9A\u4F4D\u5305\u62EC\u8138\u988A\u3001\u7709\u3001\u773C\u3001\u53E3\u3001\u9F3B\u7B49\u4EBA\u8138\u4E94\u5B98\u53CA\u8F6E\u5ED3\u7684150\u4E2A\u5173\u952E\u70B9\uFF09\u53CA\u56FE\u50CF\u7EA2\u5916\u6E29\u5EA6\u70B9\u9635\u6E29\u5EA6\u5206\u6790\u7B97\u6CD5\uFF0C \u53EF\u4EE5\u5728\u2F00\u5B9A\u2FAF\u79EF\u8303\u56F4\u5185\u6279\u91CF\u5BF9\u591A\u4EBA\u540C\u65F6\u8FDB\uFA08\u4F53\u6E29\u7B5B\u67E5\u3002 \u5B9E\u65F6\u76D1\u6D4B\u591A\u4EBA\u6D41\u573A\u666F\u52A8\u6001\uFF0C\u5BF9\u4F53\u6E29\u8D85\u51FA\u2F00\u5B9A\u9608\u503C\u7684\u4EBA\u5458\uFF0C\u7CFB\u7EDF\u4E88\u4EE5\u544A\u8B66\uFF0C \u5E2E\u52A9\u5DE5\u4F5C\u2F08\u5458\u8FC5\u901F\u67E5\u51FA\u6E29\u5EA6\u53EF\u7591\u2F08\u5458\uFF0C\u91C7\u53D6\u6709\u6548\u63AA\u65BD\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-img des-img1' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-des-title' }, '\u56FA\u5B9A\u70B9\u4F4D\u68C0\u6D4B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-des-sub' }, '\u2F08\u6D41\u4ECE\u56FA\u5B9A\u76D1\u6D4B\u70B9\u524D\u9762\u7ECF\u8FC7\uFF0C\u76D1\u6D4B\u70B9\u7684\u8BBE\u5907\u91C7\u96C6\u4EBA\u8138\u548C\u4F53\u6E29\u4FE1\u606F\u8FDB\uFA08\u5206\u6790\u7B5B\u67E5\u3002\u53D1\u73B0\u6E29\u5EA6\u5F02\u5E38\u5BF9\u8C61\u518D\u4F7F\u7528\u989D\u6E29\u67AA\u8FDB\u2F8F\u2F06\u6B21\u7B5B\u67E5\uFF0C\u63D0\u5347\u2F08\u6D41\u901A\u8FC7\u6548\u7387\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-img des-img2' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-des-title' }, '\u79FB\u52A8\u5DE1\u67E5'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-des-sub' }, '\u4F7F\u2F64\u79FB\u52A8\u8BBE\u5907\u5BF9\u4EBA\u7FA4\u8FDB\u2F8F\u2FAE\u63A5\u89E6\u5F0F\u6279\u91CF\u5DE1\u67E5\uFF0C\u53D1\u73B0\u6E29\u5EA6\u5F02\u5E38\u5BF9\u8C61\u518D\u4F7F\u2F64\u989D\u6E29\u67AA\u8FDB\uFA08\u2F06\u6B21\u7B5B\u67E5\uFF0C\u63D0\u5347\u5DE1\u67E5\u6548\u7387\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u4E1A\u52A1\u7ED3\u6784' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-img tree-img' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-sence-container' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u4E1A\u52A1\u573A\u666F' })), [{ title: '地铁/高铁/车站/机场卡点多人体温检测预警', img: __webpack_require__(500) }, { title: '安防领域热成像', img: __webpack_require__(501) }, { title: '电力、石油、化工等行业热成像监控', img: __webpack_require__(502) }].map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, style: { backgroundImage: 'url(' + item.img + ')' }, className: 'saas-p-sence-item' }, item.title);
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u65B9\u6848\u4F18\u52BF' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-advantage' }, [{ title: '实时高效', des: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u5728\u5355\u2F08\u901A\u9053\u987A\u5E8F\u901A\uFA08\u6761\u4EF6\u4E0B\uFF0C\u53EF\u57281\u5206\u949F\u5185\u5B9E\u73B0\u5BF9\u903E200\u2F08\u540C\u65F6\u901A\u8FC7\u7684\u4F53\u6E29\u5B9E\u65F6\u68C0\u6D4B\uFF0C\u5B9E\u73B0\u2F08\u7FA4\u65E0\u505C\uF9CD\u8FC7\u68C0\uFF0C\u7F13\u89E3\u4EBA\u5458\u5835\u585E\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '*\u53C2\u8003\u6570\u636E\uFF0C\u53D7\u2F08\u7FA4\u5BC6\u5EA6\u53CA\uFA08\u8FDB\u901F\u5EA6\u5F71\u54CD\u3002')), url: __webpack_require__(503) }, { title: '精准可靠', des: '实现了体温检测与人脸识别的技术同步及佩戴⼝罩时的识别问题，可准确定位、快速锁定体温异常人员并实时⾃动告警，⽅便⼯作人员进行⼆次复检。', url: __webpack_require__(504) }, { title: '非接触无感知', des: '借助全⾃动化的体温检测，被检人员仅需做弱配合，大幅减少相互的近距离接触，降低潜在的安全隐患。', url: __webpack_require__(505) }, { title: '快速部署降低成本', des: '实现检测结果的实时可视化，并可在通道、重要区域快速部署，有效降低成本，缓解疫情防控期间紧张的⼈力资源调配。', url: __webpack_require__(506) }].map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-p-advantage-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon', style: { backgroundImage: 'url(' + item.url + ')' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des' }, item.des)));
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { background: '#F5F5F5', padding: '1rem 0' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u6210\u529F\u6848\u4F8B' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-img' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-title' }, '\u5408\u4F5C\u4F19\u4F34\uFF1A'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-sub' }, '\u5317\u4EAC\u6E05\u6CB3\u9AD8\u94C1\u7AD9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-title', style: { marginTop: '.4rem' } }, '\u5E94\u7528\u573A\u666F\uFF1A'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-sub' }, '\u2F08\u6D41\u4ECE\u56FA\u5B9A\u68C0\u6D4B\u70B9\u901A\u8FC7\uFF0C\u2F46\u987B\u505C\uF9CD\u9010\u4E2A\u4F53\u6E29\u68C0\u6D4B\uFF0C\u767E\u5EA6AI\u591A\u2F08\u4F53\u6E29\u68C0\u6D4B\u65B9\u6848\u7684\u8FB9\u7F18\u8BBE\u5907\u81EA\u52A8\u8FDB\u2F8F\u2F08\u8138\u548C\u4F53\u6E29\u4FE1\u606F\u7684\u91C7\u96C6\u5206\u6790\uFF0C \u7CBE\u51C6\u8BC6\u522B\u65C5\u5BA2\u53CA\u5BF9\u5E94\u7684\u4F53\u6E29\uFF0C\u4E00\u65E6\u53D1\u73B0\u4F53\u6E29\u5F02\u5E38\uFF0C\u2ECB\u7AD9\u2F2F\u4F5C\u2F08\u5458\u80FD\u7B2C\u4E00\u65F6\u95F4\u76D1\u6D4B\u5230\u5E76\u793A\u610F\u5176\u51FA\uF99C\uFF0C\u7528\u2F3F\u6301\u8BBE\u5907\u8FDB\uFA08\u2F06\u6B21\u68C0\u6D4B\u3002 \u901A\u8FC7\u5E94\u2F64\u767E\u5EA6AI\u4F53\u6E29\u68C0\u6D4B\u89E3\u51B3\u65B9\u6848\uFF0C\u53EF\u4EE5\u66F4\u597D\u5730\u5E94\u5BF9\u5BA2\u6D41\u9AD8\u5CF0\uFF0C\u5FEB\u901F\u5B8C\u6210\u4F53\u6E29\u68C0\u6D4B\uFF0C\u63D0\u5347\u4EBA\u6D41\u901A\u8FC7\u6548\u7387\u7684\u540C\u65F6\uFF0C\u4FDD\u8BC1\u5DE5\u4F5C\u4EBA\u5458\u7684\u5B89\u5168\u3002')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null));
    } }]);return PageTemperature;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object }, _temp);

/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_ditie_wap.b723f7e4.png";

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_anfang_wap.e20fd741.png";

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_dianli_wap.d31763fe.png";

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_shishigaoxiao_wap.c277fd49.svg";

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_jingzhunkekao_wap.60c1e8bd.svg";

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_feijiechuwuganzhi_wap.47bdfc7b.svg";

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_dichengben_wap.77450354.svg";

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_productAction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_fileCheckAction__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: wangzhuang@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2023-09-06 14:38:55
  * @FilePath: /m-anquan-baidu-com/src/containers/product/compliance.js
  * @Description: 史宾格安全及隐私合规平台
  */var Compliance = (_temp = _class = function (_Component) {
  _inherits(Compliance, _Component);function Compliance(props, context) {
    _classCallCheck(this, Compliance);var _this = _possibleConstructorReturn(this, (Compliance.__proto__ || Object.getPrototypeOf(Compliance)).call(this, props, context));_this.state = { cardOff: false };return _this;
  }_createClass(Compliance, [{ key: 'render', value: function render() {
      var _this2 = this;var cardOff = this.state.cardOff;var bannerInfo = this.props.bannerInfo || {};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, '\u57FA\u4E8EAI\u80FD\u529B\u7684\u5B89\u5168/\u9690\u79C1\u95EE\u9898\u68C0\u6D4B\u53CA\u52A8\u6001\u5206\u6790\u5E73\u53F0\u3002\u5E2E\u52A9\u60A8\u7684\u4F01\u4E1A\u9AD8\u6548\u3001\u4F4E\u6210\u672C\u5730\u5F00\u5C55 App \u5408\u89C4\u95EE\u9898\u81EA\u67E5\uFF0C \u6EE1\u8DB3\u76D1\u7BA1\u8981\u6C42\u52A9\u529B\u60A8\u9690\u79C1\u5408\u89C4\u3002\u57FA\u4E8E AI \u68C0\u6D4B\u6280\u672F\uFF0C\u63D0\u4F9B\u9690\u79C1\u98CE\u9669\u9879\u68C0\u6D4B\u3001\u9690\u79C1\u4E13\u9879\u68C0\u6D4B\u3001\u573A\u666F\u68C0\u6D4B\u3001\u6743\u9650\u8FC7\u5EA6\u6536\u96C6\u4E0E\u4F7F\u7528 \u60C5\u51B5\u68C0\u6D4B\u7B49\u4EA7\u54C1\u670D\u52A1\uFF0C\u6DF1\u5EA6\u6316\u6398 App \u9690\u79C1\u5408\u89C4\u98CE\u9669\u4EA7\u751F\u7684\u6E90\u5934\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'compliance-title' }, '\u53F2\u5BBE\u683C\u5B89\u5168\u53CA\u9690\u79C1\u5408\u89C4\u5E73\u53F0-\u7528\u79D1\u6280\u8BA9\u5408\u89C4\u66F4\u7B80\u5355'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '适用场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable com-pro', style: { backgroundImage: 'url(' + __webpack_require__(508) + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u76D1\u7BA1\u673A\u6784'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, '\u6EE1\u8DB3\u9AD8\u5E76\u53D1\u91CF\u7684\u68C0\u6D4B\u9700\u6C42\uFF0C\u53EF\u8FC5\u901F\u53D1\u73B0 App \u4E2D\u7684\u9690\u79C1\u98CE\u9669\u95EE\u9898\uFF0C\u6700\u5927\u5316\u964D\u4F4E\u4EBA\u529B\u4E0E\u65F6\u95F4\u6295\u5165\u6210\u672C\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable com-pro', style: { backgroundImage: 'url(' + __webpack_require__(509) + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u5E94\u7528\u5E02\u573A'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, '\u63D0\u4F9B\u5B9A\u5236\u5316\u68C0\u6D4B\u63A5\u53E3\uFF0C\u4E0E\u5E94\u7528\u5E02\u573A\u63A7\u5236\u7AEF\u5F62\u6210\u65E0\u7F1D\u8854\u63A5\uFF0C\u5728\u4E0D\u7834\u574F\u539F\u6709\u8FD0\u8425\u67B6\u6784\u7684\u60C5\u51B5\u4E0B\uFF0C\u7CBE\u51C6\u6279\u91CF\u5730\u5BF9\u5E94\u7528\u5E02\u573A\u5185\u53D1\u5E03\u7684 App \u8FDB\u884C\u9690\u79C1\u5408\u89C4\u68C0\u6D4B\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable com-pro', style: { backgroundImage: 'url(' + __webpack_require__(510) + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u5927\u578B\u4F01\u4E1A'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, '\u4F01\u4E1A\u7EA7 App \u7684\u9690\u79C1\u98CE\u9669\u76D1\u63A7\uFF0C\u4E00\u7AD9\u5F0F\u89E3\u51B3\u4F01\u4E1A App \u77E9\u9635\u9690\u79C1\u98CE\u9669\u6CBB\u7406\u95EE\u9898\u3002\u907F\u514D\u95EE\u9898\u4EA7\u54C1\u6D41\u5411\u5E02\u573A\uFF0C\u51FA\u73B0\u8206\u8BBA\u6216\u5408\u89C4\u98CE\u9669\uFF0C\u4E3A\u4F01\u4E1A\u7684\u826F\u597D\u53E3\u7891\u548C\u5065\u5EB7\u53D1\u5C55\u63D0\u4F9B\u66F4\u6709\u529B\u7684\u4FDD\u969C\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable com-pro', style: { backgroundImage: 'url(' + __webpack_require__(511) + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, 'App\u5F00\u53D1\u8005'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, '\u9762\u5BF9\u6781\u5176\u7E41\u91CD\u7684\u68C0\u6D4B\u4EFB\u52A1\uFF0C\u53EF\u81EA\u52A8\u68C0\u6D4B App \u7684\u654F\u611F\u6743\u9650\u7533\u8BF7\u548C\u4F7F\u7528\u7684\u5B8F\u89C2\u72B6\u51B5\uFF0C\u7CBE\u51C6\u5B9A\u4F4D\u95EE\u9898\u4EE3\u7801\u4F4D\u7F6E\u548C\u95EE\u9898\u573A\u666F\uFF0C\u534F\u52A9\u5728 App \u4E0A\u67B6\u524D\u8FDB\u884C\u5408\u89C4\u98CE\u9669\u81EA\u67E5\u3002')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '产品功能' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u9690\u79C1\u4E13\u9879\u68C0\u6D4B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u4EE5\u56FD\u5BB6\u9881\u5E03\u5E76\u6267\u884C\u7684\u6CD5\u5F8B\u6CD5\u89C4\u4E3A\u68C0\u6D4B\u6807\u51C6\uFF0C\u57FA\u4E8E\u9690\u79C1\u653F\u7B56\u6587\u672C\u81EA\u52A8\u5316\u5206\u6790\u6280\u672F\uFF0C\u5BF9 App \u4E2A\u4EBA\u4FE1\u606F\u6536\u96C6\u4F7F\u7528\u884C\u4E3A \u8FDB\u884C\u9010\u6761\u5BF9\u5E94\u5206\u6790\uFF0C\u53D1\u73B0\u95EE\u9898\u5E76\u9488\u5BF9\u68C0\u6D4B\u7ED3\u679C\u7ED9\u51FA\u5408\u89C4\u6027\u5EFA\u8BAE\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u9690\u79C1\u98CE\u9669\u9879\u68C0\u6D4B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u5BF9 App \u8FDD\u6CD5\u8FDD\u89C4\u884C\u4E3A\u8FDB\u884C\u5168\u81EA\u52A8\u68C0\u6D4B\uFF0C\u5305\u542B\u9891\u7E41\u7533\u8BF7\u6743\u9650\u3001\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u4F20\u8F93\u7B49\u884C\u4E3A\u3002 \u7ECF\u8FC7\u5BF9\u8F93\u51FA\u7ED3\u679C\u7684\u5904\u7406\u53EF\u4EE5\u5BF9\u5E94\u5230\u5177\u4F53\u6CD5\u89C4\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u573A\u666F\u68C0\u6D4B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u63D0\u4F9B\u5BF9 APP \u7684\u9690\u79C1\u653F\u7B56\u7684\u5408\u89C4\u6027\u68C0\u6D4B\u80FD\u529B\uFF0C\u4EE5\u53CA\u5728\u4E0D\u540C\u8FD0\u884C\u73AF\u5883\u4E0B\u654F\u611F\u884C\u4E3A\u7684\u53D1\u73B0\u3001\u4EE3\u7801\u5B9A\u4F4D\u548C\u654F\u611F\u6743\u9650\u7684\u7533\u8BF7 \u544A\u77E5\u573A\u666F\u3001\u4F7F\u7528\u573A\u666F\u7684\u68C0\u6D4B\u80FD\u529B\uFF0C\u662F\u5224\u65AD APP \u9690\u79C1\u5408\u89C4\u7684\u91CD\u8981\u4F9D\u636E\u3002', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u901A\u8FC7\u4E91\u7AEF\u624B\u673A\u6A21\u62DF APP \u7684\u771F\u5B9E\u4F7F\u7528\u73AF\u5883\uFF0C\u53D1\u73B0\u654F\u611F\u6743\u9650\u4E0B\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u6EAF\u6E90\u548C\u4E2A\u4EBA\u4FE1\u606F\u7684\u4F20\u8F93\u6240\u5B58\u5728\u54EA\u4E9B\u9690\u79C1 \u98CE\u9669\u95EE\u9898\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u6743\u9650\u68C0\u6D4B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u57FA\u4E8E\u5E02\u573A\u6700\u5168\u7684\u7B2C\u4E09\u65B9 SDK \u9690\u79C1\u68C0\u6D4B\u80FD\u529B\u548C\u7279\u5F81\u5E93\uFF0C\u4EE5\u53CA\u6743\u9650\u5230 API \u7684\u6620\u5C04\u5173\u7CFB\u6570\u636E\u5E93\uFF0C\u68C0\u6D4B App \u7533\u8BF7\u53CA \u4F7F\u7528\u7684\u654F\u611F\u6743\u9650\u548C\u96C6\u6210 SDK \u60C5\u51B5\u3002\u53EF\u89C6\u5316\u5C55\u793A\u6743\u9650\u7684\u4EE3\u7801\u8C03\u7528\u5206\u5E03\uFF0C\u5E76\u5BF9 SDK \u4E2D\u8C03\u7528\u6743\u9650\u6240\u5728\u7684\u5177\u4F53\u4EE3\u7801\u8C03 \u7528\u4F4D\u7F6E\u8FDB\u884C\u6EAF\u6E90\u3002\u540C\u65F6\u57FA\u4E8E\u8BED\u4E49\u5206\u6790\u6280\u672F\u68C0\u6D4B\u8F93\u5165\u578B\u4E2A\u4EBA\u654F\u611F\u4FE1\u606F\u5E76\u67E5\u770B\u5176\u4EE3\u7801\u4F4D\u7F6E\u3002', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u901A\u8FC7\u5BF9\u4EA7\u54C1\u591A\u4E2A\u4E0D\u540C\u7248\u672C\u4E4B\u95F4\u7684\u5BF9\u6BD4\u5206\u6790\uFF0C\u5E2E\u52A9\u4EA7\u54C1\u5FEB\u901F\u5B9A\u4F4D\u9690\u79C1\u5408\u89C4\u95EE\u9898\u8D77\u59CB\u7248\u672C\u548C\u539F\u56E0\uFF0C\u66F4\u5FEB\u89E3\u51B3\u9690\u79C1\u5408\u89C4 \u95EE\u9898\u3002\u5229\u7528\u5E02\u573A\u4E0A\u540C\u7C7B\u4EA7\u54C1\u7684\u5DEE\u5F02\u6027\u5BF9\u6BD4\uFF0C\u53EF\u4EE5\u4ECE\u66F4\u5B8F\u89C2\u7684\u89C6\u89D2\u4E86\u89E3\u4EA7\u54C1\u7684\u9690\u79C1\u60C5\u51B5\uFF0C\u53CA\u65F6\u53D1\u73B0\u4E0D\u5FC5\u8981\u7684\u9690 \u79C1\u5408\u89C4\u95EE\u9898\u5E76\u53CA\u65E9\u8C03\u6574\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u5B89\u5168\u670D\u52A1'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u5E94\u5BF9 App \u5B58\u5728\u7684\u4E3B\u6D41\u5B89\u5168\u98CE\u9669\uFF0C\u91C7\u7528\u5F3A\u5927\u7684\u591A\u5F15\u64CE\u626B\u63CF\u7CFB\u7EDF\u548C\u6F0F\u6D1E\u626B\u63CF\u5F15\u64CE\u4E3A App \u63D0\u4F9B\u75C5\u6BD2\u8BEF\u62A5\u68C0\u6D4B\u548C\u6F0F\u6D1E\u68C0\u6D4B\u670D\u52A1\uFF0C \u4EE5\u4FBF\u5B89\u5FC3\u4E0A\u67B6\u3002')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '核心优势' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(512), width: '100%', alt: '' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u7CBE\u786E:\u9886\u5148\u7684\u68C0\u6D4B\u6280\u672F'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u4EE5\u5148\u8FDB\u7684\u4EBA\u5DE5\u667A\u80FD\u6280\u672F\u4E3A\u652F\u6491\uFF0C\u8986\u76D6\u4EA7\u54C1\u5168\u751F\u547D\u5468\u671F\u7684\u9690\u79C1\u5408\u89C4\u9700\u6C42\uFF0C\u5305\u542B\u9690\u79C1\u6570\u636E\u91C7\u96C6\u3001\u6743\u9650\u4F7F\u7528\u573A\u666F\u3001\u9690\u79C1 \u653F\u7B56\u7BA1\u7406\u7B49\u591A\u91CD\u7EAC\u5EA6\u6280\u672F\u68C0\u6D4B\u80FD\u529B\uFF0C\u5F97\u51FA\u5168\u9762\u7CBE\u51C6\u5730\u5408\u89C4\u98CE\u9669\u68C0\u6D4B\u7ED3\u679C\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(513), width: '100%', alt: '' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u6807\u51C6:\u6DF1\u5EA6\u8D34\u5408\u56FD\u5BB6\u76D1\u7BA1\u6807\u51C6'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u4F9D\u636E\u56FD\u5BB6\u7F51\u4FE1\u529E\u3001\u5DE5\u4FE1\u90E8\u3001\u516C\u5B89\u90E8\u3001\u5E02\u573A\u76D1\u7BA1\u603B\u5C40\u4E8E2019 \u5E74 12 \u6708 30 \u65E5\u8054\u5408\u53D1\u5E03\u7684\u300AApp \u8FDD\u6CD5\u8FDD\u89C4\u6536\u96C6\u4F7F\u7528 \u4E2A\u4EBA\u4FE1\u606F\u884C\u4E3A\u8BA4\u5B9A\u65B9\u6CD5\u300B\uFF0C\u56FD\u5BB6\u6807\u51C6GB/T35273\u300A\u4FE1\u606F\u5B89\u5168\u6280\u672F \u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u89C4\u8303\u300B\uFF0C\u4EE5\u53CA\u300A\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD \u7F51\u7EDC\u5B89\u5168\u6CD5\u300B\u3001\u300A\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u6D88\u8D39\u8005\u6743\u76CA\u4FDD\u62A4\u6CD5\u300B\u7B49\u76F8\u5173\u56FD\u5BB6\u6CD5\u5F8B\u6CD5\u89C4\uFF0C\u5BF9 App \u6536\u96C6\u4F7F\u7528\u7528\u6237\u4E2A\u4EBA\u4FE1\u606F\u7684 \u884C\u4E3A\u9010\u6761\u5BF9\u5E94\u5206\u6790\uFF0C\u5408\u89C4\u95EE\u9898\u4E00\u76EE\u4E86\u7136\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex', style: { borderBottom: 'none', paddingBottom: '0' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(514), width: '100%', alt: '' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u9AD8\u6548:\u4F01\u4E1A\u7EA7\u81EA\u52A8\u5316\u68C0\u6D4B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u81EA\u52A8\u5316\u9690\u79C1\u98CE\u9669\u53D1\u73B0\u548C\u68C0\u6D4B\uFF0C\u5BF9 App \u6536\u96C6\u4F7F\u7528\u4E2A\u4EBA\u4FE1\u606F\u7684\u884C\u4E3A\u6DF1\u5165\u5206\u6790\uFF0C\u66FF\u4EE3\u4EBA\u5DE5\u7FFB\u67E5\u4EE3\u7801\uFF0C\u53EF\u5FEB\u901F\u5904\u7406\u5927 \u6279\u91CFApp\uFF0C\u8282\u7EA6\u4EBA\u529B\u6210\u672C\uFF0C\u663E\u8457\u63D0\u5347\u68C0\u6D4B\u6548\u7387\u3002')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '合作伙伴' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(515), alt: '\u5408\u4F5C\u4F19\u4F34', style: { width: '100%' } }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'join-type-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '接入方式' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'join-type' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'join-type-item zy' }, '\u4F01\u4E1A\u5C0A\u4EAB\u7248\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'join-type-link', onClick: function onClick() {
          _this2.setState({ cardOff: !cardOff });
        } }, '\u7ACB\u5373\u54A8\u8BE2', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', { className: cardOff ? 'on' : '', width: '.44rem', height: '.44rem', viewBox: '0 0 44 44', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', null, 'icon_fold blue'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('desc', null, 'Created with Sketch.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g', { id: 'icon_fold-blue', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g', { id: '\u7F16\u7EC4-11' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g', { id: 'icon_arrow_blue_normal_24' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g', { id: 'Rectangle-9' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { x: '0', y: '0', width: '44', height: '44' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { id: 'lj-3', fill: '#3388FF', fillRule: 'nonzero', points: '34.485551 15.2610112 35.8329865 16.7389888 21.992399 29.3' + '571092 8.32162654 16.7347173 9.67837346 15.2652827 22.001 26.642' }))))), cardOff ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'join-type-item-card' }, '\u5408\u4F5C\u7535\u8BDD\uFF1A010-58003138', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u5DE5\u4F5C\u65F6\u95F4\uFF1A9:00-20:00') : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'join-type-item fc', style: { display: 'none' } }, '\u6276\u6301\u7248\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'join-type-link', href: '/springer/plan', target: '_blank' }, '\u9650\u65F6\u7533\u9886', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', { width: '.44rem', height: '.44rem', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', null, 'icon_arrow_blue_normal_24'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('desc', null, 'Created with Sketch.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g', { id: 'icon_arrow_blue_normal_24', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { id: 'Rectangle-9', x: '0', y: '0', width: '24', height: '24' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M19.618975,11.5 L11.6799078,4.88411064 L12.3200922,4.115889' + '36 L21.3200922,11.6158894 C21.5599693,11.8157869 21.5599693,1' + '2.1842131 21.3200922,12.3841106 L12.3200922,19.8841106 L11.679' + '9078,19.1158894 L19.618975,12.5 L3.95351375,12.5 L3.95351375,' + '11.5 L19.618975,11.5 Z', id: 'Combined-Shape', fill: '#3388FF', fillRule: 'nonzero' })))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'join-type-item fc', style: { display: 'none' } }, '\u4F01\u4E1A\u7528\u6237\u6807\u51C6\u7248\xA0', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'join-type-link', href: '/console/#/SpringerBuy', target: '_blank' }, '\u7ACB\u5373\u4F53\u9A8C', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg', { width: '.44rem', height: '.44rem', viewBox: '0 0 24 24', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title', null, 'icon_arrow_blue_normal_24'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('desc', null, 'Created with Sketch.'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g', { id: 'icon_arrow_blue_normal_24', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { id: 'Rectangle-9', x: '0', y: '0', width: '24', height: '24' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M19.618975,11.5 L11.6799078,4.88411064 L12.3200922,4.115889' + '36 L21.3200922,11.6158894 C21.5599693,11.8157869 21.5599693,1' + '2.1842131 21.3200922,12.3841106 L12.3200922,19.8841106 L11.679' + '9078,19.1158894 L19.618975,12.5 L3.95351375,12.5 L3.95351375,' + '11.5 L19.618975,11.5 Z', id: 'Combined-Shape', fill: '#3388FF', fillRule: 'nonzero' })))))))));
    } }]);return Compliance;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return { pagesDatabyid: state.pagesDatabyid, navListIndex: state.navListIndex, serviceIntroduce: state.serviceIntroduce };
}function mapDispatchToProps(dispatch) {
  return { fetchUrlUpload: function fetchUrlUpload(obj, type) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__actions_fileCheckAction__["a" /* fetchUrlUpload */])(dispatch, obj, type);
    }, fetchPagesDataById: function fetchPagesDataById(id) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__actions_productAction__["f" /* fetchPagesDataById */])(dispatch, id);
    }, fetchServiceIntroduce: function fetchServiceIntroduce(itemid) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__actions_productAction__["h" /* fetchServiceIntroduce */])(dispatch, itemid);
    }, fetchProductId: function fetchProductId(id) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__actions_productAction__["g" /* fetchProductId */])(dispatch, id);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Compliance));

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/c1.ff724b46.png";

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/c2.d0569976.png";

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/c3.ffc115f8.png";

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/c4.1f25f025.png";

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_jingzhun.c73d0969.svg";

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_biaozhun.919e5700.svg";

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_gaoxiao.46006613.svg";

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/friend.ac1cefa7.png";

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_search_bar_style_css__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_search_bar_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_search_bar_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_search_bar__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_search_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_search_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_image_picker_style_css__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_image_picker_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_image_picker_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_image_picker__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_image_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_image_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_fileCheckAction__ = __webpack_require__(76);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: WangZhuang@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2023-06-09 15:10:43
  * @FilePath: /m-anquan-baidu-com/src/containers/product/vdc.js
  * @Description: 墨源文件威胁感知系统
  */var Vdc = (_temp = _class = function (_PureComponent) {
  _inherits(Vdc, _PureComponent);function Vdc(props, context) {
    _classCallCheck(this, Vdc);var _this = _possibleConstructorReturn(this, (Vdc.__proto__ || Object.getPrototypeOf(Vdc)).call(this, props, context));_this.clear = function () {
      _this.setState({ value: '', vdcPage: false });window.scrollTo(0, _this.state.srcollTop);
    };_this.onChange = function (vdcValue) {
      _this.setState({ vdcValue: vdcValue });
    };_this.onSubmit = function (value) {
      if (!value) {
        return;
      }var vdcType = _this.state.vdcType;var json = {};if (vdcType === 'search') {
        json = { resource: value };
      } else {
        json = { url: value };
      }_this.props.fetchUrlUpload(json, vdcType === 'search' ? 'report' : 'urlUpload').then(function (data) {
        var obj = data.data;if (obj.status === 0) {
          if (obj.data.is_auth === 'bot') {
            _this.setState({ vdcPage: false, vdcInputHint: '检测结果异常，请重新检测。' });return;
          }if (vdcType === 'search') {
            location.href = '/m/fileCheck/report/' + value;
          } else {
            location.href = '/m/fileCheck/task/' + obj.data.task_id;
          }
        } else {
          _this.setState({ vdcPage: false, vdcInputHint: obj.description });
        }
      });
    };_this.onUpImgChange = function (files) {
      if (files[0].file.size > 1048576 * 15) {
        _this.setState({ fileWaring: true, fileHint: '文件超出大小限制' });return;
      }_this.setState({ upIng: true });var json = { files: files[0].file };_this.props.fetchUrlUpload(json, 'fileUpload').then(function (data) {
        var obj = data.data;if (obj.status === 0) {
          if (obj.data.is_auth === 'bot') {
            _this.setState({ upIng: false, fileWaring: true, fileHint: '检测结果异常，请重新检测。' });return;
          }_this.setState({ upIng: false, fileWaring: false, fileHint: '请上传要检测的文件，文件大小不超过15M' });location.href = '/m/fileCheck/task/' + obj.data.task_id;
        } else {
          _this.setState({ upIng: false, fileWaring: true, fileHint: obj.description });
        }
      });
    };_this.state = { vdcType: 'search', vdcValue: '', srcollTop: 0, fileHint: '请上传要检测的文件，文件大小不超过15M', fileWaring: false, vdcPage: false, vdcText: '请输入待检测文件对应的md5', vdcInputHint: '', upIng: false };return _this;
  }_createClass(Vdc, [{ key: 'componentDidMount', value: function componentDidMount() {} }, { key: 'render', value: function render() {
      var _this2 = this;var bannerInfo = this.props.bannerInfo;var _state = this.state,
          vdcType = _state.vdcType,
          vdcText = _state.vdcText,
          upIng = _state.upIng,
          vdcValue = _state.vdcValue,
          vdcPage = _state.vdcPage,
          fileHint = _state.fileHint,
          fileWaring = _state.fileWaring,
          vdcInputHint = _state.vdcInputHint;var proinfoBox = [{ title: '精准检测', 'mobile_pic': __webpack_require__(125), content: '通过多家评测机构认证，独有的深度学习分析引擎，准确识别出多种平台下不同文件格式可能存在的安全风险' }, { title: '高吞吐性', 'mobile_pic': __webpack_require__(126), content: '支持每秒数万级并发查询，每日千万级新文件分析检测能力' }, { title: '快速接入', 'mobile_pic': __webpack_require__(127), content: '接口简单易用，不需要太多开发工作即可快速上线使用' }, { title: '隐私保护', 'mobile_pic': __webpack_require__(128), content: '依托百度多年积累的文件知识库，仅需文件特征即可获得文件鉴定结果' }];var profunBox = [{ title: '文件哈希检查', content: '可以根据文件内容的hash值，查询文件的威胁的详细信息。' }, { title: '文件内容检查', content: '可以上传文件，通过文件内容进行异步的文件结果扫描，获取文件扫描结果。' }, { title: '文件URL检查', content: '可以提供仅提供文件下载路径，后台下载后对文件内容进行检查识别。' }, { title: '威胁详情查询', content: '可以通过文件的部分信息，进行检索存在威胁的文件信息详情。' }, { title: '威胁文件下载', content: '可以通过文件的哈希值，获取到存在危险的文件内容，需要进行相关保密合约的签署。' }];return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'product dc' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'product-des' }, '\u4F9D\u6258\u767E\u5EA6\u5B89\u5168\u591A\u5E74\u79EF\u7D2F\u7684\u6570\u4EBF\u7EA7\u6587\u4EF6\u9ED1\u540D\u5355\u548C\u667A\u80FD\u6587\u4EF6\u5B89\u5168\u5206\u6790\u5F15\u64CE\uFF0C \u5E2E\u52A9\u7528\u6237\u5728\u6D89\u53CA\u6587\u4EF6\u76F8\u5173\u7684\u573A\u666F\u4E2D\u5BF9\u98CE\u9669\u6587\u4EF6\u8FDB\u884C\u5FEB\u901F\u51C6\u786E\u7684\u7504\u522B\uFF0C \u964D\u4F4E\u6076\u610F\u4EE3\u7801\u653B\u51FB\u5E26\u6765\u7684\u98CE\u9669\uFF0C\u63D0\u5347\u7528\u6237\u5B89\u5168\u4F53\u9A8C\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'product-vdc' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ProductTitle__["a" /* default */], { title: '文件安全检测' })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'vdc-mod' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'vdc-tab' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: vdcType === 'search' ? 'vdc-search on' : 'vdc-search', onClick: function onClick() {
          _this2.setState({ vdcValue: '', vdcType: 'search', vdcInputHint: '', vdcText: '请输入待检测文件对应的md5' });
        } }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i', null), '\u641C\u7D22'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: vdcType === 'url' ? 'vdc-url on' : 'vdc-url', onClick: function onClick() {
          _this2.setState({ vdcValue: '', vdcType: 'url', vdcInputHint: '', vdcText: '请输入待检测文件对应的url' });
        } }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i', null), 'URL'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: vdcType === 'file' ? 'vdc-file on' : 'vdc-file', onClick: function onClick() {
          _this2.setState({ vdcType: 'file', vdcInputHint: '' });
        } }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('i', null), '\u6587\u4EF6\u68C0\u6D4B')), vdcType === 'file' ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'file-mod' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'file-btn-box pr' }, !upIng ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'm-btn' }, '\u4E0A\u4F20\u6587\u4EF6') : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'm-btn file-btn' }, '\u6587\u4EF6\u4E0A\u4F20\u4E2D'), !upIng ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_image_picker___default.a, { accept: '*/*', multiple: false, capture: true, onChange: this.onUpImgChange, selectable: true }) : null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: fileWaring ? 'file-hint on' : 'file-hint' }, fileHint)) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'vdc-input', onClick: function onClick() {
          _this2.setState({ vdcPage: true, srcollTop: document.documentElement.scrollTop || document.body.scrollTop }, function () {
            window.scrollTo(0, 0);_this2.manualFocusInst.focus();
          });
        } }, vdcText), vdcInputHint ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'vdc-input-hint' }, vdcInputHint) : null)))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ProductTitle__["a" /* default */], { title: '产品特色' })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'product-mod' }, proinfoBox.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { key: index, className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: item.mobile_pic, width: '100%', alt: item.title })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'proinfo-box-title' }, item.title), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'proinfo-box-des' }, item.content)));
      })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ProductTitle__["a" /* default */], { title: '产品功能' })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'product-mod' }, profunBox.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'profun-box mui-flex', key: index }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'profun-box-title' }, item.title), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'profun-box-des', dangerouslySetInnerHTML: { __html: item.content } })));
      })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ProductTitle__["a" /* default */], { title: '合作伙伴' })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: __webpack_require__(525), alt: '\u5408\u4F5C\u4F19\u4F34', style: { width: '100%' } })), vdcPage ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'vdc-input-page' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_search_bar___default.a, { value: vdcValue ? vdcValue : '', placeholder: vdcText, onSubmit: this.onSubmit, onClear: function onClear() {
          _this2.setState({ value: '' });
        }, onFocus: function onFocus() {
          if (_this2.state.showHistory) {
            return;
          }_this2.setState({ showHistory: true });
        }, ref: function ref(_ref) {
          return _this2.manualFocusInst = _ref;
        }, onCancel: this.clear, showCancelButton: true, onChange: this.onChange })) : null);
    } }]);return Vdc;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]), _class.propTypes = { fetchUrlUpload: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, bannerInfo: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object }, _temp);function mapStateToProps() {
  return {};
}function mapDispatchToProps(dispatch) {
  return { fetchUrlUpload: function fetchUrlUpload(obj, type) {
      return Object(__WEBPACK_IMPORTED_MODULE_9__actions_fileCheckAction__["a" /* fetchUrlUpload */])(dispatch, obj, type);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Vdc));

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(518);

__webpack_require__(520);

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

__webpack_require__(519);

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rmcFeedback = __webpack_require__(38);

var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);

var _flex = __webpack_require__(522);

var _flex2 = _interopRequireDefault(_flex);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* tslint:disable:no-bitwise */
function noop() {}

var ImagePicker = function (_React$Component) {
    (0, _inherits3['default'])(ImagePicker, _React$Component);

    function ImagePicker() {
        (0, _classCallCheck3['default'])(this, ImagePicker);

        // http://stackoverflow.com/questions/7584794/accessing-jpeg-exif-rotation-data-in-javascript-on-the-client-side
        var _this = (0, _possibleConstructorReturn3['default'])(this, (ImagePicker.__proto__ || Object.getPrototypeOf(ImagePicker)).apply(this, arguments));

        _this.getOrientation = function (file, callback) {
            var reader = new FileReader();
            reader.onload = function (e) {
                var view = new DataView(e.target.result);
                if (view.getUint16(0, false) !== 0xffd8) {
                    return callback(-2);
                }
                var length = view.byteLength;
                var offset = 2;
                while (offset < length) {
                    var marker = view.getUint16(offset, false);
                    offset += 2;
                    if (marker === 0xffe1) {
                        var tmp = view.getUint32(offset += 2, false);
                        if (tmp !== 0x45786966) {
                            return callback(-1);
                        }
                        var little = view.getUint16(offset += 6, false) === 0x4949;
                        offset += view.getUint32(offset + 4, little);
                        var tags = view.getUint16(offset, little);
                        offset += 2;
                        for (var i = 0; i < tags; i++) {
                            if (view.getUint16(offset + i * 12, little) === 0x0112) {
                                return callback(view.getUint16(offset + i * 12 + 8, little));
                            }
                        }
                    } else if ((marker & 0xff00) !== 0xff00) {
                        break;
                    } else {
                        offset += view.getUint16(offset, false);
                    }
                }
                return callback(-1);
            };
            reader.readAsArrayBuffer(file.slice(0, 64 * 1024));
        };
        _this.getRotation = function () {
            var orientation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

            var imgRotation = 0;
            switch (orientation) {
                case 3:
                    imgRotation = 180;
                    break;
                case 6:
                    imgRotation = 90;
                    break;
                case 8:
                    imgRotation = 270;
                    break;
                default:
            }
            return imgRotation;
        };
        _this.removeImage = function (index) {
            var newImages = [];
            var _this$props$files = _this.props.files,
                files = _this$props$files === undefined ? [] : _this$props$files;

            files.forEach(function (image, idx) {
                if (index !== idx) {
                    newImages.push(image);
                }
            });
            if (_this.props.onChange) {
                _this.props.onChange(newImages, 'remove', index);
            }
        };
        _this.addImage = function (imgItem) {
            var _this$props$files2 = _this.props.files,
                files = _this$props$files2 === undefined ? [] : _this$props$files2;

            var newImages = files.concat(imgItem);
            if (_this.props.onChange) {
                _this.props.onChange(newImages, 'add');
            }
        };
        _this.onImageClick = function (index) {
            if (_this.props.onImageClick) {
                _this.props.onImageClick(index, _this.props.files);
            }
        };
        _this.onFileChange = function () {
            var fileSelectorEl = _this.fileSelectorInput;
            if (fileSelectorEl && fileSelectorEl.files && fileSelectorEl.files.length) {
                var files = fileSelectorEl.files;
                var imageParsePromiseList = [];
                for (var i = 0; i < files.length; i++) {
                    imageParsePromiseList.push(_this.parseFile(files[i], i));
                }
                Promise.all(imageParsePromiseList).then(function (imageItems) {
                    return _this.addImage(imageItems);
                })['catch'](function (error) {
                    if (_this.props.onFail) {
                        _this.props.onFail(error);
                    }
                });
            }
            if (fileSelectorEl) {
                fileSelectorEl.value = '';
            }
        };
        _this.parseFile = function (file, index) {
            return new Promise(function (resolve, reject) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    var dataURL = e.target.result;
                    if (!dataURL) {
                        reject('Fail to get the ' + index + ' image');
                        return;
                    }
                    var orientation = 1;
                    _this.getOrientation(file, function (res) {
                        // -2: not jpeg , -1: not defined
                        if (res > 0) {
                            orientation = res;
                        }
                        resolve({
                            url: dataURL,
                            orientation: orientation,
                            file: file
                        });
                    });
                };
                reader.readAsDataURL(file);
            });
        };
        return _this;
    }

    (0, _createClass3['default'])(ImagePicker, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                style = _props.style,
                className = _props.className,
                _props$files = _props.files,
                files = _props$files === undefined ? [] : _props$files,
                selectable = _props.selectable,
                onAddImageClick = _props.onAddImageClick,
                multiple = _props.multiple,
                accept = _props.accept,
                capture = _props.capture,
                disableDelete = _props.disableDelete;

            var imgItemList = [];
            var count = parseInt('' + this.props.length, 10);
            if (count <= 0) {
                count = 4;
            }
            var wrapCls = (0, _classnames2['default'])('' + prefixCls, className);
            files.forEach(function (image, index) {
                var imgStyle = {
                    backgroundImage: 'url("' + image.url + '")',
                    transform: 'rotate(' + _this2.getRotation(image.orientation) + 'deg)'
                };
                var itemStyle = {};
                imgItemList.push(React.createElement(
                    _flex2['default'].Item,
                    { key: 'item-' + index, style: itemStyle },
                    React.createElement(
                        'div',
                        { key: index, className: prefixCls + '-item' },
                        !disableDelete && React.createElement('div', { className: prefixCls + '-item-remove', role: 'button', 'aria-label': 'Click and Remove this image'
                            // tslint:disable-next-line:jsx-no-multiline-js
                            , onClick: function onClick() {
                                _this2.removeImage(index);
                            } }),
                        React.createElement('div', { className: prefixCls + '-item-content', role: 'button', 'aria-label': 'Image can be clicked'
                            // tslint:disable-next-line:jsx-no-multiline-js
                            , onClick: function onClick() {
                                _this2.onImageClick(index);
                            }, style: imgStyle })
                    )
                ));
            });
            var selectEl = React.createElement(
                _flex2['default'].Item,
                { key: 'select' },
                React.createElement(
                    _rmcFeedback2['default'],
                    { activeClassName: prefixCls + '-upload-btn-active' },
                    React.createElement(
                        'div',
                        { className: prefixCls + '-item ' + prefixCls + '-upload-btn', onClick: onAddImageClick, role: 'button', 'aria-label': 'Choose and add image' },
                        React.createElement('input', { ref: function ref(input) {
                                if (input) {
                                    _this2.fileSelectorInput = input;
                                }
                            }, type: 'file', accept: accept
                            // tslint:disable-next-line:jsx-no-multiline-js
                            , onChange: function onChange() {
                                _this2.onFileChange();
                            }, multiple: multiple, capture: capture })
                    )
                )
            );
            var allEl = selectable ? imgItemList.concat([selectEl]) : imgItemList;
            var length = allEl.length;
            if (length !== 0 && length % count !== 0) {
                var blankCount = count - length % count;
                var fillBlankEl = [];
                for (var i = 0; i < blankCount; i++) {
                    fillBlankEl.push(React.createElement(_flex2['default'].Item, { key: 'blank-' + i }));
                }
                allEl = allEl.concat(fillBlankEl);
            }
            var flexEl = [];
            for (var _i = 0; _i < allEl.length / count; _i++) {
                var rowEl = allEl.slice(_i * count, _i * count + count);
                flexEl.push(rowEl);
            }
            var renderEl = flexEl.map(function (item, index) {
                return React.createElement(
                    _flex2['default'],
                    { key: 'flex-' + index },
                    item
                );
            });
            return React.createElement(
                'div',
                { className: wrapCls, style: style },
                React.createElement(
                    'div',
                    { className: prefixCls + '-list', role: 'group' },
                    renderEl
                )
            );
        }
    }]);
    return ImagePicker;
}(React.Component);

exports['default'] = ImagePicker;

ImagePicker.defaultProps = {
    prefixCls: 'am-image-picker',
    files: [],
    onChange: noop,
    onImageClick: noop,
    onAddImageClick: noop,
    onFail: noop,
    selectable: true,
    multiple: false,
    accept: 'image/*',
    length: 4,
    disableDelete: false
};
module.exports = exports['default'];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Flex = __webpack_require__(523);

var _Flex2 = _interopRequireDefault(_Flex);

var _FlexItem = __webpack_require__(524);

var _FlexItem2 = _interopRequireDefault(_FlexItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Flex2['default'].Item = _FlexItem2['default'];
exports['default'] = _Flex2['default'];
module.exports = exports['default'];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(17);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Flex = function (_React$Component) {
    (0, _inherits3['default'])(Flex, _React$Component);

    function Flex() {
        (0, _classCallCheck3['default'])(this, Flex);
        return (0, _possibleConstructorReturn3['default'])(this, (Flex.__proto__ || Object.getPrototypeOf(Flex)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Flex, [{
        key: 'render',
        value: function render() {
            var _classnames;

            var _a = this.props,
                direction = _a.direction,
                wrap = _a.wrap,
                justify = _a.justify,
                align = _a.align,
                alignContent = _a.alignContent,
                className = _a.className,
                children = _a.children,
                prefixCls = _a.prefixCls,
                style = _a.style,
                restProps = __rest(_a, ["direction", "wrap", "justify", "align", "alignContent", "className", "children", "prefixCls", "style"]);
            var wrapCls = (0, _classnames3['default'])(prefixCls, className, (_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-dir-row', direction === 'row'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-dir-row-reverse', direction === 'row-reverse'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-dir-column', direction === 'column'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-dir-column-reverse', direction === 'column-reverse'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-nowrap', wrap === 'nowrap'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-wrap', wrap === 'wrap'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-wrap-reverse', wrap === 'wrap-reverse'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-justify-start', justify === 'start'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-justify-end', justify === 'end'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-justify-center', justify === 'center'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-justify-between', justify === 'between'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-justify-around', justify === 'around'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-align-start', align === 'start'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-align-center', align === 'center'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-align-end', align === 'end'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-align-baseline', align === 'baseline'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-align-stretch', align === 'stretch'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-align-content-start', alignContent === 'start'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-align-content-end', alignContent === 'end'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-align-content-center', alignContent === 'center'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-align-content-between', alignContent === 'between'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-align-content-around', alignContent === 'around'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-align-content-stretch', alignContent === 'stretch'), _classnames));
            return React.createElement(
                'div',
                (0, _extends3['default'])({ className: wrapCls, style: style }, restProps),
                children
            );
        }
    }]);
    return Flex;
}(React.Component);

exports['default'] = Flex;

Flex.defaultProps = {
    prefixCls: 'am-flexbox',
    align: 'center'
};
module.exports = exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var FlexItem = function (_React$Component) {
    (0, _inherits3['default'])(FlexItem, _React$Component);

    function FlexItem() {
        (0, _classCallCheck3['default'])(this, FlexItem);
        return (0, _possibleConstructorReturn3['default'])(this, (FlexItem.__proto__ || Object.getPrototypeOf(FlexItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(FlexItem, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                children = _a.children,
                className = _a.className,
                prefixCls = _a.prefixCls,
                style = _a.style,
                restProps = __rest(_a, ["children", "className", "prefixCls", "style"]);
            var wrapCls = (0, _classnames2['default'])(prefixCls + '-item', className);
            return React.createElement(
                'div',
                (0, _extends3['default'])({ className: wrapCls, style: style }, restProps),
                children
            );
        }
    }]);
    return FlexItem;
}(React.Component);

exports['default'] = FlexItem;

FlexItem.defaultProps = {
    prefixCls: 'am-flexbox'
};
module.exports = exports['default'];

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hezuohuoban.60a3bc7a.png";

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageAppSolution; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_app_solution_less__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_app_solution_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__page_app_solution_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: wence@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2023-06-09 15:40:25
  * @FilePath: /m-anquan-baidu-com/src/containers/product/page_app_solution.js
  * @Description: app解决方案
  */var PageAppSolution = (_temp = _class = function (_PureComponent) {
  _inherits(PageAppSolution, _PureComponent);function PageAppSolution() {
    _classCallCheck(this, PageAppSolution);return _possibleConstructorReturn(this, (PageAppSolution.__proto__ || Object.getPrototypeOf(PageAppSolution)).apply(this, arguments));
  }_createClass(PageAppSolution, [{ key: 'render', value: function render() {
      var bannerInfo = this.props.bannerInfo || {};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, '\u57FA\u4E8EAI\u548C\u5927\u6570\u636E\u6280\u672F\uFF0C\u4E3AAPP\u63D0\u4F9B\u4ECE\u5E94\u7528\u7AEF\u5230\u670D\u52A1\u7AEF\u7684\u5168\u65B9\u4F4D\u9632\u62A4\uFF0C\u652F\u6301\u5E94\u7528\u52A0\u56FA\u3001\u9690\u79C1\u5408\u89C4\u3001\u5185\u5BB9\u98CE\u9669\u68C0\u6D4B\u3001\u670D\u52A1\u7AEF\u7EFC\u5408\u9632\u62A4\u3001\u5A01\u80C1\u60C5\u62A5\u548C\u5B89\u5168\u4E13\u5BB6\u8BC4\u4F30\u670D\u52A1\u7B49\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '适用场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingBottom: 0 } }, [{ 'mobile_pic': __webpack_require__(528), title: '应用加固', content: '防止应用被逆向、破解造成业务数据泄露、核心代码被窃取或篡改。' }, { 'mobile_pic': __webpack_require__(529), title: '隐私合规', content: '支持APP隐私专项检测、场景检测和权限过度收集等检测。帮企业高效、低成本地做APP合规自查，满足监管要求。' }, { 'mobile_pic': __webpack_require__(530), title: '威胁情报', content: '提供访问的终端设备、访问IP和访问内容等的风险识别和提示，帮企业做好风险访问隔离和风险内容处置，保障业务安全。' }, { 'mobile_pic': __webpack_require__(531), title: '服务端防护', content: '提供包括服务端安全漏洞扫描、恶意入侵拦截和安全专家评估等服务，提升服务端的安全级别。' }].map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable', key: index, style: { backgroundImage: 'url(' + item.mobile_pic + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, item.content));
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u4E1A\u52A1\u7ED3\u6784' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(532), style: { width: '10rem', margin: '0 auto' }, alt: '' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u65B9\u6848\u4F18\u52BF' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-advantage' }, [{ title: '全面防护', des: '覆盖APP的服务端和应用端。安全防护问题一站式解决。', url: __webpack_require__(226) }, { title: '按需定制', des: '企业可以根据自身的安全需求，选择采用解决方案中的部分安全能力。', url: __webpack_require__(533) }, { title: '适用面广', des: '适用各种类型的APP，包括电商、金融、视频、资讯、社交和教育等。', url: __webpack_require__(534) }, { title: '有效保护', des: '基于百度核心技术研发，服务多个核心产品线和外部客户，服务能力已被有效验证。', url: __webpack_require__(535) }].map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-p-advantage-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon', style: { backgroundImage: 'url(' + item.url + ')' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des' }, item.des)));
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u5408\u4F5C\u5BA2\u6237' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: '100%', marginBottom: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { width: '100%', src: __webpack_require__(536), alt: '' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { background: '#F5F5F5', paddingBottom: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u76F8\u5173\u4EA7\u54C1' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, [{ title: '安全OTA', content: '\u767E\u5EA6\u5B89\u5168OTA\u662F\u767E\u5EA6\u5229\u7528\u79EF\u7D2F\u591A\u5E74\u7684\u4E91\u7BA1\u7AEF\u5B89\u5168\u80FD\u529B\u6253\u9020\u7684\u5B89\u5168OTA\u65B9\u6848\uFF0C\n                                    \u96C6\u6210\u4E86\u767E\u5EA6\u591A\u9879\u5B89\u5168\u4E13\u5229\u6280\u672F\uFF0C\u65E8\u5728\u4E3A\u667A\u80FD\u8BBE\u5907\u63D0\u4F9B\u5B89\u5168\u3001\u9AD8\u6548\u7684\u7CFB\u7EDF\u5347\u7EA7\u65B9\u6848\uFF0C\u652F\u6301Android\u3001Linux\u53CA\u5D4C\u5165\u5F0F\u7CFB\u7EDF\u8BBE\u5907\uFF0C\n                                    \u63D0\u4F9B\u4E91\u7AEF\u8BBE\u5907\u7BA1\u7406\u5E73\u53F0\u53CA\u8BBE\u5907\u7AEFSDK\uFF0C\u63A5\u5165\u7B80\u5355\u4FBF\u6377\uFF0C\u53EF\u89C6\u5316\u7BA1\u7406\u96F6\u95E8\u69DB\u3002', url: 'https://anquan.baidu.com/page/29' }, { title: '图数据库', content: 'HugeGraph\u662F\u4E00\u6B3E\u6613\u7528\u3001\u9AD8\u6548\u3001\u901A\u7528\u7684\u56FE\u6570\u636E\u5E93\uFF0C\n                                    \u5B9E\u73B0\u4E86Apache TinkerPop3\u6846\u67B6\u53CA\u517C\u5BB9Gremlin\u67E5\u8BE2\u8BED\u8A00\u3002\u652F\u6301\u767E\u4EBF\u4EE5\u4E0A\u7684\u9876\u70B9(Vertex)\u548C\u8FB9(Edge)\u5FEB\u901F\u5BFC\u5165\uFF0C\n                                    \u5E76\u63D0\u4F9B\u6BEB\u79D2\u7EA7\u7684\u5173\u8054\u67E5\u8BE2\u80FD\u529B\uFF0C\u5E76\u53EF\u4E0EHadoop\u3001Spark\u7B49\u5927\u6570\u636E\u5E73\u53F0\u96C6\u6210\u4EE5\u8FDB\u884C\u79BB\u7EBF\u5206\u6790\u3002\n                                    \u4E3B\u8981\u5E94\u7528\u573A\u666F\u5305\u62EC\u5173\u8054\u5206\u6790\u3001\u6B3A\u8BC8\u68C0\u6D4B\u548C\u77E5\u8BC6\u56FE\u8C31\u7B49\u3002', url: 'https://anquan.baidu.com/page/27' }, { title: '云手机', content: '\u767E\u5EA6\u4E91\u624B\u673A\u662F\u4F9D\u6258\u516C\u6709\u4E91\u548CARM\u865A\u62DF\u5316\u6280\u672F\uFF0C\u6700\u7EC8\u4E3A\u7528\u6237/\u5BA2\u6237\u5728\u4E91\u7AEF\u63D0\u4F9B\u7684\u4E00\u4E2A\u4E2A\u5B89\u5353\u5B9E\u4F8B\uFF08\u64CD\u4F5C\u7CFB\u7EDF\uFF09\u3002\n                                    \u7528\u6237/\u5BA2\u6237\u53EF\u4EE5\u901A\u8FC7\u89C6\u9891\u6D41\u7684\u65B9\u5F0F\uFF0C\u8FDC\u7A0B\u5B9E\u65F6\u63A7\u5236\u4E91\u624B\u673A\uFF0C\n                                    \u6700\u7EC8\u5B9E\u73B0\u5B89\u5353\u539F\u751FAPP\u53CA\u624B\u6E38\u7684\u4E91\u7AEF\u8FD0\u884C\u3002', url: 'https://anquan.baidu.com/page/59' }].map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-app-solution-card' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, item.content), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: item.url, target: '_blank', className: 'btn' }, '\u4E86\u89E3\u8BE6\u60C5'));
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des' }, '\u5982\u679C\u60A8\u5BF9\u4EA7\u54C1\u548C\u65B9\u6848\u7684\u9002\u7528\u573A\u666F\u6216\u6280\u672F\u67B6\u6784\u7B49', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u65B9\u9762\u6709\u95EE\u9898\uFF0C\u6B22\u8FCE\u968F\u65F6\u8054\u7CFB\u6211\u4EEC\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.url, className: 'btn' }, '\u5546\u52A1\u54A8\u8BE2'))));
    } }]);return PageAppSolution;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object }, _temp);

/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_1.1cd4b9ea.png";

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_2.cd89384d.png";

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_3.fd262384.png";

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_4.2ed99762.png";

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tree.8b5c41e6.png";

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_anxudingzhi.c25d6a98.svg";

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_shiyongmianguang.31e45a4a.svg";

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_youxiaofanghu.e295e9f2.svg";

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-wap.a591030a.png";

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_productAction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_exif_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_exif_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_exif_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_drawRegion__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__page_imagerecognition_less__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__page_imagerecognition_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__page_imagerecognition_less__);
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: wence@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2023-06-09 16:39:33
  * @FilePath: /m-anquan-baidu-com/src/containers/product/page_imagerecognition.js
  * @Description: 深度检测
  */var PageImageRecignition = (_temp = _class = function (_PureComponent) {
  _inherits(PageImageRecignition, _PureComponent);function PageImageRecignition(props) {
    var _this2 = this;_classCallCheck(this, PageImageRecignition);var _this = _possibleConstructorReturn(this, (PageImageRecignition.__proto__ || Object.getPrototypeOf(PageImageRecignition)).call(this, props));_this.fetchChackAiImage = function (url, file, filename) {
      _this.setState({ isCheckLoading: true });_this.draw.drawImage({ url: url }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var body, checkAiImageData, faceListLen, curList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                body = {};if (file) {
                  body = new FormData();body.append('file', file, filename);_this.addData(body, true);
                } else {
                  body = { 'upload_url': url };_this.addData(body);
                }_context.next = 4;return _this.props.fetchChackAiImage(body);case 4:
                checkAiImageData = _this.props.checkAiImageData || {};if (checkAiImageData.status === 0) {
                  if (checkAiImageData.data && checkAiImageData.data.err_code === 0) {
                    faceListLen = (checkAiImageData.data.face_list || []).length;curList = checkAiImageData.data.face_list.map(function (item, index) {
                      return { location: item.location, score: item.score, textColor: item.score > 0.5 ? '#40C87F' : '#F5535B', strokeStyle: item.score > 0.5 ? '#40C87F' : '#F5535B', text: faceListLen === 1 ? '' : index + 1, lineWidth: _this.draw.getPixelRatio(2) };
                    });_this.setState({ resultList: curList, errorMsg: '' });_this.draw.drawStrokeInImage({ list: curList });
                  } else {
                    _this.setState({ errorMsg: checkAiImageData.data && checkAiImageData.data.err_msg });
                  }
                } else {
                  _this.setState({ errorMsg: checkAiImageData.description });
                }_this.setState({ isCheckLoading: false });case 7:case 'end':
                return _context.stop();}
          }
        }, _callee, _this2);
      })), function () {
        _this.setState({ errorMsg: '图片加载失败', isCheckLoading: false });
      });
    };_this.onUploadFile = function (e) {
      var curfile = e.target.files[0];if (!curfile) {
        return;
      }_this.draw.clearDraw();_this.setState({ isImageLoading: true, isShowCanvas: true, errorMsg: '', resultList: [] });_this.getRealImage(curfile).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            blob = _ref3[0],
            file = _ref3[1];_this.setState({ isImageLoading: false });if (!(file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/jpeg')) {
          _this.setState({ errorMsg: '图片格式不正确，请重新上传' });return;
        }if (file.size > 1024 * 1024 * 5) {
          _this.setState({ errorMsg: '图片超大，请上传小于5M的图片' });return;
        }var readerFile = new FileReader();readerFile.readAsDataURL(file);readerFile.onload = function (e) {
          _this.fetchChackAiImage(e.target.result, blob, file.name);
        };readerFile.onerror = function () {
          this.setState({ errorMsg: '上传图片失败，请重新上传' });
        };
      }, function () {
        _this.setState({ isImageLoading: false });
      });
    };_this.getRealImage = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(file) {
        var fileSize, scale, orientation, data, fdate, files;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                if (file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/jpeg') {
                  _context2.next = 3;break;
                }_this.setState({ errorMsg: '图片格式不正确，请重新上传', isImageLoading: false });return _context2.abrupt('return');case 3:
                fileSize = 1024 * 1024 * 2;scale = fileSize / file.size > 1 ? 1 : fileSize / file.size;_context2.next = 7;return _this.getOriention(file);case 7:
                orientation = _context2.sent;_context2.next = 10;return _this.readFile(file);case 10:
                data = _context2.sent;_context2.next = 13;return _this.compressImage(data.target.result, orientation, scale, scale);case 13:
                fdate = _context2.sent;files = _this.dataURLtoFile(fdate, file.name);return _context2.abrupt('return', files);case 16:case 'end':
                return _context2.stop();}
          }
        }, _callee2, _this2);
      }));return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onChange = function (e) {
      _this.setState({ inputValue: e.target.value });
    };_this.onUpload = function (e) {
      e.stopPropagation();e.preventDefault();_this.draw.clearDraw();_this.setState({ isShowCanvas: true });if (!/^(http|https):\/\//.test(_this.state.inputValue)) {
        _this.setState({ errorMsg: '图片url无效，请更换图片后重新体验' });return;
      }_this.fetchChackAiImage(_this.state.inputValue);_this.setState({ errorMsg: '', inputValue: '' });
    };_this.onFocus = function () {
      var navBar = document.querySelector('.nav-bar');if (navBar) {
        navBar.style.position = 'absolute';
      }
    };_this.onBlur = function () {
      var navBar = document.querySelector('.nav-bar');if (navBar) {
        navBar.style.position = 'fixed';
      }
    };_this.state = { errorMsg: '', resultList: [], inputValue: '', isShowCanvas: false, isCheckLoading: false, isImageLoading: false };return _this;
  }_createClass(PageImageRecignition, [{ key: 'componentDidMount', value: function componentDidMount() {
      var width = this.checkImageContainer.offsetWidth;var height = this.checkImageContainer.offsetHeight;this.draw = new __WEBPACK_IMPORTED_MODULE_11__components_drawRegion__["a" /* default */]({ id: 'check-img', width: width, height: height });
    } }, { key: 'addData', value: function addData(params, isFromdata) {
      var localData = {};try {
        Object(__WEBPACK_IMPORTED_MODULE_10__util__["a" /* bAntiBotSend */])();if (window.localStorage) {
          var localKey = '__abbaidu_20181211_cb';localData = JSON.parse(window.localStorage.getItem(localKey));
        }
      } catch (e) {
        localData = {};
      }if (isFromdata) {
        if (localData && localData.data) {
          params.append('data', localData.data);
        }if (localData && localData.key_id) {
          params.append('key_id', localData.key_id);
        }if (localData && localData.sign) {
          params.append('sign', localData.sign);
        }
      } else {
        if (localData && localData.data) {
          params.data = localData.data;
        }if (localData && localData.key_id) {
          params['key_id'] = localData.key_id;
        }if (localData && localData.sign) {
          params.sign = localData.sign;
        }
      }
    } }, { key: 'readFile', value: function readFile(file) {
      return new Promise(function (resolve, reject) {
        var fileReader = new FileReader();fileReader.addEventListener('load', resolve);fileReader.addEventListener('error', reject);fileReader.readAsDataURL(file);
      });
    } }, { key: 'compressImage', value: function compressImage(base64Data, orientation, quality) {
      var scale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;return new Promise(function (resolve, reject) {
        var image = new Image();image.addEventListener('load', function () {
          var width = image.width * scale;var height = image.height * scale;var cvs = document.createElement('canvas');var context = cvs.getContext('2d');cvs.height = height;cvs.width = width;if (orientation && orientation !== 1) {
            switch (orientation) {case 6:
                // 旋转90度
                cvs.height = width;cvs.width = height;context.rotate(Math.PI / 2);context.drawImage(image, 0, -height, width, height);break;case 3:
                // 旋转180度
                context.rotate(Math.PI);context.drawImage(image, -width, -height, width, height);break;case 8:
                // 旋转-90度
                cvs.height = width;cvs.width = height;context.rotate(3 * Math.PI / 2);context.drawImage(image, -width, 0, width, height);break;}
          } else {
            context.drawImage(image, 0, 0, width, height);
          }var dataURL = cvs.toDataURL('image/jpeg', quality);resolve(dataURL);
        });image.addEventListener('error', reject);image.src = base64Data;
      });
    } }, { key: 'dataURLtoFile', value: function dataURLtoFile(base64Data, filename) {
      var arr = base64Data.split(','); // const mime = arr[0].match(/:(.*?);/)[1];
      var bstr = window.atob(arr[1]);var len = bstr.length;var u8arr = new window.Uint8Array(len);while (len--) {
        u8arr[len] = bstr.charCodeAt(len);
      }var options = { type: 'image/jpeg' };var blob = new Blob([u8arr], options);return [blob, new File([u8arr], filename, options)];
    } }, { key: 'getOriention', value: function getOriention(file) {
      return new Promise(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_9_exif_js___default.a.getData(file, function () {
          resolve(__WEBPACK_IMPORTED_MODULE_9_exif_js___default.a.getTag(this, 'Orientation'));
        });
      });
    } }, { key: 'getNumber', value: function getNumber(number) {
      var n = number * 100;var newNum = n.toFixed(2);if (/^[0-9]+.00$/.test(newNum)) {
        return +newNum.split('.')[0];
      }if (/^[0-9]+.[0-9]{1}0$/.test(newNum)) {
        return +newNum.slice(0, 3);
      }return +newNum;
    } }, { key: 'render', value: function render() {
      var _this3 = this;var bannerInfo = this.props.bannerInfo || {};var productList = [{ 'mobile_pic': __webpack_require__(540), title: '人脸深度伪造检测', content: '识别图片或视频中的人脸是否存在伪造的情况，提供Deepfake、人脸融合这两种主要的人脸深度伪造检测' }, { 'mobile_pic': __webpack_require__(541), title: '人声伪造检测 (即将上线）', content: '识别声音是否存在伪造的情况，提供合成语音及人声转换检测' }];var senceList = [{ 'mobile_pic': __webpack_require__(542), title: '视频网站', content: '通过对视频中提取图片的检测，高效识别人脸伪造信息，降低人力审核成本‘降低业务违规风险' }, { 'mobile_pic': __webpack_require__(543), title: '新闻机构', content: '识别机构网站或者资源库中的图片和视频是否存在人脸伪造信息，降低人力审核成本，降低业务违规风险。支持定期检测，也可对上传图片做实时检测' }, { 'mobile_pic': __webpack_require__(544), title: '网络论坛', content: '识别网络论坛或者资源库中的图片和视频是否存在人脸伪造信息，降低人力审核成本，降低业务违规风险。支持定期检测，也可对上传图片做实时检测' }, { 'mobile_pic': __webpack_require__(545), title: '新媒体', content: '识别新媒体或者资源库中的图片和视频是否存在人脸伪造信息，降低人力审核成本，降低业务违规风险。支持定期检测，也可对上传图片做实时检测' }];var proinfoBox = [{ 'mobile_pic': __webpack_require__(546), title: '持续领先的检测技术', content: '深度换脸伪造技术进步日新月异，持续的投入的对抗和检测，积累起海量数据，保障可靠的检测能力' }, { 'mobile_pic': __webpack_require__(547), title: '识别准确率高', content: '假脸识别功能基于深度学习的智能识别技术，拥有海量人脸、图片训练集，准确率行业领先' }, { 'mobile_pic': __webpack_require__(548), title: '不断维护的数据支撑', content: '深度换脸伪造技术进步日新月异，持续的投入的对抗和检测，积累起海量数据，保障可靠的检测能力' }, { 'mobile_pic': __webpack_require__(549), title: '灵活的接入方式', content: '支持快速方便的WEB API或SDK调用，提供根据业务场景和需求适配的行业解决方案' }];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-des' }, '\u51ED\u501F\u5728\u6DF1\u5EA6\u4F2A\u9020\u68C0\u6D4B\u4E0A\u6DF1\u539A\u7684\u6280\u672F\u79EF\u7D2F\uFF0C\u767E\u5EA6\u5B89\u5168\u6DF1\u5EA6\u6362\u8138\u68C0\u6D4B\u5E73\u53F0\u5728\u4EBA\u8138\u4F2A\u9020\u5927\u6570\u636E\u4E2D\uFF0C \u5BFB\u627E\u9020\u5047\u7684\u86DB\u4E1D\u9A6C\u8FF9\u3002\u901A\u8FC7\u8BAD\u7EC3\u6DF1\u5EA6\u795E\u7ECF\u7F51\u7EDC\u6A21\u578B\u8BC6\u522B\u5047\u8138\u7684\u8FB9\u7F18\u6548\u5E94\u3001\u7EB9\u7406\u3001\u80A4\u8272\u53D8\u5316\u3001\u5206\u8FA8\u7387\u5DEE\u5F02\u3001\u626D\u66F2\u7B49\u7279\u5F81\u6765\u9274\u522B\u5047\u8138\uFF0C \u7ED3\u5408\u6570\u5B57\u56FE\u50CF\u5904\u7406\u6280\u672F\uFF0C\u4E3A\u6570\u636E\u9274\u4F2A\u5DE5\u4F5C\uFF0C\u63D0\u4F9B\u6709\u529B\u652F\u6301\u3002'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ProductTitle__["a" /* default */], { title: '\u4EA7\u54C1\u529F\u80FD' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, productList.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, className: 'proinfo-box mui-flex', style: { borderBottom: 0, paddingTop: 0, paddingBottom: '.8rem' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-icon', style: { height: '1.8rem', width: '2.2rem' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: item.mobile_pic, width: '100%', alt: item.title })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-title', style: { marginBottom: '0.1rem' } }, item.title), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-des' }, item.content)));
      })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ProductTitle__["a" /* default */], { title: '\u529F\u80FD\u4F53\u9A8C' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-function' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('product-function-canvas', { show: this.state.isShowCanvas }) }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { ref: function ref(checkImageContainer) {
          _this3.checkImageContainer = checkImageContainer;
        }, className: 'check-img-container' }, this.state.isImageLoading && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'image-loading-cantainer' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'image-loading' })), this.state.isCheckLoading && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'check-img-loading' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('canvas', { id: 'check-img', ref: function ref(checkImage) {
          _this3.checkImage = checkImage;
        } })), this.state.errorMsg && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-function-canvas-tip' }, this.state.errorMsg), !this.state.errorMsg && this.state.resultList.length > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('product-function-canvas-result', { simple: this.state.resultList.length <= 3 }) }, this.state.resultList.map(function (item, index) {
        var score = item.score;var isCur = score > 0.5;var curIndex = _this3.state.resultList.length === 1 ? '' : index + 1 + '.';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, style: { color: isCur ? '#40C87F' : '#F5535B' }, className: 'product-function-canvas-result-item' }, curIndex, isCur ? '真脸' : '假脸', _this3.getNumber(isCur ? item.score : 1 - item.score), '%');
      }))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label', { className: 'product-function-upload' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { type: 'file', accept: 'image/jpeg,image/png,image/bmp', onChange: this.onUploadFile }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-function-upload-des' }, '\u4E0A\u4F20\u68C0\u6D4B\u56FE\u7247')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-function-blank' }, '\u6216'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-function-url' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form', { onSubmit: this.onUpload }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { type: 'text', onFocus: this.onFocus, onBlur: this.onBlur, value: this.state.inputValue, onChange: this.onChange, placeholder: '\u8BF7\u8F93\u5165\u56FE\u7247url' }))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-function-des' }, '\u4EC5\u652F\u6301PNG\u3001JPG\u3001JPEG\u3001BMP\u7C7B\u578B\u6587\u4EF6\uFF0C\u56FE\u7247\u5927\u5C0F\u4E0D\u8D85\u8FC75M')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ProductTitle__["a" /* default */], { title: '\u9002\u7528\u573A\u666F' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, senceList.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-applicable', key: index, style: { backgroundImage: 'url(' + item.mobile_pic + ')' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-title' }, item.title), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-content' }, item.content));
      }))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ProductTitle__["a" /* default */], { title: '\u4EA7\u54C1\u7279\u8272' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, proinfoBox.map(function (item, index) {
        var style = index === 3 ? { borderBottom: 0 } : null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, className: 'proinfo-box mui-flex', style: style }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: item.mobile_pic, width: '100%', alt: item.title })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-title' }, item.title), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-des' }, item.content)));
      })));
    } }]);return PageImageRecignition;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]), _class.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, fetchChackAiImage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, checkAiImageData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function (state) {
  return { checkAiImageData: state.checkAiImageData };
}, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({ fetchChackAiImage: __WEBPACK_IMPORTED_MODULE_8__actions_productAction__["c" /* fetchChackAiImage */] }, dispatch);
})(PageImageRecignition));

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(539);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 539 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic-1.8da125c1.png";

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic-2.ffabecba.png";

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sence1.0ec5a10d.png";

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sence2.57cde21e.png";

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sence3.bfade696.png";

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sence4.f3371eed.png";

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_1.cbaa8152.svg";

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_2.c73d0969.svg";

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_3.e16b10b2.svg";

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_4.3e2d51f1.svg";

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_productAction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Confirmation__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_aiScan__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__page_imagerecognition_less__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__page_imagerecognition_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__page_imagerecognition_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: wence@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2023-06-09 16:01:23
  * @FilePath: /m-anquan-baidu-com/src/containers/product/page_inspection.js
  * @Description: 园区智慧巡检
  */var PageInspection = (_temp = _class = function (_PureComponent) {
  _inherits(PageInspection, _PureComponent);function PageInspection(props) {
    _classCallCheck(this, PageInspection);var _this = _possibleConstructorReturn(this, (PageInspection.__proto__ || Object.getPrototypeOf(PageInspection)).call(this, props));_this.afterResponse = function (res) {
      if (res.status === 4040001) {
        Object(__WEBPACK_IMPORTED_MODULE_9__components_Confirmation__["a" /* default */])({ okText: '立即申请', concelText: '取消', onOk: function onOk() {
            window.location.href = '/m/apply-inspection?url=' + encodeURIComponent(window.location.pathname);
          }, renderBody: function renderBody() {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'title', style: { fontSize: '.48rem', marginBottom: '.2rem' } }, '\u514D\u8D39\u4F53\u9A8C\u6B21\u6570\u9650\u5236\u63D0\u793A'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'content' }, '\u666E\u901A\u7528\u6237\u652F\u6301\u6BCF\u5929\u8BD5\u752810\u6B21\uFF0C\u7533\u8BF7\u5BA1\u6838\u901A\u8FC7\u540E\uFF0C\u60A8\u53EF\u83B7\u5F97\u6BCF\u5929\u514D\u8D39\u4F53\u9A8C50\u6B21\u7684\u6743\u9650\u3002'));
          } });
      } else if (res.status === 4040002) {
        Object(__WEBPACK_IMPORTED_MODULE_9__components_Confirmation__["a" /* default */])({ okText: '立即申请', concelText: '取消', onOk: function onOk() {
            window.location.href = '/console/#/inspectionApply';
          }, renderBody: function renderBody() {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'title', style: { fontSize: '.48rem', marginBottom: '.2rem' } }, '\u514D\u8D39\u4F53\u9A8C\u6B21\u6570\u9650\u5236\u63D0\u793A'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'content' }, '\u5F53\u524D\u514D\u8D39\u4F53\u9A8C\u6B21\u6570\u5DF2\u7528\u5B8C\uFF0C\u4F53\u9A8C\u66F4\u591A\u68C0\u6D4B\u80FD\u529B\u53EF\u7533\u8BF7POC'));
          } });
      }
    };_this.state = { instanceId: '' };return _this;
  }_createClass(PageInspection, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                _context.next = 2;return Object(__WEBPACK_IMPORTED_MODULE_8__actions_productAction__["j" /* getInstanceId */])();case 2:
                res = _context.sent;if (res.status === 0) {
                  this.setState({ instanceId: Object.keys(res.data)[0] });
                }case 4:case 'end':
                return _context.stop();}
          }
        }, _callee, this);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _this2 = this;var bannerInfo = this.props.bannerInfo || {};var productList = [{ 'mobile_pic': __webpack_require__(553), title: '安全帽合规检测', content: '工业厂区生产环境复杂，安全帽佩戴对保障人员安全至关重要。针对视频内容，实时检测出工地人员，并判断是否佩戴安全帽，当未佩戴安全帽时，及时报警，规范着装要求，降低作业风险。' }, { 'mobile_pic': __webpack_require__(554), title: '危险行为检测', content: '根据图片或实时监控视频，识别工作人员是否存在抽烟打电话行为，若存在，及时报警，降低火灾风险，营造安全作业环境。' }];var senceList = [{ 'mobile_pic': __webpack_require__(555), title: '工业园区', content: '聚焦安全生产问题，从人员着装规范和厂区生产环境两个方面，为生产安全提供保障。智能化监控未佩戴安全帽行为，降低着装违规风险，高效捕捉抽烟打电话行为，为生产环境安全提供进一步保障。' }, { 'mobile_pic': __webpack_require__(556), title: '加油站', content: '检测加油服务场景中是否存在抽烟打电话行为，高效识别并及时报警，降低加油站火灾风险。' }, { 'mobile_pic': __webpack_require__(557), title: '餐厅商店等营业场所', content: '在餐厅商店等公共区域，抽烟行为会影响其他顾客就餐以及购物体验并有火灾风险，高效识别抽烟行为并报警，营造良好的营业环境，增加顾客满意度。' }];var proinfoBox = [{ 'mobile_pic': __webpack_require__(558), title: '领先的检测技术', content: '依托百度安全在检测领域的丰富技术积累和不断更新的技术能力，保障检测服务的领先能力。' }, { 'mobile_pic': __webpack_require__(559), title: '识别准确率高', content: '依托百度安全的算法积累和工业原始训练数据积累，模型准确率和召回率行业领先。' }, { 'mobile_pic': __webpack_require__(560), title: '易于集成部署', content: '提供完善的组件化SDK、API接口、配置后台，根据业务场景和需求灵活配置部署。' }];var userLoginstate = this.props.userLoginstate;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-des' }, '\u57FA\u4E8E\u767E\u5EA6AI\u56FE\u50CF\u8BC6\u522B\u6280\u672F\uFF0C\u96C6\u6210\u5404\u7C7B\u6444\u50CF\u5934\u3001\u65E0\u4EBA\u673A\u3001\u673A\u5668\u4EBA\u3001AI\u82AF\u7247\u53CA\u5DE1\u68C0\u573A\u666F\u6A21\u578B\uFF0C \u5B9E\u73B0\u5BF9\u5DE5\u4E1A\u751F\u4EA7\u573A\u666F\u751F\u4EA7\u4F5C\u4E1A\u3001\u8BBE\u5907\u72B6\u6001\u3001\u4EBA\u5458\u5B89\u5168\u7684\u667A\u80FD\u76D1\u63A7\u548C\u5B9E\u65F6\u9884\u8B66\uFF0C\u5E2E\u52A9\u4F01\u4E1A\u5B9E\u73B0\u5B89\u5168\u751F\u4EA7\uFF0C \u63D0\u9AD8\u76D1\u7BA1\u6548\u7387\uFF0C\u51CF\u5C11\u4EBA\u529B\u6210\u672C'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ProductTitle__["a" /* default */], { title: '\u4EA7\u54C1\u529F\u80FD' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, productList.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, className: 'proinfo-box mui-flex', style: { borderBottom: 0, paddingTop: 0, paddingBottom: '.8rem' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-icon', style: { height: '1.8rem', width: '2.2rem' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: item.mobile_pic, width: '100%', alt: item.title })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-title', style: { marginBottom: '0.1rem' } }, item.title), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-des' }, item.content)));
      })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ProductTitle__["a" /* default */], { title: '\u529F\u80FD\u4F53\u9A8C' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-function product-inspection-scan' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_aiScan__["a" /* default */], { hiddenUrl: true, onUploadBtnClick: function onUploadBtnClick(e) {
          if (!(userLoginstate && userLoginstate.status === 0)) {
            e.stopPropagation();e.preventDefault();window.location.href = _this2.loginUrl();
          }
        }, afterResponse: this.afterResponse, renderResultList: function renderResultList(resultList, isFetch) {
          if (!isFetch) {
            return '';
          }var errList = resultList.filter(function (item) {
            return item.name === 'none';
          }) || [];return errList.length + '\u5904\u5F02\u5E38';
        }, responseFormater: function responseFormater(data) {
          var list = [];data.results.forEach(function (item, index) {
            if (item.attrib && item.attrib.length > 0) {
              item.attrib.forEach(function (attr, attrIndex) {
                var defaultColor = attr.name === 'none' ? '#F5535B' : '#40C87F';list.push({ location: attr.location, score: attr.score, textColor: defaultColor, name: attr.name, strokeStyle: defaultColor, text: attrIndex + index + 1 });
              });
            }
          });return list;
        }, beforeFetch: function beforeFetch(data) {
          return { image: (data.upload_url || '').split(',')[1] || data.upload_url, 'key_id': data.key_id, 'instance_id': _this2.state.instanceId, sign: data.sign, data: data.data, model: 'anquanmao', type: 0 };
        }, fetchChackAiImage: this.props.fetchChackAiIndustry, checkAiImageData: this.props.checkAiInsdustryData })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ProductTitle__["a" /* default */], { title: '\u9002\u7528\u573A\u666F' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, senceList.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-applicable', key: index, style: { backgroundImage: 'url(' + item.mobile_pic + ')', height: index === 0 ? '3.96rem' : '3.46rem', backgroundSize: 'contain', display: 'flex', alignItems: 'flex-start', flexDirection: 'column', justifyContent: 'center', paddingTop: 0 } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-title' }, item.title), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-content' }, item.content));
      }))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ProductTitle__["a" /* default */], { title: '\u4EA7\u54C1\u7279\u8272' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, proinfoBox.map(function (item, index) {
        var style = index === 2 ? { borderBottom: 0 } : null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, className: 'proinfo-box mui-flex', style: style }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: item.mobile_pic, width: '100%', alt: item.title })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-title' }, item.title), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-des' }, item.content)));
      })));
    } }]);return PageInspection;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]), _class.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, fetchChackAiIndustry: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, checkAiInsdustryData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, userLoginstate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function (state) {
  return { checkAiInsdustryData: state.checkAiInsdustryData, userLoginstate: state.userLoginstate };
}, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({ fetchChackAiIndustry: __WEBPACK_IMPORTED_MODULE_8__actions_productAction__["d" /* fetchChackAiIndustry */] }, dispatch);
})(PageInspection));

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AiScan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_exif_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_exif_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_exif_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__drawRegion__ = __webpack_require__(227);
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: ai扫描组件
  * @author: wence
  */var AiScan = (_temp = _class = function (_PureComponent) {
  _inherits(AiScan, _PureComponent);function AiScan(props) {
    var _this2 = this;_classCallCheck(this, AiScan);var _this = _possibleConstructorReturn(this, (AiScan.__proto__ || Object.getPrototypeOf(AiScan)).call(this, props));_this.fetchChackAiImage = function (url, file, filename) {
      _this.setState({ isCheckLoading: true });_this.draw.drawImage({ url: url }, _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var body, cur, checkAiImageData, faceListLen, curList, responseFormater, _curList, afterResponse;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                body = {};if (_this.props.beforeFetch) {
                  cur = { file: file, filename: filename, 'upload_url': url };_this.addData(cur);body = _this.props.beforeFetch(cur);
                } else if (file) {
                  body = new FormData();body.append('file', file, filename);_this.addData(body, !!file);
                } else {
                  body = { 'upload_url': url };_this.addData(body, !!file);
                }_context.next = 4;return _this.props.fetchChackAiImage(body);case 4:
                checkAiImageData = _this.props.checkAiImageData || {};if (checkAiImageData.status === 0) {
                  if (checkAiImageData.data && checkAiImageData.data.err_code && checkAiImageData.data.err_code === 0) {
                    faceListLen = (checkAiImageData.data.face_list || []).length;curList = checkAiImageData.data.face_list.map(function (item, index) {
                      return { location: item.location, score: item.score, textColor: item.score > 0.5 ? '#40C87F' : '#F5535B', strokeStyle: item.score > 0.5 ? '#40C87F' : '#F5535B', text: faceListLen === 1 ? '' : index + 1, lineWidth: _this.draw.getPixelRatio(2) };
                    });_this.setState({ resultList: curList, errorMsg: '' });_this.draw.drawStrokeInImage({ list: curList });
                  } else if (checkAiImageData.data && checkAiImageData.data.err_msg) {
                    _this.setState({ errorMsg: checkAiImageData.data && checkAiImageData.data.err_msg });
                  } else {
                    responseFormater = _this.props.responseFormater;_curList = responseFormater ? responseFormater(checkAiImageData.data) : checkAiImageData.data;_this.setState({ resultList: _curList, errorMsg: '' });_this.draw.drawStrokeInImage({ list: _curList });
                  }
                } else {
                  _this.setState({ errorMsg: checkAiImageData.description });
                }afterResponse = _this.props.afterResponse;if (afterResponse) {
                  afterResponse(checkAiImageData);
                }_this.setState({ isCheckLoading: false, isFetch: true });case 9:case 'end':
                return _context.stop();}
          }
        }, _callee, _this2);
      })), function () {
        _this.setState({ errorMsg: '图片加载失败', isCheckLoading: false });
      });
    };_this.onUploadFile = function (e) {
      var curfile = e.target.files[0];if (!curfile) {
        return;
      }_this.draw.clearDraw();_this.setState({ isImageLoading: true, isShowCanvas: true, errorMsg: '', resultList: [], isFetch: false });_this.getRealImage(curfile).then(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            blob = _ref3[0],
            file = _ref3[1];_this.setState({ isImageLoading: false });if (!(file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/jpeg')) {
          _this.setState({ errorMsg: '图片格式不正确，请重新上传' });return;
        }if (file.size > 1024 * 1024 * 5) {
          _this.setState({ errorMsg: '图片超大，请上传小于5M的图片' });return;
        }var readerFile = new FileReader();readerFile.readAsDataURL(file);readerFile.onload = function (e) {
          _this.fetchChackAiImage(e.target.result, blob, file.name);
        };readerFile.onerror = function () {
          this.setState({ errorMsg: '上传图片失败，请重新上传' });
        };
      }, function () {
        _this.setState({ isImageLoading: false });
      });
    };_this.getRealImage = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(file) {
        var fileSize, scale, orientation, data, fdate, files;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                if (file.type === 'image/png' || file.type === 'image/bmp' || file.type === 'image/jpeg') {
                  _context2.next = 3;break;
                }_this.setState({ errorMsg: '图片格式不正确，请重新上传', isImageLoading: false });return _context2.abrupt('return');case 3:
                fileSize = 1024 * 1024 * 2;scale = fileSize / file.size > 1 ? 1 : fileSize / file.size;_context2.next = 7;return _this.getOriention(file);case 7:
                orientation = _context2.sent;_context2.next = 10;return _this.readFile(file);case 10:
                data = _context2.sent;_context2.next = 13;return _this.compressImage(data.target.result, orientation, scale, scale);case 13:
                fdate = _context2.sent;files = _this.dataURLtoFile(fdate, file.name);return _context2.abrupt('return', files);case 16:case 'end':
                return _context2.stop();}
          }
        }, _callee2, _this2);
      }));return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }();_this.onChange = function (e) {
      _this.setState({ inputValue: e.target.value });
    };_this.onUpload = function (e) {
      e.stopPropagation();e.preventDefault();_this.draw.clearDraw();_this.setState({ isShowCanvas: true, isFetch: false });if (!/^(http|https):\/\//.test(_this.state.inputValue)) {
        _this.setState({ errorMsg: '图片url无效，请更换图片后重新体验' });return;
      }_this.fetchChackAiImage(_this.state.inputValue);_this.setState({ errorMsg: '', inputValue: '' });
    };_this.onFocus = function () {
      var navBar = document.querySelector('.nav-bar');if (navBar) {
        navBar.style.position = 'absolute';
      }
    };_this.onBlur = function () {
      var navBar = document.querySelector('.nav-bar');if (navBar) {
        navBar.style.position = 'fixed';
      }
    };_this.state = { errorMsg: '', resultList: [], inputValue: '', isShowCanvas: false, isCheckLoading: false, isImageLoading: false, isFetch: false };return _this;
  }_createClass(AiScan, [{ key: 'componentDidMount', value: function componentDidMount() {
      var width = this.checkImageContainer.offsetWidth;var height = this.checkImageContainer.offsetHeight;this.draw = new __WEBPACK_IMPORTED_MODULE_6__drawRegion__["a" /* default */]({ id: 'check-img', width: width, height: height });
    } }, { key: 'addData', value: function addData(params, isFromdata) {
      var localData = {};try {
        Object(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* bAntiBotSend */])();if (window.localStorage) {
          var localKey = '__abbaidu_20181211_cb';localData = JSON.parse(window.localStorage.getItem(localKey));
        }
      } catch (e) {
        localData = {};
      }if (isFromdata) {
        if (localData && localData.data) {
          params.append('data', localData.data);
        }if (localData && localData.key_id) {
          params.append('key_id', localData.key_id);
        }if (localData && localData.sign) {
          params.append('sign', localData.sign);
        }
      } else {
        if (localData && localData.data) {
          params.data = localData.data;
        }if (localData && localData.key_id) {
          params['key_id'] = localData.key_id;
        }if (localData && localData.sign) {
          params.sign = localData.sign;
        }
      }
    } }, { key: 'readFile', value: function readFile(file) {
      return new Promise(function (resolve, reject) {
        var fileReader = new FileReader();fileReader.addEventListener('load', resolve);fileReader.addEventListener('error', reject);fileReader.readAsDataURL(file);
      });
    } }, { key: 'compressImage', value: function compressImage(base64Data, orientation, quality) {
      var scale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;return new Promise(function (resolve, reject) {
        var image = new Image();image.addEventListener('load', function () {
          var width = image.width * scale;var height = image.height * scale;var cvs = document.createElement('canvas');var context = cvs.getContext('2d');cvs.height = height;cvs.width = width;if (orientation && orientation !== 1) {
            switch (orientation) {case 6:
                // 旋转90度
                cvs.height = width;cvs.width = height;context.rotate(Math.PI / 2);context.drawImage(image, 0, -height, width, height);break;case 3:
                // 旋转180度
                context.rotate(Math.PI);context.drawImage(image, -width, -height, width, height);break;case 8:
                // 旋转-90度
                cvs.height = width;cvs.width = height;context.rotate(3 * Math.PI / 2);context.drawImage(image, -width, 0, width, height);break;}
          } else {
            context.drawImage(image, 0, 0, width, height);
          }var dataURL = cvs.toDataURL('image/jpeg', quality);resolve(dataURL);
        });image.addEventListener('error', reject);image.src = base64Data;
      });
    } }, { key: 'dataURLtoFile', value: function dataURLtoFile(base64Data, filename) {
      var arr = base64Data.split(','); // const mime = arr[0].match(/:(.*?);/)[1];
      var bstr = window.atob(arr[1]);var len = bstr.length;var u8arr = new window.Uint8Array(len);while (len--) {
        u8arr[len] = bstr.charCodeAt(len);
      }var options = { type: 'image/jpeg' };var blob = new Blob([u8arr], options);return [blob, new File([u8arr], filename, options)];
    } }, { key: 'getOriention', value: function getOriention(file) {
      return new Promise(function (resolve) {
        __WEBPACK_IMPORTED_MODULE_5_exif_js___default.a.getData(file, function () {
          resolve(__WEBPACK_IMPORTED_MODULE_5_exif_js___default.a.getTag(this, 'Orientation'));
        });
      });
    } }, { key: 'getNumber', value: function getNumber(number) {
      var n = number * 100;var newNum = n.toFixed(2);if (/^[0-9]+.00$/.test(newNum)) {
        return +newNum.split('.')[0];
      }if (/^[0-9]+.[0-9]{1}0$/.test(newNum)) {
        return +newNum.slice(0, 3);
      }return +newNum;
    } }, { key: 'render', value: function render() {
      var _this3 = this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('product-function-canvas', { show: this.state.isShowCanvas }) }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { ref: function ref(checkImageContainer) {
          _this3.checkImageContainer = checkImageContainer;
        }, className: 'check-img-container' }, this.state.isImageLoading && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'image-loading-cantainer' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'image-loading' })), this.state.isCheckLoading && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'check-img-loading' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('canvas', { id: 'check-img', ref: function ref(checkImage) {
          _this3.checkImage = checkImage;
        } })), this.state.errorMsg && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-function-canvas-tip' }, this.state.errorMsg), !this.state.errorMsg && this.state.resultList.length >= 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('product-function-canvas-result', { simple: this.state.resultList.length <= 3 && this.state.resultList.length > 0 }) }, this.props.renderResultList ? this.props.renderResultList(this.state.resultList, this.state.isFetch) : this.state.resultList.map(function (item, index) {
        var score = item.score;var isCur = score > 0.5;var curIndex = _this3.state.resultList.length === 1 ? '' : index + 1 + '.';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, style: { color: isCur ? '#40C87F' : '#F5535B' }, className: 'product-function-canvas-result-item' }, curIndex, isCur ? '真脸' : '假脸', _this3.getNumber(isCur ? item.score : 1 - item.score), '%');
      }))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label', { className: 'product-function-upload', onClick: this.props.onUploadBtnClick }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { type: 'file', accept: 'image/jpeg,image/png,image/bmp', onChange: this.onUploadFile }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-function-upload-des' }, '\u4E0A\u4F20\u68C0\u6D4B\u56FE\u7247')), !this.props.hiddenUrl && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-function-blank' }, '\u6216'), !this.props.hiddenUrl && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-function-url' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form', { onSubmit: this.onUpload }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { type: 'text', onFocus: this.onFocus, onBlur: this.onBlur, value: this.state.inputValue, onChange: this.onChange, placeholder: '\u8BF7\u8F93\u5165\u56FE\u7247url' }))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-function-des' }, '\u4EC5\u652F\u6301PNG\u3001JPG\u3001JPEG\u3001BMP\u7C7B\u578B\u6587\u4EF6\uFF0C\u56FE\u7247\u5927\u5C0F\u4E0D\u8D85\u8FC75M'));
    } }]);return AiScan;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]), _class.propTypes = { fetchChackAiImage: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, renderResultList: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, checkAiImageData: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, hiddenUrl: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool, onUploadBtnClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, beforeFetch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, afterResponse: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, responseFormater: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func }, _temp);

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_anquanmaojiance.ebf27cc9.png";

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/iocn_weixianxingwei.8ee1e311.png";

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sence1.6180ff9b.png";

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sence2.02c262a5.png";

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sence3.5838e1e4.png";

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_jiancejishu.9281236a.svg";

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_zhunquelv.0c707ba7.svg";

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_jichengbushu.d2d32adb.svg";

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__ = __webpack_require__(10);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 产品二级页
  * @author wangzhuang
  * */var Product = (_temp = _class = function (_Component) {
  _inherits(Product, _Component);function Product(props, context) {
    _classCallCheck(this, Product);var _this = _possibleConstructorReturn(this, (Product.__proto__ || Object.getPrototypeOf(Product)).call(this, props, context));_this.state = {};return _this;
  }_createClass(Product, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        location.href = '/newsite/security_privacy';
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {} }, { key: 'render', value: function render() {
      var bannerInfo = this.props.bannerInfo || {};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, '依托百度领先的数据安全能力及隐私保护技术，数据安全与隐私解决方案集成数据治理与敏捷大数据' + '分析、AI数据脱敏及联邦计算，覆盖数据资产管理、敏感数据处理及安全合规数据流通三大场景，助力企业实现数据全生命周' + '期的安全治理及防护。'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '业务结构' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod pr sp-step' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'structure' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '//anquan.baidu.com/m/product/11', className: 'shadow1' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '//anquan.baidu.com/m/product/36', className: 'shadow2' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '//anquan.baidu.com/m/product/63', className: 'shadow3' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '//anquan.baidu.com/m/product/10', className: 'shadow4' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '方案优势' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod sec-p-box' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(229), width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u9886\u5148\u524D\u6CBF\u7684\u6570\u636E\u5B89\u5168\u6280\u672F'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '依托百度安全在数据安全及隐私保护方向领先的安全技术(MPC、TEE、DP)、AI技术(图像识别、' + '自然语言处理)长期积累，保障整体数据安全可控'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(230), width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u7A33\u5B9A\u9AD8\u6548\u7684\u5DE5\u7A0B\u80FD\u529B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '支持集群分布式、并发计算、算法优化等功能，实现海量大数据安全生产流通，保障数据链路稳定高效'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(231), width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u72EC\u7ACB\u79C1\u6709\u5316\u90E8\u7F72\u65B9\u5F0F'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '支持私有化+SaaS的部署方式，还可根据用户业务需求场景独立私有化部署，能够与区块链、边缘计算等业务进行有机融合')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '方案特点' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u5B89\u5168\u9886\u5148\u7684\u8054\u90A6\u8BA1\u7B97\u7CFB\u7EDF'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '基于百度安全先进的MPC、TEE、DP安全技术，满足政务数据的安全共享，金融数据的联合风控、' + '医疗数据的联合建模以及广告领域的联合营销等复杂业务场景'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u5B89\u5168\u9AD8\u6548\u7684\u6570\u636E\u6CBB\u7406\u8C03\u5EA6\u7CFB\u7EDF'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '支持批量任务的开发与调度管理，实现异常任务监控探查，在保证数据高效使用及价值挖掘的基础上，支持完善的资产权限控制'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u7075\u6D3B\u6613\u7528\u7684\u6570\u636E\u8D44\u4EA7\u7BA1\u7406\u4E0E\u4EF7\u503C\u6316\u6398\u7CFB\u7EDF'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '支持快速搭建数据门户，实现自助多维数据敏捷分析，自动生成阶段性报告，专业的数据可视化呈现，满足用户的数据分析挖掘场景需求'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u5065\u5168\u5408\u89C4\u7684\u654F\u611F\u6570\u636E\u4FDD\u62A4\u7CFB\u7EDF'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '基于百度先进的AI技术体系，支持医疗领域影像及电子病历的脱敏保护，满足GDPR等规范要求的敏感数据类' + '行保护，严格遵守国标、行标的产品技术要求，提供有效的合规性背书')))));
    } }]);return Product;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return {};
}function mapDispatchToProps(dispatch) {
  return {};
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Product));

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_luBangAction__ = __webpack_require__(563);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: WangZhuang@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2023-06-09 15:43:05
  * @FilePath: /m-anquan-baidu-com/src/containers/product/pageLuBang.js
  * @Description: 鲁棒性检测
  */var PageLuBang = (_temp = _class = function (_PureComponent) {
  _inherits(PageLuBang, _PureComponent);function PageLuBang(props, context) {
    _classCallCheck(this, PageLuBang);var _this = _possibleConstructorReturn(this, (PageLuBang.__proto__ || Object.getPrototypeOf(PageLuBang)).call(this, props, context));_this.setValFn = function (s) {
      var str = '';s = s.toString().substr(2, s.length).split('');for (var i = 0; i < s.length; i++) {
        if (s[i] > 0) {
          str = s[i] + 'e-' + (i + 1);break;
        }
      }return str;
    };_this.state = { objClass: {}, objTarget: {}, off1: false, off2: false };return _this;
  }_createClass(PageLuBang, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        location.href = '/newsite/robustness';
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;this.props.fetchLeaderBoard({ type: 'classification' }).then(function (data) {
        if (data.data.status === 0) {
          _this2.setState({ objClass: data.data.data.classification || {} });
        }
      });this.props.fetchLeaderBoard({ type: 'target' }).then(function (data) {
        if (data.data.status === 0) {
          _this2.setState({ objTarget: data.data.data.target || {} });
        }
      });
    } }, { key: 'render', value: function render() {
      var _this3 = this;var bannerInfo = this.props.bannerInfo || {};var _state = this.state,
          objClass = _state.objClass,
          objTarget = _state.objTarget,
          off1 = _state.off1,
          off2 = _state.off2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product lubang' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, '基于百度安全深度学习模型安全评估框架，对AI模型在多个安全维度进行鲁棒性检测，为研究人员和用户提升AI模型质量，' + '降低由于客观真实环境变化或恶意攻击造成的安全隐患。'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lb-box1' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '产品功能' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lb-mod1' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u9C81\u68D2\u6027\u68C0\u6D4B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, '\u5BF9\u4E0A\u4F20\u7684AI\u6A21\u578B\u8FDB\u884C\u9C81\u68D2\u6027\u68C0\u6D4B\uFF0C\u53EF\u6309\u9700\u8BBE\u7F6E\u8BC4\u6D4B\u5C5E\u6027\u3001\u8BC4\u6D4B\u6807\u51C6\u3001\u4EE5\u53CA\u9C81\u68D2\u6027\u5EA6\u91CF\u6807\u51C6\u3002')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u6B3A\u9A97\u6027\u6837\u672C'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, '\u5982\u679C\u7528\u6237\u9700\u8981\uFF0C\u5E73\u53F0\u53EF\u4EE5\u63D0\u4F9B\u6B3A\u9A97\u6A21\u578B\u7684\u8F93\u5165\u6837\u672C\u6570\u636E\u96C6\u3002')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u68C0\u6D4B\u62A5\u544A'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, '\u63D0\u4F9B\u68C0\u6D4B\u7ED3\u679C\uFF0C\u652F\u6301\u5BF9\u4E0D\u540C\u7684\u5B89\u5168\u5C5E\u6027\uFF0C\u5C55\u793A\u4E0E\u5176\u4ED6\u9884\u8BAD\u7EC3\u6A21\u578B\u4E4B\u95F4\u7684\u6BD4\u8F83\u3002')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '适用场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable', style: { backgroundImage: 'url(' + __webpack_require__(564) + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u65B0\u5F00\u53D1AI\u6A21\u578B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, '\u5BF9\u65B0\u5F00\u53D1\u7684AI\u6A21\u578B\u505A\u9C81\u68D2\u6027\u68C0\u6D4B\uFF0C\u63D0\u524D\u53D1\u73B0\u95EE\u9898\u5E76\u8FDB\u884C\u4FEE\u590D\uFF0C\u63D0\u9AD8\u6A21\u578B\u7684\u5B89\u5168\u6027\u3002')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable', style: { backgroundImage: 'url(' + __webpack_require__(565) + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, 'AI\u6A21\u578B\u5347\u7EA7'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, 'AI\u6A21\u578B\u5347\u7EA7\u540E\u8FDB\u884C\u9C81\u68D2\u6027\u68C0\u6D4B\uFF0C\u53D1\u73B0\u5347\u7EA7\u95EE\u9898\uFF0C\u63D0\u9AD8\u6A21\u578B\u7684\u5B89\u5168\u6027\u3002')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable', style: { backgroundImage: 'url(' + __webpack_require__(566) + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, 'AI\u6A21\u578B\u4E0D\u5B9A\u671F\u68C0\u6D4B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, '\u9C81\u68D2\u6027\u68C0\u6D4B\u4F1A\u6301\u7EED\u66F4\u65B0\u68C0\u6D4B\u80FD\u529B\uFF0C\u66F4\u65B0\u540E\u53EF\u4E3AAI\u6A21\u578B\u505A\u591A\u68C0\u6D4B\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '产品特色' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(131), width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u591A\u5E73\u53F0\u652F\u6301'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '鲁棒性测试代码可以无需修改地对多种热门深度学习框架下的模型进行标准化评测，支持的框架包' + '括：Keras, PyTorch'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(132), width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u591A\u4EFB\u52A1\u652F\u6301'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '目前所有的对抗机器学习库都仅支持基础的图像分类任务，Perceptron 支持包括对无人驾驶' + '意义重大的目标检测模型在内的多种视觉任务'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(133), width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u4E91\u7AEF\u9ED1\u76D2\u6A21\u578B\u652F\u6301'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, 'Perceptron同时也支持对 MLaaS 场景下封装后的云端模型API的鲁棒性度量，我们为包括' + 'Google Cloud Vision, Baidu AIP, Amazon Rekognition在内的多个商用AI平台提' + '供了便于测试的接口'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(134), width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u6807\u51C6\u5316\u5EA6\u91CF'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, 'Perceptron Robustness Benchmark 所给出的模型鲁棒性度量可以用来进行多任务，' + '多模型间的比较，并可被用来作为对模型鲁棒性上界的估计'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(135), width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u53EF\u9A8C\u8BC1\u7684\u9C81\u68D2\u6027'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, 'Perceptron Robustness Benchmark 使用形式化验证的方法，通过符号区间分' + '析 (symbolic interval analysis) 为模型计算出可信赖的鲁棒性下界，即当' + '叠加在样本上的扰动小于该下界，模型能够确保预测结果的一致性')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lb-box2' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '鲁棒性排行榜' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lb-mod4' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u5206\u7C7B\u9519\u8BEF\u9C81\u68D2\u6027\u6392\u884C\u699C'), Object.keys(objClass).map(function (item, index) {
        var data = objClass[item];if (index > 1 && !off1) {
          return null;
        }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'item', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, data[0].attributes), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, data.map(function (item2, index2) {
          var score = _this3.setValFn(item2.score);var firstVal = score[0];var lastVal = score[score.length - 1];var w = (6 - lastVal) * 0.81 + 0.81 * firstVal / 10;var n = w / 4.86 * 100;var c = '';switch (true) {case n >= 80:
              c = 'c1';break;case n >= 60 && n < 80:
              c = 'c2';break;case n >= 40 && n < 60:
              c = 'c3';break;case n >= 20 && n < 40:
              c = 'c4';break;case n >= 0 && n < 20:
              c = 'c5';break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list', key: index2 }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-title' }, item2.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-num ' + c, style: { width: w + 'rem' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-val' }, score));
        })));
      }), Object.keys(objClass).length > 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'linkText', onClick: function onClick() {
          _this3.setState({ off1: !off1 });
        } }, off1 ? '收起' : '加载更多') : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'lb-mod4 mt40' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u76EE\u6807\u8BC6\u522B\u9519\u8BEF\u9C81\u68D2\u6027\u6392\u884C\u699C'), Object.keys(objTarget).map(function (item, index) {
        var data = objTarget[item];if (index > 1 && !off2) {
          return null;
        }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'item', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, data[0].attributes), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, data.map(function (item2, index2) {
          var score = _this3.setValFn(item2.score);var firstVal = score[0];var lastVal = score[score.length - 1];var w = (6 - lastVal) * 0.81 + 0.81 * firstVal / 10;var n = w / 4.86 * 100;var c = '';switch (true) {case n >= 80:
              c = 'c1';break;case n >= 60 && n < 80:
              c = 'c2';break;case n >= 40 && n < 60:
              c = 'c3';break;case n >= 20 && n < 40:
              c = 'c4';break;case n >= 0 && n < 20:
              c = 'c5';break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list', key: index2 }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-title' }, item2.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-num ' + c, style: { width: w + 'rem' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list-val' }, score));
        })));
      }), Object.keys(objTarget).length > 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'linkText', onClick: function onClick() {
          _this3.setState({ off2: !off2 });
        } }, off2 ? '收起' : '加载更多') : null)));
    } }]);return PageLuBang;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, fetchLeaderBoard: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func }, _temp);function mapStateToProps() {
  return {};
}function mapDispatchToProps(dispatch) {
  return { fetchLeaderBoard: function fetchLeaderBoard(obj, type) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__actions_luBangAction__["a" /* fetchLeaderBoard */])(dispatch, obj);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(PageLuBang));

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchLeaderBoard;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file 申请试用页面
 * @author wangzhuang
 */function fetchLeaderBoard(dispatch, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/robustness/getLeaderBoard', {}, obj, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["y" /* GET_LEADER_BOARD */], data: data.data });
  });
}

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lbcj1.cc680671.png";

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lbcj2.dfb70bf6.png";

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lbcj3.5673253b.png";

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_productAction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_buyAction__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pageUrlSec_less__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pageUrlSec_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pageUrlSec_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(5);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: WangZhuang@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2023-06-09 16:02:35
  * @FilePath: /m-anquan-baidu-com/src/containers/product/pageUrlSec.js
  * @Description: 网址安全检测
  */var PageUrlSec = (_temp = _class = function (_PureComponent) {
  _inherits(PageUrlSec, _PureComponent);function PageUrlSec(props, context) {
    var _this2 = this;_classCallCheck(this, PageUrlSec);var _this = _possibleConstructorReturn(this, (PageUrlSec.__proto__ || Object.getPrototypeOf(PageUrlSec)).call(this, props, context));_this.checkFn = function () {
      var inputVal = _this.state.inputVal;var newVal = '';if (!inputVal) {
        _this.setState({ error: '请输入要查询的网址' });return false;
      }if (!/^https?:/.test(inputVal)) {
        newVal = 'http://' + inputVal;_this.setState({ inputVal: newVal });
      } else {
        newVal = inputVal;
      }if (!/https?:\/\/[A-Za-z0-9_-]+\.[A-Za-z0-9]+/.test(newVal)) {
        _this.setState({ error: '输入的域名不符合规范，请确认输入域名的准确性' });return;
      }_this.setState({ error: false });Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* bAntiBotSend */])();if (window['__abbaidu_2024_cb']) {
        window['__abbaidu_2024_cb'] = function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(responseData) {
            var companyJson, localData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {case 0:
                    companyJson = { url: newVal };localData = JSON.parse(responseData);if (localData && localData.data) {
                      companyJson.data = localData.data;
                    }if (localData && localData.key_id) {
                      companyJson['key_id'] = localData['key_id'];
                    }if (localData && localData.sign) {
                      companyJson.sign = localData.sign;
                    }_this.props.fetchBsbCheck(companyJson).then(function (data) {
                      if (data.status === 0) {
                        _this.setState({ resObj: data.data, resRrl: newVal });
                      } else if (data.status === 401) {
                        window.location.href = _this.loginUrl();
                      } else {
                        _this.setState({ error: data.description });
                      }
                    });case 6:case 'end':
                    return _context.stop();}
              }
            }, _callee, _this2);
          }));return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      } else {
        setTimeout(function () {
          _this.checkFn();
        }, 300);
      }
    };_this.handleTime = function (item) {
      var buyType = _this.state.buyType;var val = item < 31536000 ? parseInt(item / 2592000, 10) : parseInt(item / 31536000, 10);var unit = item < 31536000 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u6708'), buyType === 'ent' && item >= 31536000 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', null, '(3\u6298)') : null) : '年';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, val, unit);
    };_this.denderRes = function () {
      var _this$state = _this.state,
          resObj = _this$state.resObj,
          resRrl = _this$state.resRrl;var imgUrl = '';var imgName = '';switch (resObj.score) {case '白':case '灰':
          imgName = '安全';imgUrl = 'anquan';break;case '未知':
          imgName = '未知';imgUrl = 'weizhi';break;default:
          imgName = '危险';imgUrl = 'weixian';break;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'res' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'title' }, '\u7F51\u5740\u68C0\u6D4B\u7ED3\u679C'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'img' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(571)("./icon_" + imgUrl + '.svg'), alt: '' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: imgUrl }, imgName)), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'text' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, '\u68C0\u6D4B\u5730\u5740'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, resRrl)));
    };_this.state = { serverData: [], resObj: {}, error: false, resRrl: '', inputVal: '' };return _this;
  }_createClass(PageUrlSec, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this3 = this;this.props.fetchInstanceGetInstance().then(function (data) {
        var json = {};if (data.data.status === 0) {
          json['instance_id'] = Object.keys(data.data.data)[0];
        }_this3.props.fetchGetServices(json).then(function (data) {
          if (data.status === 0) {
            _this3.setState({ serverData: data.data });
          }
        });
      });
    } }, { key: 'render', value: function render() {
      var bannerInfo = this.props.bannerInfo || {}; // let {serverData, inputVal, resObj, error} = this.state;
      /* bca-disable */return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product pageUrlSec' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-des' }, bannerInfo.bannerNote), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod mt100' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ProductTitle__["a" /* default */], { title: '产品优势' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(575), width: '100%' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u7CFB\u7EDF\u68C0\u6D4B\u80FD\u529B\u5F3A'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u57FA\u4E8E\u767E\u5EA6\u5927\u6570\u636E\u548C\u4EBA\u5DE5\u667A\u80FD\u6280\u672F\uFF0C\u65E5\u5747\u68C0\u6D4BURL\u8D85\u8FC73\u4EBF\u6761'))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(576), width: '100%' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u68C0\u51FA\u80FD\u529B\u5F3A'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u65E5\u5747\u68C0\u51FA\u5A01\u80C1URL\u8D85\u8FC7600\u4E07\uFF0C\u68C0\u6D4B\u51C6\u786E\u7387\u9AD899%+\u3001\u68C0\u51FA\u738795%+'))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(577), width: '100%' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u5BF9\u5916\u670D\u52A1\u80FD\u529B\u5F3A'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u65E5\u5747\u5B89\u5168\u67E5\u8BE2\u8D85\u8FC730\u4EBF\uFF0C\u5E73\u5747\u54CD\u5E94\u65F6\u95F4\u4E3A30\u6BEB\u79D2\uFF0C\u7CFB\u7EDF\u670D\u52A1\u7A33\u5B9A99.99%'))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(578), width: '100%' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u652F\u6301\u591A\u79CD\u68C0\u6D4B\u6A21\u578B'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u652F\u6301DNN\u7B49\u591A\u79CD\u68C0\u6D4B\u6A21\u578B\u7B97\u6CD5\uFF0C\u7ED3\u5408\u4EA7\u54C1\u9700\u6C42\u7075\u6D3B\u5B9A\u5236\u9632\u62A4\u80FD\u529B')))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ProductTitle__["a" /* default */], { title: '适用场景' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-applicable', style: { backgroundImage: 'url(' + __webpack_require__(579) + ')' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u6B3A\u8BC8\u573A\u666F'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-content' }, '\u865A\u5047\u4E2D\u5956\u3001\u865A\u5047\u767B\u5F55\u3001\u865A\u5047\u8D2D\u7269\u3001\u865A\u5047\u62DB\u8058\u3001\u865A\u5047\u5BA2\u670D')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-applicable', style: { backgroundImage: 'url(' + __webpack_require__(580) + ')' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u9690\u79C1\u4FDD\u62A4\u573A\u666F'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-content' }, '\u4E2A\u4EBA\u9690\u79C1\u4FE1\u606F\u5982\u8EAB\u4EFD\u8BC1\u3001\u94F6\u884C\u5361\u7B49\u8BC1\u4EF6\u4FE1\u606F\uFF0C\u57FA\u672C\u8D44\u6599\u53CA\u624B\u673A\u53F7\uFF0C\u7F51\u8D2D\u5386\u53F2\u6570\u636E\u3001\u9152\u65C5\u4FE1\u606F\u3001\u5065\u5EB7\u60C5\u51B5\u7B49')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-applicable', style: { backgroundImage: 'url(' + __webpack_require__(581) + ')' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u98CE\u9669\u573A\u666F'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-content' }, '\u9493\u9C7C\u7F51\u7AD9\u3001\u6076\u610F\u8DF3\u8F6C\u3001\u7F51\u9875\u6302\u7801\u3001\u7F51\u7AD9\u88AB\u9ED1')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-applicable', style: { backgroundImage: 'url(' + __webpack_require__(582) + ')' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u8FDD\u6CD5\u573A\u666F'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-content' }, '\u5229\u7528\u7F51\u7AD9\u5185\u5BB9\u5BA1\u6838\u6F0F\u6D1E\u53D1\u5E03\u535A\u5F69\u3001\u8272\u60C5\u3001\u975E\u6CD5\u8A00\u8BBA\u7B49\u8FDD\u6CD5\u4FE1\u606F\uFF0C\u6EE5\u7528\u7F51\u7EDC\u57FA\u7840\u8BBE\u65BD\uFF0C\u7BE1\u6539\u9AD8\u6743\u91CD\u7F51\u7AD9\u9875\u9762'))));
    } }]);return PageUrlSec;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]), _class.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, fetchBsbCheck: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, fetchInstanceGetInstance: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, fetchGetServices: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func }, _temp);function mapStateToProps() {
  return {};
}function mapDispatchToProps(dispatch) {
  return { fetchBsbCheck: function fetchBsbCheck(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__actions_productAction__["b" /* fetchBsbCheck */])(obj);
    }, fetchGetServices: function fetchGetServices(json) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__actions_productAction__["e" /* fetchGetServices */])(json);
    }, fetchInstanceGetInstance: function fetchInstanceGetInstance() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__actions_buyAction__["d" /* fetchInstanceGetInstance */])(dispatch);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(PageUrlSec));

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_search.9feda082.svg";

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_clear.a80509d1.svg";

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon_anquan.svg": 572,
	"./icon_clear.svg": 570,
	"./icon_search.svg": 569,
	"./icon_weixian.svg": 573,
	"./icon_weizhi.svg": 574
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 571;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_anquan.be19773e.svg";

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_weixian.b99623a5.svg";

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_weizhi.9e531862.svg";

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jiance.1c5318e4.svg";

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jianchu.3715a2b2.svg";

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/duiwai.a54bb5bd.svg";

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zhichi.50bc02a3.svg";

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1-wap.7941b4c8.png";

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2-wap.f32c6615.png";

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3-wap.c79012ae.png";

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4-wap.1ef6e2f9.png";

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_productAction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_buyAction__ = __webpack_require__(30);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: WangZhuang@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2023-06-09 16:05:44
  * @FilePath: /m-anquan-baidu-com/src/containers/product/pageTic.js
  * @Description: 昊天镜杀毒引擎
  */var PageTic = (_temp = _class = function (_PureComponent) {
  _inherits(PageTic, _PureComponent);function PageTic(props, context) {
    _classCallCheck(this, PageTic);var _this = _possibleConstructorReturn(this, (PageTic.__proto__ || Object.getPrototypeOf(PageTic)).call(this, props, context));_this.state = { serverData: [], resObj: {}, error: false, resRrl: '', inputVal: '' };return _this;
  }_createClass(PageTic, [{ key: 'componentDidMount', value: function componentDidMount() {} }, { key: 'render', value: function render() {
      var bannerInfo = this.props.bannerInfo || {};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, bannerInfo.bannerNote), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod mt100' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '产品特色' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(584), width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u8D85\u5F3A\u67E5\u6740\u80FD\u529B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u6740\u6BD2\u80FD\u529B\u5728\u56FD\u9645\u56FD\u5185\u591A\u9879\u6743\u5A01\u8BC4\u6D4B\u4E2D\u5747\u53D6\u5F97\u8FC7\u591A\u6B21\u4F18\u5F02\u6210\u7EE9\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(585), width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u9AD8\u6027\u80FD\u4F4E\u5360\u7528'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u626B\u63CF\u65F6\u8D44\u6E90\u5360\u7528\u4F18\u4E8E\u884C\u4E1A\u8868\u73B0\uFF0C\u4E0D\u4F1A\u4E3A\u5BA2\u6237\u7AEF\u6216\u670D\u52A1\u5668\u5E26\u6765\u989D\u5916\u8D1F\u8377\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(586), width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u591A\u5F62\u6001\u670D\u52A1\u65B9\u6848'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u5305\u542B\u5BA2\u6237\u7AEF\u53CA\u670D\u52A1\u7AEF\u89E3\u51B3\u65B9\u6848\uFF0C\u652F\u6301\u8054\u7F51\u4E0E\u65AD\u7F51\u73AF\u5883\u4E0B\u67E5\u6740\uFF0C\u4E5F\u53EF\u4E0A\u4F20\u6837\u672C\u6216MD5\u81F3\u4E91\u7AEF\u8FDB\u884C\u4E91\u67E5\u3002')))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '适用场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable', style: { backgroundImage: 'url(' + __webpack_require__(587) + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u5BA2\u6237\u7AEFSDK'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, '本地扫：支持在断网环境下对终端设备的文件进行查杀。云扫+本地扫：支持通过连接到云端进行病毒查杀，' + '提供更加实时强大的病毒查杀能力。')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable', style: { backgroundImage: 'url(' + __webpack_require__(588) + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u670D\u52A1\u7AEF\u626B\u63CF\u5F15\u64CE'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, '通过一键部署安装包一键部署到后台,实现本地扫+云扫的反病毒检测能力。满足企业云盘等多' + '场景安全需求，提供全方位数据保护。')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable', style: { backgroundImage: 'url(' + __webpack_require__(589) + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u5168\u5E73\u53F0\u89E3\u51B3\u65B9\u6848'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, '服务端通过一键部署安装包一键部署到后台,客户端通过合入SDK实现全平台的反病毒检测能力。' + '查杀快，检出率高，资源占用低。'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProductTitle__["a" /* default */], { title: '部署方式' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u672C\u5730\u67E5\u6740\u80FD\u529B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '支持在断网情况下对设备上的本地文件进行病毒查杀，可进行全盘扫描或根据指定文件路径输出扫描结果，' + '扫描结果包含病毒类型及描述等详细信息。终端查杀能力适合高数据保密性业务场景或终端无法连接到网络的' + '业务场景。'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u516C\u6709\u4E91\u90E8\u7F72\u67E5\u6740'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '支持通过互联网连接到云端进行病毒云扫查杀。云查提供了更加实时强大的病毒查杀能力。' + '该能力适用于对安全实时性要求较高、终端可以直接连接到互联网的应用场景。'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u79C1\u6709\u5316\u90E8\u7F72'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '支持在局域网环境下的查杀。可以在提供实时病毒查杀能力的同时，降低私有数据泄漏的风险。' + '适合高数据敏感性的客户选择使用。')))));
    } }]);return PageTic;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, fetchBsbCheck: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, fetchInstanceGetInstance: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, fetchGetServices: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func }, _temp);function mapStateToProps() {
  return {};
}function mapDispatchToProps(dispatch) {
  return { fetchBsbCheck: function fetchBsbCheck(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__actions_productAction__["b" /* fetchBsbCheck */])(obj);
    }, fetchGetServices: function fetchGetServices(json) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__actions_productAction__["e" /* fetchGetServices */])(json);
    }, fetchInstanceGetInstance: function fetchInstanceGetInstance() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__actions_buyAction__["d" /* fetchInstanceGetInstance */])(dispatch);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(PageTic));

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_cq.9ec7237a.svg";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_dx.29eec30a.svg";

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_gx.e8fdebac.svg";

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_kehu.c3af24d2.png";

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_fuwu.9c3dad0b.png";

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_quanping.9b0351d7.png";

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_productAction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pageTextCheck_less__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pageTextCheck_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pageTextCheck_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util__ = __webpack_require__(5);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: WangZhuang@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2023-06-09 16:07:39
  * @FilePath: /m-anquan-baidu-com/src/containers/product/pageTextCheck.js
  * @Description: 文本变体检测
  */var dataCiting = [{ title: '案例一', text: '需要小妹滋源的,去薇博搜用户名→美女店主' }, { title: '案例二', text: '⽹网≤占:ẓẓĝẑẕ1 cοm �͆ � ,, ,,, ,,, 清明时节⾬雨纷纷，路路上⾏行行⼈人欲断魂。借问酒家何处有，牧童遥指杏花村。' }, { title: '案例三', text: '置换3裙 5己4030还58042，tongxie们 来捡漏w' }];var PageTextCheck = (_temp = _class = function (_PureComponent) {
  _inherits(PageTextCheck, _PureComponent);function PageTextCheck(props, context) {
    var _this2 = this;_classCallCheck(this, PageTextCheck);var _this = _possibleConstructorReturn(this, (PageTextCheck.__proto__ || Object.getPrototypeOf(PageTextCheck)).call(this, props, context));_this.checkFn = function () {
      var textVal = _this.state.textVal;if (!textVal) {
        _this.setState({ error: '请输入要检测的内容' });return false;
      }if (textVal.length > 120) {
        _this.setState({ error: '超出字数限制' });return;
      }_this.setState({ error: false }); /* eslint-disable */Object(__WEBPACK_IMPORTED_MODULE_8__util__["a" /* bAntiBotSend */])();if (window['__abbaidu_2024_cb']) {
        window['__abbaidu_2024_cb'] = function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(responseData) {
            var companyJson, localData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {case 0:
                    companyJson = new FormData();companyJson.append('text', textVal);localData = JSON.parse(responseData);if (localData && localData.data) {
                      companyJson.data = localData.data;companyJson.append('data', localData.data);
                    }if (localData && localData.key_id) {
                      companyJson.append('key_id', localData['key_id']);
                    }if (localData && localData.sign) {
                      companyJson.append('sign', localData['sign']);
                    }_this.props.fetchVariantCheck(companyJson).then(function (data) {
                      if (data.status === 0) {
                        _this.setState({ pageObj: data.data[0], error: '' });
                      } else {
                        _this.setState({ pageObj: null, error: data.description });
                      }
                    });case 7:case 'end':
                    return _context.stop();}
              }
            }, _callee, _this2);
          }));return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      } /* eslint-enable */
    };_this.state = { pageObj: null, error: '', textVal: '' };return _this;
  }_createClass(PageTextCheck, [{ key: 'componentDidMount', value: function componentDidMount() {} }, { key: 'render', value: function render() {
      var _this3 = this;var bannerInfo = this.props.bannerInfo || {};var _state = this.state,
          textVal = _state.textVal,
          error = _state.error,
          pageObj = _state.pageObj;var adScore = 0;var urlScore = 0;var contactScore = 0;if (pageObj) {
        adScore = (pageObj.adv_ad_score * 100).toFixed(0);urlScore = (pageObj.adv_url_score * 100).toFixed(0);contactScore = (pageObj.adv_contact_score * 100).toFixed(0);
      }var len = 120 - textVal.length;if (len < 0) {
        len = 0;
      }return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product pageTextCheck' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-des' }, bannerInfo.bannerNote), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'tc-bg-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ProductTitle__["a" /* default */], { title: '产品功能' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod tc-mod1' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'title' }, '\u53D8\u4F53\u5E7F\u544A\u68C0\u6D4B'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'text' }, '\u68C0\u6D4B\u5F85\u5BA1\u6838\u6587\u672C\u4E2D\u662F\u5426\u5305\u542B\u53D8\u4F53\u5E7F\u544A')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'title' }, '\u53D8\u4F53\u7F51\u5740\u68C0\u6D4B'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'text' }, '\u68C0\u6D4B\u5F85\u5BA1\u6838\u6587\u672C\u4E2D\u662F\u5426\u5305\u542B\u53D8\u4F53\u2F79\u5740')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'title' }, '\u53D8\u4F53\u8054\u7CFB\u65B9\u5F0F'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'text' }, '\u68C0\u6D4B\u5F85\u5BA1\u6838\u6587\u672C\u4E2D\u662F\u5426\u5305\u542B\u53D8\u4F53\u8054\u7CFB\u2F45\u5F0F'))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ProductTitle__["a" /* default */], { title: '功能演示' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'tc-mod2' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'nav' }, dataCiting.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, className: textVal === item.text ? 'on' : '', onClick: function onClick() {
            _this3.setState({ textVal: item.text, pageObj: null }, function () {
              _this3.checkFn();
            });
          } }, item.title);
      })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pr' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'textarea' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea', { placeholder: '请输入文本或选择案例进行检测', value: textVal, onChange: function onChange(ev) {
          _this3.setState({ textVal: ev.target.value, error: ev.target.value.length > 120 ? '超出字数限制' : '' });
        } })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'count' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, len), textVal.length ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i', { onClick: function onClick() {
          _this3.setState({ textVal: '', pageObj: null });
        } }) : null)), pageObj ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'resMod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u53D8\u4F53\u5E7F\u544A'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: adScore >= 50 ? 'high' : '' }, adScore, '%')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u53D8\u4F53\u7F51\u5740'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: urlScore >= 50 ? 'high' : '' }, urlScore, '%')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u53D8\u4F53\u8054\u7CFB\u65B9\u5F0F'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: contactScore >= 50 ? 'high' : '' }, contactScore, '%'))) : null, error ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'error' }, error) : null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'm-btn', onClick: function onClick() {
          _this3.checkFn();
        } }, '\u68C0\u6D4B')))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ProductTitle__["a" /* default */], { title: '适用场景' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-applicable', style: { backgroundImage: 'url(' + __webpack_require__(592) + ')' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u793E\u533A\u8BBA\u575B'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-content' }, '\u5BF9\u793E\u533A\u8BBA\u575B\u53D1\u5E16\u3001\u56DE\u5E16\u548C\u7AD9\u5185\u4FE1\u7B49\u6587\u5B57\u8FDB\u884C\u68C0\u6D4B\uFF0C\u53D1\u73B0\u5176\u4E2D\u5305\u542B\u7684\u53D8\u4F53\u5E7F\u544A\u3001\u7F51\u5740\u548C\u8054\u7CFB\u65B9\u5F0F\u7B49\u5F02\u5E38\u5185\u5BB9\u3002')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-applicable', style: { backgroundImage: 'url(' + __webpack_require__(593) + ')' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u76F4\u64AD/\u4FE1\u606F\u6D41'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-content' }, '\u5BF9\u76F4\u64AD\u5F39\u5E55\u3001\u79C1\u4FE1\u548C\u4FE1\u606F\u6D41\u8BC4\u8BBA\u7B49\u6587\u5B57\u8FDB\u884C\u68C0\u6D4B\uFF0C\u53D1\u73B0\u5176\u4E2D\u5305\u542B\u7684\u53D8\u4F53\u5E7F\u544A\u3001\u7F51\u5740\u548C\u8054\u7CFB\u65B9\u5F0F\u7B49\u5F02\u5E38\u5185\u5BB9\u3002')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-applicable', style: { backgroundImage: 'url(' + __webpack_require__(594) + ')' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-title' }, '\u5373\u65F6\u901A\u4FE1'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'pro-app-content' }, '\u5BF9\u5373\u65F6\u901A\u4FE1\u5185\u5BB9\u3001\u77ED\u4FE1\u5185\u5BB9\u7B49\u6587\u5B57\u8FDB\u884C\u68C0\u6D4B\uFF0C\u53D1\u73B0\u5176\u4E2D\u5305\u542B\u7684\u53D8\u4F53\u5E7F\u544A\u3001\u7F51\u5740\u548C\u8054\u7CFB\u65B9\u5F0F\u7B49\u5F02\u5E38\u5185\u5BB9\u3002'))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_ProductTitle__["a" /* default */], { title: '产品特色' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(595), width: '100%' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u6301\u7EED\u9886\u5148\u7684\u68C0\u6D4B\u6280\u672F'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u4F9D\u6258\u767E\u5EA6\u4E1A\u754C\u9886\u5148\u7684\u2F08\u5DE5\u667A\u80FD\u6280\u672F\uFF0C\u4E0D\u65AD\u63D0\u5347\u5BF9\u6587\u672C\u53D8\u4F53\u7684\u68C0\u6D4B\u80FD\u529B\uFF0C\u5728\u4FDD\u8BC1\u51C6\u786E\u7387\u7684\u524D\u63D0\u4E0B\uFF0C\u6301\u7EED\u589E\u52A0\u5BF9\u5404\u79CD\u5F62\u5F0F\u53D8\u4F53\u6587\u672C\u7684\u53EC\u56DE\u80FD\u529B'))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(596), width: '100%' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u8BC6\u522B\u51C6\u786E\u7387\u9AD8'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u57FA\u4E8E\u6DF1\u5EA6\u5B66\u4E60\u7684\u667A\u80FD\u68C0\u6D4B\u6280\u672F\u4EE5\u53CA\u957F\u671F\u79EF\u7D2F\u7684\u6D77\u91CF\u53D8\u4F53\u6587\u672C\u6570\u636E\uFF0C\u51C6\u786E\u7387\u9AD8\u8FBE99.5%\u4EE5\u4E0A'))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(597), width: '100%' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u6301\u7EED\u5BF9\u6297'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u5728\u4E0E\u4E00\u7EBF\u9ED1\u7070\u4EA7\u5BF9\u6297\u7684\u8FC7\u7A0B\u4E2D\uFF0C\u6301\u7EED\u2ED3\u63D0\u5347\u6A21\u578B\u5BF9\u5404\u79CD\u65B0\u578B\u53D8\u4F53\u7684\u68C0\u6D4B\u80FD\u529B'))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(598), width: '100%' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-title' }, '\u7075\u6D3B\u7684\u63A5\u2F0A\u65B9\u5F0F'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'proinfo-box-des' }, '\u652F\u6301\u5FEB\u901F\u2F45\u4FBF\u7684WEB API\u6216SDK\u8C03\u7528\uFF0C\u63D0\u4F9B\u6839\u636E\u4E1A\u52A1\u573A\u666F\u548C\u9700\u6C42\u9002\u914D\u7684\u884C\u4E1A\u89E3\u51B3\u65B9\u6848')))));
    } }]);return PageTextCheck;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]), _class.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, fetchVariantCheck: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func }, _temp);function mapStateToProps() {
  return {};
}function mapDispatchToProps() {
  return { fetchVariantCheck: function fetchVariantCheck(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__actions_productAction__["i" /* fetchVariantCheck */])(obj);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(PageTextCheck));

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_01.37a9276f.png";

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_02.da188406.png";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_03.b74542d9.png";

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_1.a54bb5bd.svg";

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_2.3715a2b2.svg";

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_3.36e79bbd.svg";

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_4.3476d409.svg";

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageBrain_less__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageBrain_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pageBrain_less__);
/**
 * @Author: wangzhuang@baidu.com
 * @Date: 2023-01-10 17:48:54
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-06-09 16:24:05
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageBrain.js
 * @Description: 工业大脑
 */var structureData = [{ imgSrc: __webpack_require__(601), title: '企业知识库', text: '汇集行业知识、企业管理规范和经验等，基于知识图谱构建企业知识库，解决数据多源异构造成知识协同困难的问题，有效提升员工获取知识的效率' }, { imgSrc: __webpack_require__(602), imgWidth: '3.14rem', title: '辅助设备检修', text: '在企业知识库中加入设备维修手册、培训文档和使用说明等文档和视频材料，构建设备检修智能问答，帮助维修工程师和用户高效定位问题，获得指导' }, { imgSrc: __webpack_require__(603), title: '故障预测', text: '基于设备运行参数和历史故障数据构建系统运行知识图谱应用， 并对联网设备实施全局监控，实时发现状态异常的节点，通过人工干预降低故障发生的概率' }, { imgSrc: __webpack_require__(604), title: '供应链预测', text: '基于需求、生产、供应和市场数据的提取和深度挖掘，帮企业更好地管理供需关系，提升生产效率，降低运营风险' }];var proinfoData = [{ imgSrc: __webpack_require__(77), title: '强大的技术支撑', text: '基于需求、生产、供应和市场数据的提取和深度挖掘，帮企业更好地管理供需关系，提升生产效率，降低运营风险' }, { imgSrc: __webpack_require__(136), title: '业务专家团队', text: '兼具丰富的的行业知识和产品知识，可协同客户根据实际需求进行业务建模和定制化方案设计' }, { imgSrc: __webpack_require__(137), title: '丰富的系统建设经验', text: '多年的企业级系统建设，在各种业务规模的系统上都有多次成功实践' }, { imgSrc: __webpack_require__(232), title: '专业的交付团队', text: '在海量客服交付案例中提炼出行之有效的标准化的交付流程，并锻炼了一⽀客户导向的专业交付团队' }];var PageBrain = function PageBrain(props) {
  var bannerInfo = props.bannerInfo || {};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product Brain' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, bannerInfo.bannerNote), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '业务结构' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(605), alt: '', width: '100%' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(606), alt: '', width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod mt100' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '业务场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, structureData.map(function (_ref, index) {
    var imgSrc = _ref.imgSrc,
        title = _ref.title,
        text = _ref.text,
        imgWidth = _ref.imgWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: (index + 1) % 2 === 0 ? 'structure hui' : 'structure', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'shadow' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'imgBor', style: { width: imgWidth ? imgWidth : '100%' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imgSrc, alt: title }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, text));
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod mt100' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '方案优势' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod sec-p-box' }, proinfoData.map(function (_ref2, index) {
    var imgSrc = _ref2.imgSrc,
        title = _ref2.title,
        text = _ref2.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imgSrc, width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, text)));
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { background: '#F5F5F5', paddingBottom: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u76F8\u5173\u4EA7\u54C1' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, [{ title: '安全知识图谱', content: '应用知识图谱技术实现知识抽取和业务建模等应用，支持百亿以上的实体和关系管理，基于业' + '务场景对数据进行深度关联分析，可广泛应用于公安侦查、金融风控、营销管理和企业综合应用等场景', url: 'https://anquan.baidu.com/product/skg' }, { title: '图数据库', content: 'HugeGraph是一款易用、高效、通用的图数据库，实现了Apache TinkerPop3' + '框架及兼容Gremlin查询语言。支持百亿以上的顶点(Vertex)和边(Edge)快速导入，' + '并提供毫秒级的关联查询能力，并可与Hadoop、Spark等大数据平台集成以进行离线分析。' + '主要应用场景包括关联分析、欺诈检测和知识图谱等。', url: 'https://anquan.baidu.com/page/27' }, { title: '数据安全与隐私解决方案', content: '依托百度领先的数据安全能力及隐私保护技术，数据安全与隐私解决方案集成数据治理' + '与敏捷大数据分析、AI数据脱敏及联邦计算，覆盖数据资产管理、敏感数据处理及安全合规' + '数据流通三大场景，助力企业实现数据全生命周期的安全治理及防护。', url: 'https://anquan.baidu.com/product/dpsec' }].map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-app-solution-card' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, item.content), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: item.url, target: '_blank', className: 'btn' }, '\u4E86\u89E3\u8BE6\u60C5'));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des', style: { paddingTop: '1.2rem' } }, '\u8054\u7CFB\u6211\u4EEC\u7ACB\u5373\u83B7\u53D6\u514D\u8D39\u6280\u672F\u4E13\u5BB6\u54A8\u8BE2'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.url, className: 'btn', style: { marginTop: '.76rem' } }, '\u7ACB\u5373\u54A8\u8BE2'))));
};PageBrain.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object };/* harmony default export */ __webpack_exports__["a"] = (PageBrain);

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yewu-cj1.5974aa1b.png";

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yewu-cj2.c36c888f.png";

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yewu-cj3.d1751022.png";

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yewu-cj4.9e119d9e.png";

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yewu-jiegou1.43f7c39a.png";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yewu-jiegou2.4eced61e.png";

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageCommercialPassword_less__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageCommercialPassword_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pageCommercialPassword_less__);
/**
 * @Author: v_huangyongxing@baidu.com
 * @Date: 2023-03-20 15:27:02
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-03-20 16:49:20
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageCommercialPassword.js
 * @Description: 商用密码安全合规解决方案
 */var structureData = [{ imgSrc: __webpack_require__(609), title: '金融领域', text: '根据《金融领域国产密码改造评价指标》和《金融领域信息系统国产密码改造基线》相关要求，金融行业的核心系统、柜面系统、ATM系统、' + '智慧柜员机、现金柜员机、智能POS、个人手机银行、企业手机银行、直销银行、移动展业、网上银行、银企直连、中间业务系统等系统的强制按要求进行国密改造。' }, { imgSrc: __webpack_require__(610), title: '电力领域', text: '根据《密码法》、《关键信息基础设施安全保护条例》等法律法规的明确要求，关键信息基础设施的运营者采购涉及商用密码的网络产品和服务，' + '可能影响国家安全的，应当按照《中华人民共和国网络安全法》的规定，通过国家网信部门会同国家密码管理部门等有关部门组织的国家安全审查。电力行业的安全性需求已上升到国家安全层级。' }, { imgSrc: __webpack_require__(611), title: '政务领域', text: '随着《密码法》的颁布实施，各级政务信息系统是商用密码应用安全评估的最重要领域。政务信息系统作为民生数据信息的重点承载和应用系统，合规性是重中之重，其安全性已经上升到关乎国计民生的重要程度。' }];var proinfoData = [{ imgSrc: __webpack_require__(77), title: '合规性', text: '使用的密码算法、密码协议、密钥管理符合国家法律法规和标准规定，密码产品或服务经过国家密码管理局核准和认证机构认证合格。' }, { imgSrc: __webpack_require__(136), title: '正确性', text: '密码算法、密码协议、密钥管理、密码产品或服务使用正确。即按密码相关的国家和行业标准进行正确设计和实现。' }, { imgSrc: __webpack_require__(137), title: '有效性', text: '密码保障系统在系统运行过程中能够发挥实际效用，保障信息系统的安全需求，解决信息系统面临的安全问题。' }];var PageCommercialPassword = function PageCommercialPassword(props) {
  var bannerInfo = props.bannerInfo || {};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product Brain' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, bannerInfo.bannerNote), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod mt100' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '三大基本要求' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod sec-p-box' }, proinfoData.map(function (_ref, index) {
    var imgSrc = _ref.imgSrc,
        title = _ref.title,
        text = _ref.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imgSrc, width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, text)));
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '一站式综合服务体系' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(612), alt: '', width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { background: '#F5F5F5', paddingBottom: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u65B9\u6848\u4F18\u52BF' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, [{ title: '专业性', content: '加解密技术是信息安全的基石，基于密码学领域的技术积累与实践，为客户提供专业服务。' }, { title: '完整性', content: '提供从咨询服务到密评服务的完整服务体系，为客户提务完善的turn-key服务。' }, { title: '多样性', content: '基于百度智能云完整的生态服务能力，打通产业上下游生态，提供全国性的服务能力。' }].map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-app-solution-card' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, item.content));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod mt100' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '应用场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, structureData.map(function (_ref2, index) {
    var imgSrc = _ref2.imgSrc,
        title = _ref2.title,
        text = _ref2.text,
        imgWidth = _ref2.imgWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: (index + 1) % 2 === 0 ? 'structure hui' : 'structure', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'shadow' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'imgBor', style: { width: imgWidth ? imgWidth : '100%' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imgSrc, alt: title }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, text));
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des', style: { paddingTop: '1.2rem' } }, '\u8054\u7CFB\u6211\u4EEC\u7ACB\u5373\u83B7\u53D6\u514D\u8D39\u6280\u672F\u4E13\u5BB6\u54A8\u8BE2'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.url, className: 'btn', style: { marginTop: '.76rem' } }, '\u7ACB\u5373\u54A8\u8BE2'))));
};PageCommercialPassword.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object };/* harmony default export */ __webpack_exports__["a"] = (PageCommercialPassword);

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jinrong.cd4667d0.png";

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dianli.ccfc4e45.png";

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zhengwu.fe63456b.png";

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arc.ba45beff.png";

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageSecureSmartLock_less__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageSecureSmartLock_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pageSecureSmartLock_less__);
/**
 * @Author: v_huangyongxing@baidu.com
 * @Date: 2023-03-20 17:35:26
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2023-06-09 16:27:12
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageSecureSmartLock.js
 * @Description: 物联网安全智能锁解决方案
 */var structureData = [{ imgSrc: __webpack_require__(615), title: '酒店/公寓/民宿', text1: '-人证合一安全入住，入住记录实时上传，远程授权方便快捷。', text2: '-智能无源电子锁、智能指纹密码钥匙、智能读卡器、手机App与智能锁具管理平台互联。' }, { imgSrc: __webpack_require__(616), title: '社区/园区/校园', text1: '-数据云端一体化，实时上传记录，可远程快捷授权，并进行数据跟踪和分析，提供预警信息，帮助客户完成巡检、权限等管理操作。', text2: '-包含无源锁管理平台和手机App，基于SaaS架构提供锁具管理、安装空间管理、巡检任务设置、权限管理、部门管理、开锁记录查看等功能。' }, { imgSrc: __webpack_require__(617), title: '银行/商业综合体', text1: '-百度数字证书PKI CA人证系统，符合国密算法。', text2: '-连同可独立部署的物联网安全套件，保障智能锁安全。' }];var proinfoData = [{ imgSrc: __webpack_require__(77), title: '智能锁安全受到重视', text: '国家越来越重视智能锁信息安全，包括锁体安全、信息传输安全、通讯安全、平台安全等，对于平台、智能锁、App的信息安全将建立新的标准。' }, { imgSrc: __webpack_require__(136), title: '与平台连接成基础', text: '场景应用与智能锁的深度融合成为智能锁销售的关键，与平台连接成为基础。' }, { imgSrc: __webpack_require__(137), title: 'B端市场规模增长', text: '智能锁市场需求增长加快，更多场景通过应用智能锁解决场景的管理和安全问题。' }, { imgSrc: __webpack_require__(232), title: '技术革新体验至上', text: 'NB-IoT因其低功耗、免布线、通讯安全等特点，越来越受市场青睐，二维码、人脸识别、蓝牙、智能手环等新型开锁方式开始被广泛应用。' }];var PageCommercialPassword = function PageCommercialPassword(props) {
  var bannerInfo = props.bannerInfo || {};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product Brain' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, bannerInfo.bannerNote), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod mt100' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '行业趋势' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod sec-p-box' }, proinfoData.map(function (_ref, index) {
    var imgSrc = _ref.imgSrc,
        title = _ref.title,
        text = _ref.text;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box mui-flex', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imgSrc, width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-title' }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proinfo-box-des' }, text)));
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '业务挑战' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, [{ title: '存在潜在风险隐患', content: '存在钥匙丢失、钥匙被复制等风险，且钥匙丢失或损坏后更换锁具成本较大。在一些规模较大的机构内，网店主管需要' + '保管不同设备的大量锁具和钥匙，存在普遍的管理不规范、随意开锁的现象。' }, { title: '管理成本较大', content: '由于管理人员变动，必须按相应规章制度的管理要求交接；由于备用钥匙集中管理，工作人员频繁流动导致备用钥匙保管员' + '随时要变更保管记录，工作压力较大，备用钥匙管理使用混乱。' }, { title: '交接及保管存在混岗风险', content: '由于部分双人分管的钥匙不能兼管，存在一定的混岗现象，也会带来不必要的风险。管理密码和钥匙的岗位人员不能混岗，' + '必须平行交接，然而在实际工作中，无法实现平行交接且不方便。' }, { title: '密码管理漏洞多', content: '目前银行加配钞的工作人员普遍年龄偏大，为方便起见，负责管理记录密码的人员不会经常修改初始密码，在输入密码期间' + '也无法做到安全遮挡，存在密码盗用的风险；另外密码转盘属电子产品，灵敏度极高，不方便操作。' }].map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, item.content)));
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '方案架构' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(618), alt: '', width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { background: '#F5F5F5', paddingBottom: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u65B9\u6848\u4ECB\u7ECD' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, [{ title: '终端安全', content: '内置安全芯片；锁体可信启动；数据安全存储；升级可信校验；固件加固防逆' }, { title: '平台安全', content: '安全实施监控；合规等保三级；国密密钥体系；多重安全防护；端云闭环安全' }, { title: '身份安全', content: '端云身份认证；端端离线认证；权限分级管理；入住人证比对；数据授权管理' }, { title: '云端安全', content: '杜绝重放攻击；交互基于标识；防护篡改伪造；数据密态交互；轻量适配窄带' }].map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-app-solution-card' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, item.content));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod mt100' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '应用场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, structureData.map(function (_ref2, index) {
    var imgSrc = _ref2.imgSrc,
        title = _ref2.title,
        text1 = _ref2.text1,
        text2 = _ref2.text2,
        imgWidth = _ref2.imgWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: (index + 1) % 2 === 0 ? 'structure hui' : 'structure', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'shadow' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'imgBor', style: { width: imgWidth ? imgWidth : '100%' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imgSrc, alt: title }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, text1), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, text2));
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des', style: { paddingTop: '1.2rem' } }, '\u8054\u7CFB\u6211\u4EEC\u7ACB\u5373\u83B7\u53D6\u514D\u8D39\u6280\u672F\u4E13\u5BB6\u54A8\u8BE2'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.url, className: 'btn', style: { marginTop: '.76rem' } }, '\u7ACB\u5373\u54A8\u8BE2'))));
};PageCommercialPassword.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object };/* harmony default export */ __webpack_exports__["a"] = (PageCommercialPassword);

/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/minsu.57fe0119.png";

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/xiaoyuan.5059550d.png";

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shangye.57cca905.png";

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fanganjiagou.74c46fa8.png";

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageLargeModelSecurity_less__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageLargeModelSecurity_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pageLargeModelSecurity_less__);
/**
 * @Author: v_huangyongxing@baidu.com
 * @Date: 2023-08-21 15:05:16
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2024-04-26 15:00:04
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageLargeModelSecurity.js
 * @Description: 大模型安全风控解决方案
 */var PageCommercialPassword = function PageCommercialPassword(props) {
  var bannerInfo = props.bannerInfo || {};var learnMoreItem = bannerInfo.learnMore.length === 1 ? bannerInfo.learnMore[0] || {} : {};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product Brain' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: '下载白皮书', bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null, bannerInfo.learnMore.length ? bannerInfo.learnMore.length === 1 ? bannerInfo.nextIndex === '0' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: learnMoreItem.content, target: '_blank', className: 'compliance-btn compliance-btn-border' }, learnMoreItem.title) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: learnMoreItem.content, target: '_blank', className: 'compliance-btn compliance-btn-border' }, learnMoreItem.title) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-tab' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-slide' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, learnMore.map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: item.content, target: '_blank' }, item.title));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tab-shadow' })) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, '\u767E\u5EA6\u4E8C\u5341\u4F59\u5E74\u5B89\u5168\u5BF9\u6297\u7684\u603B\u7ED3\u4E0E\u63D0\u70BC\uFF0C\u56F4\u7ED5\u767E\u5EA6\u3010\u6587\u5FC3\u5927\u6A21\u578B\u3011\u5B89\u5168\u5B9E\u8DF5\u7ECF\u9A8C\uFF0C\u63A8\u51FA\u4EE5AI\u5B89\u5168\u4E3A\u6838\u5FC3\u7684\u5927\u6A21\u578B\u5B89\u5168\u89E3\u51B3\u65B9\u6848\uFF0C\u4ECE\u5927\u6A21\u578B\u5168\u751F\u547D\u5468\u671F\u89C6\u89D2\u51FA\u53D1\uFF0C \u65B9\u6848\u6DB5\u76D6\u5927\u6A21\u578B\u8BAD\u7EC3/\u7CBE\u8C03/\u63A8\u7406\u3001\u5927\u6A21\u578B\u90E8\u7F72\u3001\u5927\u6A21\u578B\u4E1A\u52A1\u8FD0\u8425\u7B49\u5173\u952E\u9636\u6BB5\u6240\u9762\u4E34\u7684\u5B89\u5168\u98CE\u9669\u4E0E\u4E1A\u52A1\u6311\u6218\uFF0C\u63D0\u4F9B\u5168\u5957\u5B89\u5168\u4EA7\u54C1\u4E0E\u670D\u52A1\uFF0C\u52A9\u529B\u4F01\u4E1A\u6784\u5EFA\u5E73\u7A33\u5065\u5EB7\u3001\u53EF\u4FE1\u53EF\u9760\u7684\u5927\u6A21\u578B\u670D\u52A1\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u4E1A\u52A1\u6311\u6218' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-advantage' }, [{ title: '数据安全与隐私保护', des: '大模型在训练、精调、推理以及一些行业共建的过程中，如何解决敏感数据的传输、使用以及共享时的数据安全与隐私保护的问题', url: __webpack_require__(620) }, { title: '模型保护', des: '大模型在传输、部署、存储、以及访问过程中，如应对模型窃取、模型篡改、对抗样本攻击等威胁，如何建立安全有效的访问控制机制。', url: __webpack_require__(621) }, { title: 'AIGC内容合规', des: '针对用户输入内容以及大模型生成内容，如何解决违法违规、偏见歧视、违反社会价值观、侵犯隐私、恐怖/极端主义等安全合规问题。', url: __webpack_require__(622) }, { title: '大模型业务运营', des: '在大模型运营阶段如何解决账号安全、AIGC盗爬、垃圾提问、投毒反馈、频率突破、接口攻击等问题。', url: __webpack_require__(623) }].map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-p-advantage-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon', style: { backgroundImage: 'url(' + item.url + ')' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des' }, item.des)));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '方案介绍' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-des', style: { color: '#999' } }, '\u4ECE\u5927\u6A21\u578B\u5168\u751F\u547D\u5468\u671F\u89C6\u89D2\u51FA\u53D1\uFF0C\u65B9\u6848\u6DB5\u76D6\u5927\u6A21\u578B\u8BAD\u7EC3/\u7CBE\u8C03/\u63A8\u7406\u3001\u5927\u6A21\u578B\u90E8\u7F72\u3001\u5927\u6A21\u578B\u4E1A\u52A1\u8FD0\u8425\u7B49\u5173\u952E\u9636\u6BB5\u6240\u9762\u4E34\u7684\u5B89\u5168\u98CE\u9669\u4E0E\u4E1A\u52A1\u6311\u6218\uFF0C \u63D0\u4F9B\u5168\u5957\u5B89\u5168\u4EA7\u54C1\u4E0E\u670D\u52A1\uFF0C\u52A9\u529B\u4F01\u4E1A\u6784\u5EFA\u5E73\u7A33\u5065\u5EB7\u3001\u53EF\u4FE1\u53EF\u9760\u7684\u5927\u6A21\u578B\u670D\u52A1'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(624), alt: '', width: '95%', height: '175px', style: { margin: '0 auto' } }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u65B9\u6848\u4F18\u52BF' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'programme-box' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-img img1', style: { backgroundImage: 'url(require(../../asset/image/pageLargeModelSecurity/icon_shujuanquan.svg))' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-title' }, '\u6570\u636E\u5B89\u5168\u4E0E\u9690\u79C1\u4FDD\u62A4'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u6570\u636E\u5B89\u5168\u98CE\u9669'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u4F20\u8F93\u622A\u83B7\u98CE\u9669\uFF1A\u5728\u4F7F\u7528\u975E\u79C1\u6709\u5316\u7684\u9884\u8BAD\u7EC3\u3001\u7CBE\u8C03\u3001\u63A8\u7406\u670D\u52A1\u65F6\u9700\u8981\u5927\u91CF\u8DE8\u4E3B\u4F53/\u90E8\u95E8\u6570\u636E\uFF0C \u5728\u4F20\u8F93\u8FC7\u7A0B\u4F1A\u4EA7\u751F\u6570\u636E\u88AB\u622A\u83B7\u7684\u98CE\u9669\uFF1B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u8FD0\u8425\u65B9\u7AA5\u63A2\u98CE\u9669\uFF1A\u7CBE\u8C03\u4E0E\u63A8\u7406\u9636\u6BB5\u6240\u7528\u654F\u611F\u6570\u636E\uFF0C\u5B58\u5728\u88AB\u5927\u6A21\u578B\u8FD0\u8425\u673A\u6784\u7AA5\u89C6\u548C\u6536\u96C6\u7684\u98CE\u9669\uFF1B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u6A21\u578B\u8BB0\u5FC6\u98CE\u9669\uFF1A\u88AB\u7CBE\u8C03\u8FC7\u6216\u652F\u6301\u5B9E\u65F6\u66F4\u65B0\u7684\u6A21\u578B\uFF0C\u82E5\u88AB\u6CC4\u9732\u6216\u5171\u4EAB\u4F7F\u7528\uFF0C\u5B58\u5728\u6A21\u578B\u8BB0\u5FC6\u548C\u8BB0\u5FC6\u5185\u5BB9\u6CC4\u5BC6\u98CE\u9669\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u6570\u636E\u5B89\u5168\u65B9\u6848'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u6A2A\u5411\u8054\u90A6\u5927\u6A21\u578B\u89E3\u51B3\u65B9\u6848\uFF1A\u767E\u5EA6\u5B89\u5168\u53EF\u540C\u65F6\u652F\u6301\u516C\u6709\u4E91\u3001\u79C1\u6709\u5316\u4E24\u79CD\u573A\u666F\u4E0B\u7684\u6A2A\u5411\u8054\u90A6\u8F6F\u4EF6 \u65B9\u6848\uFF0C\u4F7F\u5F97\u6570\u636E\u4E0D\u51FA\u57DF\u7684\u60C5\u51B5\u4E0B\uFF0C\u5B8C\u6210\u5927\u6A21\u578B\u7684\u9884\u8BAD\u7EC3\u3001\u7CBE\u8C03\uFF0C\u89E3\u51B3\u6570\u636E\u4F20\u8F93\u8FC7\u7A0B\u4E2D\u88AB\u622A\u83B7\u7684\u98CE\u9669\uFF1B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u53EF\u4FE1\u6267\u884C\u73AF\u5883\u8F6F\u786C\u4E00\u4F53\u673A\u89E3\u51B3\u65B9\u6848\uFF1A\u767E\u5EA6\u5B89\u5168\u901A\u8FC7\u5B8C\u5168\u786C\u4EF6\u5316\u7684CPU+GPU\u4FDD\u62A4\u65B9\u6848\u4FDD\u969C\u6A21\u578B \u548C\u6570\u636E\u5B89\u5168\u7684\u65B9\u5F0F\uFF0C\u89E3\u51B3\u5927\u6A21\u578B\u5728\u90E8\u7F72\u9636\u6BB5\u9762\u4E34\u7684\u6A21\u578B\u8BB0\u5FC6\u6CC4\u9732\u4EE5\u53CA\u516C\u6709\u4E91\u573A\u666F\u4E0B\u6570\u636E\u9690\u79C1\u4FDD\u62A4\u95EE\u9898\uFF1B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u540C\u6001\u5BC6\u7801\u5B66\u8F6F\u4EF6\u89E3\u51B3\u65B9\u6848\uFF1A\u9488\u5BF9\u5927\u6A21\u578B\u5728\u516C\u6709\u4E91\u63A8\u7406\u9636\u6BB5\u6570\u636E\u9690\u79C1\u4FDD\u62A4\u95EE\u9898\uFF0C\u767E\u5EA6\u70B9\u77F3\u9690\u79C1\u8BA1\u7B97 \u56E2\u961F\u63D0\u4F9B\u540C\u6001\u5BC6\u7801\u5B66\u8F6F\u4EF6\u89E3\u51B3\u65B9\u6848\uFF0C\u4EC5\u9700\u8981\u5728\u5BA2\u6237\u7AEF\u5B89\u88C5\u4E00\u4E2A\u63D2\u4EF6\uFF0C\u5229\u7528\u540C\u6001\u5BC6\u7801\u5B66\u6280\u672F\u8FDB\u884C\u5BC6\u6001\u6570\u636E\u8BA1\u7B97\u3002'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'programme-box' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-img img2' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-title' }, '\u6A21\u578B\u4FDD\u62A4'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u4E1A\u52A1\u75DB\u70B9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u8BED\u6599\u6570\u636E\u7BA1\u7406\uFF1A\u9762\u5BF9\u591A\u6E20\u9053\u6536\u96C6\u73CD\u8D35\u8BED\u6599\u6570\u636E\uFF0C\u5982\u4F55\u5B9E\u73B0\u9AD8\u6548\u7684\u6570\u636E\u7BA1\u7406\uFF0C\u9632\u8303\u6A21\u578B\u539F\u59CB \u8BED\u6599\u6570\u636E\u6CC4\u6F0F\uFF0C\u63D0\u9AD8\u8BED\u6599\u6570\u636E\u52A0\u5DE5\u6548\u7387\uFF1B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u6A21\u578B\u8D44\u4EA7\u4FDD\u62A4\uFF1A\u5927\u6A21\u578B\u6587\u4EF6\u662F\u4F01\u4E1A\u6838\u5FC3\u6570\u5B57\u8D44\u4EA7\uFF0C\u5982\u4F55\u9632\u8303\u5927\u6A21\u578B\u6587\u4EF6\u5728\u8BAD\u7EC3\u3001\u63A8\u7406\u3001 \u5FAE\u8C03\u7B49\u73AF\u8282\u7684\u6A21\u578B\u6587\u4EF6\u6CC4\u6F0F\u98CE\u9669\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u89E3\u51B3\u65B9\u6848'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u5927\u6A21\u578B\u8BED\u6599\u6570\u636E\u5B89\u5168\u7BA1\u7406\uFF1A\u63D0\u4F9B\u6574\u5957\u8BED\u6599\u6570\u636E\u5B89\u5168\u7BA1\u7406\u65B9\u6848\uFF0C\u5305\u62EC\u5143\u6570\u636E\u7BA1\u7406\u3001\u5206\u7C7B\u5206\u7EA7\u3001 \u6D41\u8F6C\u5BA1\u6279\u3001\u6570\u636E\u9274\u6743\u3001\u884C\u4E3A\u5BA1\u8BA1\u7B49\u591A\u9879\u80FD\u529B\uFF1B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u5927\u6A21\u578B\u8D44\u4EA7\u5168\u6D41\u7A0B\u4FDD\u62A4\uFF1A\u91C7\u7528\u9886\u5148\u7684Baidu Ai Realm\u6280\u672F\uFF0C\u4E3A\u5927\u6A21\u578B\u5168\u751F\u547D\u5468\u671F\u63D0\u4F9B \u591A\u65B9\u4F4D\u5B89\u5168\u9632\u62A4\u63AA\u65BD\uFF0C\u8986\u76D6\u6A21\u578B\u8BAD\u7EC3\u3001\u6A21\u578B\u6D41\u8F6C\u3001\u6A21\u578B\u63A8\u7406\u3001\u6A21\u578B\u5FAE\u8C03\u4EE5\u53CA\u79C1\u6709\u5316\u90E8\u7F72\u7B49\u5404\u73AF\u8282\u3002'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'programme-box' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-img img3' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-title' }, 'AIGC\u5185\u5BB9\u5408\u89C4'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u5185\u5BB9\u5408\u89C4\u95EE\u9898'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u7528\u6237prompt\u5185\u5BB9\uFF1A\u7528\u6237\u8F93\u5165prompt\u5185\u5BB9\u660E\u663E\u5B58\u5728\u5982\u8272\u60C5\u3001\u6D89\u653F\u3001\u6D89\u6050\u3001\u6D89\u7206\u7B49 \u8FDD\u6CD5\u8FDD\u89C4\u7684\u5F15\u5BFC\u8BCD\u53CA\u56FE\u50CF\uFF1B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u56F4\u7ED5\u5927\u6A21\u578B\u751F\u6210\u5185\u5BB9\uFF0C\u5177\u6709\u4E00\u5B9A\u7684\u968F\u673A\u3001\u4E0D\u53EF\u63A7\u7684\u60C5\u51B5\uFF0C\u5BB9\u6613\u51FA\u73B0\u8FDD\u6CD5\u8FDD\u89C4\u5185\u5BB9\u3001 \u8FDD\u53CD\u793E\u4F1A\u4EF7\u503C\u89C2\u3001\u6B67\u89C6\u504F\u89C1\u3001\u9690\u79C1\u6CC4\u6F0F\u3001\u5185\u5BB9\u4FB5\u6743\u7B49\u8BF8\u591A\u98CE\u9669\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u5185\u5BB9\u5408\u89C4\u5B89\u5168\u65B9\u6848'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, 'Prompt\u5BA1\u6838\u4E0E\u6539\u5199\uFF1A\u5BF9\u4E8E\u7528\u6237\u8F93\u5165\u5185\u5BB9\u63D0\u4F9B\u591A\u7EF4\u5EA6\u5185\u5BB9\u5BA1\u6838\u80FD\u529B\u3001\u5E76\u9488\u5BF9\u6076\u610F\u8BF1\u5BFC \u5927\u6A21\u578B\u751F\u6210\u8FDD\u89C4\u5185\u5BB9\u7684Prompt\u8FDB\u884C\u6539\u5199\u5E76\u505A\u6BD2\u6027\u63D0\u793A\uFF1B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, 'AIGC\u591A\u6A21\u6001\u5185\u5BB9\u5BA1\u6838\uFF1A\u4E3A\u5927\u6A21\u578B\u751F\u6210\u5185\u5BB9\u63D0\u4F9B\u5305\u542B\u8FDD\u6CD5\u8FDD\u89C4\u5185\u5BB9\u5BA1\u6838\u3001\u8FDD\u53CD\u4EF7\u503C\u89C2\u3001 \u5B58\u5728\u504F\u89C1\u6B67\u89C6\u3001\u5185\u5BB9\u4FB5\u6743\u7B49\u98CE\u9669\u5185\u5BB9\u8FC7\u6EE4\u670D\u52A1\uFF1B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u5927\u6A21\u578B\u5185\u5BB9\u5408\u89C4\u8BC4\u6D4B\uFF1A\u4F9D\u636E\u4E03\u90E8\u59D4\u8054\u5408\u53D1\u5E03\u7684\u300A\u751F\u6210\u5F0F\u4EBA\u5DE5\u667A\u80FD\u670D\u52A1\u7BA1\u7406\u6682\u884C\u529E\u6CD5\u300B\uFF0C \u63D0\u4F9B\u5185\u5BB9\u5B89\u5168\u8BC4\u6D4B\u548C\u653B\u51FB\u6307\u4EE4\u8BC4\u6D4B\uFF0C\u5BF9\u5927\u6A21\u578B\u505A\u5B9A\u671F\u8BC4\u4F30\u3002'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'programme-box' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-img img4' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-title' }, '\u5927\u6A21\u578B\u4E1A\u52A1\u8FD0\u8425\u5B89\u5168\u98CE\u63A7'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u4E1A\u52A1\u8FD0\u8425\u98CE\u9669'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u5927\u6A21\u578B\u524D\u7F6E\u4E1A\u52A1\u73AF\u8282\uFF1A\u5927\u6A21\u578B\u4E1A\u52A1\u8FD0\u8425\u8FC7\u7A0B\u4E2D\u51FA\u73B0\u7684\u8D26\u53F7\u5B89\u5168\u95EE\u9898\u3001\u6743\u76CA\u4FB5\u5360\u7B49\u4E1A\u52A1\u5B89\u5168\u95EE\u9898\uFF1B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u7528\u6237\u63D0\u95EE\u884C\u4E3A\u8FC7\u7A0B\u4E2D\u4E5F\u5BB9\u6613\u51FA\u73B0AIGC\u76D7\u722C\u3001\u5783\u573E\u63D0\u95EE\u3001\u6295\u6BD2\u53CD\u9988\u3001\u9891\u7387\u7A81\u7834\u3001\u63A5\u53E3\u653B\u51FB\u7B49\u95EE\u9898\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u4E1A\u52A1\u98CE\u63A7\u65B9\u6848'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u4E1A\u52A1\u5B89\u5168\u9632\u62A4\u4F53\u7CFB\uFF1A\u4F9D\u6258\u767E\u5EA6\u5B89\u5168\u667A\u80FD\u98CE\u63A7\u89E3\u51B3\u65B9\u6848\uFF0C\u53EF\u4EE5\u5728\u5927\u6A21\u578B\u524D\u7F6E\u8FD0\u8425\u9636\u6BB5\uFF08\u5982\uFF1A \u7528\u6237\u6CE8\u518C\u3001\u767B\u5F55\u3001\u6743\u76CA\u7533\u8BF7\u7B49\u73AF\u8282\uFF09\u3001\u4EE5\u53CA\u5927\u6A21\u578B\u4EA4\u4E92\u73AF\u8282\uFF08\u5982\uFF1A\u7528\u6237\u63D0\u95EE\u73AF\u8282\u3001\u56DE\u7B54\u5185\u5BB9\u53CD\u9988\u7B49\u73AF\u8282\uFF09\uFF0C\u7ED3\u5408\u7528\u6237\u884C\u4E3A\u3001\u7EC8\u7AEF \u73AF\u5883\u3001\u7F51\u7EDC\u7279\u5F81\u7B49\u4FE1\u606F\u5EFA\u7ACB\u6709\u6548\u7684\u5B89\u5168\u9632\u62A4\u4F53\u7CFB\uFF0C\u9488\u5BF9\u5F02\u5E38\u8BF7\u6C42\u505A\u5B9E\u65F6\u98CE\u9669\u68C0\u6D4B\uFF0C\u4FDD\u969C\u5927\u6A21\u578B\u5904\u4E8E\u4E00\u4E2A\u5B89\u5168\u3001\u53EF\u9760\u7684\u8FD0\u8425\u72B6\u6001\u3002'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'programme-box' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-img img5' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-title' }, '\u5927\u6A21\u578B\u5185\u5BB9\u5B89\u5168\u8BC4\u6D4B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u4E1A\u52A1\u75DB\u70B9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u9488\u5BF9\u5927\u6A21\u578B\u751F\u6210\u5185\u5BB9\u5177\u6709\u4E00\u5B9A\u7684\u968F\u673A\u6027\uFF0C\u5BB9\u6613\u51FA\u73B0\u8FDD\u6CD5\u8FDD\u89C4\u3001\u6B67\u89C6\u3001\u5546\u4E1A\u4FB5\u6743\u7B49\u98CE\u9669\u7684\u95EE \u9898\uFF0C\u5F88\u591A\u6D4B\u8BD5\u56E2\u961F\u4E3B\u8981\u4F9D\u8D56\u4EBA\u5DE5\u7F16\u5199\u6D4B\u8BD5\u9898\u548C\u6807\u6CE8\u98CE\u9669\u56DE\u590D\u7684\u65B9\u5F0F\u8FDB\u884C\u8BC4\u6D4B\uFF0C\u8FD9\u79CD\u65B9\u5F0F\u9650\u5236\u4E86\u53D1\u73B0\u5A01\u80C1\u7684\u6570\u91CF\u548C\u591A\u6837\u6027\uFF0C\u4F46\u82E5\u6269\u5927 \u89C4\u6A21\u53C8\u4F1A\u8017\u8D39\u5927\u91CF\u7684\u4EBA\u529B\u548C\u65F6\u95F4\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u89E3\u51B3\u65B9\u6848'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u672C\u65B9\u6848\u662F\u4E00\u79CD\u4E3B\u52A8\u7684\u5B89\u5168\u6D4B\u8BD5\u65B9\u6CD5\uFF0C\u65E8\u5728\u6A21\u62DF\u653B\u51FB\u8005\u7684\u884C\u4E3A\uFF0C\u8BC4\u4F30\u5927\u6A21\u578B\u5728\u771F\u5B9E\u5A01\u80C1\u9762\u524D \u7684\u5B89\u5168\u6027\u80FD\u4E0E\u5185\u5BB9\u5408\u89C4\u95EE\u9898\u3002\u65B9\u6848\u4F18\u52BF\u5982\u4E0B\uFF1A'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u2022 \u72EC\u6709\u7684\u5185\u5BB9\u5B89\u5168\u8BC4\u6D4B\u6570\u636E\u96C6\uFF1A\u4F9D\u636E\u4E03\u90E8\u59D4\u8054\u5408\u53D1\u5E03\u7684\u300A\u751F\u6210\u5F0F\u4EBA\u5DE5\u667A\u80FD\u670D\u52A1\u7BA1\u7406\u6682\u884C\u529E \u6CD5\u300B\uFF0C\u7ED3\u5408\u81EA\u8EAB\u5341\u4F59\u5E74\u7684\u5185\u5BB9\u98CE\u63A7\u7ECF\u9A8C\u6C89\u6DC0\uFF0C\u5EFA\u7ACB\u4E86\u8986\u76D6100+\u79CD\u98CE\u9669\u5206\u7C7B\u3001\u6DB5\u76D620+\u79CD\u9AD8\u7EA7\u653B\u51FB\u7684\u81EA\u52A8\u5316\u6570\u636E\u96C6\u751F\u6210\u80FD\u529B\uFF0C\u53EF\u4EE5\u6EE1 \u8DB3\u4E0D\u540C\u5BA2\u6237\u573A\u666F\u7684\u8BC4\u6D4B\u9700\u6C42\uFF1B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u2022 \u53EF\u5FEB\u901F\u90E8\u7F72\u7684\u5927\u6A21\u578B\u5185\u5BB9\u5B89\u5168\u8BC4\u6D4B\u6846\u67B6\uFF1A\u8BC4\u6D4B\u6846\u67B6\u5177\u6709\u5F00\u7BB1\u5373\u7528\u7684\u7279\u70B9\uFF0C\u53EF\u4EE5\u7075\u6D3B\u9002\u914D \u5404\u79CD\u5927\u6A21\u578B\uFF0C\u652F\u6301\u914D\u7F6E\u8BC4\u6D4B\u6570\u636E\u96C6\u7C7B\u578B\u4E0E\u6570\u91CF\uFF0C\u81EA\u52A8\u5316\u5B8C\u6210\u63D0\u95EE\u4E0E\u7B54\u6848\u56DE\u6536\uFF0C\u901A\u8FC7\u88C1\u5224\u5927\u6A21\u578B\u5148\u5206\u7C7B\u518D\u8F85\u4EE5\u4EBA\u5DE5\u590D\u6838\u5B8C\u6210\u6807\u6CE8\uFF1B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u2022 \u517C\u5177\u98CE\u9669\u4E0E\u6539\u8FDB\u5EFA\u8BAE\u7684\u8BE6\u5B9E\u8BC4\u6D4B\u62A5\u544A\uFF1A\u8BC4\u6D4B\u62A5\u544A\u5185\u5BB9\u5305\u62EC\u8BC4\u6D4B\u65B9\u6CD5\u3001\u8BC4\u6D4B\u6570\u636E\u96C6\u3001\u8BC4\u6D4B \u6307\u6807\u7B49\u6570\u636E;\u8FD8\u4F1A\u6839\u636E\u53D1\u73B0\u7684\u98CE\u9669\u7ED9\u51FA\u8BE6\u7EC6\u7684\u95EE\u9898\u6E05\u5355\u548C\u6539\u8FDB\u5EFA\u8BAE\uFF0C\u4EE5\u8FBE\u5230\u5E2E\u52A9\u5927\u6A21\u578B\u5185\u5BB9\u98CE\u63A7\u7CFB\u7EDF\u5347\u7EA7\u7684\u76EE\u7684\u3002')))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '适用场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingBottom: 0 } }, [{ 'mobile_pic': __webpack_require__(138), title: 'NLP大模型', content: '面向语言理解、语言生成等NLP场景，具备超强语言理解能力以及对话生成、文学创作、逻辑推理等能力的大模型服务。' }, { 'mobile_pic': __webpack_require__(139), title: 'CV大模型', content: '基于领先的视觉技术和海量的数据，构建能够自主学习图像中的特征和模式，实现图像分类/检测/生成等复杂视觉任务的大模型服务。' }, { 'mobile_pic': __webpack_require__(140), title: '跨模态大模型', content: '基于知识增强的跨模态语义理解关键技术，实现跨模态检索、图文生成、图片文档的信息抽取等应用的大模型服务。' }, { 'mobile_pic': __webpack_require__(625), title: '行业大模型', content: '与各行业企业联手，在通用大模型的基础上学习行业特色数据与知识，建设行业AI基础设施，多方共建的行业大模型服务。' }].map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable', key: index, style: { backgroundImage: 'url(' + item.mobile_pic + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, item.content));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '方案优势' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u4E13\u4E1A\u6027'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u4F9D\u6258\u767E\u5EA6\u5B89\u5168\u5728\u6570\u636E\u5B89\u5168\u53CA\u9690\u79C1\u4FDD\u62A4\u65B9\u5411\u9886\u5148\u7684\u5B89\u5168\u6280\u672F(MPC\u3001TEE\u3001DP)\u3001 AI\u6280\u672F(\u56FE\u50CF\u8BC6\u522B\u3001\u81EA\u7136\u8BED\u8A00\u5904\u7406)\u957F\u671F\u79EF\u7D2F\u3001\u4EE5\u53CA\u6A21\u578B\u4FDD\u62A4\u548C\u4E1A\u52A1\u5B89\u5168\u6301\u7EED\u5BF9\u6297\uFF0C\u53EF\u6709\u63D0\u4F9B\u4E13\u4E1A\u7684\u5927\u6A21\u578B\u5B89\u5168\u65B9\u6848\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u5B8C\u6574\u6027'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u4F9D\u6258\u767E\u5EA6\u5B89\u5168\u5927\u6A21\u578B\u5B89\u5168\u4FDD\u969C\u5B9E\u8DF5\u5DE5\u4F5C\u603B\u7ED3\uFF0C\u4ECE\u5927\u6A21\u578B\u5168\u751F\u547D\u5468\u671F\u89C6\u89D2\u51FA\u53D1\uFF0C\u65B9\u6848\u6DB5\u76D6 \u5927\u6A21\u578B\u8BAD\u7EC3/\u7CBE\u8C03/\u63A8\u7406\u3001\u5927\u6A21\u578B\u90E8\u7F72\u3001\u5927\u6A21\u578B\u4E1A\u52A1\u8FD0\u8425\u5728\u5185\u5168\u90E8\u5173\u952E\u9636\u6BB5\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u591A\u6837\u6027'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u65B9\u6848\u53EF\u4EE5\u63D0\u4F9B\u5305\u542BNLP\u81EA\u7136\u8BED\u8A00\u5927\u6A21\u578B\u3001CV\u5927\u6A21\u578B\u3001\u8DE8\u6A21\u6001\u5927\u6A21\u578B\u3001\u884C\u4E1A\u5927\u6A21\u578B\u5728\u5185\u591A\u79CD \u6A21\u578B\u5E94\u7528\u573A\u666F\u7684\u5B89\u5168\u9632\u62A4\uFF0C\u6DB5\u76D6\u4E91\u4E0A\u7CBE\u8C03\u3001\u79C1\u6709\u5316\u5171\u5EFA\u3001\u4EE5\u53CA\u5B89\u5168\u54A8\u8BE2\u7B49\u591A\u6837\u7684\u5B89\u5168\u670D\u52A1\u3002'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des', style: { paddingTop: '1.2rem' } }, '\u8054\u7CFB\u6211\u4EEC\u7ACB\u5373\u83B7\u53D6\u514D\u8D39\u6280\u672F\u4E13\u5BB6\u54A8\u8BE2'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.url, className: 'btn', style: { marginTop: '.76rem' } }, '\u7ACB\u5373\u54A8\u8BE2'))));
};PageCommercialPassword.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object };/* harmony default export */ __webpack_exports__["a"] = (PageCommercialPassword);

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_shujuanquan.dce00734.svg";

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_moxingbaohu.4c5752be.svg";

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_neironghegui.b66a346b.svg";

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_yewuyunying.31e45a4a.svg";

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fangan.9c789cbb.png";

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg_card_4_wap.25fda518.png";

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageLargeModelSecurity_less__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageLargeModelSecurity_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pageLargeModelSecurity_less__);
/**
 * @Author: v_huangyongxing@baidu.com
 * @Date: 2023-08-21 15:05:16
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2024-04-26 15:00:04
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageLargeModelSecurity.js
 * @Description: 大模型安全风控解决方案
 */var PageCommercialPassword = function PageCommercialPassword(props) {
  var bannerInfo = props.bannerInfo || {};var learnMoreItem = bannerInfo.learnMore.length === 1 ? bannerInfo.learnMore[0] || {} : {};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product Brain' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: '商务咨询', bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null, bannerInfo.learnMore.length ? bannerInfo.learnMore.length === 1 ? bannerInfo.nextIndex === '0' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: learnMoreItem.content, target: '_blank', className: 'compliance-btn compliance-btn-border' }, learnMoreItem.title) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: learnMoreItem.content, target: '_blank', className: 'compliance-btn compliance-btn-border' }, learnMoreItem.title) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-tab' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-slide' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, learnMore.map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: item.content, target: '_blank' }, item.title));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tab-shadow' })) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, '\u5168\u81EA\u52A8\u6A21\u62DF\u771F\u5B9E\u7F51\u7EDC\u9493\u9C7C\u573A\u666F\u5F00\u5C55\u653B\u9632\u6F14\u7EC3\uFF0C\u52A9\u529B\u4F01\u4E1A\u68C0\u9A8C\u4EBA\u5458\u5B89\u5168\u9632\u8303\u80FD\u529B\uFF0C\u642D\u914D\u591A\u6837\u5316\u5B89\u5168\u5BA3\u4F20\u4E0E\u6D3B\u52A8\uFF0C\u5168\u9762\u4E14\u6DF1\u5165\u5730\u63D0\u5347\u4F01\u4E1A\u4EBA\u5458\u5B89\u5168\u8BA4\u77E5\uFF0C\u4E3A\u4F01\u4E1A\u7B51\u7262\u4EBA\u5458\u5B89\u5168\u9632\u7EBF\u63D0\u4F9B\u6709\u529B\u652F\u6491\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '业务挑战' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u7F51\u7EDC\u5B89\u5168\u5A01\u80C1\u4E0D\u65AD'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u5168\u7403\u7F51\u7EDC\u653B\u51FB\u4E8B\u4EF6\u6570\u91CF\u9010\u5E74\u6500\u5347\uFF0C\u52D2\u7D22\u8F6F\u4EF6\u3001\u9493\u9C7C\u653B\u51FB\u3001\u6570\u636E\u6CC4\u9732\u7B49\u5A01\u80C1\u624B\u6BB5\u5C42\u51FA\u4E0D\u7A77\u3002\u653B\u51FB\u624B\u6BB5\u8FED\u4EE3\u5FEB\uFF0C\u7CBE\u51C6\u7784\u51C6\u4EBA\u5458\u6F0F\u6D1E\u3002\u4F20\u7EDF\u6280\u672F\u9632\u62A4\u96BE\u5168\u9762\u62E6\u622A\uFF0C\u6613\u5F15\u53D1\u6570\u636E\u6CC4\u9732\u3001\u7CFB\u7EDF\u762B\u75EA\u7B49\u98CE\u9669\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u7F51\u5B89\u7ACB\u6CD5\u9010\u6B65\u5B8C\u5584'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u300A\u6570\u636E\u5B89\u5168\u6CD5\u300B\u300A\u4E2A\u4FDD\u6CD5\u300B\u7B49\u6CD5\u89C4\u660E\u786E\u4F01\u4E1A\u8D23\u4EFB\uFF0C\u76D1\u7BA1\u68C0\u67E5\u9891\u6B21\u589E\u52A0\u3002\u82E5\u4EBA\u5458\u64CD\u4F5C\u4E0D\u5408\u89C4\uFF0C\u4F01\u4E1A\u6613\u9762\u4E34\u9AD8\u989D\u7F5A\u6B3E\u3001\u4E1A\u52A1\u6682\u505C\u7B49\u4E25\u91CD\u540E\u679C\uFF0C\u5408\u89C4\u538B\u529B\u5267\u589E\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u4EBA\u5458\u5B89\u5168\u610F\u8BC6\u8584\u5F31'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u5458\u5DE5\u666E\u904D\u5B58\u5728\u5F31\u5BC6\u7801\u3001\u8FDD\u89C4\u4F20\u6570\u636E\u7B49\u884C\u4E3A\uFF0C\u5B89\u5168\u57F9\u8BAD\u591A\u6D41\u4E8E\u5F62\u5F0F\uFF0C\u96BE\u4EE5\u8F6C\u5316\u4E3A\u5B9E\u9645\u9632\u62A4\u80FD\u529B\uFF0C\u4EBA\u5458\u77ED\u677F\u6210\u4F01\u4E1A\u5B89\u5168\u9632\u7EBF\u7684\u4E3B\u8981\u7A81\u7834\u53E3\u3002'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '方案介绍' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(627), alt: '', width: '95%', height: '175px', style: { margin: '0 auto' } }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u6838\u5FC3\u670D\u52A1' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'programme-box' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-title' }, '\u9493\u9C7C\u6F14\u7EC3\u5E73\u53F0'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { width: '100%', className: 'programme-box-img', src: __webpack_require__(628), alt: '\u9493\u9C7C\u6F14\u7EC3\u5E73\u53F0' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'programme-box' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-case-title' }, '\u4EBA\u5458\u5B89\u5168\u57F9\u8BAD'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { width: '100%', className: 'programme-box-img', src: __webpack_require__(629), alt: '\u4EBA\u5458\u5B89\u5168\u57F9\u8BAD' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '适用场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingBottom: 0 } }, [{ 'mobile_pic': __webpack_require__(138), title: '安全培训', // eslint-disable-next-line max-len
    content: '适用于新员工入职、全体员工及年度安全能力提升，通过线上课程 + 线下专家课，覆盖各类安全风险、钓鱼攻击识别等知识，帮员工快速建立安全认知，适配企业全员覆盖需求。' }, { 'mobile_pic': __webpack_require__(139), title: '安全演练', content: '常态化演练适配日常风险防控，如每月钓鱼测试；专项演练应对特殊场景，如数据泄露应急。通过模拟实战，提升员工风险处置能力，降低真实事故损失。' }, { 'mobile_pic': __webpack_require__(140), title: '安全活动', content: '适合企业安全宣传周、季度宣贯等节点，线上设知识挑战赛，线下落地互动展，以趣味形式强化安全记忆，营造全员参与的安全文化氛围，补足传统培训趣味性短板。' }].map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable', key: index, style: { backgroundImage: 'url(' + item.mobile_pic + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content' }, item.content));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u6838\u5FC3\u4F18\u52BF' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-advantage' }, [{ title: '专业性', des: '立足甲方防护思维，凭借多年攻防经验，融入大模型 AI 技术，精准洞察人员安全风险，提升方案针对性与防护有效性。', url: __webpack_require__(234) }, { title: '完整性', des: '依托百度安全大模型实践总结，从员工全生命周期出发，覆盖钓鱼演练、安全培训、意识考核、AI 钓鱼等关键阶段，形成闭环保障。', url: __webpack_require__(235) }, { title: '多样性', des: '提供方案、内容输出、活动落地等多类培训场景，涵盖云上精调、私有化共建、安全咨询等服务，适配企业不同需求。', url: __webpack_require__(236) }, { title: '创新性', // eslint-disable-next-line max-len
    des: '打破传统培训枯燥感，设线上挑战赛、模拟黑客捕鱼达人、CTF 挑战赛、逻辑推理游戏，线下开展钓鱼互动、迷宫探险、黑客追击者等，让员工在趣味互动中掌握安全知识，实现寓教于乐。', url: __webpack_require__(237) }].map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-p-advantage-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon', style: { backgroundImage: 'url(' + item.url + ')' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des' }, item.des)));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des', style: { paddingTop: '1.2rem' } }, '\u8054\u7CFB\u6211\u4EEC\u7ACB\u5373\u83B7\u53D6\u514D\u8D39\u6280\u672F\u4E13\u5BB6\u54A8\u8BE2'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.url, className: 'btn', style: { marginTop: '.76rem' } }, '\u7ACB\u5373\u54A8\u8BE2'))));
};PageCommercialPassword.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object };/* harmony default export */ __webpack_exports__["a"] = (PageCommercialPassword);

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/plan.ebda091f.png";

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fish.7521e712.png";

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/train.bec4e6d0.png";

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageAiSoc_less__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageAiSoc_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pageAiSoc_less__);
/**
 * @Author: v_huangyongxing@baidu.com
 * @Date: 2023-08-21 15:05:16
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2024-04-26 15:00:04
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageLargeModelSecurity.js
 * @Description: 大模型安全风控解决方案
 */var structureData = [{ imgSrc: __webpack_require__(238), title: '客户挑战：', text1: '在常态化安全运营与重点活动保障场景中，客户面临以下核心痛点：', text2: ['告警过载：安全告警数量庞大，关键威胁难以快速识别', '研判困难：安全告警线索繁多，难以关联，研判难度大，效率受限', '响应迟缓：威胁响应依赖人工，流程长、速度慢，错过黄金时间', '经验难以服用：专业安全人员不足，专家经验未能体系化沉淀与复用'] }, { imgSrc: __webpack_require__(239), title: '解决方案：', text1: '部署AISOC智能安全运营中心，构建覆盖全网安全告警的统一智能运营体系，实现以下关键成效：', text2: ['告警智能降噪：实现告警智能降噪，过滤无效告警超过90%', '告警智能研判：构建“Al预判+人工复核”模式，显著提升研判效率', '智能化处置：建立自动化安全智能体工作流，缩短响应时间', '构建行业标准：沉淀自动化处置模板，助力行业智能安全标准化'] }];var PageCommercialPassword = function PageCommercialPassword(props) {
  var bannerInfo = props.bannerInfo || {};var learnMoreItem = bannerInfo.learnMore.length === 1 ? bannerInfo.learnMore[0] || {} : {};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product Brain' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: '商务咨询', bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null, bannerInfo.learnMore.length ? bannerInfo.learnMore.length === 1 ? bannerInfo.nextIndex === '0' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: learnMoreItem.content, target: '_blank', className: 'compliance-btn compliance-btn-border' }, learnMoreItem.title) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: learnMoreItem.content, target: '_blank', className: 'compliance-btn compliance-btn-border' }, learnMoreItem.title) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-tab' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-slide' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, learnMore.map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: item.content, target: '_blank' }, item.title));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tab-shadow' })) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, '\u4EE5\u4EBA\u5DE5\u667A\u80FD\u4E3A\u6838\u5FC3\u7684\u65B0\u4E00\u4EE3\u667A\u80FD\u5B89\u5168\u8FD0\u8425\u5E73\u53F0\uFF0C \u4EE5\u5B89\u5168\u6A21\u578B\u4E3A\u57FA\u77F3\uFF0C\u4EE5\u6D77\u91CF\u5B89\u5168\u544A\u8B66\u4E3A\u6570\u636E\u57FA\u7840\uFF0C \u7ED3\u5408\u591A\u7C7B\u578B\u5B89\u5168\u667A\u80FD\u4F53\u534F\u540C\uFF0C\u6253\u9020\u81EA\u52A8\u5316\u201C\u7814\u5224-\u5206\u6790-\u5904\u7F6E\u201D\u7684\u5B89\u5168\u667A\u80FD\u4F53\u5DE5\u4F5C\u6D41\uFF0C \u5E76\u6DF1\u5EA6\u878D\u5408\u4E13\u5BB6\u7ECF\u9A8C\u4E0E\u4EBA\u673A\u534F\u540C\u673A\u5236\uFF0C\u6210\u4E3A\u5B89\u5168\u5DE5\u7A0B\u5E08\u7684\u4E13\u5BB6\u52A9\u624B\uFF0C \u52A9\u529B\u5176\u4ECE\u7E41\u91CD\u544A\u8B66\u4E2D\u91CA\u653E\u7CBE\u529B\uFF0C\u91CD\u5851\u5B89\u5168\u8FD0\u8425\u751F\u4EA7\u529B\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '行业痛点' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u544A\u8B66\u8FC7\u8F7D\uFF0C\u771F\u5B9E\u5A01\u80C1\u88AB\u6DF9\u6CA1'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u5927\u91CF\u65E0\u6548\u544A\u8B66\u6DF9\u6CA1\u6838\u5FC3\u5A01\u80C1\uFF0C\u4F20\u7EDF\u4EBA\u5DE5\u7814\u5224\u6A21\u5F0F\u6548\u7387\u4F4E\u4E0B\uFF0C\u5BFC\u81F4\u5B89\u5168\u56E2\u961F\u75B2\u4E8E\u5E94\u5BF9\uFF0C\u5374\u4ECD\u4E0E\u9AD8\u98CE\u9669\u544A\u8B66\u5931\u4E4B\u4EA4\u81C2\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u54CD\u5E94\u6EDE\u540E\uFF0C\u9632\u5FA1\u901F\u5EA6\u8FFD\u4E0D\u4E0A\u653B\u51FB'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u653B\u51FB\u65B9\u5229\u7528\u5927\u6A21\u578B\uFF0C\u4F20\u7EDF\u89C4\u5219\u9632\u5FA1\u96BE\u4EE5\u62DB\u67B6\u3002\u9632\u5FA1\u4F53\u7CFB\u9677\u5165\u201C\u4EBA\u529B\u8FFD\u4E0D\u4E0A\u7B97\u529B\uFF0C\u89C4\u5219\u8DD1\u4E0D\u8D62\u53D8\u5F02\u201D\u7684\u56F0\u5883\uFF0C\u5C61\u5C61\u9519\u5931\u5173\u952E\u54CD\u5E94\u65F6\u673A\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u57FA\u7840\u8BBE\u65BD\u590D\u6742\uFF0C\u5168\u5C40\u9632\u5FA1\u96BE\u5B9E\u73B0'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u4E91\u3001\u5BB9\u5668\u3001\u5FAE\u670D\u52A1\u7B49\u73B0\u4EE3\u57FA\u7840\u8BBE\u65BD\u52A8\u6001\u4E14\u590D\u6742\uFF0C\u653B\u51FB\u9762\u77AC\u606F\u4E07\u53D8\uFF0C\u6570\u636E\u548C\u5B89\u5168\u5DE5\u5177\u5206\u5B64\u5C9B\u6797\u7ACB\uFF0C\u65E0\u6CD5\u6784\u5EFA\u6709\u6548\u7684\u5168\u5C40\u5B89\u5168\u89C6\u91CE\u548C\u7EDF\u4E00\u5B89\u5168\u9632\u5FA1\u3002'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '产品介绍' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, '\u5E73\u53F0\u56F4\u7ED5\u5B89\u5168\u8FD0\u8425\u6838\u5FC3\u573A\u666F\uFF0C\u6253\u9020\u4E86\u544A\u8B66\u964D\u566A\u3001\u7814\u5224\u5206\u6790\u3001\u4E8B\u4EF6\u54CD\u5E94\u3001\u62A5\u544A\u751F\u6210\u3001\u60C5\u62A5\u89E3\u8BFB\u53CA\u6F0F\u6D1E\u5206\u6790\u7B49\u4E00\u7CFB\u5217\u4E13\u4E1A\u667A\u80FD\u4F53\uFF0C \u540C\u65F6\u901A\u8FC7\u667A\u80FD\u4F53\u7684\u81EA\u5B9A\u4E49\u7F16\u6392\u80FD\u529B\uFF0C\u53EF\u81EA\u4E3B\u6784\u5EFA\u8D34\u5408\u9700\u6C42\u7684\u5B89\u5168\u8FD0\u8425\u81EA\u52A8\u5316\u5DE5\u4F5C\u6D41\uFF0C\u63D0\u5347\u5B89\u5168\u8FD0\u8425\u6548\u7387\u4E0E\u81EA\u52A8\u5316\u6C34\u5E73\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(632), alt: '', width: '95%', height: '175px', style: { margin: '0 auto' } }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u6838\u5FC3\u529F\u80FD' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u667A\u80FD\u964D\u566A\u667A\u80FD\u4F53\uFF0C\u4ECE\u4EBA\u5DE5\u7B5B\u9009\u5230AI\u7CBE\u51C6\u6295\u9012'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u57FA\u4E8EAI\u5BF9\u544A\u8B66\u610F\u56FE\u7684\u6DF1\u5EA6\u7406\u89E3\uFF0C\u6709\u6548\u8FC7\u6EE4\u65E0\u6548\u544A\u8B66\u3001\u667A\u80FD\u805A\u5408\u76F8\u4F3C\u544A\u8B66\uFF0C\u7CBE\u51C6\u9501\u5B9A\u5173\u952E\u5A01\u80C1\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u544A\u8B66\u7814\u5224\u53CA\u6258\u7BA1\u667A\u80FD\u4F53\uFF0C\u4ECE\u6D77\u91CF\u7B5B\u9009\u5230\u81EA\u52A8\u6258\u7BA1'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u901A\u8FC7AI\u7814\u5224\u6A21\u578B\u8FDB\u884C\u591A\u7EF4\u5EA6\u5173\u8054\u5206\u6790\uFF0C\u9AD8\u6548\u8F93\u51FA\u7814\u5224\u7ED3\u8BBA\uFF0C\u5E76\u652F\u6301\u81EA\u52A8\u63A5\u7BA1\uFF0C\u5C06\u5355\u6761\u544A\u8B66\u5904\u7406\u65F6\u95F4\u4ECE\u6570\u5C0F\u65F6\u7F29\u77ED\u81F3\u5206\u949F\u7EA7\uFF0C\u7ED3\u5408\u4E13\u5BB6\u7ECF\u9A8C\u5B9E\u73B0\u9AD8\u6548\u7CBE\u51C6\u7684\u5A01\u80C1\u5224\u5B9A\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, 'AI- SOAR\uFF0C\u4ECE\u81EA\u52A8\u5316\u5DE5\u5177\u5230\u667A\u80FD\u5B89\u5168\u5206\u6790\u5E08'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, 'AI\u6DF1\u5EA6\u8D4B\u80FD\u5B89\u5168\u8FD0\u8425\uFF0C\u5B9E\u73B0\u544A\u8B66\u81EA\u52A8\u5206\u6790\u3001\u5904\u7F6E\u5EFA\u8BAE\u751F\u6210\uFF1B\u652F\u6301\u5B89\u5168\u667A\u80FD\u4F53\u81EA\u5B9A\u4E49\u7F16\u6392\uFF0C\u6784\u5EFA\u5177\u5907\u81EA\u4E3B\u51B3\u7B56\u80FD\u529B\u7684\u5B89\u5168\u667A\u80FD\u4F53\u5DE5\u4F5C\u6D41\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u5B89\u5168\u77E5\u8BC6\u56FE\u8C31\uFF0C\u4ECE\u5B64\u7ACB\u6570\u636E\u5230\u5168\u666F\u89C6\u56FE'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u57FA\u4E8E\u81EA\u4E3B\u53EF\u63A7\u56FE\u5B58\u50A8\u548C\u8BA1\u7B97\u5F15\u64CE\uFF0C\u5C06\u544A\u8B66\u3001\u8D44\u4EA7\u3001\u673A\u5668\u3001\u8FDB\u7A0B\u3001\u6587\u4EF6\u3001\u4EBA\u5458\u3001\u573A\u666F\u7B49\u591A\u7EF4\u6570\u636E\u7684\u667A\u80FD\u5173\u8054\uFF0C\u5B9E\u73B0\u653B\u51FB\u94FE\u7684\u5B8C\u6574\u8FD8\u539F\uFF0C \u6784\u5EFA\u5168\u666F\u5F0F\u8D44\u4EA7\u3001\u653B\u51FB\u3001\u544A\u8B66\u56FE\u8C31\uFF0C\u5B9E\u73B0\u8D44\u4EA7\u4E0E\u98CE\u9669\u7684\u5168\u57DF\u53EF\u89C6\u3001\u53EF\u7BA1\u3001\u53EF\u63A7\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, '\u4E8B\u4EF6\u8C03\u67E5\u4E0E\u54CD\u5E94\u667A\u80FD\u4F53\uFF0C\u4ECE\u5C0F\u65F6\u7EA7\u5230\u5206\u949F\u7EA7\u54CD\u5E94'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, '\u667A\u80FD\u751F\u6210\u5B89\u5168\u4E8B\u4EF6\u7684\u6807\u51C6\u5316\u5904\u7F6E\u6D41\u7A0B\u4E0E\u5206\u8BCA\u5EFA\u8BAE\uFF0C\u5C06\u4E13\u5BB6\u7ECF\u9A8C\u6C89\u6DC0\u4E3A\u53EF\u590D\u7528\u7684\u8FD0\u8425\u7B56\u7565\uFF0C\u5B9E\u73B0\u5B89\u5168\u4E8B\u4EF6\u7684\u81EA\u52A8\u5316\u54CD\u5E94\u3002'))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '适用场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingBottom: 0 } }, [{ 'mobile_pic': __webpack_require__(138), title: '常态化安全运营场景', // eslint-disable-next-line max-len
    content: '在日复一日的安全运营中，AISOC可自动处理无效告警，使团队从“告警海洋”中解脱，并实现告警自动闭环处置，将大量重复性、流程化工作交由AI接管，大幅提升日常运营效率。' }, { 'mobile_pic': __webpack_require__(139), title: '实战攻防演练场景', content: '在红蓝对抗的极限压力下，AISOC将成为指挥中心的“最强大脑”，自动关联海量攻击线索，还原攻击链，帮助团队在分秒必争的演练中快速定位攻击意图与范围。' }, { 'mobile_pic': __webpack_require__(140), title: '重大活动保障场景', // eslint-disable-next-line max-len
    content: '在需要万无一失的重大活动保障期间，通过预设的运营策略，实现“无人化”或“少人化”高效值守，打破数据孤岛，为保障指挥部提供全域、可视化的安全态势总览，是确保安全防线稳固、响应及时的定心丸。' }].map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-applicable', key: index, style: { backgroundImage: 'url(' + item.mobile_pic + ')' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-app-content', style: { fontSize: '0.3rem' } }, item.content));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u6838\u5FC3\u4F18\u52BF' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-advantage' }, [{ title: '精准告警研判', des: ['过滤无效告警，聚焦真实威胁', '高效完成告警分析与自动化研判', '提供可解释的告警根因与完整研判依据，决策透明可信'], url: __webpack_require__(234) }, { title: '全天候自动安全值守', des: ['构建人机协同机制，全天候安全值守', '提供全程可追溯的处置记录'], url: __webpack_require__(236) }, { title: '丰富的实战经验', des: ['百度内部AI安全最佳落地实践', '历经丰富真实场景打磨，贴合企业实际安全运营需求'], url: __webpack_require__(237) }, { title: '懂安全的智能体', // eslint-disable-next-line max-len
    des: ['基于海量高质量安全数据训练，具备精准威胁推理能力', '模型内化完备的安全知识体系，具备对威胁的深刻理解', '基于研判结果与专家反馈学习，实现智能体能力不断进化'], url: __webpack_require__(235) }, { title: '灵活可扩展架构', // eslint-disable-next-line max-len
    des: ['广泛的数据兼容性， 兼容主流安全产品与数据源，支持多源异构数据快速接入', '具备灵活的集成能力，支持第三方安全工具、模型快速接入'], url: __webpack_require__(77) }, { title: '全栈技术可控', // eslint-disable-next-line max-len
    des: ['基于文心、deepseek、通义千问通用大模型，构建坚实可靠的大模型基座', '应用百度自研超大规模图数据库HugeGraph，底层技术自主掌控'], url: __webpack_require__(226) }].map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-p-advantage-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon', style: { backgroundImage: 'url(' + item.url + ')' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des', style: { marginLeft: '0.2rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, item.des.map(function (desItem, desIndex) {
      // eslint-disable-next-line max-len
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { key: desIndex, className: 'des-item', style: { listStyleType: 'disc' } }, desItem);
    })))));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { padding: '1rem 0 0', background: '#f5f7f9' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u5BA2\u6237\u6848\u4F8B' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', { style: { textAlign: 'center', padding: '15px 0' } }, '(\u80FD\u6E90\u884C\u4E1A\u6848\u4F8B)')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, structureData.map(function (_ref, index) {
    var imgSrc = _ref.imgSrc,
        title = _ref.title,
        text1 = _ref.text1,
        text2 = _ref.text2,
        imgWidth = _ref.imgWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: (index + 1) % 2 === 0 ? 'structure hui' : 'structure', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'shadow' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'imgBor', style: { width: imgWidth ? imgWidth : '100%' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imgSrc, alt: title }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, text1), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, Array.isArray(text2) ? text2.map(function (item, idx) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: idx, style: { marginBottom: '0.2rem' } }, '\u2022 ', item);
    }) : null));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des', style: { paddingTop: '1.2rem' } }, '\u8054\u7CFB\u6211\u4EEC\u7ACB\u5373\u83B7\u53D6\u514D\u8D39\u6280\u672F\u4E13\u5BB6\u54A8\u8BE2'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.url, className: 'btn', style: { marginTop: '.76rem' } }, '\u7ACB\u5373\u54A8\u8BE2'))));
};PageCommercialPassword.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object };/* harmony default export */ __webpack_exports__["a"] = (PageCommercialPassword);

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/product.b215ec25.png";

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageIntelligentDataSecurityGateway_less__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pageIntelligentDataSecurityGateway_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pageIntelligentDataSecurityGateway_less__);
/**
 * @Author: v_huangyongxing@baidu.com
 * @Date: 2024-04-26 10:40:15
 * @LastEditors: v_huangyongxing@baidu.com
 * @LastEditTime: 2024-04-26 17:38:18
 * @FilePath: /m-anquan-baidu-com/src/containers/product/pageIntelligentDataSecurityGateway.js
 * @Description: 智能数据安全网关
 */var structureData = [{ imgSrc: __webpack_require__(238), title: '应用侧敏感数据识别与梳理', text1: '痛点：对业务系统中敏感数据分布情况不清晰', text2: '通过主动探测和智能识别的方式，协助企业准确快速识别业务系统中的敏感数据和泄露风险点；对敏感数据进行分类分级、打标签。' }, { imgSrc: __webpack_require__(635), title: '应用侧敏感数据脱敏与访问控制', text1: '痛点：业务难改造，数据泄露事件频发', text2: '部署方式为反向代理，业务免改造即可通过脱敏、可逆脱敏等能力对敏感数据进行防护。也能通过访问控制能力，对用户异常行为进行监测和预警，避免敏感数据被合法人员非法使用。' }, { imgSrc: __webpack_require__(636), title: '水印及水印溯源', text1: '痛点：员工安全意识不足，截图拍照引发信息泄露', text2: '通过WEB、文件及图片水印，对截图拍照等数据泄漏行为起到威慑作用；基于身份水印码，精准追溯到数据泄漏者。' }, { imgSrc: __webpack_require__(239), title: '敏感数据访问实时监控审计', text1: '痛点：泄露事件难溯源难定责', text2: '通过全量记录访问行为日志，提供完整证据链路用于事后追溯，解决企业泄露事件难溯源难定责等问题。' }];var clientData = [{ imgSrc: __webpack_require__(637), title: '金融行业案例', text: '面对金融机构数据安全的复杂挑战，我们通过脱敏和敏感行为管控对其Web业务（OA/ERP）进行防护，并利用金融行业分类分级模版对其敏感数据梳理并打标' + '签，不仅实现业务免改造即可保障数据安全，还提升了客户数据资产管理效率，支持金融客户在严格合规的同时保障业务稳定持续运行。' }, { imgSrc: __webpack_require__(638), title: '医疗机构案例', text: '为解决医疗机构对敏感数据定义不明、特权账号管理混乱等痛点，本产品提供敏感资产梳理、数据分类分级及权限管控等能力，并在其CRM系统、营销系统及大' + '数据资源管理运行平台等内部系统配置水印，实现用户数据安全管理的智能化和规范化，助力客户兼顾业务发展与安全的平衡。' }];var PageIntelligentDataSecurityGateway = function PageIntelligentDataSecurityGateway(props) {
  var bannerInfo = props.bannerInfo || {};var learnMoreItem = bannerInfo.learnMore.length === 1 ? bannerInfo.learnMore[0] || {} : {};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product Brain' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProBanner__["a" /* default */], { title: bannerInfo.title, urlText: bannerInfo.urlText, bgImg: bannerInfo.bgImg, url: bannerInfo.url }), bannerInfo.nextText ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.nextUrl, target: '_blank', className: 'compliance-btn' }, bannerInfo.nextText) : null, bannerInfo.learnMore.length ? bannerInfo.learnMore.length === 1 ? bannerInfo.nextIndex === '0' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: learnMoreItem.content, target: '_blank', className: 'compliance-btn compliance-btn-border' }, learnMoreItem.title) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: learnMoreItem.content, target: '_blank', className: 'compliance-btn compliance-btn-border' }, learnMoreItem.title) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-tab' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-slide' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, learnMore.map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: item.content, target: '_blank' }, item.title));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tab-shadow' })) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, bannerInfo.bannerNote), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u4EA7\u54C1\u4EF7\u503C' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-p-advantage' }, bannerInfo.proinfoBox.map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-p-advantage-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon', style: { backgroundImage: 'url(' + item.mobile_pic + ')' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des' }, item.content)));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '产品功能' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, bannerInfo.profunBox.map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'profun-box mui-flex' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'star' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'profun-box-des' }, item.content)));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u4EA7\u54C1\u4F18\u52BF' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, [{ title: '联动信通院', content: '与信通院的分类分级产品联动，提高敏感数据识别的合规性，为客户提供符合行业高标准的安全防护。' }, { title: '数据可逆脱敏', content: '支持数据可逆脱敏，允许将数据恢复至原始状态，能够在不牺牲安全性的前提下充分利用数据资源。' }, { title: '支持图片脱敏', content: '采用Swin Transformer深度学习模型，实现了对图像数据中敏感元素如人脸、车牌号的高效脱敏。' }, { title: '丰富的水印能力', content: '支持Web水印、文档和图片明暗水印，提升员工安全红线意识，并能通过水印码追溯并锁定泄密者。' }].map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-app-solution-card' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, item.content));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '应用场景' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, structureData.map(function (_ref, index) {
    var imgSrc = _ref.imgSrc,
        title = _ref.title,
        text1 = _ref.text1,
        text2 = _ref.text2,
        imgWidth = _ref.imgWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: (index + 1) % 2 === 0 ? 'structure hui' : 'structure', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'shadow' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'imgBor', style: { width: imgWidth ? imgWidth : '100%' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imgSrc, alt: title }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, text1), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, text2));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '客户案例' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, clientData.map(function (_ref2, index) {
    var imgSrc = _ref2.imgSrc,
        title = _ref2.title,
        text = _ref2.text,
        imgWidth = _ref2.imgWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: (index + 1) % 2 === 0 ? 'structure hui' : 'structure', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'shadow' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'imgBor', style: { width: imgWidth ? imgWidth : '100%' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: imgSrc, alt: title }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, text));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { background: '#F5F5F5', paddingBottom: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u76F8\u5173\u4EA7\u54C1' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, [{ title: '智能威胁狩猎平台', content: '智能威胁狩猎平台是百度融合大数据及AI技术，将多种安全能力整合所打造的开箱即用的智能安全产品，在为客户构建完整的纵深防御体系的同时，' + '通过强大的智能溯源系统识别攻击者身份，并结合实时数据和智能算法模型，辅助客户进行高级安全决策，赋能安全运维人员，为企业保驾护航。', url: 'https://anquan.baidu.com/product/znwxsl' }, { title: 'DDoS攻击防护', content: '具备超过1.5Tbps抗D能力，采用云防护模式，全业务支持TCP/UDP/HTTP/HTTPS。无论您的源站是在百度云、其他公有云，或自建/租赁的线下' + 'IDC均可接入和使用，有效防御各类三到七层DDoS/ CC攻击，挽回因网站或业务服务中断造成的诸多损失。更多问题点击下方咨询，价格优惠 限时试用。', url: 'https://anquan.baidu.com/product/ddos' }, { title: 'WEB应用防火墙', content: '由国内专家Web安全专家组成的技术团队，为不同行业、不同规模的网站提供了革命性的云防护安全模式，彻底颠覆了过去单点部署WAF形式的被动防护，' + '以网站替身的形式为网站拦截各种SQL注入、XSS跨站、网站挂马、篡改、拖库等黑客攻击，并做到实时更新防护策略，第一时间防御各种0day漏洞，有效保护用户源站安全。', url: 'https://anquan.baidu.com/product/waf' }].map(function (item, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-app-solution-card' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, item.content), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: item.url, target: '_blank', className: 'btn' }, '\u4E86\u89E3\u8BE6\u60C5'));
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-app-solution-contact-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des', style: { paddingTop: '1.2rem' } }, '\u8054\u7CFB\u6211\u4EEC\u7ACB\u5373\u83B7\u53D6\u514D\u8D39\u6280\u672F\u4E13\u5BB6\u54A8\u8BE2'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: bannerInfo.url, className: 'btn', style: { marginTop: '.76rem' } }, '\u7ACB\u5373\u54A8\u8BE2'))));
};PageIntelligentDataSecurityGateway.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object };/* harmony default export */ __webpack_exports__["a"] = (PageIntelligentDataSecurityGateway);

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yewu-cj2.f2408669.png";

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/yewu-cj3.eee05bb6.png";

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/kehu-al1.c9523872.png";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/kehu-al2.a66c9bfb.png";

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/product_sences_bg.97ef9b48.png";

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/jishuzhichi.c0fe95ea.svg";

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/qqkefu.0aa61dd2.svg";

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shequluntan.d2265a1d.svg";

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lianxiyouxiang.0a6ced4d.svg";

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/number_auth_bg.291d4489.png";

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner.15c53068.png";

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner-wap.ae41dba1.png";

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner.a036095f.png";

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner.d0c54f54.png";

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner.0b35c077.png";

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sp_banner.2c460db6.png";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lb-banner.21701f8a.png";

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner.55517600.png";

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner.3722361f.png";

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner.0899c0a6.png";

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner.046df8b3.png";

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner.8af4d16c.png";

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner.4f111dcd.png";

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_textarea_item_style_css__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_textarea_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_textarea_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_textarea_item__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_textarea_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_textarea_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_input_item_style_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_input_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_input_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_input_item__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_input_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_input_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib_list_style_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib_list_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_mobile_lib_list_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_list__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_applyAction__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_less__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_less__);
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
    }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}function _possibleConstructorReturn(self, call) {
    if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: wangzhuang@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2024-02-21 15:05:31
  * @FilePath: /m-anquan-baidu-com/src/containers/apply/index.js
  * @Description: 申请试用页面
  */var Apply = (_temp = _class = function (_Component) {
    _inherits(Apply, _Component); /**
                                  * 构造函数，初始化状态和属性
                                  * @param {Object} props React组件属性，包含match对象
                                  * @param {Object} context React组件上下文对象
                                  */function Apply(props, context) {
        _classCallCheck(this, Apply);var _this = _possibleConstructorReturn(this, (Apply.__proto__ || Object.getPrototypeOf(Apply)).call(this, props, context));_this.userPhoneChange = function (val) {
            var fruit = false;var hint = '';if (_this.isEmpty(val)) {
                hint = '电话号码不能为空';fruit = _this.isEmpty(val);
            } else if (!_this.isPhone(val)) {
                hint = '电话号码格式不正确，请确认';fruit = !_this.isPhone(val);
            }_this.setState({ userPhoneError: fruit, userPhoneVal: val, userPhoneErrorHint: hint });return !fruit;
        };_this.submitFun = function () {
            var _this$state = _this.state,
                overallTypeIndex = _this$state.overallTypeIndex,
                probationIndex = _this$state.probationIndex,
                enterpriseName = _this$state.enterpriseName,
                userName = _this$state.userName,
                userPhoneVal = _this$state.userPhoneVal,
                overallTextarea = _this$state.overallTextarea,
                codeVal = _this$state.codeVal,
                from = _this$state.from;_this.setState({ enterpriseNameError: _this.isEmpty(enterpriseName), userNameError: _this.isEmpty(userName), codeError: _this.isEmpty(codeVal), codeHint: _this.isEmpty(codeVal) ? '验证码不能为空' : '' });_this.userPhoneChange(userPhoneVal);if (!_this.isEmpty(userName) && _this.userPhoneChange(userPhoneVal) && !_this.isEmpty(codeVal)) {
                if (overallTypeIndex === 2) {
                    if (_this.isEmpty(enterpriseName)) {
                        return;
                    }
                }var json = { 'company_name': enterpriseName, 'real_name': userName, 'phone_number': userPhoneVal.replace(/\s+/g, ''), 'id_type': overallTypeIndex, 'note': _this.props.match.params.Iid === '1' ? probationIndex === 2 ? '需要试用' + overallTextarea : '不需要需要试用' + overallTextarea : overallTextarea, 'catpcha': codeVal, 'from': from };if (overallTypeIndex === 1) {
                    delete json['company_name'];
                }_this.props.fetchUserApply(json).then(function () {
                    var cmsapiUserapply = _this.props.cmsapiUserapply;if (location.href.indexOf('testError') !== -1) {
                        alert(cmsapiUserapply.msg);
                    }if (cmsapiUserapply.is_error === 0) {
                        if (_this.isPageTitle('mesatee', _this.state.overallTextarea)) {
                            _this.reportData('mesatee_submit');
                        }var isLlmsec = location.href.includes('/m/apply/77');setTimeout(function () {
                            if (from) {
                                location.href = '/m/apply-succ?from=' + from;
                            } else {
                                location.href = '/m/apply-succ?isLlmsec=' + isLlmsec;
                            }
                        }, 100);
                    }if (cmsapiUserapply.is_error === 3) {
                        _this.setState({ codeError: true, codeHint: '验证码不正确', codeImg: '/catpcha?t=' + Date.now() });
                    }
                });
            }
        };_this.isEmpty = function (val) {
            var reg = /\S/;return !reg.test(val);
        };_this.isEmail = function (val) {
            var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;var value = val.replace(/\s/g, '');return reg.test(value);
        };_this.state = { overallTypeIndex: 2, // 身份类型
            probationIndex: 2, // 是否试用
            enterpriseName: '', // 企业名称
            codeVal: '', enterpriseNameError: false, userNameError: false, codeError: false, userName: '', // 真实姓名
            hasError: false, userPhoneVal: '', // 电话号码
            workId: [_this.props.match.params.Iid], // 感兴趣的业务
            overallTextarea: '', // 咨询内容
            userPhoneError: false, desInfoError: false, userPhoneErrorHint: '手机号码不能为空', userEmailError: false, userEmailErrorHint: '联系邮箱不能为空', codeImg: '/catpcha', codeHint: '验证码不能为空', from: _this.getRequest().from };_this.overallType = [{ val: '企业', id: 2 }, { val: '个人', id: 1 }];_this.probation = [{ val: '需要', id: 2 }, { val: '不需要', id: 1 }];return _this;
    } /**
      * 组件将要挂载时调用，判断是否为pc端，如果是则重定向到对应的页面
      */_createClass(Apply, [{ key: 'componentWillMount', value: function componentWillMount() {
            if (this.isPC()) {
                var str = '/?showForm=open';var Iid = this.props.match.params.Iid;var from = this.state.from;if (Iid) {
                    str = '/page/' + Iid + '?showForm=open';
                }if (Iid && from) {
                    str = '/page/' + Iid + '?showForm=open&from=' + from;
                }if (!Iid && from) {
                    str = '/?showForm=open&from=' + from;
                }location.href = str;
            }
        } /**
          * @function componentDidMount
          * @description 在组件挂载后，根据路由参数获取工作ID，并设置textarea的值为对应的导航名称。如果没有路由参数，则从服务列表中查询工作ID对应的导航名称，并设置textarea的值为对应的导航名称。
          */ }, { key: 'componentDidMount', value: function componentDidMount() {
            var _this2 = this;var name = this.getParams().name;if (name) {
                this.setState({ overallTextarea: name });return;
            }this.props.fetchCmsapiIndexData().then(function () {
                var itemlist = _this2.props.userApplyData.itemlist;var workId = _this2.state.workId[0];itemlist.service_list.forEach(function (item) {
                    if (workId === item.id) {
                        _this2.setState({ overallTextarea: '#' + item.navigation_name + '#' });
                    }
                });
            });
        } }, { key: 'render', /**
                              * @description 主要功能函数，返回一个React元素列表，包括输入框、文本区域等。
                              * 如果路由参数中有Iid=1，则显示“申请试用”相关信息；否则只显示基本信息。
                              * 对于输入框，需要判断是否为必填项，并在失去焦点时进行校验，错误时添加样式，同时显示错误提示。
                              * 对于文本区域，也需要进行校验，错误时添加样式，同时显示错误提示。
                              * 对于验证码，需要使用图片验证码，当点击图片验证码时，重新获取验证码，并将验证码值清空。
                              * 最后，提交按钮的事件处理器应该调用submitFun函数。
                              * @param {Object} props - React组件属性，包含match对象，match对象中包含了路由参数Iid，可以根据这个参数来判断是否显示“申请试用”相关信息。
                              * @returns {Array.<JSX.Element>} 返回一个React元素列表，包括输入框、文本区域等。
                              */value: function render() {
            var _this3 = this;var _state = this.state,
                overallTypeIndex = _state.overallTypeIndex,
                probationIndex = _state.probationIndex,
                enterpriseNameError = _state.enterpriseNameError,
                overallTextarea = _state.overallTextarea,
                userNameError = _state.userNameError,
                codeError = _state.codeError,
                userPhoneError = _state.userPhoneError,
                userEmailError = _state.userEmailError,
                userPhoneErrorHint = _state.userPhoneErrorHint,
                userEmailErrorHint = _state.userEmailErrorHint,
                codeHint = _state.codeHint,
                codeImg = _state.codeImg;var enterpriseClass = __WEBPACK_IMPORTED_MODULE_9_classnames___default()({ 'input-disable': overallTypeIndex === 1, 'on': enterpriseNameError && overallTypeIndex !== 1 });return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('h2', null, this.props.match.params.Iid === '1' ? '业务咨询 申请试用' : '业务咨询'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'spu-apply-from' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('form', null, this.props.match.params.Iid === '1' ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_list___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-form-title' }, '\u8BF7\u7559\u4E0B\u60A8\u7684\u8054\u7CFB\u65B9\u5F0F\uFF0C\u767E\u5EA6\u5B89\u5168\u7ED9\u60A8\u63D0\u4F9B\u4E13\u4E1A\u65B9\u6848')) : '', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_list___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u8EAB\u4EFD\u7C7B\u578B\uFF1A'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-form-assist' }, this.overallType.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'overall-type-box', key: index, onClick: function onClick() {
                        _this3.setState({ overallTypeIndex: item.id });
                    } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: overallTypeIndex === item.id ? 'on' : '' }), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', null, item.val));
            }))), this.props.match.params.Iid === '1' ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_list___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u662F\u5426\u7533\u8BF7\u8BD5\u7528\uFF1A'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-form-assist' }, this.probation.map(function (item, index) {
                return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'overall-type-box', key: index, onClick: function onClick() {
                        _this3.setState({ probationIndex: item.id });
                    } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: probationIndex === item.id ? 'on' : '' }), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', null, item.val));
            }))) : '', __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_list___default.a, { className: enterpriseClass }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u4F01\u4E1A\u540D\u79F0\uFF1A'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_input_item___default.a, { placeholder: '\u8BF7\u8F93\u5165\u771F\u5B9E\u4F01\u4E1A\u540D\u79F0', disabled: overallTypeIndex === 1, onBlur: function onBlur(val) {
                    _this3.setState({ enterpriseName: val });
                } }), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-error-hint' }, '\u4F01\u4E1A\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_list___default.a, { className: userNameError ? 'on' : '' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u771F\u5B9E\u59D3\u540D\uFF1A'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_input_item___default.a, { placeholder: '\u8BF7\u8F93\u5165\u771F\u5B9E\u59D3\u540D\u4FBF\u4E8E\u8054\u7CFB', onBlur: function onBlur(val) {
                    _this3.setState({ userName: val });
                } }), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-error-hint' }, '\u771F\u5B9E\u59D3\u540D\u4E0D\u80FD\u4E3A\u7A7A')), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_list___default.a, { className: userPhoneError ? 'on' : '' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u7535\u8BDD\u53F7\u7801\uFF1A'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_input_item___default.a, { type: 'phone', placeholder: '\u8BF7\u8F93\u5165\u771F\u5B9E\u7535\u8BDD\u53F7\u7801\u4FBF\u4E8E\u8054\u7CFB', onChange: function onChange(val) {
                    _this3.setState({ userPhoneVal: val });
                } }), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-error-hint' }, userPhoneErrorHint)), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_list___default.a, null, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-form-title' }, '\u54A8\u8BE2\u5185\u5BB9\uFF1A'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_textarea_item___default.a, { placeholder: '请描述您想咨询的内容', value: overallTextarea, onChange: function onChange(val) {
                    _this3.setState({ overallTextarea: val });
                } }), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-error-hint' })), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_antd_mobile_lib_list___default.a, { className: codeError ? 'codeInput on' : 'x' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u9A8C\u8BC1\u7801\uFF1A'), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_input_item___default.a, { placeholder: '\u8BF7\u8F93\u51FA\u53F3\u4FA7\u9A8C\u8BC1\u7801', onChange: function onChange(val) {
                    _this3.setState({ codeVal: val, codeError: !val.replace(/\s+/g, '') });
                } }), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'overall-code', onClick: function onClick() {
                    _this3.setState({ codeImg: '' }, function () {
                        _this3.setState({ codeImg: '/catpcha' });
                    });
                } }, __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { src: codeImg, alt: '', height: '100%' })), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-error-hint' }, codeHint)))), __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'apply-subbtn', onClick: this.submitFun }, '\u63D0\u4EA4'));
        } }]);return Apply;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]), _class.propTypes = { fetchCmsapiIndexData: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, fetchUserApply: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, userApplyData: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, cmsapiUserapply: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, userLoginstate: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, match: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object }, _temp); /**
                                                                                                                                                                                                                                                  * @description 将redux的state映射到组件的props中，包含用户登录状态、用户申请数据和CMSAPI获取的用户申请信息等
                                                                                                                                                                                                                                                  * @param {Object} state redux的state对象，包含多个reducer的state
                                                                                                                                                                                                                                                  * @returns {Object} 返回一个包含多个属性的对象，每个属性都是redux的state中的一个属性，如{userLoginstate, userApplyData, cmsapiUserapply}
                                                                                                                                                                                                                                                  */function mapStateToProps(state) {
    return { userLoginstate: state.userLoginstate, userApplyData: state.userApplyData, cmsapiUserapply: state.cmsapiUserapply };
} /**
  * @param {Function} dispatch - redux的dispatch函数，用于触发action
  * @returns {Object} - 包含了一些方法的对象，每个方法都是一个thunk，返回一个promise，可以在这里处理异步操作
  * fetchCmsapiIndexData：获取首页数据的action，参数为dispatch
  * fetchUserApply：提交申请的action，参数为{obj}，其中obj包含{name, phone, email, content}等字段
  */function mapDispatchToProps(dispatch) {
    return { fetchCmsapiIndexData: function fetchCmsapiIndexData() {
            return Object(__WEBPACK_IMPORTED_MODULE_10__actions_applyAction__["a" /* fetchCmsapiIndexData */])(dispatch);
        }, fetchUserApply: function fetchUserApply(obj) {
            return Object(__WEBPACK_IMPORTED_MODULE_10__actions_applyAction__["b" /* fetchUserApply */])(dispatch, obj);
        } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Apply));

/***/ }),
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(21);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _class = __webpack_require__(664);

var _CustomKeyboard = __webpack_require__(665);

var _CustomKeyboard2 = _interopRequireDefault(_CustomKeyboard);

var _Portal = __webpack_require__(666);

var _Portal2 = _interopRequireDefault(_Portal);

var _exenv = __webpack_require__(142);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var customNumberKeyboard = null;
var IS_REACT_16 = !!ReactDOM.createPortal;
function getBodyScrollTop() {
    var el = document.scrollingElement || document.documentElement;
    return el && el.scrollTop || 0;
}
function setBodyScrollTop(scrollTop) {
    var el = document.scrollingElement || document.documentElement;
    el.scrollTop = scrollTop;
}

var NumberInput = function (_React$Component) {
    (0, _inherits3['default'])(NumberInput, _React$Component);

    function NumberInput(props) {
        (0, _classCallCheck3['default'])(this, NumberInput);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (NumberInput.__proto__ || Object.getPrototypeOf(NumberInput)).call(this, props));

        _this.onChange = function (value) {
            if (!('value' in _this.props)) {
                _this.setState({ value: value.target.value });
            }
            _this.props.onChange(value);
        };
        _this.onConfirm = function (value) {
            _this.props.onVirtualKeyboardConfirm(value);
        };
        _this.addBlurListener = function () {
            document.addEventListener('click', _this.doBlur, false);
        };
        _this.removeBlurListener = function () {
            document.removeEventListener('click', _this.doBlur, false);
        };
        _this.saveRef = function (el) {
            if (IS_REACT_16 && el) {
                customNumberKeyboard = el;
            }
        };
        _this.doBlur = function (ev) {
            var value = _this.state.value;

            if (ev.target !== _this.inputRef) {
                _this.onInputBlur(value);
            }
        };
        _this.unLinkInput = function () {
            if (customNumberKeyboard && customNumberKeyboard.antmKeyboard && customNumberKeyboard.linkedInput && customNumberKeyboard.linkedInput === _this) {
                customNumberKeyboard.linkedInput = null;
                if (_this.props.autoAdjustHeight) {
                    _this.getContainer().style.height = '0';
                }
                (0, _class.addClass)(customNumberKeyboard.antmKeyboard, _this.props.keyboardPrefixCls + '-wrapper-hide');
            }
            // for unmount
            _this.removeBlurListener();
        };
        _this.onInputBlur = function (value) {
            if (IS_REACT_16) {
                _this.keyBoard = null;
            }
            var focus = _this.state.focus;

            if (focus) {
                _this.setState({
                    focus: false
                });
                _this.props.onBlur(value);
                setTimeout(function () {
                    _this.unLinkInput();
                }, 50);
            }
        };
        _this.onInputFocus = function () {
            var value = _this.state.value;

            _this.props.onFocus(value);
            _this.setState({
                focus: true
            }, function () {
                if (customNumberKeyboard) {
                    customNumberKeyboard.linkedInput = _this;
                    if (customNumberKeyboard.antmKeyboard) {
                        if (_this.props.autoAdjustHeight) {
                            var keyBoardHeight = customNumberKeyboard.antmKeyboard.offsetHeight;
                            _this.getContainer().style.height = keyBoardHeight + 'px';
                            if (_this.inputRef) {
                                var _this$inputRef$getBou = _this.inputRef.getBoundingClientRect(),
                                    bottom = _this$inputRef$getBou.bottom;

                                var clientHeight = window.innerHeight;
                                // 计算输入框距离视窗的底部距离
                                var distance = clientHeight - bottom;
                                if (distance < keyBoardHeight) {
                                    setBodyScrollTop(getBodyScrollTop() + keyBoardHeight - distance);
                                }
                            }
                        }
                        (0, _class.removeClass)(customNumberKeyboard.antmKeyboard, _this.props.keyboardPrefixCls + '-wrapper-hide');
                    }
                    customNumberKeyboard.confirmDisabled = value === '';
                    if (customNumberKeyboard.confirmKeyboardItem) {
                        if (value === '') {
                            (0, _class.addClass)(customNumberKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
                        } else {
                            (0, _class.removeClass)(customNumberKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
                        }
                    }
                }
            });
        };
        _this.onKeyboardClick = function (KeyboardItemValue) {
            var maxLength = _this.props.maxLength;
            var value = _this.state.value;
            // tslint:disable-next-line:no-this-assignment

            var onChange = _this.onChange;

            var valueAfterChange = void 0;
            // 删除键
            if (KeyboardItemValue === 'delete') {
                valueAfterChange = value.substring(0, value.length - 1);
                onChange({ target: { value: valueAfterChange } });
                // 确认键
            } else if (KeyboardItemValue === 'confirm') {
                valueAfterChange = value;
                onChange({ target: { value: valueAfterChange } });
                _this.onInputBlur(value);
                _this.onConfirm(value);
                // 收起键
            } else if (KeyboardItemValue === 'hide') {
                valueAfterChange = value;
                _this.onInputBlur(valueAfterChange);
            } else {
                if (maxLength !== undefined && +maxLength >= 0 && (value + KeyboardItemValue).length > maxLength) {
                    valueAfterChange = (value + KeyboardItemValue).substr(0, maxLength);
                    onChange({ target: { value: valueAfterChange } });
                } else {
                    valueAfterChange = value + KeyboardItemValue;
                    onChange({ target: { value: valueAfterChange } });
                }
            }
            if (customNumberKeyboard) {
                customNumberKeyboard.confirmDisabled = valueAfterChange === '';
                if (customNumberKeyboard.confirmKeyboardItem) {
                    if (valueAfterChange === '') {
                        (0, _class.addClass)(customNumberKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
                    } else {
                        (0, _class.removeClass)(customNumberKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
                    }
                }
            }
        };
        _this.onFakeInputClick = function () {
            _this.focus();
        };
        _this.focus = function () {
            // this focus may invocked by users page button click, so this click may trigger blurEventListener at the same time
            _this.renderCustomKeyboard();
            _this.removeBlurListener();
            var focus = _this.state.focus;

            if (!focus) {
                _this.onInputFocus();
            }
            setTimeout(function () {
                _this.addBlurListener();
            }, 50);
        };
        _this.state = {
            focus: false,
            value: props.value || ''
        };
        return _this;
    }

    (0, _createClass3['default'])(NumberInput, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
                this.setState({
                    value: nextProps.value
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // focus:true unmount 不能触发 blur
            if (this.state.focus) {
                this.props.onBlur(this.state.value);
            }
            this.unLinkInput();
        }
    }, {
        key: 'getComponent',
        value: function getComponent() {
            var _props = this.props,
                confirmLabel = _props.confirmLabel,
                backspaceLabel = _props.backspaceLabel,
                cancelKeyboardLabel = _props.cancelKeyboardLabel,
                keyboardPrefixCls = _props.keyboardPrefixCls,
                moneyKeyboardWrapProps = _props.moneyKeyboardWrapProps,
                moneyKeyboardHeader = _props.moneyKeyboardHeader,
                disabledKeys = _props.disabledKeys;

            return React.createElement(_CustomKeyboard2['default'], { ref: this.saveRef, onClick: this.onKeyboardClick, prefixCls: keyboardPrefixCls, confirmLabel: confirmLabel, backspaceLabel: backspaceLabel, cancelKeyboardLabel: cancelKeyboardLabel, wrapProps: moneyKeyboardWrapProps, header: moneyKeyboardHeader, disabledKeys: disabledKeys });
        }
    }, {
        key: 'getContainer',
        value: function getContainer() {
            var keyboardPrefixCls = this.props.keyboardPrefixCls;

            var container = document.querySelector('#' + keyboardPrefixCls + '-container');
            if (!container) {
                container = document.createElement('div');
                container.setAttribute('id', keyboardPrefixCls + '-container');
                document.body.appendChild(container);
            }
            this.container = container;
            return this.container;
        }
    }, {
        key: 'renderCustomKeyboard',
        value: function renderCustomKeyboard() {
            var _this2 = this;

            if (IS_REACT_16) {
                this.keyBoard = React.createElement(
                    _Portal2['default'],
                    { getContainer: function getContainer() {
                            return _this2.getContainer();
                        } },
                    this.getComponent()
                );
            } else {
                customNumberKeyboard = ReactDOM.unstable_renderSubtreeIntoContainer(this, this.getComponent(), this.getContainer());
            }
        }
    }, {
        key: 'renderPortal',
        value: function renderPortal() {
            if (!IS_REACT_16 || !_exenv.canUseDOM) {
                return null;
            }
            return this.keyBoard;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                placeholder = _props2.placeholder,
                disabled = _props2.disabled,
                editable = _props2.editable,
                moneyKeyboardAlign = _props2.moneyKeyboardAlign;
            var _state = this.state,
                focus = _state.focus,
                value = _state.value;

            var preventKeyboard = disabled || !editable;
            var fakeInputCls = (0, _classnames2['default'])('fake-input', {
                focus: focus,
                'fake-input-disabled': disabled
            });
            var fakeInputContainerCls = (0, _classnames2['default'])('fake-input-container', {
                'fake-input-container-left': moneyKeyboardAlign === 'left'
            });
            return React.createElement(
                'div',
                { className: fakeInputContainerCls },
                value === '' &&
                // tslint:disable-next-line:jsx-no-multiline-js
                React.createElement(
                    'div',
                    { className: 'fake-input-placeholder' },
                    placeholder
                ),
                React.createElement(
                    'div',
                    { role: 'textbox', 'aria-label': value || placeholder, className: fakeInputCls, ref: function ref(el) {
                            return _this3.inputRef = el;
                        }, onClick: preventKeyboard ? function () {} : this.onFakeInputClick },
                    value
                ),
                this.renderPortal()
            );
        }
    }]);
    return NumberInput;
}(React.Component);

NumberInput.defaultProps = {
    onChange: function onChange() {},
    onFocus: function onFocus() {},
    onBlur: function onBlur() {},
    onVirtualKeyboardConfirm: function onVirtualKeyboardConfirm() {},
    placeholder: '',
    disabled: false,
    editable: true,
    prefixCls: 'am-input',
    keyboardPrefixCls: 'am-number-keyboard',
    autoAdjustHeight: false
};
exports['default'] = NumberInput;
module.exports = exports['default'];

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
function hasClass(node, className) {
    if (node.classList) {
        return node.classList.contains(className);
    }
    var originClass = node.className;
    return (' ' + originClass + ' ').indexOf(' ' + className + ' ') > -1;
}
function addClass(node, className) {
    if (node.classList) {
        node.classList.add(className);
    } else {
        if (!hasClass(node, className)) {
            node.className = node.className + ' ' + className;
        }
    }
}
function removeClass(node, className) {
    if (node.classList) {
        node.classList.remove(className);
    } else {
        if (hasClass(node, className)) {
            var originClass = node.className;
            node.className = (' ' + originClass + ' ').replace(' ' + className + ' ', '');
        }
    }
}

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.KeyboardItem = undefined;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(17);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rmcFeedback = __webpack_require__(38);

var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);

var _exenv = __webpack_require__(142);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

/**
 * determines whether an array includes a certain value among its entries, returning true or false as appropriate.
 * @param {array} arr The array to search in
 * @param {any} item  The value to search for
 */
function includes(arr, item) {
    if (!arr || !arr.length || !item) {
        return false;
    }
    for (var i = 0, len = arr.length; i < len; i++) {
        if (arr[i] === item) {
            return true;
        }
    }
    return false;
}

var KeyboardItem = exports.KeyboardItem = function (_React$Component) {
    (0, _inherits3['default'])(KeyboardItem, _React$Component);

    function KeyboardItem() {
        (0, _classCallCheck3['default'])(this, KeyboardItem);
        return (0, _possibleConstructorReturn3['default'])(this, (KeyboardItem.__proto__ || Object.getPrototypeOf(KeyboardItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(KeyboardItem, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                _onClick = _a.onClick,
                className = _a.className,
                disabled = _a.disabled,
                children = _a.children,
                tdRef = _a.tdRef,
                label = _a.label,
                iconOnly = _a.iconOnly,
                restProps = __rest(_a, ["prefixCls", "onClick", "className", "disabled", "children", "tdRef", "label", "iconOnly"]);
            var value = children;
            if (className === 'keyboard-delete') {
                value = 'delete';
            } else if (className === 'keyboard-hide') {
                value = 'hide';
            } else if (className === 'keyboard-confirm') {
                value = 'confirm';
            }
            var extraCls = (0, _defineProperty3['default'])({}, prefixCls + '-item-disabled', disabled);
            var wrapCls = (0, _classnames2['default'])(prefixCls + '-item', className, extraCls);
            return React.createElement(
                _rmcFeedback2['default'],
                { disabled: disabled, activeClassName: prefixCls + '-item-active' },
                React.createElement(
                    'td',
                    (0, _extends3['default'])({ ref: tdRef
                        // tslint:disable-next-line:jsx-no-multiline-js
                        , onClick: function onClick(e) {
                            _onClick(e, value);
                        }, className: wrapCls }, restProps),
                    children,
                    iconOnly && React.createElement(
                        'i',
                        { className: 'sr-only' },
                        label
                    )
                )
            );
        }
    }]);
    return KeyboardItem;
}(React.Component);

KeyboardItem.defaultProps = {
    prefixCls: 'am-number-keyboard',
    onClick: function onClick() {},
    disabled: false
};

var CustomKeyboard = function (_React$Component2) {
    (0, _inherits3['default'])(CustomKeyboard, _React$Component2);

    function CustomKeyboard() {
        (0, _classCallCheck3['default'])(this, CustomKeyboard);

        var _this2 = (0, _possibleConstructorReturn3['default'])(this, (CustomKeyboard.__proto__ || Object.getPrototypeOf(CustomKeyboard)).apply(this, arguments));

        _this2.onKeyboardClick = function (e) {
            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            e.nativeEvent.stopImmediatePropagation();
            if (_this2.props.disabledKeys && includes(_this2.props.disabledKeys, value)) {
                return null;
            }
            if (value === 'confirm' && _this2.confirmDisabled) {
                return null;
            } else {
                if (_this2.linkedInput) {
                    _this2.linkedInput.onKeyboardClick(value);
                }
            }
        };
        _this2.renderKeyboardItem = function (item, index) {
            var disabled = false;
            if (_this2.props.disabledKeys && includes(_this2.props.disabledKeys, item)) {
                disabled = true;
            }
            return React.createElement(
                KeyboardItem,
                { onClick: _this2.onKeyboardClick, key: 'item-' + item + '-' + index, disabled: disabled },
                item
            );
        };
        return _this2;
    }

    (0, _createClass3['default'])(CustomKeyboard, [{
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                confirmLabel = _props.confirmLabel,
                backspaceLabel = _props.backspaceLabel,
                cancelKeyboardLabel = _props.cancelKeyboardLabel,
                wrapProps = _props.wrapProps,
                header = _props.header;

            var wrapperCls = (0, _classnames2['default'])(prefixCls + '-wrapper', prefixCls + '-wrapper-hide');
            return React.createElement(
                'div',
                (0, _extends3['default'])({ className: wrapperCls, ref: function ref(el) {
                        return _this3.antmKeyboard = el;
                    } }, wrapProps),
                header && React.cloneElement(header, { onClick: this.onKeyboardClick }),
                React.createElement(
                    'table',
                    null,
                    React.createElement(
                        'tbody',
                        null,
                        React.createElement(
                            'tr',
                            null,
                            ['1', '2', '3'].map(function (item, index) {
                                return (
                                    // tslint:disable-next-line:jsx-no-multiline-js
                                    _this3.renderKeyboardItem(item, index)
                                );
                            }),
                            React.createElement(KeyboardItem, (0, _extends3['default'])({ className: 'keyboard-delete', rowSpan: 2, onClick: this.onKeyboardClick }, this.getAriaAttr(backspaceLabel)))
                        ),
                        React.createElement(
                            'tr',
                            null,
                            ['4', '5', '6'].map(function (item, index) {
                                return (
                                    // tslint:disable-next-line:jsx-no-multiline-js
                                    _this3.renderKeyboardItem(item, index)
                                );
                            })
                        ),
                        React.createElement(
                            'tr',
                            null,
                            ['7', '8', '9'].map(function (item, index) {
                                return (
                                    // tslint:disable-next-line:jsx-no-multiline-js
                                    _this3.renderKeyboardItem(item, index)
                                );
                            }),
                            React.createElement(
                                KeyboardItem,
                                { className: 'keyboard-confirm', rowSpan: 2, onClick: this.onKeyboardClick, tdRef: function tdRef(el) {
                                        return _this3.confirmKeyboardItem = el;
                                    } },
                                confirmLabel
                            )
                        ),
                        React.createElement(
                            'tr',
                            null,
                            ['.', '0'].map(function (item, index) {
                                return (
                                    // tslint:disable-next-line:jsx-no-multiline-js
                                    _this3.renderKeyboardItem(item, index)
                                );
                            }),
                            React.createElement(KeyboardItem, (0, _extends3['default'])({ className: 'keyboard-hide', onClick: this.onKeyboardClick }, this.getAriaAttr(cancelKeyboardLabel)))
                        )
                    )
                )
            );
        }
    }, {
        key: 'getAriaAttr',
        value: function getAriaAttr(label) {
            if (_exenv.IS_IOS) {
                return { label: label, iconOnly: true };
            } else {
                return { role: 'button', 'aria-label': label };
            }
        }
    }]);
    return CustomKeyboard;
}(React.Component);

CustomKeyboard.defaultProps = {
    prefixCls: 'am-number-keyboard',
    disabledKeys: null
};
exports['default'] = CustomKeyboard;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(21);

var ReactDOM = _interopRequireWildcard(_reactDom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var createPortal = ReactDOM.createPortal;

var Portal = function (_React$Component) {
    (0, _inherits3['default'])(Portal, _React$Component);

    function Portal(props) {
        (0, _classCallCheck3['default'])(this, Portal);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props));

        _this.container = _this.props.getContainer();
        return _this;
    }

    (0, _createClass3['default'])(Portal, [{
        key: 'render',
        value: function render() {
            if (this.props.children) {
                return createPortal(this.props.children, this.container);
            }
            return null;
        }
    }]);
    return Portal;
}(React.Component);

exports['default'] = Portal;
module.exports = exports['default'];

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Input = function (_React$Component) {
    (0, _inherits3["default"])(Input, _React$Component);

    function Input() {
        (0, _classCallCheck3["default"])(this, Input);

        var _this = (0, _possibleConstructorReturn3["default"])(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));

        _this.onInputBlur = function (e) {
            var value = e.target.value;
            if (_this.props.onBlur) {
                _this.props.onBlur(value);
            }
        };
        _this.onInputFocus = function (e) {
            // here should have a value definition but none.
            var value = e.target.value;
            if (_this.props.onFocus) {
                _this.props.onFocus(value);
            }
        };
        _this.focus = function () {
            if (_this.inputRef) {
                _this.inputRef.focus();
            }
        };
        return _this;
    }

    (0, _createClass3["default"])(Input, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _a = this.props,
                onBlur = _a.onBlur,
                onFocus = _a.onFocus,
                restProps = __rest(_a, ["onBlur", "onFocus"]);
            return React.createElement("input", (0, _extends3["default"])({ ref: function ref(el) {
                    return _this2.inputRef = el;
                }, onBlur: this.onInputBlur, onFocus: this.onInputFocus }, restProps));
        }
    }]);
    return Input;
}(React.Component);

exports["default"] = Input;
module.exports = exports["default"];

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    confirmLabel: '确定',
    backspaceLabel: '退格',
    cancelKeyboardLabel: '收起键盘'
};
module.exports = exports['default'];

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Brief = undefined;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(17);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames5 = __webpack_require__(3);

var _classnames6 = _interopRequireDefault(_classnames5);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _rmcFeedback = __webpack_require__(38);

var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

var Brief = exports.Brief = function (_React$Component) {
    (0, _inherits3['default'])(Brief, _React$Component);

    function Brief() {
        (0, _classCallCheck3['default'])(this, Brief);
        return (0, _possibleConstructorReturn3['default'])(this, (Brief.__proto__ || Object.getPrototypeOf(Brief)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Brief, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                { className: 'am-list-brief', style: this.props.style },
                this.props.children
            );
        }
    }]);
    return Brief;
}(React.Component);

var ListItem = function (_React$Component2) {
    (0, _inherits3['default'])(ListItem, _React$Component2);

    function ListItem(props) {
        (0, _classCallCheck3['default'])(this, ListItem);

        var _this2 = (0, _possibleConstructorReturn3['default'])(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));

        _this2.onClick = function (ev) {
            var _this2$props = _this2.props,
                onClick = _this2$props.onClick,
                platform = _this2$props.platform;

            var isAndroid = platform === 'android';
            if (!!onClick && isAndroid) {
                if (_this2.debounceTimeout) {
                    clearTimeout(_this2.debounceTimeout);
                    _this2.debounceTimeout = null;
                }
                var Item = ev.currentTarget;
                var RippleWidth = Math.max(Item.offsetHeight, Item.offsetWidth);
                var ClientRect = ev.currentTarget.getBoundingClientRect();
                var pointX = ev.clientX - ClientRect.left - Item.offsetWidth / 2;
                var pointY = ev.clientY - ClientRect.top - Item.offsetWidth / 2;
                var coverRippleStyle = {
                    width: RippleWidth + 'px',
                    height: RippleWidth + 'px',
                    left: pointX + 'px',
                    top: pointY + 'px'
                };
                _this2.setState({
                    coverRippleStyle: coverRippleStyle,
                    RippleClicked: true
                }, function () {
                    _this2.debounceTimeout = setTimeout(function () {
                        _this2.setState({
                            coverRippleStyle: { display: 'none' },
                            RippleClicked: false
                        });
                    }, 1000);
                });
            }
            if (onClick) {
                onClick(ev);
            }
        };
        _this2.state = {
            coverRippleStyle: { display: 'none' },
            RippleClicked: false
        };
        return _this2;
    }

    (0, _createClass3['default'])(ListItem, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _classnames3,
                _classnames4,
                _this3 = this;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                activeStyle = _a.activeStyle,
                error = _a.error,
                align = _a.align,
                wrap = _a.wrap,
                disabled = _a.disabled,
                children = _a.children,
                multipleLine = _a.multipleLine,
                thumb = _a.thumb,
                extra = _a.extra,
                arrow = _a.arrow,
                onClick = _a.onClick,
                restProps = __rest(_a, ["prefixCls", "className", "activeStyle", "error", "align", "wrap", "disabled", "children", "multipleLine", "thumb", "extra", "arrow", "onClick"]);var platform = restProps.platform,
                otherProps = __rest(restProps, ["platform"]);var _state = this.state,
                coverRippleStyle = _state.coverRippleStyle,
                RippleClicked = _state.RippleClicked;

            var wrapCls = (0, _classnames6['default'])(prefixCls + '-item', className, (_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-item-disabled', disabled), (0, _defineProperty3['default'])(_classnames, prefixCls + '-item-error', error), (0, _defineProperty3['default'])(_classnames, prefixCls + '-item-top', align === 'top'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-item-middle', align === 'middle'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-item-bottom', align === 'bottom'), _classnames));
            var rippleCls = (0, _classnames6['default'])(prefixCls + '-ripple', (0, _defineProperty3['default'])({}, prefixCls + '-ripple-animate', RippleClicked));
            var lineCls = (0, _classnames6['default'])(prefixCls + '-line', (_classnames3 = {}, (0, _defineProperty3['default'])(_classnames3, prefixCls + '-line-multiple', multipleLine), (0, _defineProperty3['default'])(_classnames3, prefixCls + '-line-wrap', wrap), _classnames3));
            var arrowCls = (0, _classnames6['default'])(prefixCls + '-arrow', (_classnames4 = {}, (0, _defineProperty3['default'])(_classnames4, prefixCls + '-arrow-horizontal', arrow === 'horizontal'), (0, _defineProperty3['default'])(_classnames4, prefixCls + '-arrow-vertical', arrow === 'down' || arrow === 'up'), (0, _defineProperty3['default'])(_classnames4, prefixCls + '-arrow-vertical-up', arrow === 'up'), _classnames4));
            var content = React.createElement(
                'div',
                (0, _extends3['default'])({}, otherProps, { onClick: function onClick(ev) {
                        _this3.onClick(ev);
                    }, className: wrapCls }),
                thumb ? React.createElement(
                    'div',
                    { className: prefixCls + '-thumb' },
                    typeof thumb === 'string' ? React.createElement('img', { src: thumb }) : thumb
                ) : null,
                React.createElement(
                    'div',
                    { className: lineCls },
                    children !== undefined && React.createElement(
                        'div',
                        { className: prefixCls + '-content' },
                        children
                    ),
                    extra !== undefined && React.createElement(
                        'div',
                        { className: prefixCls + '-extra' },
                        extra
                    ),
                    arrow && React.createElement('div', { className: arrowCls, 'aria-hidden': 'true' })
                ),
                React.createElement('div', { style: coverRippleStyle, className: rippleCls })
            );
            var touchProps = {};
            Object.keys(otherProps).forEach(function (key) {
                if (/onTouch/i.test(key)) {
                    touchProps[key] = otherProps[key];
                    delete otherProps[key];
                }
            });
            return React.createElement(
                _rmcFeedback2['default'],
                (0, _extends3['default'])({}, touchProps, { disabled: disabled || !onClick, activeStyle: activeStyle, activeClassName: prefixCls + '-item-active' }),
                content
            );
        }
    }]);
    return ListItem;
}(React.Component);

ListItem.defaultProps = {
    prefixCls: 'am-list',
    align: 'middle',
    error: false,
    multipleLine: false,
    wrap: false,
    platform: 'ios'
};
ListItem.Brief = Brief;
exports['default'] = ListItem;

/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_input_item_style_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_input_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_input_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_list_style_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_list_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_list_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__numberOptions_formCom__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_applyAction__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_less__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 扶持计划的表单申请
  * @author wangzhuang
  * */var textAreaList = [{ label: '智能硬件“安全+”', value: '智能硬件“安全+”' }, { label: '个人信息保护', value: '个人信息保护' }, { label: '远程办公守护（WAF+VPN）', value: '远程办公守护（WAF+VPN）' }, { label: '公益平台保护', value: '公益平台保护' }, { label: '云加速SCDN', value: '云加速SCDN' }, { label: '业务风控', value: '业务风控' }, { label: 'APP消息推送', value: 'APP消息推送' }];var Apply = (_temp = _class = function (_Component) {
  _inherits(Apply, _Component);function Apply(props, context) {
    _classCallCheck(this, Apply);var _this = _possibleConstructorReturn(this, (Apply.__proto__ || Object.getPrototypeOf(Apply)).call(this, props, context));_this.userPhoneChange = function (val) {
      var fruit = false;var hint = '';if (_this.isEmpty(val)) {
        hint = '电话号码不能为空';fruit = _this.isEmpty(val);
      } else if (!_this.isPhone(val)) {
        hint = '电话号码格式不正确，请确认';fruit = !_this.isPhone(val);
      }_this.setState({ userPhoneError: fruit, userPhoneVal: val, userPhoneErrorHint: hint });return !fruit;
    };_this.userEmailChange = function (val) {
      var fruit = false;var hint = '';if (_this.isEmpty(val)) {
        hint = '邮箱不能为空';fruit = _this.isEmpty(val);
      } else if (!_this.isEmail(val)) {
        hint = '邮箱格式不正确，请确认';fruit = !_this.isEmail(val);
      }_this.setState({ userEmailError: fruit, userEmailVal: val, userEmailErrorHint: hint });return !fruit;
    };_this.submitFun = function () {
      var _this$state = _this.state,
          overallTypeIndex = _this$state.overallTypeIndex,
          enterpriseName = _this$state.enterpriseName,
          userName = _this$state.userName,
          userPhoneVal = _this$state.userPhoneVal,
          userEmailVal = _this$state.userEmailVal,
          overallTextarea = _this$state.overallTextarea,
          codeVal = _this$state.codeVal,
          from = _this$state.from;_this.setState({ enterpriseNameError: _this.isEmpty(enterpriseName), userNameError: _this.isEmpty(userName), codeError: _this.isEmpty(codeVal), codeHint: _this.isEmpty(codeVal) ? '验证码不能为空' : '' });_this.userPhoneChange(userPhoneVal);_this.userEmailChange(userEmailVal);if (!_this.isEmpty(userName) && _this.userPhoneChange(userPhoneVal) && _this.userEmailChange(userEmailVal) && !_this.isEmpty(codeVal)) {
        if (overallTypeIndex === 2) {
          if (_this.isEmpty(enterpriseName)) {
            return;
          }
        }var json = { 'company_name': enterpriseName, 'real_name': userName, 'phone_number': userPhoneVal.replace(/\s+/g, ''), 'email': userEmailVal.replace(/\s+/g, ''), 'id_type': overallTypeIndex, 'note': (overallTextarea || '') + '-扶持计划专项', 'catpcha': codeVal, 'from': from };if (overallTypeIndex === 1) {
          delete json['company_name'];
        }_this.props.fetchUserApply(json).then(function () {
          var cmsapiUserapply = _this.props.cmsapiUserapply;if (location.href.indexOf('testError') !== -1) {
            alert(cmsapiUserapply.msg);
          }if (cmsapiUserapply.is_error === 0) {
            if (from) {
              location.href = '/m/apply-succ?from=' + from;
            } else {
              location.href = '/m/apply-succ';
            }
          }if (cmsapiUserapply.is_error === 3) {
            _this.setState({ codeError: true, codeHint: '验证码不正确', codeImg: '/catpcha?t=' + Date.now() });
          }
        });
      }
    };_this.isEmpty = function (val) {
      var reg = /\S/;return !reg.test(val);
    };_this.isEmail = function (val) {
      var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;var value = val.replace(/\s/g, '');return reg.test(value);
    };_this.state = { overallTypeIndex: 2, // 身份类型
      enterpriseName: '', // 企业名称
      codeVal: '', enterpriseNameError: false, userNameError: false, codeError: false, userName: '', // 真实姓名
      hasError: false, userPhoneVal: '', // 电话号码
      userEmailVal: '', // 邮箱
      workId: [_this.props.match.params.Iid], // 感兴趣的业务
      overallTextarea: textAreaList[0].value, // 咨询内容
      userPhoneError: false, desInfoError: false, userPhoneErrorHint: '手机号码不能为空', userEmailError: false, userEmailErrorHint: '联系邮箱不能为空', codeImg: '/catpcha', codeHint: '验证码不能为空', from: _this.getRequest().from };_this.overallType = [{ val: '企业', id: 2 }, { val: '个人', id: 1 }];return _this;
  }_createClass(Apply, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        var str = '/?showPlanForm=open';var Iid = this.props.match.params.Iid;var from = this.state.from;if (Iid) {
          str = '/page/' + Iid + '?showPlanForm=open';
        }if (Iid && from) {
          str = '/page/' + Iid + '?showPlanForm=open&from=' + from;
        }if (!Iid && from) {
          str = '/?showPlanForm=open&from=' + from;
        }location.href = str;
      }
    } }, { key: 'render', value: function render() {
      var _this2 = this;var _state = this.state,
          overallTypeIndex = _state.overallTypeIndex,
          enterpriseNameError = _state.enterpriseNameError,
          overallTextarea = _state.overallTextarea,
          userNameError = _state.userNameError,
          codeError = _state.codeError,
          userPhoneError = _state.userPhoneError,
          userEmailError = _state.userEmailError,
          userPhoneErrorHint = _state.userPhoneErrorHint,
          userEmailErrorHint = _state.userEmailErrorHint,
          codeHint = _state.codeHint,
          codeImg = _state.codeImg;var enterpriseClass = __WEBPACK_IMPORTED_MODULE_7_classnames___default()({ 'input-disable': overallTypeIndex === 1, 'on': enterpriseNameError && overallTypeIndex !== 1 });return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h2', null, '\u7533\u8BF7\u8868\u5355'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-apply-from' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u8EAB\u4EFD\u7C7B\u578B\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-assist' }, this.overallType.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'overall-type-box', key: index, onClick: function onClick() {
            _this2.setState({ overallTypeIndex: item.id });
          } }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: overallTypeIndex === item.id ? 'on' : '' }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', null, item.val));
      }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, { className: enterpriseClass }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u4F01\u4E1A\u540D\u79F0\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, { placeholder: '\u8BF7\u8F93\u5165\u771F\u5B9E\u4F01\u4E1A\u540D\u79F0', disabled: overallTypeIndex === 1, onBlur: function onBlur(val) {
          _this2.setState({ enterpriseName: val });
        } }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-error-hint' }, '\u4F01\u4E1A\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A')), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, { className: userNameError ? 'on' : '' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u771F\u5B9E\u59D3\u540D\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, { placeholder: '\u8BF7\u8F93\u5165\u771F\u5B9E\u59D3\u540D\u4FBF\u4E8E\u8054\u7CFB', onBlur: function onBlur(val) {
          _this2.setState({ userName: val });
        } }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-error-hint' }, '\u771F\u5B9E\u59D3\u540D\u4E0D\u80FD\u4E3A\u7A7A')), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, { className: userPhoneError ? 'on' : '' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u7535\u8BDD\u53F7\u7801\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, { type: 'phone', placeholder: '\u8BF7\u8F93\u5165\u771F\u5B9E\u7535\u8BDD\u53F7\u7801\u4FBF\u4E8E\u8054\u7CFB', onChange: function onChange(val) {
          _this2.setState({ userPhoneVal: val });
        } }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-error-hint' }, userPhoneErrorHint)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, { className: userEmailError ? 'on' : '' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u90AE\u7BB1\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, { type: 'email', placeholder: '\u8BF7\u8F93\u5165\u771F\u5B9E\u90AE\u7BB1\u4FBF\u4E8E\u8054\u7CFB', onChange: function onChange(val) {
          _this2.setState({ userEmailVal: val });
        } }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-error-hint' }, userEmailErrorHint)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'hint-star' }, '*'), '\u7533\u8BF7\u670D\u52A1\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__numberOptions_formCom__["c" /* Select */], { placeholder: '\u7533\u8BF7\u670D\u52A1', value: overallTextarea, onChange: function onChange(value) {
          _this2.setState({ overallTextarea: value });
        }, data: textAreaList }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-error-hint' })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, { className: codeError ? 'codeInput on' : 'codeInput' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u9A8C\u8BC1\u7801\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, { placeholder: '\u8BF7\u8F93\u51FA\u53F3\u4FA7\u9A8C\u8BC1\u7801', onChange: function onChange(val) {
          _this2.setState({ codeVal: val, codeError: !val.replace(/\s+/g, '') });
        } }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'overall-code', onClick: function onClick() {
          _this2.setState({ codeImg: '' }, function () {
            _this2.setState({ codeImg: '/catpcha' });
          });
        } }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: codeImg, alt: '', height: '100%' })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-error-hint' }, codeHint)))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-subbtn', onClick: this.submitFun }, '\u63D0\u4EA4'));
    } }]);return Apply;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class.propTypes = { fetchCmsapiIndexData: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, fetchUserApply: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, userApplyData: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, cmsapiUserapply: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, userLoginstate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, match: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return { userLoginstate: state.userLoginstate, userApplyData: state.userApplyData, cmsapiUserapply: state.cmsapiUserapply };
}function mapDispatchToProps(dispatch) {
  return { fetchCmsapiIndexData: function fetchCmsapiIndexData() {
      return Object(__WEBPACK_IMPORTED_MODULE_9__actions_applyAction__["a" /* fetchCmsapiIndexData */])(dispatch);
    }, fetchUserApply: function fetchUserApply(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_9__actions_applyAction__["b" /* fetchUserApply */])(dispatch, obj);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Apply));

/***/ }),
/* 672 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_trash_normal.a059692c.svg";

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_upload.7e34a0e0.svg";

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplySucc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: wangzhuang@baidu.com
  * @Date: 2023-01-10 17:48:54
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2023-08-23 17:12:55
  * @FilePath: /m-anquan-baidu-com/src/containers/appliSucc/index.js
  * @Description: 申请试用成功
  */var ApplySucc = function (_Component) {
  _inherits(ApplySucc, _Component);function ApplySucc(props, context) {
    _classCallCheck(this, ApplySucc);var _this = _possibleConstructorReturn(this, (ApplySucc.__proto__ || Object.getPrototypeOf(ApplySucc)).call(this, props, context));_this.closeFun = function () {
      window.close();
    };return _this;
  }_createClass(ApplySucc, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        location.href = '/';
      }
    } }, { key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'apply-succ' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null, '\u63D0\u4EA4\u6210\u529F'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'apply-succ-des' }, '\u60A8\u7684\u7533\u8BF7\u5DF2\u63D0\u4EA4\uFF0C\u4E4B\u540E\u4F1A\u6709\u6211\u4EEC\u7684\u5546\u52A1\u56E2\u961F\u4E0E\u60A8\u8054\u7CFB\uFF0C\u8C22\u8C22\uFF01'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'apply-succ-img' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(248), alt: '' })), location.href.includes('isLlmsec=true') ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'apply-succ-btn', href: 'https://bj.bcebos.com/ensec-web-privacy/anquan/大模型安全解决方案白皮书.pdf', target: '_blank' }, '\u4E0B\u8F7D\u767D\u76AE\u4E66') : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'window-close', onClick: this.closeFun }, '\u5173\u95ED'));
    } }]);return ApplySucc;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Help */
/* unused harmony export mapStateToProps */
/* unused harmony export mapDispatchToProps */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_helpAction__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 帮助与支持
  * @author wangzhuang
  * */var tabData = ['产品指南', '更多...'];var Help = (_temp = _class = function (_Component) {
  _inherits(Help, _Component);function Help(props, context) {
    _classCallCheck(this, Help);var _this = _possibleConstructorReturn(this, (Help.__proto__ || Object.getPrototypeOf(Help)).call(this, props, context));_this.findParent = function (dom, name) {
      if (dom.tagName.toLowerCase() === name) {
        return dom;
      }return _this.findParent(dom.parentNode, name);
    };_this.renderNav = function (navList, num) {
      var padLeft = (num + 1) * 0.4;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', { className: num === 0 ? 'menu-el' : '' }, navList.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { key: index }, item.flag === 'page' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/community/' + item.url_id + '/' + item.file_type + '/' + (item.help_type ? item.help_type : ''), className: 'menu-el-page', style: { paddingLeft: padLeft + 'rem' } }, item.name) : '', item.flag === 'navigation' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'just-bet', style: { paddingLeft: padLeft + 'rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, item.name), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'menu-el-icon' })) : '', item.flag === 'navigation' ? _this.renderNav(item.sub, num + 1) : '');
      }));
    };_this.state = { tabIndex: 0 };return _this;
  }_createClass(Help, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        location.href = '/help';
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;this.props.fetchHelpapiIndex();var menuEl = document.querySelector('#menu');menuEl.onclick = function (e) {
        var domLi = _this2.findParent(e.target, 'li');if (domLi.className === 'on') {
          domLi.classList.remove('on');domLi.querySelectorAll('li').forEach(function (item) {
            item.classList.remove('on');
          });
        } else {
          domLi.classList.add('on');
        }
      };
    } }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps(nextProps) {
      if (nextProps.history.location.pathname === '/' && this.props.history.location.pathname !== '/' && this.state.menuShow) {
        var liOnList = document.querySelectorAll('li.on');liOnList.forEach(function (item) {
          item.classList.remove('on');
        });
      }
    } }, { key: 'render', value: function render() {
      var _this3 = this;var helpapiIndex = this.props.helpapiIndex;var tabIndex = this.state.tabIndex;var menuEl = !this.isEmptyobj(helpapiIndex) ? this.renderNav(helpapiIndex.itemlist.help_list, 0) : '';var mereEl = !this.isEmptyobj(helpapiIndex) ? this.renderNav(helpapiIndex.itemlist.brance_list, 0) : '';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spu-help' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1', null, '\u5E2E\u52A9\u4E0E\u652F\u6301'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'help-tab align-center' }, tabData.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: tabIndex === index ? 'on' : '', key: index, onClick: function onClick() {
            _this3.setState({ tabIndex: index });
          } }, item);
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'menu', className: 'menu-box' }, tabIndex === 0 ? menuEl : '', tabIndex === 1 ? mereEl : ''));
    } }]);return Help;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { helpapiIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, fetchHelpapiIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return { helpapiIndex: state.helpapiIndex };
}function mapDispatchToProps(dispatch) {
  return { fetchHelpapiIndex: function fetchHelpapiIndex() {
      return Object(__WEBPACK_IMPORTED_MODULE_4__actions_helpAction__["a" /* fetchHelpapiIndex */])(dispatch);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Help)));

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchHelpapiIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file 帮助支持
 * @author wangzhuang
 */function fetchHelpapiIndex(dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/helpapi/index', {}, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["v" /* GET_HELPAPI_INDEX */], data: data.data });
  });
}

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Community */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_communityAction__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file Community
  * @author wangzhuang
  * */var Community = (_temp = _class = function (_Component) {
  _inherits(Community, _Component);function Community(props, context) {
    _classCallCheck(this, Community);var _this = _possibleConstructorReturn(this, (Community.__proto__ || Object.getPrototypeOf(Community)).call(this, props, context));_this.state = { index: 0, isFixed: false };_this.changeTab = _this.changeTab.bind(_this);_this.srcollTop = _this.srcollTop.bind(_this);_this.renderTypicalCase = _this.renderTypicalCase.bind(_this);return _this;
  }_createClass(Community, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        var params = this.props.match.params;var url = '';if (params.fileType) {
          url = 'id=' + params.urlId + '&file_type=' + params.fileType;
        } else {
          url = 'id=' + params.urlId;
        }if (params.typeid) {
          url += '&typeid=' + params.typeid;
        }location.href = '/help?' + url;
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var params = this.props.match.params;this.props.fetchHelpapiGettext({ urlId: params.urlId, fileType: params.fileType });window.addEventListener('scroll', this.srcollTop);
    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.srcollTop);
    } }, { key: 'srcollTop', value: function srcollTop() {
      if (this.tabNode) {
        var srcollTop = document.documentElement.scrollTop || document.body.scrollTop;var tabNodeTop = this.tabNode.offsetTop;var tabNodeHeight = this.tabNode.offsetHeight;if (srcollTop > tabNodeTop - tabNodeHeight) {
          this.setState({ isFixed: true });
        } else if (srcollTop <= tabNodeTop - tabNodeHeight) {
          this.setState({ isFixed: false });
        }
      }
    } }, { key: 'changeTab', value: function changeTab(index) {
      this.setState({ index: index });document.documentElement.scrollTop = document.body.scrollTop = 0;
    } }, { key: 'renderTypicalCase', value: function renderTypicalCase(_ref) {
      var _this2 = this;var helpList = _ref.helpList;return [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: 'tab', style: { height: '1.3rem' }, ref: function ref(tabNode) {
          return _this2.tabNode = tabNode;
        } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('tab-content', { tabFixed: this.state.isFixed }) }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tab-wrapper' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tab' }, helpList && helpList.map(function (helpItem, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: _this2.changeTab.bind(_this2, index), className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('tab-item', { active: _this2.state.index === index }), key: index }, helpItem.title);
      }))))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: 'content', className: 'community-text-contant' }, helpList && helpList.map(function (helpItem, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('community-text-item', { active: _this2.state.index === index }) }, helpItem.note && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'note' }, helpItem.note), helpItem.logo_pic && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'logo-pic' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: helpItem.logo_pic, alt: 'logo-pic' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('community-text-item-content', { show: index === helpItem }), dangerouslySetInnerHTML: { __html: helpItem.content } }));
      }))];
    } }, { key: 'render', value: function render() {
      var helpapiGettext = this.props.helpapiGettext;var helpData = null;var helpList = [];var helpType = null;if (!this.isEmptyobj(helpapiGettext)) {
        helpData = helpapiGettext.itemlist.help_data;helpList = helpapiGettext.itemlist.help_list;helpType = helpData && helpData.help_type;
      }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'community' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1', null, !this.isEmptyobj(helpapiGettext) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, helpData.page_name, '\xA0|\xA0', helpData.help_title) : ''), helpType === '3' ? this.renderTypicalCase({ helpData: helpData, helpList: helpList }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'community-text' }, !this.isEmptyobj(helpapiGettext) ? helpList.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'community-mod', key: index }, item.title && item.title.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', { className: item.content && item.content.length ? 'community-cut' : '' }, helpData.help_type === '1' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'class-hint' }, 'Q: ') : '', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell' }, item.title)) : '', item.content && item.content.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'community-conten' }, helpData.help_type === '1' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'class-hint' }, 'A: ') : '', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'cell', dangerouslySetInnerHTML: { __html: item.content } })) : '');
      }) : ''));
    } }]);return Community;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { fetchHelpapiGettext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, helpapiGettext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, match: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return { helpapiGettext: state.helpapiGettext };
}function mapDispatchToProps(dispatch) {
  return { fetchHelpapiGettext: function fetchHelpapiGettext(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__actions_communityAction__["a" /* fetchHelpapiGettext */])(dispatch, obj);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Community));

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchHelpapiGettext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file 帮助指南文章页
 * @author wangzhuang
 */function fetchHelpapiGettext(dispatch, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/helpapi/mobileGettext/' + obj.urlId, { file_type: obj.fileType }, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["u" /* GET_HELPAPI_GETTEXT */], data: data.data });
  });
}

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return About; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @Author: v_huangyongxing@baidu.com
  * @Date: 2023-02-21 13:51:12
  * @LastEditors: v_huangyongxing@baidu.com
  * @LastEditTime: 2024-12-20 14:05:18
  * @FilePath: /m-anquan-baidu-com/src/containers/about/index.js
  * @Description: 
  */ /**
     * @file 关于我们
     * @author wangzhuang
     * */var About = (_temp = _class = function (_Component) {
  _inherits(About, _Component);function About(props, context) {
    _classCallCheck(this, About);var _this = _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).call(this, props, context));_this.state = { aboutType: _this.props.match.params.type || 'us', overstep: false };return _this;
  }_createClass(About, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        location.href = '/about/' + this.state.aboutType;
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;setTimeout(function () {
        window.scrollTo(0, 0);
      }, 600);window.addEventListener('scroll', function () {
        return _this2.sildeTabTop();
      });
    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
      var _this3 = this;window.removeEventListener('scroll', function () {
        return _this3.sildeTabTop();
      });
    } }, { key: 'sildeTabTop', value: function sildeTabTop() {
      var aboutBoxBanner = this.aboutBoxBanner;var docScrollTop = document.documentElement.scrollTop || document.body.scrollTop;if (aboutBoxBanner) {
        if (docScrollTop >= aboutBoxBanner.offsetHeight) {
          this.setState({ overstep: true });
        } else {
          this.setState({ overstep: false });
        }
      }
    } }, { key: 'render', value: function render() {
      var _this4 = this;var _state = this.state,
          aboutType = _state.aboutType,
          overstep = _state.overstep;var tabData = [{ value: '了解我们', name: 'us' }, { value: '联系我们', name: 'contacts' }];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'xbu-about' }, overstep ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { height: '7rem' } }) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: overstep ? 'about-banner-box about-fixed' : 'about-banner-box' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-banner', ref: function ref(el) {
          return _this4.aboutBoxBanner = el;
        } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1', null, '\u6210\u4E3A\u6DF1\u8C19\u4E1A\u52A1\u7684', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u667A\u80FD\u4E16\u754C\u5B89\u5168\u9886\u5BFC\u8005'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(686), alt: 'banner', width: '100%' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-tab' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-slide' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul', null, tabData.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li', { className: item.name === aboutType ? 'on' : '', key: index, onClick: function onClick() {
            _this4.setState({ tabIndex: index, aboutType: item.name });_this4.props.history.push('/about/' + item.name);if (_this4.state.overstep) {
              document.documentElement.scrollTop = document.body.scrollTop = _this4.aboutBoxBanner.offsetHeight;
            }
          } }, item.value);
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tab-shadow' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'tab-shadow' }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-con' }, aboutType === 'us' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-us' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { style: { marginBottom: '.8rem' } }, '\u767E\u5EA6\u5B89\u5168\u662F\u767E\u5EA6\u516C\u53F8\u65D7\u4E0B\uFF0C\u4EE5AI\u4E3A\u6838\u5FC3\u6253\u9020\u7684\u5B89\u5168\u54C1\u724C\uFF0C\u662F\u767E\u5EA6\u4E8C\u5341\u56DB\u5E74\u5B89\u5168\u5B9E\u8DF5\u7684\u603B\u7ED3\u4E0E\u63D0\u70BC\uFF0C\u81F4\u529B\u4E8E\u6210\u4E3A\u6DF1\u8C19\u4E1A\u52A1\u7684\u667A\u80FD\u4E16\u754C\u5B89\u5168 \u9886\u5BFC\u8005\u3002\u57FA\u4E8E\u57FA\u7840\u5B89\u5168\u3001\u6570\u636E\u5B89\u5168\u3001\u4E1A\u52A1\u5B89\u5168\u3001\u8F66\u4E0EIoT\u5B89\u5168\u56DB\u5927\u4EA7\u54C1\u77E9\u9635\uFF0C\u767E\u5EA6\u5B89\u5168\u4E1A\u52A1\u8986\u76D6\u767E\u5EA6\u5404\u79CD\u590D\u6742\u4E1A\u52A1\u573A\u666F\uFF0C\u540C\u65F6\u9762\u5411\u5408\u4F5C \u4F19\u4F34\u8F93\u51FA\u5B89\u5168\u4EA7\u54C1\u4E0E\u884C\u4E1A\u4E00\u4F53\u5316\u89E3\u51B3\u65B9\u6848\uFF0C\u6DB5\u76D6\u6CDB\u79D1\u6280\u3001\u667A\u6167\u91D1\u878D\u3001\u667A\u6167\u5DE5\u4E1A\u3001\u667A\u6167\u6C7D\u8F66\u3001\u667A\u6167\u653F\u52A1\u7B49\u9886\u57DF\uFF0C\u5168\u9762\u63A2\u7D22AI\u65F6\u4EE3\u7684\u65B0\u5B9E\u8DF5\u3001 \u65B0\u8303\u5F0F\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\u9762\u5411\u884C\u4E1A\u751F\u6001\uFF0C\u4E00\u65B9\u9762\uFF0C\u53D1\u6325\u6280\u672F\u80FD\u529B\u6253\u51FB\u5305\u62EC\u7535\u4FE1\u7F51\u7EDC\u8BC8\u9A97\u3001\u8D4C\u535A\u3001\u9690\u79C1\u7A83\u53D6\u5728\u5185\u7684\u5404\u7C7B\u8FDD\u6CD5\u72AF\u7F6A\u884C\u4E3A\uFF0C\u534F\u52A9\u516C\u5B89\u673A\u5173\u7834\u6848\u6570\u767E\u8D77\uFF0C \u6D89\u6848\u91D1\u989D\u8FBE\u6570\u4EBF\u5143\u4EBA\u6C11\u5E01\uFF0C\u4E00\u65B9\u9762\uFF0C\u79C9\u627F\u6280\u672F\u5F00\u6E90\u3001\u6807\u51C6\u9A71\u52A8\u7406\u5FF5\uFF0C\u8054\u5408\u751F\u6001\u5408\u4F5C\u4F19\u4F34\u63A8\u52A8AI\u65F6\u4EE3\u7684\u5B89\u5168\u751F\u6001\u5EFA\u8BBE\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-bot' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(687), alt: '\u767E\u5EA6\u5B89\u5168' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(688), alt: '\u767E\u5EA6\u5B89\u5168' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(689), alt: '\u767E\u5EA6\u5B89\u5168' }))) : null, aboutType === 'contacts' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'about-contacts' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProductTitle__["a" /* default */], { title: '商务咨询' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'details-mod mb40 about-way', style: { paddingLeft: '1.2rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mb40' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'aboutTextLeft' }, '\u81F4\u7535'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'tel://010-58003138' }, '010-58003138')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'aboutTextLeft' }, '\u90AE\u7BB1'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'mailto:anquan_business@baidu.com', target: '' }, 'anquan_business@baidu.com'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'details-mod align-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ml160' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(690), style: { width: '1.4rem', height: '1.4rem' }, alt: '\u7533\u8BF7\u8BD5\u7528' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ml140' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/apply', className: 'm-btn mb40' }, '\u7533\u8BF7\u8BD5\u7528'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'weak-hint' }, '\u63D0\u4EA4\u9700\u6C42\uFF0C\u4E13\u4EBA\u56DE\u590D'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProductTitle__["a" /* default */], { title: '建议/反馈' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'details-mod align-center mb40' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ml160' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(691), style: { width: '1.4rem', height: '1.4rem' }, alt: '\u7559\u8A00\u5EFA\u8BAE' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ml140' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://zhiqiu.baidu.com/imcswebchat/h5chat/h5message' + '.html?id=7360&token' + '=ou5qte56q1a5nrsd2i7bvvo50to16s81&domainID=baiduanquan', className: 'm-btn mb40', target: '_blank' }, '\u7559\u8A00\u5EFA\u8BAE'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'weak-hint' }, '\u6211\u4EEC\u671F\u5F85\u60A8\u7684\u5EFA\u8BAE'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'details-mod align-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ml160' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(692), style: { width: '1.4rem', height: '1.4rem' }, alt: '\u53EA\u80FD\u5BA2\u670D' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ml140' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://zhiqiu.baidu.com/imcswebchat/roulette/in?id=26333' + '&token=1lhv02nii91bejjb5a4f5u2gfk7skm4k&domainID=baiduanquan&type=1', className: 'm-btn mb40', target: '_blank' }, '\u667A\u80FD\u5BA2\u670D'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'weak-hint' }, '\u667A\u80FD\u673A\u5668\u4EBA\uFF0C\u61C2\u4F60\u6240\u60F3'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProductTitle__["a" /* default */], { title: '了解更多' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'details-mod align-center mb40' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ml160' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(693), style: { width: '1.4rem', height: '1.4rem' }, alt: '\u4EA7\u54C1\u677F\u5757' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ml140' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/productCenter', className: 'm-btn mb40' }, '\u4EA7\u54C1\u677F\u5757'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'weak-hint' }, '\u4EA7\u54C1\u6848\u4F8B\u3001\u6307\u5357\u3001\u8D44\u6599'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'details-mod align-center' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ml160' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(694), style: { width: '1.4rem', height: '1.4rem' }, alt: '\u7559\u8A00\u5EFA\u8BAE' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'ml140' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'weak-hint' }, '\u5173\u6CE8\u6211\u4EEC')))) : null));
    } }]);return About;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { match: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object }, _temp);

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/guanyuwomen_wap.22dcd0c0.svg";

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.c8d6e661.jpg";

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2.cb3e2019.png";

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3.d582efb7.png";

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shenqingshiyongi_140.74caf2cc.svg";

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/liuyanjianyi_140.6754117a.svg";

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zhinnegkefu_140.ff302c42.svg";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/chanpinbankuai_140.6a414406.svg";

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/image_QR code_wap.dbcc2083.png";

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Redirect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 404页面
  * @author wangzhuang
  * */var Redirect = function (_Component) {
  _inherits(Redirect, _Component);function Redirect(props, context) {
    _classCallCheck(this, Redirect);return _possibleConstructorReturn(this, (Redirect.__proto__ || Object.getPrototypeOf(Redirect)).call(this, props, context));
  }_createClass(Redirect, [{ key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'redirect' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'redirect-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(697), alt: '' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'redirect-con' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u554A\u54E6\uFF0C\u6CA1\u6709\u627E\u5230\u8FD9\u4E2A\u9875\u9762/(ToT)/\uFF5E\uFF5E'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/' }, '\u8FD4\u56DE\u767E\u5EA6\u5B89\u5168\u9996\u9875')));
    } }]);return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_404.faa247a2.svg";

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Brand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_wing_blank_style_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_wing_blank_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_wing_blank_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_wing_blank__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_wing_blank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_wing_blank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_carousel_style_css__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_carousel_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_carousel_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_carousel__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 品牌升级页
  * @author WangZhuang
  */var Brand = function (_Component) {
  _inherits(Brand, _Component);function Brand(props) {
    _classCallCheck(this, Brand);var _this = _possibleConstructorReturn(this, (Brand.__proto__ || Object.getPrototypeOf(Brand)).call(this, props));_this.state = { selectedIndex: 0 };return _this;
  }_createClass(Brand, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        location.href = '/pages/brand.html';
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      // 解决工具栏底部遮挡问题
      document.documentElement.style.height = window.innerHeight + 'px';if (this.isIos()) {
        document.body.addEventListener('touchmove', this.preventDefault, { passive: false });
      }
    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
      if (this.isIos()) {
        document.removeEventListener('touchmove', this.preventDefault, { passive: false });
      }
    } }, { key: 'preventDefault', value: function preventDefault(e) {
      e.preventDefault();
    } }, { key: 'render', value: function render() {
      var _this2 = this;var style = this.isSafari() && this.isIos() ? { height: '90vh' } : null;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'brand', style: style }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_wing_blank___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_carousel___default.a, { className: 'my-carousel', vertical: true, dots: false, selectedIndex: this.state.selectedIndex, afterChange: function afterChange(index) {
          _this2.setState({ selectedIndex: index });
        } }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: style, className: 'v-item carousel1' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: '/m/', className: 'brand-logo' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: __webpack_require__(700), width: '100%', alt: 'logo' })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car1-text' }, '\u6709 A I\uFF0C \u66F4 \u5B89 \u5168')), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: style, className: 'v-item carousel2 align-center' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-title' }, '\u54C1\u724C\u5347\u7EA7'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-text' }, '\u91CD\u65B0\u5B9A\u4E49AI\u65F6\u4EE3\u7684\u5B89\u5168\u3002AI\u7684\u5B89\u5168\uFF0C\u5B89\u5168\u7684AI\uFF0C\u65B0\u65F6\u4EE3\u7684 \u5B89\u5168\u751F\u6001\u7CFB\u7EDF\u9762\u4E34\u5168\u65B0\u7684\u673A\u9047\u4E0E\u6311\u6218\u3002\u57FA\u4E8E\u5728\u5B89\u5168\u9886\u57DF 20\u5E74\u5B89\u5168\u5B9E\u8DF5\u7684\u603B\u7ED3\u4E0E\u63D0\u70BC\uFF0C\u767E\u5EA6\u5B89\u5168\u4EE5AI\u4E3A\u6838\u5FC3\uFF0C\u4EE5\u5927 \u6570\u636E\u4E3A\u57FA\u7840\uFF0C\u4E3A\u751F\u6001\u5408\u4F5C\u4F19\u4F34\u63D0\u4F9B\u6280\u672F\u652F\u70B9\u53CA\u5B8C\u5584\u7684\u4EA7\u54C1 \u89E3\u51B3\u65B9\u6848\uFF0C\u4FC3\u8FDBAI\u65F6\u4EE3\u7684\u4EA7\u4E1A\u5171\u8D62\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car2-img' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'img1' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: __webpack_require__(701), alt: '\u767E\u5EA6\u5B89\u5168' }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'img-hint' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, 'Before'))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'img2' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: __webpack_require__(702), alt: '\u767E\u5EA6\u5B89\u5168' }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'img-hint' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, 'After')))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: style, className: 'v-item carousel3 align-center' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-title' }, '\u767E\u5EA6\u5B89\u5168 \u54C1\u724C\u4F7F\u547D'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-text' }, '\u767E\u5EA6\u5B89\u5168\u65E8\u5728\u4EE5AI\u4E3A\u6838\u5FC3\u6784\u5EFA\u5B89\u5168\u751F\u6001\u7CFB\u7EDF\uFF0C\u5BF9\u5185\u4E3A\u767E\u5EA6 \u516C\u53F8\u5404\u4E2A\u4E1A\u52A1\u4FDD\u9A7E\u62A4\u822A\uFF0C\u5BF9\u5916\u5411\u5168\u884C\u4E1A\u8F93\u51FA\u80FD\u529B\u4E0E\u89E3\u51B3\u65B9 \u6848\uFF0C\u8BA9\u5168\u884C\u4E1A\u4EAB\u53D7\u66F4\u5B89\u5168\u7684AI\u6240\u6765\u5E26\u6765\u7684\u53D8\u9769\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car3-img' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null)))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: style, className: 'v-item carousel4' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car4-con align-center' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-title' }, '\u5F00\u653E \u2022 \u5B89\u5168'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-text' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: { fontSize: '.4rem' } }, '\u767E\u5EA6\u5B89\u5168\u670D\u52A1\u5E73\u53F0'), '\u5728\u63D0\u4F9B\u6807\u51C6\u5316\u5B89\u5168\u4EA7\u54C1\u53CA\u670D\u52A1\u57FA\u7840\u4E0A\uFF0C\u4E3A\u5408\u4F5C\u4F19\u4F34\u63D0\u4F9B\u5B9A\u5236\u5316\u4F01\u4E1A\u7EA7\u5B89\u5168\u89E3\u51B3\u65B9\u6848', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: { fontSize: '.4rem', marginTop: '.3rem' } }, '\u5168\u7F51\u5B89\u5168\u5927\u6570\u636E\u4ED3\u5E93'), '\u57FA\u4E8E\u6D77\u91CF\u5A01\u80C1\u60C5\u62A5\uFF0C\u63D0\u4F9B\u5927\u6570\u636E\u5206\u6790\u548C\u5B89\u5168\u60C5\u62A5\u5171\u4EAB\u670D\u52A1', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br', null), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: { fontSize: '.4rem', marginTop: '.3rem' } }, '\u5B89\u5168\u751F\u6001\u7CFB\u7EDF'), '\u4EE5\u6280\u672F\u5F00\u6E90\u3001\u4E13\u5229\u5171\u4EAB\u3001\u6807\u51C6\u9A71\u52A8\u4E3A\u7406\u5FF5\uFF0C\u8054\u5408\u4E92\u8054\u7F51\u516C \u53F8\u3001\u5B89\u5168\u5382\u5546\u3001\u7EC8\u7AEF\u5236\u9020\u5546\u3001\u9AD8\u6821\u53CA\u79D1\u7814\u673A\u6784\uFF0C\u5171\u5EFA\u5B89\u5168 \u7684AI\u65F6\u4EE3', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('br', null))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: style, className: 'v-item carousel5' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car5-con align-center' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-title' }, '\u667A\u80FD \u2022 \u5B89\u5168'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-text' }, '\u4EE5AI\u4E3A\u6838\u5FC3\uFF0C\u6253\u9020\u57FA\u4E8E\u5927\u6570\u636E\u548C\u673A\u5668\u5B66\u4E60\u7684\u7EB5\u6DF1\u9632\u5FA1\uFF0C\u663E \u8457\u63D0\u9AD8\u5B89\u5168\u5728\u6570\u636E\u5C42\u3001\u611F\u77E5\u5C42\u548C\u6267\u884C\u5C42\u7684\u6548\u7387\u3002\u6709AI\uFF0C\u66F4 \u5B89\u5168\u3002\u4ECE\u6D77\u91CF\u5A01\u80C1\u60C5\u62A5\uFF0C\u5230\u9ED1\u8272\u4EA7\u4E1A\u94FE\u8FFD\u8E2A\uFF0C\u52A9\u529B\u667A\u6167\u516C \u5B89\u65B0\u4E1A\u6001')))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: style, className: 'v-item carousel6' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car6-con align-center' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-title' }, '\u53EF\u9760 \u2022 \u5B89\u5168'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-text' }, 'AI\u5B89\u5168\u3001\u4E91\u5B89\u5168\u3001\u79FB\u52A8\u5B89\u5168\u3001\u6570\u636E\u5B89\u5168\u3001DuEdge\u5B89\u5168\u3001 IoT\u5B89\u5168\uFF0C\u4E1A\u52A1\u5B89\u5168\uFF0C\u4E03\u5927\u5B89\u5168\u89E3\u51B3\u65B9\u6848\u77E9\u9635\uFF0C\u57FA\u4E8E\u767E\u5EA6 \u5728\u5B89\u5168\u9886\u57DF20\u5E74\u5B89\u5168\u5B9E\u8DF5\u7684\u603B\u7ED3\u4E0E\u63D0\u70BC\uFF0C\u5411\u5168\u884C\u4E1A\u8FDB\u884C \u8F93\u51FA\u80FD\u529B\u4E0E\u89E3\u51B3\u65B9\u6848'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car6-img just-center' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: __webpack_require__(703), alt: '\u5B89\u5168' }))))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: style, className: 'v-item carousel7 align-center' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-title' }, '\u7ED3\u6784\u4E4B\u601D'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-text' }, '\u767E\u5EA6\u5B89\u5168\u5168\u65B0LOGO\u7ED3\u6784\u4E3A\u4E2D\u95F4\u9542\u7A7A\u7684\u201C\u767E\u201D\u5B57\u5EFA\u7B51\u4F53\uFF0C\u6253 \u9020\u5F00\u9614\u3001\u5B8F\u4F1F\u3001\u5A01\u4E25\u4E4B\u611F\uFF0C\u5916\u5F62\u8F6E\u5ED3\u4E3A\u786C\u6717\u7684\u76FE\u724C\uFF0C\u4F20\u9012 \u4EE5AI\u4E3A\u6838\u5FC3\u767E\u5EA6\u5B89\u5168\u5F00\u653E\u3001\u667A\u80FD\u3001\u53EF\u9760\u7684\u54C1\u724C\u5F62\u8C61\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car7-img' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: __webpack_require__(704), alt: '\u767E\u5EA6', width: '100%' })))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: style, className: 'v-item carousel8' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car8-con align-center' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-title' }, 'VI \u89C4\u8303'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car-text' }, '\u767E\u5EA6\u5B89\u5168\u54C1\u724C\u5347\u7EA7\uFF0Clogo\u7684\u9020\u578B\u4E3A\u4E2D\u95F4\u9542\u7A7A\u7684\u201C\u767E\u201D\u5B57\u5F62\u6210\u7684\u5EFA\u7B51\u4F53\uFF0C\u7ED9\u4EBA\u5F00\u9614\u89C6\u91CE\u548C\u5B8F\u4F1F\u53EF\u9760\u7684\u89C6\u89C9\u611F\u53D7\u3002 \u901A\u8FC7\u4E25\u683C\u6807\u51C6\u7684\u8BED\u8A00\u548C\u7CFB\u7EDF\u5316\u89C6\u89C9\u7B26\u53F7\uFF0C\u5C06\u65B0\u5F62\u8C61\u7406\u5FF5\u5B97\u65E8\uFF0C\u884C\u4E3A\u548C\u529F\u80FD\u4F20\u7ED9\u793E\u4F1A\u516C\u4F17\uFF0C\u8D77\u5230\u5F3A\u5316\u54C1\u724C\u5F62\u8C61\u7684\u4F5C\u7528\u3002')))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: style, className: 'v-item carousel9' }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: style, className: 'v-item carousel10' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car10-con align-center' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: { width: '100%' } }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car10-title' }, '\u66F4\u591A\u4E1A\u52A1\u8BE6\u60C5\u8BF7\u8BBF\u95EE \u767E\u5EA6\u5B89\u5168'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'just-center' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'car10-link' }, 'anquan.baidu.com'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: 'https://anquan.baidu.com/', className: 'car10-click' }, '\u70B9\u51FB\u8FDB\u5165')))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'back-top', onClick: function onClick() {
          _this2.setState({ selectedIndex: 0 });
        } })))));
    } }]);return Brand;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.2e2356da.svg";

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/car2-logo1.0fce8978.png";

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/car2-logo2.d787b9b1.png";

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/6-icon.f5b04a2e.svg";

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/p7.db5ee114.svg";

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Submission; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TopBar__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file submission
  * @author WenCe
  * */var Submission = function (_PureComponent) {
  _inherits(Submission, _PureComponent);function Submission() {
    _classCallCheck(this, Submission);return _possibleConstructorReturn(this, (Submission.__proto__ || Object.getPrototypeOf(Submission)).apply(this, arguments));
  }_createClass(Submission, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        location.href = '/forum';
      }
    } }, { key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'submission' }, !this.isPC() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'top-bar pr' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_TopBar__["a" /* default */], { typeLeft: false })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'submission-container' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(707), alt: '\u7ACB\u5373\u6295\u7A3F' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'submission-email' }, '\u7A3F\u4EF6\u8BF7\u53D1\u9001\u81F3\uFF1Azqanquan@baidu.com'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'submission-btn', onClick: function onClick() {
          return location.href = 'mailto:zqanquan@baidu.com';
        } }, '\u7ACB\u5373\u6295\u7A3F')));
    } }]);return Submission;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pic_gaojianfasong.0455c895.svg";

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_TopBar__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_productCenterAction__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 产品板块列表页
  * @author WenCe
  * */var ProductCenter = (_temp = _class = function (_PureComponent) {
  _inherits(ProductCenter, _PureComponent);function ProductCenter(props) {
    _classCallCheck(this, ProductCenter);var _this = _possibleConstructorReturn(this, (ProductCenter.__proto__ || Object.getPrototypeOf(ProductCenter)).call(this, props));_this.state = { taggleIds: [] };_this.renderList = _this.renderList.bind(_this);_this.taggleCollapse = _this.taggleCollapse.bind(_this);_this.onClickRoot = _this.onClickRoot.bind(_this);_this.onClickChildren = _this.onClickChildren.bind(_this);return _this;
  }_createClass(ProductCenter, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        location.href = '/productCenter';
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;this.props.fetchCmsapiProductList().then(function () {
        var _props = _this2.props,
            defaultExpand = _props.defaultExpand,
            cmapiProductList = _props.cmapiProductList;var itemList = cmapiProductList && cmapiProductList.itemlist;if (defaultExpand && itemList) {
          var taggleIds = itemList.map(function (_, index) {
            return index;
          });_this2.setState({ taggleIds: taggleIds });
        }
      });
    } }, { key: 'onClickRoot', value: function onClickRoot(id) {
      var index = this.state.taggleIds.indexOf(id);var newTargetIds = [].concat(this.state.taggleIds);if (index === -1) {
        newTargetIds.push(id);
      } else {
        newTargetIds.splice(index, 1);
      }this.setState({ taggleIds: newTargetIds });
    } }, { key: 'onClickChildren', value: function onClickChildren(id) {
      location.href = '/m/productDetail/' + id;
    } }, { key: 'taggleCollapse', value: function taggleCollapse(isRoot, id, e) {
      e.persist();isRoot ? this.onClickRoot(id) : this.onClickChildren(id);
    } }, { key: 'renderList', value: function renderList(list, isRoot) {
      var _this3 = this;return list && list.map(function (item, index) {
        var hasChild = item && item.children && item.children.length > 0;var taggleIdIndex = _this3.state.taggleIds.indexOf(index);var isShowItemList = taggleIdIndex >= 0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: item.navigation_id || index, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ 'root': isRoot, 'sub-list': !isRoot }) }, isRoot ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: _this3.taggleCollapse.bind(_this3, isRoot, index), className: 'item-title' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'vertical-line' }), item && item.navigation_name, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('fold', { active: isShowItemList }) }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { alt: 'unfold', src: __webpack_require__(711) }))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { onClick: _this3.taggleCollapse.bind(_this3, isRoot, item && item.id), className: 'item-card' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'item-card-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: item && item.icon, alt: 'icon' })), item && item.name), hasChild && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('item-list', { active: isShowItemList }) }, _this3.renderList(item.children)));
      });
    } }, { key: 'render', value: function render() {
      var cmapiProductList = this.props.cmapiProductList;var taggleIds = this.state.taggleIds;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-list pr' }, !this.isPC() && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'top-bar-box pr' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_TopBar__["a" /* default */], { typeLeft: false })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1', { className: 'product-center-title' }, '\u4EA7\u54C1\u677F\u5757'), cmapiProductList && this.renderList(cmapiProductList.itemlist, true)), cmapiProductList.itemlist && taggleIds.length === cmapiProductList.itemlist.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'loading-box', style: { paddingTop: '.85rem', paddingBottom: '1.05rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'loading pr' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'conter' }, '\u4F60\u5DF2\u5230\u8FBE\u7248\u5757\u5C3D\u5934'))) : '');
    } }]);return ProductCenter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { defaultExpand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, cmapiProductList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, fetchCmsapiProductList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func }, _class.defaultProps = { defaultExpand: true }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function (state) {
  return { cmapiProductList: state.cmapiProductList };
}, function (dispatch) {
  return { fetchCmsapiProductList: function fetchCmsapiProductList() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_productCenterAction__["a" /* fetchCmsapiProductList */].apply(undefined, arguments));
    } };
})(ProductCenter));

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchCmsapiProductList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file 产品板块
 * @author Wence
 */function fetchCmsapiProductList() {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/productSegment', null, {}, function (res) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["m" /* GET_CMSAPI_PRODUCT_LIST */], data: res.data && res.data.is_error === 0 ? res.data : {} });
    });
  };
}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/unfold.5fe74a0f.svg";

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_TopBar__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ListPro__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Spin__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Loading__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Confirmation__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_productDetailAction__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_less__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file productsDetails
  * @author Wence
  */var ProductsDetails = (_temp = _class = function (_PureComponent) {
  _inherits(ProductsDetails, _PureComponent);function ProductsDetails(props) {
    _classCallCheck(this, ProductsDetails);var _this = _possibleConstructorReturn(this, (ProductsDetails.__proto__ || Object.getPrototypeOf(ProductsDetails)).call(this, props));_this.state = { tagid: 0, isTabFixed: false, isLoading: false, isMore: false };_this.onDocumentScroll = _this.onDocumentScroll.bind(_this);_this.renderTabBar = _this.renderTabBar.bind(_this);_this.renderList = _this.renderList.bind(_this);_this.getArticleList = _this.getArticleList.bind(_this);_this.getIsMore = _this.getIsMore.bind(_this);_this.getProductDetailId = _this.getProductDetailId.bind(_this);_this.getInitialTagId = _this.getInitialTagId.bind(_this);_this.fetchMoreProductList = _this.fetchMoreProductList.bind(_this);_this.openConfirm = _this.openConfirm.bind(_this);_this.pushApplyPage = _this.pushApplyPage.bind(_this);return _this;
  }_createClass(ProductsDetails, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        var id = this.props.match.params.id;location.href = '/productDetail/' + id;
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;var id = this.getProductDetailId();if (id) {
        this.props.fetchProductDetailIndexData({ id: id }).then(function () {
          _this2.setState({ isMore: _this2.getIsMore(), tagid: _this2.getInitialTagId() });
        });
      }document.addEventListener('scroll', this.onDocumentScroll);
    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
      document.removeEventListener('scroll', this.onDocumentScroll);
    } }, { key: 'getInitialTagId', value: function getInitialTagId() {
      var cmsapiProductDetailIndexData = this.props.cmsapiProductDetailIndexData;var tagsList = cmsapiProductDetailIndexData && cmsapiProductDetailIndexData.itemlist && cmsapiProductDetailIndexData.itemlist.tags;if (tagsList && tagsList.length === 1) {
        return tagsList[0] && tagsList[0].tagid;
      }return 0;
    } }, { key: 'getScrollTop', value: function getScrollTop(e) {
      var ele = e ? e.target : document;return ele.documentElement.scrollTop || ele.body.scrollTop;
    } }, { key: 'getArticleList', value: function getArticleList() {
      var itemlist = this.props.cmsapiProductDetailIndexData.itemlist;return itemlist && itemlist.article_list;
    } }, { key: 'getIsMore', value: function getIsMore() {
      var updateArticleList = this.getArticleList();return updateArticleList && updateArticleList.cur_page < updateArticleList.total_page;
    } }, { key: 'getProductDetailId', value: function getProductDetailId() {
      return this.props.match.params.id;
    } }, { key: 'onDocumentScroll', value: function onDocumentScroll(e) {
      var scrollTop = this.getScrollTop(e);if (this.tabNode.offsetTop <= scrollTop + this.topBox.clientHeight) {
        this.setState({ isTabFixed: true });
      } else if (this.tabNode.offsetTop > scrollTop + this.topBox.clientHeight) {
        this.setState({ isTabFixed: false });
      }
    } }, { key: 'changeTab', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                this.setState({ isLoading: true, tagid: id });if (this.state.isTabFixed) {
                  document.documentElement.scrollTop = document.body.scrollTop = this.tabNode.offsetTop - this.tabNode.offsetHeight;
                }_context.next = 4;return this.props.fetchProductDetailList({ id: this.getProductDetailId(), tagid: id, page: 1 });case 4:
                this.setState({ isLoading: false, isMore: this.getIsMore() });if (this.getScrollTop() < this.tabNode.offsetTop - this.tabNode.clientHeight) {
                  document.documentElement.scrollTop = document.body.scrollTop = 0;
                }case 6:case 'end':
                return _context.stop();}
          }
        }, _callee, this);
      }));function changeTab(_x) {
        return _ref.apply(this, arguments);
      }return changeTab;
    }() }, { key: 'fetchMoreProductList', value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _this3 = this;var articleList, page;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                articleList = this.getArticleList();page = articleList ? articleList.cur_page + 1 : 1;this.setState({ isMore: false });_context2.next = 5;return this.props.fetchProductDetailList({ id: this.getProductDetailId(), tagid: this.state.tagid, page: page }, true);case 5:
                this.setState({ isMore: this.getIsMore() }, function () {
                  return !_this3.state.isMore && _this3.forceUpdate();
                });case 6:case 'end':
                return _context2.stop();}
          }
        }, _callee2, this);
      }));function fetchMoreProductList() {
        return _ref2.apply(this, arguments);
      }return fetchMoreProductList;
    }() }, { key: 'openConfirm', value: function openConfirm() {
      var content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';var isEmail = content.indexOf('@') >= 0;var href = isEmail ? 'mailto:' + content : 'tel:' + content;Object(__WEBPACK_IMPORTED_MODULE_9__components_Confirmation__["a" /* default */])({ content: '\u8054\u7CFB\u5546\u52A1\uFF1A' + content, onOk: function onOk() {
          return location.href = href;
        } });
    } }, { key: 'pushApplyPage', value: function pushApplyPage() {
      var id = this.getProductDetailId();var itemlist = this.props.cmsapiProductDetailIndexData.itemlist;if (itemlist.next_index === '2') {
        location.href = itemlist.next_url;
      } else {
        location.href = '/m/apply/' + id;
      }
    } }, { key: 'renderTabBar', value: function renderTabBar() {
      var _this4 = this;var cmsapiProductDetailIndexData = this.props.cmsapiProductDetailIndexData;var itemlist = cmsapiProductDetailIndexData.itemlist;var tabList = itemlist.tags;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'tab-warpper', ref: function ref(tabNode) {
          return _this4.tabNode = tabNode;
        } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('tab', { fixed: this.state.isTabFixed }) }, tabList && tabList.length > 3 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'tab-shadow' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'tab-shadow-left' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'tab-shadow-right' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'tab-content' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul', null, tabList && tabList.length > 1 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li', { onClick: this.changeTab.bind(this, 0), className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ active: this.state.tagid === 0 }) }, '\u5168\u90E8'), tabList && tabList.map(function (tabItem) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ active: tabItem.tagid === _this4.state.tagid }), onClick: _this4.changeTab.bind(_this4, tabItem && tabItem.tagid), key: tabItem && tabItem.tagid }, tabItem && tabItem.tagname);
      }))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'border-bottom' })));
    } }, { key: 'renderList', value: function renderList() {
      var _this5 = this;var cmsapiProductDetailIndexData = this.props.cmsapiProductDetailIndexData;var itemlist = cmsapiProductDetailIndexData.itemlist;var articleList = itemlist.article_list;if (this.state.isLoading) {
        // loading加载时默认为20个listpro高度防止闪动
        var defaultHeight = 3.12 * 20 + 'rem';return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: 'list', className: 'list-loading', style: { height: defaultHeight } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Spin__["a" /* default */], null));
      }return [__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { ref: function ref(listNode) {
          return _this5.listNode = listNode;
        }, key: 'list', className: 'section list' }, articleList && articleList.datalist && articleList.datalist.map(function (listItem) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { key: listItem.aid, href: '/m/forum/page/' + listItem.aid, target: '_blank' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_ListPro__["a" /* default */], { title: listItem.title, time: listItem.publish_time.slice(5, 10), brief: listItem.pv + '\u4EBA\u9605\u8BFB', imgSrc: listItem.pic }));
      })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Loading__["a" /* default */], { key: 'loading', style: { paddingTop: '1.25rem', paddingBottom: '1.05rem' }, isLoad: this.state.isMore, type: this.getIsMore(), callbackFn: this.fetchMoreProductList })];
    } }, { key: 'renderProductCard', value: function renderProductCard() {
      var cmsapiProductDetailIndexData = this.props.cmsapiProductDetailIndexData;var itemlist = cmsapiProductDetailIndexData.itemlist;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: 'product-center', className: 'product-center' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-center-content' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: itemlist && itemlist.segment_icon, alt: 'icon' })), itemlist && itemlist.navigation_name), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-center-footer' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'btn', onClick: this.pushApplyPage }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(716), alt: 'try' })), itemlist && itemlist.next_index_note), itemlist && itemlist.segment_contact && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { onClick: this.openConfirm.bind(this, itemlist.segment_contact), className: 'btn border-left' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(717), alt: 'business' })), '\u5546\u52A1\u5408\u4F5C')));
    } }, { key: 'render', value: function render() {
      var _this6 = this;var cmsapiProductDetailIndexData = this.props.cmsapiProductDetailIndexData;var isRender = cmsapiProductDetailIndexData && cmsapiProductDetailIndexData.itemlist;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-details' }, !this.isPC() && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'top-bar-box', ref: function ref(topBox) {
          return _this6.topBox = topBox;
        } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_TopBar__["a" /* default */], null)), isRender && this.renderProductCard(), isRender && this.renderTabBar(), isRender && this.renderList());
    } }]);return ProductsDetails;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]), _class.propTypes = { match: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, cmsapiProductDetailIndexData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, fetchProductDetailIndexData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, fetchProductDetailList: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(function (state) {
  return { cmsapiProductDetailIndexData: state.cmsapiProductDetailIndexData };
}, function (dispatch) {
  return { fetchProductDetailIndexData: function fetchProductDetailIndexData() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_10__actions_productDetailAction__["a" /* fetchProductDetailIndexData */].apply(undefined, arguments));
    }, fetchProductDetailList: function fetchProductDetailList() {
      return dispatch(__WEBPACK_IMPORTED_MODULE_10__actions_productDetailAction__["b" /* fetchProductDetailList */].apply(undefined, arguments));
    } };
})(ProductsDetails));

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchProductDetailIndexData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchProductDetailList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
} /**
  * @file 产品详情板块
  * @author Wence
  */var isError = function isError(res) {
  return res && res.data && res.data.is_error === 0;
};var fetchProductDetailIndexData = function fetchProductDetailIndexData(params) {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/getProductSegmentData', params, {}, function (res) {
      dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["k" /* GET_CMSAPI_PRODUCT_DETAIL_INDEX */], data: isError(res) ? res.data : {} });
    });
  };
};var fetchProductDetailList = function fetchProductDetailList(params, isMore) {
  return function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/cmsapi/productTagData', params, {}, function (res) {
      var articleList = 'article_list';isMore ? dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["n" /* GET_CMSAPI_PRODUCT_MORE_DETAIL_LIST */], data: isError(res) ? res.data : { itemlist: _defineProperty({}, articleList, { datalist: [] }) } }) : dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["l" /* GET_CMSAPI_PRODUCT_DETAIL_LIST */], data: isError(res) ? res.data : {} });
    });
  };
};

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_try.f68cc5fa.svg";

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_business.24db7b8f.svg";

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_searchBar__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp, _initialiseProps;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 号码搜索
  * @author: wence
  */var historyKey = 'numberSearch';var NumberSearch = (_temp = _class = function (_PureComponent) {
  _inherits(NumberSearch, _PureComponent);function NumberSearch(props) {
    _classCallCheck(this, NumberSearch);var _this = _possibleConstructorReturn(this, (NumberSearch.__proto__ || Object.getPrototypeOf(NumberSearch)).call(this, props));_initialiseProps.call(_this);var storage = localStorage.getItem(historyKey);var historyList = storage ? JSON.parse(storage) : [];_this.state = { historyList: historyList, searchValue: '' };if (_this.isPC()) {
      location.href = '/haoma/search';
    }return _this;
  }_createClass(NumberSearch, [{ key: 'render', value: function render() {
      var _this2 = this;var _state = this.state,
          searchValue = _state.searchValue,
          historyList = _state.historyList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'number-search' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_searchBar__["a" /* default */], { value: searchValue, onChange: this.onChange, onSubmit: this.onSubmit, onCancel: function onCancel() {
          var navigationList = _this2.props.navigationList || {};var list = navigationList.itemlist || [];var id = _this2.findId(list);if (id) {
            location.href = '/m/product/' + id;
          } else {
            _this2.props.history.goBack();
          }
        }, placeholder: '\u8BF7\u8F93\u5165\u8981\u67E5\u8BE2\u7684\u7535\u8BDD\u53F7\u7801\u6216\u5173\u952E\u5B57', autoFocus: true, isShowCancel: true }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'search-history' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'search-history-title' }, '\u641C\u7D22\u5386\u53F2'), historyList.map(function (text, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/haoma/result/' + text, className: 'search-history-item', key: index }, text, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { onClick: _this2.removeHistoryItem.bind(_this2, index), src: __webpack_require__(478), alt: 'cancel' }));
      })));
    } }]);return NumberSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, navigationList: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object }, _initialiseProps = function _initialiseProps() {
  var _this3 = this;this.changeHistoryList = function (list) {
    localStorage.setItem(historyKey, JSON.stringify(list));_this3.setState({ historyList: list });
  };this.onChange = function (value) {
    _this3.setState({ searchValue: value });
  };this.findId = function (list) {
    var id = '';var loop = function loop(list) {
      list.forEach(function (item) {
        if (!item) {
          return;
        }if (item.navigation_name === '号码认证') {
          id = item.id;
        } else if (item.child && item.child.length > 0) {
          loop(item.child);
        }
      });
    };loop(list);return id;
  };this.onSubmit = function (value) {
    if (!(value || '').trim()) {
      return;
    }var historyList = [].concat(_this3.state.historyList);var index = historyList.indexOf(value);if (index < 0) {
      historyList.push(value);
    }_this3.changeHistoryList(historyList);location.href = '/m/haoma/result/' + value;
  };this.removeHistoryItem = function (index, e) {
    e.preventDefault();var historyList = [].concat(_this3.state.historyList);historyList.splice(index, 1);_this3.changeHistoryList(historyList);_this3.setState({ historyList: historyList });
  };
}, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
  return { navigationList: state.navigationList };
})(NumberSearch));

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Spin__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_searchBar__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_numberAuthAction__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_less__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 号码搜索结果
  * @author: wence
  */var statusEnum = { normal: 0, abnormal: 400 };var authEnum = { default: 0, done: 4 };var imageUrl = '/xiapi/api/v1/phone/captcha';var paramPage = 'request_page';var NumberSearch = (_temp = _class = function (_PureComponent) {
  _inherits(NumberSearch, _PureComponent);function NumberSearch(props) {
    _classCallCheck(this, NumberSearch);var _this = _possibleConstructorReturn(this, (NumberSearch.__proto__ || Object.getPrototypeOf(NumberSearch)).call(this, props));_this.renderPhone = function (item) {
      // return (
      //     (item.phone
      //         .map(item =>
      //             item.label && item.label !== item.number
      //                 ? `${item.label} ${item.number}`
      //                 : item.number) || []).join('、')
      // );
      var length = (item.phone || []).length;return (item.phone || []).map(function (item, index) {
        if (item.label && item.label !== item.number) {
          return index === 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { key: index }, item.label + ' ' + item.number) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index }, item.label + ' ' + item.number);
        } else {
          return length - 1 === index ? item.number : item.number + '、';
        }
      });
    };_this.state = { searchValue: '', reloadImage: imageUrl, isLoadingMore: false, isLoading: false, isValidate: false };if (_this.isPC()) {
      var keywords = _this.props.match.params.keywords;location.href = '/haoma/search?search=' + keywords;
    }_this.renderResultItem = _this.renderResultItem.bind(_this);_this.renderResult = _this.renderResult.bind(_this);_this.scrollLoading = _this.scrollLoading.bind(_this);_this.vilidateValue = _this.vilidateValue.bind(_this);return _this;
  }_createClass(NumberSearch, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var keywords;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                keywords = this.props.match.params.keywords;this.setState({ searchValue: keywords, isLoading: true });_context.next = 4;return this.props.getNumberSearchResult(_defineProperty({ search: keywords }, paramPage, 1));case 4:
                this.setState({ isLoading: false });window.addEventListener('scroll', this.scrollLoading);case 6:case 'end':
                return _context.stop();}
          }
        }, _callee, this);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'vilidateValue', value: function vilidateValue(e) {
      var _this2 = this;e.preventDefault();var value = (this.input.value || '').trim();if (value === '') {
        return;
      }var numberSearchResult = this.props.numberSearchResult || {};Object(__WEBPACK_IMPORTED_MODULE_7__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/phone/verifty', {}, { id: numberSearchResult.params && numberSearchResult.params.key_id, captcha: value }, function (data) {
        if (data.data && data.data.status === 0 && data.data.data && data.data.data.status) {
          _this2.setState({ isLoading: true });if (numberSearchResult.params && numberSearchResult.params.request_page > 1) {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
          }_this2.props.getNumberSearchResult(_defineProperty({ search: _this2.state.searchValue }, paramPage, 1)).then(function () {
            _this2.setState({ isLoading: false });
          }).catch(function () {
            _this2.setState({ isLoading: false });
          });
        } else if (_this2.input) {
          _this2.input.value = '';
        }_this2.setState(function () {
          return { reloadImage: imageUrl + '?t=' + Date.now() };
        });
      });
    } }, { key: 'uploadData', value: function uploadData() {
      try {
        Object(__WEBPACK_IMPORTED_MODULE_7__util__["a" /* bAntiBotSend */])();
      } catch (e) {
        return;
      }
    } }, { key: 'scrollLoading', value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var scrollTop, clientHeight, _props, match, numberSearchResult, keywords, curPage, total, perPage, maxPage, isMore, _props$getNumberSearc2;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                if (!this.loading) {
                  _context2.next = 16;break;
                }scrollTop = document.documentElement.scrollTop || document.body.scrollTop;clientHeight = document.documentElement.clientHeight || document.body.clientHeight;_props = this.props, match = _props.match, numberSearchResult = _props.numberSearchResult;keywords = match.params.keywords;curPage = Number(numberSearchResult.curr_page) || 1;total = numberSearchResult.total;perPage = numberSearchResult.per_page;maxPage = Math.ceil(total / perPage); // 大于300条以后无限滚动
                isMore = total >= 300 ? true : curPage < maxPage;if (!(clientHeight + 100 + scrollTop >= this.loading.offsetTop && !this.state.isLoadingMore && isMore)) {
                  _context2.next = 16;break;
                }this.uploadData();this.setState({ isLoadingMore: true });_context2.next = 15;return this.props.getNumberSearchResult((_props$getNumberSearc2 = { search: keywords }, _defineProperty(_props$getNumberSearc2, paramPage, curPage + 1), _defineProperty(_props$getNumberSearc2, 'isMore', true), _defineProperty(_props$getNumberSearc2, 'position', numberSearchResult.params && numberSearchResult.params.position), _props$getNumberSearc2));case 15:
                this.setState({ isLoadingMore: false });case 16:case 'end':
                return _context2.stop();}
          }
        }, _callee2, this);
      }));function scrollLoading() {
        return _ref2.apply(this, arguments);
      }return scrollLoading;
    }() }, { key: 'renderResultItem', value: function renderResultItem(item, index) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, className: 'result-search-item' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'result-search-icon' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: item.logourl ? item.logourl : __webpack_require__(720), style: item.logourl ? { borderRadius: '50%' } : null, alt: 'phone-icon' })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'result-search-title' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'result-search-title-h1' }, item && item.name), authEnum.done === (item && item.status) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'result-search-title-auth' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(721), alt: 'auth' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u5DF2\u901A\u8FC7\u767E\u5EA6\u5B89\u5168\u53F7\u7801\u9A8C\u8BC1')), !!item && !!item.phone && item.phone.length > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'result-search-title-h2' }, '\u53F7\u7801\uFF1A', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, this.renderPhone(item))), !!item && !!item.address && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'result-search-title-h2' }, '\u5730\u5740\uFF1A', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, item.address))));
    } }, { key: 'renderNoResult', value: function renderNoResult() {
      var numberSearchResult = this.props.numberSearchResult || {};if (this.state.isLoading) {
        return null;
      }if (numberSearchResult.list && (numberSearchResult.list.length > 0 || !!numberSearchResult.list.locate)) {
        return null;
      }return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'no-result' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(251), alt: 'warning' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', null, '\u62B1\u6B49\uFF0C\u65E0\u8BE5\u5185\u5BB9\u4FE1\u606F'));
    } }, { key: 'renderValidation', value: function renderValidation() {
      var _this3 = this;if (this.state.isLoading) {
        return null;
      }return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'verification' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(251), alt: 'warning' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', null, '\u8BF7\u9A8C\u8BC1\u4E00\u4E0B\uFF0C\u6211\u4E0D\u662F\u673A\u5668\u4EBA'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'verification-img', onClick: function onClick() {
          _this3.setState(function () {
            return { reloadImage: imageUrl + '?t=' + Date.now() };
          });
        } }, this.state.reloadImage && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: this.state.reloadImage, alt: 'warning' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u5237\u65B0\u9A8C\u8BC1\u7801')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'verification-input' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form', { onSubmit: this.vilidateValue }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801', ref: function ref(input) {
          return _this3.input = input;
        }, type: 'text' }))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { onClick: this.vilidateValue, className: 'verification-btn' }, '\u9A8C\u8BC1'));
    } }, { key: 'renderResult', value: function renderResult() {
      var _this4 = this;var numberSearchResult = this.props.numberSearchResult;if (this.state.isLoading) {
        return null;
      }if (numberSearchResult.status !== statusEnum.normal) {
        return null;
      }if (numberSearchResult.list && 'status' in numberSearchResult.list) {
        var numberSearchResultList = numberSearchResult.list || {};var locate = numberSearchResultList.locate;if (!locate) {
          return null;
        }return this.renderResultItem({ name: locate, phone: [{ number: this.state.searchValue, label: this.state.searchValue }] });
      }if (numberSearchResult.list.length <= 0) {
        return null;
      }return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, numberSearchResult.list && numberSearchResult.list.map(this.renderResultItem), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { ref: function ref(loading) {
          return _this4.loading = loading;
        }, className: 'result-loading' }, this.state.isLoadingMore && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'loding-btn' })));
    } }, { key: 'render', value: function render() {
      var searchValue = this.state.searchValue;var numberSearchResult = this.props.numberSearchResult || {};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'number-search-result' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: '/m/haoma/search' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'result-search' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_searchBar__["a" /* default */], { isShowClear: false, disabled: true, value: searchValue }))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'result-search-container' }, this.state.isLoading && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Spin__["a" /* default */], null), !numberSearchResult.is_auth && this.renderNoResult(), !numberSearchResult.is_auth && numberSearchResult.status === statusEnum.normal && this.renderResult(), !!numberSearchResult.is_auth && this.renderValidation()));
    } }]);return NumberSearch;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]), _class.propTypes = { match: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, getNumberSearchResult: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, getCaptchaImage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, numberSearchResult: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, capgchaImage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state) {
  return { numberSearchResult: state.numberSearchResult };
}, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])({ getNumberSearchResult: __WEBPACK_IMPORTED_MODULE_8__actions_numberAuthAction__["c" /* getNumberSearchResult */] }, dispatch);
})(NumberSearch));

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_phone.6d57b0f0.svg";

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_yirenzheng.d798af85.svg";

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NumberCommon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_numberAuthAction__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_less__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 常用号码详情页
  * @author: wence
  */var NumberCommon = (_temp = _class = function (_PureComponent) {
  _inherits(NumberCommon, _PureComponent);function NumberCommon(props) {
    _classCallCheck(this, NumberCommon);var _this = _possibleConstructorReturn(this, (NumberCommon.__proto__ || Object.getPrototypeOf(NumberCommon)).call(this, props));_this.state = { activeIndex: 0, isShowDrapdown: false, openDetailsIndexs: [], fixed: false };_this.tabItemLefts = [];_this.setSrollLeft = _this.setSrollLeft.bind(_this);_this.fetchDetail = _this.fetchDetail.bind(_this);if (_this.isPC()) {
      var id = _this.props.match.params.id;location.href = id ? '/haoma/common?id=' + id : '/haoma/common';
    }return _this;
  }_createClass(NumberCommon, [{ key: 'componentDidMount', value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _this2 = this;var id, list, curListIds, index;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                id = this.props.match.params.id;_context.next = 3;return this.props.getNumberCommonList();case 3:
                list = this.props.numberCommonList || [];curListIds = list.map(function (item) {
                  return item.id;
                });index = curListIds.indexOf(id) || 0;_context.next = 8;return this.fetchDetail(list, index);case 8:
                this.setState({ activeIndex: index });this.setSrollLeft(index);setTimeout(function () {
                  _this2.setState({ fixed: true });
                }, 100);case 11:case 'end':
                return _context.stop();}
          }
        }, _callee, this);
      }));function componentDidMount() {
        return _ref.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
      this.setState({ fixed: false });
    } }, { key: 'fetchDetail', value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(list, index) {
        var curId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                curId = (list[index] || list[0] || {}).id;_context2.next = 3;return this.props.getNumberCommonInfo(curId);case 3:
                // 修复某些浏览器tab不显示问题
                if (this.isMount) {
                  document.documentElement.scrollTop = document.body.scrollTop = 0;
                }this.isMount = true;case 5:case 'end':
                return _context2.stop();}
          }
        }, _callee2, this);
      }));function fetchDetail(_x, _x2) {
        return _ref2.apply(this, arguments);
      }return fetchDetail;
    }() }, { key: 'setSrollLeft', value: function setSrollLeft(index) {
      this.tab.scrollLeft = this.tabItemLefts[index - 2] || 0;
    } }, { key: 'onChangeId', value: function onChangeId(activeIndex) {
      this.setState({ activeIndex: activeIndex, openDetailsIndexs: [] });this.fetchDetail(this.props.numberCommonList, activeIndex);
    } }, { key: 'onChangeDrapdownId', value: function onChangeDrapdownId(activeIndex) {
      this.setSrollLeft(activeIndex);this.setState({ activeIndex: activeIndex, isShowDrapdown: false, openDetailsIndexs: [] });this.fetchDetail(this.props.numberCommonList, activeIndex);
    } }, { key: 'openDetails', value: function openDetails(openIndex, disabled) {
      if (disabled) {
        return;
      }var curOpenIndex = [].concat(this.state.openDetailsIndexs);var index = curOpenIndex.indexOf(openIndex);if (index >= 0) {
        curOpenIndex.splice(index, 1);
      } else {
        curOpenIndex.push(openIndex);
      }this.setState({ openDetailsIndexs: curOpenIndex });
    } }, { key: 'getName', value: function getName(item) {
      var details = item && item.details || [];if (!item.urldesc && !item.strip_url && details.length === 1 && details[0] && details[0].number) {
        return item.name + '-' + (details[0] && details[0].number);
      }return item.name;
    } }, { key: 'render', value: function render() {
      var _this3 = this;var list = this.props.numberCommonList || [];var content = this.props.numberCommonInfo || [];var contentItem = content[0];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'number-common' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'number-common-content' }, !!contentItem && !!contentItem.dial && contentItem.dial.length > 0 && contentItem.dial.map(function (item, index) {
        var hasOpened = _this3.state.openDetailsIndexs.indexOf(index) >= 0;var details = item && item.details || [];var length = item.urldesc && item.strip_url ? details.length + 1 : details.length;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('item-wrapper', { active: hasOpened }) }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { onClick: _this3.openDetails.bind(_this3, index, details.length <= 1 && !item.urldesc && !item.strip_url), className: 'number-common-content-item' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: item.iconurl, alt: 'icon' }), _this3.getName(item), length > 1 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { className: 'arrow', alt: 'icon', src: __webpack_require__(446) })), length > 1 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'number-common-content-detail' }, item.details.map(function (detailsItem, index) {
          if (detailsItem.label && detailsItem.number) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', { key: index }, detailsItem.label + '-' + detailsItem.number);
          }if (detailsItem.label) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', { key: index }, detailsItem.label);
          }if (detailsItem.number) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', { key: index }, detailsItem.number);
          }return null;
        }), item.urldesc && item.strip_url && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', null, item.urldesc + '-', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { className: 'detail-des', target: '_blank', href: item.url }, item.strip_url))));
      })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('number-common-tab', { fixed: this.state.fixed }) }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { ref: function ref(tab) {
          return _this3.tab = tab;
        }, className: 'number-common-tab-container' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul', null, list.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li', { ref: function ref(tabItem) {
            if (tabItem) {
              _this3.tabItemLefts[index] = tabItem.offsetLeft;
            }
          }, key: item.id, onClick: _this3.onChangeId.bind(_this3, index), className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('number-common-tab-item', { active: _this3.state.activeIndex === index }) }, item.name);
      }))), list.length - 1 !== this.state.activeIndex && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'shadow' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { onClick: function onClick() {
          return _this3.setState({ isShowDrapdown: true });
        }, className: 'number-common-tab-folder-btn' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img', { src: __webpack_require__(724), alt: 'number' }))), this.state.isShowDrapdown && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'drapdown' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'mask', onClick: function onClick() {
          return _this3.setState({ isShowDrapdown: false });
        } }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('ul', { className: 'drapdown-content' }, list.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('li', { className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()({ active: _this3.state.activeIndex === index }), key: item.id, onClick: _this3.onChangeDrapdownId.bind(_this3, index) }, item.name);
      }))));
    } }]);return NumberCommon;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]), _class.propTypes = { getNumberCommonList: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, getNumberCommonInfo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, numberCommonInfo: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, numberCommonList: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, match: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function (state) {
  return { numberCommonList: state.numberCommonList, numberCommonInfo: state.numberCommonInfo };
}, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({ getNumberCommonList: __WEBPACK_IMPORTED_MODULE_6__actions_numberAuthAction__["b" /* getNumberCommonList */], getNumberCommonInfo: __WEBPACK_IMPORTED_MODULE_6__actions_numberAuthAction__["a" /* getNumberCommonInfo */] }, dispatch);
})(NumberCommon));

/***/ }),
/* 723 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_changyonghaoma.6fe94d63.svg";

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guidePage_less__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__guidePage_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__guidePage_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file:
  * @author: wence
  */var GuidePage = (_temp = _class = function (_PureComponent) {
  _inherits(GuidePage, _PureComponent);function GuidePage(props) {
    _classCallCheck(this, GuidePage);var _this = _possibleConstructorReturn(this, (GuidePage.__proto__ || Object.getPrototypeOf(GuidePage)).call(this, props));if (_this.isPC()) {
      var url = '/haoma/guide' + location.search;window.location.href = url;
    }return _this;
  }_createClass(GuidePage, [{ key: 'componentDidMount', value: function componentDidMount() {
      window.onpageshow = function (event) {
        if (event.persisted) {
          window.location.reload();
        }
      };
    } }, { key: 'componentWillMount', value: function componentWillMount() {
      window.onpageshow = null;
    } }, { key: 'pushUrl', value: function pushUrl(url) {
      window.location.href = this.props.isLogin ? url : this.loginUrl(url);
    } }, { key: 'render', value: function render() {
      var phone = this.getParams().phone || '';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'number-guide' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'number-guide-tips' }, '\u6E29\u99A8\u63D0\u793A'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'number-guide-des' }, '\u53F7\u7801\u7533\u8BC9\u548C\u4E3E\u62A5\u9700\u8981\u5728\u767B\u5F55\u72B6\u6001\u4E0B\u624D\u80FD\u529E\u7406\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'number-guide-des' }, '\u60A8\u53EF\u4EE5\u70B9\u51FB\u754C\u9762\u53F3\u4E0A\u89D2', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(222), alt: 'logo' }), '\u770B\u548C\u7BA1\u7406\u767B\u5F55\u72B6\u6001\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.pushUrl.bind(this, '/m/haoma/report?phone=' + phone), className: 'number-options-card first-card' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'card-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(225), alt: 'icon' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'card-title' }, '\u9A9A\u6270\u7535\u8BDD\u4E3E\u62A5'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'card-btn' }, '\u7ACB\u5373\u4E3E\u62A5')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.pushUrl.bind(this, '/m/haoma/appeal/company?phone=' + phone + '&selectType=2'), className: 'number-options-card' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'card-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(223), alt: 'icon' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'card-title' }, '\u4F01\u4E1A\u53F7\u7801\u7533\u8BC9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'card-btn' }, '\u7ACB\u5373\u7533\u8BC9')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { onClick: this.pushUrl.bind(this, '/m/haoma/appeal/person?phone=' + phone + '&selectType=2'), className: 'number-options-card last-card' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'card-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(224), alt: 'icon' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'card-title' }, '\u4E2A\u4EBA\u53F7\u7801\u7533\u8BC9'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'card-btn' }, '\u7ACB\u5373\u7533\u8BC9')));
    } }]);return GuidePage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { isLogin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, match: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
  return { isLogin: state.userLoginstate && state.userLoginstate.status === 0 };
})(GuidePage));

/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_toast_style_css__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_toast__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_numberOptionsActions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__numberReport_less__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__numberReport_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__numberReport_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__formCom__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(57);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: number report
  * @author: wence
  */var NumberReport = (_temp = _class = function (_PureComponent) {
  _inherits(NumberReport, _PureComponent);function NumberReport(props) {
    var _this2 = this;_classCallCheck(this, NumberReport);var _this = _possibleConstructorReturn(this, (NumberReport.__proto__ || Object.getPrototypeOf(NumberReport)).call(this, props));_this.validate = [];_this.onChange = function (key, value) {
      _this.setState({ params: Object.assign({}, _this.state.params, _defineProperty({}, key, value)) });
    };_this.onBlur = function () {
      if (_this.isIOS) {
        _this.setState({ fixed: false });document.querySelector('.nav-bar').style.position = '';
      }
    };_this.onFocus = function () {
      if (_this.isIOS) {
        _this.setState({ fixed: true });document.querySelector('.nav-bar').style.position = 'absolute';
      }
    };_this.onSubmit = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var canSubmit, reportRes;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              canSubmit = true;_this.validate.map(function (fn) {
                var vilidate = fn();if (vilidate.validate && canSubmit) {
                  canSubmit = false;
                }
              });if (!canSubmit) {
                _context.next = 7;break;
              }_context.next = 5;return _this.props.postNumberReport(_this.state.params);case 5:
              reportRes = _this.props.reportRes;if (reportRes.status === 0) {
                window.location.href = '/m/haoma/success/report';
              } else if (reportRes.status === 401) {
                window.location.href = _this.loginUrl();
              } else {
                if (reportRes && reportRes.description) {
                  __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_toast___default.a.info(reportRes.description, 2);
                }_this.codePic.resetCode();_this.resetCaptcha();
              }case 7:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2);
    }));_this.resetCaptcha = function () {
      _this.setState({ params: Object.assign({}, _this.state.params, { captcha: '' }) });
    };_this.pushValidate = function (node) {
      if (node) {
        _this.validate.push(node.validate);
      }
    };_this.state = { params: { type: '1', phone: _this.getParams().phone || '' } };if (_this.isPC()) {
      window.location.href = '/console/#/reportNumber?phone=' + (_this.getParams().phone || '');
    }return _this;
  }_createClass(NumberReport, [{ key: 'componentDidUpdate', value: function componentDidUpdate(nextProps) {
      if (nextProps.userInfo !== this.props.userInfo && this.props.userInfo && this.props.userInfo.status !== 0) {
        var url = location.pathname + location.search;var phone = this.getParams().phone;window.location.href = '/m/haoma/guide?url=' + encodeURIComponent(url) + '&phone=' + (phone || '');
      }
    } }, { key: 'render', value: function render() {
      var _this3 = this;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'number-report' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'number-report-title' }, '\u9A9A\u6270\u7535\u8BDD\u4E3E\u62A5'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'number-report-wrapper' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'form' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__formCom__["b" /* FormItem */], { isRequire: true, value: this.state.params.phone, onChange: this.onChange.bind(this, 'phone'), className: 'first-form-item', type: 'input', des: '\u8BF7\u52FF\u8F93\u5165\u7A7A\u683C\u3001\u8FDE\u5B57\u7B26\u7B49\u7279\u6B8A\u5B57\u7B26\u3001\u5EA7\u673A\u8BF7\u52A0\u533A\u53F7', label: '\u4E3E\u62A5\u53F7\u7801\uFF1A', placeholder: '\u8BF7\u8F93\u5165\u5EA7\u673A\u3001\u624B\u673A\u3001400\u53F7\u7801', comClassName: 'form-input', ref: this.pushValidate, onBlur: this.onBlur, onFocus: this.onFocus, rules: [Object(__WEBPACK_IMPORTED_MODULE_10__utils__["f" /* validateRequire */])('举报号码'), { validate: function validate(value) {
            var re = /^\d{6,25}$/;return !re.test(value);
          }, message: '号码格式不正确！' }] }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__formCom__["b" /* FormItem */], { isRequire: true, type: 'select', label: '\u53F7\u7801\u7C7B\u578B\uFF1A', title: '\u53F7\u7801\u7C7B\u578B', ref: this.pushValidate, value: this.state.params.type, onChange: this.onChange.bind(this, 'type'), onBlur: this.onBlur, onFocus: this.onFocus, data: [{ label: '诈骗电话', value: 1 }, { label: '保险电话', value: 2 }, { label: '金融理财', value: 3 }, { label: '中介电话', value: 4 }, { label: '猎头电话', value: 5 }, { label: '广告媒介', value: 6 }, { label: '外卖送餐', value: 7 }, { label: '快递公司', value: 8 }, { label: '骚扰电话', value: 10 }, { label: '违法电话', value: 11 }], rules: [Object(__WEBPACK_IMPORTED_MODULE_10__utils__["f" /* validateRequire */])('号码类型')] }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__formCom__["b" /* FormItem */], { type: 'textarea', label: '\u4E3E\u62A5\u539F\u56E0\uFF1A', value: this.state.params.reason, onChange: this.onChange.bind(this, 'reason'), placeholder: '\u8BF7\u7B80\u8981\u63CF\u8FF0\u4E3E\u62A5\u539F\u56E0\uFF08100\u5B57\u4EE5\u5185\uFF09', rows: 3, ref: this.pushValidate, comClassName: 'form-textarea', rules: [Object(__WEBPACK_IMPORTED_MODULE_10__utils__["c" /* validateMax */])('举报原因', 100)], onBlur: this.onBlur, onFocus: this.onFocus }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__formCom__["b" /* FormItem */], { type: 'input', label: '\u8054\u7CFB\u90AE\u7BB1\uFF1A', comClassName: 'form-input', value: this.state.params.email, onChange: this.onChange.bind(this, 'email'), placeholder: '\u8BF7\u8F93\u5165\u60A8\u7684\u90AE\u7BB1', ref: this.pushValidate, rules: Object(__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* validateEmail */])(), onBlur: this.onBlur, onFocus: this.onFocus }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__formCom__["b" /* FormItem */], { type: 'input', label: '\u9A8C\u8BC1\u7801\uFF1A', comClassName: 'form-input code', value: this.state.params.captcha, onChange: this.onChange.bind(this, 'captcha'), placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801', ref: this.pushValidate, rules: [Object(__WEBPACK_IMPORTED_MODULE_10__utils__["f" /* validateRequire */])('验证码')], renderRight: function renderRight() {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__formCom__["a" /* CodePic */], { resetCaptcha: _this3.resetCaptcha, ref: function ref(codePic) {
              return _this3.codePic = codePic;
            } });
        }, onBlur: this.onBlur, onFocus: this.onFocus })), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { onClick: this.onSubmit, className: 'number-options-btn' }, '\u63D0\u4EA4\u4E3E\u62A5'))));
    } }]);return NumberReport;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]), _class.propTypes = { postNumberReport: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, reportRes: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, match: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, userInfo: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(function (state) {
  return { reportRes: state.postNumberReport, userInfo: state.userLoginstate };
}, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({ postNumberReport: __WEBPACK_IMPORTED_MODULE_7__actions_numberOptionsActions__["d" /* postNumberReport */] }, dispatch);
})(NumberReport));

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(729);

/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Notification__ = __webpack_require__(732);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Notification__["a" /* default */]);

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_animate__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Notice__ = __webpack_require__(741);















var seed = 0;
var now = Date.now();

function getUuid() {
  return 'rcNotification_' + now + '_' + seed++;
}

var Notification = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Notification, _Component);

  function Notification() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Notification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      notices: []
    }, _this.add = function (notice) {
      var key = notice.key = notice.key || getUuid();
      _this.setState(function (previousState) {
        var notices = previousState.notices;
        if (!notices.filter(function (v) {
          return v.key === key;
        }).length) {
          return {
            notices: notices.concat(notice)
          };
        }
      });
    }, _this.remove = function (key) {
      _this.setState(function (previousState) {
        return {
          notices: previousState.notices.filter(function (notice) {
            return notice.key !== key;
          })
        };
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Notification, [{
    key: 'getTransitionName',
    value: function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;
      if (!transitionName && props.animation) {
        transitionName = props.prefixCls + '-' + props.animation;
      }
      return transitionName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _className;

      var props = this.props;
      var noticeNodes = this.state.notices.map(function (notice) {
        var onClose = Object(__WEBPACK_IMPORTED_MODULE_11_rc_util_es_createChainedFunction__["a" /* default */])(_this2.remove.bind(_this2, notice.key), notice.onClose);
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_13__Notice__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
            prefixCls: props.prefixCls
          }, notice, {
            onClose: onClose
          }),
          notice.content
        );
      });
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.prefixCls, 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_12_classnames___default()(className), style: props.style },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_10_rc_animate__["a" /* default */],
          { transitionName: this.getTransitionName() },
          noticeNodes
        )
      );
    }
  }]);

  return Notification;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Notification.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  animation: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object]),
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object
};
Notification.defaultProps = {
  prefixCls: 'rmc-notification',
  animation: 'fade',
  style: {
    top: 65,
    left: '50%'
  }
};


Notification.newInstance = function newNotificationInstance(properties, callback) {
  var _ref2 = properties || {},
      getContainer = _ref2.getContainer,
      props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['getContainer']);

  var div = void 0;
  if (getContainer) {
    div = getContainer();
  } else {
    div = document.createElement('div');
    document.body.appendChild(div);
  }
  var called = false;
  function ref(notification) {
    if (called) {
      return;
    }
    called = true;
    callback({
      notice: function notice(noticeProps) {
        notification.add(noticeProps);
      },
      removeNotice: function removeNotice(key) {
        notification.remove(key);
      },

      component: notification,
      destroy: function destroy() {
        __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.unmountComponentAtNode(div);
        if (!getContainer) {
          document.body.removeChild(div);
        }
      }
    });
  }
  __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Notification, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, props, { ref: ref })), div);
};

/* harmony default export */ __webpack_exports__["a"] = (Notification);

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(254);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(253);
} catch (err) {
  var index = __webpack_require__(253);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);

  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);









var Notice = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Notice, _Component);

  function Notice() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Notice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Notice.__proto__ || Object.getPrototypeOf(Notice)).call.apply(_ref, [this].concat(args))), _this), _this.close = function () {
      _this.clearCloseTimer();
      _this.props.onClose();
    }, _this.startCloseTimer = function () {
      if (_this.props.duration) {
        _this.closeTimer = setTimeout(function () {
          _this.close();
        }, _this.props.duration * 1000);
      }
    }, _this.clearCloseTimer = function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Notice, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _className;

      var props = this.props;
      var componentClass = props.prefixCls + '-notice';
      var className = (_className = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, '' + componentClass, 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, componentClass + '-closable', props.closable), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_className, props.className, !!props.className), _className);
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className), style: props.style },
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'div',
          { className: componentClass + '-content' },
          props.children
        ),
        props.closable ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          'a',
          { tabIndex: '0', onClick: this.close, className: componentClass + '-close' },
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: componentClass + '-close-x' })
        ) : null
      );
    }
  }]);

  return Notice;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Notice.propTypes = {
  duration: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  onClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};
Notice.defaultProps = {
  onEnd: function onEnd() {},
  onClose: function onClose() {},

  duration: 1.5,
  style: {
    right: '50%'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Notice);

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(6);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(7);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(8);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(9);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _loadSprite = __webpack_require__(743);

var _loadSprite2 = _interopRequireDefault(_loadSprite);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Icon = function (_React$Component) {
    (0, _inherits3['default'])(Icon, _React$Component);

    function Icon() {
        (0, _classCallCheck3['default'])(this, Icon);
        return (0, _possibleConstructorReturn3['default'])(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Icon, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _loadSprite2['default'])();
        }
    }, {
        key: 'render',
        value: function render() {
            var _a = this.props,
                type = _a.type,
                className = _a.className,
                size = _a.size,
                restProps = __rest(_a, ["type", "className", "size"]);
            var cls = (0, _classnames2['default'])(className, 'am-icon', 'am-icon-' + type, 'am-icon-' + size);
            return React.createElement(
                'svg',
                (0, _extends3['default'])({ className: cls }, restProps),
                React.createElement('use', { xlinkHref: '#' + type })
            );
        }
    }]);
    return Icon;
}(React.Component);

exports['default'] = Icon;

Icon.defaultProps = {
    size: 'md'
};
module.exports = exports['default'];

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* tslint:disable:max-line-length */
// inspried by https://github.com/kisenka/svg-sprite-loader/blob/master/runtime/browser-sprite.js
// Much simplified, do make sure run this after document ready
var svgSprite = function svgSprite(contents) {
    return '\n  <svg\n    xmlns="http://www.w3.org/2000/svg"\n    xmlns:xlink="http://www.w3.org/1999/xlink"\n    id="__ANTD_MOBILE_SVG_SPRITE_NODE__"\n    style="display:none;overflow:hidden;width:0;height:0"\n  >\n    <defs>\n      ' + contents + '\n    </defs>\n  </svg>\n';
};
// both minified by https://github.com/svg/svgo
var icons = {
    check: '<svg viewBox="0 0 44 44"><path fill-rule="evenodd" d="M34.538 8L38 11.518 17.808 32 8 22.033l3.462-3.518 6.346 6.45z"/></svg>',
    'check-circle': '<svg viewBox="0 0 48 48"><path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zM13.1 23.2l-2.2 2.1 10 9.9L38.1 15l-2.2-2-15.2 17.8-7.6-7.6z" fill-rule="evenodd"/></svg>',
    'check-circle-o': '<svg viewBox="0 0 48 48"><g fill-rule="evenodd"><path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z"/><path d="M12.2 23.2L10 25.3l10 9.9L37.2 15 35 13 19.8 30.8z"/></g></svg>',
    cross: '<svg viewBox="0 0 44 44"><path fill-rule="evenodd" d="M24.008 21.852l8.97-8.968L31.092 11l-8.97 8.968L13.157 11l-1.884 1.884 8.968 8.968-9.24 9.24 1.884 1.885 9.24-9.24 9.24 9.24 1.885-1.884-9.24-9.24z"/></svg>',
    'cross-circle': '<svg viewBox="0 0 48 48"><g fill-rule="evenodd"><path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z"/><path d="M24.34 22.22l-7.775-7.775a1.5 1.5 0 1 0-2.12 2.12l7.773 7.775-7.774 7.775a1.5 1.5 0 1 0 2.12 2.12l7.775-7.773 7.774 7.774a1.5 1.5 0 1 0 2.12-2.12L26.46 24.34l7.774-7.774a1.5 1.5 0 1 0-2.12-2.12l-7.776 7.773z"/></g></svg>',
    'cross-circle-o': '<svg viewBox="0 0 48 48"><path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm.353-25.77l-7.593-7.593c-.797-.8-1.538-.822-2.263-.207-.724.614-.56 1.617-.124 2.067l7.852 7.847-7.72 7.723c-.727.728-.56 1.646-.066 2.177.493.532 1.553.683 2.31-.174l7.588-7.584 7.644 7.623c.796.798 1.608.724 2.21.145.605-.58.72-1.442-.074-2.24l-7.657-7.67 7.545-7.52c.81-.697.9-1.76.297-2.34-.92-.885-1.85-.338-2.264.078l-7.685 7.667z" fill-rule="evenodd"/></svg>',
    // Todo: simplify direction to 2, use css transform
    left: '<svg viewBox="0 0 44 44"><defs><path id="a" d="M-129-845h24v24h-24z"/></defs><clipPath id="b"><use xlink:href="#a" overflow="visible"/></clipPath><g clip-path="url(#b)"><defs><path id="c" d="M-903-949H947V996H-903z"/></defs></g><path d="M16.247 21.4L28.48 9.165l2.12 2.12-10.117 10.12L30.6 31.524l-2.12 2.12-12.233-12.232.007-.006z"/></svg>',
    right: '<svg viewBox="0 0 44 44"><defs><path id="a" d="M-129-845h24v24h-24z"/></defs><clipPath id="b"><use xlink:href="#a" overflow="visible"/></clipPath><g clip-path="url(#b)"><defs><path id="c" d="M-903-949H947V996H-903z"/></defs></g><path d="M30.6 21.4L18.37 9.165l-2.12 2.12 10.117 10.12-10.118 10.118 2.12 2.12 12.234-12.232-.005-.006z"/></svg>',
    down: '<svg viewBox="0 0 44 44"><path d="M22.355 28.237l-11.483-10.9c-.607-.576-1.714-.396-2.48.41l.674-.71c-.763.802-.73 2.07-.282 2.496l11.37 10.793-.04.04 2.088 2.195L23.3 31.52l12.308-11.682c.447-.425.48-1.694-.282-2.496l.674.71c-.766-.806-1.873-.986-2.48-.41L22.355 28.237z" fill-rule="evenodd"/></svg>',
    up: '<svg viewBox="0 0 44 44"><path fill="none" d="M-1-1h46v46H-1z"/><defs><path id="a" d="M-129-845h24v24h-24z"/></defs><clipPath id="b"><use xlink:href="#a"/></clipPath><g clip-path="url(#b)"><defs><path id="c" d="M-903-949H947V996H-903z"/></defs></g><path d="M23.417 14.23L11.184 26.46l2.12 2.12 10.12-10.117 10.118 10.118 2.12-2.12L23.43 14.228l-.006.005z"/></svg>',
    loading: '<svg viewBox="0 -2 59.75 60.25"><path fill="#ccc" d="M29.69-.527C14.044-.527 1.36 12.158 1.36 27.806S14.043 56.14 29.69 56.14c15.65 0 28.334-12.686 28.334-28.334S45.34-.527 29.69-.527zm.185 53.75c-14.037 0-25.417-11.38-25.417-25.417S15.838 2.39 29.875 2.39s25.417 11.38 25.417 25.417-11.38 25.416-25.417 25.416z"/><path fill="none" stroke="#108ee9" stroke-width="3" stroke-linecap="round" stroke-miterlimit="10" d="M56.587 29.766c.37-7.438-1.658-14.7-6.393-19.552"/></svg>',
    search: '<svg viewBox="0 0 44 44"><path d="M32.98 29.255l8.915 8.293L39.603 40l-8.86-8.242a15.952 15.952 0 0 1-10.753 4.147C11.16 35.905 4 28.763 4 19.952 4 11.142 11.16 4 19.99 4s15.99 7.142 15.99 15.952c0 3.472-1.112 6.685-3 9.303zm.05-9.21c0 7.123-5.7 12.918-12.88 12.918-7.176 0-13.015-5.795-13.015-12.918 0-7.12 5.84-12.917 13.017-12.917 7.178 0 12.88 5.797 12.88 12.917z" fill-rule="evenodd"/></svg>',
    ellipsis: '<svg viewBox="0 0 44 44"><circle cx="21.888" cy="22" r="4.045"/><circle cx="5.913" cy="22" r="4.045"/><circle cx="37.863" cy="22" r="4.045"/></svg>',
    'ellipsis-circle': '<svg viewBox="0 0 44 44"><g fill-rule="evenodd"><path d="M22.13.11C10.05.11.255 9.902.255 21.983S10.05 43.86 22.13 43.86s21.875-9.795 21.875-21.876S34.21.11 22.13.11zm0 40.7c-10.396 0-18.825-8.43-18.825-18.826S11.735 3.16 22.13 3.16c10.396 0 18.825 8.428 18.825 18.824S32.525 40.81 22.13 40.81z"/><circle cx="21.888" cy="22.701" r="2.445"/><circle cx="12.23" cy="22.701" r="2.445"/><circle cx="31.546" cy="22.701" r="2.445"/></g></svg>',
    'exclamation-circle': '<svg viewBox="0 0 64 64"><path d="M59.58 40.89L41.193 9.11C39.135 5.382 35.723 3 31.387 3c-3.11 0-6.52 2.382-8.58 6.11L4.42 40.89c-2.788 4.635-3.126 8.81-1.225 12.22C5.015 56.208 7.572 58 13 58h36.773c5.428 0 9.21-1.792 11.03-4.89 1.9-3.41 1.565-7.583-1.224-12.22zm-2.452 11c-.635 1.694-3.802 2.443-7.354 2.443H13c-3.59 0-5.493-.75-6.13-2.444-1.71-2.41-1.374-5.263 0-8.557l18.387-31.777c2.116-3.168 4.394-4.89 6.13-4.89 2.96 0 5.238 1.722 7.354 4.89l18.387 31.777c1.374 3.294 1.713 6.146 0 8.556zm-25.74-33c-.405 0-1.227.835-1.227 2.443v15.89c0 1.608.823 2.444 1.227 2.444 1.628 0 2.452-.836 2.452-2.445v-15.89c0-1.607-.825-2.443-2.453-2.443zm0 23.22c-.405 0-1.227.79-1.227 1.223v2.445c0 .434.823 1.222 1.227 1.222 1.628 0 2.452-.788 2.452-1.222v-2.445c0-.434-.825-1.222-2.453-1.222z" fill-rule="evenodd"/></svg>',
    'info-circle': '<svg viewBox="0 0 44 44"><circle cx="13.828" cy="19.63" r="1.938"/><circle cx="21.767" cy="19.63" r="1.938"/><circle cx="29.767" cy="19.63" r="1.938"/><path d="M22.102 4.16c-9.918 0-17.958 7.147-17.958 15.962 0 4.935 2.522 9.345 6.48 12.273v5.667l.04.012a2.627 2.627 0 1 0 4.5 1.455h.002l5.026-3.54c.628.06 1.265.094 1.91.094 9.92 0 17.96-7.146 17.96-15.96C40.06 11.306 32.02 4.16 22.1 4.16zm-.04 29.902c-.902 0-1.78-.08-2.642-.207l-5.882 4.234c-.024.024-.055.04-.083.06l-.008.005a.51.51 0 0 1-.284.095.525.525 0 0 1-.525-.525l.005-6.375c-3.91-2.516-6.456-6.544-6.456-11.1 0-7.628 7.107-13.812 15.875-13.812s15.875 6.184 15.875 13.812-7.107 13.812-15.875 13.812z"/></svg>',
    'question-circle': '<svg viewBox="0 0 44 44"><g fill-rule="evenodd"><path d="M21.186 3c-10.853 0-19.36 8.506-19.36 19.358C1.827 32.494 10.334 41 21.187 41c10.133 0 18.64-8.506 18.64-18.642C39.827 11.506 31.32 3 21.187 3m15.64 19c0 8.823-7.178 16-16 16s-16-7.177-16-16 7.178-16 16-16 16 7.177 16 16z"/><path d="M22.827 31.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m4-15.48c0 .957-.203 1.822-.61 2.593-.427.792-1.117 1.612-2.073 2.457-.867.734-1.453 1.435-1.754 2.096-.302.7-.453 1.693-.453 2.98a.828.828 0 0 1-.823.854.828.828 0 0 1-.584-.22.877.877 0 0 1-.24-.635c0-1.305.168-2.38.506-3.227.336-.883.93-1.682 1.78-2.4 1.01-.883 1.71-1.692 2.1-2.428.336-.645.503-1.38.503-2.21-.02-.935-.3-1.7-.85-2.288-.655-.717-1.62-1.075-2.897-1.075-1.506 0-2.596.535-3.27 1.6-.46.754-.688 1.645-.688 2.677a.92.92 0 0 1-.266.66.747.747 0 0 1-.56.25.73.73 0 0 1-.584-.194c-.16-.164-.24-.393-.24-.69 0-1.82.585-3.272 1.755-4.357C18.645 11.486 19.928 11 21.434 11h.293c1.452 0 2.638.414 3.56 1.24 1.028.903 1.54 2.163 1.54 3.78z"/></g></svg>',
    voice: '<svg viewBox="0 0 38 33"><g fill-rule="evenodd"><path d="M17.838 28.8c-.564-.468-1.192-.983-1.836-1.496-4.244-3.385-5.294-3.67-6.006-3.67-.014 0-.027.005-.04.005-.015 0-.028-.006-.042-.006H3.562c-.734 0-.903-.203-.903-.928v-12.62c0-.49.057-.8.66-.8H9.1c.694 0 1.76-.28 6.4-3.63.83-.596 1.638-1.196 2.337-1.722V28.8zM19.682.19c-.463-.22-1.014-.158-1.417.157-.02.016-1.983 1.552-4.152 3.125C10.34 6.21 9.243 6.664 9.02 6.737H3.676c-.027 0-.053.003-.08.004H1.183c-.608 0-1.1.487-1.1 1.086V25.14c0 .598.492 1.084 1.1 1.084h8.71c.22.08 1.257.55 4.605 3.24 1.947 1.562 3.694 3.088 3.712 3.103.25.22.568.333.89.333.186 0 .373-.038.55-.116.48-.213.79-.684.79-1.204V1.38c0-.506-.294-.968-.758-1.19z" mask="url(#mask-2)"/><path d="M31.42 16.475c0-3.363-1.854-6.297-4.606-7.876-.125-.067-.42-.193-.625-.193-.613 0-1.11.488-1.11 1.09 0 .404.22.764.55.952 2.13 1.19 3.566 3.44 3.566 6.024 0 2.627-1.486 4.913-3.677 6.087-.32.19-.53.54-.53.935 0 .602.495 1.09 1.106 1.09.26.002.568-.15.568-.15 2.835-1.556 4.754-4.538 4.754-7.96" mask="url(#mask-4)"/><path d="M30.14 3.057c-.205-.122-.41-.22-.658-.22-.608 0-1.1.485-1.1 1.084 0 .434.26.78.627.978 4.042 2.323 6.76 6.636 6.76 11.578 0 4.938-2.715 9.248-6.754 11.572-.354.19-.66.55-.66.993 0 .6.494 1.085 1.102 1.085.243 0 .438-.092.65-.213 4.692-2.695 7.848-7.7 7.848-13.435 0-5.723-3.142-10.718-7.817-13.418" mask="url(#mask-6)"/></g></svg>',
    plus: '<svg viewBox="0 0 30 30"><path d="M14 14H0v2h14v14h2V16h14v-2H16V0h-2v14z" fill-rule="evenodd"/></svg>',
    minus: '<svg viewBox="0 0 30 2"><path d="M0 0h30v2H0z" fill-rule="evenodd"/></svg>',
    dislike: '<svg viewBox="0 0 72 72"><g fill="none" fill-rule="evenodd"><path d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z" fill="#FFF"/><path fill="#FFF" d="M47 22h2v6h-2zm-24 0h2v6h-2z"/><path d="M21 51s4.6-7 15-7 15 7 15 7" stroke="#FFF" stroke-width="2"/></g></svg>',
    fail: '<svg viewBox="0 0 72 72"><g fill="none" fill-rule="evenodd"><path d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z" fill="#FFF"/><path d="M22 22l28.304 28.304m-28.304 0L50.304 22" stroke="#FFF" stroke-width="2"/></g></svg>',
    success: '<svg viewBox="0 0 72 72"><g fill="none" fill-rule="evenodd"><path d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z" fill="#FFF"/><path stroke="#FFF" stroke-width="2" d="M19 34.54l11.545 11.923L52.815 24"/></g></svg>'
};
var renderSvgSprite = function renderSvgSprite() {
    var symbols = Object.keys(icons).map(function (iconName) {
        var svgContent = icons[iconName].split('svg')[1];
        return '<symbol id=' + iconName + svgContent + 'symbol>';
    }).join('');
    return svgSprite(symbols);
};
var loadSprite = function loadSprite() {
    if (!document) {
        return;
    }
    var existing = document.getElementById('__ANTD_MOBILE_SVG_SPRITE_NODE__');
    var mountNode = document.body;
    if (!existing) {
        mountNode.insertAdjacentHTML('afterbegin', renderSvgSprite());
    }
};
exports['default'] = loadSprite;
module.exports = exports['default'];

/***/ }),
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_toast_style_css__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_toast__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__formCom__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_numberOptionsActions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__numberAppeal_less__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__numberAppeal_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__numberAppeal_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 号码申诉
  * @author: wence
  */var phoneSelect = 'phone_select';var reasonSelect = 'reason_select';var otherReason = 'other_reason';var phoneTypeEnum = { tel: '1', phone: '2' };var appealTypeEnum = { person: 'person', company: 'company' };var NumberAppeal = (_temp = _class = function (_PureComponent) {
  _inherits(NumberAppeal, _PureComponent);function NumberAppeal(props) {
    var _this2 = this,
        _params;_classCallCheck(this, NumberAppeal);var _this = _possibleConstructorReturn(this, (NumberAppeal.__proto__ || Object.getPrototypeOf(NumberAppeal)).call(this, props));_this.resetCaptcha = function () {
      _this.setState({ params: Object.assign({}, _this.state.params, { captcha: '' }) });
    };_this.onChangeTabIndex = function (tabIndex) {
      _this.setState({ tabIndex: tabIndex });_this.validate = {};_this.props.history.replace('/haoma/appeal/' + tabIndex + '?selectType=' + _this.state.params[phoneSelect]);
    };_this.task = function (fn) {
      var run = true;if (run) {
        fn(function () {
          _this.timer = setTimeout(function () {
            return _this.task(fn);
          }, 1000);
        });
      }return function () {
        run = false;_this.timer = null;
      };
    };_this.sendCode = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var phoneValidate, phoneNumber, hasValidate, res;return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              phoneValidate = _this.validate.phone();phoneNumber = _this.state.params.phone;hasValidate = (_this.state.phoneList || []).some(function (item) {
                return item === phoneNumber;
              });if (!hasValidate) {
                _context.next = 6;break;
              }_this.validate.phone({ validate: true, message: '号码已在审核中！' });return _context.abrupt('return');case 6:
              if (!(phoneValidate && phoneValidate.validate)) {
                _context.next = 10;break;
              }_this.validate.code({ validate: true, message: '请输入正确的手机号' });_context.next = 15;break;case 10:
              _this.validate.code({ validate: false, message: '' });_context.next = 13;return Object(__WEBPACK_IMPORTED_MODULE_10__actions_numberOptionsActions__["e" /* validateNumberOwner */])({ action: 'mobile', type: 2, mobile: _this.state.params.phone });case 13:
              res = _context.sent;if (res.status === 0 && res.data.status === 1) {
                _this.setState({ hiddenCodeSendBtn: true, codeResendTime: 61 });_this.task(function (callback) {
                  var codeResendTime = _this.state.codeResendTime;if (codeResendTime <= 0) {
                    _this.timer = null;_this.setState({ hiddenCodeSendBtn: false });return;
                  }_this.setState({ codeResendTime: codeResendTime - 1 }, callback);
                });
              }case 15:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2);
    }));_this.addPhoneNumber = function () {
      var curValue = _this.state.phoneNumbers.slice(0);curValue.push('');_this.setState({ phoneNumbers: curValue });
    };_this.renderMorePhone = function () {
      var phoneNumbers = _this.state.phoneNumbers;var len = phoneNumbers.length;var disableAdd = len >= 4;var self = _this;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', null, phoneNumbers.map(function (phoneNumber, index) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__formCom__["b" /* FormItem */], { key: index, isRequire: true, type: 'input', noLabel: true, className: 'more-input-wrapper', placeholder: '\u8BF7\u8F93\u5165\u60A8\u8981\u7533\u8BC9\u7684\u53F7\u7801', comClassName: 'form-input more-input', renderRight: function renderRight() {
            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { onClick: _this.deleteNumber.bind(_this, index), className: 'delete-number' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img', { src: __webpack_require__(747), alt: '' }));
          }, ref: _this.pushValidate.bind(_this, 'phone' + (index + 2)), value: phoneNumber, onChange: _this.onPhoneNumberChange.bind(_this, index), onFocus: _this.getAlreadyPhoneList, onBlur: _this.onBlur, rules: [].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_9__utils__["e" /* validatePhone */])('申诉号码', true)), [{ validate: function validate(value) {
              return self.state.phoneList.some(function (item) {
                return item === value;
              });
            }, message: '号码已在审核中！' }]) });
      }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { onClick: !disableAdd ? _this.addPhoneNumber : function () {
          return null;
        }, className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('phone-number-add', { disabled: disableAdd }) }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img', { src: disableAdd ? __webpack_require__(748) : __webpack_require__(749), alt: '' }), '\u65B0\u589E\u4E00\u4E2A'));
    };_this.renderRight = function () {
      var hiddenCodeSendBtn = _this.state.hiddenCodeSendBtn;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'phone-code' }, hiddenCodeSendBtn ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'task-tips' }, _this.state.codeResendTime, '\u79D2\u540E\u91CD\u65B0\u83B7\u53D6') : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { onClick: _this.sendCode }, '\u53D1\u9001\u9A8C\u8BC1\u7801'));
    };_this.getAlreadyPhoneList = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var phoneListRes;return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _this.onFocus();_context2.next = 3;return _this.props.getAlreadyPhoneList();case 3:
              phoneListRes = _context2.sent;if (phoneListRes.status === 0) {
                _this.setState({ phoneList: phoneListRes.data });
              } else if (phoneListRes.status === 401) {
                window.location.href = _this.loginUrl();
              }case 5:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2);
    }));_this.onBlur = function () {
      if (_this.isIOS) {
        _this.setState({ fixed: false });document.querySelector('.nav-bar').style.position = '';
      }
    };_this.onFocus = function () {
      if (_this.isIOS) {
        _this.setState({ fixed: true });document.querySelector('.nav-bar').style.position = 'absolute';
      }
    };_this.getTypeData = function () {
      if (_this.state.tabIndex === appealTypeEnum.company) {
        return [{ label: '标记为诈骗、骚扰等类型', value: 4 }, { label: '号码的企业信息有误 ', value: 1 }, { label: '不希望显示企业信息', value: 2 }, { label: '该号码非本企业号码', value: 5 }];
      }return [{ label: '标记为诈骗、骚扰等类型', value: 4 }, { label: '号码被标记为企业名称', value: 1 }];
    };var params = _this.getParams();_this.state = { params: (_params = {}, _defineProperty(_params, phoneSelect, props.match.params.type !== 'company' ? params.selectType || phoneTypeEnum.phone : phoneTypeEnum.phone), _defineProperty(_params, 'phone', params.phone), _defineProperty(_params, reasonSelect, 4), _params), hiddenCodeSendBtn: false, tabIndex: props.match.params.type || appealTypeEnum.person, phoneNumbers: [], phoneList: [], fixed: false };_this.validate = {};_this.numberValidate = [];_this.onSubmit = _this.onSubmit.bind(_this);if (_this.isPC()) {
      window.location.href = '/console/#/appealNumber/' + (props.match.params.type === appealTypeEnum.company ? 'enterprise' : 'personal') + '?phone=' + (params.phone || '');
    }return _this;
  }_createClass(NumberAppeal, [{ key: 'componentDidUpdate', value: function componentDidUpdate(nextProps) {
      if (nextProps.userInfo !== this.props.userInfo && this.props.userInfo && this.props.userInfo.status !== 0) {
        var url = location.pathname + location.search;var phone = this.getParams().phone;window.location.href = '/m/haoma/guide?url=' + encodeURIComponent(url) + '&phone=' + (phone || '');
      }
    } }, { key: 'pushValidate', value: function pushValidate(key, node) {
      if (node) {
        this.validate[key] = node.validate;
      }
    } }, { key: 'onSubmit', value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var _this3 = this;var canSubmit, postParams, _state, tabIndex, params, _postParams, _postParams2, _postParams3, formData, personRes, companyRes;return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                canSubmit = true;Object.keys(this.validate).map(function (valiKey) {
                  var vilidate = _this3.validate && _this3.validate[valiKey]();if (vilidate.validate && canSubmit) {
                    canSubmit = false;
                  }
                });if (!canSubmit) {
                  _context3.next = 31;break;
                }postParams = {};_state = this.state, tabIndex = _state.tabIndex, params = _state.params;if (tabIndex === appealTypeEnum.person && phoneTypeEnum.phone === params[phoneSelect]) {
                  postParams = (_postParams = {}, _defineProperty(_postParams, phoneSelect, params[phoneSelect]), _defineProperty(_postParams, 'phone', params.phone), _defineProperty(_postParams, reasonSelect, params[reasonSelect]), _defineProperty(_postParams, 'code', params.code), _postParams);
                }if (tabIndex === appealTypeEnum.person && phoneTypeEnum.tel === params[phoneSelect]) {
                  postParams = (_postParams2 = {}, _defineProperty(_postParams2, phoneSelect, params[phoneSelect]), _defineProperty(_postParams2, 'phone', params.phone), _defineProperty(_postParams2, reasonSelect, params[reasonSelect]), _defineProperty(_postParams2, 'email', params.email || ''), _defineProperty(_postParams2, 'captcha', params.captcha), _defineProperty(_postParams2, 'certificates', this.state.certificates), _postParams2);
                }if (tabIndex === appealTypeEnum.company) {
                  postParams = (_postParams3 = {}, _defineProperty(_postParams3, phoneSelect, params[phoneSelect]), _defineProperty(_postParams3, reasonSelect, params[reasonSelect]), _defineProperty(_postParams3, 'email', params.email || ''), _defineProperty(_postParams3, 'captcha', params.captcha), _defineProperty(_postParams3, 'certificates', this.state.certificates), _defineProperty(_postParams3, 'certificates2', this.state.certificates2), _postParams3);postParams.phone = [params.phone].concat(this.state.phoneNumbers).join(',');
                }if (params[otherReason]) {
                  postParams[otherReason] = params[otherReason];
                }formData = new FormData();Object.keys(postParams).forEach(function (postParamsKey) {
                  formData.append(postParamsKey, postParams[postParamsKey]);
                });if (!(tabIndex === appealTypeEnum.person)) {
                  _context3.next = 21;break;
                }_context3.next = 14;return Object(__WEBPACK_IMPORTED_MODULE_10__actions_numberOptionsActions__["b" /* fetchPersonComplaint */])(formData);case 14:
                personRes = _context3.sent;if (!(personRes.status === 0)) {
                  _context3.next = 20;break;
                }window.location.href = '/m/haoma/success/appeal/person/' + params[phoneSelect];return _context3.abrupt('return');case 20:
                if (personRes.status === 401) {
                  window.location.href = this.loginUrl();
                } else if (postParams[phoneSelect] === phoneTypeEnum.phone) {
                  __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_toast___default.a.info(personRes.description, 2);
                } else {
                  if (personRes && personRes.description) {
                    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_toast___default.a.info(personRes.description, 2);
                  }this.codePic.resetCode();this.resetCaptcha();
                }case 21:
                if (!(tabIndex === appealTypeEnum.company)) {
                  _context3.next = 31;break;
                }_context3.next = 24;return Object(__WEBPACK_IMPORTED_MODULE_10__actions_numberOptionsActions__["a" /* fetchCompanyComplaint */])(formData);case 24:
                companyRes = _context3.sent;if (!(companyRes.status === 0)) {
                  _context3.next = 30;break;
                }window.location.href = '/m/haoma/success/appeal/company';return _context3.abrupt('return');case 30:
                if (companyRes.status === 401) {
                  window.location.href = this.loginUrl();
                } else {
                  if (companyRes && companyRes.description) {
                    __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_toast___default.a.info(companyRes.description, 2);
                  }this.codePic.resetCode();this.resetCaptcha();
                }case 31:case 'end':
                return _context3.stop();}
          }
        }, _callee3, this);
      }));function onSubmit() {
        return _ref3.apply(this, arguments);
      }return onSubmit;
    }() }, { key: 'onChange', value: function onChange(key, value, file) {
      this.setState({ params: Object.assign({}, this.state.params, _defineProperty({}, key, value)) });if (key === 'certificates' || key === 'certificates2') {
        this.setState(_defineProperty({}, key, file));
      }if (key === phoneSelect) {
        this.validate = {};this.props.history.replace('/haoma/appeal/' + this.state.tabIndex + '?selectType=' + value);
      }
    } }, { key: 'deleteNumber', value: function deleteNumber(index) {
      var curValue = this.state.phoneNumbers.slice(0);curValue.splice(index, 1);this.setState({ phoneNumbers: curValue });this.validate = {};
    } }, { key: 'onPhoneNumberChange', value: function onPhoneNumberChange(index, value) {
      var curValue = this.state.phoneNumbers.slice(0);curValue[index] = value;this.setState({ phoneNumbers: curValue });
    } }, { key: 'render', value: function render() {
      var _this4 = this;var _state2 = this.state,
          params = _state2.params,
          tabIndex = _state2.tabIndex;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'number-appeal' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('number-appeal-tab', { fixed: this.state.fixed }) }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { onClick: this.onChangeTabIndex.bind(this, appealTypeEnum.person), className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('tab-item', { active: tabIndex === appealTypeEnum.person }) }, '\u4E2A\u4EBA\u53F7\u7801\u7533\u8BC9', __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'tab-stick' })), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { onClick: this.onChangeTabIndex.bind(this, appealTypeEnum.company), className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('tab-item', { active: tabIndex === appealTypeEnum.company }) }, '\u4F01\u4E1A\u53F7\u7801\u7533\u8BC9', __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'tab-stick' }))), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'number-appeal-wrapper' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'form' }, tabIndex === appealTypeEnum.person && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__formCom__["b" /* FormItem */], { isRequire: true, type: 'select', label: '\u53F7\u7801\u7C7B\u578B\uFF1A', placeholder: '\u7535\u8BDD\u53F7\u7801', value: this.state.params[phoneSelect], onChange: this.onChange.bind(this, phoneSelect), ref: this.pushValidate.bind(this, phoneSelect), onBlur: this.onBlur, onFocus: this.onFocus, data: [{ label: '手机号码 ', value: phoneTypeEnum.phone }, { label: '座机号码', value: phoneTypeEnum.tel }] }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__formCom__["b" /* FormItem */], { isRequire: true, type: 'input', label: '\u7533\u8BC9\u53F7\u7801\uFF1A', des: tabIndex === appealTypeEnum.company ? '请输入座机、手机、座机格式：010-12345678' : '', placeholder: tabIndex === appealTypeEnum.company ? '请输入您要申诉的号码' : params[phoneSelect] === phoneTypeEnum.phone ? '请输入手机号码' : '请输入座机号码、座机格式：010-12345678', comClassName: 'form-input', ref: this.pushValidate.bind(this, 'phone'), value: this.state.params.phone, onChange: this.onChange.bind(this, 'phone'), onFocus: this.getAlreadyPhoneList, onBlur: this.onBlur, rules: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["e" /* validatePhone */])('申诉号码', tabIndex === appealTypeEnum.company || params[phoneSelect] === phoneTypeEnum.tel, this.state.phoneList) }), tabIndex === appealTypeEnum.company && this.renderMorePhone(), params[phoneSelect] === phoneTypeEnum.phone && tabIndex === appealTypeEnum.person && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__formCom__["b" /* FormItem */], { type: 'input', isRequire: true, label: '\u9A8C\u8BC1\u7801\uFF1A', comClassName: 'form-input code', rules: [Object(__WEBPACK_IMPORTED_MODULE_9__utils__["f" /* validateRequire */])('验证码')], ref: this.pushValidate.bind(this, 'code'), value: this.state.params.code, onChange: this.onChange.bind(this, 'code'), placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801', renderRight: this.renderRight, onBlur: this.onBlur, onFocus: this.onFocus })), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__formCom__["b" /* FormItem */], { isRequire: true, type: 'select', label: '\u7533\u8BC9\u7406\u7531\uFF1A', placeholder: '\u6807\u8BB0\u4E3A\u8BC8\u9A97\u3001\u9A9A\u6270\u7B49\u7C7B\u578B', data: this.getTypeData(), ref: this.pushValidate.bind(this, reasonSelect), value: this.state.params[reasonSelect], onChange: this.onChange.bind(this, reasonSelect) }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__formCom__["b" /* FormItem */], { type: 'textarea', label: '\u5176\u4ED6\u7406\u7531\uFF1A', placeholder: '\u5176\u4ED6\u7406\u7531\uFF08100\u5B57\u4EE5\u5185\uFF09', rows: 3, comClassName: 'form-textarea', ref: this.pushValidate.bind(this, otherReason), rules: [Object(__WEBPACK_IMPORTED_MODULE_9__utils__["c" /* validateMax */])('其他理由', 100)], value: this.state.params[otherReason], onChange: this.onChange.bind(this, otherReason), onBlur: this.onBlur, onFocus: this.onFocus }), params[phoneSelect] === phoneTypeEnum.tel && tabIndex !== appealTypeEnum.company && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__formCom__["b" /* FormItem */], { type: 'upload', isRequire: true, name: 'certificates', label: '\u6DFB\u52A0\u8BC1\u660E \uFF1A', labelName: '\u6DFB\u52A0\u8BC1\u660E', des: '\u7533\u8BC9\u53F7\u7801\u7684\u5F00\u6237\u8BC1\u660E\uFF0C\u7F34\u8D39\u8BC1\u660E\uFF0C\u7F51\u9875\u622A\u56FE\u7B49\u6709\u6548\u8BC1\u660E\uFF0C\u4EFB\u9009\u5176\u4E00\u56FE\u7247\u652F\u6301jpg\u6216png\u683C\u5F0F\uFF0C\u5927\u5C0F\u4E0D\u8D85\u8FC71M', fileType: 'image/png;image/jpg', fileSize: 1024 * 1024, ref: this.pushValidate.bind(this, 'certificates'), rules: [Object(__WEBPACK_IMPORTED_MODULE_9__utils__["f" /* validateRequire */])('添加证明')], value: this.state.params.certificates, onChange: this.onChange.bind(this, 'certificates') }), tabIndex === appealTypeEnum.company && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__formCom__["b" /* FormItem */], { type: 'upload', isRequire: true, name: 'certificates2', label: '\u4F01\u4E1A\u5408\u6CD5\u8D44\u8D28\uFF1A', labelName: '\u4F01\u4E1A\u5408\u6CD5\u8D44\u8D28', des: '\u6700\u65B0\u5E74\u68C0\u7684\u4F01\u4E1A\u8425\u4E1A\u6267\u7167\uFF0C\u7EC4\u7EC7\u673A\u6784\u4EE3\u7801\u8BC1\uFF0C\u7A0E\u52A1\u8BC1\u4E66\uFF08\u4E09\u9009\u4E00\uFF09\u56FE\u7247\u652F\u6301jpg\u6216png\u683C\u5F0F\uFF0C\u5927\u5C0F\u4E0D\u8D85\u8FC71M', fileType: 'image/png;image/jpg', fileSize: 1024 * 1024, ref: this.pushValidate.bind(this, 'certificates'), rules: [Object(__WEBPACK_IMPORTED_MODULE_9__utils__["f" /* validateRequire */])('企业合法资质')], value: this.state.params.certificates, onChange: this.onChange.bind(this, 'certificates') }), tabIndex === appealTypeEnum.company && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__formCom__["b" /* FormItem */], { type: 'upload', isRequire: true, name: 'certificates1', label: '\u8FD0\u8425\u5546\u8BC1\u660E\uFF1A', labelName: '\u8FD0\u8425\u5546\u8BC1\u660E', des: '\u8BA4\u8BC1\u53F7\u7801\u7684\u5F00\u6237\u8BC1\u660E\uFF0C\u7F34\u8D39\u8BC1\u660E\u7B49\u6709\u6548\u8BC1\u660E\uFF0C\u9009\u5176\u4E00\u5373\u53EF \u56FE\u7247\u652F\u6301jpg\u6216png\u683C\u5F0F\uFF0C\u5927\u5C0F\u4E0D\u8D85\u8FC71M', fileType: 'image/png;image/jpg', fileSize: 1024 * 1024, ref: this.pushValidate.bind(this, 'certificates2'), rules: [Object(__WEBPACK_IMPORTED_MODULE_9__utils__["f" /* validateRequire */])('运营商证明')], value: this.state.params.certificates2, onChange: this.onChange.bind(this, 'certificates2') }), (params[phoneSelect] === phoneTypeEnum.tel || tabIndex === appealTypeEnum.company) && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__formCom__["b" /* FormItem */], { type: 'input', label: '\u8054\u7CFB\u90AE\u7BB1\uFF1A', comClassName: 'form-input', value: this.state.params.email, onChange: this.onChange.bind(this, 'email'), placeholder: '\u8BF7\u8F93\u5165\u60A8\u7684\u90AE\u7BB1', ref: this.pushValidate.bind(this, 'email'), rules: Object(__WEBPACK_IMPORTED_MODULE_9__utils__["b" /* validateEmail */])(), onBlur: this.onBlur, onFocus: this.onFocus }), (params[phoneSelect] === phoneTypeEnum.tel || tabIndex === appealTypeEnum.company) && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__formCom__["b" /* FormItem */], { type: 'input', label: '\u9A8C\u8BC1\u7801\uFF1A', comClassName: 'form-input code', value: this.state.params.captcha, onChange: this.onChange.bind(this, 'captcha'), onBlur: this.onBlur, onFocus: this.onFocus, placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801', ref: this.pushValidate.bind(this, 'captcha'), rules: [Object(__WEBPACK_IMPORTED_MODULE_9__utils__["f" /* validateRequire */])('验证码')], renderRight: function renderRight() {
          return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__formCom__["a" /* CodePic */], { resetCaptcha: _this4.resetCaptcha, ref: function ref(codePic) {
              return _this4.codePic = codePic;
            } });
        } })), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { onClick: this.onSubmit, className: 'number-options-btn' }, '\u63D0\u4EA4\u7533\u8BC9'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('p', { className: 'submit-tips' }, '\u63D0\u4EA4\u7533\u8BC9\u540E\uFF0C\u4F1A\u57282\u4E2A\u5DE5\u4F5C\u65E5\u5BA1\u6838\u5B8C\u6BD5'))));
    } }]);return NumberAppeal;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]), _class.propTypes = { match: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, history: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, userInfo: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, getAlreadyPhoneList: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(function (state) {
  return { userInfo: state.userLoginstate };
}, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_7_redux__["b" /* bindActionCreators */])({ getAlreadyPhoneList: __WEBPACK_IMPORTED_MODULE_10__actions_numberOptionsActions__["c" /* getAlreadyPhoneList */] }, dispatch);
})(NumberAppeal));

/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_delete.7ba425ef.svg";

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_addinbtn_disable.2f49b07c.svg";

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon_addinbtn.775a05d9.svg";

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SuccessPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__successPage_less__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__successPage_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__successPage_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp2;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 提交成功页
  * @author: wence
  */var SuccessPage = (_temp2 = _class = function (_PureComponent) {
  _inherits(SuccessPage, _PureComponent);function SuccessPage() {
    var _ref;var _temp, _this, _ret;_classCallCheck(this, SuccessPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SuccessPage.__proto__ || Object.getPrototypeOf(SuccessPage)).call.apply(_ref, [this].concat(args))), _this), _this.getViewPath = function () {
      var params = _this.props.match.params;return '/console/#/' + params.path;
    }, _this.getReSubmitPath = function () {
      var params = _this.props.match.params;return '/m/haoma/' + params.path + (params.type ? '/' + params.type + '?selectType=' + (params.selectType || '2') : '');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }_createClass(SuccessPage, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this; // 将最小高度去除掉
      setTimeout(function () {
        _this2.node && _this2.node.parentNode && (_this2.node.parentNode.style.minHeight = '');
      }, 0);
    } }, { key: 'render', value: function render() {
      var _this3 = this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { ref: function ref(node) {
          return _this3.node = node;
        }, className: 'number-success-page' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'success-title' }, '\u63D0\u4EA4\u6210\u529F'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'success-sub-title' }, '\u5DF2\u6210\u529F\u63D0\u4EA4\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85\u5904\u7406'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'success-icon' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(248), alt: '' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'success-btn' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: this.getViewPath(), className: 'success-btn-view' }, '\u67E5\u770B\u63D0\u4EA4\u8BB0\u5F55'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: this.getReSubmitPath(), className: 'success-btn-repost' }, '\u7EE7\u7EED\u63D0\u4EA4')));
    } }]);return SuccessPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { match: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object }, _temp2);

/***/ }),
/* 751 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_buyAction__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 聚合页
  * @author wangzhuang
  * */var Buy = (_temp = _class = function (_Component) {
  _inherits(Buy, _Component);function Buy(props, context) {
    _classCallCheck(this, Buy); // let reg = new RegExp('(localhost|127.0.0.1|test.anquan.baidu.com|cq02-security-dev01.cq02.baidu.com)');
    // let res = reg.test(location.host); // 判断是否为测试线
    var _this = _possibleConstructorReturn(this, (Buy.__proto__ || Object.getPrototypeOf(Buy)).call(this, props, context));_this.onClose = function (key) {
      return function () {
        _this.setState(_defineProperty({}, key, false));
      };
    };_this.state = { modal1: false, modal2: false, toast: false, toastTitle: '', lookUrl: '', authType: 0, // 是不是企业认证
      // loginUrl: res
      //     ? `http://wappass.qatest.baidu.com?tpl=spu&subpro=spuuser&u=${location.href}`
      //     : `http://wappass.baidu.com?tpl=spu&subpro=spuuser&u=${location.href}`
      loginUrl: _this.loginUrl() };return _this;
  }_createClass(Buy, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        location.href = '/buy' + location.search;
      }
    } }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;var nextUser = nextProps.userLoginstate;if (!Object.is(nextUser, this.props.userLoginstate)) {
        if (nextUser.status === 0) {
          this.props.fetchInstanceGetInstance().then(function (data) {
            var key = Object.keys(data.data.data)[0];_this2.props.fetchActivityGetService({ 'instance_id': key });
          });
        } else {
          this.props.fetchActivityGetService();
        }
      }
    } }, { key: 'hmt', value: function hmt() {
      try {
        window._hmt.push(['_trackEvent', 'gmplugin', 'use', 'mobile']);
      } catch (e) {
        return;
      }
    } }, { key: 'render', value: function render() {
      var _this3 = this;var _props = this.props,
          activityGetService = _props.activityGetService,
          instanceGetinstance = _props.instanceGetinstance,
          userLoginstate = _props.userLoginstate;var _state = this.state,
          modal1 = _state.modal1,
          modal2 = _state.modal2,
          loginUrl = _state.loginUrl,
          lookUrl = _state.lookUrl;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'saas-buy' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'saas-buy-banner' }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'saas-buy-hint' }, '\u767B\u5F55\u8D26\u53F7\u4E00\u952E\u4E0B\u5355\uFF0C\u70ED\u95E8\u4EA7\u54C1\u514D\u8D39\u8BD5\u7528'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'saas-buy-pro' }, !this.isEmptyobj(activityGetService) ? activityGetService.data.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'saas-buy-item', key: index }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'saas-buy-name' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: item.is_hot ? 'hot' : null }, item.service_name), item.is_hot ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', { className: 'saas-buy-hot' }) : null), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'saas-buy-text' }, item.service_desc), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'saas-buy-info' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: item.url, target: '_blank' }, '\u67E5\u770B\u8BE6\u60C5 ', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('i', null))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'saas-buy-item-hint' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', null, '\u514D\u8D39\u4F53\u9A8C\u65F6\u957F\uFF1A'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', null, item.is_buy ? '-' : item.capacity)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: item.is_buy ? 'saas-buy-btn disable' : 'saas-buy-btn', onClick: function onClick() {
            if (item.is_buy) {
              return false;
            }if (!_this3.isEmptyobj(activityGetService) && userLoginstate.status === 0) {
              var key = Object.keys(instanceGetinstance.data)[0];var json = { 'instance_id': key, 'service_id': item.service_id, 'meal_id': item.meal_id };_this3.props.fetchApimealPay(json).then(function (data) {
                if (data.data.status === 0) {
                  // 购买成功
                  _this3.hmt();_this3.props.fetchActivityGetService({ 'instance_id': key });_this3.setState({ modal2: true, lookUrl: item.url });
                } else if (data.data.status === 404008) {
                  // 未实名
                  Object(__WEBPACK_IMPORTED_MODULE_5__actions_buyAction__["f" /* fetchRealName */])({ 'instance_id': key }).then(function (res) {
                    _this3.setState({ modal1: true, authType: res && res.data && res.data['auth_type'] || 0 });
                  });
                } else if (data.data.status === 404008) {
                  // 未登录
                  location.href = loginUrl;
                } else if (data.data.description) {
                  _this3.setState({ toastTitle: data.data.description, toast: true });
                }
              });
            } else {
              location.href = loginUrl;
            }
          } }, item.is_buy ? '已领取' : '免费领取'));
      }) : null), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default.a, { visible: modal1, transparent: true, maskClosable: true, className: 'saas-attest', onClose: this.onClose('modal1') }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'hint' }, '\u60A8\u7684\u8D26\u53F7\u8FD8\u6CA1\u6709\u8BA4\u8BC1\uFF0C\u8BA4\u8BC1\u540E\u624D\u80FD\u8D2D\u4E70\u54E6\uFF01'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { className: 'saas-buy-btn', href: this.state.authType === 0 ? this.userCenterUrl() : '/console/#/attestation' // target={'_blank'}
        , onClick: function onClick() {
          _this3.setState({ modal1: false });
        } }, '\u53BB\u8BA4\u8BC1')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default.a, { visible: modal2, transparent: true, maskClosable: false, className: 'saas-attest', onClose: this.onClose('modal2') }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'hint' }, '\u8D2D\u4E70\u6210\u529F\uFF0C\u53EF\u524D\u5F80\u63A7\u5236\u53F0\u67E5\u770B\u4F7F\u7528\u8BF4\u660E'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'operate' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { className: 'saas-buy-btn hint-btn', href: lookUrl, target: '_blank', onClick: function onClick() {
          _this3.setState({ modal2: false });
        } }, '\u53BB\u63A7\u5236\u53F0'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'saas-buy-btn', onClick: function onClick() {
          _this3.setState({ modal2: false });
        } }, '\u7EE7\u7EED\u8D2D\u4E70'))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default.a, { visible: this.state.toast, transparent: true, maskClosable: false, wrapClassName: 'spu-modal-confirm', className: 'saas-attest', onClose: this.onClose('modal2') }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'hint' }, this.state.toastTitle), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'operate' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { className: 'saas-buy-btn', onClick: function onClick(e) {
          e.preventDefault();_this3.setState({ toast: false, toastTitle: '' });
        } }, '\u5173\u95ED'))));
    } }]);return Buy;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]), _class.propTypes = { userLoginstate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, activityGetService: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, instanceGetinstance: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, fetchApimealPay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, fetchActivityGetService: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, fetchInstanceGetInstance: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func }, _temp);function mapStateToProps(state) {
  return { userLoginstate: state.userLoginstate, activityGetService: state.activityGetService, instanceGetinstance: state.instanceGetinstance };
}function mapDispatchToProps(dispatch) {
  return { fetchApimealPay: function fetchApimealPay(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__actions_buyAction__["b" /* fetchApimealPay */])(dispatch, obj);
    }, fetchActivityGetService: function fetchActivityGetService(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__actions_buyAction__["a" /* fetchActivityGetService */])(dispatch, obj);
    }, fetchInstanceGetInstance: function fetchInstanceGetInstance() {
      return Object(__WEBPACK_IMPORTED_MODULE_5__actions_buyAction__["d" /* fetchInstanceGetInstance */])(dispatch);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Buy));

/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = alert;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(21);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _closest = __webpack_require__(146);

var _closest2 = _interopRequireDefault(_closest);

var _Modal = __webpack_require__(82);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function alert(title, message) {
    var actions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [{ text: '确定' }];
    var platform = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ios';

    var closed = false;
    if (!title && !message) {
        // console.log('Must specify either an alert title, or message, or both');
        return {
            close: function close() {}
        };
    }
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        ReactDOM.unmountComponentAtNode(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    var footer = actions.map(function (button) {
        // tslint:disable-next-line:only-arrow-functions
        var orginPress = button.onPress || function () {};
        button.onPress = function () {
            if (closed) {
                return;
            }
            var res = orginPress();
            if (res && res.then) {
                res.then(function () {
                    closed = true;
                    close();
                })['catch'](function () {});
            } else {
                closed = true;
                close();
            }
        };
        return button;
    });
    var prefixCls = 'am-modal';
    function onWrapTouchStart(e) {
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        var pNode = (0, _closest2['default'])(e.target, '.' + prefixCls + '-footer');
        if (!pNode) {
            e.preventDefault();
        }
    }
    ReactDOM.render(React.createElement(
        _Modal2['default'],
        { visible: true, transparent: true, title: title, transitionName: 'am-zoom', closable: false, maskClosable: false, footer: footer, maskTransitionName: 'am-fade', platform: platform, wrapProps: { onTouchStart: onWrapTouchStart } },
        React.createElement(
            'div',
            { className: prefixCls + '-alert-content' },
            message
        )
    ), div);
    return {
        close: close
    };
}
module.exports = exports['default'];

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dialog__ = __webpack_require__(756);








function noop() {}
var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.createPortal;
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var DialogWrap = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DialogWrap, _React$Component);

    function DialogWrap() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DialogWrap);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DialogWrap.__proto__ || Object.getPrototypeOf(DialogWrap)).apply(this, arguments));

        _this.saveRef = function (node) {
            if (IS_REACT_16) {
                _this._component = node;
            }
        };
        _this.getComponent = function (visible) {
            var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this.props);
            ['visible', 'onAnimateLeave'].forEach(function (key) {
                if (props.hasOwnProperty(key)) {
                    delete props[key];
                }
            });
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Dialog__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { visible: visible, onAnimateLeave: _this.removeContainer, ref: _this.saveRef }));
        };
        _this.removeContainer = function () {
            if (_this.container) {
                if (!IS_REACT_16) {
                    __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.unmountComponentAtNode(_this.container);
                }
                _this.container.parentNode.removeChild(_this.container);
                _this.container = null;
            }
        };
        _this.getContainer = function () {
            if (!_this.container) {
                var container = document.createElement('div');
                var containerId = _this.props.prefixCls + '-container-' + new Date().getTime();
                container.setAttribute('id', containerId);
                document.body.appendChild(container);
                _this.container = container;
            }
            return _this.container;
        };
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DialogWrap, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.visible) {
                this.componentDidUpdate();
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(_ref) {
            var visible = _ref.visible;

            return !!(this.props.visible || visible);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.visible) {
                if (!IS_REACT_16) {
                    this.renderDialog(false);
                } else {
                    // TODO for react@16 createPortal animation
                    this.removeContainer();
                }
            } else {
                this.removeContainer();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!IS_REACT_16) {
                this.renderDialog(this.props.visible);
            }
        }
    }, {
        key: 'renderDialog',
        value: function renderDialog(visible) {
            __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this.getComponent(visible), this.getContainer());
        }
    }, {
        key: 'render',
        value: function render() {
            if (!CAN_USE_DOM) {
                return null;
            }
            var visible = this.props.visible;

            if (IS_REACT_16 && (visible || this._component)) {
                return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.createPortal(this.getComponent(visible), this.getContainer());
            }
            return null;
        }
    }]);

    return DialogWrap;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (DialogWrap);

DialogWrap.defaultProps = {
    visible: false,
    prefixCls: 'rmc-dialog',
    onClose: noop
};

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rc_animate__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LazyRenderBox__ = __webpack_require__(757);








function noop() {}

var Dialog = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Dialog, _React$Component);

    function Dialog() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Dialog);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).apply(this, arguments));

        _this.getDialogElement = function () {
            var props = _this.props;
            var closable = props.closable;
            var prefixCls = props.prefixCls;
            var footer = void 0;
            if (props.footer) {
                footer = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-footer', ref: function ref(el) {
                        return _this.footerRef = el;
                    } }, props.footer);
            }
            var header = void 0;
            if (props.title) {
                header = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-header', ref: function ref(el) {
                        return _this.headerRef = el;
                    } }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-title' }, props.title));
            }
            var closer = void 0;
            if (closable) {
                closer = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("button", { onClick: _this.close, "aria-label": "Close", className: prefixCls + '-close' }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", { className: prefixCls + '-close-x' }));
            }
            var transitionName = _this.getTransitionName();
            var dialogElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LazyRenderBox__["a" /* default */], { key: "dialog-element", role: "document", ref: function ref(el) {
                    return _this.dialogRef = el;
                }, style: props.style || {}, className: prefixCls + ' ' + (props.className || ''), visible: props.visible }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-content' }, closer, header, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", { className: prefixCls + '-body', style: props.bodyStyle, ref: function ref(el) {
                    return _this.bodyRef = el;
                } }, props.children), footer));
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_rc_animate__["a" /* default */], { key: "dialog", showProp: "visible", onAppear: _this.onAnimateAppear, onLeave: _this.onAnimateLeave, transitionName: transitionName, component: "", transitionAppear: true }, dialogElement);
        };
        _this.onAnimateAppear = function () {
            document.body.style.overflow = 'hidden';
        };
        _this.onAnimateLeave = function () {
            document.body.style.overflow = '';
            if (_this.wrapRef) {
                _this.wrapRef.style.display = 'none';
            }
            if (_this.props.onAnimateLeave) {
                _this.props.onAnimateLeave();
            }
            if (_this.props.afterClose) {
                _this.props.afterClose();
            }
        };
        _this.close = function (e) {
            if (_this.props.onClose) {
                _this.props.onClose(e);
            }
        };
        _this.onMaskClick = function (e) {
            if (e.target === e.currentTarget) {
                _this.close(e);
            }
        };
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Dialog, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // fix: react@16 no dismissing animation
            document.body.style.overflow = '';
            if (this.wrapRef) {
                this.wrapRef.style.display = 'none';
            }
        }
    }, {
        key: 'getZIndexStyle',
        value: function getZIndexStyle() {
            var style = {};
            var props = this.props;
            if (props.zIndex !== undefined) {
                style.zIndex = props.zIndex;
            }
            return style;
        }
    }, {
        key: 'getWrapStyle',
        value: function getWrapStyle() {
            var wrapStyle = this.props.wrapStyle || {};
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getZIndexStyle(), wrapStyle);
        }
    }, {
        key: 'getMaskStyle',
        value: function getMaskStyle() {
            var maskStyle = this.props.maskStyle || {};
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getZIndexStyle(), maskStyle);
        }
    }, {
        key: 'getMaskTransitionName',
        value: function getMaskTransitionName() {
            var props = this.props;
            var transitionName = props.maskTransitionName;
            var animation = props.maskAnimation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        }
    }, {
        key: 'getTransitionName',
        value: function getTransitionName() {
            var props = this.props;
            var transitionName = props.transitionName;
            var animation = props.animation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        }
    }, {
        key: 'getMaskElement',
        value: function getMaskElement() {
            var props = this.props;
            var maskElement = void 0;
            if (props.mask) {
                var maskTransition = this.getMaskTransitionName();
                maskElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LazyRenderBox__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ style: this.getMaskStyle(), key: "mask-element", className: props.prefixCls + '-mask', hiddenClassName: props.prefixCls + '-mask-hidden', visible: props.visible }, props.maskProps));
                if (maskTransition) {
                    maskElement = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_rc_animate__["a" /* default */], { key: "mask", showProp: "visible", transitionAppear: true, component: "", transitionName: maskTransition }, maskElement);
                }
            }
            return maskElement;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var props = this.props;
            var prefixCls = props.prefixCls,
                maskClosable = props.maskClosable;

            var style = this.getWrapStyle();
            if (props.visible) {
                style.display = null;
            }
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", null, this.getMaskElement(), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ className: prefixCls + '-wrap ' + (props.wrapClassName || ''), ref: function ref(el) {
                    return _this2.wrapRef = el;
                }, onClick: maskClosable ? this.onMaskClick : undefined, role: "dialog", "aria-labelledby": props.title, style: style }, props.wrapProps), this.getDialogElement()));
        }
    }]);

    return Dialog;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Dialog);

Dialog.defaultProps = {
    afterClose: noop,
    className: '',
    mask: true,
    visible: false,
    closable: true,
    maskClosable: true,
    prefixCls: 'rmc-dialog',
    onClose: noop
};

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);







var LazyRenderBox = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LazyRenderBox, _React$Component);

    function LazyRenderBox() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LazyRenderBox.__proto__ || Object.getPrototypeOf(LazyRenderBox)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LazyRenderBox, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            return !!nextProps.hiddenClassName || !!nextProps.visible;
        }
    }, {
        key: "render",
        value: function render() {
            var className = this.props.className;
            if (!!this.props.hiddenClassName && !this.props.visible) {
                className += " " + this.props.hiddenClassName;
            }
            var props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props);
            delete props.hiddenClassName;
            delete props.visible;
            props.className = className;
            return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props));
        }
    }]);

    return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = operation;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(21);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _closest = __webpack_require__(146);

var _closest2 = _interopRequireDefault(_closest);

var _Modal = __webpack_require__(82);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function operation() {
    var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [{ text: '确定' }];
    var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ios';

    var closed = false;
    var prefixCls = 'am-modal';
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        ReactDOM.unmountComponentAtNode(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    var footer = actions.map(function (button) {
        // tslint:disable-next-line:only-arrow-functions
        var orginPress = button.onPress || function () {};
        button.onPress = function () {
            if (closed) {
                return;
            }
            var res = orginPress();
            if (res && res.then) {
                res.then(function () {
                    closed = true;
                    close();
                })['catch'](function () {});
            } else {
                closed = true;
                close();
            }
        };
        return button;
    });
    function onWrapTouchStart(e) {
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        var pNode = (0, _closest2['default'])(e.target, '.am-modal-footer');
        if (!pNode) {
            e.preventDefault();
        }
    }
    ReactDOM.render(React.createElement(_Modal2['default'], { visible: true, operation: true, transparent: true, prefixCls: prefixCls, transitionName: 'am-zoom', closable: false, maskClosable: true, onClose: close, footer: footer, maskTransitionName: 'am-fade', className: 'am-modal-operation', platform: platform, wrapProps: { onTouchStart: onWrapTouchStart } }), div);
    return {
        close: close
    };
}
module.exports = exports['default'];

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = prompt;

var _react = __webpack_require__(0);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(21);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _closest = __webpack_require__(146);

var _closest2 = _interopRequireDefault(_closest);

var _Modal = __webpack_require__(82);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function prompt(title, message, callbackOrActions) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'default';
    var defaultValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var placeholders = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ['', ''];
    var platform = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'ios';

    var closed = false;
    defaultValue = typeof defaultValue === 'string' ? defaultValue : typeof defaultValue === 'number' ? '' + defaultValue : '';
    if (!callbackOrActions) {
        // console.log('Must specify callbackOrActions');
        return {
            close: function close() {}
        };
    }
    var prefixCls = 'am-modal';
    var data = {
        text: defaultValue
    };
    function onChange(e) {
        var target = e.target;
        var inputType = target.getAttribute('type');
        if (inputType !== null) {
            data[inputType] = target.value;
        }
    }
    // hotfix issue: https://github.com/ant-design/ant-design-mobile/issues/2177
    function onClick(e) {
        var target = e.currentTarget || e.target;
        if (target) {
            target.focus();
        }
    }
    function onBlurFixWechat() {
        // https://github.com/ant-design/ant-design-mobile/issues/3137
        if (/MicroMessenger/.test(navigator.userAgent)) {
            document.body.scrollTop = document.body.scrollTop;
        }
    }
    var inputDom = void 0;
    var focusFn = function focusFn(input) {
        setTimeout(function () {
            if (input) {
                input.focus();
            }
        }, 500);
    };
    switch (type) {
        case 'login-password':
            inputDom = React.createElement(
                'div',
                { className: prefixCls + '-input-container' },
                React.createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    React.createElement(
                        'label',
                        null,
                        React.createElement('input', { type: 'text', defaultValue: data.text, ref: function ref(input) {
                                return focusFn(input);
                            }, onClick: onClick, onChange: onChange, placeholder: placeholders[0], onBlur: onBlurFixWechat })
                    )
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    React.createElement(
                        'label',
                        null,
                        React.createElement('input', { type: 'password', defaultValue: data.password, onClick: onClick, onChange: onChange, placeholder: placeholders[1], onBlur: onBlurFixWechat })
                    )
                )
            );
            break;
        case 'secure-text':
            inputDom = React.createElement(
                'div',
                { className: prefixCls + '-input-container' },
                React.createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    React.createElement(
                        'label',
                        null,
                        React.createElement('input', { type: 'password', defaultValue: data.password, ref: function ref(input) {
                                return focusFn(input);
                            }, onClick: onClick, onChange: onChange, placeholder: placeholders[0], onBlur: onBlurFixWechat })
                    )
                )
            );
            break;
        case 'default':
        default:
            inputDom = React.createElement(
                'div',
                { className: prefixCls + '-input-container' },
                React.createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    React.createElement(
                        'label',
                        null,
                        React.createElement('input', { type: 'text', defaultValue: data.text, ref: function ref(input) {
                                return focusFn(input);
                            }, onClick: onClick, onChange: onChange, placeholder: placeholders[0], onBlur: onBlurFixWechat })
                    )
                )
            );
    }
    var content = React.createElement(
        'div',
        null,
        message,
        inputDom
    );
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        ReactDOM.unmountComponentAtNode(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    function handleConfirm(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        var _data$text = data.text,
            text = _data$text === undefined ? '' : _data$text,
            _data$password = data.password,
            password = _data$password === undefined ? '' : _data$password;

        var callbackArgs = type === 'login-password' ? [text, password] : type === 'secure-text' ? [password] : [text];
        return callback.apply(undefined, callbackArgs);
    }
    var actions = void 0;
    if (typeof callbackOrActions === 'function') {
        actions = [{
            text: '取消',
            onPress: function onPress() {}
        }, {
            text: '确定',
            onPress: function onPress() {
                handleConfirm(callbackOrActions);
            }
        }];
    } else {
        actions = callbackOrActions.map(function (item) {
            return {
                text: item.text,
                onPress: function onPress() {
                    return handleConfirm(item.onPress);
                }
            };
        });
    }
    var footer = actions.map(function (button) {
        // tslint:disable-next-line:only-arrow-functions
        var orginPress = button.onPress || function () {};
        button.onPress = function () {
            if (closed) {
                return;
            }
            var res = orginPress();
            if (res && res.then) {
                res.then(function () {
                    closed = true;
                    close();
                })['catch'](function () {});
            } else {
                closed = true;
                close();
            }
        };
        return button;
    });
    function onWrapTouchStart(e) {
        // exclude input element for focus
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        var pNode = (0, _closest2['default'])(e.target, '.' + prefixCls + '-content');
        if (!pNode) {
            e.preventDefault();
        }
    }
    ReactDOM.render(React.createElement(
        _Modal2['default'],
        { visible: true, transparent: true, prefixCls: prefixCls, title: title, closable: false, maskClosable: false, transitionName: 'am-zoom', footer: footer, maskTransitionName: 'am-fade', platform: platform, wrapProps: { onTouchStart: onWrapTouchStart } },
        React.createElement(
            'div',
            { className: prefixCls + '-propmt-content' },
            content
        )
    ), div);
    return {
        close: close
    };
}
module.exports = exports['default'];

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_buyAction__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_less__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 活动页
  * @author wence
  * */var payStatus = { pay: 0, // 领取成功
  payBind: 1, // 领取成功为绑定手机号
  hasPay: 2 // 已经领取过
};var Buy = (_temp = _class = function (_Component) {
  _inherits(Buy, _Component);function Buy(props, context) {
    var _this2 = this;_classCallCheck(this, Buy);var _this = _possibleConstructorReturn(this, (Buy.__proto__ || Object.getPrototypeOf(Buy)).call(this, props, context));_this.fetchBuyData = function (nextUser) {
      if (nextUser.status === 0) {
        _this.props.fetchInstanceGetInstance().then(function (data) {
          var key = Object.keys(data.data.data)[0];_this.props.fetchActivityGetService({ 'instance_id': key });_this.getPayInfo({ 'instance_id': key });
        });
      } else if (nextUser.status === 401) {
        location.href = _this.state.loginUrl;
      } else {
        _this.props.fetchActivityGetService();
      }
    };_this.getPayInfo = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(params) {
        var res, service;return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                _context.next = 2;return Object(__WEBPACK_IMPORTED_MODULE_7__actions_buyAction__["e" /* fetchPayInfo */])(params);case 2:
                res = _context.sent;if (res.status === 0) {
                  if (res.data.is_buy === 0) {
                    service = res.data && res.data.service || {};_this.payFristAction({ 'instance_id': params.instance_id, 'service_id': service.service_id, 'meal_id': service.meal_id });
                  } else {
                    _this.setState({ status: payStatus.hasPay });
                  }_this.setState({ payInfo: res.data });
                } else if (res.status === 401) {
                  location.href = _this.state.loginUrl;
                } else if (res.description) {
                  _this.setState({ toastTitle: res.description, toast: true });
                }case 4:case 'end':
                return _context.stop();}
          }
        }, _callee, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.onClose = function (key) {
      return function () {
        _this.setState(_defineProperty({}, key, false));
      };
    };_this.renderBuySuccessBody = function () {
      var status = _this.state.status || 0;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'sass-buy-success-container large' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-success' }, _this.renders[status] && _this.renders[status]())), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-hint' }, '\u8BD5\u7528\u66F4\u591A\u5B89\u5168\u4EA7\u54C1'));
    };_this.renderNormalCard = function (isLarge, isBind, isBuy) {
      var serviceInfo = _this.state.payInfo.service || {};return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('saas-buy-success-bg', { 'normal': !isBind, 'large-margin': isLarge, 'error': isBind }) }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('saas-buy-success-card', { large: isLarge }) }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-item-label' }, '\u4EA7\u54C1\u540D\u79F0'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-item-value', style: { marginBottom: '.3rem' } }, serviceInfo.name), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-item-label' }, '\u8BF7\u6C42\u6B21\u6570'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-item-value', style: { marginBottom: '.3rem' } }, isBuy ? '-' : serviceInfo.capacity), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-item-label' }, '\u6709\u6548\u671F'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-item-value' }, isBuy ? '-' : serviceInfo.time), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', { href: '/console/#/inquires/' + serviceInfo.service_id, className: 'saas-buy-item-btn' }, '\u67E5\u770B\u8BE6\u60C5'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'sass-buy-item-des' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', null, '\u7ED1\u5B9A\u9ED8\u8BA4\u8054\u7CFB\u65B9\u5F0F\uFF0C\u518D\u7533\u8BF7\u514D\u8D39\u8BD5\u7528\u53EF\u4EAB\u53D7\u8BF7\u6C42\u6B21\u6570\u548C\u6709\u6548\u671F\u7FFB\u500D\u3002'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', { className: 'saas-buy-item-des-bind', href: '/console/#/userCenter' }, '\u7ACB\u5373\u7ED1\u5B9A'))));
    };_this.renderLargeCard = function () {
      return _this.renderNormalCard(true);
    };_this.renderBuyBindedCard = function () {
      var serviceInfo = _this.state.payInfo.service || {};if (_this.state.payInfo && _this.state.payInfo.is_bind) {
        return _this.renderNormalCard(false, true, _this.state.payInfo.is_buy);
      }return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-success-bg error' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-success-card error' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-item-label' }, '\u4EA7\u54C1\u540D\u79F0'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-item-value', style: { marginBottom: '.3rem' } }, serviceInfo.name), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-item-label' }, '\u8BF7\u6C42\u6B21\u6570'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-item-value', style: { marginBottom: '.3rem' } }, _this.state.payInfo.is_buy ? '-' : serviceInfo.capacity), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'sass-buy-item-des error' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', null, '\u7ED1\u5B9A\u9ED8\u8BA4\u8054\u7CFB\u65B9\u5F0F\uFF0C\u4EAB\u53D7\u66F4\u4F18\u8D28\u670D\u52A1\u3002'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', { className: 'saas-buy-item-des-bind', href: '/console/#/userCenter' }, '\u7ACB\u5373\u7ED1\u5B9A'))));
    };_this.payFristAction = function (params) {
      _this.props.fetchApimealPay(params).then(function (data) {
        if (data.data.status === 0) {
          // 购买成功
          _this.hmt();_this.setState({ status: _this.state.payInfo.is_bind ? payStatus.pay : payStatus.payBind });_this.props.fetchActivityGetService({ 'instance_id': params.instance_id });
        } else if (data.data.status === 404008) {
          // 未实名
          Object(__WEBPACK_IMPORTED_MODULE_7__actions_buyAction__["f" /* fetchRealName */])({ 'instance_id': params.instance_id }).then(function (res) {
            _this.setState({ modal1: true, authType: res && res.data && res.data['auth_type'] || 0 });
          });
        } else if (data.data.description) {
          _this.setState({ toastTitle: data.data.description, toast: true });
        }
      });
    };_this.payAction = function (item) {
      var _this$props = _this.props,
          activityGetService = _this$props.activityGetService,
          instanceGetinstance = _this$props.instanceGetinstance,
          userLoginstate = _this$props.userLoginstate;var loginUrl = _this.state.loginUrl;if (item.is_buy) {
        return false;
      }if (!_this.isEmptyobj(activityGetService) && userLoginstate.status === 0) {
        var key = Object.keys(instanceGetinstance.data)[0];var json = { 'instance_id': key, 'service_id': item.service_id, 'meal_id': item.meal_id };_this.props.fetchApimealPay(json).then(function (data) {
          if (data.data.status === 0) {
            // 购买成功
            _this.hmt();_this.props.fetchActivityGetService({ 'instance_id': key });_this.setState({ modal2: true, lookUrl: item.url });
          } else if (data.data.status === 404008) {
            // 未实名
            Object(__WEBPACK_IMPORTED_MODULE_7__actions_buyAction__["f" /* fetchRealName */])({ 'instance_id': key }).then(function (res) {
              _this.setState({ modal1: true, authType: res && res.data && res.data['auth_type'] || 0 });
            });
          } else if (data.data.status === 404008) {
            // 未登录
            location.href = loginUrl;
          } else if (data.data.description) {
            _this.setState({ toastTitle: data.data.description, toast: true });
          }
        });
      } else {
        location.href = loginUrl;
      }
    };_this.state = { modal1: false, modal2: false, toast: false, toastTitle: '', lookUrl: '', status: -1, payInfo: {}, authType: 0, // 是不是企业认证
      loginUrl: _this.loginUrl() };_this.renders = [_this.renderNormalCard, _this.renderLargeCard, _this.renderBuyBindedCard];return _this;
  }_createClass(Buy, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        location.href = '/activity/buy' + location.search;
      }
    } }, { key: 'componentWillReceiveProps', value: function componentWillReceiveProps(nextProps) {
      var nextUser = nextProps.userLoginstate;if (!Object.is(nextUser, this.props.userLoginstate)) {
        this.fetchBuyData(nextUser);
      }
    } }, { key: 'hmt', value: function hmt() {
      try {
        window._hmt.push(['_trackEvent', 'gmplugin', 'use', 'mobile']);
      } catch (e) {
        return;
      }
    } }, { key: 'render', value: function render() {
      var _this3 = this;var activityGetService = this.props.activityGetService;var _state = this.state,
          modal1 = _state.modal1,
          modal2 = _state.modal2,
          lookUrl = _state.lookUrl;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy' }, this.renderBuySuccessBody(), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-pro' }, !this.isEmptyobj(activityGetService) ? activityGetService.data.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-item', key: index }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-name' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: item.is_hot ? 'hot' : null }, item.service_name), item.is_hot ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('i', { className: 'saas-buy-hot' }) : null), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-text' }, item.service_desc), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-info' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', { href: item.url, target: '_blank' }, '\u67E5\u770B\u8BE6\u60C5 ', __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('i', null))), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-item-hint' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', null, '\u514D\u8D39\u4F53\u9A8C\u65F6\u957F\uFF1A'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', null, item.is_buy ? '-' : item.capacity)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: item.is_buy ? 'saas-buy-btn disable' : 'saas-buy-btn', onClick: _this3.payAction.bind(_this3, item) }, item.is_buy ? '已领取' : '免费领取'));
      }) : null), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default.a, { visible: modal1, transparent: true, maskClosable: true, className: 'saas-attest', onClose: this.onClose('modal1') }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'hint' }, '\u60A8\u7684\u8D26\u53F7\u8FD8\u6CA1\u6709\u8BA4\u8BC1\uFF0C\u8BA4\u8BC1\u540E\u624D\u80FD\u8D2D\u4E70\u54E6\uFF01'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', { className: 'saas-buy-btn', href: this.state.authType === 0 ? this.userCenterUrl() : '/console/#/attestation' // target={'_blank'}
        , onClick: function onClick() {
          _this3.setState({ modal1: false });
        } }, '\u53BB\u8BA4\u8BC1')), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default.a, { visible: modal2, transparent: true, maskClosable: false, className: 'saas-attest', onClose: this.onClose('modal2') }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'hint' }, '\u8D2D\u4E70\u6210\u529F\uFF0C\u53EF\u524D\u5F80\u63A7\u5236\u53F0\u67E5\u770B\u4F7F\u7528\u8BF4\u660E'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'operate' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', { className: 'saas-buy-btn hint-btn', href: lookUrl, target: '_blank', onClick: function onClick() {
          _this3.setState({ modal2: false });
        } }, '\u53BB\u63A7\u5236\u53F0'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'saas-buy-btn', onClick: function onClick() {
          _this3.setState({ modal2: false });
        } }, '\u7EE7\u7EED\u8D2D\u4E70'))), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default.a, { visible: this.state.toast, transparent: true, maskClosable: false, wrapClassName: 'spu-modal-confirm', className: 'saas-attest', onClose: this.onClose('modal2') }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'hint' }, this.state.toastTitle), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'operate' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('a', { className: 'saas-buy-btn', onClick: function onClick(e) {
          e.preventDefault();_this3.setState({ toast: false, toastTitle: '' });
        } }, '\u5173\u95ED'))));
    } }]);return Buy;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]), _class.propTypes = { userLoginstate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, activityGetService: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, instanceGetinstance: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, fetchApimealPay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, fetchActivityGetService: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, fetchInstanceGetInstance: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func }, _temp);function mapStateToProps(state) {
  return { userLoginstate: state.userLoginstate, activityGetService: state.activityGetService, instanceGetinstance: state.instanceGetinstance };
}function mapDispatchToProps(dispatch) {
  return { fetchApimealPay: function fetchApimealPay(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__actions_buyAction__["b" /* fetchApimealPay */])(dispatch, obj);
    }, fetchActivityGetService: function fetchActivityGetService(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__actions_buyAction__["a" /* fetchActivityGetService */])(dispatch, obj);
    }, fetchInstanceGetInstance: function fetchInstanceGetInstance() {
      return Object(__WEBPACK_IMPORTED_MODULE_7__actions_buyAction__["d" /* fetchInstanceGetInstance */])(dispatch);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Buy));

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lq.909ea937.png";

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivityAddress; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_activityAction__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 抽奖地址页
  * @author: wence
  */var ActivityAddress = function (_PureComponent) {
  _inherits(ActivityAddress, _PureComponent);function ActivityAddress(props) {
    var _this2 = this;_classCallCheck(this, ActivityAddress);var _this = _possibleConstructorReturn(this, (ActivityAddress.__proto__ || Object.getPrototypeOf(ActivityAddress)).call(this, props));_this.getActivityId = function () {
      return ((_this.state.activityInfo || {}).activity || {}).activity_id;
    };_this.fetchPrizeInfo = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              _context.next = 2;return Object(__WEBPACK_IMPORTED_MODULE_4__actions_activityAction__["c" /* fetchPrizeInfo */])({ aid: _this.getActivityId(), flag: __WEBPACK_IMPORTED_MODULE_5__index__["c" /* flag */] });case 2:
              res = _context.sent;if (res.status === 0) {
                _this.setState({ banAddress: res.data.ban, prizeList: res.data.info });if (res.data && res.data.length <= 0) {
                  _this.confirm = Object(__WEBPACK_IMPORTED_MODULE_5__index__["a" /* confirm */])({ title: '', content: '这里空空哦～快去抽奖吧', okText: '返回抽奖', okClick: function okClick() {
                      _this.confirm && _this.confirm();window.location.href = '/m/activity/prize';
                    } });
                }
              } else if (res.status === 401) {
                _this.confirm = Object(__WEBPACK_IMPORTED_MODULE_5__index__["a" /* confirm */])({ title: '', content: res.description, okText: '去登录', okClick: function okClick() {
                    _this.confirm && _this.confirm();window.location.href = _this.loginUrl();
                  } });
              }case 4:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2);
    }));_this.fetchActivityInfo = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              _context2.next = 2;return Object(__WEBPACK_IMPORTED_MODULE_4__actions_activityAction__["a" /* fetchActivityInfo */])({ flag: __WEBPACK_IMPORTED_MODULE_5__index__["c" /* flag */], 'is_wap': 1 });case 2:
              res = _context2.sent;if (res.status === 0) {
                _this.setState({ activityInfo: res.data });
              } else {
                _this.setState({ activityInfo: {} });
              }case 4:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2);
    }));_this.state = { prizeList: [], visible: false, banAddress: false, prizeInfo: null, activityInfo: {}, conMinHeight: 0 };if (_this.isPC()) {
      location.href = '/activity/address';
    }return _this;
  }_createClass(ActivityAddress, [{ key: 'componentDidMount', value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var footer;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                footer = document.querySelector('.footer-bar');this.setState({ conMinHeight: window.innerHeight - footer.offsetHeight });_context3.next = 4;return this.fetchActivityInfo();case 4:
                _context3.next = 6;return this.fetchPrizeInfo();case 6:case 'end':
                return _context3.stop();}
          }
        }, _callee3, this);
      }));function componentDidMount() {
        return _ref3.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          prizeList = _state.prizeList,
          banAddress = _state.banAddress;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { minHeight: this.state.conMinHeight }, className: 'w-activity w-activity-address-content' }, prizeList && prizeList.length > 0 ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__modal__["a" /* default */], { aid: this.getActivityId(), resetData: function resetData() {
          return _this3.fetchPrizeInfo();
        }, visible: this.state.visible, successMsg: '信息提交成功', parizeInfo: this.state.prizeInfo, onCancel: function onCancel() {
          return _this3.setState({ visible: false, parizeInfo: null });
        } }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-activity-banner' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-section-title padding-top-100' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3', { className: 'w-section-title-text' }, '\u6211\u7684\u5956\u54C1')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-activity-address' }, prizeList.map(function (prizeInfo, index) {
        var hasBtn = prizeInfo.prize_type === 1;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('w-activity-address-item-wrapper', { 'has-btn': prizeInfo.prize_type !== 1 || hasBtn && !prizeInfo.address }) }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'w-activity-address-item' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u7F16\u53F7\uFF1A'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, index + 1)), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u65F6\u95F4\uFF1A'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, prizeInfo.prize_time)), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', null, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u5956\u54C1\u540D\u79F0\uFF1A'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, prizeInfo.prize_name)), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p', { className: 'address' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u5730\u5740\u4FE1\u606F\uFF1A'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, prizeInfo.address || '-')), hasBtn && !prizeInfo.address ? banAddress ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { onClick: function onClick() {
            if (prizeInfo.prize_type === 1) {
              _this3.setState({ prizeInfo: prizeInfo, visible: true });
            }
          }, className: 'product-btn w-address-btn' }, '\u586B\u5199\u5730\u5740') : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'product-btn  w-address-btn disabled' }, '\u5DF2\u8FC7\u671F') : '', !hasBtn && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: '/console/#/orderView', target: '_blank', className: 'product-btn w-address-btn' }, '\u524D\u5F80\u63A7\u5236\u53F0')));
      }))) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { style: { minHeight: this.state.conMinHeight }, className: 'w-activity-empty' }, '\u8FD9\u91CC\u7A7A\u7A7A\u54E6\uFF5E\u5FEB\u53BB\u62BD\u5956\u5427'));
    } }]);return ActivityAddress;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__activity__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_activitySuAction__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_buyAction__ = __webpack_require__(30);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 云加速活动
  * @author: wence
  */var ActivitySu = function (_PureComponent) {
  _inherits(ActivitySu, _PureComponent);function ActivitySu(props) {
    var _this2 = this;_classCallCheck(this, ActivitySu);var _this = _possibleConstructorReturn(this, (ActivitySu.__proto__ || Object.getPrototypeOf(ActivitySu)).call(this, props));_this.resetHtmlFont = function () {
      // 部分机型显示有问题
      var html = document.querySelector('html');var fontSize = window.getComputedStyle(html).fontSize.replace('px', '');html.style.fontSize = Math.ceil(fontSize) + 'px';
    };_this.getVoucher = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var params, res, serverList;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {case 0:
              if (_this.state.isLogin) {
                _context.next = 3;break;
              }_this.loginUrl();return _context.abrupt('return');case 3:
              params = { channel: '1' };if (_this.instanceId) {
                params['instance_id'] = _this.instanceId;
              }_context.next = 7;return Object(__WEBPACK_IMPORTED_MODULE_4__actions_activitySuAction__["a" /* getVoucher */])(params);case 7:
              res = _context.sent;if (res.status === 0) {
                serverList = res.data && res.data.service_list || [];_this.setState({ serverList: serverList, voucherList: res.data && res.data.list || [], advServer: serverList.find(function (i) {
                    return i.version === 'adv';
                  }), entServer: serverList.find(function (i) {
                    return i.version === 'ent';
                  }) });
              } else if (res.status === 401) {
                _this.loginUrl();
              } else if (res.description) {
                _this.confirm = Object(__WEBPACK_IMPORTED_MODULE_3__activity__["a" /* confirm */])({ title: '', content: res.description, okText: '关闭', isAnimation: false, okClick: function okClick() {
                    return _this.confirm && _this.confirm();
                  } });
              }case 9:case 'end':
              return _context.stop();}
        }
      }, _callee, _this2);
    }));_this.payVoucher = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(item, btnUrl) {
        var params, localKey, dataStr, data, res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {case 0:
                params = { 'instance_id': _this.instanceId, 'channel': '1', 'voucher_id': item.voucher_id };try {
                  localKey = '__abbaidu_20181211_cb';dataStr = localStorage.getItem(localKey);data = JSON.parse(dataStr);params.data = data.data;params['key_id'] = data.key_id;params.sign = data.sign;
                } catch (e) {
                  params.data = '';params['key_id'] = '';params.sign = '';
                }_context2.next = 4;return Object(__WEBPACK_IMPORTED_MODULE_4__actions_activitySuAction__["b" /* payVoucher */])(params);case 4:
                res = _context2.sent;if (res.status === 0) {
                  _this.confirm = Object(__WEBPACK_IMPORTED_MODULE_3__activity__["a" /* confirm */])({ title: '', content: '<div class="su-modal-title">已成功领取优惠券</div>' + '进入“ <a class="su-link" target="_blank" href="/console/#/orderView">商务中心</a> ”查看对应优惠券', okText: '立即使用', isAnimation: false, okClick: function okClick() {
                      return window.location.href = btnUrl;
                    } });
                } else if (res.status === 401) {
                  window.location.href = _this.loginUrl();
                } else if (res.description) {
                  _this.confirm = Object(__WEBPACK_IMPORTED_MODULE_3__activity__["a" /* confirm */])({ title: '', content: res.description, okText: '关闭', isAnimation: false, okClick: function okClick() {
                      return _this.confirm && _this.confirm();
                    } });
                }case 6:case 'end':
                return _context2.stop();}
          }
        }, _callee2, _this2);
      }));return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();_this.state = { isLogin: false, voucherList: [], serverList: [], advServer: {}, entServer: {} };_this.instanceId = '';if (_this.isPC()) {
      location.href = '/activity/su';
    }return _this;
  }_createClass(ActivitySu, [{ key: 'componentDidMount', value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var fetchInstanceGetInstance, instanceRes;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {case 0:
                fetchInstanceGetInstance = this.props.fetchInstanceGetInstance;_context3.next = 3;return fetchInstanceGetInstance();case 3:
                instanceRes = _context3.sent; // if (this.isAndroid()) {
                //     this.resetHtmlFont();
                // }
                if (instanceRes.data && instanceRes.data.status === 0) {
                  this.instanceId = Object.keys(instanceRes.data.data)[0];this.setState({ isLogin: true });
                } else if (instanceRes.data && instanceRes.data.status === 401) {
                  this.setState({ isLogin: false });
                }this.getVoucher();case 6:case 'end':
                return _context3.stop();}
          }
        }, _callee3, this);
      }));function componentDidMount() {
        return _ref3.apply(this, arguments);
      }return componentDidMount;
    }() }, { key: 'getPayUrl', value: function getPayUrl(index) {
      var advServer = this.state.advServer || {};if (index === 0 || index === 1) {
        return '/console/#/scan/buy?' + 'serviceId=' + advServer.service_id + '&mealId=' + advServer.meal_id + '&time=' + (index === 0 ? '2592000' : '31536000');
      } // 企业版
      var entServer = this.state.entServer || {};if (index === 2) {
        return '/console/#/scan/buy?' + 'serviceId=' + entServer.service_id + '&mealId=' + entServer.meal_id + '&time=31536000';
      }
    } }, { key: 'render', value: function render() {
      var _this3 = this;var list = [{ title: '专业版月度套餐', url: 'https://anquan.baidu.com/page/5', price: 100, giftBg: __webpack_require__(258) }, { title: '专业版年度套餐', url: 'https://anquan.baidu.com/page/5', price: 400, giftBg: __webpack_require__(259) }, { title: '企业版年度套餐', url: 'https://anquan.baidu.com/page/5', price: 8000, giftBg: __webpack_require__(260) }];var suList = [{ title: '专业版年度套餐', url: 'https://su.baidu.com/plan.html', price: 200, giftBg: __webpack_require__(258), btnUrl: 'https://su.baidu.com/home/buy-plan?plan=pro' }, { title: '商业版年度套餐', url: 'https://su.baidu.com/plan.html', price: 800, giftBg: __webpack_require__(259), btnUrl: 'https://su.baidu.com/home/buy-plan?plan=bus' }, { title: '企业版年度套餐', url: 'https://su.baidu.com/plan.html', price: 5000, giftBg: __webpack_require__(260), btnUrl: 'https://su.baidu.com/home/buy-plan?plan=ent' }];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'saas-su-page' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'saas-su-banner bg' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'saas-su-banner title1' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'su-mod-des1' }, '\u6D3B\u52A8\u671F\u95F4\uFF0C\u9886\u53D6\u4F18\u60E0\u5238\u5373\u53EF\u4EAB\u53D7\u4E13\u5C5E\u4F18\u60E0\uFF0C\u4E13\u4E1A\u7248\u5957\u9910\u4F4E\u81F3199/\u6708\uFF0C\u4F01\u4E1A\u7248\u5E74\u5957\u9910\u7ACB\u51CF8000\u5143\uFF01'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'su-mod-content1' }, '\u5168\u9762\u8D44\u4EA7\u76D1\u63A7\uFF1A\u5FEB\u901F\u8BC6\u522B\u8D44\u4EA7\u3001\u5927\u5E45\u63D0\u9AD8\u626B\u63CF\u6548\u7387\u3001\u4F4E\u6210\u672C\u63A5\u5165', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '\u98CE\u9669\u8D44\u4EA7\u8BC6\u522B\uFF1A\u57FA\u4E8E\u6D77\u91CF\u6F0F\u6D1E\u77E5\u8BC6\u5E93\uFF0C\u53D1\u73B0\u8D44\u4EA7\u98CE\u9669\uFF0C\u4FDD\u969C\u8D44\u4EA7\u5B89\u5168', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '\u6F0F\u6D1E\u626B\u63CF\u53D1\u73B0\uFF1A\u5B9E\u73B0\u5BF9OWASP Top 10\u6F0F\u6D1E\u7C7B\u578B\u3001\u6570\u5343\u9AD8\u5371\u6F0F\u6D1EPOC\u8986\u76D6\u8FBE99%\u4EE5\u4E0A', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '\u7F51\u9875\u5B89\u5168\u68C0\u6D4B\uFF1A\u5FEB\u901F\u8BC6\u522B\u6D89\u9EC4\u8D4C\u6BD2\u3001\u6B3A\u8BC8\u5185\u5BB9\u3001\u7BE1\u6539\u9875\u9762\u3001\u6302\u9A6C\uFF0C\u89C4\u907F\u6CD5\u5F8B\u98CE\u9669'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'saas-su-mod1', style: { marginTop: '1rem' } }, list.map(function (item, index) {
        var btnUrl = _this3.getPayUrl(index);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, className: 'child' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'child-inner' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'saas-su-card' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { className: 'link', href: item.url }, '产品详情 >'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'detail' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'detail-price' }, item.price), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'detail-content' }, '\u5143\u4E13\u5C5E', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '\u4EE3\u91D1\u5238'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'detail-btn', onClick: _this3.payVoucher.bind(_this3, _this3.state.voucherList[index] || {}, btnUrl) }, '\u7ACB\u5373', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '\u9886\u5238')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'gift', style: { backgroundImage: 'url(' + (item.giftBg || '') + ')' } }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { className: 'btn', href: btnUrl }, '\u7ACB\u5373\u8D2D\u4E70'))));
      })), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'saas-su-banner title2' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'saas-su-banner detail1' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'saas-su-banner title3' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'saas-su-mod2', style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'planlist' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'child' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'child-inner new-pay' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'left' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'title' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', null, '\u65B0\u57DF\u540D\u4EAB\u597D\u793C'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'title-des' }, 'NEW')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'detail' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'detail-price' }, '15\u5929'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', { className: 'detail-conetnt' }, '\u4E13\u4E1A\u7248\u5151\u6362\u5238'))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'right' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: 'https://m-su.baidu.com/#/activity/5eba43a41768e5f6fa874267?' + 'hmsr=%E6%BC%8F%E6%B4%9E%E6%89%AB%E6%8F%8F-' + 'wap&hmpl=%E6%BC%8F%E6%B4%9E%E6%89%AB%E6%8F%8F' + '-wap&hmcu=&hmkw=&hmci=', className: 'right-btn' }, '\u7ACB \u5373', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '\u9886 \u5238')))))), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'saas-su-banner title4' }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'saas-su-mod1', style: { marginTop: '1rem', paddingBottom: '1rem' } }, suList.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { key: index, className: 'child' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'child-inner' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'saas-su-card' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { className: 'link', href: item.url }, '产品详情 >'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'detail' }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'detail-price' }, item.price), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'detail-content' }, '\u5143\u7EED\u8D39', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '\u4EE3\u91D1\u5238'), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { href: 'https://m-su.baidu.com/#/activity/5eba43a41768e5f6fa874267?' + 'hmsr=%E6%BC%8F%E6%B4%9E%E6%89%AB%E6%8F%8F-wap' + '&hmpl=%E6%BC%8F%E6%B4%9E%E6%89%AB%E6%8F%8F' + '-wap&hmcu=&hmkw=&hmci=', className: 'detail-btn' }, '\u7ACB\u5373', __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null), '\u9886\u5238')), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: 'gift', style: { backgroundImage: 'url(' + (item.giftBg || '') + ')' } }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a', { className: 'btn', href: 'https://m-su.baidu.com/#/activity/5eba43a41768e5f6fa874267?' + 'hmsr=%E6%BC%8F%E6%B4%9E%E6%89%AB%E6%8F%8F-' + 'wap&hmpl=%E6%BC%8F%E6%B4%9E%E6%89%AB%E6%8F%8F' + '-wap&hmcu=&hmkw=&hmci=' }, '\u7ACB\u5373\u7EED\u8BA2'))));
      })));
    } }]);return ActivitySu;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state) {
  return { instanceGetinstance: state.instanceGetinstance };
}, function (dispatch) {
  return { fetchInstanceGetInstance: function fetchInstanceGetInstance() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }return __WEBPACK_IMPORTED_MODULE_6__actions_buyAction__["d" /* fetchInstanceGetInstance */].apply(undefined, [dispatch].concat(args));
    } };
})(ActivitySu));

/***/ }),
/* 764 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivityResume; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp2;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 返工活动
  * @author: wence
  */var Modal = (_temp2 = _class = function (_Component) {
  _inherits(Modal, _Component);function Modal() {
    var _ref;var _temp, _this, _ret;_classCallCheck(this, Modal);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.top = 0, _temp), _possibleConstructorReturn(_this, _ret);
  }_createClass(Modal, [{ key: 'componentDidMount', value: function componentDidMount() {
      document.body.style.width = '100%';var navBar = document.querySelector('.nav-bar');this.top = window.scrollY;document.body.style.top = -this.top + 'px';document.body.style.position = 'fixed';navBar.style.top = 0;
    } }, { key: 'componentWillUnmount', value: function componentWillUnmount() {
      document.body.style.width = '';var navBar = document.querySelector('.nav-bar');navBar.style.top = '';document.body.style.position = '';document.body.style.top = '';document.body.scrollTop = document.documentElement.scrollTop = this.top;
    } }, { key: 'render', value: function render() {
      var _props = this.props,
          visible = _props.visible,
          onCancel = _props.onCancel;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('spu-resume-modal', { on: visible }) }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mask' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'body' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u6D3B\u52A8\u89C4\u5219'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content-inner-text' }, '\u6D3B\u52A8\u65F6\u95F4\uFF1A2020\u5E745\u670829\u65E5 - 6\u670818\u65E5\uFF1B', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u79D2\u6740\u65F6\u95F4\uFF1A2020\u5E745\u670829\u65E5\u8D77\uFF0C\u9650\u65F6\u79D2\u6740\u62A2\u5360\u4F18\u60E0\u8D44\u683C\uFF0C\u62A2\u5B8C\u4E3A\u6B62\uFF1B', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u6D3B\u52A8\u9002\u7528\u4EBA\u7FA4\uFF1A\u767E\u5EA6\u5B89\u5168\u65B0\u8001\u7528\u6237\u7686\u53EF\u53C2\u4E0E\uFF0C\u63D0\u4EA4\u8868\u5355\u6210\u529F\u540E\uFF0C \u5C06\u6709\u5BA2\u670D24\u5C0F\u65F6\u4E4B\u5185\u4E0E\u60A8\u8054\u7CFB\uFF0C\u6216\u5728\u7EBF\u54A8\u8BE2/\u81F4\u7535\u54A8\u8BE2010-58003138\uFF0C \u62A2\u5360\u79D2\u6740\u4EF7\u683C\u5E76\u5B8C\u6210\u540E\u7EED\u8D2D\u4E70\u6D41\u7A0B\uFF1B\u53C2\u4E0E\u6D3B\u52A8\u7684\u7528\u6237\u5E94\u540C\u65F6\u9075\u5B88\u767E\u5EA6\u5B89\u5168\u5B98\u7F51\u6240\u793A\u7684\u300A\u7528\u6237\u670D\u52A1\u534F\u8BAE\u300B\u3001 \u4EA7\u54C1\u76F8\u5173\u7684\u534F\u8BAE\u53CA\u9875\u9762\u4F7F\u7528\u89C4\u5219\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4EA7\u54C1\u670D\u52A1\u7B49\u7EA7\u534F\u8BAE\uFF0C\u4F7F\u7528\u89C4\u8303\uFF0C\u4EA7\u54C1\u670D\u52A1\u6761\u6B3E\u7B49\uFF09\uFF1B', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u5BF9\u4E8E\u901A\u8FC7\u6076\u610F\u6CE8\u518C\u6216\u5176\u4ED6\u4E0D\u6B63\u5F53\u624B\u6BB5\u5728\u672C\u6B21\u6D3B\u52A8\u4E2D\u8FDB\u884C\u975E\u6CD5\u725F\u5229\u3001\u7092\u4F5C\u3001\u8F6C\u552E\u3001\u83B7\u5956\u3001\u865A\u5047\u4EA4\u6613\u7684\u7528\u6237\uFF0C \u767E\u5EA6\u5B89\u5168\u6709\u6743\u53D6\u6D88\u5176\u8D44\u683C\u6216\u5176\u56E0\u53C2\u52A0\u6D3B\u52A8\u6240\u83B7\u6743\u76CA\uFF0C\u6709\u6743\u91C7\u53D6\u5305\u62EC\u4E0D\u9650\u4E8E\u505C\u6B62\u670D\u52A1\u3001\u5C01\u505C\u5E10\u53F7\u3001\u51BB\u7ED3\u4EE3\u91D1\u5238\u7B49\u6B62\u635F\u548C\u4FDD\u62A4\u63AA\u65BD\uFF1B \u5982\u8BE5\u8FDD\u89C4\u884C\u4E3A\u7ED9\u767E\u5EA6\u5B89\u5168\u9020\u6210\u635F\u5931\u7684\uFF0C\u767E\u5EA6\u5B89\u5168\u4FDD\u7559\u8FFD\u7A76\u5176\u6C11\u4E8B\u8D23\u4EFB\u548C\u5211\u4E8B\u8D23\u4EFB\u7684\u6743\u5229\uFF1B', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u767E\u5EA6\u5B89\u5168\u5728\u6CD5\u5F8B\u5141\u8BB8\u7684\u8303\u56F4\u5185\u4EAB\u6709\u5BF9\u672C\u6D3B\u52A8\u7684\u89E3\u91CA\u6743\u3002'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'footer' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spu-activity-btn', onClick: onCancel }, '\u786E\u8BA4'))));
    } }]);return Modal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { visible: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, onCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func }, _temp2);var ActivityResume = function (_Component2) {
  _inherits(ActivityResume, _Component2);function ActivityResume(props) {
    _classCallCheck(this, ActivityResume);var _this2 = _possibleConstructorReturn(this, (ActivityResume.__proto__ || Object.getPrototypeOf(ActivityResume)).call(this, props));_this2.getUnicodeName = function (name) {
      return encodeURIComponent(name);
    };_this2.state = { visible: false };if (_this2.isPC()) {
      window.location.href = '/activity/resume';
    }return _this2;
  }_createClass(ActivityResume, [{ key: 'render', value: function render() {
      var _this3 = this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spu-activity-resume' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'banner' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-title' }, '\u5373\u523B\u63D0\u4EA4\u8868\u5355\u62A2\u5360\u9650\u65F6\u79D2\u6740\u8D44\u683C'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-card icon1' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-card-title' }, '\u8F6F\u786C\u4EF6\u4E00\u4F53\u591A\u4EBA\u5FEB\u901F\u6D4B\u6E29\u7CFB\u7EDF\uFF08\u4E2D\u901A\u91CF\u7248\uFF09'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-card-point icon1' }, '\u786C\u4EF6\u8BBE\u5907\uFF1A\u591A\u4EBA\u4F53\u6E29\u68C0\u6D4B\u667A\u80FD\u7EC8\u7AEFGTT'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-card-des' }, '200\u4E07\u9AD8\u7CBE\u5EA6\u4EBA\u8138+\u4F53\u6E29\u68C0\u6D4B\u53CC\u76EE\u6444\u50CF\u673A', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u56FD\u4EA7\u6D4B\u6E29\u4F20\u611F\u5668\u82AF\u7247', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u6D4B\u6E29\u8303\u56F4\uFF1A0\u2103~50\u2103', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u6D4B\u6E29\u7CBE\u786E\u5EA6\xB10.5\u5EA6', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-card-point icon2' }, '\u8F6F\u4EF6\u5E73\u53F0\uFF1A\u7269\u53EF\u89C6IOTVIZ'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-card-des' }, '\u5B9E\u73B0\u8BBE\u5907\u63A5\u5165\u3001\u7BA1\u7406\u3001\u8FDC\u7A0B\u63A7\u5236', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u6240\u6709\u6570\u636E\u53CA\u56FE\u50CF\u5747\u6709\u8FF9\u53EF\u5FAA', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u652F\u6301\u6570\u636E\u7EDF\u8BA1\u5206\u6790\u3001\u56FE\u50CF\u67E5\u770B\u4E0B\u8F7D\u7B49', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u63A8\u8350\u5B66\u6821\uFF0C\u529E\u516C\u533A\u573A\u666F\u4F7F\u7528', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spick-card-price' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'price' }, '35000'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'unit' }, '\u5143/\u5957'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u770135000\u5143')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/apply?name=' + this.getUnicodeName('#百度AI体温检测秒杀活动# 软硬件一体多人快速测温系统（中通量版）'), className: 'spu-activity-btn' }, '\u9650\u91CF\u79D2\u6740'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spu-card-mobile' }, '\u7535\u8BDD\u62A2\u8D2D\uFF1A010-58003138')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-card icon2', style: { marginTop: '.4rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-card-title' }, '\u5355\u4EBA\u95E8\u7981\u667A\u80FD\u6D4B\u6E29\u7CFB\u7EDF\uFF08\u4F4E\u901A\u91CF\u7248\uFF09'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-card-des' }, '\u4F53\u6E29\u68C0\u6D4B+\u4EBA\u8138\u8BC6\u522B\u667A\u80FD\u529F\u80FD\u53CC\u96C6\u6210', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u5185\u7F6E\u9AD8\u7CBE\u5EA6\u70ED\u7EA2\u5916\u6A21\u5757', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u6D4B\u6E29\u8303\u56F4\uFF1A35\u2103~42\u2103', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u6700\u4F18\u6D4B\u6E29\u8DDD\u79BB0.5\u7C73', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u6D4B\u6E29\u7CBE\u786E\u5EA6\xB10.5\u2103', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u4E3B\u7801\u6D41\uFF1A1920*1080', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u5C3A\u5BF8\uFF1A215x125x25mm', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-card-des' }, '\u652F\u6301\u4F4E\u6E29\u62A5\u8B66\u3001\u9AD8\u6E29\u62A5\u8B66\u53CA\u533A\u57DF\u6E29\u5DEE\u62A5\u8B66\u7B49\u591A\u79CD\u62A5\u8B66\u65B9\u5F0F', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u652F\u6301\u63A5\u53E3\u6570\u636E\u4E0A\u62A5', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u53EF\u5E7F\u6CDB\u5E94\u7528\u4E8E\u901A\u9053\u3001\u95E8\u53E3\u3001\u95F8\u673A\u7B49\u7BA1\u63A7\u51FA\u5165\u53E3\u6216\u6D4B\u6E29\u533A\u57DF', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spick-card-price' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'price' }, '5200'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'unit' }, '\u5143/\u5957'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u770112200\u5143')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/apply?name=' + this.getUnicodeName('#百度AI体温检测秒杀活动# 单人门禁智能测温系统（低通量版）'), className: 'spu-activity-btn' }, '\u9650\u91CF\u79D2\u6740'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spu-card-mobile' }, '\u7535\u8BDD\u62A2\u8D2D\uFF1A010-58003138')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-card-detail' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-card-detail-title' }, '\u6D3B\u52A8\u89C4\u5219'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spike-card-detail-content' }, '\u6D3B\u52A8\u65F6\u95F4\uFF1A2020\u5E745\u670829\u65E5 - 6\u670818\u65E5\uFF1B', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u79D2\u6740\u65B9\u5F0F\uFF1A2020\u5E745\u670829\u65E5\u8D77\uFF0C\u9650\u65F6\u79D2\u6740\u62A2\u5360\u4F18\u60E0\u8D44\u683C\uFF0C\u62A2\u5B8C\u4E3A\u6B62\u3002', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'spu-link', onClick: function onClick() {
          return _this3.setState({ visible: true });
        } }, '\u67E5\u770B\u8BE6\u60C5'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spu-activity-title' }, '\u6838\u5FC3\u4F18\u52BF'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spu-advantage' }, [{ title: '实时高效', des: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\u5728\u5355\u4EBA\u901A\u9053\u987A\u5E8F\u901A\u884C\u6761\u4EF6\u4E0B\uFF0C\u53EF\u57281\u5206\u949F\u5185\u5B9E\u73B0\u5BF9\u903E200\u4EBA\u540C\u65F6\u901A\u8FC7\u7684\u4F53\u6E29\u5B9E\u65F6\u68C0\u6D4B\uFF0C\u5B9E\u73B0\u4EBA\u7FA4\u65E0\u505C\u7559\u8FC7\u68C0\uFF0C\u7F13\u89E3\u4EBA\u5458\u5835\u585E\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '*\u53C2\u8003\u6570\u636E\uFF0C\u53D7\u4EBA\u7FA4\u5BC6\u5EA6\u53CA\u884C\u8FDB\u901F\u5EA6\u5F71\u54CD\u3002')) }, { title: '精准可靠', des: '实现了体温检测与人脸识别的技术同步及佩戴口罩时的识别问题，可准确定位、快速锁定体温异常人员并实时自动告警，方便工作人员进行二次复检。' }, { title: '非接触无感知', des: '借助全自动化的体温检测，被检人员仅需做弱配合，大幅减少相互的近距离接触，降低潜在的安全隐患。' }, { title: '快速部署降低成本', des: '实现检测结果的实时可视化，并可在通道、重要区域快速部署，有效降低成本，缓解疫情防控期间紧张的人力资源调配。' }].map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spu-advantage-item bg' + (index + 1), key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des' }, item.des));
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spu-activity-title' }, '\u5408\u4F5C\u4F19\u4F34'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spu-activity-list' }, '\u5317\u4EAC\u6E05\u6CB3\u706B\u8F66\u7AD9', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u5317\u4EAC\u4E94\u9053\u53E3\u5730\u94C1', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u5317\u4EAC\u5927\u5B66\u9644\u5C5E\u5C0F\u5B66', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u4E2D\u5173\u6751\u4E00\u5C0F', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u4E2D\u5173\u6751\u4E8C\u5C0F', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u516B\u91CC\u5E84\u5C0F\u5B66', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u5317\u822A\u5927\u5B66\u6821\u533A', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u5317\u4EAC\u6570\u5B57\u5927\u53A6', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u5317\u4EAC\u957F\u5B89\u5546\u573A', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u5317\u4EAC\u534E\u8054\u5546\u8D8510\u4F59\u5BB6', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u5317\u4EAC\u516B\u5B9D\u5C71\u516C\u5893\u7B4920\u5904\u5893\u56ED', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u90D1\u5DDE\u4E09\u9644\u533B\u9662', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u534E\u6DA6\u7269\u4E1A', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u91D1\u9685\u6587\u5316', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null), '\u7D2B\u91D1\u7269\u4E1A', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spu-footer-container' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spu-footer' }, '\u5373\u523B\u63D0\u4EA4\u8868\u5355\u62A2\u5360\u9650\u65F6\u79D2\u6740\u8D44\u683C', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: '/m/apply?name=' + this.getUnicodeName('#百度AI体温检测秒杀活动#'), className: 'spu-btn' }, '\u7ACB\u5373\u79D2\u6740'))), this.state.visible && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Modal, { key: this.state.key, visible: this.state.visible, onCancel: function onCancel() {
          return _this3.setState({ visible: false });
        } }));
    } }]);return ActivityResume;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_fileCheckAction__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 文件检测
  * @author wangzhuang
  * */var FileCheck = (_temp = _class = function (_Component) {
  _inherits(FileCheck, _Component);function FileCheck(props, context) {
    _classCallCheck(this, FileCheck);var _this = _possibleConstructorReturn(this, (FileCheck.__proto__ || Object.getPrototypeOf(FileCheck)).call(this, props, context));_this.mainLevelFn = function (val) {
      var str = 'tag_weizhi';switch (val) {case 100:case 110:
          str = 'tag_anquan';break;case 150:case 160:
          str = 'tag_weizhi';break;case 170:case 180:
          str = 'tag_keyi';break;case 190:case 200:
          str = 'tag_weixian';break;default:
          return '';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(769)("./" + str + '.svg'), alt: '' });
    };_this.levelFn = function (val) {
      var str = '';var htmlVal = '';switch (parseInt(val, 10)) {case 100:case 110:
          str = 'anquan';htmlVal = '安全';break;case 150:case 160:case 170:case 180:
          str = 'wufajiance';htmlVal = '无法检测';break;case 190:case 200:
          str = 'weixian';htmlVal = '危险';break;default:
          return '';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { backgroundImage: 'url(' + __webpack_require__(774)("./icon_" + str + '.svg') + ')' } }, htmlVal);
    };_this.fileTypeFn = function (type) {
      var str = 'qita';var fileType = /sys|dll|exe/.exec(type);if (fileType) {
        str = fileType[0];
      }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'mod1-top-img', src: __webpack_require__(775)("./icon_file_" + str + '.svg'), alt: '' });
    };_this.state = {};_this.timer = null;_this.timerNum = 0;_this.timerCount = 24; // 轮询两分钟停止
    return _this;
  }_createClass(FileCheck, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;var params = this.props.match.params;if (this.isPC()) {
        location.href = '/vdc/fileCheck?type=' + params.type + '&key=' + params.key;return;
      }this.vdcReportFn();this.timer = setInterval(function () {
        _this2.timerNum++;_this2.vdcReportFn();
      }, 5000);
    } }, { key: 'vdcReportFn', value: function vdcReportFn() {
      var _this3 = this;if (this.timerNum >= this.timerCount) {
        clearInterval(this.timer);
      }var params = this.props.match.params;var json = {};if (params.type === 'report') {
        json.resource = params.key;
      } else {
        json['task_id'] = params.key;
      }this.props.fetchVdcReport(json, params.type).then(function (data) {
        var obj = data.data;if (params.type === 'report') {
          clearInterval(_this3.timer);
        }if (obj && obj.data) {
          if (obj.data.is_auth === 'bot') {
            clearInterval(_this3.timer);
          }if (obj.data.scans && (obj.data.scans.status === 'merged' || obj.data.scans.status === 'error')) {
            clearInterval(_this3.timer);
          }
        }
      });
    } }, { key: 'render', value: function render() {
      var _this4 = this;var _props = this.props,
          vdcReport = _props.vdcReport,
          match = _props.match;var bot = false;var fileInfo = null;var scans = {};if (vdcReport.data) {
        if (vdcReport.data.meta) {
          fileInfo = match.params.type === 'report' ? vdcReport.data.meta : vdcReport.data.meta.file_info;
        }if (vdcReport.data.scans) {
          scans = vdcReport.data.scans;if (scans.status === 'error' && match.params.type !== 'report') {
            bot = true;
          }
        }if (vdcReport.data.is_auth === 'bot') {
          bot = true;
        }
      }if (this.timerNum >= this.timerCount && this.isEmptyobj(vdcReport.data)) {
        bot = true;
      }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'FileCheck' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'fc-title' }, '\u6587\u4EF6\u68C0\u6D4B'), bot ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'fc-bot' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(266), alt: '' }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'fc-bot-text' }, '\u68C0\u6D4B\u7ED3\u679C\u5F02\u5E38\uFF0C\u8BF7\u91CD\u65B0\u68C0\u6D4B\u3002')) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, vdcReport.data && fileInfo ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'fc-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod1-top' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod1-top-left' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'mod1-top-name' }, '\u8BE5\u6587\u4EF6\u7684\u68C0\u6D4B\u7ED3\u679C\u4E3A'), this.mainLevelFn(vdcReport.data.main_level)), this.fileTypeFn(fileInfo.type)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod2-box' }, fileInfo.name ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u6587\u4EF6\u540D\u79F0'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, fileInfo.name)) : null, fileInfo.size ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u6587\u4EF6\u540D\u5927\u5C0F'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, fileInfo.size)) : null, fileInfo.type ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u6587\u4EF6\u7C7B\u578B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, fileInfo.type)) : null, fileInfo.md5 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'MD5'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, fileInfo.md5)) : null, vdcReport.data.scan_date ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u68C0\u6D4B\u65F6\u95F4'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, vdcReport.data.scan_date)) : null)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'fc-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod1-top' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod1-top-left' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'mod1-top-name' }, '\u8BE5\u6587\u4EF6\u7684\u68C0\u6D4B\u7ED3\u679C\u4E3A'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'vdc-loading', src: __webpack_require__(84), alt: '' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'mod1-top-img', src: __webpack_require__(83), alt: '' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod2-box' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u6587\u4EF6\u540D\u79F0'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '...')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u6587\u4EF6\u540D\u5927\u5C0F'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '...')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u6587\u4EF6\u7C7B\u578B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '...')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, 'MD5'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '...')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u68C0\u6D4B\u65F6\u95F4'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '...')))), vdcReport.data && vdcReport.data.scans ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'fc-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod1-top' }, '\u591A\u6E90\u68C0\u6D4B\u7ED3\u679C'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod2-box' }, Object.keys(scans).map(function (item, index) {
        var obj = '';if (typeof scans[item] !== 'string') {
          obj = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod2-con', key: index }, scans[item].level ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod2-res' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: '' }, item), _this4.levelFn(scans[item].level)) : null, scans[item].result ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u75C5\u6BD2\u540D\u79F0'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, scans[item].result)) : null, scans[item].engine_version ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u5F15\u64CE\u7248\u672C'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, scans[item].engine_version)) : null, scans[item].library_version ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, '\u75C5\u6BD2\u5E93\u7248\u672C'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, scans[item].library_version)) : null);
        }return obj;
      })))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'fc-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { paddingBottom: '1.6rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod1-top' }, '\u591A\u6E90\u68C0\u6D4B\u7ED3\u679C'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: 'vdc-loading mod2-loading', src: __webpack_require__(84), alt: '' })))));
    } }]);return FileCheck;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { match: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, vdcReport: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, fetchVdcReport: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func }, _temp);function mapStateToProps(state) {
  return { vdcReport: state.vdcReport };
}function mapDispatchToProps(dispatch) {
  return { fetchVdcReport: function fetchVdcReport(obj, type) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__actions_fileCheckAction__["b" /* fetchVdcReport */])(dispatch, obj, type);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(FileCheck));

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon_anquan.svg": 261,
	"./icon_biaozhunhua.svg": 134,
	"./icon_duopingtai.svg": 131,
	"./icon_duorenwu.svg": 132,
	"./icon_file.svg": 244,
	"./icon_file_apk.svg": 150,
	"./icon_file_click.svg": 141,
	"./icon_file_dex.svg": 151,
	"./icon_file_dll.svg": 152,
	"./icon_file_dmg.svg": 153,
	"./icon_file_doc.svg": 154,
	"./icon_file_elf.svg": 155,
	"./icon_file_exe.svg": 156,
	"./icon_file_loading.svg": 83,
	"./icon_file_pdf.svg": 157,
	"./icon_file_qita.svg": 158,
	"./icon_file_so.svg": 159,
	"./icon_file_sys.svg": 160,
	"./icon_gaotuntu.svg": 126,
	"./icon_input_search.svg": 262,
	"./icon_jingzhunjiance.svg": 125,
	"./icon_keyanzheng.svg": 135,
	"./icon_kuaisujieru.svg": 127,
	"./icon_search.svg": 240,
	"./icon_search_click.svg": 241,
	"./icon_spinner_large.svg": 84,
	"./icon_spinner_small.svg": 263,
	"./icon_url.svg": 242,
	"./icon_url_click.svg": 243,
	"./icon_weixian.svg": 264,
	"./icon_wufajiance.svg": 265,
	"./icon_yinsibaohu.svg": 128,
	"./icon_yunduanheihe.svg": 133,
	"./pic_normalerror.svg": 266,
	"./sp_duli.svg": 231,
	"./sp_lingxian.svg": 229,
	"./sp_wending.svg": 230,
	"./tag_anquan.svg": 770,
	"./tag_keyi.svg": 771,
	"./tag_weixian.svg": 772,
	"./tag_weizhi.svg": 773
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 769;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tag_anquan.dbdf3c64.svg";

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tag_keyi.346fb053.svg";

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tag_weixian.59a97bbb.svg";

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tag_weizhi.58868176.svg";

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon_anquan.svg": 261,
	"./icon_biaozhunhua.svg": 134,
	"./icon_duopingtai.svg": 131,
	"./icon_duorenwu.svg": 132,
	"./icon_file.svg": 244,
	"./icon_file_apk.svg": 150,
	"./icon_file_click.svg": 141,
	"./icon_file_dex.svg": 151,
	"./icon_file_dll.svg": 152,
	"./icon_file_dmg.svg": 153,
	"./icon_file_doc.svg": 154,
	"./icon_file_elf.svg": 155,
	"./icon_file_exe.svg": 156,
	"./icon_file_loading.svg": 83,
	"./icon_file_pdf.svg": 157,
	"./icon_file_qita.svg": 158,
	"./icon_file_so.svg": 159,
	"./icon_file_sys.svg": 160,
	"./icon_gaotuntu.svg": 126,
	"./icon_input_search.svg": 262,
	"./icon_jingzhunjiance.svg": 125,
	"./icon_keyanzheng.svg": 135,
	"./icon_kuaisujieru.svg": 127,
	"./icon_search.svg": 240,
	"./icon_search_click.svg": 241,
	"./icon_spinner_large.svg": 84,
	"./icon_spinner_small.svg": 263,
	"./icon_url.svg": 242,
	"./icon_url_click.svg": 243,
	"./icon_weixian.svg": 264,
	"./icon_wufajiance.svg": 265,
	"./icon_yinsibaohu.svg": 128,
	"./icon_yunduanheihe.svg": 133
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 774;

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./icon_file_apk.svg": 150,
	"./icon_file_click.svg": 141,
	"./icon_file_dex.svg": 151,
	"./icon_file_dll.svg": 152,
	"./icon_file_dmg.svg": 153,
	"./icon_file_doc.svg": 154,
	"./icon_file_elf.svg": 155,
	"./icon_file_exe.svg": 156,
	"./icon_file_loading.svg": 83,
	"./icon_file_pdf.svg": 157,
	"./icon_file_qita.svg": 158,
	"./icon_file_so.svg": 159,
	"./icon_file_sys.svg": 160
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 775;

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__item__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_buyAction__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_less__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 安全扶持计划
  * @author: wence
  */var SecurityPlan = (_temp = _class = function (_React$Component) {
  _inherits(SecurityPlan, _React$Component);function SecurityPlan(props) {
    _classCallCheck(this, SecurityPlan);var _this = _possibleConstructorReturn(this, (SecurityPlan.__proto__ || Object.getPrototypeOf(SecurityPlan)).call(this, props));_this.mealPay = function (item) {
      if (item.is_buy) {
        return false;
      }var _this$props = _this.props,
          activityGetService = _this$props.activityGetService,
          userLoginstate = _this$props.userLoginstate,
          instanceGetinstance = _this$props.instanceGetinstance;if (!_this.isEmptyobj(activityGetService) && userLoginstate.status === 0) {
        var key = Object.keys(instanceGetinstance.data)[0];var json = { 'instance_id': key, 'service_id': item.service_id, 'meal_id': item.meal_id };_this.props.fetchApimealPay(json).then(function (data) {
          if (data.data.status === 0) {
            // 购买成功
            _this.hmt();_this.props.fetchActivityGetService({ 'instance_id': key });_this.setState({ modal2: true, lookUrl: item.url });
          } else if (data.data.status === 404008) {
            // 未实名
            Object(__WEBPACK_IMPORTED_MODULE_6__actions_buyAction__["f" /* fetchRealName */])({ 'instance_id': key }).then(function (res) {
              _this.setState({ modal1: true, authType: res && res.data && res.data['auth_type'] || 0 });
            });
          } else if (data.data.status === 404008) {
            // 未登录
            location.href = _this.loginUrl();
          } else if (data.data.description) {
            _this.setState({ toastTitle: data.data.description, toast: true });
          }
        });
      } else {
        location.href = _this.loginUrl();
      }
    };_this.onClose = function (key) {
      _this.setState(_defineProperty({}, key, false));
    };_this.state = { modal1: false, modal2: false, toast: false, toastTitle: '', lookUrl: '' };if (_this.isPC()) {
      location.href = '/security/plan' + location.search;
    }return _this;
  }_createClass(SecurityPlan, [{ key: 'componentDidUpdate', value: function componentDidUpdate(prevProps) {
      var _this2 = this;var nextUser = this.props.userLoginstate;if (!Object.is(nextUser, prevProps.userLoginstate)) {
        if (nextUser.status === 0) {
          this.props.fetchInstanceGetInstance().then(function (data) {
            var key = Object.keys(data.data.data)[0];_this2.props.fetchActivityGetService({ 'instance_id': key, route: 'plan' });
          });
        } else {
          this.props.fetchActivityGetService({ route: 'plan' });
        }
      }
    } }, { key: 'hmt', value: function hmt() {
      try {
        window._hmt.push(['_trackEvent', 'gmplugin', 'use', 'mobile']);
      } catch (e) {
        return;
      }
    } }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          toast = _state.toast,
          modal2 = _state.modal2,
          modal1 = _state.modal1,
          lookUrl = _state.lookUrl;var activityGetService = this.props.activityGetService;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-banner' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: '/m/apply', className: 'spu-btn' }, '\u7ACB\u5373\u54A8\u8BE2')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { style: { background: '#FFF' } }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-title' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'text' }, '\u5173\u4E8E\u767E\u5EA6\u5B89\u5168\u6276\u6301\u8BA1\u5212')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p', { className: 'arctile margin' }, '\u767E\u5EA6\u5B89\u5168\u6276\u6301\u8BA1\u5212\uFF0C\u4E3A\u767E\u5EA6\u5B89\u5168\u9762\u5411\u5E7F\u5927\u521D\u521B\u4F01\u4E1A\u53CA\u5F00\u53D1\u8005\u5F00\u653E\u7684\u4E00\u7CFB\u5217\u5B89\u5168\n                    \u80FD\u529B\u548C\u6276\u6301\u8D44\u6E90\uFF0C\u81F4\u529B\u4E8E\u964D\u4F4E\u4F01\u4E1A\u7684\u5B89\u5168\u90E8\u7F72\u6210\u672C\uFF0C\u5FEB\u901F\u5BF9\u9F50\u56FD\u5BB6\u3001\n                    \u884C\u4E1A\u5B89\u5168\u6807\u51C6\u4E0E\u89C4\u8303\uFF0C\u62A4\u822A\u4F01\u4E1A\u5B89\u5168\u201C\u8D77\u98DE\u201D\u3002'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p', { className: 'arctile' }, '\u957F\u671F\u4EE5\u6765\uFF0C\u767E\u5EA6\u5B89\u5168\u4EE5\u6280\u672F\u5F00\u6E90\u3001\u4E13\u5229\u5171\u4EAB\u3001\u6807\u51C6\u9A71\u52A8\u4E3A\u7406\u5FF5\uFF0C\n                    \u8054\u5408\u884C\u4E1A\u751F\u6001\u4F19\u4F34\uFF0C\u5171\u540C\u63A8\u52A8AI\u65F6\u4EE3\u7684\u5B89\u5168\u751F\u6001\u5EFA\u8BBE\u3002\n                    \u4F5C\u4E3A\u767E\u5EA6\u5B89\u5168\u5F00\u653E\u6218\u7565\u7684\u91CD\u8981\u7EC4\u6210\u90E8\u5206\uFF0C\u6276\u6301\u8BA1\u5212\u4ECE\u6280\u672F\u3001\u670D\u52A1\u3001\u5408\u89C4\u6027\u4E09\u4E2A\u5C42\u9762\uFF0C\n                    \u514D\u8D39\u63D0\u4F9B\u9762\u5411', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', null, '\u521D\u521B\u578B\u667A\u80FD\u786C\u4EF6\u5382\u5546'), '、', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', null, '\u4E2D\u5C0FApp\u5F00\u53D1\u8005'), '、', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', null, '\u6709\u7EBF\u4E0A\u8D44\u4EA7\u7684\u4E2D\u5C0F\u4F01\u4E1A'), '三类企业用户的安全防护资源。'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-title' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'text' }, '\u521D\u521B\u4F01\u4E1A\u4E09\u5927\u5B89\u5168\u75DB\u70B9')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-pain' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-pain-item' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'image icon_1' }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'content' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'title' }, '\u5B89\u5168\u5A01\u80C1'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u9ED1\u4EA7\u7CFB\u7EDF\u8FD0\u4F5C\u3001\u653B\u9632\u5BF9\u6297\u5347\u7EA7\u3001\u7ECF\u6D4E\u635F\u5931\u5DE8\u5927'))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-pain-item' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'image icon_2' }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'content' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'title' }, '\u6210\u672C\u63A7\u5236'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u90E8\u7F72\u590D\u6742\u3001\u6210\u672C\u9AD8\u6602\u3001\u4EBA\u624D\u63A3\u8098'))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-pain-item' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'image icon_3' }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'content' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'title' }, '\u76D1\u7BA1\u8981\u6C42'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u300A\u7F51\u7EDC\u5B89\u5168\u6CD5\u300B\u5B9E\u65BD\u3001\u4E2A\u4EBA\u4FE1\u606F\u4FDD\u62A4\u6210\u6574\u6CBB\u91CD\u70B9'))))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-title' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'text' }, '\u6276\u6301\u65B9\u5F0F')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-way' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-way-item' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'title icon_1' }, '\u667A\u80FD\u786C\u4EF6\u201C\u5B89\u5168+\u201D\u6276\u6301\u8BA1\u5212'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, '20000\u53F0\u5B89\u5168OTA\u989D\u5EA6'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u964D\u4F4EOTA\u6210\u672C\uFF0C\u63D0\u9AD8\u8BBE\u5907\u5B89\u5168\u7CFB\u6570'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, '\u514D\u8D39\u5B89\u5168\u52A0\u56FA\u3001\u8BC4\u4F30\u3001\u54A8\u8BE2\u670D\u52A1'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u4E13\u4E1A\u6280\u672F\u4EBA\u5458\u652F\u6301\uFF0C\u6E17\u900F\u6D4B\u8BD5\u3001\u7B49\u4FDD\u6D4B\u8BC4\u3001\u5B89\u5168\u54A8\u8BE2\u7B49'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, '\u4E1A\u754C\u9886\u5148\u7684\u5B89\u5168\u6280\u672F\u5B9E\u529B'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u767E\u5EA6\u591A\u9879\u4E13\u5229+20\u5E74\u5B89\u5168\u884C\u4E1A\u5B9E\u8DF5\u53CC\u91CD\u4FDD\u969C\uFF0C\u4E13\u4E1A\u3001\u53EF\u4FE1\u8D56'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: 'https://ota.baidu.com/support.html', className: 'spu-btn' }, '\u4E86\u89E3\u8BE6\u60C5')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-way-item' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'title icon_2' }, '\u4E2A\u4EBA\u4FE1\u606F\u4FDD\u62A4\u6276\u6301\u8BA1\u5212'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, 'App\u9690\u79C1\u5408\u89C4\u98CE\u9669\u68C0\u6D4B\u670D\u52A1'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '5\u6B21/\u5929\u9690\u79C1\u5408\u89C4\u68C0\u6D4B\uFF0C\u9AD8\u6548\u751F\u6210\u98CE\u9669\u8BC4\u4F30\u7ED3\u679C'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, '\u6DF1\u5EA6\u8D34\u5408\u56FD\u5BB6\u76D1\u7BA1\u6807\u51C6'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u9884\u8B66\u5408\u89C4\u98CE\u9669\uFF0C\u65B9\u4FBF\u4F01\u4E1A\u53CA\u65F6\u6574\u6539'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, '\u5408\u89C4\u57F9\u8BAD'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u4E2A\u4EBA\u4FE1\u606F\u4FDD\u62A4\u6C99\u9F99\uFF0C\u7D27\u8DDF\u884C\u4E1A\u8D8B\u52BF'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: 'https://anquan.baidu.com/springer/plan', className: 'spu-btn' }, '\u4E86\u89E3\u8BE6\u60C5')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-way-item' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'title icon_3' }, '\u6F0F\u6D1E\u626B\u63CF\u6276\u6301\u8BA1\u5212'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, 'Web\u6F0F\u6D1E\u626B\u63CF\u670D\u52A1'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u5FEB\u901F\u53D1\u73B0\u6F5C\u5728\u98CE\u9669\uFF0C\u9632\u5FA1\u9ED1\u4EA7\u653B\u51FB\u3001\u89C4\u907F\u6CD5\u5F8B\u98CE\u9669'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, '\u4E13\u4E1A\u7248\u9650\u514D\u8BD5\u7528\u53CA\u7279\u6B8A\u6298\u6263\u901A\u9053'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u8D44\u4EA7\u53D1\u73B0\u3001\u7F51\u7AD9\u5B89\u5168\u6F0F\u6D1E\u4E0E\u5185\u5BB9\u98CE\u9669\u68C0\u6D4B\u3001\u89C4\u907F\u6302\u9A6C\u3001\u5185\u5BB9\u7BE1\u6539\u98CE\u9669'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: 'https://anquan.baidu.com/page/5', className: 'spu-btn' }, '\u4E86\u89E3\u8BE6\u60C5')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-way-item' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'title icon_4' }, 'APP\u6D88\u606F\u63A8\u9001\u6276\u6301\u8BA1\u5212'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, '\u63D0\u4F9B\u6210\u719F\u4E13\u4E1A\u7684\u6D88\u606F\u63A8\u9001\u670D\u52A1'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u652F\u6301\u767E\u4EBF\u7EA7\u7684\u6D88\u606F\u63A8\u9001\uFF0C\u5DF2\u670D\u52A1\u591A\u4E2A\u767E\u5EA6\u7CFB\u4EA7\u54C1'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, '\u8986\u76D6\u5404\u7C7B\u578B\u63A8\u9001\u9700\u6C42\u548C\u529F\u80FD'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u652F\u6301\u591A\u7C7B\u578B\u63A8\u9001\uFF0C\u753B\u50CF\u5B9A\u5411\u63A8\u9001\uFF0C\u5B9A\u65F6\u63A8\u9001\u548C\u5168\u65B9\u4F4D\u6570\u636E\u7EDF\u8BA1'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, '\u4F7F\u7528\u8F7B\u91CF\u7B80\u5355\u5B89\u5168\u53EF\u9760'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u8F7B\u91CFSDK\u96C6\u6210\u4F7F\u7528\uFF0C\u91C7\u7528\u767E\u5EA6\u667A\u80FD\u5FC3\u8DF3\u63A2\u6D4B\u6280\u672F\u4FDD\u969C\u5230\u8FBE\u7387'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: 'https://anquan.baidu.com/page/60', className: 'spu-btn' }, '\u4E86\u89E3\u8BE6\u60C5')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-way-item' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'title icon_5' }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, '\u514D\u8D39\u63D0\u4F9B\u98CE\u63A7\u670D\u52A1'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u8425\u9500\u98CE\u63A7\u53CA\u6E20\u9053\u53CD\u4F5C\u5F0A\u670D\u52A1\u5168\u9762\u652F\u6301'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, '\u8D85\u4EBF\u7EA7\u522B\u9ED1\u4EA7\u8BC6\u522B\u6570\u636E'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u6D77\u91CF\u9ED1\u4EA7\u624B\u673A\u8D26\u53F7\u8BBE\u5907\u6570\u636E'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'sub-title' }, '\u7CBE\u51C6\u8BBE\u5907\u6307\u7EB9'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'des' }, '\u8986\u76D6\u767E\u5EA6\u7CFB\u4E3B\u6D41APP\uFF0C\u8BC6\u522B\u7FA4\u63A7\u5F02\u5E38\u767B\u5F55'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: '/control/plan', className: 'spu-btn' }, '\u4E86\u89E3\u8BE6\u60C5'))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-process' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-title' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'text' }, '\u5165\u9A7B\u6D41\u7A0B')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'image' }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p', null, '\u5B89\u5168\u4E0D\u662F\u4EFB\u4F55\u4E00\u5BB6\u516C\u53F8\u80FD\u591F\u72EC\u7ACB\u89E3\u51B3\u7684\u4E8B\u60C5\u9700\u5728', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', null, '\u5F00\u653E\u5171\u4EAB'), '\u4E2D\u5BFB\u6C42', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', null, '\u751F\u6001\u5171\u8D62')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p', null, '\u6280\u672F\u4E0D\u4EC5\u662F\u4F01\u4E1A\u51B3\u5B9A\u80DC\u8D1F\u7684\u91CD\u8981\u7B79\u7801\u66F4\u9700\u5728', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', null, '\u5F00\u653E\u5171\u4EAB'), '\u4E2D\u521B\u9020', __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', null, '\u66F4\u5927\u4EF7\u503C'))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-plan-title' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: 'text' }, '\u5176\u4ED6\u514D\u8D39\u8BD5\u7528\u5B89\u5168\u670D\u52A1')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { href: '/m/buy', className: 'spu-link push-btn' }, '\u524D\u5F80\u514D\u8D39\u5957\u9910\u4F53\u9A8C\u9986'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'spu-service-list' }, !this.isEmptyobj(activityGetService) ? activityGetService.data.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__item__["a" /* default */], { item: item, key: index, onClick: _this3.mealPay.bind(_this3, item) });
      }) : null), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default.a, { visible: modal1, transparent: true, maskClosable: true, className: 'saas-attest', onClose: this.onClose.bind(this, 'modal1') }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'hint' }, '\u60A8\u7684\u8D26\u53F7\u8FD8\u6CA1\u6709\u8BA4\u8BC1\uFF0C\u8BA4\u8BC1\u540E\u624D\u80FD\u8D2D\u4E70\u54E6\uFF01'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { className: 'saas-buy-btn', href: this.state.authType === 0 ? this.userCenterUrl() : '/console/#/attestation', onClick: function onClick() {
          _this3.setState({ modal1: false });
        } }, '\u53BB\u8BA4\u8BC1')), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default.a, { visible: modal2, transparent: true, maskClosable: false, className: 'saas-attest', onClose: this.onClose.bind(this, 'modal2') }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'hint' }, '\u8D2D\u4E70\u6210\u529F\uFF0C\u53EF\u524D\u5F80\u63A7\u5236\u53F0\u67E5\u770B\u4F7F\u7528\u8BF4\u660E'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'operate' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { className: 'saas-buy-btn hint-btn', href: lookUrl, target: '_blank', onClick: function onClick() {
          _this3.setState({ modal2: false });
        } }, '\u53BB\u63A7\u5236\u53F0'), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'saas-buy-btn', onClick: function onClick() {
          _this3.setState({ modal2: false });
        } }, '\u7EE7\u7EED\u8D2D\u4E70'))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default.a, { visible: toast, transparent: true, maskClosable: false, wrapClassName: 'spu-modal-confirm', className: 'saas-attest', onClose: this.onClose.bind(this, 'modal2') }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'hint' }, this.state.toastTitle), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div', { className: 'operate' }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a', { className: 'saas-buy-btn', onClick: function onClick(e) {
          e.preventDefault();_this3.setState({ toast: false, toastTitle: '' });
        } }, '\u5173\u95ED'))));
    } }]);return SecurityPlan;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component), _class.propTypes = { fetchActivityGetService: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, fetchInstanceGetInstance: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, fetchApimealPay: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, userLoginstate: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, activityGetService: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, instanceGetinstance: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function (state) {
  return { userLoginstate: state.userLoginstate, activityGetService: state.activityGetService, instanceGetinstance: state.instanceGetinstance };
}, function (dispatch) {
  return { fetchApimealPay: function fetchApimealPay(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__actions_buyAction__["b" /* fetchApimealPay */])(dispatch, obj);
    }, fetchActivityGetService: function fetchActivityGetService(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__actions_buyAction__["a" /* fetchActivityGetService */])(dispatch, obj);
    }, fetchInstanceGetInstance: function fetchInstanceGetInstance() {
      return Object(__WEBPACK_IMPORTED_MODULE_6__actions_buyAction__["d" /* fetchInstanceGetInstance */])(dispatch);
    } };
})(SecurityPlan));

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Item; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__item_less__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__item_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__item_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 购买item组件
  * @author: wence
  */var Item = (_temp = _class = function (_Component) {
  _inherits(Item, _Component);function Item() {
    _classCallCheck(this, Item);return _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
  }_createClass(Item, [{ key: 'render', value: function render() {
      var _props = this.props,
          item = _props.item,
          onClick = _props.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-buy-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-buy-name' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: item.is_hot ? 'hot' : null }, item.service_name), item.is_hot ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'saas-buy-hot' }) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-buy-text' }, item.service_desc), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-buy-info' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: item.url, target: '_blank' }, '\u67E5\u770B\u8BE6\u60C5 ', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', null))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-buy-item-hint' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, '\u514D\u8D39\u4F53\u9A8C\u65F6\u957F\uFF1A'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', null, item.is_buy ? '-' : item.capacity)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: item.is_buy ? 'saas-buy-btn disable' : 'saas-buy-btn', onClick: onClick }, item.is_buy ? '已领取' : '免费领取'));
    } }]);return Item;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { item: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func }, _temp);

/***/ }),
/* 778 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AiTemperature; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dplayer_cus_lite__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dplayer_cus_lite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dplayer_cus_lite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__temperature_less__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__temperature_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__temperature_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 体温检测
  * @author: wence
  */var AiTemperature = (_temp = _class = function (_PureComponent) {
  _inherits(AiTemperature, _PureComponent);function AiTemperature(props) {
    _classCallCheck(this, AiTemperature);var _this = _possibleConstructorReturn(this, (AiTemperature.__proto__ || Object.getPrototypeOf(AiTemperature)).call(this, props));if (_this.isPC()) {
      location.href = '/page/ai/temperature';
    }return _this;
  }_createClass(AiTemperature, [{ key: 'componentDidMount', value: function componentDidMount() {
      var dp = new __WEBPACK_IMPORTED_MODULE_3_dplayer_cus_lite___default.a({ container: document.getElementById('saas-t-video'), autoplay: false, theme: '#b7daff', loop: 0, preload: 'auto', video: { url: '//secapi.cdn.bcebos.com/ai/video.mp4', type: 'auto' }, mutex: 1, iconsColor: 'red' });dp.on('ended', function () {
        dp.seek(0);
      });
    } }, { key: 'render', value: function render() {
      this.shareWX({ title: '百度安全-有AI更安全', content: '百度AI体温检测解决方案自2020年1月28日在北京清河站试运行以来，已有超过上万人通过检测。同时，我们已将这一解决方案对外开放，以AI安全之力助力全国疫情防控战役。' });var advanageList = [{ title: '实时高效', des: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '\u5728\u5355\u4EBA\u901A\u9053\u987A\u5E8F\u901A\u884C\u6761\u4EF6\u4E0B\uFF0C\u53EF\u57281\u5206\u949F\u5185\u5B9E\u73B0\u5BF9\u903E200\u4EBA\u540C\u65F6\u901A\u8FC7\u7684\u4F53\u6E29\u5B9E\u65F6\u68C0\u6D4B\uFF0C\u5B9E\u73B0\u4EBA\u7FA4\u65E0\u505C\u7559\u8FC7\u68C0\uFF0C\u7F13\u89E3\u4EBA\u5458\u5835\u585E\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', null, '*\u53C2\u8003\u6570\u636E\uFF0C\u53D7\u4EBA\u7FA4\u5BC6\u5EA6\u53CA\u884C\u8FDB\u901F\u5EA6\u5F71\u54CD\u3002')) }, { title: '精准可靠', des: '实现了体温检测与人脸识别的技术同步及佩戴口罩时的识别问题，可准确定位、快速锁定体温异常人员并实时自动告警，方便工作人员进行二次复检。' }, { title: '非接触无感知', des: '借助全自动化的体温检测，被检人员仅需做弱配合，大幅减少相互的近距离接触，降低潜在的安全隐患。' }, { title: '快速部署降低成本', des: '实现检测结果的实时可视化，并可在通道、重要区域快速部署，有效降低成本，缓解疫情防控期间紧张的人力资源调配。' }];var reportList = [{ title: '央视新闻', des: '\u201C\u76EE\u524D\uFF0C\u5728\u5355\u4EBA\u901A\u9053\u987A\u5E8F\u901A\u884C\u6761\u4EF6\u4E0B\uFF0C\u767E\u5EA6AI\u591A\u4EBA\u4F53\u6E29\u5FEB\u901F\u68C0\u6D4B\u89E3\u51B3\u65B9\u6848\u53EF\u57281\u5206\u949F\u5185\u5B9E\u73B0\u5BF9\u903E200\u4EBA\u540C\u65F6\u901A\u8FC7\u7684\u4F53\u6E29\u5B9E\u65F6\u68C0\u6D4B\uFF08\u5B9E\u9645\u6570\u636E\u53D7\u4EBA\u7FA4\u5BC6\u5EA6\u53CA\u884C\u8FDB\u901F\u5EA6\u5F71\u54CD\uFF09\uFF0C\n                    \u4F7F\u65C5\u5BA2\u53EF\u65E0\u505C\u7559\u8FC7\u68C0\uFF0C\u7F13\u89E3\u68C0\u6D4B\u9020\u6210\u7684\u51FA\u5165\u53E3\u4EBA\u5458\u5835\u585E\u538B\u529B\uFF0C\u5E76\u6700\u7EC8\u5B9E\u73B0\u65C5\u5BA2\u5FEB\u901F\u901A\u884C\u548C\u201C\u4E00\u4E2A\u4E0D\u843D\u201D\u5730\u63A5\u53D7\u5230\u4F53\u6E29\u68C0\u6D4B\u7684\u53CC\u91CD\u76EE\u6807\u3002\u201D', url: 'http://rmbjb.jyrmb.com/INF_List_TV.asp?SortStr=INF&Sucaid=2&ID=CT2020020222102200001&SID=3237\n                    &Daystr=2020-02-02&Title=&CGUID=D73C3BCB-2070-4352-B0C5-525F8648AD17&charset=gb2312' }, { title: '北京日报', des: ' \u201C\u76EE\u524D\u5E02\u573A\u4E0A\u7684\u5927\u5BA2\u6D41\u4F53\u6E29\u76D1\u6D4B\u8BBE\u5907\uFF0C\u4E3B\u8981\u662F\u4EE5\u786C\u4EF6\u4E3A\u4E3B\u5BFC\u7684\u9AD8\u6E29\u7EA2\u5916\u8BBE\u5907\u68C0\u6D4B\u4EEA\u5668\uFF0C\u4F46\u9020\u4EF7\u9AD8\u3001\u4E25\u91CD\u7F3A\u8D27\u3002\u4E3A\u5E94\u5BF9\u8FD4\u4EAC\u5927\u5BA2\u6D41\u5230\u6765\u7684\u9700\u8981\uFF0C\n                    \u767E\u5EA6\u516C\u53F8\u5BF9\u5176\u8F6F\u4EF6\u7CFB\u7EDF\u8FDB\u884C\u4F18\u5316\uFF0C\u89E3\u51B3\u9AD8\u94C1\u7AD9\u534A\u5F00\u653E\u73AF\u5883\u6C14\u6E29\u4F4E\u3001\u51FA\u7AD9\u4EBA\u5458\u6234\u53E3\u7F69\u6234\u5E3D\u5B50\u4EBA\u8138\u4FE1\u606F\u7F3A\u5931\u7B49\u96BE\u70B9\uFF0C\u7814\u53D1\u8C03\u8BD5\u51FAAI\u5927\u5BA2\u6D41\u4F53\u6E29\u68C0\u6D4B\u89E3\u51B3\u65B9\u6848\u3002\u201D', url: 'https://ie.bjd.com.cn/5b165687a010550e5ddc0e6a/contentApp\n                    /5b1a1310e4b03aa54d764015/AP5e363eaae4b0768ce1976e67\n                    ?isshare=1&app=ae1971f4eac243f3' }, { title: '北京电视台', des: '\u201C\u9664\u4E86\u5728\u7B5B\u9009\u6548\u7387\u65B9\u9762\u7684\u63D0\u5347\uFF0C\u8BE5\u89E3\u51B3\u65B9\u6848\u7684\u90E8\u7F72\u4E5F\u5341\u5206\u7B80\u4FBF\u3002\u6BD4\u5982\uFF0C\u5728\u901A\u9053\u6216\u91CD\u8981\u533A\u57DF\u653E\u7F6E\u56FA\u5B9A\u70B9\u4F4D\u6444\u50CF\u673A\uFF0C\u5728\u65E0\u9700\u7FA4\u4F17\u914D\u5408\u6216\u5F31\u914D\u5408\u7684\u60C5\u51B5\u4E0B\uFF0C\u6444\u50CF\u673A\u5B8C 3-5 \u4EBA/\u6279\u6B21\u7684\u9762\u90E8\u6E29\u5EA6\u5FEB\u901F\u68C0\u6D4B\u7CFB\u7EDF\u3002\n                    \u76EE\u524D\uFF0C\u8BE5\u7CFB\u7EDF\u80FD\u591F\u6D4B\u91CF\u7684\u6E29\u5DEE\u5728 0.05 \u6444\u6C0F\u5EA6\u4E4B\u5185\u3002\u201D', url: 'https://haokan.baidu.com/v?vid=8760943309900751167&pd=bjh&fr=bjhauthor&type=video' }];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'proBanner saas-t-banner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { className: 'saas-t-btn', href: '/m/apply' }, '\u5408\u4F5C\u54A8\u8BE2'))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'saas-t-des', style: { paddingTop: '1rem' } }, '\u767E\u5EA6AI\u4F53\u6E29\u68C0\u6D4B\u89E3\u51B3\u65B9\u6848\u81EA2020\u5E741\u670828\u65E5\u5728\u5317\u4EAC\u6E05\u6CB3\u7AD9\u8BD5\u8FD0\u884C\u4EE5\u6765\uFF0C\u5DF2\u6709\u8D85\u8FC7\u4E0A', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'saas-t-tag' }, '\u4E07\u4EBA'), '\u901A\u8FC7\u68C0\u6D4B\u3002 \u540C\u65F6\uFF0C\u6211\u4EEC\u5DF2\u5C06\u8FD9\u4E00\u89E3\u51B3\u65B9\u6848\u5BF9\u5916\u5F00\u653E\uFF0C', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'saas-t-tag' }, '\u4EE5AI\u5B89\u5168\u4E4B\u529B\u52A9\u529B\u5168\u56FD\u75AB\u60C5\u9632\u63A7\u6218\u5F79'), '\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'saas-t-des' }, '\u5F53\u524D\uFF0C\u5168\u56FD\u5BF9\u65B0\u578B\u51A0\u72B6\u75C5\u6BD2\u75AB\u60C5\u7684\u9632\u63A7\u5DF2\u8FDB\u5165\u5173\u952E\u671F\uFF0C\u5728\u8F66\u7AD9\u7B49\u4EBA\u6D41\u91CF\u5DE8\u5927\u7684\u516C\u5171\u573A\u6240\uFF0C\u5982\u4F55\u5B89\u5168\u3001\u5FEB\u901F\u3001\u9AD8\u6548\u5730\u5B9E\u73B0\u5BF9\u6765\u5F80\u4EBA\u7FA4\u7684\u4F53\u6E29\u68C0\u6D4B\u9010\u6E10\u6210\u4E3A\u9632\u63A7\u5DE5\u4F5C\u7684\u91CD\u8981\u4E00\u73AF\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { className: 'saas-t-des' }, '\u9488\u5BF9\u73B0\u6709\u4F53\u6E29\u68C0\u6D4B\u7CFB\u7EDF\u6240\u5B58\u5728\u7684\u5C40\u9650\u6027\uFF0C\u767E\u5EA6AI\u591A\u4EBA\u4F53\u6E29\u5FEB\u901F\u68C0\u6D4B\u89E3\u51B3\u65B9\u6848\u843D\u5730\u5E94\u7528\u3002 \u57FA\u4E8EAI\u56FE\u50CF\u8BC6\u522B\u6280\u672F\u548C\u7EA2\u5916\u70ED\u6210\u50CF\u6280\u672F\uFF0C\u4EE5\u975E\u63A5\u89E6\u3001\u65E0\u611F\u77E5\u7684\u65B9\u5F0F\uFF0C\u53EF\u9760\u3001\u9AD8\u6548\u5730\u89E3\u51B3\u4E86\u5728\u516C\u5171\u573A\u6240\u4EBA\u5458\u9AD8\u5EA6\u805A\u96C6\u3001\u9AD8\u6D41\u52A8\u6027\u60C5\u51B5\u4E0B\u7684\u4F53\u6E29\u5B9E\u65F6\u521D\u7B5B\u68C0\u6D4B\u95EE\u9898\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-t-video' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'saas-t-video' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-t-header' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProductTitle__["a" /* default */], { title: '\u6838\u5FC3\u4F18\u52BF' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-t-advantage' }, advanageList.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-t-advantage-item bg' + (index + 1), key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des' }, item.des));
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-t-report-container' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-t-header' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProductTitle__["a" /* default */], { title: '\u5A92\u4F53\u62A5\u9053' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-t-report' }, reportList.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: item.url, target: '_blank', className: 'saas-t-report-item', key: index }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des' }, item.des));
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-t-footer-container' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-t-footer' }, '\u66F4\u591A\u6559\u80B2\u3001\u5DE5\u4E1A\u3001\u573A\u9986\u7B49\u573A\u666FAI\u89E3\u51B3\u65B9\u6848', __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { target: '_blank', rel: 'noopener noreferrer', className: 'saas-t-btn', href: 'https://anquan.baidu.com/page/47' }, '\u4E86\u89E3\u8BE6\u60C5'))));
    } }]);return AiTemperature;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { pagesDatabyid: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any }, _temp);

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("DPlayer",[],t):"object"==typeof exports?exports.DPlayer=t():e.DPlayer=t()}(window,(function(){return function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="/",n(n.s=23)}([function(e,t){function n(e){return(n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var r;r=function(){return this}();try{r=r||new Function("return this")()}catch(e){"object"===("undefined"==typeof window?"undefined":n(window))&&(r=window)}e.exports=r},function(e,t,n){"use strict";e.exports=n(21)},function(e,t,n){"use strict";(function(e){var r=n(3);function o(e){return(o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var i=setTimeout;function a(e){return Boolean(e&&void 0!==e.length)}function l(){}function s(e){if(!(this instanceof s))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],h(e,this)}function c(e,t){for(;3===e._state;)e=e._value;0!==e._state?(e._handled=!0,s._immediateFn((function(){var n=1===e._state?t.onFulfilled:t.onRejected;if(null!==n){var r;try{r=n(e._value)}catch(e){return void p(t.promise,e)}d(t.promise,r)}else(1===e._state?d:p)(t.promise,e._value)}))):e._deferreds.push(t)}function d(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"===o(t)||"function"==typeof t)){var n=t.then;if(t instanceof s)return e._state=3,e._value=t,void u(e);if("function"==typeof n)return void h((r=n,i=t,function(){r.apply(i,arguments)}),e)}e._state=1,e._value=t,u(e)}catch(t){p(e,t)}var r,i}function p(e,t){e._state=2,e._value=t,u(e)}function u(e){2===e._state&&0===e._deferreds.length&&s._immediateFn((function(){e._handled||s._unhandledRejectionFn(e._value)}));for(var t=0,n=e._deferreds.length;t<n;t++)c(e,e._deferreds[t]);e._deferreds=null}function y(e,t,n){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.promise=n}function h(e,t){var n=!1;try{e((function(e){n||(n=!0,d(t,e))}),(function(e){n||(n=!0,p(t,e))}))}catch(e){if(n)return;n=!0,p(t,e)}}s.prototype.catch=function(e){return this.then(null,e)},s.prototype.then=function(e,t){var n=new this.constructor(l);return c(this,new y(e,t,n)),n},s.prototype.finally=r.a,s.all=function(e){return new s((function(t,n){if(!a(e))return n(new TypeError("Promise.all accepts an array"));var r=Array.prototype.slice.call(e);if(0===r.length)return t([]);var i=r.length;function l(e,a){try{if(a&&("object"===o(a)||"function"==typeof a)){var s=a.then;if("function"==typeof s)return void s.call(a,(function(t){l(e,t)}),n)}r[e]=a,0==--i&&t(r)}catch(e){n(e)}}for(var s=0;s<r.length;s++)l(s,r[s])}))},s.resolve=function(e){return e&&"object"===o(e)&&e.constructor===s?e:new s((function(t){t(e)}))},s.reject=function(e){return new s((function(t,n){n(e)}))},s.race=function(e){return new s((function(t,n){if(!a(e))return n(new TypeError("Promise.race accepts an array"));for(var r=0,o=e.length;r<o;r++)s.resolve(e[r]).then(t,n)}))},s._immediateFn="function"==typeof e&&function(t){e(t)}||function(e){i(e,0)},s._unhandledRejectionFn=function(e){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)},t.a=s}).call(this,n(18).setImmediate)},function(e,t,n){"use strict";t.a=function(e){var t=this.constructor;return this.then((function(n){return t.resolve(e()).then((function(){return n}))}),(function(n){return t.resolve(e()).then((function(){return t.reject(n)}))}))}},function(e,t){e.exports='<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 16 32"><path d="M15.552 15.168q0.448 0.32 0.448 0.832 0 0.448-0.448 0.768l-13.696 8.512q-0.768 0.512-1.312 0.192t-0.544-1.28v-16.448q0-0.96 0.544-1.28t1.312 0.192z"></path></svg>'},function(e,t){e.exports='<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 17 32"><path d="M14.080 4.8q2.88 0 2.88 2.048v18.24q0 2.112-2.88 2.112t-2.88-2.112v-18.24q0-2.048 2.88-2.048zM2.88 4.8q2.88 0 2.88 2.048v18.24q0 2.112-2.88 2.112t-2.88-2.112v-18.24q0-2.048 2.88-2.048z"></path></svg>'},function(e,t){e.exports='<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32"><path d="M1.882 16.941c0 4.152 3.221 7.529 7.177 7.529v1.882c-4.996 0-9.060-4.222-9.060-9.412s4.064-9.412 9.060-9.412h7.96l-3.098-3.098 1.331-1.331 5.372 5.37-5.37 5.372-1.333-1.333 3.1-3.098h-7.962c-3.957 0-7.177 3.377-7.177 7.529zM22.94 7.529v1.882c3.957 0 7.177 3.377 7.177 7.529s-3.221 7.529-7.177 7.529h-7.962l3.098-3.098-1.331-1.331-5.37 5.37 5.372 5.372 1.331-1.331-3.1-3.1h7.96c4.998 0 9.062-4.222 9.062-9.412s-4.064-9.412-9.060-9.412z"></path></svg>'},function(e,t){e.exports='<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 21 32"><path d="M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8zM20.576 16q0 1.344-0.768 2.528t-2.016 1.664q-0.16 0.096-0.448 0.096-0.448 0-0.8-0.32t-0.32-0.832q0-0.384 0.192-0.64t0.544-0.448 0.608-0.384 0.512-0.64 0.192-1.024-0.192-1.024-0.512-0.64-0.608-0.384-0.544-0.448-0.192-0.64q0-0.48 0.32-0.832t0.8-0.32q0.288 0 0.448 0.096 1.248 0.48 2.016 1.664t0.768 2.528zM25.152 16q0 2.72-1.536 5.056t-4 3.36q-0.256 0.096-0.448 0.096-0.48 0-0.832-0.352t-0.32-0.8q0-0.704 0.672-1.056 1.024-0.512 1.376-0.8 1.312-0.96 2.048-2.4t0.736-3.104-0.736-3.104-2.048-2.4q-0.352-0.288-1.376-0.8-0.672-0.352-0.672-1.056 0-0.448 0.32-0.8t0.8-0.352q0.224 0 0.48 0.096 2.496 1.056 4 3.36t1.536 5.056z"></path></svg>'},function(e,t){e.exports='<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 21 32"><path d="M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8zM20.576 16q0 1.344-0.768 2.528t-2.016 1.664q-0.16 0.096-0.448 0.096-0.448 0-0.8-0.32t-0.32-0.832q0-0.384 0.192-0.64t0.544-0.448 0.608-0.384 0.512-0.64 0.192-1.024-0.192-1.024-0.512-0.64-0.608-0.384-0.544-0.448-0.192-0.64q0-0.48 0.32-0.832t0.8-0.32q0.288 0 0.448 0.096 1.248 0.48 2.016 1.664t0.768 2.528z"></path></svg>'},function(e,t){e.exports='<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 21 32"><path d="M13.728 6.272v19.456q0 0.448-0.352 0.8t-0.8 0.32-0.8-0.32l-5.952-5.952h-4.672q-0.48 0-0.8-0.352t-0.352-0.8v-6.848q0-0.48 0.352-0.8t0.8-0.352h4.672l5.952-5.952q0.32-0.32 0.8-0.32t0.8 0.32 0.352 0.8z"></path></svg>'},function(e,t){e.exports='<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 33"><path d="M6.667 28h-5.333c-0.8 0-1.333-0.533-1.333-1.333v-5.333c0-0.8 0.533-1.333 1.333-1.333s1.333 0.533 1.333 1.333v4h4c0.8 0 1.333 0.533 1.333 1.333s-0.533 1.333-1.333 1.333zM30.667 28h-5.333c-0.8 0-1.333-0.533-1.333-1.333s0.533-1.333 1.333-1.333h4v-4c0-0.8 0.533-1.333 1.333-1.333s1.333 0.533 1.333 1.333v5.333c0 0.8-0.533 1.333-1.333 1.333zM30.667 12c-0.8 0-1.333-0.533-1.333-1.333v-4h-4c-0.8 0-1.333-0.533-1.333-1.333s0.533-1.333 1.333-1.333h5.333c0.8 0 1.333 0.533 1.333 1.333v5.333c0 0.8-0.533 1.333-1.333 1.333zM1.333 12c-0.8 0-1.333-0.533-1.333-1.333v-5.333c0-0.8 0.533-1.333 1.333-1.333h5.333c0.8 0 1.333 0.533 1.333 1.333s-0.533 1.333-1.333 1.333h-4v4c0 0.8-0.533 1.333-1.333 1.333z"></path></svg>'},function(e,t){e.exports='<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 33"><path d="M24.965 24.38h-18.132c-1.366 0-2.478-1.113-2.478-2.478v-11.806c0-1.364 1.111-2.478 2.478-2.478h18.132c1.366 0 2.478 1.113 2.478 2.478v11.806c0 1.364-1.11 2.478-2.478 2.478zM6.833 10.097v11.806h18.134l-0.002-11.806h-18.132zM2.478 28.928h5.952c0.684 0 1.238-0.554 1.238-1.239 0-0.684-0.554-1.238-1.238-1.238h-5.952v-5.802c0-0.684-0.554-1.239-1.238-1.239s-1.239 0.556-1.239 1.239v5.802c0 1.365 1.111 2.478 2.478 2.478zM30.761 19.412c-0.684 0-1.238 0.554-1.238 1.238v5.801h-5.951c-0.686 0-1.239 0.554-1.239 1.238 0 0.686 0.554 1.239 1.239 1.239h5.951c1.366 0 2.478-1.111 2.478-2.478v-5.801c0-0.683-0.554-1.238-1.239-1.238zM0 5.55v5.802c0 0.683 0.554 1.238 1.238 1.238s1.238-0.555 1.238-1.238v-5.802h5.952c0.684 0 1.238-0.554 1.238-1.238s-0.554-1.238-1.238-1.238h-5.951c-1.366-0.001-2.478 1.111-2.478 2.476zM32 11.35v-5.801c0-1.365-1.11-2.478-2.478-2.478h-5.951c-0.686 0-1.239 0.554-1.239 1.238s0.554 1.238 1.239 1.238h5.951v5.801c0 0.683 0.554 1.237 1.238 1.237 0.686 0.002 1.239-0.553 1.239-1.236z"></path></svg>'},function(e,t){e.exports='<svg version="1.1" viewBox="0 0 22 22"><svg x="7" y="1"><circle class="diplayer-loading-dot diplayer-loading-dot-0" cx="4" cy="4" r="2"></circle></svg><svg x="11" y="3"><circle class="diplayer-loading-dot diplayer-loading-dot-1" cx="4" cy="4" r="2"></circle></svg><svg x="13" y="7"><circle class="diplayer-loading-dot diplayer-loading-dot-2" cx="4" cy="4" r="2"></circle></svg><svg x="11" y="11"><circle class="diplayer-loading-dot diplayer-loading-dot-3" cx="4" cy="4" r="2"></circle></svg><svg x="7" y="13"><circle class="diplayer-loading-dot diplayer-loading-dot-4" cx="4" cy="4" r="2"></circle></svg><svg x="3" y="11"><circle class="diplayer-loading-dot diplayer-loading-dot-5" cx="4" cy="4" r="2"></circle></svg><svg x="1" y="7"><circle class="diplayer-loading-dot diplayer-loading-dot-6" cx="4" cy="4" r="2"></circle></svg><svg x="3" y="3"><circle class="diplayer-loading-dot diplayer-loading-dot-7" cx="4" cy="4" r="2"></circle></svg></svg>'},function(e,t,n){var r=n(1);e.exports=function(e){"use strict";e=e||{};var t="",o=(arguments[1],function(e){return t+=e}),i=e.video,a=e.icons,l=r.$escape,s=e.options;return t+='<div class="dplayer-mask"></div>\n<div class="dplayer-video-wrap">\n    ',o(n(22)(i)),t+='\n    <div class="dplayer-bezel">\n        <span class="dplayer-bezel-icon"></span>\n        <span class="diplayer-loading-icon">',t+=a.loading,t+='</span>\n    </div>\n</div>\n<div class="dplayer-controller-mask"></div>\n<div class="dplayer-controller">\n    <div class="dplayer-icons dplayer-icons-left">\n        <button class="dplayer-icon dplayer-play-icon">\n            <span class="dplayer-icon-content">',t+=a.play,t+='</span>\n        </button>\n        <div class="dplayer-volume">\n            <button class="dplayer-icon dplayer-volume-icon">\n                <span class="dplayer-icon-content">',t+=a.volumeDown,t+='</span>\n            </button>\n            <div class="dplayer-volume-bar-wrap">\n                <div class="dplayer-volume-bar">\n                    <div class="dplayer-volume-bar-inner" style="background: ',t+=l(s.theme),t+=';">\n                        <span class="dplayer-thumb" style="background: ',t+=l(s.theme),t+='"></span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <span class="dplayer-time">\n            <span class="dplayer-ptime">0:00</span> / <span class="dplayer-dtime">0:00</span>\n        </span>\n    </div>\n    <div class="dplayer-icons dplayer-icons-right">\n        <div class="dplayer-loop">\n            <button class="dplayer-icon dplayer-loop-icon">\n                <span class="dplayer-icon-content">',t+=a.loop,t+='</span>\n            </button>\n        </div>\n        <div class="dplayer-full-in">\n            <button class="dplayer-icon dplayer-full-in-icon">\n                <span class="dplayer-icon-content">',t+=a.fullWeb,t+='</span>\n            </button>\n        </div>\n        <div class="dplayer-full">\n            <button class="dplayer-icon dplayer-full-icon">\n                <span class="dplayer-icon-content">',t+=a.full,t+='</span>\n            </button>\n        </div>\n    </div>\n    <div class="dplayer-bar-wrap">\n        <div class="dplayer-bar-time hidden">00:00</div>\n        <div class="dplayer-bar">\n            <div class="dplayer-loaded" style="width: 0;"></div>\n            <div class="dplayer-played" style="width: 0; background: ',t+=l(s.theme),t+='">\n                <span class="dplayer-thumb" style="background: ',t+=l(s.theme),t+='"></span>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="dplayer-notice"></div>'}},function(e,t,n){var r=n(15);"string"==typeof r&&(r=[[e.i,r,""]]);var o={insert:"head",singleton:!1};n(17)(r,o);r.locals&&(e.exports=r.locals)},function(e,t,n){(e.exports=n(16)(!1)).push([e.i,".dplayer{position:relative;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;line-height:1}.dplayer *{box-sizing:content-box}.dplayer svg{width:100%;height:100%}.dplayer svg circle,.dplayer svg path{fill:#fff}.dplayer:-webkit-full-screen{width:100%;height:100%;background:#000;position:fixed;z-index:100000;left:0;top:0;margin:0;padding:0;transform:translate(0)}@media (min-width:900px){.dplayer.dplayer-playing .dplayer-controller,.dplayer.dplayer-playing .dplayer-controller-mask{opacity:0}.dplayer.dplayer-playing:hover .dplayer-controller,.dplayer.dplayer-playing:hover .dplayer-controller-mask{opacity:1}}.dplayer.dplayer-loading .dplayer-bezel .diplayer-loading-icon{display:block}.dplayer.dplayer-hide-controller{cursor:none}.dplayer.dplayer-hide-controller .dplayer-controller,.dplayer.dplayer-hide-controller .dplayer-controller-mask{opacity:0;transform:translateY(100%)}.dplayer.dplayer-fulled{position:fixed;z-index:100000;left:0;top:0;width:100%;height:100%}.dplayer.dplayer-mobile .dplayer-bar-time,.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-full-in,.dplayer.dplayer-mobile .dplayer-controller .dplayer-icons .dplayer-volume{display:none}.dplayer-web-fullscreen-fix{position:fixed;top:0;left:0;margin:0;padding:0}.dplayer-bezel{position:absolute;left:0;right:0;top:0;bottom:0;font-size:22px;color:#fff;pointer-events:none}.dplayer-bezel .dplayer-bezel-icon{position:absolute;top:50%;left:50%;margin:-26px 0 0 -26px;height:52px;width:52px;padding:12px;box-sizing:border-box;background:rgba(0,0,0,.5);border-radius:50%;opacity:0;pointer-events:none}.dplayer-bezel .dplayer-bezel-icon.dplayer-bezel-transition{-webkit-animation:bezel-hide .5s linear;animation:bezel-hide .5s linear}@-webkit-keyframes bezel-hide{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(2)}}@keyframes bezel-hide{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(2)}}.dplayer-bezel .diplayer-loading-icon{display:none;position:absolute;top:50%;left:50%;margin:-18px 0 0 -18px;height:36px;width:36px;pointer-events:none}.dplayer-bezel .diplayer-loading-icon .diplayer-loading-hide{display:none}.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot{-webkit-animation:diplayer-loading-dot-fade .8s ease infinite;animation:diplayer-loading-dot-fade .8s ease infinite;opacity:0;transform-origin:4px 4px}.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-7{-webkit-animation-delay:.7s;animation-delay:.7s}.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-6{-webkit-animation-delay:.6s;animation-delay:.6s}.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-5{-webkit-animation-delay:.5s;animation-delay:.5s}.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-4{-webkit-animation-delay:.4s;animation-delay:.4s}.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-3{-webkit-animation-delay:.3s;animation-delay:.3s}.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-2{-webkit-animation-delay:.2s;animation-delay:.2s}.dplayer-bezel .diplayer-loading-icon .diplayer-loading-dot.diplayer-loading-dot-1{-webkit-animation-delay:.1s;animation-delay:.1s}@-webkit-keyframes diplayer-loading-dot-fade{0%{opacity:.7;transform:scale(1.2)}50%{opacity:.25;transform:scale(.9)}to{opacity:.25;transform:scale(.85)}}@keyframes diplayer-loading-dot-fade{0%{opacity:.7;transform:scale(1.2)}50%{opacity:.25;transform:scale(.9)}to{opacity:.25;transform:scale(.85)}}.dplayer-controller-mask{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADGCAYAAAAT+OqFAAAAdklEQVQoz42QQQ7AIAgEF/T/D+kbq/RWAlnQyyazA4aoAB4FsBSA/bFjuF1EOL7VbrIrBuusmrt4ZZORfb6ehbWdnRHEIiITaEUKa5EJqUakRSaEYBJSCY2dEstQY7AuxahwXFrvZmWl2rh4JZ07z9dLtesfNj5q0FU3A5ObbwAAAABJRU5ErkJggg==) repeat-x bottom;height:98px;width:100%}.dplayer-controller,.dplayer-controller-mask{position:absolute;bottom:0;transition:all .3s ease}.dplayer-controller{left:0;right:0;height:41px;padding:0 20px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.dplayer-controller .dplayer-bar-wrap{padding:5px 0;cursor:pointer;position:absolute;bottom:33px;width:calc(100% - 40px);height:3px}.dplayer-controller .dplayer-bar-wrap:hover .dplayer-bar .dplayer-played .dplayer-thumb{transform:scale(1)}.dplayer-controller .dplayer-bar-wrap .dplayer-bar-time{position:absolute;left:0;top:-20px;border-radius:4px;padding:5px 7px;background-color:rgba(0,0,0,.62);color:#fff;font-size:12px;text-align:center;opacity:1;transition:opacity .1s ease-in-out;word-wrap:normal;word-break:normal;z-index:2;pointer-events:none}.dplayer-controller .dplayer-bar-wrap .dplayer-bar-time.hidden{opacity:0}.dplayer-controller .dplayer-bar-wrap .dplayer-bar{position:relative;height:3px;width:100%;background:hsla(0,0%,100%,.2);cursor:pointer}.dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-loaded{background:hsla(0,0%,100%,.4);transition:all .5s ease}.dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-loaded,.dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-played{position:absolute;left:0;top:0;bottom:0;height:3px;will-change:width}.dplayer-controller .dplayer-bar-wrap .dplayer-bar .dplayer-played .dplayer-thumb{position:absolute;top:0;right:5px;margin-top:-4px;margin-right:-10px;height:11px;width:11px;border-radius:50%;cursor:pointer;transition:all .3s ease-in-out;transform:scale(0)}.dplayer-controller .dplayer-icons{height:38px;position:absolute;bottom:0}.dplayer-controller .dplayer-icons.dplayer-icons-left .dplayer-icon{padding:7px}.dplayer-controller .dplayer-icons.dplayer-icons-right{right:20px}.dplayer-controller .dplayer-icons.dplayer-icons-right .dplayer-icon{padding:8px}.dplayer-controller .dplayer-icons .dplayer-time{line-height:38px;color:#eee;text-shadow:0 0 2px rgba(0,0,0,.5);vertical-align:middle;font-size:13px;cursor:default}.dplayer-controller .dplayer-icons .dplayer-icon{width:40px;height:100%;border:none;background-color:transparent;outline:none;position:relative;cursor:pointer;vertical-align:middle;box-sizing:border-box;display:inline-block}.dplayer-controller .dplayer-icons .dplayer-icon .dplayer-icon-content{transition:all .2s ease-in-out;opacity:.8}.dplayer-controller .dplayer-icons .dplayer-icon:hover .dplayer-icon-content{opacity:1}.dplayer-controller .dplayer-icons .dplayer-icon.dplayer-volume-icon{width:43px}.dplayer-controller .dplayer-icons .dplayer-volume{position:relative;display:inline-block;cursor:pointer;height:100%}.dplayer-controller .dplayer-icons .dplayer-volume:hover .dplayer-volume-bar-wrap .dplayer-volume-bar{width:45px}.dplayer-controller .dplayer-icons .dplayer-volume:hover .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner .dplayer-thumb{transform:scale(1)}.dplayer-controller .dplayer-icons .dplayer-volume.dplayer-volume-active .dplayer-volume-bar-wrap .dplayer-volume-bar{width:45px}.dplayer-controller .dplayer-icons .dplayer-volume.dplayer-volume-active .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner .dplayer-thumb{transform:scale(1)}.dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap{display:inline-block;margin:0 15px 0 -5px;vertical-align:middle;height:100%}.dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap .dplayer-volume-bar{position:relative;top:17px;width:0;height:3px;background:#aaa;transition:all .3s ease-in-out}.dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner{position:absolute;bottom:0;left:0;height:100%;transition:all .1s ease;will-change:width}.dplayer-controller .dplayer-icons .dplayer-volume .dplayer-volume-bar-wrap .dplayer-volume-bar .dplayer-volume-bar-inner .dplayer-thumb{position:absolute;top:0;right:5px;margin-top:-4px;margin-right:-10px;height:11px;width:11px;border-radius:50%;cursor:pointer;transition:all .3s ease-in-out;transform:scale(0)}.dplayer-controller .dplayer-icons .dplayer-full,.dplayer-controller .dplayer-icons .dplayer-full-in,.dplayer-controller .dplayer-icons .dplayer-loop{display:inline-block;height:100%}.dplayer-notice{opacity:0;position:absolute;bottom:60px;left:20px;font-size:14px;border-radius:2px;background:rgba(28,28,28,.9);padding:7px 20px;transition:all .3s ease-in-out;overflow:hidden;color:#fff;pointer-events:none}.dplayer-mask{position:absolute;top:0;bottom:0;left:0;right:0;z-index:1;display:none}.dplayer-mask.dplayer-mask-show{display:block}.dplayer-video-wrap{position:relative;background:#000;font-size:0;width:100%;height:100%}.dplayer-video-wrap .dplayer-video{width:100%;height:100%;display:none}.dplayer-video-wrap .dplayer-video-current{display:block}",""])},function(e,t,n){"use strict";e.exports=function(e){var t=[];return t.toString=function(){return this.map((function(t){var n=function(e,t){var n=e[1]||"",r=e[3];if(!r)return n;if(t&&"function"==typeof btoa){var o=(a=r,l=btoa(unescape(encodeURIComponent(JSON.stringify(a)))),s="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(l),"/*# ".concat(s," */")),i=r.sources.map((function(e){return"/*# sourceURL=".concat(r.sourceRoot).concat(e," */")}));return[n].concat(i).concat([o]).join("\n")}var a,l,s;return[n].join("\n")}(t,e);return t[2]?"@media ".concat(t[2],"{").concat(n,"}"):n})).join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},o=0;o<this.length;o++){var i=this[o][0];null!=i&&(r[i]=!0)}for(var a=0;a<e.length;a++){var l=e[a];null!=l[0]&&r[l[0]]||(n&&!l[2]?l[2]=n:n&&(l[2]="(".concat(l[2],") and (").concat(n,")")),t.push(l))}},t}},function(e,t,n){"use strict";var r,o={},i=function(){return void 0===r&&(r=Boolean(window&&document&&document.all&&!window.atob)),r},a=function(){var e={};return function(t){if(void 0===e[t]){var n=document.querySelector(t);if(window.HTMLIFrameElement&&n instanceof window.HTMLIFrameElement)try{n=n.contentDocument.head}catch(e){n=null}e[t]=n}return e[t]}}();function l(e,t){for(var n=[],r={},o=0;o<e.length;o++){var i=e[o],a=t.base?i[0]+t.base:i[0],l={css:i[1],media:i[2],sourceMap:i[3]};r[a]?r[a].parts.push(l):n.push(r[a]={id:a,parts:[l]})}return n}function s(e,t){for(var n=0;n<e.length;n++){var r=e[n],i=o[r.id],a=0;if(i){for(i.refs++;a<i.parts.length;a++)i.parts[a](r.parts[a]);for(;a<r.parts.length;a++)i.parts.push(v(r.parts[a],t))}else{for(var l=[];a<r.parts.length;a++)l.push(v(r.parts[a],t));o[r.id]={id:r.id,refs:1,parts:l}}}}function c(e){var t=document.createElement("style");if(void 0===e.attributes.nonce){var r=n.nc;r&&(e.attributes.nonce=r)}if(Object.keys(e.attributes).forEach((function(n){t.setAttribute(n,e.attributes[n])})),"function"==typeof e.insert)e.insert(t);else{var o=a(e.insert||"head");if(!o)throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");o.appendChild(t)}return t}var d,p=(d=[],function(e,t){return d[e]=t,d.filter(Boolean).join("\n")});function u(e,t,n,r){var o=n?"":r.css;if(e.styleSheet)e.styleSheet.cssText=p(t,o);else{var i=document.createTextNode(o),a=e.childNodes;a[t]&&e.removeChild(a[t]),a.length?e.insertBefore(i,a[t]):e.appendChild(i)}}function y(e,t,n){var r=n.css,o=n.media,i=n.sourceMap;if(o&&e.setAttribute("media",o),i&&btoa&&(r+="\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i))))," */")),e.styleSheet)e.styleSheet.cssText=r;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(r))}}var h=null,f=0;function v(e,t){var n,r,o;if(t.singleton){var i=f++;n=h||(h=c(t)),r=u.bind(null,n,i,!1),o=u.bind(null,n,i,!0)}else n=c(t),r=y.bind(null,n,t),o=function(){!function(e){if(null===e.parentNode)return!1;e.parentNode.removeChild(e)}(n)};return r(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;r(e=t)}else o()}}e.exports=function(e,t){(t=t||{}).attributes="object"==typeof t.attributes?t.attributes:{},t.singleton||"boolean"==typeof t.singleton||(t.singleton=i());var n=l(e,t);return s(n,t),function(e){for(var r=[],i=0;i<n.length;i++){var a=n[i],c=o[a.id];c&&(c.refs--,r.push(c))}e&&s(l(e,t),t);for(var d=0;d<r.length;d++){var p=r[d];if(0===p.refs){for(var u=0;u<p.parts.length;u++)p.parts[u]();delete o[p.id]}}}}},function(e,t,n){(function(e){var r=void 0!==e&&e||"undefined"!=typeof self&&self||window,o=Function.prototype.apply;function i(e,t){this._id=e,this._clearFn=t}t.setTimeout=function(){return new i(o.call(setTimeout,r,arguments),clearTimeout)},t.setInterval=function(){return new i(o.call(setInterval,r,arguments),clearInterval)},t.clearTimeout=t.clearInterval=function(e){e&&e.close()},i.prototype.unref=i.prototype.ref=function(){},i.prototype.close=function(){this._clearFn.call(r,this._id)},t.enroll=function(e,t){clearTimeout(e._idleTimeoutId),e._idleTimeout=t},t.unenroll=function(e){clearTimeout(e._idleTimeoutId),e._idleTimeout=-1},t._unrefActive=t.active=function(e){clearTimeout(e._idleTimeoutId);var t=e._idleTimeout;t>=0&&(e._idleTimeoutId=setTimeout((function(){e._onTimeout&&e._onTimeout()}),t))},n(19),t.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==e&&e.setImmediate||this&&this.setImmediate,t.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==e&&e.clearImmediate||this&&this.clearImmediate}).call(this,n(0))},function(e,t,n){(function(e,t){!function(e,n){"use strict";if(!e.setImmediate){var r,o,i,a,l,s=1,c={},d=!1,p=e.document,u=Object.getPrototypeOf&&Object.getPrototypeOf(e);u=u&&u.setTimeout?u:e,"[object process]"==={}.toString.call(e.process)?r=function(e){t.nextTick((function(){h(e)}))}:!function(){if(e.postMessage&&!e.importScripts){var t=!0,n=e.onmessage;return e.onmessage=function(){t=!1},e.postMessage("","*"),e.onmessage=n,t}}()?e.MessageChannel?((i=new MessageChannel).port1.onmessage=function(e){h(e.data)},r=function(e){i.port2.postMessage(e)}):p&&"onreadystatechange"in p.createElement("script")?(o=p.documentElement,r=function(e){var t=p.createElement("script");t.onreadystatechange=function(){h(e),t.onreadystatechange=null,o.removeChild(t),t=null},o.appendChild(t)}):r=function(e){setTimeout(h,0,e)}:(a="setImmediate$"+Math.random()+"$",l=function(t){t.source===e&&"string"==typeof t.data&&0===t.data.indexOf(a)&&h(+t.data.slice(a.length))},e.addEventListener?e.addEventListener("message",l,!1):e.attachEvent("onmessage",l),r=function(t){e.postMessage(a+t,"*")}),u.setImmediate=function(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),n=0;n<t.length;n++)t[n]=arguments[n+1];var o={callback:e,args:t};return c[s]=o,r(s),s++},u.clearImmediate=y}function y(e){delete c[e]}function h(e){if(d)setTimeout(h,0,e);else{var t=c[e];if(t){d=!0;try{!function(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(n,r)}}(t)}finally{y(e),d=!1}}}}}("undefined"==typeof self?void 0===e?this:e:self)}).call(this,n(0),n(20))},function(e,t){var n,r,o=e.exports={};function i(){throw new Error("setTimeout has not been defined")}function a(){throw new Error("clearTimeout has not been defined")}function l(e){if(n===setTimeout)return setTimeout(e,0);if((n===i||!n)&&setTimeout)return n=setTimeout,setTimeout(e,0);try{return n(e,0)}catch(t){try{return n.call(null,e,0)}catch(t){return n.call(this,e,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:i}catch(e){n=i}try{r="function"==typeof clearTimeout?clearTimeout:a}catch(e){r=a}}();var s,c=[],d=!1,p=-1;function u(){d&&s&&(d=!1,s.length?c=s.concat(c):p=-1,c.length&&y())}function y(){if(!d){var e=l(u);d=!0;for(var t=c.length;t;){for(s=c,c=[];++p<t;)s&&s[p].run();p=-1,t=c.length}s=null,d=!1,function(e){if(r===clearTimeout)return clearTimeout(e);if((r===a||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(e);try{r(e)}catch(t){try{return r.call(null,e)}catch(t){return r.call(this,e)}}}(e)}}function h(e,t){this.fun=e,this.array=t}function f(){}o.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];c.push(new h(e,t)),1!==c.length||d||l(y)},h.prototype.run=function(){this.fun.apply(null,this.array)},o.title="browser",o.browser=!0,o.env={},o.argv=[],o.version="",o.versions={},o.on=f,o.addListener=f,o.once=f,o.off=f,o.removeListener=f,o.removeAllListeners=f,o.emit=f,o.prependListener=f,o.prependOnceListener=f,o.listeners=function(e){return[]},o.binding=function(e){throw new Error("process.binding is not supported")},o.cwd=function(){return"/"},o.chdir=function(e){throw new Error("process.chdir is not supported")},o.umask=function(){return 0}},function(e,t,n){"use strict";(function(t){var n="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==t?t:{},r=Object.create(n),o=/["&'<>]/;r.$escape=function(e){return function(e){var t=""+e,n=o.exec(t);if(!n)return e;var r="",i=void 0,a=void 0,l=void 0;for(i=n.index,a=0;i<t.length;i++){switch(t.charCodeAt(i)){case 34:l="&#34;";break;case 38:l="&#38;";break;case 39:l="&#39;";break;case 60:l="&#60;";break;case 62:l="&#62;";break;default:continue}a!==i&&(r+=t.substring(a,i)),a=i+1,r+=l}return a!==i?r+t.substring(a,i):r}(function e(t){"string"!=typeof t&&(t=null==t?"":"function"==typeof t?e(t.call(t)):JSON.stringify(t));return t}(e))},r.$each=function(e,t){if(Array.isArray(e))for(var n=0,r=e.length;n<r;n++)t(e[n],n);else for(var o in e)t(e[o],o)},e.exports=r}).call(this,n(0))},function(e,t,n){var r=n(1);e.exports=function(e){"use strict";var t="",n=(e=e||{}).pic,o=r.$escape,i=e.preload,a=e.url;return t+='<video class="dplayer-video dplayer-video-current" webkit-playsinline playsinline',n&&(t+=' poster="',t+=o(n),t+='"'),i&&(t+=' preload="',t+=o(i),t+='"'),a&&(t+=' src="',t+=o(a),t+='"'),t+="></video>"}},function(e,t,n){"use strict";n.r(t);n(14);var r=n(2),o=/mobile/i.test(window.navigator.userAgent),i={secondToTime:function(e){if(0===(e=e||0)||e===1/0||"NaN"===e.toString())return"00:00";var t=Math.floor(e/3600),n=Math.floor((e-3600*t)/60),r=Math.floor(e-3600*t-60*n);return(t>0?[t,n,r]:[n,r]).map((function(e){return e<10?"0"+e:""+e})).join(":")},getElementViewLeft:function(e){var t=e.offsetLeft,n=e.offsetParent,r=document.body.scrollLeft+document.documentElement.scrollLeft;if(document.fullscreenElement||document.mozFullScreenElement||document.webkitFullscreenElement)for(;null!==n&&n!==e;)t+=n.offsetLeft,n=n.offsetParent;else for(;null!==n;)t+=n.offsetLeft,n=n.offsetParent;return t-r},getBoundingClientRectViewLeft:function(e){var t=window.scrollY||window.pageYOffset||document.body.scrollTop+(document.documentElement&&document.documentElement.scrollTop||0);if(e.getBoundingClientRect){if("number"!=typeof this.getBoundingClientRectViewLeft.offset){var n=document.createElement("div");n.style.cssText="position:absolute;top:0;left:0;",document.body.appendChild(n),this.getBoundingClientRectViewLeft.offset=-n.getBoundingClientRect().top-t,document.body.removeChild(n),n=null}var r=e.getBoundingClientRect(),o=this.getBoundingClientRectViewLeft.offset;return r.left+o}return this.getElementViewLeft(e)},getScrollPosition:function(){return{left:window.pageXOffset||document.documentElement.scrollLeft||document.body.scrollLeft||0,top:window.pageYOffset||document.documentElement.scrollTop||document.body.scrollTop||0}},setScrollPosition:function(e){var t=e.left,n=void 0===t?0:t,r=e.top,o=void 0===r?0:r;this.isFirefox?(document.documentElement.scrollLeft=n,document.documentElement.scrollTop=o):window.scrollTo(n,o)},isMobile:o,isFirefox:/firefox/i.test(window.navigator.userAgent),isChrome:/chrome/i.test(window.navigator.userAgent),nameMap:{dragStart:o?"touchstart":"mousedown",dragMove:o?"touchmove":"mousemove",dragEnd:o?"touchend":"mouseup"}},a=function(e){var t={container:e.element||document.getElementsByClassName("dplayer")[0],autoplay:!1,theme:"#b7daff",loop:!1,lang:(navigator.language||navigator.browserLanguage).toLowerCase(),preload:"auto",volume:1,video:{},mutex:!0,pluginOptions:{hls:{},flvjs:{},dash:{},webtorrent:{}}};for(var n in t)t.hasOwnProperty(n)&&!e.hasOwnProperty(n)&&(e[n]=t[n]);return e.video&&!e.video.type&&(e.video.type="auto"),e.lang&&(e.lang=e.lang.toLowerCase()),e};var l={"zh-cn":{"Video load failed":"视频加载失败","Go forward":"快进","Go back":"快退",seconds:"秒",Volume:"音量"},"zh-tw":{"Video load failed":"視頻加載失敗","Go forward":"快進","Go back":"快退",seconds:"秒",Volume:"音量"}},s=function(e){var t=this;this.lang=e,this.tran=function(e){return l[t.lang]&&l[t.lang][e]?l[t.lang][e]:e}},c=n(4),d=n.n(c),p=n(5),u=n.n(p),y=n(6),h=n.n(y),f=n(7),v=n.n(f),m=n(8),g=n.n(m),b=n(9),w=n.n(b),k=n(10),x=n.n(k),T=n(11),E=n.n(T),L=n(12),S=n.n(L),M={play:d.a,pause:u.a,loop:h.a,volumeUp:v.a,volumeDown:g.a,volumeOff:w.a,full:x.a,fullWeb:E.a,loading:S.a},z=n(13),B=n.n(z);function q(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var F=function(){function e(t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.container=t.container,this.options=t.options,this.tran=t.tran,this.init()}var t,n,r;return t=e,(n=[{key:"init",value:function(){this.container.innerHTML=B()({options:this.options,tran:this.tran,icons:M,video:{pic:this.options.video.pic,preload:this.options.preload,url:this.options.video.url}}),this.volumeBar=this.container.querySelector(".dplayer-volume-bar-inner"),this.volumeBarWrap=this.container.querySelector(".dplayer-volume-bar"),this.volumeBarWrapWrap=this.container.querySelector(".dplayer-volume-bar-wrap"),this.volumeButton=this.container.querySelector(".dplayer-volume"),this.volumeButtonIcon=this.container.querySelector(".dplayer-volume-icon"),this.volumeIcon=this.container.querySelector(".dplayer-volume-icon .dplayer-icon-content"),this.playedBar=this.container.querySelector(".dplayer-played"),this.loadedBar=this.container.querySelector(".dplayer-loaded"),this.playedBarWrap=this.container.querySelector(".dplayer-bar-wrap"),this.playedBarTime=this.container.querySelector(".dplayer-bar-time"),this.video=this.container.querySelector(".dplayer-video-current"),this.bezel=this.container.querySelector(".dplayer-bezel-icon"),this.playButton=this.container.querySelector(".dplayer-play-icon"),this.videoWrap=this.container.querySelector(".dplayer-video-wrap"),this.controllerMask=this.container.querySelector(".dplayer-controller-mask"),this.ptime=this.container.querySelector(".dplayer-ptime"),this.loopButton=this.container.querySelector(".dplayer-loop-icon"),this.loopIcon=this.container.querySelector(".dplayer-loop-icon .dplayer-icon-content"),this.dtime=this.container.querySelector(".dplayer-dtime"),this.browserFullButton=this.container.querySelector(".dplayer-full-icon"),this.webFullButton=this.container.querySelector(".dplayer-full-in-icon"),this.notice=this.container.querySelector(".dplayer-notice")}}])&&q(t.prototype,n),r&&q(t,r),e}();function j(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var _=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.events={},this.videoEvents=["abort","canplay","canplaythrough","durationchange","emptied","ended","error","loadeddata","loadedmetadata","loadstart","mozaudioavailable","pause","play","playing","progress","ratechange","seeked","seeking","stalled","suspend","timeupdate","volumechange","waiting"],this.playerEvents=["loop_enable","loop_disable","notice_show","notice_hide","destroy","resize","fullscreen","fullscreen_cancel","webfullscreen","webfullscreen_cancel"]}var t,n,r;return t=e,(n=[{key:"on",value:function(e,t){this.type(e)&&"function"==typeof t&&(this.events[e]||(this.events[e]=[]),this.events[e].push(t))}},{key:"trigger",value:function(e,t){if(this.events[e]&&this.events[e].length)for(var n=0;n<this.events[e].length;n++)this.events[e][n](t)}},{key:"type",value:function(e){return-1!==this.playerEvents.indexOf(e)?"player":-1!==this.videoEvents.indexOf(e)?"video":(console.error("Unknown event name: ".concat(e)),null)}}])&&j(t.prototype,n),r&&j(t,r),e}();function C(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var O=function(){function e(t){var n=this;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.player=t,this.lastScrollPosition={left:0,top:0},this.player.events.on("webfullscreen",(function(){n.player.resize()})),this.player.events.on("webfullscreen_cancel",(function(){n.player.resize(),i.setScrollPosition(n.lastScrollPosition)}));var r=function(){n.player.resize(),n.isFullScreen("browser")?n.player.events.trigger("fullscreen"):(i.setScrollPosition(n.lastScrollPosition),n.player.events.trigger("fullscreen_cancel"))},o=function(){var e=document.fullscreenElement||document.mozFullScreenElement||document.msFullscreenElement;e&&e!==n.player.container||(n.player.resize(),e?n.player.events.trigger("fullscreen"):(i.setScrollPosition(n.lastScrollPosition),n.player.events.trigger("fullscreen_cancel")))};/Firefox/.test(navigator.userAgent)?(document.addEventListener("mozfullscreenchange",o),document.addEventListener("fullscreenchange",o)):(this.player.container.addEventListener("fullscreenchange",r),this.player.container.addEventListener("webkitfullscreenchange",r),document.addEventListener("msfullscreenchange",o),document.addEventListener("MSFullscreenChange",o))}var t,n,r;return t=e,(n=[{key:"isFullScreen",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"browser";switch(e){case"browser":return document.fullscreenElement||document.mozFullScreenElement||document.webkitFullscreenElement||document.msFullscreenElement;case"web":return this.player.container.classList.contains("dplayer-fulled")}}},{key:"request",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"browser",t="browser"===e?"web":"browser",n=this.isFullScreen(t);switch(n||(this.lastScrollPosition=i.getScrollPosition()),e){case"browser":this.player.container.requestFullscreen?this.player.container.requestFullscreen():this.player.container.mozRequestFullScreen?this.player.container.mozRequestFullScreen():this.player.container.webkitRequestFullscreen?this.player.container.webkitRequestFullscreen():this.player.video.webkitEnterFullscreen?this.player.video.webkitEnterFullscreen():this.player.video.webkitEnterFullScreen?this.player.video.webkitEnterFullScreen():this.player.container.msRequestFullscreen&&this.player.container.msRequestFullscreen();break;case"web":this.player.container.classList.add("dplayer-fulled"),document.body.classList.add("dplayer-web-fullscreen-fix"),this.player.events.trigger("webfullscreen")}n&&this.cancel(t)}},{key:"cancel",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"browser";switch(e){case"browser":document.cancelFullScreen?document.cancelFullScreen():document.mozCancelFullScreen?document.mozCancelFullScreen():document.webkitCancelFullScreen?document.webkitCancelFullScreen():document.webkitCancelFullscreen?document.webkitCancelFullscreen():document.msCancelFullScreen?document.msCancelFullScreen():document.msExitFullscreen&&document.msExitFullscreen();break;case"web":this.player.container.classList.remove("dplayer-fulled"),document.body.classList.remove("dplayer-web-fullscreen-fix"),this.player.events.trigger("webfullscreen_cancel")}}},{key:"toggle",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"browser";this.isFullScreen(e)?this.cancel(e):this.request(e)}}])&&C(t.prototype,n),r&&C(t,r),e}();function A(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var P=function(){function e(t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.elements={},this.elements.volume=t.volumeBar,this.elements.played=t.playedBar,this.elements.loaded=t.loadedBar}var t,n,r;return t=e,(n=[{key:"set",value:function(e,t,n){t=Math.max(t,0),t=Math.min(t,1),this.elements[e].style[n]=100*t+"%"}},{key:"get",value:function(e){return parseFloat(this.elements[e].style.width)/100}}])&&A(t.prototype,n),r&&A(t,r),e}();function I(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var R=function(){function e(t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.player=t,window.requestAnimationFrame=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(e){window.setTimeout(e,1e3/60)},this.types=["loading"],this.init()}var t,n,r;return t=e,(n=[{key:"init",value:function(){var e=this;this.types.map((function(t){return e["init".concat(t,"Checker")](),t}))}},{key:"initloadingChecker",value:function(){var e=this,t=0,n=0,r=!1;this.loadingChecker=setInterval((function(){e.enableloadingChecker&&(n=e.player.video.currentTime,r||n!==t||e.player.video.paused||(e.player.container.classList.add("dplayer-loading"),r=!0),r&&n>t&&!e.player.video.paused&&(e.player.container.classList.remove("dplayer-loading"),r=!1),t=n)}),100)}},{key:"enable",value:function(e){this["enable".concat(e,"Checker")]=!0}},{key:"disable",value:function(e){this["enable".concat(e,"Checker")]=!1}},{key:"destroy",value:function(){var e=this;this.types.map((function(t){return e["enable".concat(t,"Checker")]=!1,e["".concat(t,"Checker")]&&clearInterval(e["".concat(t,"Checker")]),t}))}}])&&I(t.prototype,n),r&&I(t,r),e}();function W(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var H=function(){function e(t){var n=this;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.container=t,this.container.addEventListener("animationend",(function(){n.container.classList.remove("dplayer-bezel-transition")}))}var t,n,r;return t=e,(n=[{key:"switch",value:function(e){this.container.innerHTML=e,this.container.classList.add("dplayer-bezel-transition")}}])&&W(t.prototype,n),r&&W(t,r),e}();function V(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var D=function(){function e(t){var n=this;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.player=t,this.autoHideTimer=0,i.isMobile||this.player.container.addEventListener("mousemove",(function(){n.setAutoHide()})),this.player.container.addEventListener("click",(function(){n.setAutoHide()})),this.player.on("play",(function(){n.setAutoHide()})),this.player.on("pause",(function(){n.setAutoHide()})),this.initPlayButton(),this.initPlayedBar(),this.initFullButton(),i.isMobile||this.initVolumeButton()}var t,n,r;return t=e,(n=[{key:"initPlayButton",value:function(){var e=this;this.player.template.playButton.addEventListener("click",(function(){e.player.toggle()})),i.isMobile?(this.player.template.videoWrap.addEventListener("click",(function(){e.toggle()})),this.player.template.controllerMask.addEventListener("click",(function(){e.toggle()}))):(this.player.template.videoWrap.addEventListener("click",(function(){e.player.toggle()})),this.player.template.controllerMask.addEventListener("click",(function(){e.player.toggle()})))}},{key:"initPlayedBar",value:function(){var e=this,t=function(t){var n=((t.clientX||t.changedTouches[0].clientX)-i.getBoundingClientRectViewLeft(e.player.template.playedBarWrap))/e.player.template.playedBarWrap.clientWidth;n=Math.max(n,0),n=Math.min(n,1),e.player.bar.set("played",n,"width"),e.player.template.ptime.innerHTML=i.secondToTime(n*e.player.video.duration)},n=function n(r){document.removeEventListener(i.nameMap.dragEnd,n),document.removeEventListener(i.nameMap.dragMove,t);var o=((r.clientX||r.changedTouches[0].clientX)-i.getBoundingClientRectViewLeft(e.player.template.playedBarWrap))/e.player.template.playedBarWrap.clientWidth;o=Math.max(o,0),o=Math.min(o,1),e.player.bar.set("played",o,"width"),e.player.seek(e.player.bar.get("played")*e.player.video.duration),e.player.timer.enable("progress")};this.player.template.playedBarWrap.addEventListener(i.nameMap.dragStart,(function(){e.player.timer.disable("progress"),document.addEventListener(i.nameMap.dragMove,t),document.addEventListener(i.nameMap.dragEnd,n)})),this.player.template.playedBarWrap.addEventListener(i.nameMap.dragMove,(function(t){if(e.player.video.duration){var n=e.player.template.playedBarWrap.getBoundingClientRect().left,r=(t.clientX||t.changedTouches[0].clientX)-n;if(r<0||r>e.player.template.playedBarWrap.offsetWidth)return;var o=e.player.video.duration*(r/e.player.template.playedBarWrap.offsetWidth);e.player.template.playedBarTime.style.left="".concat(r-(o>=3600?25:20),"px"),e.player.template.playedBarTime.innerText=i.secondToTime(o),e.player.template.playedBarTime.classList.remove("hidden")}e.setAutoHide()})),i.isMobile||(this.player.template.playedBarWrap.addEventListener("mouseenter",(function(){e.player.video.duration&&e.player.template.playedBarTime.classList.remove("hidden")})),this.player.template.playedBarWrap.addEventListener("mouseleave",(function(){e.player.video.duration&&e.player.template.playedBarTime.classList.add("hidden")})))}},{key:"initFullButton",value:function(){var e=this;this.player.template.browserFullButton.addEventListener("click",(function(){e.player.fullScreen.toggle("browser")})),this.player.template.webFullButton.addEventListener("click",(function(){e.player.fullScreen.toggle("web")}))}},{key:"initVolumeButton",value:function(){var e=this,t=function(t){var n=t||window.event,r=((n.clientX||n.changedTouches[0].clientX)-i.getBoundingClientRectViewLeft(e.player.template.volumeBarWrap)-5.5)/35;e.player.volume(r)},n=function n(){document.removeEventListener(i.nameMap.dragEnd,n),document.removeEventListener(i.nameMap.dragMove,t),e.player.template.volumeButton.classList.remove("dplayer-volume-active")};this.player.template.volumeBarWrapWrap.addEventListener("click",(function(t){var n=t||window.event,r=((n.clientX||n.changedTouches[0].clientX)-i.getBoundingClientRectViewLeft(e.player.template.volumeBarWrap)-5.5)/35;e.player.volume(r)})),this.player.template.volumeBarWrapWrap.addEventListener(i.nameMap.dragStart,(function(){document.addEventListener(i.nameMap.dragMove,t),document.addEventListener(i.nameMap.dragEnd,n),e.player.template.volumeButton.classList.add("dplayer-volume-active")})),this.player.template.volumeButtonIcon.addEventListener("click",(function(){e.player.video.muted?(e.player.video.muted=!1,e.player.switchVolumeIcon(),e.player.bar.set("volume",e.player.volume(),"width")):(e.player.video.muted=!0,e.player.template.volumeIcon.innerHTML=M.volumeOff,e.player.bar.set("volume",0,"width"))}))}},{key:"setAutoHide",value:function(){var e=this;this.show(),clearTimeout(this.autoHideTimer),this.autoHideTimer=setTimeout((function(){e.player.video.played.length&&e.hide()}),3e3)}},{key:"show",value:function(){this.player.container.classList.remove("dplayer-hide-controller")}},{key:"hide",value:function(){this.player.container.classList.add("dplayer-hide-controller")}},{key:"isShow",value:function(){return!this.player.container.classList.contains("dplayer-hide-controller")}},{key:"toggle",value:function(){this.isShow()?this.hide():this.show()}},{key:"destroy",value:function(){clearTimeout(this.autoHideTimer)}}])&&V(t.prototype,n),r&&V(t,r),e}();var U=function e(t){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),document.addEventListener("keydown",(function(e){if(t.focus){var n,r=e||window.event;switch(r.keyCode){case 27:t.fullScreen.isFullScreen("web")&&t.fullScreen.cancel("web");break;case 32:r.preventDefault(),t.toggle(),t.controller.setAutoHide();break;case 37:r.preventDefault(),t.seek(t.video.currentTime-3,!0);break;case 39:r.preventDefault(),t.seek(t.video.currentTime+3,!0);break;case 38:r.preventDefault(),n=t.volume()+.01,t.volume(n,!0);break;case 40:r.preventDefault(),n=t.volume()-.01,t.volume(n,!0)}}}))};function N(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r)}return n}function X(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function $(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var G=[],J=function(){function e(t){var n=this;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.options=a(function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?N(n,!0).forEach((function(t){X(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):N(n).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}({preload:"webtorrent"===t.video.type?"none":"metadata"},t)),this.tran=new s(this.options.lang).tran,this.events=new _,this.container=this.options.container,this.container.classList.add("dplayer"),i.isMobile&&this.container.classList.add("dplayer-mobile"),this.template=new F({container:this.container,options:this.options,tran:this.tran}),this.video=this.template.video,this.bar=new P(this.template),this.bezel=new H(this.template.bezel),this.fullScreen=new O(this),this.controller=new D(this),this.plugins={},document.addEventListener("click",(function(){n.focus=!1}),!0),this.container.addEventListener("click",(function(){n.focus=!0}),!0),this.paused=!0,this.timer=new R(this),this.hotkey=new U(this),this.initVideo(this.video,this.options.video.type),this.loop=this.options.loop;n.events.on("loop_enable",(function(){n.template.loopIcon.style.opacity=""})),n.events.on("loop_disable",(function(){n.template.loopIcon.style.opacity="0.4"})),n.template.loopButton.addEventListener("click",(function(){n.loop=!n.loop,n.loop?n.events.trigger("loop_enable"):n.events.trigger("loop_disable")})),this.loop?this.events.trigger("loop_enable"):this.events.trigger("loop_disable"),this.options.autoplay&&this.play(),this.container.addEventListener("contextmenu",(function(e){(e||window.event).preventDefault()})),G.push(this)}var t,n,o;return t=e,(n=[{key:"seek",value:function(e,t){e=Math.max(e,0),this.video.duration&&(e=Math.min(e,this.video.duration)),this.video.currentTime<e&&t?this.notice("".concat(this.tran("Go forward")," ").concat((e-this.video.currentTime).toFixed(0)," ").concat(this.tran("seconds"))):this.video.currentTime>e&&t&&this.notice("".concat(this.tran("Go back")," ").concat((this.video.currentTime-e).toFixed(0)," ").concat(this.tran("seconds"))),this.video.currentTime=e,this.bar.set("played",e/this.video.duration,"width"),this.template.ptime.innerHTML=i.secondToTime(e)}},{key:"play",value:function(){var e=this;if(this.paused=!1,this.video.paused&&this.bezel.switch(M.play),this.template.playButton.innerHTML=M.pause,r.a.resolve(this.video.play()).catch((function(){e.pause()})).then((function(){})),this.timer.enable("loading"),this.container.classList.add("dplayer-playing"),this.options.mutex)for(var t=0;t<G.length;t++)this!==G[t]&&G[t].pause()}},{key:"pause",value:function(){this.paused=!0,this.container.classList.remove("dplayer-loading"),this.video.paused||this.bezel.switch(M.pause),this.template.playButton.innerHTML=M.play,this.video.pause(),this.timer.disable("loading"),this.container.classList.remove("dplayer-playing")}},{key:"switchVolumeIcon",value:function(){this.volume()>=.8?this.template.volumeIcon.innerHTML=M.volumeUp:this.volume()>0?this.template.volumeIcon.innerHTML=M.volumeDown:this.template.volumeIcon.innerHTML=M.volumeOff}},{key:"volume",value:function(e,t){return e=parseFloat(e),isNaN(e)||(e=Math.max(e,0),e=Math.min(e,1),this.bar.set("volume",e,"width"),t&&this.notice("".concat(this.tran("Volume")," ").concat((100*e).toFixed(0),"%")),this.video.volume=e,this.video.muted&&(this.video.muted=!1),this.switchVolumeIcon()),this.video.volume}},{key:"toggle",value:function(){this.video.paused?this.play():this.pause()}},{key:"on",value:function(e,t){this.events.on(e,t)}},{key:"initMSE",value:function(e,t){var n=this;if(this.type=t,this.options.video.customType&&this.options.video.customType[t])"[object Function]"===Object.prototype.toString.call(this.options.video.customType[t])?this.options.video.customType[t](this.video,this):console.error("Illegal customType: ".concat(t));else switch("auto"===this.type&&(/m3u8(#|\?|$)/i.exec(e.src)?this.type="hls":/.flv(#|\?|$)/i.exec(e.src)?this.type="flv":/.mpd(#|\?|$)/i.exec(e.src)?this.type="dash":this.type="normal"),"hls"===this.type&&(e.canPlayType("application/x-mpegURL")||e.canPlayType("application/vnd.apple.mpegURL"))&&(this.type="normal"),this.type){case"hls":if(window.Hls)if(window.Hls.isSupported()){var r=this.options.pluginOptions.hls,o=new window.Hls(r);this.plugins.hls=o,o.loadSource(e.src),o.attachMedia(e),this.events.on("destroy",(function(){o.destroy(),delete n.plugins.hls}))}else this.notice("Error: Hls is not supported.");else this.notice("Error: Can't find Hls.");break;case"flv":if(window.flvjs)if(window.flvjs.isSupported()){var i=Object.assign(this.options.pluginOptions.flvjs,{type:"flv",url:e.src}),a=window.flvjs.createPlayer(i);this.plugins.flvjs=a,a.attachMediaElement(e),a.load(),this.events.on("destroy",(function(){a.unload(),a.detachMediaElement(),a.destroy(),delete n.plugins.flvjs}))}else this.notice("Error: flvjs is not supported.");else this.notice("Error: Can't find flvjs.");break;case"dash":if(window.dashjs){var l=window.dashjs.MediaPlayer().create().initialize(e,e.src,!1),s=this.options.pluginOptions.dash;l.updateSettings(s),this.plugins.dash=l,this.events.on("destroy",(function(){window.dashjs.MediaPlayer().reset(),delete n.plugins.dash}))}else this.notice("Error: Can't find dashjs.");break;case"webtorrent":if(window.WebTorrent)if(window.WebTorrent.WEBRTC_SUPPORT){this.container.classList.add("dplayer-loading");var c=this.options.pluginOptions.webtorrent,d=new window.WebTorrent(c);this.plugins.webtorrent=d;var p=e.src;e.src="",e.preload="metadata",e.addEventListener("durationchange",(function(){return n.container.classList.remove("dplayer-loading")}),{once:!0}),d.add(p,(function(e){e.files.find((function(e){return e.name.endsWith(".mp4")})).renderTo(n.video,{autoplay:n.options.autoplay})})),this.events.on("destroy",(function(){d.remove(p),d.destroy(),delete n.plugins.webtorrent}))}else this.notice("Error: Webtorrent is not supported.");else this.notice("Error: Can't find Webtorrent.")}}},{key:"initVideo",value:function(e,t){var n=this;this.initMSE(e,t),this.on("durationchange",(function(){1!==e.duration&&e.duration!==1/0&&(n.template.dtime.innerHTML=i.secondToTime(e.duration))})),this.on("progress",(function(){var t=e.buffered.length?e.buffered.end(e.buffered.length-1)/e.duration:0;n.bar.set("loaded",t,"width")})),this.on("error",(function(){n.video.error&&n.tran&&n.notice&&"webtorrent"!==n.type&&n.notice(n.tran("Video load failed"),-1)})),this.on("ended",(function(){n.bar.set("played",1,"width"),n.loop?(n.seek(0),n.play()):n.pause()})),this.on("play",(function(){n.paused&&n.play()})),this.on("pause",(function(){n.paused||n.pause()})),this.on("timeupdate",(function(){n.bar.set("played",n.video.currentTime/n.video.duration,"width");var e=i.secondToTime(n.video.currentTime);n.template.ptime.innerHTML!==e&&(n.template.ptime.innerHTML=e)}));for(var r=function(t){e.addEventListener(n.events.videoEvents[t],(function(){n.events.trigger(n.events.videoEvents[t])}))},o=0;o<this.events.videoEvents.length;o++)r(o);this.volume(this.options.volume)}},{key:"notice",value:function(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1500,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:.8;this.template.notice.innerHTML=e,this.template.notice.style.opacity=r,this.noticeTime&&clearTimeout(this.noticeTime),this.events.trigger("notice_show",e),n>0&&(this.noticeTime=setTimeout((function(){t.template.notice.style.opacity=0,t.events.trigger("notice_hide")}),n))}},{key:"resize",value:function(){this.events.trigger("resize")}},{key:"destroy",value:function(){G.splice(G.indexOf(this),1),this.pause(),this.controller.destroy(),this.timer.destroy(),this.video.src="",this.container.innerHTML="",this.events.trigger("destroy")}}])&&$(t.prototype,n),o&&$(t,o),e}();t.default=J}]).default}));

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_input_item_style_css__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_input_item_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_input_item_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_list_style_css__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_list_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_list_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_applyAction__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__activity_index__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_less__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 申请试用页面
  * @author wangzhuang
  * */var Apply = (_temp = _class = function (_Component) {
  _inherits(Apply, _Component);function Apply(props, context) {
    _classCallCheck(this, Apply);var _this = _possibleConstructorReturn(this, (Apply.__proto__ || Object.getPrototypeOf(Apply)).call(this, props, context));_this.userPhoneChange = function (val) {
      var fruit = false;var hint = '';if (_this.isEmpty(val)) {
        hint = '电话号码不能为空';fruit = _this.isEmpty(val);
      } else if (!_this.isPhone(val)) {
        hint = '电话号码格式不正确，请确认';fruit = !_this.isPhone(val);
      }_this.setState({ userPhoneError: fruit, userPhoneVal: val, userPhoneErrorHint: hint });return !fruit;
    };_this.userEmailChange = function (val) {
      var fruit = false;var hint = '';if (_this.isEmpty(val)) {
        hint = '邮箱不能为空';fruit = _this.isEmpty(val);
      } else if (!_this.isEmail(val)) {
        hint = '邮箱格式不正确，请确认';fruit = !_this.isEmail(val);
      }_this.setState({ userEmailError: fruit, userEmailVal: val, userEmailErrorHint: hint });return !fruit;
    };_this.submitFun = function () {
      var _this$state = _this.state,
          overallTypeIndex = _this$state.overallTypeIndex,
          enterpriseName = _this$state.enterpriseName,
          userName = _this$state.userName,
          userPhoneVal = _this$state.userPhoneVal,
          userEmailVal = _this$state.userEmailVal,
          overallTextarea = _this$state.overallTextarea,
          codeVal = _this$state.codeVal,
          from = _this$state.from;_this.setState({ enterpriseNameError: _this.isEmpty(enterpriseName), userNameError: _this.isEmpty(userName), codeError: _this.isEmpty(codeVal), codeHint: _this.isEmpty(codeVal) ? '验证码不能为空' : '' });_this.userPhoneChange(userPhoneVal);_this.userEmailChange(userEmailVal);if (!_this.isEmpty(userName) && _this.userPhoneChange(userPhoneVal) && _this.userEmailChange(userEmailVal) && !_this.isEmpty(codeVal)) {
        if (overallTypeIndex === 2) {
          if (_this.isEmpty(enterpriseName)) {
            return;
          }
        }var json = { 'company_name': enterpriseName, 'real_name': userName, 'phone_number': userPhoneVal.replace(/\s+/g, ''), 'email': userEmailVal.replace(/\s+/g, ''), 'id_type': overallTypeIndex, 'note': overallTextarea + ' - 慧推', 'catpcha': codeVal, 'from': from };if (overallTypeIndex === 1) {
          delete json['company_name'];
        }_this.props.fetchUserApply(json).then(function () {
          var cmsapiUserapply = _this.props.cmsapiUserapply;if (location.href.indexOf('testError') !== -1) {
            alert(cmsapiUserapply.msg);
          }if (cmsapiUserapply.is_error === 0) {
            window.location.href = 'https://console.bce.baidu.com/spp/?cf=aqgw';
          }if (cmsapiUserapply.is_error === 3) {
            _this.setState({ codeError: true, codeHint: '验证码不正确', codeImg: '/catpcha?t=' + Date.now() });
          }
        });
      }
    };_this.isEmpty = function (val) {
      var reg = /\S/;return !reg.test(val);
    };_this.isEmail = function (val) {
      var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;var value = val.replace(/\s/g, '');return reg.test(value);
    };_this.state = { overallTypeIndex: 2, // 身份类型
      enterpriseName: '', // 企业名称
      codeVal: '', enterpriseNameError: false, userNameError: false, codeError: false, userName: '', // 真实姓名
      hasError: false, userPhoneVal: '', // 电话号码
      userEmailVal: '', // 邮箱
      workId: [_this.props.match.params.Iid], // 感兴趣的业务
      overallTextarea: '', // 咨询内容
      userPhoneError: false, desInfoError: false, userPhoneErrorHint: '手机号码不能为空', userEmailError: false, userEmailErrorHint: '联系邮箱不能为空', codeImg: '/catpcha', codeHint: '验证码不能为空', from: _this.getRequest().from };_this.overallType = [{ val: '企业', id: 2 }, { val: '个人', id: 1 }];return _this;
  }_createClass(Apply, [{ key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;this.confirm = Object(__WEBPACK_IMPORTED_MODULE_9__activity_index__["a" /* confirm */])({ disableCloseByMask: true, title: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { style: { width: '6.5rem', margin: '0 auto' } }, '\u767E\u5EA6\u5B89\u5168\u4E2A\u4EBA\u4FE1\u606F\u4FDD\u62A4\u6276\u6301\u8BA1\u5212\u4F01\u4E1A\u5165\u9A7B\u534F\u8BAE'), type: 'large', content: __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'details-wrapper' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'details' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '\u6B22\u8FCE\u52A0\u5165\u767E\u5EA6\u5B89\u5168APP\u6D88\u606F\u63A8\u9001\u6276\u6301\u8BA1\u5212\uFF01'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '\u672C\u534F\u8BAE\u7531\u7533\u8BF7\u52A0\u5165\u767E\u5EA6\u5B89\u5168APP\u6D88\u606F\u63A8\u9001\u6276\u6301\u8BA1\u5212\u7684\u4F01\u4E1A\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u4F01\u4E1A\u201D\uFF09\u4E0E\u5317\u4EAC\u767E\u5EA6\u7F51\u8BAF\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u767E\u5EA6\u5B89\u5168\u201D\uFF09\u7B7E\u7F72\u3002 \u5728\u63A5\u53D7\u672C\u534F\u8BAE\u4E4B\u524D\uFF0C\u8BF7\u4ED4\u7EC6\u9605\u8BFB\u5E76\u9075\u5B88\u672C\u534F\u8BAE\u7684\u5168\u90E8\u5185\u5BB9\u3002\u8BF7\u52A1\u5FC5\u5BA1\u614E\u9605\u8BFB\u3001\u5145\u5206\u7406\u89E3\u5404\u6761\u6B3E\u7684\u5185\u5BB9\uFF0C\u7279\u522B\u662F\u4EE5\u7C97\u4F53\u4E0B\u5212\u7EBF\u6807\u6CE8\u7684\u6761\u6B3E\u3002 \u4F01\u4E1A\u901A\u8FC7\u7F51\u7EDC\u9875\u9762\u70B9\u51FB\u786E\u8BA4\u7533\u8BF7\u52A0\u5165\u767E\u5EA6\u5B89\u5168APP\u6D88\u606F\u63A8\u9001\u6276\u6301\u8BA1\u5212\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u672C\u8BA1\u5212\u201D\uFF09\u5C06\u89C6\u4E3A\u5BF9\u672C\u534F\u8BAE\u7684\u63A5\u53D7\uFF0C\u5DF2\u8FBE\u6210\u534F\u8BAE\u5E76\u540C\u610F\u63A5\u53D7\u672C\u534F\u8BAE\u7684\u5168\u90E8\u7EA6\u5B9A\u5185\u5BB9\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '\u672C\u534F\u8BAE\u7531\u7533\u8BF7\u52A0\u5165\u767E\u5EA6\u5B89\u5168APP\u6D88\u606F\u63A8\u9001\u6276\u6301\u8BA1\u5212\u7684\u4F01\u4E1A\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u4F01\u4E1A\u201D\uFF09\u4E0E\u5317\u4EAC\u767E\u5EA6\u7F51\u8BAF\u79D1\u6280\u6709\u9650\u516C\u53F8\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u767E\u5EA6\u5B89\u5168\u201D\uFF09\u7B7E\u7F72\u3002 \u5728\u63A5\u53D7\u672C\u534F\u8BAE\u4E4B\u524D\uFF0C\u8BF7\u4ED4\u7EC6\u9605\u8BFB\u5E76\u9075\u5B88\u672C\u534F\u8BAE\u7684\u5168\u90E8\u5185\u5BB9\u3002\u8BF7\u52A1\u5FC5\u5BA1\u614E\u9605\u8BFB\u3001\u5145\u5206\u7406\u89E3\u5404\u6761\u6B3E\u7684\u5185\u5BB9\uFF0C\u7279\u522B\u662F\u4EE5\u7C97\u4F53\u4E0B\u5212\u7EBF\u6807\u6CE8\u7684\u6761\u6B3E\u3002 \u4F01\u4E1A\u901A\u8FC7\u7F51\u7EDC\u9875\u9762\u70B9\u51FB\u786E\u8BA4\u7533\u8BF7\u52A0\u5165\u767E\u5EA6\u5B89\u5168APP\u6D88\u606F\u63A8\u9001\u6276\u6301\u8BA1\u5212\uFF08\u4EE5\u4E0B\u7B80\u79F0\u201C\u672C\u8BA1\u5212\u201D\uFF09\u5C06\u89C6\u4E3A\u5BF9\u672C\u534F\u8BAE\u7684\u63A5\u53D7\uFF0C\u5DF2\u8FBE\u6210\u534F\u8BAE\u5E76\u540C\u610F\u63A5\u53D7\u672C\u534F\u8BAE\u7684\u5168\u90E8\u7EA6\u5B9A\u5185\u5BB9\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '\u672C\u534F\u8BAE\u5185\u5BB9\u5305\u62EC\u534F\u8BAE\u6B63\u6587\u53CA\u6240\u6709\u767E\u5EA6\u5B89\u5168\u5DF2\u7ECF\u53D1\u5E03\u7684\u6216\u5C06\u6765\u53EF\u80FD\u53D1\u5E03\u7684\u670D\u52A1\u4F7F\u7528\u89C4\u5219\u3002\u6240\u6709\u89C4\u5219\u4E3A\u672C\u534F\u8BAE\u4E0D\u53EF\u5206\u5272\u7684\u4E00\u90E8\u5206\uFF0C\u4E0E\u534F\u8BAE\u6B63\u6587\u5177\u6709\u76F8\u540C\u6CD5\u5F8B\u6548\u529B\u3002 \u767E\u5EA6\u5B89\u5168\u6709\u6743\u4E0D\u65F6\u4FEE\u6539\u672C\u534F\u8BAE\u548C\u76F8\u5173\u89C4\u5219\u7684\u5185\u5BB9\uFF0C\u4FEE\u6539\u540E\u7684\u5185\u5BB9\u5C06\u516C\u5E03\u4E8E\u672C\u8BA1\u5212\u76F8\u5173\u9875\u9762\uFF0C\u5982\u4F01\u4E1A\u7EE7\u7EED\u53C2\u4E0E\u5E76\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u7684\uFF0C\u5219\u89C6\u4E3A\u4F01\u4E1A\u63A5\u53D7\u5E76\u540C\u610F\u9075\u5B88\u4FEE\u6539\u540E\u7684\u5185\u5BB9\u3002 \u5982\u4F01\u4E1A\u5BF9\u4FEE\u6539\u5B58\u6709\u4EFB\u4F55\u5F02\u8BAE\uFF0C \u6216\u8005\u4F01\u4E1A\u4E0D\u540C\u610F\u767E\u5EA6\u5B89\u5168\u516C\u5E03\u7684\u89C4\u5219\u7684\uFF0C\u4F01\u4E1A\u5E94\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\uFF0C\u540C\u65F6\u5411\u767E\u5EA6\u5B89\u5168\u63D0\u4EA4\u4E66\u9762\u7EC8\u6B62\u901A\u77E5\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '\u672C\u534F\u8BAE\u5185\u5BB9\u5305\u62EC\u534F\u8BAE\u6B63\u6587\u53CA\u6240\u6709\u767E\u5EA6\u5B89\u5168\u5DF2\u7ECF\u53D1\u5E03\u7684\u6216\u5C06\u6765\u53EF\u80FD\u53D1\u5E03\u7684\u670D\u52A1\u4F7F\u7528\u89C4\u5219\u3002\u6240\u6709\u89C4\u5219\u4E3A\u672C\u534F\u8BAE\u4E0D\u53EF\u5206\u5272\u7684\u4E00\u90E8\u5206\uFF0C\u4E0E\u534F\u8BAE\u6B63\u6587\u5177\u6709\u76F8\u540C\u6CD5\u5F8B\u6548\u529B\u3002 \u767E\u5EA6\u5B89\u5168\u6709\u6743\u4E0D\u65F6\u4FEE\u6539\u672C\u534F\u8BAE\u548C\u76F8\u5173\u89C4\u5219\u7684\u5185\u5BB9\uFF0C\u4FEE\u6539\u540E\u7684\u5185\u5BB9\u5C06\u516C\u5E03\u4E8E\u672C\u8BA1\u5212\u76F8\u5173\u9875\u9762\uFF0C\u5982\u4F01\u4E1A\u7EE7\u7EED\u53C2\u4E0E\u5E76\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u7684\uFF0C\u5219\u89C6\u4E3A\u4F01\u4E1A\u63A5\u53D7\u5E76\u540C\u610F\u9075\u5B88\u4FEE\u6539\u540E\u7684\u5185\u5BB9\u3002 \u5982\u4F01\u4E1A\u5BF9\u4FEE\u6539\u5B58\u6709\u4EFB\u4F55\u5F02\u8BAE\uFF0C \u6216\u8005\u4F01\u4E1A\u4E0D\u540C\u610F\u767E\u5EA6\u5B89\u5168\u516C\u5E03\u7684\u89C4\u5219\u7684\uFF0C\u4F01\u4E1A\u5E94\u7ACB\u5373\u505C\u6B62\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\uFF0C\u540C\u65F6\u5411\u767E\u5EA6\u5B89\u5168\u63D0\u4EA4\u4E66\u9762\u7EC8\u6B62\u901A\u77E5\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '\u4E00\u3001 \u5B9A\u4E49'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '1.APP\u6D88\u606F\u63A8\u9001\u6276\u6301\u8BA1\u5212\uFF1A\u6307\u7531\u767E\u5EA6\u5B89\u5168\u53D1\u8D77\u7684\uFF0C \u4F9D\u6258\u767E\u5EA6\u5B89\u5168\u7684App\u6D88\u606F\u63A8\u9001\u6280\u672F\u80FD\u529B\uFF0C\u901A\u8FC7\u6240\u8FD0\u8425\u7684\u767E\u5EA6\u6167\u63A8\u670D\u52A1\u5E73\u53F0\uFF08\u5730\u5740\uFF1Ahttps://cloud.baidu.com/product/spp.html\uFF09 \u5E2E\u52A9\u4E2D\u5C0F\u4F01\u4E1AApp\u63D0\u4F9B\u5404\u7C7B\u578B\u6D88\u606F\u63A8\u9001\u529F\u80FD\u3002 \u672C\u534F\u8BAE\u4E2D\u53EF\u79F0\u4E3A\u201C\u672C\u8BA1\u5212\u201D\uFF08\u672C\u8BA1\u5212\u5B98\u7F51\u9875\u9762\u5730\u5740\uFF1Ahttps://anquan.baidu.com/page/60\uFF09\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '2.APP\u6D88\u606F\u63A8\u9001\u6276\u6301\u8BA1\u5212\u5165\u9A7B\u4F01\u4E1A\uFF1A\u6307\u7B26\u5408\u672C\u534F\u8BAE\u9879\u4E0B\u7533\u8BF7\u6761\u4EF6\uFF0C\u5B8C\u5168\u540C\u610F\u672C\u534F\u8BAE\u6761\u6B3E\uFF0C\u5B8C\u6210\u6CE8\u518C\u7533\u8BF7\u6D41\u7A0B\uFF0C\u5E76\u7ECF\u767E\u5EA6\u5B89\u5168\u6279\u51C6\u52A0\u5165\u672C\u8BA1\u5212\u5E76\u4F7F\u7528\u672C\u8BA1\u5212\u5404\u9879\u670D\u52A1\u7684\u4F01\u4E1A\u3002 \u672C\u534F\u8BAE\u4E2D\u53EF\u79F0\u4E3A\u201C\u5165\u9A7B\u4F01\u4E1A\u201D\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '3.APP\u6D88\u606F\u63A8\u9001\u6276\u6301\u8BA1\u5212\u670D\u52A1\uFF1A\u6307\u767E\u5EA6\u5B89\u5168\u4E3A\u5165\u9A7B\u4F01\u4E1A\u63D0\u4F9B\u7684App\u6D88\u606F\u63A8\u9001\u6280\u672F\u670D\u52A1\u3002\u672C\u534F\u8BAE\u4E2D\u53EF\u79F0\u4E3A\u201C\u670D\u52A1\u201D\uFF0C\u5177\u4F53\u5185\u5BB9\u8BE6\u89C1\u672C\u534F\u8BAE\u7B2C\u4E09\u6761\u7EA6\u5B9A\u3002 \u4E3A\u514D\u6B67\u4E49\uFF0C\u672C\u534F\u8BAE\u4E2D\u7684\u670D\u52A1\u8303\u56F4\u4EC5\u9650\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5927\u9646\u5730\u533A\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '4.APP\u6D88\u606F\u63A8\u9001\u6276\u6301\u8BA1\u5212\u8D26\u53F7\uFF1A\u6307\u4F01\u4E1A\u4E3A\u7533\u8BF7\u52A0\u5165\u672C\u8BA1\u5212\u4EE5\u53CA\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u800C\u767B\u5F55\u7684\u767E\u5EA6\u8D26\u53F7\u3002\u672C\u534F\u8BAE\u4E2D\u53EF\u79F0\u4E3A\u201C\u8D26\u53F7\u201D\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '5.\u767E\u5EA6\u8D26\u53F7\uFF1A\u5B9A\u4E49\u8BE6\u89C1\u300A', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { target: '_blank', className: 'spu-link', rel: 'noopener noreferrer', href: 'https://passport.baidu.com/static/passpc-account/html/protocal.html' }, '\u767E\u5EA6\u7528\u6237\u534F\u8BAE'), '\u300B\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '\u4E8C\u3001 \u7533\u8BF7\u6761\u4EF6\u53CA\u6D41\u7A0B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '1.\u7533\u8BF7\u52A0\u5165\u672C\u8BA1\u5212\u7684\u4F01\u4E1A\u9700\u7B26\u5408\u4EE5\u4E0B\u6761\u4EF6\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '1\uFF09\u8425\u4E1A\u6267\u7167\u6240\u767B\u8BB0\u7684\u6CE8\u518C\u8D44\u672C\u5C0F\u4E8E1000\u4E07\u5143\u4EBA\u6C11\u5E01\u7684\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5927\u9646\u5730\u533A\u4F01\u4E1A\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '2\uFF09\u4F01\u4E1A\u4ECE\u4E8B\u4E1A\u52A1\u8303\u56F4\u4E3AApp\u5F00\u53D1/\u8FD0\u8425\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '3\uFF09\u4F01\u4E1A\u6240\u5F00\u53D1/\u8FD0\u8425\u7684\u5355\u4E2AApp\u7528\u6237\u91CF\u5C0F\u4E8E\u767E\u4E07\u4E14\u7528\u6237\u6708\u6D3B\u91CF\u5C0F\u4E8E\u767E\u4E07\u3002/\u8FD0\u8425\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '4\uFF09\u4F01\u4E1A\u540C\u610F\u6388\u6743\u767E\u5EA6\u5B89\u5168\u5728\u767E\u5EA6\u5B89\u5168\u5B98\u7F51\u3001\u7EBF\u4E0B\u5C55\u4F1A\u3001\u7EBF\u4E0A\u4F20\u64AD\u7B49\u4F4D\u7F6E\u8FDB\u884C\u4F01\u4E1A\u54C1\u724C\u9732\u51FA\uFF08\u4EE5\u4F01\u4E1A\u7533\u8BF7\u65F6\u63D0\u4F9B\u7684\u4F01\u4E1A\u540D\u79F0\u3001\u7B80\u79F0\u4EE5\u53CALOGO\u4E3A\u51C6\uFF09\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '5\uFF09\u4F01\u4E1A\u9700\u5728\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u7684App\u5185\u663E\u8457\u4F4D\u7F6E\u9732\u51FA\u672C\u8BA1\u5212\u6807\u8BC6\uFF08\u4EE5\u767E\u5EA6\u5B89\u5168\u53E6\u884C\u901A\u77E5\u786E\u8BA4\u4E3A\u51C6\uFF09\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '6\uFF09\u4F01\u4E1A\u9700\u53C2\u4E0E\u767E\u5EA6\u5B89\u5168\u7684\u8C03\u67E5\u95EE\u5377\uFF0C\u53CD\u9988\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u7684\u4F53\u9A8C\u3001\u9047\u5230\u7684\u95EE\u9898\u7B49\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '2.\u7533\u8BF7\u6D41\u7A0B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '1\uFF09\u4F01\u4E1A\u5728\u7533\u8BF7\u52A0\u5165\u672C\u8BA1\u5212\u65F6\uFF0C\u9700\u8981\u63D0\u4F9B\u4E0E\u7533\u8BF7\u6761\u4EF6\u8D26\u53F7\u6CE8\u518C\u4FE1\u606F\u76F8\u7B26\u7684\u76F8\u5173\u7684\u8D44\u8D28\u8BC1\u660E\u6750\u6599\u4EE5\u53CA\u5176\u4ED6\u7533\u8BF7\u6761\u4EF6\u5FC5\u8981\u8BC1\u660E\u6750\u6599\uFF0C \u767E\u5EA6\u5B89\u5168\u5C06\u5728\u5BA1\u67E5\u4F01\u4E1A\u63D0\u4EA4\u7684\u76F8\u5173\u8BC1\u660E\u6750\u6599\u540E\u51B3\u5B9A\u4F01\u4E1A\u662F\u5426\u53EF\u52A0\u5165\u672C\u8BA1\u5212\u4EE5\u53CA\u662F\u5426\u5411\u4F01\u4E1A\u63D0\u4F9B\u76F8\u5E94\u670D\u52A1\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '2\uFF09\u7533\u8BF7\u52A0\u5165\u672C\u8BA1\u5212\u5E76\u4F7F\u7528\u670D\u52A1\uFF0C\u4F01\u4E1A\u9700\u8981\u767B\u5F55\u767E\u5EA6\u8D26\u53F7\u3002\u5982\u679C\u4F01\u4E1A\u6CA1\u6709\u767E\u5EA6\u8D26\u53F7\uFF0C\u9700\u8981\u9996\u5148\u6CE8\u518C\u767E\u5EA6\u8D26\u53F7\u3002 \u5728\u6CE8\u518C\u767E\u5EA6\u8D26\u53F7\u65F6\uFF0C\u4F01\u4E1A\u5E94\u9605\u8BFB\u5E76\u63A5\u53D7\u300A\u767E\u5EA6\u7528\u6237\u534F\u8BAE\u300B \uFF08https://passport.baidu.com/static/passpc-account/html/protocal.html\uFF09\u3002 \u5728\u5B8C\u6210\u767E\u5EA6\u8D26\u53F7\u6CE8\u518C\u6D41\u7A0B\u540E\u540E\uFF0C\u4F01\u4E1A\u5C06\u5F97\u5230\u4E00\u4E2A\u8D26\u53F7\u548C\u5BC6\u7801\u3002\u5982\u679C\u4F01\u4E1A\u5DF2\u62E5\u6709\u767E\u5EA6\u8D26\u53F7\uFF0C\u53EF\u4EE5\u901A\u8FC7\u4F01\u4E1A\u7684\u767E\u5EA6\u8D26\u53F7\u548C\u5BC6\u7801\u76F4\u63A5\u767B\u5F55\u3002 \u767E\u5EA6\u5B89\u5168\u5C06\u6839\u636E\u8D26\u53F7\u548C\u5BC6\u7801\u6765\u786E\u8BA4\u4F01\u4E1A\u7684\u8EAB\u4EFD\uFF0C\u4F01\u4E1A\u9700\u8981\u59A5\u5584\u4FDD\u7BA1\u5176\u8D26\u53F7\u548C\u5BC6\u7801\uFF0C \u5BF9\u4F01\u4E1A\u5728\u8D26\u53F7\u4E2D\u7684\u6240\u6709\u6D3B\u52A8\u548C\u4E8B\u4EF6\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u7F51\u4E0A\u70B9\u51FB\u540C\u610F\u5404\u7C7B\u89C4\u5219\u534F\u8BAE\u3001\u53D1\u5E03\u4FE1\u606F\u3001\u62AB\u9732\u4FE1\u606F\u3001\u8BA2\u8D2D\u670D\u52A1\u3001\u652F\u4ED8\u8D39\u7528\u7B49\uFF09\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '3\uFF09\u4F01\u4E1A\u5728\u6CE8\u518C\u8D26\u53F7\u3001\u7533\u8BF7\u52A0\u5165\u672C\u8BA1\u5212\u4EE5\u53CA\u4F7F\u7528\u76F8\u5173\u670D\u52A1\u65F6\uFF0C\u63D0\u4F9B\u7684\u7528\u6237\u8D44\u6599\u5E94\u771F\u5B9E\u3001\u51C6\u786E\u3001\u5B8C\u6574\u3001\u5408\u6CD5\u6709\u6548\u3002\u7528\u6237\u8D44\u6599\u5982\u6709\u53D8\u52A8\u7684\uFF0C\u5E94\u53CA\u65F6\u66F4\u65B0\uFF1B \u5982\u679C\u4F01\u4E1A\u63D0\u4F9B\u7684\u7528\u6237\u8D44\u6599\u4E0D\u5408\u6CD5\u3001\u4E0D\u771F\u5B9E\u3001\u4E0D\u51C6\u786E\u3001\u4E0D\u8BE6\u5C3D\u7684\uFF0C\u4F01\u4E1A\u9700\u627F\u62C5\u56E0\u6B64\u5F15\u8D77\u7684\u76F8\u5E94\u8D23\u4EFB\u53CA\u540E\u679C\uFF0C\u5E76\u4E14\u767E\u5EA6\u5B89\u5168\u4FDD\u7559\u7EC8\u6B62\u4F01\u4E1A\u4F7F\u7528\u672C\u8BA1\u5212\u5404\u9879\u670D\u52A1\u7684\u6743\u5229\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '4\uFF09\u5982\u679C\u4F01\u4E1A\u5C06\u5176\u5E10\u53F7\u3001\u5BC6\u7801\u8F6C\u8BA9\u3001\u51FA\u501F\u3001\u9500\u552E\u6216\u4EE5\u4EFB\u4F55\u8131\u79BB\u63A7\u5236\u7684\u5F62\u5F0F\u4EA4\u7531\u4EFB\u4F55\u7B2C\u4E09\u65B9\u4F7F\u7528\uFF0C \u7531\u6B64\u5BFC\u81F4\u7684\u9488\u5BF9\u4F01\u4E1A\u3001\u767E\u5EA6\u5B89\u5168\u53CA\u5176\u5173\u8054\u65B9\u3001\u6216\u4EFB\u4F55\u7B2C\u4E09\u65B9\u9020\u6210\u7684\u635F\u5BB3\uFF0C\u4F01\u4E1A\u5C06\u627F\u62C5\u5168\u90E8\u8D23\u4EFB\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '5\uFF09\u5982\u4F01\u4E1A\u53D1\u73B0\u5E10\u53F7\u906D\u4ED6\u4EBA\u975E\u6CD5\u4F7F\u7528\uFF0C\u5E94\u7ACB\u5373\u901A\u77E5\u767E\u5EA6\u5B89\u5168\u3002 \u56E0\u9ED1\u5BA2\u884C\u4E3A\u6216\u4F01\u4E1A\u7684\u4FDD\u7BA1\u758F\u5FFD\u5BFC\u81F4\u5E10\u53F7\u3001\u5BC6\u7801\u906D\u4ED6\u4EBA\u975E\u6CD5\u4F7F\u7528\uFF0C\u767E\u5EA6\u5B89\u5168\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '\u4E09\u3001 \u670D\u52A1\u5185\u5BB9'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '\u5728\u672C\u8BA1\u5212\u5B58\u7EED\u671F\u95F4\uFF0C\u672C\u8BA1\u5212\u9879\u4E0B\u767E\u5EA6\u5B89\u5168\u5411\u5165\u9A7B\u4F01\u4E1A\u63D0\u4F9B\u7684\u670D\u52A1\u5185\u5BB9\u5982\u4E0B\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '1.APP\u6D88\u606F\u63A8\u9001\u6280\u672F\u670D\u52A1\uFF1A\u5165\u9A7B\u4F01\u4E1A\u96C6\u6210\u201C\u767E\u5EA6\u6167\u63A8\u201DAPP\u6D88\u606F\u63A8\u9001SDK\uFF0C\u5E76\u767B\u9646\u767E\u5EA6\u6167\u63A8\u670D\u52A1\u5E73\u53F0\u5F00\u901A\u670D\u52A1\u540E\uFF0C \u53EF\u83B7\u5F97\u514D\u8D39APP\u6D88\u606F\u63A8\u9001\u6280\u672F\u670D\u52A1\uFF0C\u670D\u52A1\u671F\u9650\u4E3A\u4E00\u5E74\uFF08\u670D\u52A1\u671F\u9650\u81EA\u670D\u52A1\u5F00\u901A\u4E4B\u65E5\u8D77\u8BA1\u7B97\uFF0C\u5982\u670D\u52A1\u671F\u6EE1\u4E4B\u524D\u672C\u8BA1\u5212\u505C\u8FD0\uFF0C\u5219\u670D\u52A1\u81EA\u505C\u8FD0\u4E4B\u65E5\u8D77\u7EC8\u6B62\uFF09\u3002 \u670D\u52A1\u5185\u5BB9\u5305\u62ECAPP\u6D88\u606F\u63A8\u9001\u57FA\u7840\u529F\u80FD\u3001SDK\u63A5\u5165\u6280\u672F\u54A8\u8BE2\u670D\u52A1\u7B49\uFF0C\u5177\u4F53\u670D\u52A1\u5185\u5BB9\u53CA\u670D\u52A1\u89C4\u5219\u4EE5\u670D\u52A1\u671F\u9650\u5185\u767E\u5EA6\u6167\u63A8\u670D\u52A1\u5E73\u53F0\u516C\u793A\u4E3A\u51C6'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '2.APP\u6D88\u606F\u63A8\u9001\u6280\u672F\u57F9\u8BAD\uFF1A\u5165\u9A7B\u4F01\u4E1A\u53EF\u53C2\u52A0\u767E\u5EA6\u5B89\u5168\u4E0D\u5B9A\u671F\u4E3E\u529EAPP\u6D88\u606F\u63A8\u9001\u6280\u672F\u6C99\u9F99 \uFF0C\u4E86\u89E3\u6700\u65B0\u653F\u7B56\u548CAPP\u6D88\u606F\u63A8\u9001\u6280\u672F\u3002 \u57F9\u8BAD\u7684\u5177\u4F53\u65F6\u95F4\u3001\u5730\u70B9\u4EE5\u53CA\u5185\u5BB9\u4EE5\u767E\u5EA6\u5B89\u5168\u670D\u52A1\u5E73\u53F0\u516C\u793A\u3001\u767E\u5EA6\u6167\u63A8\u670D\u52A1\u5E73\u53F0\u516C\u793A\u6216\u767E\u5EA6\u5B89\u5168\u53E6\u884C\u901A\u77E5\u4E3A\u51C6\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '\u56DB\u3001\u5165\u9A7B\u987B\u77E5'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '1.\u4F01\u4E1A\u77E5\u6653\u5E76\u540C\u610F\uFF0C\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u5373\u89C6\u4E3A\u4F01\u4E1A\u540C\u610F\u5E76\u63A5\u53D7\u5305\u62EC\u300A', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: 'https://anquan.baidu.com/help?id=16&typeId=&file_type=2', target: '_blank', rel: 'noopener noreferrer' }, '\u767E\u5EA6\u5B89\u5168\u670D\u52A1\u5E73\u53F0\u7528\u6237\u534F\u8BAE'), '\u300B\u3001 \u300A', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { href: 'https://console.bce.baidu.com/spp/#/protocol', target: '_blank', rel: 'noopener noreferrer' }, '\u767E\u5EA6\u6167\u63A8\u5E73\u53F0\u670D\u52A1\u534F\u8BAE'), '\u300B \u53CA\u300A', __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('a', { target: '_blank', rel: 'noopener noreferrer', href: 'http://sofire.bdstatic.com/push/privacy.html' }, '\u767E\u5EA6\u6167\u63A8\u9690\u79C1\u653F\u7B56'), '\u300B\u5728\u5185\u7684\u76F8\u5173\u670D\u52A1\u534F\u8BAE\u4EE5\u53CA\u5176\u4ED6\u767E\u5EA6\u5B89\u5168\u6240\u516C\u793A\u7684\u670D\u52A1\u89C4\u5219\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '2.\u4F01\u4E1A\u627F\u8BFA\uFF0C\u52A0\u5165\u672C\u8BA1\u5212\u4EE5\u53CA\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u65F6\u4E25\u683C\u9075\u5B88\u4EFB\u4F55\u53EF\u80FD\u9002\u7528\u7684\u7684\u6CD5\u5F8B\u6CD5\u89C4\uFF0C \u5E76\u5E94\u83B7\u5F97\u5728APP\u4E0A\u96C6\u6210\u767E\u5EA6\u6167\u63A8SDK\u548C\u4F7F\u7528\u767E\u5EA6\u6167\u63A8\u5E73\u53F0\u670D\u52A1\u5E94\u83B7\u5F97\u7684APP\u76F8\u5173\u6388\u6743\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8EAPP\u6700\u7EC8\u7528\u6237\u7684\u6388\u6743\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '3.\u4F01\u4E1A\u5E94\u9075\u5B88\u6240\u9002\u7528\u7684\u5173\u4E8E\u4FDD\u62A4\u4E2A\u4EBA\u6570\u636E\u548C\u9690\u79C1\u3001\u901A\u4FE1\u81EA\u7531\u53CA\u4FDD\u969C\u7F51\u7EDC\u5B89\u5168\u8FD0\u884C\u7B49\u65B9\u9762\u7684\u6CD5\u5F8B\u6CD5\u89C4\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '4.\u4E3A\u4E86\u4FBF\u4E8E\u4F01\u4E1A\u7533\u8BF7\u3001\u52A0\u5165\u672C\u8BA1\u5212\u4EE5\u53CA\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\uFF0C\u4F01\u4E1A\u7406\u89E3\u5E76\u63A5\u53D7\uFF0C\u767E\u5EA6\u5B89\u5168\u53EF\u4EE5\u901A\u8FC7\u90AE\u4EF6\u3001\u77ED\u4FE1\u3001\u7535\u8BDD\u3001\u7AD9\u5185\u4FE1\u3001\u5F39\u51FA\u6D88\u606F\u7B49\u5F62\u5F0F\uFF0C\u5411\u4F01\u4E1A\u53D1\u9001\u516C\u793A\u89C4\u5219\u7B49\u5404\u7C7B\u901A\u77E5\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '5.\u4F01\u4E1A\u4E0D\u5F97\u4F7F\u7528\u672C\u8BA1\u5212\u53CA\u9879\u4E0B\u670D\u52A1\u4E0A\u8F7D\u3001\u4F20\u9001\u3001\u53D1\u5E03\u6216\u4F20\u64AD\u654F\u611F\u4FE1\u606F\u548C\u8FDD\u53CD\u56FD\u5BB6\u6CD5\u5F8B\u6CD5\u89C4\u653F\u7B56\u7684\u4FE1\u606F\uFF08\u5F62\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6587\u5B57\u3001\u56FE\u7247\u3001\u8BED\u97F3\u3001\u97F3\u89C6\u9891\u7B49\uFF09\uFF0C \u6B64\u7C7B\u4FE1\u606F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '1\uFF09\u53CD\u5BF9\u5BAA\u6CD5\u6240\u786E\u5B9A\u7684\u57FA\u672C\u539F\u5219\u7684\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '2\uFF09\u5371\u5BB3\u56FD\u5BB6\u5B89\u5168\uFF0C\u6CC4\u9732\u56FD\u5BB6\u79D8\u5BC6\uFF0C\u98A0\u8986\u56FD\u5BB6\u653F\u6743\uFF0C\u7834\u574F\u56FD\u5BB6\u7EDF\u4E00\u7684\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '3\uFF09\u635F\u5BB3\u56FD\u5BB6\u8363\u8A89\u548C\u5229\u76CA\u7684\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '4\uFF09\u717D\u52A8\u6C11\u65CF\u4EC7\u6068\u3001\u6C11\u65CF\u6B67\u89C6\u3001\u7834\u574F\u6C11\u65CF\u56E2\u7ED3\u7684\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '5\uFF09\u7834\u574F\u56FD\u5BB6\u5B97\u6559\u653F\u7B56\uFF0C\u5BA3\u626C\u90AA\u6559\u548C\u5C01\u5EFA\u8FF7\u4FE1\u7684\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '6\uFF09\u6563\u5E03\u8C23\u8A00\uFF0C\u6270\u4E71\u793E\u4F1A\u79E9\u5E8F\uFF0C\u7834\u574F\u793E\u4F1A\u7A33\u5B9A\u7684\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '7\uFF09\u6563\u5E03\u6DEB\u79FD\u3001\u8272\u60C5\u3001\u8D4C\u535A\u3001\u66B4\u529B\u3001\u51F6\u6740\u3001\u6050\u6016\u6216\u8005\u6559\u5506\u72AF\u7F6A\u7684\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '8\uFF09\u4FAE\u8FB1\u6216\u8005\u8BFD\u8C24\u4ED6\u4EBA\uFF0C\u4FB5\u5BB3\u4ED6\u4EBA\u5408\u6CD5\u6743\u76CA\u7684\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '9\uFF09\u542B\u6709\u865A\u5047\u3001\u8BC8\u9A97\u3001\u6709\u5BB3\u3001\u80C1\u8FEB\u3001\u4FB5\u5BB3\u4ED6\u4EBA\u9690\u79C1\u3001\u9A9A\u6270\u3001\u4FB5\u5BB3\u3001\u4E2D\u4F24\u3001\u7C97\u4FD7\u3001\u7325\u4EB5\u3001\u6216\u5176\u4ED6\u9053\u5FB7\u4E0A\u4EE4\u4EBA\u53CD\u611F\u7684\u5185\u5BB9\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '10\uFF09\u542B\u6709\u4FB5\u5BB3\u4ED6\u4EBA\u540D\u8A89\u6743\u3001\u8096\u50CF\u6743\u3001\u77E5\u8BC6\u4EA7\u6743\u3001\u5546\u4E1A\u79D8\u5BC6\u7B49\u5408\u6CD5\u6743\u5229\u7684\u5185\u5BB9\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '11\uFF09\u542B\u6709\u9A9A\u6270\u3001\u5E7F\u544A\u4FE1\u606F\u3001\u8FC7\u5EA6\u8425\u9500\u4FE1\u606F\u53CA\u5783\u573E\u4FE1\u606F\u6216\u542B\u6709\u4EFB\u4F55\u6027\u6216\u6027\u6697\u793A\u7684\u5185\u5BB9\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '12\uFF09\u542B\u6709\u5176\u4ED6\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u3001\u653F\u7B56\u3001\u516C\u5E8F\u826F\u4FD7\u3001\u793E\u4F1A\u516C\u5FB7\u6216\u5E72\u6270\u5546\u57CE\u8FD0\u8425\u548C\u4FB5\u72AF\u5176\u4ED6\u4F01\u4E1A\u6216\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u76CA\u5185\u5BB9\u7684\u4FE1\u606F\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '6.\u4F01\u4E1A\u627F\u8BFA\u4E0D\u5BF9\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u91C7\u53D6\u4EE5\u4E0B\u884C\u4E3A\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '1) \u5BF9\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u8FDB\u884C\u53CD\u5411\u5DE5\u7A0B\u3001\u53CD\u5411\u6C47\u7F16\u3001\u53CD\u5411\u7F16\u8BD1\uFF0C\u6216\u8005\u4EE5\u5176\u4ED6\u65B9\u5F0F\u5C1D\u8BD5\u53D1\u73B0\u8F6F\u4EF6\u7684\u6E90\u4EE3\u7801\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '2) \u5BF9\u767E\u5EA6\u5B89\u5168\u62E5\u6709\u77E5\u8BC6\u4EA7\u6743\u7684\u5185\u5BB9\u8FDB\u884C\u51FA\u79DF\u3001\u51FA\u501F\u3001\u590D\u5236\u3001\u4FEE\u6539\u3001\u94FE\u63A5\u3001\u8F6C\u8F7D\u3001\u6C47\u7F16\u3001\u53D1\u8868\u3001\u51FA\u7248\u3001\u5EFA\u7ACB\u955C\u50CF\u7AD9\u70B9\u7B49\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '3) \u5BF9\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u8FD0\u884C\u8FC7\u7A0B\u4E2D\u91CA\u653E\u5230\u4EFB\u4F55\u7EC8\u7AEF\u5185\u5B58\u4E2D\u7684\u6570\u636E\u3001\u670D\u52A1\u8FD0\u884C\u8FC7\u7A0B\u4E2D\u7EC8\u7AEF\u4E0E\u670D\u52A1\u5668\u7AEF\u7684\u4EA4\u4E92\u6570\u636E\uFF0C \u4EE5\u53CA\u670D\u52A1\u8FD0\u884C\u6240\u5FC5\u9700\u7684\u7CFB\u7EDF\u6570\u636E\uFF0C\u8FDB\u884C\u590D\u5236\u3001\u4FEE\u6539\u3001\u589E\u52A0\u3001\u5220\u9664\u3001\u6302\u63A5\u8FD0\u884C\u6216\u521B\u4F5C\u4EFB\u4F55\u884D\u751F\u4F5C\u54C1\uFF0C\u5F62\u5F0F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4F7F\u7528\u63D2\u4EF6\u3001\u5916\u6302\u6216\u975E\u7ECF\u767E\u5EA6\u5B89\u5168\u6388\u6743\u7684\u7B2C\u4E09\u65B9\u5DE5\u5177/\u670D\u52A1\u63A5\u5165\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u76F8\u5173\u7CFB\u7EDF\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '4) \u901A\u8FC7\u4FEE\u6539\u6216\u4F2A\u9020\u670D\u52A1\u8FD0\u884C\u4E2D\u7684\u6307\u4EE4\u3001\u6570\u636E\uFF0C\u589E\u52A0\u3001\u5220\u51CF\u3001\u53D8\u52A8\u670D\u52A1\u7684\u529F\u80FD\u6216\u8FD0\u884C\u6548\u679C\uFF0C\u6216\u8005\u5C06\u7528\u4E8E\u4E0A\u8FF0\u7528\u9014\u7684\u8F6F\u4EF6\u3001\u65B9\u6CD5\u8FDB\u884C\u8FD0\u8425\u6216\u5411\u516C\u4F17\u4F20\u64AD\uFF0C\u65E0\u8BBA\u8FD9\u4E9B\u884C\u4E3A\u662F\u5426\u4E3A\u5546\u4E1A\u76EE\u7684\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '5) \u901A\u8FC7\u975E\u767E\u5EA6\u5B89\u5168\u5F00\u53D1\u3001\u6388\u6743\u7684\u7B2C\u4E09\u65B9\u8F6F\u4EF6\u3001\u63D2\u4EF6\u3001\u5916\u6302\u3001\u7CFB\u7EDF\uFF0C\u767B\u5F55\u6216\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\uFF0C\u6216\u5236\u4F5C\u3001\u53D1\u5E03\u3001\u4F20\u64AD\u4E0A\u8FF0\u5DE5\u5177\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '6) \u81EA\u884C\u6216\u8005\u6388\u6743\u4ED6\u4EBA\u3001\u7B2C\u4E09\u65B9\u8F6F\u4EF6\u5BF9\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u76F8\u5173\u8F6F\u4EF6\u53CA\u5176\u7EC4\u4EF6\u3001\u6A21\u5757\u3001\u6570\u636E\u8FDB\u884C\u5E72\u6270\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '7) \u91C7\u53D6\u5176\u4ED6\u672A\u7ECF\u767E\u5EA6\u5B89\u5168\u660E\u793A\u6388\u6743\u7684\u884C\u4E3A\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '7.\u4F01\u4E1A\u627F\u8BFA\u4E0D\u4EE5\u4EFB\u4F55\u5F62\u5F0F\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u6765\u4FB5\u72AF\u767E\u5EA6\u5B89\u5168\u53CA\u5176\u5173\u8054\u65B9\u7684\u5229\u76CA\uFF0C\u6216\u4ECE\u4E8B\u4EFB\u4F55\u53EF\u80FD\u5BF9\u767E\u5EA6\u5B89\u5168\u53CA\u5176\u5173\u8054\u65B9\u9020\u6210\u635F\u5BB3\u6216\u4E0D\u5229\u4E8E\u767E\u5EA6\u5B89\u5168\u53CA\u5176\u5173\u8054\u65B9\u7684\u884C\u4E3A\u3002 \u5982\u56E0\u4F01\u4E1A\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u7684\u884C\u4E3A\uFF0C\u5BFC\u81F4\u767E\u5EA6\u5B89\u5168\u53CA\u5176\u5173\u8054\u65B9\u6216\u4EFB\u4F55\u7B2C\u4E09\u65B9\u4E3A\u6B64\u627F\u62C5\u4E86\u76F8\u5173\u7684\u8D23\u4EFB\uFF0C\u5219\u4F01\u4E1A\u9700\u5168\u989D\u8D54\u507F\u767E\u5EA6\u5B89\u5168\u53CA\u5176\u5173\u8054\u65B9\u6216\u4EFB\u4F55\u7B2C\u4E09\u65B9\u7684\u76F8\u5173\u652F\u51FA\u53CA\u635F\u5931\uFF0C \u5305\u62EC\u5408\u7406\u7684\u5F8B\u5E08\u8D39\u7528\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '8.\u4F01\u4E1A\u4E0D\u5F97\u4ECE\u4E8B\u4E0E\u767E\u5EA6\u6167\u63A8\u5E73\u53F0\u4EA7\u54C1/\u670D\u52A1\u76F8\u540C\u6216\u7C7B\u4F3C\u7684APP\u6D88\u606F\u63A8\u9001\u4E1A\u52A1\uFF0C \u4E0D\u5F97\u7814\u53D1\u3001\u751F\u4EA7\u3001\u7ECF\u8425\u4E0E\u767E\u5EA6\u6167\u63A8\u5E73\u53F0\u4EA7\u54C1/\u670D\u52A1\u76F8\u540C\u6216\u7C7B\u4F3C\u7684\u4EA7\u54C1/\u670D\u52A1\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '9.\u767E\u5EA6\u5B89\u5168\u53EF\u6839\u636E\u672C\u8BA1\u5212\u5B9E\u9645\u60C5\u51B5\u6216\u81EA\u8EAB\u8FD0\u8425\u5B89\u6392\u5728\u6CD5\u5F8B\u5141\u8BB8\u7684\u8303\u56F4\u5185\u5BF9\u672C\u534F\u8BAE\u53CA\u672C\u8BA1\u5212\u76F8\u5173\u89C4\u5219\u8FDB\u884C\u8C03\u6574\uFF0C \u5E76\u901A\u8FC7\u672C\u8BA1\u5212\u76F8\u5173\u9875\u9762\u5C06\u8C03\u6574\u5185\u5BB9\u8FDB\u884C\u516C\u5E03\uFF0C\u6216\u4EE5\u672C\u534F\u8BAE\u7EA6\u5B9A\u7684\u65B9\u5F0F\u5C06\u8C03\u6574\u5185\u5BB9\u901A\u77E5\u5165\u9A7B\u4F01\u4E1A\u3002\u76F8\u5173\u8C03\u6574\u5185\u5BB9\u4E00\u7ECF\u516C\u5E03/\u901A\u77E5\u5373\u4EA7\u751F\u6548\u529B\uFF0C \u5165\u9A7B\u4F01\u4E1A\u5E94\u5F53\u4E88\u4EE5\u9075\u5B88\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '\u4E94\u3001 \u8D39\u7528\u4E0E\u7ED3\u7B97'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '1.\u672C\u534F\u8BAE\u7B2C\u4E09\u6761\u7EA6\u5B9A\u7684\u201C\u670D\u52A1\u5185\u5BB9\u201D\u4E3A\u514D\u8D39\u670D\u52A1\uFF0C\u5165\u9A7B\u4F01\u4E1A\u65E0\u987B\u5C31\u4F7F\u7528\u524D\u8FF0\u670D\u52A1\u5411\u767E\u5EA6\u5B89\u5168\u652F\u4ED8\u4EFB\u4F55\u8D39\u7528\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '3.\u9664\u672C\u534F\u8BAE\u7B2C\u4E09\u6761\u7EA6\u5B9A\u7684\u201C\u670D\u52A1\u5185\u5BB9\u201D\u5916\uFF0C \u5165\u9A7B\u4F01\u4E1A\u4F7F\u7528\u767E\u5EA6\u5B89\u5168\u53CA\u767E\u5EA6\u516C\u53F8\u4EFB\u4F55\u670D\u52A1\uFF0C\u5747\u987B\u6839\u636E\u76F8\u5173\u670D\u52A1\u534F\u8BAE\u53CA\u89C4\u5219\u652F\u4ED8\u76F8\u5E94\u670D\u52A1\u8D39\u7528\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '\u516D\u3001 \u77E5\u8BC6\u4EA7\u6743'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '4.\u767E\u5EA6\u5B89\u5168\u5BF9\u5176\u72EC\u7ACB\u521B\u4F5C\u3001\u8BBE\u8BA1\u3001\u5236\u4F5C\u7684\u4EE5\u53CA\u59D4\u6258\u4ED6\u4EBA\u521B\u4F5C\u7684\u5185\u5BB9\uFF0C \u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u6587\u5B57\u3001\u5546\u6807\u3001\u6807\u8BC6\u3001\u5916\u89C2\u8BBE\u8BA1\u3001\u7248\u9762\u8BBE\u8BA1\u3001\u8F6F\u4EF6\u3001\u56FE\u7247\u3001\u97F3\u89C6\u9891\u3001\u7B97\u6CD5\u3001\u6A21\u578B\u7B49\uFF0C\u4EAB\u6709\u6240\u6709\u6743\u548C\u77E5\u8BC6\u4EA7\u6743\uFF0C \u5BF9\u5176\u4ECE\u7B2C\u4E09\u65B9\u83B7\u5F97\u5408\u6CD5\u8BB8\u53EF\u7684\u4FE1\u606F\u5185\u5BB9\u4EAB\u6709\u5408\u6CD5\u4F7F\u7528\u6743\u3002 \u672A\u7ECF\u767E\u5EA6\u5B89\u5168\u4E8B\u5148\u4E66\u9762\u6388\u6743\uFF0C\u4F01\u4E1A\u4E0D\u5F97\u4E3A\u4EFB\u4F55\u76EE\u7684\u4FDD\u5B58\u3001\u5907\u4EFD\u3001\u4F7F\u7528\u6216\u6388\u6743\u4ED6\u4EBA\u4F7F\u7528\u524D\u8FF0\u5185\u5BB9\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '5.\u4F01\u4E1A\u540C\u610F\u672C\u8BA1\u5212\u7684\u5168\u90E8\u8FD0\u8425\u6570\u636E\u7684\u5168\u90E8\u6743\u5229\u5747\u5F52\u5C5E\u4E8E\u767E\u5EA6\u5B89\u5168\uFF0C\u4E14\u662F\u767E\u5EA6\u5B89\u5168\u7684\u5546\u4E1A\u79D8\u5BC6\uFF0C \u4F9D\u6CD5\u5C5E\u4E8E\u5165\u9A7B\u4F01\u4E1A\u4EAB\u6709\u7684\u76F8\u5173\u6743\u5229\u9664\u5916\u3002\u672A\u7ECF\u767E\u5EA6\u5B89\u5168\u4E8B\u5148\u4E66\u9762\u540C\u610F\uFF0C\u4EFB\u4F55\u4EBA\u4E0D\u5F97\u4E3A\u4EFB\u4F55\u76EE\u7684\u64C5\u81EA\u4FDD\u5B58\u3001\u5907\u4EFD\u3001\u4F7F\u7528\u524D\u8FF0\u6570\u636E\uFF0C \u4EA6\u4E0D\u5F97\u4EE5\u4EFB\u4F55\u5F62\u5F0F\u5C06\u524D\u8FF0\u6570\u636E\u63D0\u4F9B\u7ED9\u4ED6\u4EBA\u6216\u6388\u6743\u4ED6\u4EBA\u4F7F\u7528\u3002\u672A\u7ECF\u767E\u5EA6\u5B89\u5168\u4E8B\u5148\u4E66\u9762\u540C\u610F\uFF0C\u4F01\u4E1A\u4E0D\u5F97\u4E3A\u4EFB\u4F55\u76EE\u7684\u64C5\u81EA\u4FDD\u5B58\u3001\u5907\u4EFD\u3001\u4F7F\u7528\u3001\u63D0\u4F9B\u7ED9\u4ED6\u4EBA\u6216\u6388\u6743\u4ED6\u4EBA\u4F7F\u7528\u524D\u8FF0\u8FD0\u8425\u6570\u636E\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '6.\u672A\u7ECF\u767E\u5EA6\u5B89\u5168\u4E8B\u5148\u4E66\u9762\u540C\u610F\uFF0C\u4EFB\u4F55\u4EBA\u4E0D\u5F97\u4EE5\u4EFB\u4F55\u65B9\u5F0F \uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u4F7F\u7528\u673A\u5668\u4EBA\u3001\u8718\u86DB\u3001\u5176\u4ED6\u81EA\u52A8\u8BBE\u5907\u3001\u624B\u52A8\u7A0B\u5E8F\u6216\u5728\u975E\u767E\u5EA6\u5B89\u5168\u670D\u52A1\u5668\u4E0A\u8BBE\u7F6E\u955C\u50CF\u7B49\uFF09\u6765\u6293\u53D6\u3001\u590D\u5236\u6216\u76D1\u89C6\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u6216\u5176\u6240\u5305\u542B\u7684\u4EFB\u4F55\u5185\u5BB9\uFF1B \u5426\u5219\uFF0C\u767E\u5EA6\u5B89\u5168\u6709\u6743\u4F9D\u6CD5\u8FFD\u7A76\u6CD5\u5F8B\u8D23\u4EFB\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '\u4E03\u3001 \u8FDD\u7EA6\u8D23\u4EFB'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '1.\u6839\u636E\u5165\u9A7B\u4F01\u4E1A\u8FDD\u89C4\u60C5\u5F62\u7684\u4E25\u91CD\u7A0B\u5EA6\uFF0C\u767E\u5EA6\u5B89\u5168\u6709\u6743\u5BF9\u5165\u9A7B\u4F01\u4E1A\u91C7\u53D6\u5982\u4E0B\u4E00\u79CD\u6216\u591A\u79CD\u5904\u7406\u63AA\u65BD\uFF1B \u60C5\u8282\u4E25\u91CD\u7684\uFF0C\u767E\u5EA6\u5B89\u5168\u8FD8\u5C06\u4E00\u5E76\u8FFD\u7A76\u5165\u9A7B\u4F01\u4E1A\u7684\u6CD5\u5F8B\u8D23\u4EFB\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '1) \u5220\u9664\u8FDD\u89C4\u4FE1\u606F\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '2) \u9650\u5236\u3001\u4E2D\u6B62\u5165\u9A7B\u4F01\u4E1A\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '3) \u7EC8\u6B62\u5165\u9A7B\u4F01\u4E1A\u4F7F\u7528\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\uFF0C\u7EC8\u6B62\u672C\u534F\u8BAE\uFF0C\u5E76\u8FFD\u7A76\u5165\u9A7B\u4F01\u4E1A\u7684\u6CD5\u5F8B\u8D23\u4EFB\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '4) \u5176\u4ED6\u767E\u5EA6\u5B89\u5168\u8BA4\u4E3A\u9002\u5408\u7684\u5904\u7406\u63AA\u65BD\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '2.\u4F01\u4E1A\u7406\u89E3\u5E76\u540C\u610F\u767E\u5EA6\u5B89\u5168\u6709\u6743\u4EE5\u666E\u901A\u6216\u975E\u4E13\u4E1A\u4EBA\u5458\u7684\u77E5\u8BC6\u6C34\u5E73\u6807\u51C6\u5BF9\u4F01\u4E1A\u7684\u884C\u4E3A\u8FDB\u884C\u5355\u65B9\u8BA4\u5B9A\uFF0C \u5E76\u6839\u636E\u5355\u65B9\u8BA4\u5B9A\u7ED3\u679C\u9002\u7528\u534F\u8BAE\u3001\u89C4\u5219\u4E88\u4EE5\u5904\u7406\u6216\u4E2D\u6B62\u3001\u7EC8\u6B62\u5411\u4F01\u4E1A\u63D0\u4F9B\u670D\u52A1\uFF08\u5305\u62EC\u4E2D\u6B62\u6216\u7EC8\u6B62\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\uFF09\uFF0C\u4E14\u65E0\u987B\u5F81\u5F97\u4F01\u4E1A\u7684\u540C\u610F\u6216\u63D0\u524D\u901A\u77E5\u4E88\u4F01\u4E1A\u3002 \u767E\u5EA6\u5B89\u5168\u6839\u636E\u76F8\u5173\u89C4\u5219\u5BF9\u4F01\u4E1A\u8FDB\u884C\u5904\u7406\u540E\uFF0C\u4E0D\u514D\u9664\u4F01\u4E1A\u5E94\u5F53\u627F\u62C5\u7684\u6CD5\u5F8B\u8D23\u4EFB\u3002\u4F01\u4E1A\u4E0D\u53EF\u64A4\u9500\u5730\u8BA4\u53EF\u767E\u5EA6\u5B89\u5168\u7684\u5355\u65B9\u8BA4\u5B9A\u7ED3\u679C\u53CA\u8BC1\u636E\uFF08\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u767E\u5EA6\u5B89\u5168\u901A\u8FC7\u6280\u672F\u65B9\u5F0F\u6536\u96C6\u7684\u8BC1\u636E\u7B49\uFF09\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '3.\u5982\u56E0\u4F01\u4E1A\u8FDD\u53CD\u6709\u5173\u6CD5\u5F8B\u6CD5\u89C4\u6216\u8005\u672C\u534F\u8BAE\u3001\u76F8\u5173\u89C4\u5219\u4E4B\u89C4\u5B9A\uFF0C\u4F7F\u767E\u5EA6\u5B89\u5168\u906D\u53D7\u4EFB\u4F55\u635F\u5931\u3001\u53D7\u5230\u5176\u4ED6\u4F01\u4E1A\u3001\u4EFB\u4F55\u7B2C\u4E09\u65B9\u7684\u7D22\u8D54\u6216\u4EFB\u4F55\u884C\u653F\u7BA1\u7406\u90E8\u95E8\u7684\u5904\u7F5A\uFF0C \u4F01\u4E1A\u5E94\u5BF9\u767E\u5EA6\u5B89\u5168\u3001\u5176\u4ED6\u4F01\u4E1A\u6216\u76F8\u5173\u7B2C\u4E09\u65B9\u7684\u5B9E\u9645\u635F\u5931\u8FDB\u884C\u5168\u989D\u8D54\u507F\uFF0C\u5305\u62EC\u5408\u7406\u7684\u5F8B\u5E08\u8D39\u7528\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '4.\u5728\u767E\u5EA6\u5B89\u5168\u8FDD\u80CC\u672C\u534F\u8BAE\u7EA6\u5B9A\u7684\u60C5\u51B5\u4E0B\uFF0C \u767E\u5EA6\u5B89\u5168\u5411\u4F01\u4E1A\u627F\u62C5\u7684\u603B\u4F53\u8D23\u4EFB\u548C\u8D54\u507F\u4E0D\u8D85\u8FC7\u767E\u5EA6\u5B89\u5168\u5728\u622A\u6B62\u8FDD\u7EA6\u4E4B\u65F6\u57FA\u4E8E\u670D\u52A1\u4ECE\u4F01\u4E1A\u5904\u83B7\u5F97\u7684\u6280\u672F\u670D\u52A1\u8D39\u7528\u6536\u5165\u7684\u603B\u989D\uFF0C \u8BE5\u7B49\u6280\u672F\u670D\u52A1\u8D39\u7528\u6536\u5165\u4E5F\u4EC5\u9650\u4E8E\u4EE5\u8D27\u5E01\u65B9\u5F0F\u6536\u53D6\u7684\u5B9E\u9645\u6536\u5165\u800C\u4E0D\u5305\u62EC\u5176\u4ED6\u5229\u76CA\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '\u516B\u3001 \u514D\u8D23\u58F0\u660E'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '1.\u5165\u9A7B\u4F01\u4E1A\u5BF9\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u7684\u4F7F\u7528\u627F\u62C5\u98CE\u9669\u3002 \u767E\u5EA6\u5B89\u5168\u5BF9\u6B64\u4E0D\u4F5C\u4EFB\u4F55\u7C7B\u578B\u7684\u62C5\u4FDD\uFF0C\u4E0D\u8BBA\u662F\u660E\u786E\u7684\u6216\u9690\u542B\u7684\uFF0C\u4F46\u662F\u4E0D\u5BF9\u5546\u4E1A\u6027\u7684\u9690\u542B\u62C5\u4FDD\u3001\u7279\u5B9A\u76EE\u7684\u548C\u4E0D\u8FDD\u53CD\u89C4\u5B9A\u7684\u9002\u5F53\u62C5\u4FDD\u4F5C\u9650\u5236\u3002 \u767E\u5EA6\u5B89\u5168\u4E0D\u62C5\u4FDD\u670D\u52A1\u4E00\u5B9A\u80FD\u6EE1\u8DB3\u5165\u9A7B\u4F01\u4E1A\u7684\u8981\u6C42\uFF0C\u4E5F\u4E0D\u62C5\u4FDD\u670D\u52A1\u4E0D\u4F1A\u53D7\u4E2D\u65AD\uFF0C\u5BF9\u670D\u52A1\u7684\u53CA\u65F6\u6027\uFF0C\u5B89\u5168\u6027\uFF0C\u51FA\u9519\u53D1\u751F\uFF0C\u6570\u636E\u4E22\u5931\u7B49\u90FD\u4E0D\u4F5C\u62C5\u4FDD\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '2.\u767E\u5EA6\u5B89\u5168\u5BF9\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u4EE5\u53CA\u76F8\u5173\u670D\u52A1\u5C06\u5C3D\u529B\u7EF4\u62A4\u5176\u5B89\u5168\u6027\u53CA\u65B9\u4FBF\u6027\uFF0C\u56E0\u4E0B\u5217\u539F\u56E0\u5BFC\u81F4\u7684\u670D\u52A1\u6216\u7CFB\u7EDF\u4E0D\u9002\u7528\u3001\u4E0D\u4FBF\u5229\u3001\u6545\u969C\u800C\u9020\u6210\u635F\u5931\u7684\uFF0C \u767E\u5EA6\u5B89\u5168\u4E0D\u627F\u62C5\u8FDD\u7EA6\u8D23\u4EFB\u548C\u9700\u8981\u652F\u4ED8\u4EFB\u4F55\u6027\u8D28\u7684\u8D54\u507F\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '1) \u7CFB\u7EDF\u505C\u673A\u7EF4\u62A4\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '2) \u901A\u8BAF\u7EC8\u7AEF\u6216\u7535\u4FE1\u8BBE\u5907\u51FA\u73B0\u6545\u969C\u4E0D\u80FD\u8FDB\u884C\u6570\u636E\u4F20\u8F93\u7684\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '3) \u56E0\u53F0\u98CE\u3001\u5730\u9707\u3001\u6D77\u5578\u3001\u6D2A\u6C34\u3001\u505C\u7535\u3001\u6218\u4E89\u3001\u6050\u6016\u88AD\u51FB\u7B49\u4E0D\u53EF\u6297\u529B\u4E4B\u56E0\u7D20\uFF0C\u9020\u6210\u7CFB\u7EDF\u969C\u788D\u4E0D\u80FD\u6267\u884C\u4E1A\u52A1\u7684\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '4) \u7531\u4E8E\u9ED1\u5BA2\u653B\u51FB\u3001\u7535\u4FE1\u90E8\u95E8\u6280\u672F\u8C03\u6574\u6216\u6545\u969C\u3001\u7F51\u7AD9\u5347\u7EA7\u3001\u7B2C\u4E09\u65B9\u95EE\u9898\u7B49\u539F\u56E0\u800C\u9020\u6210\u7684\u670D\u52A1\u4E2D\u65AD\u6216\u8005\u5EF6\u8FDF\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '3. \u767E\u5EA6\u5B89\u5168\u5BF9\u4EFB\u4F55\u76F4\u63A5\u3001\u95F4\u63A5\u3001\u5076\u7136\u3001\u7279\u6B8A\u53CA\u7EE7\u8D77\u7684\u635F\u5BB3\u4E0D\u8D1F\u8D23\u4EFB\uFF0C\u8FD9\u4E9B\u635F\u5BB3\u53EF\u80FD\u6765\u81EA\uFF1A\u4E0D\u6B63\u5F53\u4F7F\u7528\u7F51\u7EDC\u670D\u52A1\uFF0C\u975E\u6CD5\u4F7F\u7528\u7F51\u7EDC\u670D\u52A1\u6216\u5165\u9A7B\u4F01\u4E1A\u4F20\u9001\u7684\u4FE1\u606F\u6709\u6240\u53D8\u52A8\u3002 \u8FD9\u4E9B\u884C\u4E3A\u90FD\u6709\u53EF\u80FD\u4F1A\u5BFC\u81F4\u767E\u5EA6\u5B89\u5168\u7684\u5F62\u8C61\u53D7\u635F\uFF0C\u6240\u4EE5\u767E\u5EA6\u5B89\u5168\u4E8B\u5148\u63D0\u51FA\u8FD9\u79CD\u635F\u5BB3\u7684\u53EF\u80FD\u6027\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '\u4E5D\u3001 \u534F\u8BAE\u7EC8\u6B62\u53CA\u8F6C\u8BA9'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '1.\u672C\u534F\u8BAE\u5728\u7B26\u5408\u4EE5\u4E0B\u4EFB\u610F\u4E00\u9879\u60C5\u5F62\u65F6\u7EC8\u6B62\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '1) \u901A\u77E5\u89E3\u9664\uFF1A\u767E\u5EA6\u5B89\u5168\u53EF\u63D0\u524D15\u5929\u4EE5\u4E66\u9762\u901A\u77E5\u7684\u65B9\u5F0F\u7EC8\u6B62\u672C\u534F\u8BAE\u800C\u65E0\u987B\u627F\u62C5\u8FDD\u7EA6\u8D23\u4EFB\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '2) \u56E0\u6CD5\u89C4\u653F\u7B56\u6216\u4E3B\u7BA1\u673A\u5173\u8981\u6C42\uFF0C\u672C\u8BA1\u5212\u9879\u4E0B\u670D\u52A1\u5C06\u53EF\u80FD\u4E2D\u6B62\u6216\u7EC8\u6B62\uFF0C \u4E14\u767E\u5EA6\u5B89\u5168\u6CA1\u6709\u4E49\u52A1\u6216\u65E0\u6CD5\u4E8B\u5148\u901A\u77E5\u4F01\u4E1A\uFF0C\u4F01\u4E1A\u540C\u610F\u4E0D\u56E0\u6B64\u8981\u6C42\u767E\u5EA6\u5B89\u5168\u627F\u62C5\u8FDD\u7EA6\u8D23\u4EFB\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, '3) \u5355\u65B9\u89E3\u9664\u6743\uFF1A\u51FA\u73B0\u4E0B\u5217\u60C5\u51B5\u4E4B\u4E00\u7684\uFF0C\u767E\u5EA6\u5B89\u5168\u6709\u6743\u7ACB\u523B\u7EC8\u6B62\u672C\u534F\u8BAE\uFF0C\u4E14\u6309\u6709\u5173\u89C4\u5219\u5BF9\u4F01\u4E1A\u8FDB\u884C\u5904\u7F5A\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, 'a) \u4F01\u4E1A\u8FDD\u53CD\u672C\u534F\u8BAE\u4E2D\u7684\u4EFB\u4F55\u627F\u8BFA\u6216\u4FDD\u8BC1\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u4EFB\u4F55\u7EA6\u5B9A\uFF1B'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { className: 'indent' }, 'b) \u534F\u8BAE\u89C4\u5B9A\u7684\u5176\u4ED6\u534F\u8BAE\u7EC8\u6B62\u6761\u4EF6\u53D1\u751F\u6216\u5B9E\u73B0\uFF0C\u5BFC\u81F4\u672C\u534F\u8BAE\u7EC8\u6B62\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '2.\u65E0\u8BBA\u672C\u534F\u8BAE\u56E0\u4F55\u539F\u56E0\u7EC8\u6B62\uFF0C\u4F01\u4E1A\u5728\u534F\u8BAE\u7EC8\u6B62\u524D\u7684\u884C\u4E3A\u6240\u5BFC\u81F4\u7684\u4EFB\u4F55\u8D23\u4EFB\uFF0C\u4F01\u4E1A\u5FC5\u987B\u5B8C\u5168\u4E14\u72EC\u7ACB\u5730\u627F\u62C5\uFF1B \u534F\u8BAE\u7EC8\u6B62\u540E\uFF0C\u767E\u5EA6\u5B89\u5168\u65E0\u9700\u7EE7\u7EED\u5411\u4F01\u4E1A\u63D0\u4F9B\u670D\u52A1\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '3.\u767E\u5EA6\u5B89\u5168\u6709\u6743\u5C06\u672C\u534F\u8BAE\u9879\u4E0B\u7684\u5168\u90E8\u6743\u5229\u548C\u4E49\u52A1\u8F6C\u8BA9\u7ED9\u5173\u8054\u65B9\uFF0C\u800C\u65E0\u987B\u5F81\u5F97\u4F01\u4E1A\u7684\u4E8B\u5148\u540C\u610F\uFF0C \u5C4A\u65F6\u767E\u5EA6\u5B89\u5168\u5C06\u901A\u8FC7\u90AE\u4EF6\u3001\u7AD9\u5185\u4FE1\u3001\u9875\u9762\u516C\u544A\u7B49\u65B9\u5F0F\u5411\u4F01\u4E1A\u53D1\u51FA\u8F6C\u8BA9\u901A\u77E5\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '\u5341\u3001 \u901A\u77E5\u53CA\u9001\u8FBE'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '1.\u767E\u5EA6\u5B89\u5168\u5BF9\u4E8E\u4F01\u4E1A\u6240\u6709\u7684\u901A\u77E5\u5747\u53EF\u901A\u8FC7\u7AD9\u5185\u4FE1\u3001\u9875\u9762\u516C\u544A\u3001\u7535\u5B50\u90AE\u4EF6\u3001\u624B\u673A\u77ED\u4FE1\u6216\u5E38\u89C4\u7684\u4FE1\u4EF6\u4F20\u9001\u7B49\u65B9\u5F0F\u8FDB\u884C\uFF1B\u8BE5\u7B49\u901A\u77E5\u4E8E\u53D1\u9001\u4E4B\u65E5\u89C6\u4E3A\u5DF2\u9001\u8FBE\u6536\u4EF6\u4EBA\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '2.\u4F01\u4E1A\u5BF9\u4E8E\u767E\u5EA6\u5B89\u5168\u7684\u901A\u77E5\u5E94\u5F53\u901A\u8FC7\u767E\u5EA6\u5B89\u5168\u5728\u672C\u9875\u9762\u516C\u5E03\u7684\u8054\u7CFB\u65B9\u5F0F\u8FDB\u884C\u9001\u8FBE\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '\u5341\u4E00\u3001 \u6CD5\u5F8B\u9002\u7528\u53CA\u4E89\u8BAE\u89E3\u51B3'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '1.\u672C\u534F\u8BAE\u9002\u7528\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5927\u9646\u5730\u533A\u6CD5\u5F8B\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '2.\u56E0\u4F01\u4E1A\u4E0E\u767E\u5EA6\u5B89\u5168\u5C31\u672C\u534F\u8BAE\u7684\u7B7E\u8BA2\u3001\u5C65\u884C\u6216\u89E3\u91CA\u53D1\u751F\u4E89\u8BAE\uFF0C\u53CC\u65B9\u5E94\u52AA\u529B\u53CB\u597D\u534F\u5546\u89E3\u51B3\u3002\u5982\u534F\u5546\u4E0D\u6210\uFF0C\u4EFB\u4F55\u4E00\u65B9\u5747\u6709\u6743\u5411\u5317\u4EAC\u5E02\u6D77\u6DC0\u533A\u4EBA\u6C11\u6CD5\u9662\u8D77\u8BC9\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '\u5341\u4E8C\u3001 \u8054\u7CFB\u6211\u4EEC'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '1.\u4F01\u4E1A\u5BF9\u672C\u534F\u8BAE\u6709\u4EFB\u4F55\u610F\u89C1\u6216\u5EFA\u8BAE\u53EF\u53D1\u9001\u90AE\u4EF6\u81F3spp_support@baidu.com\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', null, '2.\u4E3A\u4FDD\u969C\u6211\u4EEC\u9AD8\u6548\u5904\u7406\u4F01\u4E1A\u7684\u95EE\u9898\uFF0C\u9700\u8981\u4F01\u4E1A\u63D0\u4EA4\u8EAB\u4EFD\u8BC1\u660E\u3001\u6709\u6548\u8054\u7CFB\u65B9\u5F0F\u548C\u4E66\u9762\u8BF7\u6C42\u53CA\u76F8\u5173\u8BC1\u636E\uFF0C\u6211\u4EEC\u4F1A\u5728\u9A8C\u8BC1\u4F01\u4E1A\u8EAB\u4EFD\u540E\u5904\u7406\u4F01\u4E1A\u7684\u8BF7\u6C42\u3002'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { style: { height: '.56rem' } }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { style: { textAlign: 'right' } }, '\u5317\u4EAC\u767E\u5EA6\u7F51\u8BAF\u79D1\u6280\u6709\u9650\u516C\u53F8'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('p', { style: { textAlign: 'right' } }, '2020\u5E742\u670814\u65E5\u751F\u6548'))), disabledHtml: true, okText: '同意并继续申请', okClick: function okClick() {
          _this2.confirm && _this2.confirm();
        } });
    } }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          overallTypeIndex = _state.overallTypeIndex,
          enterpriseNameError = _state.enterpriseNameError,
          overallTextarea = _state.overallTextarea,
          userNameError = _state.userNameError,
          codeError = _state.codeError,
          userPhoneError = _state.userPhoneError,
          userEmailError = _state.userEmailError,
          userPhoneErrorHint = _state.userPhoneErrorHint,
          userEmailErrorHint = _state.userEmailErrorHint,
          codeHint = _state.codeHint,
          codeImg = _state.codeImg;var enterpriseClass = __WEBPACK_IMPORTED_MODULE_7_classnames___default()({ 'input-disable': overallTypeIndex === 1, 'on': enterpriseNameError && overallTypeIndex !== 1 });return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('h2', null, '\u4E1A\u52A1\u54A8\u8BE2'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'spu-apply-from' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('form', null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u8EAB\u4EFD\u7C7B\u578B\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-assist' }, this.overallType.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'overall-type-box', key: index, onClick: function onClick() {
            _this3.setState({ overallTypeIndex: item.id });
          } }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: overallTypeIndex === item.id ? 'on' : '' }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', null, item.val));
      }))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, { className: enterpriseClass }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u4F01\u4E1A\u540D\u79F0\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, { placeholder: '\u8BF7\u8F93\u5165\u771F\u5B9E\u4F01\u4E1A\u540D\u79F0', disabled: overallTypeIndex === 1, onBlur: function onBlur(val) {
          _this3.setState({ enterpriseName: val });
        } }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-error-hint' }, '\u4F01\u4E1A\u540D\u79F0\u4E0D\u80FD\u4E3A\u7A7A')), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, { className: userNameError ? 'on' : '' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u771F\u5B9E\u59D3\u540D\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, { placeholder: '\u8BF7\u8F93\u5165\u771F\u5B9E\u59D3\u540D\u4FBF\u4E8E\u8054\u7CFB', onBlur: function onBlur(val) {
          _this3.setState({ userName: val });
        } }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-error-hint' }, '\u771F\u5B9E\u59D3\u540D\u4E0D\u80FD\u4E3A\u7A7A')), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, { className: userPhoneError ? 'on' : '' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u7535\u8BDD\u53F7\u7801\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, { type: 'phone', placeholder: '\u8BF7\u8F93\u5165\u771F\u5B9E\u7535\u8BDD\u53F7\u7801\u4FBF\u4E8E\u8054\u7CFB', onChange: function onChange(val) {
          _this3.setState({ userPhoneVal: val });
        } }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-error-hint' }, userPhoneErrorHint)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, { className: userEmailError ? 'on' : '' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u90AE\u7BB1\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, { type: 'email', placeholder: '\u8BF7\u8F93\u5165\u771F\u5B9E\u90AE\u7BB1\u4FBF\u4E8E\u8054\u7CFB', onChange: function onChange(val) {
          _this3.setState({ userEmailVal: val });
        } }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-error-hint' }, userEmailErrorHint)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, 'APP\u540D\u79F0\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, { placeholder: '请描述您想咨询的APP名称', value: overallTextarea, onChange: function onChange(val) {
          _this3.setState({ overallTextarea: val });
        } }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-error-hint' })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_list___default.a, { className: codeError ? 'codeInput on' : 'codeInput' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-form-title' }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('span', { className: 'hint-star' }, '*'), ' \u9A8C\u8BC1\u7801\uFF1A'), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_input_item___default.a, { placeholder: '\u8BF7\u8F93\u51FA\u53F3\u4FA7\u9A8C\u8BC1\u7801', onChange: function onChange(val) {
          _this3.setState({ codeVal: val, codeError: !val.replace(/\s+/g, '') });
        } }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'overall-code', onClick: function onClick() {
          _this3.setState({ codeImg: '' }, function () {
            _this3.setState({ codeImg: '/catpcha' });
          });
        } }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('img', { src: codeImg, alt: '', height: '100%' })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-error-hint' }, codeHint)))), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'apply-subbtn', onClick: this.submitFun }, '\u63D0\u4EA4\u5E76\u4F53\u9A8C'));
    } }]);return Apply;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]), _class.propTypes = { fetchCmsapiIndexData: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, fetchUserApply: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, userApplyData: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, cmsapiUserapply: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, userLoginstate: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, match: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return { userLoginstate: state.userLoginstate, userApplyData: state.userApplyData, cmsapiUserapply: state.cmsapiUserapply };
}function mapDispatchToProps(dispatch) {
  return { fetchCmsapiIndexData: function fetchCmsapiIndexData() {
      return Object(__WEBPACK_IMPORTED_MODULE_8__actions_applyAction__["a" /* fetchCmsapiIndexData */])(dispatch);
    }, fetchUserApply: function fetchUserApply(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_8__actions_applyAction__["b" /* fetchUserApply */])(dispatch, obj);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Apply));

/***/ }),
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 登录页面
  * @author wangzhuang
  * */ /* globals ucCommonLogin passport */var getCookie = function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));if (match) {
    return match[2];
  }
};var Login = (_temp = _class = function (_Component) {
  _inherits(Login, _Component);function Login(props, context) {
    _classCallCheck(this, Login);var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props, context));var index = getCookie('loginType') === '5' ? 1 : 0;_this.state = { tabIndex: index || 0, // 0=百度账号，1=推广账号
      ppType: true // true=账号密码 false=短信
    };return _this;
  }_createClass(Login, [{ key: 'componentWillMount', value: function componentWillMount() {
      var params = this.getParams();if (this.isPC()) {
        location.href = '/?login=true' + (params.urlto ? '&urlto=' + params.urlto : '');
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;var params = this.getParams();var passDomain = 'wappass' + (this.isDev() ? '.qatest' : '') + '.baidu.com';var url = '//' + passDomain + '/static/touch/js/api/wrapper.js?cdnversion=' + new Date().getTime();var script = document.createElement('script');script.type = 'text/javascript';script.src = url;document.getElementsByTagName('head')[0].appendChild(script);var getStaticPage = function getStaticPage() {
        if (_this2.isDev()) {
          return location.origin + '/console/static/v3Jump.html';
        }return location.origin + '/upload/sdk/v3Jump.html';
      };script.onload = function () {
        passport.use('login', { // 账号密码
          library: true, defaultCss: true }, function (apiMagic) {
          /* eslint-disable-next-line */var loginInstance = new apiMagic.passport.login({ product: 'spu', staticPage: getStaticPage(), u: params && params.urlto || location.origin + '/m' });loginInstance.on('loginSuccess', function (res) {
            console.log(res);
          });loginInstance.on('loginError', function (res) {
            console.log(res);
          });loginInstance.render('loginPass');
        });passport.use('smsLogin', { // 短信
          library: true, defaultCss: true }, function (apiMagic) {
          /* eslint-disable-next-line */var loginInstance = new apiMagic.passport.smsLogin({ product: 'spu', staticPage: getStaticPage(), u: params && params.urlto || location.origin + '/m', overseas: 0, adapter: 3, smsRegTip: 1 });loginInstance.render('ppSmsLogin');
        });
      };var passDomain2 = '//cas.baidu.com/staticv2/dep/common-login/' + (this.isTest() ? 'qa-' : '') + 'api.js';var script2 = document.createElement('script');script2.type = 'text/javascript';script2.src = passDomain2;document.getElementsByTagName('head')[0].appendChild(script2);script2.onload = function () {
        ucCommonLogin.init({ container: 'ucLogin', // 登录框渲染父节点id
          appid: 592, // 登录产品线 appid
          appscope: [3, 22, 26, 27, 28, 31, 66, 67, 110, 223, 285, 303, 21, 129, 309, 58, 151, 463, 486, 406, 417, 15, 377, 289, 525, 592], // 登录成功后要跳转的地址，此 url 需要接入 casClient
          fromu: location.origin + '/user/ucState?redirect_url=' + (params && params.urlto && encodeURIComponent(params.urlto) || encodeURIComponent(encodeURIComponent(location.href))), product: 'spu', // 登录产品线信息
          staticPage: getStaticPage(), // 登录成功，跳转中转页地址
          // staticPage: `${location.origin}/uc_v3Jump.html`,  // 登录成功，跳转中转页地址
          multiLogin: 0, // 是否显示 passport 登录框+uc 登录框，默认0，只显示 uc 登录框
          isSmall: 0, // 样式大小控制
          isLayer: 0 // 浮层样式开启
        });
      };
    } }, { key: 'render', value: function render() {
      var _this3 = this;var userLoginstate = this.props.userLoginstate;if (userLoginstate.status === 0) {
        location.href = '/m';
      }var _state = this.state,
          tabIndex = _state.tabIndex,
          ppType = _state.ppType;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'spui-login' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'login-tab' }, ['百度账号', '百度推广账号'].map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: tabIndex === index ? 'on' : '', key: index, onClick: function onClick() {
            if (tabIndex === index) {
              return;
            }_this3.setState({ tabIndex: index, baiduName: '', baiduPassword: '', baiduNameOff: false, baiduPasswordOff: false });
          } }, item);
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'login-con' }, tabIndex === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'textAlginR' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'linkText', onClick: function onClick() {
          _this3.setState({ ppType: !ppType });
        } }, ppType ? '短信快捷登录' : '用户名密码登录')) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { display: '' + (tabIndex === 0 ? 'block' : 'none') } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'loginPass', style: { display: '' + (ppType ? 'block' : 'none') } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'ppSmsLogin', style: { display: '' + (!ppType ? 'block' : 'none') } })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'ucLogin', style: { display: '' + (tabIndex === 1 ? 'block' : 'none') } }), ppType || tabIndex === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'login-link' }, tabIndex === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: 'https://aq.baidu.com/new/#/school', target: '_blank' }, '\u5B89\u5168\u63A7\u4EF6\u5E38\u89C1\u95EE\u9898') : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: tabIndex === 0 ? 'https://passport.baidu.com/v2/?reg&u=https%3A//login.bce.baidu.com/' + '%3Fredirect%3Dhttp%253A%252F%252Fcloud.baidu.com%252F&tpl=bceplat' : 'https://u.baidu.com/ucweb/?' + 'module=Reguser&controller=reg&action=index&appid=3#/register', target: '_blank' }, '\u6CE8\u518C\u8D26\u53F7'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: tabIndex === 0 ? 'https://passport.baidu.com/?getpassindex&tt=1566373747096&' + 'gid=530BE4D-70B6-4A52-80B1-DC6D4EE3F2F9&tpl=bceplat&' + 'u=https%3A%2F%2Flogin.bce.baidu.com%2Fpostlogin%3F_1566373752323%26re' + 'direct%3Dhttp%253A%252F%252Fcloud.baidu.com%252F' : 'https://aq.baidu.com/new/#/findpwd', target: '_blank' }, '\u5FD8\u8BB0\u5BC6\u7801'))) : null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'login-hint' }, '\u6E29\u99A8\u63D0\u793A\uFF1A\u4E0E\u767E\u5EA6\u641C\u7D22\u3001\u767E\u5EA6\u8D34\u5427\u3001\u767E\u5EA6\u4E91\u76D8\u3001\u767E\u5EA6\u77E5\u9053\u3001\u767E\u5EA6\u6587\u5E93\u7B49\u4EA7\u54C1\u901A\u7528\u3002')));
    } }]);return Login;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { userLoginstate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object }, _temp);function mapStateToProps(state) {
  return { userLoginstate: state.userLoginstate };
}function mapDispatchToProps() {
  return {};
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Login));

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_toast_style_css__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_toast__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_numberOptionsActions__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_productAction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__numberOptions_formCom__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__numberOptions_utils__ = __webpack_require__(57);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: number report
  * @author: wence
  */var NumberReport = (_temp = _class = function (_PureComponent) {
  _inherits(NumberReport, _PureComponent);function NumberReport(props) {
    var _this2 = this;_classCallCheck(this, NumberReport);var _this = _possibleConstructorReturn(this, (NumberReport.__proto__ || Object.getPrototypeOf(NumberReport)).call(this, props));_this.validate = [];_this.onChange = function (key, value) {
      _this.setState({ params: Object.assign({}, _this.state.params, _defineProperty({}, key, value)) });
    };_this.onBlur = function () {
      if (_this.isIOS) {
        _this.setState({ fixed: false });document.querySelector('.nav-bar').style.position = '';
      }
    };_this.onFocus = function () {
      if (_this.isIOS) {
        _this.setState({ fixed: true });document.querySelector('.nav-bar').style.position = 'absolute';
      }
    };_this.onSubmit = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var canSubmit, resInstance;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              canSubmit = true;_this.validate.map(function (fn) {
                var vilidate = fn();if (vilidate.validate && canSubmit) {
                  canSubmit = false;
                }
              });if (!canSubmit) {
                _context2.next = 7;break;
              }_context2.next = 5;return Object(__WEBPACK_IMPORTED_MODULE_8__actions_productAction__["j" /* getInstanceId */])();case 5:
              resInstance = _context2.sent;if (resInstance.status === 0) {
                Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* bAntiBotSend */])();window['__abbaidu_2024_cb'] = function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(responseData) {
                    var params, responseDataJson, res, query;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {case 0:
                            params = _this.state.params;responseDataJson = {};try {
                              responseDataJson = JSON.parse(responseData);
                            } catch (e) {
                              responseDataJson = {};
                            }_context.next = 5;return Object(__WEBPACK_IMPORTED_MODULE_8__actions_productAction__["a" /* applyInspectionForm */])({ data: responseDataJson.data, 'key_id': responseDataJson.key_id, sign: responseDataJson.sign, 'instance_id': Object.keys(resInstance.data)[0], 'company_name': params.companyName, 'person_name': params.userName, 'mobile': params.phone, 'email': params.email, 'notes': params.notes, type: 0, 'product_name': '工业安防' });case 5:
                            res = _context.sent;if (res.status === 0) {
                              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_toast___default.a.success(res.data.message);query = _this.getRequest();setTimeout(function () {
                                if (query.url) {
                                  window.location.href = decodeURIComponent(query.url);
                                } else {
                                  window.history.go(-1);
                                }
                              }, 1000);
                            } else {
                              __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_toast___default.a.error(res.message || res.description || '');
                            }case 7:case 'end':
                            return _context.stop();}
                      }
                    }, _callee, _this2);
                  }));return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }();
              } else if (resInstance.status === 401) {
                window.location.href = _this.loginUrl();
              }case 7:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2);
    }));_this.pushValidate = function (node) {
      if (node) {
        _this.validate.push(node.validate);
      }
    };_this.state = { params: {}, instanceId: '' };return _this;
  }_createClass(NumberReport, [{ key: 'render', value: function render() {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'number-report' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'number-report-title' }, '\u7533\u8BF7\u6BCF\u592950\u6B21\u514D\u8D39\u8BD5\u7528'), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'number-report-wrapper' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { className: 'form' }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__numberOptions_formCom__["b" /* FormItem */], { isRequire: true, value: this.state.params.companyName, onChange: this.onChange.bind(this, 'companyName'), className: 'first-form-item', type: 'input', label: '\u516C\u53F8\u540D\u79F0\uFF1A', placeholder: '\u8BF7\u8F93\u5165\u516C\u53F8\u540D\u79F0', comClassName: 'form-input', ref: this.pushValidate, onBlur: this.onBlur, onFocus: this.onFocus, rules: [Object(__WEBPACK_IMPORTED_MODULE_11__numberOptions_utils__["f" /* validateRequire */])('公司名称'), Object(__WEBPACK_IMPORTED_MODULE_11__numberOptions_utils__["d" /* validateMin */])('公司名称', 2, '超出范围，公司名称为2-50个字符'), Object(__WEBPACK_IMPORTED_MODULE_11__numberOptions_utils__["c" /* validateMax */])('公司名称', 50, '超出范围，公司名称为2-50个字符')] }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__numberOptions_formCom__["b" /* FormItem */], { isRequire: true, type: 'input', label: '\u8054\u7CFB\u4EBA\uFF1A', comClassName: 'form-input', ref: this.pushValidate, placeholder: '\u8BF7\u8F93\u5165\u8054\u7CFB\u4EBA', value: this.state.params.userName, onChange: this.onChange.bind(this, 'userName'), onBlur: this.onBlur, onFocus: this.onFocus, rules: [Object(__WEBPACK_IMPORTED_MODULE_11__numberOptions_utils__["f" /* validateRequire */])('联系人'), Object(__WEBPACK_IMPORTED_MODULE_11__numberOptions_utils__["d" /* validateMin */])('联系人', 2, '超出范围，联系人为2-20个字符'), Object(__WEBPACK_IMPORTED_MODULE_11__numberOptions_utils__["c" /* validateMax */])('联系人', 20, '超出范围，联系人为2-20个字符')] }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__numberOptions_formCom__["b" /* FormItem */], { type: 'input', label: '\u8054\u7CFB\u7535\u8BDD\uFF1A', isRequire: true, comClassName: 'form-input', placeholder: '\u8BF7\u8F93\u5165\u8054\u7CFB\u7535\u8BDD', value: this.state.params.phone, onChange: this.onChange.bind(this, 'phone'), ref: this.pushValidate, rules: [Object(__WEBPACK_IMPORTED_MODULE_11__numberOptions_utils__["f" /* validateRequire */])('联系电话'), { validate: function validate(value) {
            var rePhone = /^1[3456789]\d{9}$/;return !rePhone.test(value);
          }, message: '联系电话格式不正确！' }], onBlur: this.onBlur, onFocus: this.onFocus }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__numberOptions_formCom__["b" /* FormItem */], { type: 'input', isRequire: true, label: '\u90AE\u4EF6\uFF1A', comClassName: 'form-input', placeholder: '\u8BF7\u8F93\u5165\u90AE\u4EF6', value: this.state.params.email, onChange: this.onChange.bind(this, 'email'), ref: this.pushValidate, rules: [Object(__WEBPACK_IMPORTED_MODULE_11__numberOptions_utils__["f" /* validateRequire */])('邮件'), { validate: function validate(value) {
            var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;return value.length !== 0 && !reg.test(value);
          }, message: '邮件格式不正确！' }], onBlur: this.onBlur, onFocus: this.onFocus }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__numberOptions_formCom__["b" /* FormItem */], { type: 'textarea', label: '\u9700\u6C42\u63CF\u8FF0\uFF1A', isRequire: true, comClassName: 'form-textarea', value: this.state.params.notes, onChange: this.onChange.bind(this, 'notes'), placeholder: '\u8BF7\u7B80\u8981\u63CF\u8FF0POC\u9700\u6C42', rules: [Object(__WEBPACK_IMPORTED_MODULE_11__numberOptions_utils__["f" /* validateRequire */])('需求描述'), Object(__WEBPACK_IMPORTED_MODULE_11__numberOptions_utils__["d" /* validateMin */])('需求描述', 2, '超出范围，需求描述为2-500个字符'), Object(__WEBPACK_IMPORTED_MODULE_11__numberOptions_utils__["c" /* validateMax */])('需求描述', 500, '超出范围，需求描述为2-500个字符')], ref: this.pushValidate, onBlur: this.onBlur, onFocus: this.onFocus }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', { onClick: this.onSubmit, className: 'number-options-btn' }, '\u63D0\u4EA4\u7533\u8BF7'))));
    } }]);return NumberReport;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]), _class.propTypes = { postNumberReport: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, reportRes: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, match: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, userInfo: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(function (state) {
  return { reportRes: state.postNumberReport, userInfo: state.userLoginstate };
}, function (dispatch) {
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({ postNumberReport: __WEBPACK_IMPORTED_MODULE_7__actions_numberOptionsActions__["d" /* postNumberReport */] }, dispatch);
})(NumberReport));

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_bugSearchAction__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp, _initialiseProps;function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file 漏洞信息查询
  * @author wangzhuang
  * */var BugSearch = (_temp = _class = function (_Component) {
  _inherits(BugSearch, _Component);function BugSearch(props, context) {
    _classCallCheck(this, BugSearch);var _this = _possibleConstructorReturn(this, (BugSearch.__proto__ || Object.getPrototypeOf(BugSearch)).call(this, props, context));_initialiseProps.call(_this);var vulName = _this.getRequest().vul_name;var vulNum = _this.getRequest().vul_num;var appName = _this.getRequest().app_name;var vulLevel = _this.getRequest().vul_level;var id = _this.getRequest().id;var from = _this.getRequest().from;_this.state = { id: id || '', from: from || '', bugTitle: vulName ? decodeURI(vulName) : '', bugIndex: vulNum ? decodeURI(vulNum) : '', appName: appName ? decodeURI(appName) : '', levelId: vulLevel || 'all', newData: [], hotData: [], infoObj: {}, page: 1, count: 10, searchMore: vulNum || appName || vulLevel || false, searchData: [], infoOff: false, searchOff: false };return _this;
  }_createClass(BugSearch, [{ key: 'componentWillMount', value: function componentWillMount() {
      if (this.isPC()) {
        location.href = '/bug_search' + location.search;
      }
    } }, { key: 'componentDidMount', value: function componentDidMount() {
      var _this2 = this;var vulName = this.getRequest().vul_name;var vulNum = this.getRequest().vul_num;var appName = this.getRequest().app_name;var vulLevel = this.getRequest().vul_level;var id = this.getRequest().id;var from = this.getRequest().from;if (id && from === 'alading') {
        this.props.fetchVulDetail({ id: id }).then(function (res) {
          var data = res.data;if (data.status === 0) {
            _this2.infoFn(data.data);window.scrollTo(0, _this2.more.offsetTop - _this2.more.offsetHeight);
          }
        });return;
      }if (vulName || vulNum || appName || vulLevel) {
        this.getSerachFn();
      } else {
        this.props.fetchVulHomepagee().then(function (res) {
          var data = res.data;if (res.data.status === 0) {
            _this2.setState({ newData: data.data.last_vul_list, hotData: data.data.hot_vul_list });
          }
        });
      }
    } }, { key: 'render', value: function render() {
      var _this3 = this;var _state = this.state,
          count = _state.count,
          page = _state.page,
          bugTitle = _state.bugTitle,
          bugIndex = _state.bugIndex,
          appName = _state.appName,
          newData = _state.newData,
          infoOff = _state.infoOff,
          levelId = _state.levelId,
          hotData = _state.hotData,
          searchMore = _state.searchMore,
          searchOff = _state.searchOff,
          searchData = _state.searchData,
          infoObj = _state.infoObj;var levelData = [{ id: 'all', name: '全部' }, { id: '3', name: '高' }, { id: '2', name: '中' }, { id: '1', name: '低' }];var showOff = false;if (Math.ceil(count / 10) <= page) {
        showOff = true;
      }return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'bug_search' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2', null, '\u6F0F\u6D1E\u4FE1\u606F\u67E5\u8BE2'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod1' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u6F0F\u6D1E\u6807\u9898\uFF1A'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text inputS' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', defaultValue: bugTitle, placeholder: '请输入关键字', onChange: function onChange(event) {
          _this3.setState({ bugTitle: event.target.value });
        } }))), searchMore ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u6F0F\u6D1E\u7F16\u53F7\uFF1A'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text inputS' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', defaultValue: bugIndex, placeholder: 'CVE/CNVD/CNNVD', onChange: function onChange(event) {
          _this3.setState({ bugIndex: event.target.value });
        } }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u5E94\u7528\u540D\u79F0\uFF1A'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text inputS' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', defaultValue: appName, placeholder: '请输入关键字', onChange: function onChange(event) {
          _this3.setState({ appName: event.target.value });
        } }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u6F0F\u6D1E\u7B49\u7EA7\uFF1A'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, levelData.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: levelId === item.id ? 'tab on' : 'tab', key: item.id, onClick: function onClick() {
            _this3.setState({ levelId: item.id });
          } }, item.name);
      })))) : null), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'm-btn', onClick: function onClick() {
          _this3.setState({ page: 1, count: 10 }, function () {
            _this3.getSerachFn();
          });
        } }, '\u641C\u7D22'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'more', ref: function ref(el) {
          return _this3.more = el;
        }, onClick: function onClick() {
          _this3.setState({ searchMore: !searchMore });
        } }, searchMore ? '恢复默认搜索' : '高级搜索'), !infoOff ? !searchOff ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'mod2' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u6700\u65B0\u6F0F\u6D1E'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, newData.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, onClick: function onClick() {
            _this3.infoFn(item);
          } }, item.vul_name);
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u6700\u70ED\u6F0F\u6D1E'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, hotData.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, onClick: function onClick() {
            _this3.infoFn(item);
          } }, item.vul_name);
      })))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'res-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u641C\u7D22\u7ED3\u679C'), searchData.length ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'list' }, searchData.map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, dangerouslySetInnerHTML: { __html: item.vul_name }, onClick: function onClick() {
            _this3.infoFn(item);
          } });
      }), count > 10 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'load-more', onClick: function onClick() {
          var val = 1;if (!showOff) {
            val = page + 1;
          }_this3.setState({ page: val }, function () {
            _this3.getSerachFn(true);
          });
        } }, showOff ? '收起' : '加载更多') : null) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, '\u6CA1\u627E\u5230\u7B26\u5408\u6761\u4EF6\u7684\u7ED3\u679C')) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'info-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u6F0F\u6D1E\u6807\u9898'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text', dangerouslySetInnerHTML: { __html: infoObj.vul_name || '-' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u6F0F\u6D1E\u7B49\u7EA7'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, { '1': '低', '2': '中', '3': '高' }[infoObj.vul_level] || '-'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, 'CNVD\u6F0F\u6D1E\u7F16\u53F7'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text', dangerouslySetInnerHTML: { __html: infoObj.cnvd || '-' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, 'CNNVD\u6F0F\u6D1E\u7F16\u53F7'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text', dangerouslySetInnerHTML: { __html: infoObj.cnnvd || '-' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, 'CVE\u6F0F\u6D1E\u7F16\u53F7'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text', dangerouslySetInnerHTML: { __html: infoObj.cve || '-' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u5E94\u7528\u540D\u79F0'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text', dangerouslySetInnerHTML: { __html: infoObj.app_name || '-' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u5F71\u54CD\u7248\u672C'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, infoObj.app_version_content || '-'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u6F0F\u6D1E\u4ECB\u7ECD'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, infoObj.vul_summary || '-'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, '\u4FEE\u590D\u5EFA\u8BAE'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'text' }, infoObj.vul_solution || '-')));
    } }]);return BugSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.propTypes = { history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, fetchVulDetail: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, fetchVulSearch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, fetchVulHomepagee: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func }, _initialiseProps = function _initialiseProps() {
  var _this4 = this;this.getSerachFn = function (off) {
    var _state2 = _this4.state,
        bugTitle = _state2.bugTitle,
        searchData = _state2.searchData,
        bugIndex = _state2.bugIndex,
        appName = _state2.appName,
        page = _state2.page,
        levelId = _state2.levelId,
        moreObj = _state2.moreObj,
        searchMore = _state2.searchMore;var json = { page: page, perPage: 10 };var urlData = [];if (off) {
      json = moreObj;json.page = page;
    } else {
      if (bugTitle) {
        json['vul_name'] = bugTitle;
      }if (searchMore) {
        if (bugIndex) {
          json['vul_num'] = bugIndex;
        }if (appName) {
          json['app_name'] = appName;
        }if (levelId !== 'all') {
          json['vul_level'] = levelId;
        }
      }
    }for (var attr in json) {
      if (attr !== 'page' && attr !== 'perPage') {
        urlData.push(attr + '=' + json[attr]);
      }
    }_this4.props.history.push('/bug_search?' + urlData.join('&'));_this4.props.fetchVulSearch(json).then(function (res) {
      var data = res.data;if (res.data.status === 0) {
        _this4.setState({ moreObj: json, count: data.data.count, searchOff: true, infoOff: false, searchData: page === 1 ? data.data.rows : [].concat(_toConsumableArray(searchData), _toConsumableArray(data.data.rows)) });
      }
    });
  };this.infoFn = function (item) {
    _this4.setState({ infoOff: true, infoObj: item });
  };
}, _temp);function mapStateToProps(state) {
  return { userLoginstate: state.userLoginstate, userApplyData: state.userApplyData, cmsapiUserapply: state.cmsapiUserapply };
}function mapDispatchToProps(dispatch) {
  return { fetchVulDetail: function fetchVulDetail(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__actions_bugSearchAction__["a" /* fetchVulDetail */])(dispatch, obj);
    }, fetchVulSearch: function fetchVulSearch(obj) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__actions_bugSearchAction__["c" /* fetchVulSearch */])(dispatch, obj);
    }, fetchVulHomepagee: function fetchVulHomepagee() {
      return Object(__WEBPACK_IMPORTED_MODULE_4__actions_bugSearchAction__["b" /* fetchVulHomepagee */])(dispatch);
    } };
}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps, mapDispatchToProps)(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* withRouter */])(BugSearch)));

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchVulHomepagee;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchVulSearch;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchVulDetail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(4);
/**
 * @file 漏洞搜索
 * @author wangzhuang
 */function fetchVulHomepagee(dispatch, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('GET', '/xiapi/api/v1/vul/homepage', obj, {}, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["M" /* GET_VUL_HOMEPAGE */], data: data.data });
  });
}function fetchVulSearch(dispatch, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/vul/search', {}, obj, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["N" /* GET_VUL_SEARCH */], data: data.data });
  });
}function fetchVulDetail(dispatch, obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/vul/detail', {}, obj, function (data) {
    dispatch({ type: __WEBPACK_IMPORTED_MODULE_1__ActionTypes__["L" /* GET_VUL_DETAIL */], data: data.data });
  });
}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageAppSolution; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ProBanner__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_website_sescurity_less__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__page_website_sescurity_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__page_website_sescurity_less__);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: app解决方案
  * @author: wence
  */var PageAppSolution = (_temp = _class = function (_PureComponent) {
  _inherits(PageAppSolution, _PureComponent);function PageAppSolution() {
    _classCallCheck(this, PageAppSolution);return _possibleConstructorReturn(this, (PageAppSolution.__proto__ || Object.getPrototypeOf(PageAppSolution)).apply(this, arguments));
  }_createClass(PageAppSolution, [{ key: 'componentDidMount', value: function componentDidMount() {
      if (this.isPC()) {
        window.location.href = '/newsite/websitesec';
      }
    } }, { key: 'render', value: function render() {
      var url = '/m/apply?name=' + encodeURIComponent('#网站安全解决方案#');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'pro-banner-box bg-new' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_ProBanner__["a" /* default */], { title: '网站安全解决方案', urlText: '\u514D\u8D39\u8BD5\u7528', bgImg: __webpack_require__(793), url: url })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-des' }, '\u767E\u5EA6\u5168\u7CFB\u7F51\u7AD9\u5B89\u5168\u670D\u52A1\uFF0C\u9488\u5BF9\u653F\u4F01\u884C\u4E1A\u91CF\u8EAB\u6253\u9020\uFF0C\u4ECE\u68C0\u6D4B\u5230\u653B\u9632\u4E00\u7AD9\u89E3\u51B3'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '解决方案介绍' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'website-solution' }, '\u57FA\u4E8E\u767E\u5EA6\u5927\u6570\u636E\u3001AI\u6280\u672F\u5B9E\u73B0\u7684\u5206\u5E03\u5F0F\u6F0F\u6D1E\u626B\u63CF\u7CFB\u7EDF\u548C\u7F51\u7AD9\u5185\u5BB9\u611F\u77E5\u80FD\u529B\uFF0C \u4E3B\u52A8\u68C0\u6D4B\u7F51\u7AD9\u5185\u5BB9\uFF0C\u5B9E\u73B0\u5FEB\u901F\u53D1\u73B0\u98CE\u9669\u8D44\u4EA7\u3001\u6F0F\u6D1E\u3001\u8FDD\u89C4\u7F51\u9875\u5185\u5BB9\u3001\u7BE1\u6539\u6302\u9A6C\u9875\u9762\uFF0C\u6709\u6548\u4FDD\u969C\u4F01\u4E1A\u8D44\u4EA7\u5B89\u5168\u3002 \u5B9A\u671F\u8F93\u51FA\u5185\u5BB9\u98CE\u9669\u68C0\u6D4B\u62A5\u544A\uFF0C\u89C4\u907F\u5185\u5BB9\u53D1\u5E03\u98CE\u9669\uFF0C\u53CA\u65F6\u627C\u5236\u8FDD\u89C4\u98CE\u9669\uFF0C\u51CF\u5C11\u4F01\u4E1A\u635F\u5931\u3002'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'website-solution-card' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'website-solution-card-title' }, '\u667A\u80FD\u6DF1\u5EA6\u5185\u5BB9\u68C0\u6D4B'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'website-solution-card-content' }, '\u57FA\u4E8E\u767E\u5EA6\u5168\u7F51\u641C\u7D22\u6570\u636E\uFF0C\u68C0\u6D4B\u88AB\u6302\u9A6C\u3001\u7BE1\u6539\u7684\u9875\u9762\u53CA\u4E0D\u5408\u89C4\u5185\u5BB9\uFF0C \u8BC6\u522B\u9493\u9C7C\u4EFF\u5192\u6216\u76F8\u5173\u6B3A\u8BC8\u7F51\u9875\u3002\u5BF9\u7F51\u7AD9\u7684\u65B0\u589E\u7F51\u9875\u8FDB\u884C\u52A8\u6001\u611F\u77E5\uFF0C \u53D1\u73B0\u7F51\u9875\u51FA\u73B0\u7684\u5A01\u80C1\u5185\u5BB9\uFF0C\u591A\u79CD\u9014\u5F84\u53CA\u65F6\u53CD\u9988\uFF0C\u591A\u91CD\u9884\u8B66\u3002')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'website-solution-card icon2' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'website-solution-card-title' }, '\u5168\u7C7B\u578B\u6F0F\u6D1E\u626B\u63CF'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'website-solution-card-content' }, '\u5E94\u7528\u767E\u5EA6\u5B89\u5168\u6307\u7EB9\u7279\u5F81\u5E93\uFF0C\u81EA\u52A8\u626B\u63CF\u670D\u52A1\u5668\u53CA\u57DF\u540D\u7B49\u76F8\u5173\u8D44\u4EA7\u5185\u5BB9\uFF0C \u5E76\u6709\u6548\u8BC6\u522B\u8D44\u4EA7\u6240\u5305\u542B\u7684\u670D\u52A1\u548CWeb\u5E94\u7528\u3002\u5BF9\u8D44\u4EA7\u8FDB\u884C\u5168\u65B9\u4F4D\u626B\u63CF\uFF0C \u6F0F\u6D1E\u7C7B\u578B\u8986\u76D6OWASP Top 10 \u98CE\u9669\u7C7B\u578B\u4EE5\u53CAWASC 25\u79CDweb\u5E94\u7528\u6F0F\u6D1E\u3002')), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '业务结构' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'struct-content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(794) }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(795) })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '方案优势' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingBottom: 0 } }, [{ url: __webpack_require__(796), title: '方便易用', content: 'API接入灵活，即刻拥有安全防护能力' }, { url: __webpack_require__(797), title: '7X24小时', content: '提供7*24小时的应急响应漏洞预警服务' }, { url: __webpack_require__(798), title: '服务稳定', content: '百度的基础服务，稳定性99.99%' }, { url: __webpack_require__(799), title: '数据全面', content: '依托百度大数据高效的感知能力和健全的漏洞数据库' }, { url: __webpack_require__(800), title: '定制灵活', content: '覆盖欺诈，违法和风险类型，结合产品需求灵活定制防护能力' }, { url: __webpack_require__(801), title: '检测报告', content: '支持查询检测结果报告输出，直观了解网站状态' }].map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-feature-item' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'icon', style: { backgroundImage: 'url(' + item.url + ')' } }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des' }, item.content)));
      })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { marginTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u5408\u4F5C\u5BA2\u6237' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { width: '100%', height: '2.4rem', marginBottom: '1rem', background: '#D8D8D8' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __webpack_require__(802), width: '100%', alt: '\u5BA2\u6237' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { style: { background: '#F5F5F5', paddingBottom: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'product-mod', style: { paddingTop: '1rem' } }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_ProductTitle__["a" /* default */], { title: '\u76F8\u5173\u4EA7\u54C1' })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null, [{ title: 'DDoS攻击防护', content: '\u5177\u59071Tbps\u6297D\u80FD\u529B\uFF0C\u91C7\u7528\u4E91\u7AEF\u9632\u62A4\u6A21\u5F0F\uFF0C\u5BA2\u6237\u65E0\u9700\u8D2D\u4E70\u6216\u79DF\u7528\u786C\u4EF6\u6E05\u6D17\u8BBE\u5907\uFF0C\n                                        \u6309\u9700\u4F7F\u7528\uFF1B\u540C\u65F6\uFF0C\u767E\u5EA6\u5B89\u5168\u56E2\u961F\u5168\u7A0B\u652F\u6301\u9632\u62A4\uFF1B\u6709\u6548\u9632\u5FA1\u5404\u7C7B\u653B\u51FB\uFF0C\u5305\u62EC\uFF08\u4E0D\u9650\u4E8E\uFF09\u6D41\u91CF\u578B\u3001\u5E94\u7528\u578B\u3001\u626B\u63CF\u7AA5\u63A2\u578B\u3001\u534F\u8BAE\u6F0F\u6D1E\u578B\u3001\u534F\u8BAE\u9009\u9879\u578B\u7B49DDoS\u653B\u51FB\uFF0C\n                                        \u5982SYN Flood\u3001UDP Flood\u3001DNS Query Flood\u3001CC\u7B49\uFF0C\u633D\u56DE\u56E0\u7F51\u7AD9\u6216\u4E1A\u52A1\u670D\u52A1\u4E2D\u65AD\u9020\u6210\u7684\u8BF8\u591A\u635F\u5931\u3002', url: 'https://anquan.baidu.com/product/ddos' }, { title: 'WAF应用防火墙', content: '\u7531\u56FD\u5185\u9886\u5148\u7684Web\u5B89\u5168\u4E13\u5BB6\u7EC4\u6210\u7684\u6280\u672F\u56E2\u961F\uFF0C\u4E3A\u4E0D\u540C\u884C\u4E1A\u3001\u4E0D\u540C\u89C4\u6A21\u7684\u7F51\u7AD9\u63D0\u4F9B\u4E86\u9769\u547D\u6027\u7684\u4E91\u9632\u62A4\u5B89\u5168\u6A21\u5F0F\uFF0C\n                                        \u5F7B\u5E95\u98A0\u8986\u4E86\u8FC7\u53BB\u5355\u70B9\u90E8\u7F72WAF\u5F62\u5F0F\u7684\u88AB\u52A8\u9632\u62A4\uFF0C\u4EE5\u7F51\u7AD9\u66FF\u8EAB\u7684\u5F62\u5F0F\u4E3A\u7F51\u7AD9\u62E6\u622A\u5404\u79CDSQL\u6CE8\u5165\u3001XSS\u8DE8\u7AD9\u3001\u7F51\u7AD9\u6302\u9A6C\u3001\u7BE1\u6539\u3001\u62D6\u5E93\u7B49\u9ED1\u5BA2\u653B\u51FB\uFF0C\n                                        \u5E76\u505A\u5230\u5B9E\u65F6\u66F4\u65B0\u9632\u62A4\u7B56\u7565\uFF0C\u7B2C\u4E00\u65F6\u95F4\u9632\u5FA1\u5404\u79CD0day\u6F0F\u6D1E\uFF0C\u6709\u6548\u4FDD\u62A4\u7528\u6237\u6E90\u7AD9\u5B89\u5168\u3002', url: 'https://anquan.baidu.com/product/waf' }, { title: '渗透测试', content: '\u4F9D\u6258\u767E\u5EA6\u4E8C\u5341\u5E74\u7684\u5B89\u5168\u79EF\u7D2F\u548C\u57F9\u517B\u7684\u5B89\u5168\u4E13\u5BB6\u56E2\u961F\uFF0C\u63A8\u51FA\u7684\u6E17\u900F\u6D4B\u8BD5\u670D\u52A1\uFF0C\u662F\u5728\u7528\u6237\u7684\u6388\u6743\u4E0B\uFF0C\n                                        \u5B8C\u5168\u6A21\u62DF\u9ED1\u5BA2\u7684\u884C\u4E3A\uFF0C\u5BF9\u5BA2\u6237\u7F51\u7AD9\u8FDB\u884C\u5165\u4FB5\u5C1D\u8BD5\u3002\u5E2E\u52A9\u7528\u6237\u7406\u89E3\u9ED1\u5BA2\u662F\u5982\u4F55\u601D\u8003\u7684\uFF0C\n                                        \u6BD4\u9ED1\u5BA2\u66F4\u65E9\u7684\u53D1\u73B0\u7F51\u7AD9\u95EE\u9898\uFF0C\u5E76\u5728\u771F\u5B9E\u7684\u7EBF\u4E0A\u73AF\u5883\u9A8C\u8BC1\u6BCF\u4E2A\u6F0F\u6D1E\u7684\u771F\u5B9E\u5371\u5BB3\uFF0C\u5E2E\u52A9\u7F51\u7AD9\u53CA\u65E9\u4FEE\u590D\u6F0F\u6D1E\u3002', url: 'https://anquan.baidu.com/product/penetration' }].map(function (item, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { key: index, className: 'saas-app-solution-card' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'title' }, item.title), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'content' }, item.content), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: item.url, target: '_blank', className: 'btn' }, '\u4E86\u89E3\u8BE6\u60C5'));
      }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-website-contact' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'saas-website-contact-inner' }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'des' }, '\u8054\u7CFB\u6211\u4EEC\u5FEB\u901F\u83B7\u53D6\u514D\u8D39\u8BD5\u7528\u548C\u4E13\u5BB6\u6280\u672F\u652F\u6301'), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', { href: url, className: 'btn btn-border' }, '\u7ACB\u5373\u54A8\u8BE2'))));
    } }]);return PageAppSolution;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]), _class.propTypes = { bannerInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object }, _temp);

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/banner.9e9a94e3.png";

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bussiness1.4d69f4f0.png";

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bussiness2.e9c4a819.png";

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/parnter.48fad102.png";

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_mobile_lib_modal_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_toast_style_css__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_mobile_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_toast__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_less__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__index_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_conpinAction__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_buyAction__ = __webpack_require__(30);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();var _class, _temp;function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);var value = info.value;
        } catch (error) {
          reject(error);return;
        }if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }return step("next");
    });
  };
}function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /**
  * @file: 优惠券领取
  * @author: wence
  */var voucherTypes = { 1: '现金券', 2: '折扣券', 3: '兑换券' };var ConpinModal = (_temp = _class = function (_PureComponent) {
  _inherits(ConpinModal, _PureComponent);function ConpinModal(props) {
    var _this2 = this;_classCallCheck(this, ConpinModal);var _this = _possibleConstructorReturn(this, (ConpinModal.__proto__ || Object.getPrototypeOf(ConpinModal)).call(this, props));_this.getConpinInfo = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(params) {
        var instance, res;return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {case 0:
                _context.next = 2;return _this.props.fetchInstanceGetInstance();case 2:
                instance = _this.props.instance;if (instance.status === 0 && instance.data) {
                  params['instance_id'] = Object.keys(instance.data)[0] || '';
                }_context.next = 6;return Object(__WEBPACK_IMPORTED_MODULE_10__actions_conpinAction__["a" /* getConpinInfo */])(params);case 6:
                res = _context.sent;if (res && res.status === 0) {
                  if (res.data) {
                    _this.setState({ visible: true, conpinInfo: res.data, isDisabled: res.data['is_buy'] === 1 || res.data['is_buy'] === 2 });
                  }
                }case 8:case 'end':
                return _context.stop();}
          }
        }, _callee, _this2);
      }));return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();_this.receiveConpin = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var loginInfo, instance, data, res;return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {case 0:
              if (!_this.state.isDisabled) {
                _context2.next = 2;break;
              }return _context2.abrupt('return');case 2:
              loginInfo = _this.props.loginInfo;if (loginInfo && loginInfo.status === 0) {
                _context2.next = 6;break;
              }window.location.href = _this.loginUrl();return _context2.abrupt('return');case 6:
              instance = _this.props.instance;if (!(instance.status === 0 && instance.data)) {
                _context2.next = 14;break;
              }data = {};try {
                data = JSON.parse(window.localStorage.getItem('__abbaidu_20181211_cb')) || {};
              } catch (e) {
                data = {};
              }_context2.next = 12;return Object(__WEBPACK_IMPORTED_MODULE_10__actions_conpinAction__["b" /* receiveConpin */])({ 'instance_id': Object.keys(instance.data)[0], 'voucher_id': _this.state.conpinInfo['voucher_id'], 'voucher_flag': _this.state.conpinInfo['voucher_flag'], // 'voucher_service': this.state.conpinInfo['voucher_service'],
                // 'voucher_meal': this.state.conpinInfo['voucher_meal'],
                // 'voucher_type': this.state.conpinInfo['voucher_type'],
                // 'voucher_name': this.state.conpinInfo['voucher_name'],
                // 'voucher_price': this.state.conpinInfo['voucher_price'],
                'data': data && data.data, 'key_id': data && data['key_id'], 'sign': data && data.sign });case 12:
              res = _context2.sent;if (res && res.status === 0 && res.data && res.data.status === 'success') {
                _this.setState({ successReceive: true });
              } else if (res && res.status === 0 && res.data && res.data.status === 'fail') {
                __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_toast___default.a.info('领取失败');
              } else if (res && res.status === 401) {
                window.location.href = _this.loginUrl();
              } else {
                __WEBPACK_IMPORTED_MODULE_3_antd_mobile_lib_toast___default.a.info(res && res.description || '领取失败');
              }case 14:case 'end':
              return _context2.stop();}
        }
      }, _callee2, _this2);
    }));_this.renderReciveBody = function () {
      var loginInfo = _this.props.loginInfo;var conpinInfo = _this.state.conpinInfo || {};return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'conpin-value' }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'conpin-value-main' }, conpinInfo['voucher_type'] === 1 && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: 'unit' }, '\uFFE5'), conpinInfo['voucher_type'] === 1 && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: 'price' }, conpinInfo['voucher_price']), conpinInfo['voucher_type'] === 3 && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: 'price' }, conpinInfo['try_time'] ? conpinInfo['try_time'] : '0天')), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'conpin-value-des' }, voucherTypes[conpinInfo['voucher_type']] || '')), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'conpin-name' }, conpinInfo['voucher_scope']), !_this.state.successReceive && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { onClick: _this.receiveConpin, className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('conpin-btn', { disabled: _this.state.isDisabled }) }, ['点击领取', '已领取', '已抢完'][conpinInfo && conpinInfo['is_buy']] || '点击领取'), !_this.state.successReceive && !(loginInfo && loginInfo.status === 0) && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'no-login' }, '\u767B\u5F55\u5373\u53EF\u9886\u53D6\u4F18\u60E0\u5238'), _this.state.successReceive && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'receive-success' }, '\u9886\u53D6\u6210\u529F'));
    };_this.state = { visible: false, conpinInfo: null, successReceive: false, isDisabled: false };return _this;
  }_createClass(ConpinModal, [{ key: 'componentDidMount', value: function componentDidMount() {
      var params = this.getParams();if (params['voucher_id'] && params['voucher_flag']) {
        this.getConpinInfo({ 'voucher_id': params['voucher_id'], 'voucher_flag': params['voucher_flag'], channel: params['channel'] || '2' });
      }
    } }, { key: 'render', value: function render() {
      var _this3 = this;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_mobile_lib_modal___default.a, { animationType: 'slide', maskTransitionName: 'mask-transition', className: 'conpin', visible: this.state.visible, transparent: true }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'conpin-container' }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'conpin-body' }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('conpin-body-bg', { success: this.state.successReceive }) }, this.renderReciveBody()))), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('div', { className: 'conpin-close', onClick: function onClick() {
          return _this3.setState({ visible: false });
        } }));
    } }]);return ConpinModal;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]), _class.propTypes = { instance: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, loginInfo: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, fetchInstanceGetInstance: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func }, _temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(function (state) {
  return { instance: state.instanceGetinstance, loginInfo: state.userLoginstate };
}, function (dispatch) {
  return { fetchInstanceGetInstance: function fetchInstanceGetInstance() {
      return Object(__WEBPACK_IMPORTED_MODULE_11__actions_buyAction__["d" /* fetchInstanceGetInstance */])(dispatch);
    } };
})(ConpinModal));

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getConpinInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return receiveConpin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(5);
/**
 * @file: 优惠券
 * @author: wence
 */var getConpinInfo = function getConpinInfo(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/pay/voucher', {}, params, function () {
    return null;
  }).then(function (data) {
    return data && data.data || {};
  });
};var receiveConpin = function receiveConpin(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__util__["c" /* rcAjax */])('POST', '/xiapi/api/v1/pay/receiveVoucher', {}, params, function () {
    return null;
  }).then(function (data) {
    return data && data.data || {};
  });
};

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__buy__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__help__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__page__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mark__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__home__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apply__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__forum__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__search__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__product__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fileCheck__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__community__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__numberAuth__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__productCenter__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__productDetail__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__numberOptions__ = __webpack_require__(822);
/**
 * @file index
 * @author WangZhuang
 *//* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__buy__, __WEBPACK_IMPORTED_MODULE_2__page__, __WEBPACK_IMPORTED_MODULE_3__mark__, __WEBPACK_IMPORTED_MODULE_4__home__, __WEBPACK_IMPORTED_MODULE_1__help__, __WEBPACK_IMPORTED_MODULE_5__apply__, __WEBPACK_IMPORTED_MODULE_6__forum__, __WEBPACK_IMPORTED_MODULE_7__search__, __WEBPACK_IMPORTED_MODULE_8__product__, __WEBPACK_IMPORTED_MODULE_9__fileCheck__, __WEBPACK_IMPORTED_MODULE_10__community__, __WEBPACK_IMPORTED_MODULE_11__numberAuth__, __WEBPACK_IMPORTED_MODULE_12__productCenter__, __WEBPACK_IMPORTED_MODULE_13__productDetail__, __WEBPACK_IMPORTED_MODULE_14__numberOptions__));

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["activityGetService"] = activityGetService;
/* harmony export (immutable) */ __webpack_exports__["instanceGetinstance"] = instanceGetinstance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
/**
 * @file 聚合页
 * @author wangzhuang
 */function activityGetService() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["d" /* GET_ACTIVITY_GET_SERVICE */]:
      if (action.data.status === 0) {
        state = action.data;return state;
      }return {};default:
      return state;}
}function instanceGetinstance() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["w" /* GET_INSTANCE_GETINSTANCE */]:
      if (action.data.status === 0) {
        state = action.data;return state;
      }return {};default:
      return state;}
}

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["helpapiIndex"] = helpapiIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
/**
 * @file help
 * @author wangzhuang
 */function helpapiIndex() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["v" /* GET_HELPAPI_INDEX */]:
      if (action.data.is_error === 0) {
        state = action.data;return state;
      }return {};default:
      return state;}
}

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["cmsapiGetArticleData"] = cmsapiGetArticleData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
/**
 * @file page
 * @author v_lichaoqing
 */function cmsapiGetArticleData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["h" /* GET_CMSAPI_GETARTICLEDATA */]:
      if (action.data.is_error === 0) {
        state = action.data;return state;
      }return {};default:
      return state;}
}

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["cmsapiTagArticleData"] = cmsapiTagArticleData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
} /**
  * @file page
  * @author v_lichaoqing
  */function cmsapiTagArticleData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["q" /* GET_CMSAPI_TAGARTICLEDATA */]:
      if (action.data.is_error === 0) {
        if (action.isMore) {
          var _action$data$itemlist;(_action$data$itemlist = action.data.itemlist.article_list.datalist).unshift.apply(_action$data$itemlist, _toConsumableArray(state.itemlist.article_list.datalist));return state = action.data;
        } else {
          return state = action.data;
        }
      }return {};default:
      return state;}
}

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["cmsapiHomepagea"] = cmsapiHomepagea;
/* harmony export (immutable) */ __webpack_exports__["userLoginstate"] = userLoginstate;
/* harmony export (immutable) */ __webpack_exports__["articleList"] = articleList;
/* harmony export (immutable) */ __webpack_exports__["navigationList"] = navigationList;
/* harmony export (immutable) */ __webpack_exports__["navListIndex"] = navListIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
/**
 * @file forum
 * @author wangzhuang
 */function cmsapiHomepagea() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["i" /* GET_CMSAPI_GETHOMEPAGE */]:
      if (action.data.is_error === 0) {
        state = action.data;return state;
      }return {};default:
      return state;}
}function userLoginstate() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["J" /* GET_USER_LOGINSTATE */]:
      state = action.data;return state;default:
      return state;}
}function articleList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["g" /* GET_ARTICLE_LIST */]:
      if (action.data.is_error === 0) {
        state = action.data;return state;
      }return {};default:
      return state;}
}function navigationList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["z" /* GET_NAVIGATION_LIST */]:
      if (action.data.is_error === 0) {
        state = action.data;return state;
      }return {};default:
      return state;}
}function navListIndex() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["A" /* GET_NAVLIST_INDEX */]:
      state = action.data;return state;default:
      return { index: 0 };}
}

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["userApplyData"] = userApplyData;
/* harmony export (immutable) */ __webpack_exports__["cmsapiUserapply"] = cmsapiUserapply;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
/**
 * @file 申请试用页面
 * @author wangzhuang
 */function userApplyData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["I" /* GET_USER_APPLY_DATA */]:
      if (action.data.is_error === 0) {
        state = action.data;return state;
      }return {};default:
      return state;}
}function cmsapiUserapply() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["r" /* GET_CMSAPI_USERAPPLY */]:
      state = action.data;return state;default:
      return state;}
}

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["cmsapiIndexData"] = cmsapiIndexData;
/* harmony export (immutable) */ __webpack_exports__["cmsapiPublish"] = cmsapiPublish;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
} /**
  * @file forum
  * @author wangzhuang
  */function cmsapiIndexData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["j" /* GET_CMSAPI_INDEXDATA */]:
      if (action.data.is_error === 0) {
        state = action.data;return state;
      }return {};default:
      return state;}
}function cmsapiPublish() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["o" /* GET_CMSAPI_PUBLISH */]:case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["j" /* GET_CMSAPI_INDEXDATA */]:
      if (action.data.is_error === 0) {
        if (action.isMore) {
          var _action$data$itemlist;(_action$data$itemlist = action.data.itemlist.article_list.datalist).unshift.apply(_action$data$itemlist, _toConsumableArray(state.datalist));return state = action.data.itemlist.article_list;
        } else {
          return state = action.data.itemlist.article_list;
        }
      }return {};default:
      return state;}
}

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["cmsapiSearchArticle"] = cmsapiSearchArticle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
} /**
  * @file search
  * @author v_lichaoqing
  */function cmsapiSearchArticle() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["p" /* GET_CMSAPI_SEARCHARTICLE */]:
      if (action.data.is_error === 0) {
        if (action.isMore) {
          var _action$data$itemlist;(_action$data$itemlist = action.data.itemlist.article_list.datalist).unshift.apply(_action$data$itemlist, _toConsumableArray(state.itemlist.article_list.datalist));return state = action.data;
        } else {
          return state = action.data;
        }
      }return {};default:
      return state;}
}

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["pagesDatabyid"] = pagesDatabyid;
/* harmony export (immutable) */ __webpack_exports__["serviceIntroduce"] = serviceIntroduce;
/* harmony export (immutable) */ __webpack_exports__["productId"] = productId;
/* harmony export (immutable) */ __webpack_exports__["scanServices"] = scanServices;
/* harmony export (immutable) */ __webpack_exports__["checkAiImageData"] = checkAiImageData;
/* harmony export (immutable) */ __webpack_exports__["checkAiInsdustryData"] = checkAiInsdustryData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
/**
 * @file product
 * @author wangzhuang
 */function pagesDatabyid() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["E" /* GET_PAGES_DATABYID */]:
      if (action.data.is_error === 0) {
        state = action.data;return state;
      }return {};default:
      return state;}
}function serviceIntroduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["G" /* GET_SERVICE_INTRODUCE */]:
      if (action.data.is_error === 0) {
        state = action.data;return state;
      }return {};default:
      return state;}
}function productId() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["P" /* POST_PRODUCT_ID */]:
      state = action.data;return action.data;default:
      return state;}
}function scanServices() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["F" /* GET_SCAN_SERVERVICE */]:
      state = action.data;return action.data;default:
      return state;}
}function checkAiImageData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["b" /* FETCH_CHACK_AI_IMAGE */]:
      state = action.data;return action.data;default:
      return state;}
}function checkAiInsdustryData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["c" /* FETCH_CHACK_AI_INSDUSTRY */]:
      state = action.data;return action.data;default:
      return state;}
}

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["vdcReport"] = vdcReport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
/**
 * @file 申请试用页面
 * @author wangzhuang
 */function vdcReport() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["K" /* GET_VDC_REPORT */]:
      state = action.data;return state;default:
      return state;}
}

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["helpapiGettext"] = helpapiGettext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
/**
 * @file community
 * @author wangzhuang
 */function helpapiGettext() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["u" /* GET_HELPAPI_GETTEXT */]:
      if (action.data.is_error === 0) {
        state = action.data;return state;
      }return {};default:
      return state;}
}

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["numberCommonList"] = numberCommonList;
/* harmony export (immutable) */ __webpack_exports__["numberCommonInfo"] = numberCommonInfo;
/* harmony export (immutable) */ __webpack_exports__["numberSearchResult"] = numberSearchResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
/**
 * @file 号码认证模块
 * @author wence
 */function numberCommonList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["C" /* GET_NUMBER_COMMON_LIST */]:
      return action.data;default:
      return state;}
}function numberCommonInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["B" /* GET_NUMBER_COMMON_INFO */]:
      return action.data;default:
      return state;}
}function numberSearchResult() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["D" /* GET_NUMBER_SEARCH_RESULT */]:
      return Object.assign({}, action.data, { status: action.status, params: action.params });default:
      return state;}
}

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["cmapiProductList"] = cmapiProductList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
/**
 * @file productCenter
 * @author WenCe
 */function cmapiProductList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var actions = arguments[1];switch (actions.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["m" /* GET_CMSAPI_PRODUCT_LIST */]:
      return Object.assign({}, actions.data);default:
      return state;}
}

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["cmsapiProductDetailIndexData"] = cmsapiProductDetailIndexData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
} /**
  * @file productDetails
  * @author WenCe
  */function cmsapiProductDetailIndexData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var _ref = arguments[1];var type = _ref.type,
      data = _ref.data;var curPage = 'cur_page';var totalPage = 'total_page';switch (type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["k" /* GET_CMSAPI_PRODUCT_DETAIL_INDEX */]:
      return Object.assign({}, data);case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["l" /* GET_CMSAPI_PRODUCT_DETAIL_LIST */]:
      return Object.assign({}, state, { itemlist: Object.assign({}, state.itemlist, data.itemlist) });case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["n" /* GET_CMSAPI_PRODUCT_MORE_DETAIL_LIST */]:
      state.itemlist.article_list.datalist = [].concat(_toConsumableArray(state.itemlist.article_list.datalist), _toConsumableArray(data.itemlist.article_list.datalist));state.itemlist.article_list[curPage] = data.itemlist.article_list.cur_page;state.itemlist.article_list[totalPage] = data.itemlist.article_list.total_page;return Object.assign({}, state);default:
      return state;}
}

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["postNumberReport"] = postNumberReport;
/* harmony export (immutable) */ __webpack_exports__["phoneList"] = phoneList;
/* harmony export (immutable) */ __webpack_exports__["instanceInfo"] = instanceInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(4);
/**
 * @file: 号码认证申诉接口
 * @author: wence
 */function postNumberReport() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["O" /* POST_NUMBER_REPORT */]:
      return action.data;default:
      return state;}
}function phoneList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["e" /* GET_ALREADY_PHONE_LIST */]:
      return action.data;default:
      return state;}
}function instanceInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var action = arguments[1];switch (action.type) {case __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["x" /* GET_INSTANCE_INFO */]:
      return action.data;default:
      return state;}
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.6bd8dc40.js